(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("c84AI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d49cb1b73b77104$export$2e2bcd8739ae039; });

var $hdL4c = parcelRequire("hdL4c");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $hdL4c.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $8d49cb1b73b77104$export$2e2bcd8739ae039 = cloneBuffer;

});
parcelRegister("hdL4c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c898290c8726c25f$export$2e2bcd8739ae039; });

var $hih3U = parcelRequire("hih3U");
/** Detect free variable `self`. */ var $c898290c8726c25f$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $c898290c8726c25f$var$root = (0, $hih3U.default) || $c898290c8726c25f$var$freeSelf || Function('return this')();
var $c898290c8726c25f$export$2e2bcd8739ae039 = $c898290c8726c25f$var$root;

});
parcelRegister("hih3U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9715a4c37a61d5f$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $c9715a4c37a61d5f$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $c9715a4c37a61d5f$export$2e2bcd8739ae039 = $c9715a4c37a61d5f$var$freeGlobal;

});



parcelRegister("1hAGW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ef3d7264352f434$export$2e2bcd8739ae039; });

var $hdL4c = parcelRequire("hdL4c");

var $3C1OK = parcelRequire("3C1OK");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $hdL4c.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $3C1OK.default);
var $0ef3d7264352f434$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("3C1OK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a1654a2f1a3819c$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $2a1654a2f1a3819c$var$stubFalse() {
    return false;
}
var $2a1654a2f1a3819c$export$2e2bcd8739ae039 = $2a1654a2f1a3819c$var$stubFalse;

});


parcelRegister("8fNPf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60265fc15038e9ae$export$2e2bcd8739ae039; });

var $hih3U = parcelRequire("hih3U");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $hih3U.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $60265fc15038e9ae$export$2e2bcd8739ae039 = nodeUtil;

});

parcelRegister("hkB5a", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', promiseTag = '[object Promise]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */ function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
}
/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */ function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
}
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array ? array.length : 0;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__['delete'](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) object[key] = value;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
    var result;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            if (isHostObject(value)) return object ? value : {};
            result = initCloneObject(isFunc ? {} : value);
            if (!isDeep) return copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, baseClone, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (!isArr) var props = isFull ? getAllKeys(value) : keys(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
    });
    return result;
}
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */ function baseCreate(proto) {
    return isObject(proto) ? objectCreate(proto) : {};
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var result = new buffer.constructor(buffer.length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */ function cloneMap(map, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
    return arrayReduce(array, addMapEntry, new map.constructor);
}
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */ function cloneSet(set, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
    return arrayReduce(array, addSetEntry, new set.constructor);
}
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        assignValue(object, key, newValue === undefined ? source[key] : newValue);
    }
    return object;
}
/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, cloneFunc, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return cloneMap(object, isDeep, cloneFunc);
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return cloneSet(object, isDeep, cloneFunc);
        case symbolTag:
            return cloneSymbol(object);
    }
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return baseClone(value, true, true);
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = cloneDeep;

});

parcelRegister("jpGem", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

});


var $d3VnV = parcelRequire("d3VnV");

const $e8e41ed2307ec892$export$e95f23a3da8bb3c7 = ()=>{
    // Datepicker
    const DATEPICKER_ELS = document.querySelectorAll(".date-picker");
    DATEPICKER_ELS.forEach((el)=>{
        const DATEPICKER = new (0, $d3VnV.Datepicker)(el, {
            todayHighlight: true,
            buttonClass: "btn",
            nextArrow: "<i class='ph ph-arrow-right'></i>",
            prevArrow: "<i class='ph ph-arrow-left'></i>"
        });
    });
    // Date Range Picker
    const RANGEPICKER_ELS = document.querySelectorAll(".date-range-picker");
    RANGEPICKER_ELS.forEach((el)=>{
        const RANGEPICKER = new (0, $d3VnV.DateRangePicker)(el, {
            buttonClass: "btn",
            nextArrow: "<i class='ph ph-arrow-right'></i>",
            prevArrow: "<i class='ph ph-arrow-left'></i>",
            clearButton: true,
            todayButton: true
        });
    });
};


/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $84aa56c5a2ec7867$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $84aa56c5a2ec7867$export$2e2bcd8739ae039 = $84aa56c5a2ec7867$var$listCacheClear;


/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $b4e6bc06a7dbe23b$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $b4e6bc06a7dbe23b$export$2e2bcd8739ae039 = $b4e6bc06a7dbe23b$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $950cdc23c08633ff$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $b4e6bc06a7dbe23b$export$2e2bcd8739ae039)(array[length][0], key)) return length;
    }
    return -1;
}
var $950cdc23c08633ff$export$2e2bcd8739ae039 = $950cdc23c08633ff$var$assocIndexOf;


/** Used for built-in method references. */ var $c430a2b0e2fc1907$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $c430a2b0e2fc1907$var$splice = $c430a2b0e2fc1907$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $c430a2b0e2fc1907$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $950cdc23c08633ff$export$2e2bcd8739ae039)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $c430a2b0e2fc1907$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $c430a2b0e2fc1907$export$2e2bcd8739ae039 = $c430a2b0e2fc1907$var$listCacheDelete;



/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $da1b54ff880ea8b1$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $950cdc23c08633ff$export$2e2bcd8739ae039)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $da1b54ff880ea8b1$export$2e2bcd8739ae039 = $da1b54ff880ea8b1$var$listCacheGet;



/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b5b40dd418dd86cb$var$listCacheHas(key) {
    return (0, $950cdc23c08633ff$export$2e2bcd8739ae039)(this.__data__, key) > -1;
}
var $b5b40dd418dd86cb$export$2e2bcd8739ae039 = $b5b40dd418dd86cb$var$listCacheHas;



/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $8ece440b22920a1d$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $950cdc23c08633ff$export$2e2bcd8739ae039)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $8ece440b22920a1d$export$2e2bcd8739ae039 = $8ece440b22920a1d$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f9c56f753e12a789$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$f9c56f753e12a789$var$ListCache.prototype.clear = (0, $84aa56c5a2ec7867$export$2e2bcd8739ae039);
$f9c56f753e12a789$var$ListCache.prototype['delete'] = (0, $c430a2b0e2fc1907$export$2e2bcd8739ae039);
$f9c56f753e12a789$var$ListCache.prototype.get = (0, $da1b54ff880ea8b1$export$2e2bcd8739ae039);
$f9c56f753e12a789$var$ListCache.prototype.has = (0, $b5b40dd418dd86cb$export$2e2bcd8739ae039);
$f9c56f753e12a789$var$ListCache.prototype.set = (0, $8ece440b22920a1d$export$2e2bcd8739ae039);
var $f9c56f753e12a789$export$2e2bcd8739ae039 = $f9c56f753e12a789$var$ListCache;



/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $41691d1d906e2d46$var$stackClear() {
    this.__data__ = new (0, $f9c56f753e12a789$export$2e2bcd8739ae039);
    this.size = 0;
}
var $41691d1d906e2d46$export$2e2bcd8739ae039 = $41691d1d906e2d46$var$stackClear;


/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $eeb0ea793dfaccd4$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $eeb0ea793dfaccd4$export$2e2bcd8739ae039 = $eeb0ea793dfaccd4$var$stackDelete;


/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e5896e5d3b7c4091$var$stackGet(key) {
    return this.__data__.get(key);
}
var $e5896e5d3b7c4091$export$2e2bcd8739ae039 = $e5896e5d3b7c4091$var$stackGet;


/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $22bec6fed932e68b$var$stackHas(key) {
    return this.__data__.has(key);
}
var $22bec6fed932e68b$export$2e2bcd8739ae039 = $22bec6fed932e68b$var$stackHas;




var $hdL4c = parcelRequire("hdL4c");
/** Built-in value references. */ var $2dd6d42499abd1d4$var$Symbol = (0, $hdL4c.default).Symbol;
var $2dd6d42499abd1d4$export$2e2bcd8739ae039 = $2dd6d42499abd1d4$var$Symbol;



/** Used for built-in method references. */ var $f64002e985553374$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f64002e985553374$var$hasOwnProperty = $f64002e985553374$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f64002e985553374$var$nativeObjectToString = $f64002e985553374$var$objectProto.toString;
/** Built-in value references. */ var $f64002e985553374$var$symToStringTag = (0, $2dd6d42499abd1d4$export$2e2bcd8739ae039) ? (0, $2dd6d42499abd1d4$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $f64002e985553374$var$getRawTag(value) {
    var isOwn = $f64002e985553374$var$hasOwnProperty.call(value, $f64002e985553374$var$symToStringTag), tag = value[$f64002e985553374$var$symToStringTag];
    try {
        value[$f64002e985553374$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $f64002e985553374$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$f64002e985553374$var$symToStringTag] = tag;
        else delete value[$f64002e985553374$var$symToStringTag];
    }
    return result;
}
var $f64002e985553374$export$2e2bcd8739ae039 = $f64002e985553374$var$getRawTag;


/** Used for built-in method references. */ var $9dab390e95b063c7$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $9dab390e95b063c7$var$nativeObjectToString = $9dab390e95b063c7$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $9dab390e95b063c7$var$objectToString(value) {
    return $9dab390e95b063c7$var$nativeObjectToString.call(value);
}
var $9dab390e95b063c7$export$2e2bcd8739ae039 = $9dab390e95b063c7$var$objectToString;


/** `Object#toString` result references. */ var $4858f35ffd09f1fe$var$nullTag = '[object Null]', $4858f35ffd09f1fe$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $4858f35ffd09f1fe$var$symToStringTag = (0, $2dd6d42499abd1d4$export$2e2bcd8739ae039) ? (0, $2dd6d42499abd1d4$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $4858f35ffd09f1fe$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $4858f35ffd09f1fe$var$undefinedTag : $4858f35ffd09f1fe$var$nullTag;
    return $4858f35ffd09f1fe$var$symToStringTag && $4858f35ffd09f1fe$var$symToStringTag in Object(value) ? (0, $f64002e985553374$export$2e2bcd8739ae039)(value) : (0, $9dab390e95b063c7$export$2e2bcd8739ae039)(value);
}
var $4858f35ffd09f1fe$export$2e2bcd8739ae039 = $4858f35ffd09f1fe$var$baseGetTag;


/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $b0c4b4ed3a4e0b7c$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $b0c4b4ed3a4e0b7c$export$2e2bcd8739ae039 = $b0c4b4ed3a4e0b7c$var$isObject;


/** `Object#toString` result references. */ var $65a0f8720364b251$var$asyncTag = '[object AsyncFunction]', $65a0f8720364b251$var$funcTag = '[object Function]', $65a0f8720364b251$var$genTag = '[object GeneratorFunction]', $65a0f8720364b251$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $65a0f8720364b251$var$isFunction(value) {
    if (!(0, $b0c4b4ed3a4e0b7c$export$2e2bcd8739ae039)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $4858f35ffd09f1fe$export$2e2bcd8739ae039)(value);
    return tag == $65a0f8720364b251$var$funcTag || tag == $65a0f8720364b251$var$genTag || tag == $65a0f8720364b251$var$asyncTag || tag == $65a0f8720364b251$var$proxyTag;
}
var $65a0f8720364b251$export$2e2bcd8739ae039 = $65a0f8720364b251$var$isFunction;



var $hdL4c = parcelRequire("hdL4c");
/** Used to detect overreaching core-js shims. */ var $cbf5d4f5979ea232$var$coreJsData = (0, $hdL4c.default)['__core-js_shared__'];
var $cbf5d4f5979ea232$export$2e2bcd8739ae039 = $cbf5d4f5979ea232$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $530084f6fd59721f$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $cbf5d4f5979ea232$export$2e2bcd8739ae039) && (0, $cbf5d4f5979ea232$export$2e2bcd8739ae039).keys && (0, $cbf5d4f5979ea232$export$2e2bcd8739ae039).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $530084f6fd59721f$var$isMasked(func) {
    return !!$530084f6fd59721f$var$maskSrcKey && $530084f6fd59721f$var$maskSrcKey in func;
}
var $530084f6fd59721f$export$2e2bcd8739ae039 = $530084f6fd59721f$var$isMasked;



/** Used for built-in method references. */ var $3461967a505fe51b$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $3461967a505fe51b$var$funcToString = $3461967a505fe51b$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $3461967a505fe51b$var$toSource(func) {
    if (func != null) {
        try {
            return $3461967a505fe51b$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $3461967a505fe51b$export$2e2bcd8739ae039 = $3461967a505fe51b$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $086bd44deb3bebf2$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $086bd44deb3bebf2$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $086bd44deb3bebf2$var$funcProto = Function.prototype, $086bd44deb3bebf2$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $086bd44deb3bebf2$var$funcToString = $086bd44deb3bebf2$var$funcProto.toString;
/** Used to check objects for own properties. */ var $086bd44deb3bebf2$var$hasOwnProperty = $086bd44deb3bebf2$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $086bd44deb3bebf2$var$reIsNative = RegExp('^' + $086bd44deb3bebf2$var$funcToString.call($086bd44deb3bebf2$var$hasOwnProperty).replace($086bd44deb3bebf2$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $086bd44deb3bebf2$var$baseIsNative(value) {
    if (!(0, $b0c4b4ed3a4e0b7c$export$2e2bcd8739ae039)(value) || (0, $530084f6fd59721f$export$2e2bcd8739ae039)(value)) return false;
    var pattern = (0, $65a0f8720364b251$export$2e2bcd8739ae039)(value) ? $086bd44deb3bebf2$var$reIsNative : $086bd44deb3bebf2$var$reIsHostCtor;
    return pattern.test((0, $3461967a505fe51b$export$2e2bcd8739ae039)(value));
}
var $086bd44deb3bebf2$export$2e2bcd8739ae039 = $086bd44deb3bebf2$var$baseIsNative;


/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $337f8f60fd08d05f$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $337f8f60fd08d05f$export$2e2bcd8739ae039 = $337f8f60fd08d05f$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $89b3b938d4180065$var$getNative(object, key) {
    var value = (0, $337f8f60fd08d05f$export$2e2bcd8739ae039)(object, key);
    return (0, $086bd44deb3bebf2$export$2e2bcd8739ae039)(value) ? value : undefined;
}
var $89b3b938d4180065$export$2e2bcd8739ae039 = $89b3b938d4180065$var$getNative;



var $hdL4c = parcelRequire("hdL4c");
/* Built-in method references that are verified to be native. */ var $ca11d0f0b14fe6e7$var$Map = (0, $89b3b938d4180065$export$2e2bcd8739ae039)((0, $hdL4c.default), 'Map');
var $ca11d0f0b14fe6e7$export$2e2bcd8739ae039 = $ca11d0f0b14fe6e7$var$Map;



/* Built-in method references that are verified to be native. */ var $9c3ca62f8805c0dc$var$nativeCreate = (0, $89b3b938d4180065$export$2e2bcd8739ae039)(Object, 'create');
var $9c3ca62f8805c0dc$export$2e2bcd8739ae039 = $9c3ca62f8805c0dc$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $ca1128a5e10fa73d$var$hashClear() {
    this.__data__ = (0, $9c3ca62f8805c0dc$export$2e2bcd8739ae039) ? (0, $9c3ca62f8805c0dc$export$2e2bcd8739ae039)(null) : {};
    this.size = 0;
}
var $ca1128a5e10fa73d$export$2e2bcd8739ae039 = $ca1128a5e10fa73d$var$hashClear;


/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $3c800d4f27984b91$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $3c800d4f27984b91$export$2e2bcd8739ae039 = $3c800d4f27984b91$var$hashDelete;



/** Used to stand-in for `undefined` hash values. */ var $9a6a039d06061a96$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $9a6a039d06061a96$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9a6a039d06061a96$var$hasOwnProperty = $9a6a039d06061a96$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $9a6a039d06061a96$var$hashGet(key) {
    var data = this.__data__;
    if (0, $9c3ca62f8805c0dc$export$2e2bcd8739ae039) {
        var result = data[key];
        return result === $9a6a039d06061a96$var$HASH_UNDEFINED ? undefined : result;
    }
    return $9a6a039d06061a96$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $9a6a039d06061a96$export$2e2bcd8739ae039 = $9a6a039d06061a96$var$hashGet;



/** Used for built-in method references. */ var $5d9d47e35a61a4a5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5d9d47e35a61a4a5$var$hasOwnProperty = $5d9d47e35a61a4a5$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $5d9d47e35a61a4a5$var$hashHas(key) {
    var data = this.__data__;
    return (0, $9c3ca62f8805c0dc$export$2e2bcd8739ae039) ? data[key] !== undefined : $5d9d47e35a61a4a5$var$hasOwnProperty.call(data, key);
}
var $5d9d47e35a61a4a5$export$2e2bcd8739ae039 = $5d9d47e35a61a4a5$var$hashHas;



/** Used to stand-in for `undefined` hash values. */ var $50a9e4bb05997cff$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $50a9e4bb05997cff$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $9c3ca62f8805c0dc$export$2e2bcd8739ae039) && value === undefined ? $50a9e4bb05997cff$var$HASH_UNDEFINED : value;
    return this;
}
var $50a9e4bb05997cff$export$2e2bcd8739ae039 = $50a9e4bb05997cff$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $cfaf5efd01e9ee58$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$cfaf5efd01e9ee58$var$Hash.prototype.clear = (0, $ca1128a5e10fa73d$export$2e2bcd8739ae039);
$cfaf5efd01e9ee58$var$Hash.prototype['delete'] = (0, $3c800d4f27984b91$export$2e2bcd8739ae039);
$cfaf5efd01e9ee58$var$Hash.prototype.get = (0, $9a6a039d06061a96$export$2e2bcd8739ae039);
$cfaf5efd01e9ee58$var$Hash.prototype.has = (0, $5d9d47e35a61a4a5$export$2e2bcd8739ae039);
$cfaf5efd01e9ee58$var$Hash.prototype.set = (0, $50a9e4bb05997cff$export$2e2bcd8739ae039);
var $cfaf5efd01e9ee58$export$2e2bcd8739ae039 = $cfaf5efd01e9ee58$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $1fc7cc2483c2f8e4$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $cfaf5efd01e9ee58$export$2e2bcd8739ae039),
        'map': new ((0, $ca11d0f0b14fe6e7$export$2e2bcd8739ae039) || (0, $f9c56f753e12a789$export$2e2bcd8739ae039)),
        'string': new (0, $cfaf5efd01e9ee58$export$2e2bcd8739ae039)
    };
}
var $1fc7cc2483c2f8e4$export$2e2bcd8739ae039 = $1fc7cc2483c2f8e4$var$mapCacheClear;


/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $6eda014386b44051$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $6eda014386b44051$export$2e2bcd8739ae039 = $6eda014386b44051$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $91ea7e499ebd4fd9$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $6eda014386b44051$export$2e2bcd8739ae039)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $91ea7e499ebd4fd9$export$2e2bcd8739ae039 = $91ea7e499ebd4fd9$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $0cd7492b78098c3c$var$mapCacheDelete(key) {
    var result = (0, $91ea7e499ebd4fd9$export$2e2bcd8739ae039)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $0cd7492b78098c3c$export$2e2bcd8739ae039 = $0cd7492b78098c3c$var$mapCacheDelete;



/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $3c429d50127be40e$var$mapCacheGet(key) {
    return (0, $91ea7e499ebd4fd9$export$2e2bcd8739ae039)(this, key).get(key);
}
var $3c429d50127be40e$export$2e2bcd8739ae039 = $3c429d50127be40e$var$mapCacheGet;



/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $ecaceab32a115acc$var$mapCacheHas(key) {
    return (0, $91ea7e499ebd4fd9$export$2e2bcd8739ae039)(this, key).has(key);
}
var $ecaceab32a115acc$export$2e2bcd8739ae039 = $ecaceab32a115acc$var$mapCacheHas;



/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $ccfb182e76ab17b8$var$mapCacheSet(key, value) {
    var data = (0, $91ea7e499ebd4fd9$export$2e2bcd8739ae039)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $ccfb182e76ab17b8$export$2e2bcd8739ae039 = $ccfb182e76ab17b8$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $ff380ada07d2b751$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$ff380ada07d2b751$var$MapCache.prototype.clear = (0, $1fc7cc2483c2f8e4$export$2e2bcd8739ae039);
$ff380ada07d2b751$var$MapCache.prototype['delete'] = (0, $0cd7492b78098c3c$export$2e2bcd8739ae039);
$ff380ada07d2b751$var$MapCache.prototype.get = (0, $3c429d50127be40e$export$2e2bcd8739ae039);
$ff380ada07d2b751$var$MapCache.prototype.has = (0, $ecaceab32a115acc$export$2e2bcd8739ae039);
$ff380ada07d2b751$var$MapCache.prototype.set = (0, $ccfb182e76ab17b8$export$2e2bcd8739ae039);
var $ff380ada07d2b751$export$2e2bcd8739ae039 = $ff380ada07d2b751$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $5f3918b945da14e4$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $5f3918b945da14e4$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $f9c56f753e12a789$export$2e2bcd8739ae039)) {
        var pairs = data.__data__;
        if (!(0, $ca11d0f0b14fe6e7$export$2e2bcd8739ae039) || pairs.length < $5f3918b945da14e4$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $ff380ada07d2b751$export$2e2bcd8739ae039)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $5f3918b945da14e4$export$2e2bcd8739ae039 = $5f3918b945da14e4$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $645f86afd3e24a54$var$Stack(entries) {
    var data = this.__data__ = new (0, $f9c56f753e12a789$export$2e2bcd8739ae039)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$645f86afd3e24a54$var$Stack.prototype.clear = (0, $41691d1d906e2d46$export$2e2bcd8739ae039);
$645f86afd3e24a54$var$Stack.prototype['delete'] = (0, $eeb0ea793dfaccd4$export$2e2bcd8739ae039);
$645f86afd3e24a54$var$Stack.prototype.get = (0, $e5896e5d3b7c4091$export$2e2bcd8739ae039);
$645f86afd3e24a54$var$Stack.prototype.has = (0, $22bec6fed932e68b$export$2e2bcd8739ae039);
$645f86afd3e24a54$var$Stack.prototype.set = (0, $5f3918b945da14e4$export$2e2bcd8739ae039);
var $645f86afd3e24a54$export$2e2bcd8739ae039 = $645f86afd3e24a54$var$Stack;



var $8059b11f9d43e1ca$var$defineProperty = function() {
    try {
        var func = (0, $89b3b938d4180065$export$2e2bcd8739ae039)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $8059b11f9d43e1ca$export$2e2bcd8739ae039 = $8059b11f9d43e1ca$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $8862dce7ac3b2968$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $8059b11f9d43e1ca$export$2e2bcd8739ae039)) (0, $8059b11f9d43e1ca$export$2e2bcd8739ae039)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $8862dce7ac3b2968$export$2e2bcd8739ae039 = $8862dce7ac3b2968$var$baseAssignValue;



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $74946082e9e38deb$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !(0, $b4e6bc06a7dbe23b$export$2e2bcd8739ae039)(object[key], value) || value === undefined && !(key in object)) (0, $8862dce7ac3b2968$export$2e2bcd8739ae039)(object, key, value);
}
var $74946082e9e38deb$export$2e2bcd8739ae039 = $74946082e9e38deb$var$assignMergeValue;


/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $dfcb1fcdbe9ba6d3$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
var $dfcb1fcdbe9ba6d3$export$2e2bcd8739ae039 = $dfcb1fcdbe9ba6d3$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $acd878c529ca6b85$var$baseFor = (0, $dfcb1fcdbe9ba6d3$export$2e2bcd8739ae039)();
var $acd878c529ca6b85$export$2e2bcd8739ae039 = $acd878c529ca6b85$var$baseFor;




var $c84AI = parcelRequire("c84AI");

var $hdL4c = parcelRequire("hdL4c");
/** Built-in value references. */ var $3a305add339d255c$var$Uint8Array = (0, $hdL4c.default).Uint8Array;
var $3a305add339d255c$export$2e2bcd8739ae039 = $3a305add339d255c$var$Uint8Array;


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $b73f5b7b6417a77a$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $3a305add339d255c$export$2e2bcd8739ae039)(result).set(new (0, $3a305add339d255c$export$2e2bcd8739ae039)(arrayBuffer));
    return result;
}
var $b73f5b7b6417a77a$export$2e2bcd8739ae039 = $b73f5b7b6417a77a$var$cloneArrayBuffer;


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $87add7998cc7c873$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $b73f5b7b6417a77a$export$2e2bcd8739ae039)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $87add7998cc7c873$export$2e2bcd8739ae039 = $87add7998cc7c873$var$cloneTypedArray;


/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $ad1498f2a739ffba$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $ad1498f2a739ffba$export$2e2bcd8739ae039 = $ad1498f2a739ffba$var$copyArray;



/** Built-in value references. */ var $a02f217ed7c19977$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $a02f217ed7c19977$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $b0c4b4ed3a4e0b7c$export$2e2bcd8739ae039)(proto)) return {};
        if ($a02f217ed7c19977$var$objectCreate) return $a02f217ed7c19977$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $a02f217ed7c19977$export$2e2bcd8739ae039 = $a02f217ed7c19977$var$baseCreate;


/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $025f1b7fefdfd289$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $025f1b7fefdfd289$export$2e2bcd8739ae039 = $025f1b7fefdfd289$var$overArg;


/** Built-in value references. */ var $7dc8997d1a06ff2e$var$getPrototype = (0, $025f1b7fefdfd289$export$2e2bcd8739ae039)(Object.getPrototypeOf, Object);
var $7dc8997d1a06ff2e$export$2e2bcd8739ae039 = $7dc8997d1a06ff2e$var$getPrototype;


/** Used for built-in method references. */ var $3362d6d05c5dd3c7$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $3362d6d05c5dd3c7$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $3362d6d05c5dd3c7$var$objectProto;
    return value === proto;
}
var $3362d6d05c5dd3c7$export$2e2bcd8739ae039 = $3362d6d05c5dd3c7$var$isPrototype;


/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $9bde282ebc195a2f$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, $3362d6d05c5dd3c7$export$2e2bcd8739ae039)(object) ? (0, $a02f217ed7c19977$export$2e2bcd8739ae039)((0, $7dc8997d1a06ff2e$export$2e2bcd8739ae039)(object)) : {};
}
var $9bde282ebc195a2f$export$2e2bcd8739ae039 = $9bde282ebc195a2f$var$initCloneObject;



/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $748eab434a4ddaf0$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $748eab434a4ddaf0$export$2e2bcd8739ae039 = $748eab434a4ddaf0$var$isObjectLike;


/** `Object#toString` result references. */ var $13e7e4944a90bd12$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $13e7e4944a90bd12$var$baseIsArguments(value) {
    return (0, $748eab434a4ddaf0$export$2e2bcd8739ae039)(value) && (0, $4858f35ffd09f1fe$export$2e2bcd8739ae039)(value) == $13e7e4944a90bd12$var$argsTag;
}
var $13e7e4944a90bd12$export$2e2bcd8739ae039 = $13e7e4944a90bd12$var$baseIsArguments;



/** Used for built-in method references. */ var $44f6a8e4462be9ae$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $44f6a8e4462be9ae$var$hasOwnProperty = $44f6a8e4462be9ae$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $44f6a8e4462be9ae$var$propertyIsEnumerable = $44f6a8e4462be9ae$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $44f6a8e4462be9ae$var$isArguments = (0, $13e7e4944a90bd12$export$2e2bcd8739ae039)(function() {
    return arguments;
}()) ? (0, $13e7e4944a90bd12$export$2e2bcd8739ae039) : function(value) {
    return (0, $748eab434a4ddaf0$export$2e2bcd8739ae039)(value) && $44f6a8e4462be9ae$var$hasOwnProperty.call(value, 'callee') && !$44f6a8e4462be9ae$var$propertyIsEnumerable.call(value, 'callee');
};
var $44f6a8e4462be9ae$export$2e2bcd8739ae039 = $44f6a8e4462be9ae$var$isArguments;


/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $50159e231742c958$var$isArray = Array.isArray;
var $50159e231742c958$export$2e2bcd8739ae039 = $50159e231742c958$var$isArray;



/** Used as references for various `Number` constants. */ var $dba51f97b10fe6e6$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $dba51f97b10fe6e6$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $dba51f97b10fe6e6$var$MAX_SAFE_INTEGER;
}
var $dba51f97b10fe6e6$export$2e2bcd8739ae039 = $dba51f97b10fe6e6$var$isLength;


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $10c7eb5f791dfca9$var$isArrayLike(value) {
    return value != null && (0, $dba51f97b10fe6e6$export$2e2bcd8739ae039)(value.length) && !(0, $65a0f8720364b251$export$2e2bcd8739ae039)(value);
}
var $10c7eb5f791dfca9$export$2e2bcd8739ae039 = $10c7eb5f791dfca9$var$isArrayLike;



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $1e24afc366b4c566$var$isArrayLikeObject(value) {
    return (0, $748eab434a4ddaf0$export$2e2bcd8739ae039)(value) && (0, $10c7eb5f791dfca9$export$2e2bcd8739ae039)(value);
}
var $1e24afc366b4c566$export$2e2bcd8739ae039 = $1e24afc366b4c566$var$isArrayLikeObject;



var $1hAGW = parcelRequire("1hAGW");





/** `Object#toString` result references. */ var $4289cd57accf01c0$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $4289cd57accf01c0$var$funcProto = Function.prototype, $4289cd57accf01c0$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $4289cd57accf01c0$var$funcToString = $4289cd57accf01c0$var$funcProto.toString;
/** Used to check objects for own properties. */ var $4289cd57accf01c0$var$hasOwnProperty = $4289cd57accf01c0$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $4289cd57accf01c0$var$objectCtorString = $4289cd57accf01c0$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $4289cd57accf01c0$var$isPlainObject(value) {
    if (!(0, $748eab434a4ddaf0$export$2e2bcd8739ae039)(value) || (0, $4858f35ffd09f1fe$export$2e2bcd8739ae039)(value) != $4289cd57accf01c0$var$objectTag) return false;
    var proto = (0, $7dc8997d1a06ff2e$export$2e2bcd8739ae039)(value);
    if (proto === null) return true;
    var Ctor = $4289cd57accf01c0$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $4289cd57accf01c0$var$funcToString.call(Ctor) == $4289cd57accf01c0$var$objectCtorString;
}
var $4289cd57accf01c0$export$2e2bcd8739ae039 = $4289cd57accf01c0$var$isPlainObject;





/** `Object#toString` result references. */ var $43514ad8672c08c1$var$argsTag = '[object Arguments]', $43514ad8672c08c1$var$arrayTag = '[object Array]', $43514ad8672c08c1$var$boolTag = '[object Boolean]', $43514ad8672c08c1$var$dateTag = '[object Date]', $43514ad8672c08c1$var$errorTag = '[object Error]', $43514ad8672c08c1$var$funcTag = '[object Function]', $43514ad8672c08c1$var$mapTag = '[object Map]', $43514ad8672c08c1$var$numberTag = '[object Number]', $43514ad8672c08c1$var$objectTag = '[object Object]', $43514ad8672c08c1$var$regexpTag = '[object RegExp]', $43514ad8672c08c1$var$setTag = '[object Set]', $43514ad8672c08c1$var$stringTag = '[object String]', $43514ad8672c08c1$var$weakMapTag = '[object WeakMap]';
var $43514ad8672c08c1$var$arrayBufferTag = '[object ArrayBuffer]', $43514ad8672c08c1$var$dataViewTag = '[object DataView]', $43514ad8672c08c1$var$float32Tag = '[object Float32Array]', $43514ad8672c08c1$var$float64Tag = '[object Float64Array]', $43514ad8672c08c1$var$int8Tag = '[object Int8Array]', $43514ad8672c08c1$var$int16Tag = '[object Int16Array]', $43514ad8672c08c1$var$int32Tag = '[object Int32Array]', $43514ad8672c08c1$var$uint8Tag = '[object Uint8Array]', $43514ad8672c08c1$var$uint8ClampedTag = '[object Uint8ClampedArray]', $43514ad8672c08c1$var$uint16Tag = '[object Uint16Array]', $43514ad8672c08c1$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $43514ad8672c08c1$var$typedArrayTags = {};
$43514ad8672c08c1$var$typedArrayTags[$43514ad8672c08c1$var$float32Tag] = $43514ad8672c08c1$var$typedArrayTags[$43514ad8672c08c1$var$float64Tag] = $43514ad8672c08c1$var$typedArrayTags[$43514ad8672c08c1$var$int8Tag] = $43514ad8672c08c1$var$typedArrayTags[$43514ad8672c08c1$var$int16Tag] = $43514ad8672c08c1$var$typedArrayTags[$43514ad8672c08c1$var$int32Tag] = $43514ad8672c08c1$var$typedArrayTags[$43514ad8672c08c1$var$uint8Tag] = $43514ad8672c08c1$var$typedArrayTags[$43514ad8672c08c1$var$uint8ClampedTag] = $43514ad8672c08c1$var$typedArrayTags[$43514ad8672c08c1$var$uint16Tag] = $43514ad8672c08c1$var$typedArrayTags[$43514ad8672c08c1$var$uint32Tag] = true;
$43514ad8672c08c1$var$typedArrayTags[$43514ad8672c08c1$var$argsTag] = $43514ad8672c08c1$var$typedArrayTags[$43514ad8672c08c1$var$arrayTag] = $43514ad8672c08c1$var$typedArrayTags[$43514ad8672c08c1$var$arrayBufferTag] = $43514ad8672c08c1$var$typedArrayTags[$43514ad8672c08c1$var$boolTag] = $43514ad8672c08c1$var$typedArrayTags[$43514ad8672c08c1$var$dataViewTag] = $43514ad8672c08c1$var$typedArrayTags[$43514ad8672c08c1$var$dateTag] = $43514ad8672c08c1$var$typedArrayTags[$43514ad8672c08c1$var$errorTag] = $43514ad8672c08c1$var$typedArrayTags[$43514ad8672c08c1$var$funcTag] = $43514ad8672c08c1$var$typedArrayTags[$43514ad8672c08c1$var$mapTag] = $43514ad8672c08c1$var$typedArrayTags[$43514ad8672c08c1$var$numberTag] = $43514ad8672c08c1$var$typedArrayTags[$43514ad8672c08c1$var$objectTag] = $43514ad8672c08c1$var$typedArrayTags[$43514ad8672c08c1$var$regexpTag] = $43514ad8672c08c1$var$typedArrayTags[$43514ad8672c08c1$var$setTag] = $43514ad8672c08c1$var$typedArrayTags[$43514ad8672c08c1$var$stringTag] = $43514ad8672c08c1$var$typedArrayTags[$43514ad8672c08c1$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $43514ad8672c08c1$var$baseIsTypedArray(value) {
    return (0, $748eab434a4ddaf0$export$2e2bcd8739ae039)(value) && (0, $dba51f97b10fe6e6$export$2e2bcd8739ae039)(value.length) && !!$43514ad8672c08c1$var$typedArrayTags[(0, $4858f35ffd09f1fe$export$2e2bcd8739ae039)(value)];
}
var $43514ad8672c08c1$export$2e2bcd8739ae039 = $43514ad8672c08c1$var$baseIsTypedArray;


/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $9a3912be2c31c49c$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $9a3912be2c31c49c$export$2e2bcd8739ae039 = $9a3912be2c31c49c$var$baseUnary;



var $8fNPf = parcelRequire("8fNPf");
/* Node.js helper references. */ var $7632c8b302ab9506$var$nodeIsTypedArray = (0, $8fNPf.default) && (0, $8fNPf.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $7632c8b302ab9506$var$isTypedArray = $7632c8b302ab9506$var$nodeIsTypedArray ? (0, $9a3912be2c31c49c$export$2e2bcd8739ae039)($7632c8b302ab9506$var$nodeIsTypedArray) : (0, $43514ad8672c08c1$export$2e2bcd8739ae039);
var $7632c8b302ab9506$export$2e2bcd8739ae039 = $7632c8b302ab9506$var$isTypedArray;


/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d76c3165696ae328$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
var $d76c3165696ae328$export$2e2bcd8739ae039 = $d76c3165696ae328$var$safeGet;




/** Used for built-in method references. */ var $ef64f423664a300a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ef64f423664a300a$var$hasOwnProperty = $ef64f423664a300a$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $ef64f423664a300a$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($ef64f423664a300a$var$hasOwnProperty.call(object, key) && (0, $b4e6bc06a7dbe23b$export$2e2bcd8739ae039)(objValue, value)) || value === undefined && !(key in object)) (0, $8862dce7ac3b2968$export$2e2bcd8739ae039)(object, key, value);
}
var $ef64f423664a300a$export$2e2bcd8739ae039 = $ef64f423664a300a$var$assignValue;



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $267eb7b1664a4334$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $8862dce7ac3b2968$export$2e2bcd8739ae039)(object, key, newValue);
        else (0, $ef64f423664a300a$export$2e2bcd8739ae039)(object, key, newValue);
    }
    return object;
}
var $267eb7b1664a4334$export$2e2bcd8739ae039 = $267eb7b1664a4334$var$copyObject;


/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $4be198bb1298beb8$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $4be198bb1298beb8$export$2e2bcd8739ae039 = $4be198bb1298beb8$var$baseTimes;





var $1hAGW = parcelRequire("1hAGW");
/** Used as references for various `Number` constants. */ var $9c2a0ae89812e08f$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $9c2a0ae89812e08f$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $9c2a0ae89812e08f$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $9c2a0ae89812e08f$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $9c2a0ae89812e08f$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $9c2a0ae89812e08f$export$2e2bcd8739ae039 = $9c2a0ae89812e08f$var$isIndex;



/** Used for built-in method references. */ var $a1b6027477e5e7a5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a1b6027477e5e7a5$var$hasOwnProperty = $a1b6027477e5e7a5$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $a1b6027477e5e7a5$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $50159e231742c958$export$2e2bcd8739ae039)(value), isArg = !isArr && (0, $44f6a8e4462be9ae$export$2e2bcd8739ae039)(value), isBuff = !isArr && !isArg && (0, $1hAGW.default)(value), isType = !isArr && !isArg && !isBuff && (0, $7632c8b302ab9506$export$2e2bcd8739ae039)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $4be198bb1298beb8$export$2e2bcd8739ae039)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $a1b6027477e5e7a5$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $9c2a0ae89812e08f$export$2e2bcd8739ae039)(key, length)))) result.push(key);
    return result;
}
var $a1b6027477e5e7a5$export$2e2bcd8739ae039 = $a1b6027477e5e7a5$var$arrayLikeKeys;




/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $8dd101decc7eb989$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $8dd101decc7eb989$export$2e2bcd8739ae039 = $8dd101decc7eb989$var$nativeKeysIn;


/** Used for built-in method references. */ var $8493baa0d1501cf1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8493baa0d1501cf1$var$hasOwnProperty = $8493baa0d1501cf1$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $8493baa0d1501cf1$var$baseKeysIn(object) {
    if (!(0, $b0c4b4ed3a4e0b7c$export$2e2bcd8739ae039)(object)) return (0, $8dd101decc7eb989$export$2e2bcd8739ae039)(object);
    var isProto = (0, $3362d6d05c5dd3c7$export$2e2bcd8739ae039)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$8493baa0d1501cf1$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $8493baa0d1501cf1$export$2e2bcd8739ae039 = $8493baa0d1501cf1$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $dad844e55cc75ed8$var$keysIn(object) {
    return (0, $10c7eb5f791dfca9$export$2e2bcd8739ae039)(object) ? (0, $a1b6027477e5e7a5$export$2e2bcd8739ae039)(object, true) : (0, $8493baa0d1501cf1$export$2e2bcd8739ae039)(object);
}
var $dad844e55cc75ed8$export$2e2bcd8739ae039 = $dad844e55cc75ed8$var$keysIn;


/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $1d9af14403f77050$var$toPlainObject(value) {
    return (0, $267eb7b1664a4334$export$2e2bcd8739ae039)(value, (0, $dad844e55cc75ed8$export$2e2bcd8739ae039)(value));
}
var $1d9af14403f77050$export$2e2bcd8739ae039 = $1d9af14403f77050$var$toPlainObject;


/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $fe6826de0a063cfb$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = (0, $d76c3165696ae328$export$2e2bcd8739ae039)(object, key), srcValue = (0, $d76c3165696ae328$export$2e2bcd8739ae039)(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        (0, $74946082e9e38deb$export$2e2bcd8739ae039)(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = (0, $50159e231742c958$export$2e2bcd8739ae039)(srcValue), isBuff = !isArr && (0, $1hAGW.default)(srcValue), isTyped = !isArr && !isBuff && (0, $7632c8b302ab9506$export$2e2bcd8739ae039)(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ((0, $50159e231742c958$export$2e2bcd8739ae039)(objValue)) newValue = objValue;
            else if ((0, $1e24afc366b4c566$export$2e2bcd8739ae039)(objValue)) newValue = (0, $ad1498f2a739ffba$export$2e2bcd8739ae039)(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = (0, $c84AI.default)(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = (0, $87add7998cc7c873$export$2e2bcd8739ae039)(srcValue, true);
            } else newValue = [];
        } else if ((0, $4289cd57accf01c0$export$2e2bcd8739ae039)(srcValue) || (0, $44f6a8e4462be9ae$export$2e2bcd8739ae039)(srcValue)) {
            newValue = objValue;
            if ((0, $44f6a8e4462be9ae$export$2e2bcd8739ae039)(objValue)) newValue = (0, $1d9af14403f77050$export$2e2bcd8739ae039)(objValue);
            else if (!(0, $b0c4b4ed3a4e0b7c$export$2e2bcd8739ae039)(objValue) || (0, $65a0f8720364b251$export$2e2bcd8739ae039)(objValue)) newValue = (0, $9bde282ebc195a2f$export$2e2bcd8739ae039)(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    (0, $74946082e9e38deb$export$2e2bcd8739ae039)(object, key, newValue);
}
var $fe6826de0a063cfb$export$2e2bcd8739ae039 = $fe6826de0a063cfb$var$baseMergeDeep;





/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $f0b489185dfe10a4$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    (0, $acd878c529ca6b85$export$2e2bcd8739ae039)(source, function(srcValue, key) {
        stack || (stack = new (0, $645f86afd3e24a54$export$2e2bcd8739ae039));
        if ((0, $b0c4b4ed3a4e0b7c$export$2e2bcd8739ae039)(srcValue)) (0, $fe6826de0a063cfb$export$2e2bcd8739ae039)(object, source, key, srcIndex, $f0b489185dfe10a4$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer((0, $d76c3165696ae328$export$2e2bcd8739ae039)(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            (0, $74946082e9e38deb$export$2e2bcd8739ae039)(object, key, newValue);
        }
    }, (0, $dad844e55cc75ed8$export$2e2bcd8739ae039));
}
var $f0b489185dfe10a4$export$2e2bcd8739ae039 = $f0b489185dfe10a4$var$baseMerge;


/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $8981d49dcfb8b2a6$var$identity(value) {
    return value;
}
var $8981d49dcfb8b2a6$export$2e2bcd8739ae039 = $8981d49dcfb8b2a6$var$identity;


/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $ed99803c4595d289$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
var $ed99803c4595d289$export$2e2bcd8739ae039 = $ed99803c4595d289$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $e423dedcb1766478$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $e423dedcb1766478$var$overRest(func, start, transform) {
    start = $e423dedcb1766478$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $e423dedcb1766478$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, $ed99803c4595d289$export$2e2bcd8739ae039)(func, this, otherArgs);
    };
}
var $e423dedcb1766478$export$2e2bcd8739ae039 = $e423dedcb1766478$var$overRest;


/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $b5fd267cc88a30aa$var$constant(value) {
    return function() {
        return value;
    };
}
var $b5fd267cc88a30aa$export$2e2bcd8739ae039 = $b5fd267cc88a30aa$var$constant;




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $a4fdd514d92f6fdc$var$baseSetToString = !(0, $8059b11f9d43e1ca$export$2e2bcd8739ae039) ? (0, $8981d49dcfb8b2a6$export$2e2bcd8739ae039) : function(func, string) {
    return (0, $8059b11f9d43e1ca$export$2e2bcd8739ae039)(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': (0, $b5fd267cc88a30aa$export$2e2bcd8739ae039)(string),
        'writable': true
    });
};
var $a4fdd514d92f6fdc$export$2e2bcd8739ae039 = $a4fdd514d92f6fdc$var$baseSetToString;


/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $b5bd38f9a570b7d1$var$HOT_COUNT = 800, $b5bd38f9a570b7d1$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b5bd38f9a570b7d1$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $b5bd38f9a570b7d1$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $b5bd38f9a570b7d1$var$nativeNow(), remaining = $b5bd38f9a570b7d1$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $b5bd38f9a570b7d1$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
var $b5bd38f9a570b7d1$export$2e2bcd8739ae039 = $b5bd38f9a570b7d1$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $83e15e9adc868971$var$setToString = (0, $b5bd38f9a570b7d1$export$2e2bcd8739ae039)((0, $a4fdd514d92f6fdc$export$2e2bcd8739ae039));
var $83e15e9adc868971$export$2e2bcd8739ae039 = $83e15e9adc868971$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $012a25aa7a4b4002$var$baseRest(func, start) {
    return (0, $83e15e9adc868971$export$2e2bcd8739ae039)((0, $e423dedcb1766478$export$2e2bcd8739ae039)(func, start, (0, $8981d49dcfb8b2a6$export$2e2bcd8739ae039)), func + '');
}
var $012a25aa7a4b4002$export$2e2bcd8739ae039 = $012a25aa7a4b4002$var$baseRest;






/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $1e720401f3bf1f9f$var$isIterateeCall(value, index, object) {
    if (!(0, $b0c4b4ed3a4e0b7c$export$2e2bcd8739ae039)(object)) return false;
    var type = typeof index;
    if (type == 'number' ? (0, $10c7eb5f791dfca9$export$2e2bcd8739ae039)(object) && (0, $9c2a0ae89812e08f$export$2e2bcd8739ae039)(index, object.length) : type == 'string' && index in object) return (0, $b4e6bc06a7dbe23b$export$2e2bcd8739ae039)(object[index], value);
    return false;
}
var $1e720401f3bf1f9f$export$2e2bcd8739ae039 = $1e720401f3bf1f9f$var$isIterateeCall;


/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $3dcce13006070cd0$var$createAssigner(assigner) {
    return (0, $012a25aa7a4b4002$export$2e2bcd8739ae039)(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && (0, $1e720401f3bf1f9f$export$2e2bcd8739ae039)(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
var $3dcce13006070cd0$export$2e2bcd8739ae039 = $3dcce13006070cd0$var$createAssigner;


/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $e60eefbf4c36c7e0$var$merge = (0, $3dcce13006070cd0$export$2e2bcd8739ae039)(function(object, source, srcIndex) {
    (0, $f0b489185dfe10a4$export$2e2bcd8739ae039)(object, source, srcIndex);
});
var $e60eefbf4c36c7e0$export$2e2bcd8739ae039 = $e60eefbf4c36c7e0$var$merge;


var $e9fc1a5fcc0c5a1a$exports = {};

$parcel$export($e9fc1a5fcc0c5a1a$exports, "Scope", function () { return $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214; });
$parcel$export($e9fc1a5fcc0c5a1a$exports, "Attributor", function () { return $e9fc1a5fcc0c5a1a$export$217610c4183502d0; });
$parcel$export($e9fc1a5fcc0c5a1a$exports, "Registry", function () { return $e9fc1a5fcc0c5a1a$export$4d9facee29974f3; });
$parcel$export($e9fc1a5fcc0c5a1a$exports, "ClassAttributor", function () { return $e9fc1a5fcc0c5a1a$export$651d45509677cf07; });
$parcel$export($e9fc1a5fcc0c5a1a$exports, "StyleAttributor", function () { return $e9fc1a5fcc0c5a1a$export$7c8099bbfe87b94d; });
$parcel$export($e9fc1a5fcc0c5a1a$exports, "AttributorStore", function () { return $e9fc1a5fcc0c5a1a$export$68ad86ab95e8de42; });
$parcel$export($e9fc1a5fcc0c5a1a$exports, "LeafBlot", function () { return $e9fc1a5fcc0c5a1a$export$7420b9c542181544; });
$parcel$export($e9fc1a5fcc0c5a1a$exports, "ParentBlot", function () { return $e9fc1a5fcc0c5a1a$export$e43113f0aad76fe; });
$parcel$export($e9fc1a5fcc0c5a1a$exports, "InlineBlot", function () { return $e9fc1a5fcc0c5a1a$export$f67a34bc25a7a861; });
$parcel$export($e9fc1a5fcc0c5a1a$exports, "BlockBlot", function () { return $e9fc1a5fcc0c5a1a$export$4f7f03641f7bfc8c; });
$parcel$export($e9fc1a5fcc0c5a1a$exports, "ContainerBlot", function () { return $e9fc1a5fcc0c5a1a$export$c898d510319704c0; });
$parcel$export($e9fc1a5fcc0c5a1a$exports, "EmbedBlot", function () { return $e9fc1a5fcc0c5a1a$export$297a1fa96f55f00f; });
$parcel$export($e9fc1a5fcc0c5a1a$exports, "ScrollBlot", function () { return $e9fc1a5fcc0c5a1a$export$7175329dad7a46f1; });
$parcel$export($e9fc1a5fcc0c5a1a$exports, "TextBlot", function () { return $e9fc1a5fcc0c5a1a$export$10ac0c5716409de6; });
var $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214 = /* @__PURE__ */ ((Scope2)=>(Scope2[Scope2.TYPE = 3] = "TYPE", Scope2[Scope2.LEVEL = 12] = "LEVEL", Scope2[Scope2.ATTRIBUTE = 13] = "ATTRIBUTE", Scope2[Scope2.BLOT = 14] = "BLOT", Scope2[Scope2.INLINE = 7] = "INLINE", Scope2[Scope2.BLOCK = 11] = "BLOCK", Scope2[Scope2.BLOCK_BLOT = 10] = "BLOCK_BLOT", Scope2[Scope2.INLINE_BLOT = 6] = "INLINE_BLOT", Scope2[Scope2.BLOCK_ATTRIBUTE = 9] = "BLOCK_ATTRIBUTE", Scope2[Scope2.INLINE_ATTRIBUTE = 5] = "INLINE_ATTRIBUTE", Scope2[Scope2.ANY = 15] = "ANY", Scope2))($e9fc1a5fcc0c5a1a$export$775b6bb06e53a214 || {});
class $e9fc1a5fcc0c5a1a$export$217610c4183502d0 {
    constructor(attrName, keyName, options = {}){
        this.attrName = attrName, this.keyName = keyName;
        const attributeBit = $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214.TYPE & $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214.ATTRIBUTE;
        this.scope = options.scope != null ? // Ignore type bits, force attribute bit
        options.scope & $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214.LEVEL | attributeBit : $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214.ATTRIBUTE, options.whitelist != null && (this.whitelist = options.whitelist);
    }
    static keys(node) {
        return Array.from(node.attributes).map((item)=>item.name);
    }
    add(node, value) {
        return this.canAdd(node, value) ? (node.setAttribute(this.keyName, value), !0) : !1;
    }
    canAdd(_node, value) {
        return this.whitelist == null ? !0 : typeof value == "string" ? this.whitelist.indexOf(value.replace(/["']/g, "")) > -1 : this.whitelist.indexOf(value) > -1;
    }
    remove(node) {
        node.removeAttribute(this.keyName);
    }
    value(node) {
        const value = node.getAttribute(this.keyName);
        return this.canAdd(node, value) && value ? value : "";
    }
}
class $e9fc1a5fcc0c5a1a$var$ParchmentError extends Error {
    constructor(message){
        message = "[Parchment] " + message, super(message), this.message = message, this.name = this.constructor.name;
    }
}
const $e9fc1a5fcc0c5a1a$var$_Registry = class _Registry {
    constructor(){
        this.attributes = {}, this.classes = {}, this.tags = {}, this.types = {};
    }
    static find(node, bubble = !1) {
        if (node == null) return null;
        if (this.blots.has(node)) return this.blots.get(node) || null;
        if (bubble) {
            let parentNode = null;
            try {
                parentNode = node.parentNode;
            } catch  {
                return null;
            }
            return this.find(parentNode, bubble);
        }
        return null;
    }
    create(scroll, input, value) {
        const match2 = this.query(input);
        if (match2 == null) throw new $e9fc1a5fcc0c5a1a$var$ParchmentError(`Unable to create ${input} blot`);
        const blotClass = match2, node = // @ts-expect-error Fix me later
        input instanceof Node || input.nodeType === Node.TEXT_NODE ? input : blotClass.create(value), blot = new blotClass(scroll, node, value);
        return _Registry.blots.set(blot.domNode, blot), blot;
    }
    find(node, bubble = !1) {
        return _Registry.find(node, bubble);
    }
    query(query, scope = $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214.ANY) {
        let match2;
        return typeof query == "string" ? match2 = this.types[query] || this.attributes[query] : query instanceof Text || query.nodeType === Node.TEXT_NODE ? match2 = this.types.text : typeof query == "number" ? query & $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214.LEVEL & $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214.BLOCK ? match2 = this.types.block : query & $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214.LEVEL & $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214.INLINE && (match2 = this.types.inline) : query instanceof Element && ((query.getAttribute("class") || "").split(/\s+/).some((name)=>(match2 = this.classes[name], !!match2)), match2 = match2 || this.tags[query.tagName]), match2 == null ? null : "scope" in match2 && scope & $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214.LEVEL & match2.scope && scope & $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214.TYPE & match2.scope ? match2 : null;
    }
    register(...definitions) {
        return definitions.map((definition)=>{
            const isBlot = "blotName" in definition, isAttr = "attrName" in definition;
            if (!isBlot && !isAttr) throw new $e9fc1a5fcc0c5a1a$var$ParchmentError("Invalid definition");
            if (isBlot && definition.blotName === "abstract") throw new $e9fc1a5fcc0c5a1a$var$ParchmentError("Cannot register abstract class");
            const key = isBlot ? definition.blotName : isAttr ? definition.attrName : void 0;
            return this.types[key] = definition, isAttr ? typeof definition.keyName == "string" && (this.attributes[definition.keyName] = definition) : isBlot && (definition.className && (this.classes[definition.className] = definition), definition.tagName && (Array.isArray(definition.tagName) ? definition.tagName = definition.tagName.map((tagName)=>tagName.toUpperCase()) : definition.tagName = definition.tagName.toUpperCase(), (Array.isArray(definition.tagName) ? definition.tagName : [
                definition.tagName
            ]).forEach((tag)=>{
                (this.tags[tag] == null || definition.className == null) && (this.tags[tag] = definition);
            }))), definition;
        });
    }
};
$e9fc1a5fcc0c5a1a$var$_Registry.blots = /* @__PURE__ */ new WeakMap();
let $e9fc1a5fcc0c5a1a$export$4d9facee29974f3 = $e9fc1a5fcc0c5a1a$var$_Registry;
function $e9fc1a5fcc0c5a1a$var$match(node, prefix) {
    return (node.getAttribute("class") || "").split(/\s+/).filter((name)=>name.indexOf(`${prefix}-`) === 0);
}
class $e9fc1a5fcc0c5a1a$var$ClassAttributor extends $e9fc1a5fcc0c5a1a$export$217610c4183502d0 {
    static keys(node) {
        return (node.getAttribute("class") || "").split(/\s+/).map((name)=>name.split("-").slice(0, -1).join("-"));
    }
    add(node, value) {
        return this.canAdd(node, value) ? (this.remove(node), node.classList.add(`${this.keyName}-${value}`), !0) : !1;
    }
    remove(node) {
        $e9fc1a5fcc0c5a1a$var$match(node, this.keyName).forEach((name)=>{
            node.classList.remove(name);
        }), node.classList.length === 0 && node.removeAttribute("class");
    }
    value(node) {
        const value = ($e9fc1a5fcc0c5a1a$var$match(node, this.keyName)[0] || "").slice(this.keyName.length + 1);
        return this.canAdd(node, value) ? value : "";
    }
}
const $e9fc1a5fcc0c5a1a$export$651d45509677cf07 = $e9fc1a5fcc0c5a1a$var$ClassAttributor;
function $e9fc1a5fcc0c5a1a$var$camelize(name) {
    const parts = name.split("-"), rest = parts.slice(1).map((part)=>part[0].toUpperCase() + part.slice(1)).join("");
    return parts[0] + rest;
}
class $e9fc1a5fcc0c5a1a$var$StyleAttributor extends $e9fc1a5fcc0c5a1a$export$217610c4183502d0 {
    static keys(node) {
        return (node.getAttribute("style") || "").split(";").map((value)=>value.split(":")[0].trim());
    }
    add(node, value) {
        return this.canAdd(node, value) ? (node.style[$e9fc1a5fcc0c5a1a$var$camelize(this.keyName)] = value, !0) : !1;
    }
    remove(node) {
        node.style[$e9fc1a5fcc0c5a1a$var$camelize(this.keyName)] = "", node.getAttribute("style") || node.removeAttribute("style");
    }
    value(node) {
        const value = node.style[$e9fc1a5fcc0c5a1a$var$camelize(this.keyName)];
        return this.canAdd(node, value) ? value : "";
    }
}
const $e9fc1a5fcc0c5a1a$export$7c8099bbfe87b94d = $e9fc1a5fcc0c5a1a$var$StyleAttributor;
class $e9fc1a5fcc0c5a1a$var$AttributorStore {
    constructor(domNode){
        this.attributes = {}, this.domNode = domNode, this.build();
    }
    attribute(attribute, value) {
        value ? attribute.add(this.domNode, value) && (attribute.value(this.domNode) != null ? this.attributes[attribute.attrName] = attribute : delete this.attributes[attribute.attrName]) : (attribute.remove(this.domNode), delete this.attributes[attribute.attrName]);
    }
    build() {
        this.attributes = {};
        const blot = $e9fc1a5fcc0c5a1a$export$4d9facee29974f3.find(this.domNode);
        if (blot == null) return;
        const attributes = $e9fc1a5fcc0c5a1a$export$217610c4183502d0.keys(this.domNode), classes = $e9fc1a5fcc0c5a1a$export$651d45509677cf07.keys(this.domNode), styles = $e9fc1a5fcc0c5a1a$export$7c8099bbfe87b94d.keys(this.domNode);
        attributes.concat(classes).concat(styles).forEach((name)=>{
            const attr = blot.scroll.query(name, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214.ATTRIBUTE);
            attr instanceof $e9fc1a5fcc0c5a1a$export$217610c4183502d0 && (this.attributes[attr.attrName] = attr);
        });
    }
    copy(target) {
        Object.keys(this.attributes).forEach((key)=>{
            const value = this.attributes[key].value(this.domNode);
            target.format(key, value);
        });
    }
    move(target) {
        this.copy(target), Object.keys(this.attributes).forEach((key)=>{
            this.attributes[key].remove(this.domNode);
        }), this.attributes = {};
    }
    values() {
        return Object.keys(this.attributes).reduce((attributes, name)=>(attributes[name] = this.attributes[name].value(this.domNode), attributes), {});
    }
}
const $e9fc1a5fcc0c5a1a$export$68ad86ab95e8de42 = $e9fc1a5fcc0c5a1a$var$AttributorStore, $e9fc1a5fcc0c5a1a$var$_ShadowBlot = class _ShadowBlot {
    constructor(scroll, domNode){
        this.scroll = scroll, this.domNode = domNode, $e9fc1a5fcc0c5a1a$export$4d9facee29974f3.blots.set(domNode, this), this.prev = null, this.next = null;
    }
    static create(rawValue) {
        if (this.tagName == null) throw new $e9fc1a5fcc0c5a1a$var$ParchmentError("Blot definition missing tagName");
        let node, value;
        return Array.isArray(this.tagName) ? (typeof rawValue == "string" ? (value = rawValue.toUpperCase(), parseInt(value, 10).toString() === value && (value = parseInt(value, 10))) : typeof rawValue == "number" && (value = rawValue), typeof value == "number" ? node = document.createElement(this.tagName[value - 1]) : value && this.tagName.indexOf(value) > -1 ? node = document.createElement(value) : node = document.createElement(this.tagName[0])) : node = document.createElement(this.tagName), this.className && node.classList.add(this.className), node;
    }
    // Hack for accessing inherited static methods
    get statics() {
        return this.constructor;
    }
    attach() {}
    clone() {
        const domNode = this.domNode.cloneNode(!1);
        return this.scroll.create(domNode);
    }
    detach() {
        this.parent != null && this.parent.removeChild(this), $e9fc1a5fcc0c5a1a$export$4d9facee29974f3.blots.delete(this.domNode);
    }
    deleteAt(index, length) {
        this.isolate(index, length).remove();
    }
    formatAt(index, length, name, value) {
        const blot = this.isolate(index, length);
        if (this.scroll.query(name, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214.BLOT) != null && value) blot.wrap(name, value);
        else if (this.scroll.query(name, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214.ATTRIBUTE) != null) {
            const parent = this.scroll.create(this.statics.scope);
            blot.wrap(parent), parent.format(name, value);
        }
    }
    insertAt(index, value, def) {
        const blot = def == null ? this.scroll.create("text", value) : this.scroll.create(value, def), ref = this.split(index);
        this.parent.insertBefore(blot, ref || void 0);
    }
    isolate(index, length) {
        const target = this.split(index);
        if (target == null) throw new Error("Attempt to isolate at end");
        return target.split(length), target;
    }
    length() {
        return 1;
    }
    offset(root = this.parent) {
        return this.parent == null || this === root ? 0 : this.parent.children.offset(this) + this.parent.offset(root);
    }
    optimize(_context) {
        this.statics.requiredContainer && !(this.parent instanceof this.statics.requiredContainer) && this.wrap(this.statics.requiredContainer.blotName);
    }
    remove() {
        this.domNode.parentNode != null && this.domNode.parentNode.removeChild(this.domNode), this.detach();
    }
    replaceWith(name, value) {
        const replacement = typeof name == "string" ? this.scroll.create(name, value) : name;
        return this.parent != null && (this.parent.insertBefore(replacement, this.next || void 0), this.remove()), replacement;
    }
    split(index, _force) {
        return index === 0 ? this : this.next;
    }
    update(_mutations, _context) {}
    wrap(name, value) {
        const wrapper = typeof name == "string" ? this.scroll.create(name, value) : name;
        if (this.parent != null && this.parent.insertBefore(wrapper, this.next || void 0), typeof wrapper.appendChild != "function") throw new $e9fc1a5fcc0c5a1a$var$ParchmentError(`Cannot wrap ${name}`);
        return wrapper.appendChild(this), wrapper;
    }
};
$e9fc1a5fcc0c5a1a$var$_ShadowBlot.blotName = "abstract";
let $e9fc1a5fcc0c5a1a$var$ShadowBlot = $e9fc1a5fcc0c5a1a$var$_ShadowBlot;
const $e9fc1a5fcc0c5a1a$var$_LeafBlot = class _LeafBlot extends $e9fc1a5fcc0c5a1a$var$ShadowBlot {
    /**
   * Returns the value represented by domNode if it is this Blot's type
   * No checking that domNode can represent this Blot type is required so
   * applications needing it should check externally before calling.
   */ static value(_domNode) {
        return !0;
    }
    /**
   * Given location represented by node and offset from DOM Selection Range,
   * return index to that location.
   */ index(node, offset) {
        return this.domNode === node || this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY ? Math.min(offset, 1) : -1;
    }
    /**
   * Given index to location within blot, return node and offset representing
   * that location, consumable by DOM Selection Range
   */ position(index, _inclusive) {
        let offset = Array.from(this.parent.domNode.childNodes).indexOf(this.domNode);
        return index > 0 && (offset += 1), [
            this.parent.domNode,
            offset
        ];
    }
    /**
   * Return value represented by this blot
   * Should not change without interaction from API or
   * user change detectable by update()
   */ value() {
        return {
            [this.statics.blotName]: this.statics.value(this.domNode) || !0
        };
    }
};
$e9fc1a5fcc0c5a1a$var$_LeafBlot.scope = $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214.INLINE_BLOT;
let $e9fc1a5fcc0c5a1a$var$LeafBlot = $e9fc1a5fcc0c5a1a$var$_LeafBlot;
const $e9fc1a5fcc0c5a1a$export$7420b9c542181544 = $e9fc1a5fcc0c5a1a$var$LeafBlot;
class $e9fc1a5fcc0c5a1a$var$LinkedList {
    constructor(){
        this.head = null, this.tail = null, this.length = 0;
    }
    append(...nodes) {
        if (this.insertBefore(nodes[0], null), nodes.length > 1) {
            const rest = nodes.slice(1);
            this.append(...rest);
        }
    }
    at(index) {
        const next = this.iterator();
        let cur = next();
        for(; cur && index > 0;)index -= 1, cur = next();
        return cur;
    }
    contains(node) {
        const next = this.iterator();
        let cur = next();
        for(; cur;){
            if (cur === node) return !0;
            cur = next();
        }
        return !1;
    }
    indexOf(node) {
        const next = this.iterator();
        let cur = next(), index = 0;
        for(; cur;){
            if (cur === node) return index;
            index += 1, cur = next();
        }
        return -1;
    }
    insertBefore(node, refNode) {
        node != null && (this.remove(node), node.next = refNode, refNode != null ? (node.prev = refNode.prev, refNode.prev != null && (refNode.prev.next = node), refNode.prev = node, refNode === this.head && (this.head = node)) : this.tail != null ? (this.tail.next = node, node.prev = this.tail, this.tail = node) : (node.prev = null, this.head = this.tail = node), this.length += 1);
    }
    offset(target) {
        let index = 0, cur = this.head;
        for(; cur != null;){
            if (cur === target) return index;
            index += cur.length(), cur = cur.next;
        }
        return -1;
    }
    remove(node) {
        this.contains(node) && (node.prev != null && (node.prev.next = node.next), node.next != null && (node.next.prev = node.prev), node === this.head && (this.head = node.next), node === this.tail && (this.tail = node.prev), this.length -= 1);
    }
    iterator(curNode = this.head) {
        return ()=>{
            const ret = curNode;
            return curNode != null && (curNode = curNode.next), ret;
        };
    }
    find(index, inclusive = !1) {
        const next = this.iterator();
        let cur = next();
        for(; cur;){
            const length = cur.length();
            if (index < length || inclusive && index === length && (cur.next == null || cur.next.length() !== 0)) return [
                cur,
                index
            ];
            index -= length, cur = next();
        }
        return [
            null,
            0
        ];
    }
    forEach(callback) {
        const next = this.iterator();
        let cur = next();
        for(; cur;)callback(cur), cur = next();
    }
    forEachAt(index, length, callback) {
        if (length <= 0) return;
        const [startNode, offset] = this.find(index);
        let curIndex = index - offset;
        const next = this.iterator(startNode);
        let cur = next();
        for(; cur && curIndex < index + length;){
            const curLength = cur.length();
            index > curIndex ? callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index)) : callback(cur, 0, Math.min(curLength, index + length - curIndex)), curIndex += curLength, cur = next();
        }
    }
    map(callback) {
        return this.reduce((memo, cur)=>(memo.push(callback(cur)), memo), []);
    }
    reduce(callback, memo) {
        const next = this.iterator();
        let cur = next();
        for(; cur;)memo = callback(memo, cur), cur = next();
        return memo;
    }
}
function $e9fc1a5fcc0c5a1a$var$makeAttachedBlot(node, scroll) {
    const found = scroll.find(node);
    if (found) return found;
    try {
        return scroll.create(node);
    } catch  {
        const blot = scroll.create($e9fc1a5fcc0c5a1a$export$775b6bb06e53a214.INLINE);
        return Array.from(node.childNodes).forEach((child)=>{
            blot.domNode.appendChild(child);
        }), node.parentNode && node.parentNode.replaceChild(blot.domNode, node), blot.attach(), blot;
    }
}
const $e9fc1a5fcc0c5a1a$var$_ParentBlot = class _ParentBlot extends $e9fc1a5fcc0c5a1a$var$ShadowBlot {
    constructor(scroll, domNode){
        super(scroll, domNode), this.uiNode = null, this.build();
    }
    appendChild(other) {
        this.insertBefore(other);
    }
    attach() {
        super.attach(), this.children.forEach((child)=>{
            child.attach();
        });
    }
    attachUI(node) {
        this.uiNode != null && this.uiNode.remove(), this.uiNode = node, _ParentBlot.uiClass && this.uiNode.classList.add(_ParentBlot.uiClass), this.uiNode.setAttribute("contenteditable", "false"), this.domNode.insertBefore(this.uiNode, this.domNode.firstChild);
    }
    /**
   * Called during construction, should fill its own children LinkedList.
   */ build() {
        this.children = new $e9fc1a5fcc0c5a1a$var$LinkedList(), Array.from(this.domNode.childNodes).filter((node)=>node !== this.uiNode).reverse().forEach((node)=>{
            try {
                const child = $e9fc1a5fcc0c5a1a$var$makeAttachedBlot(node, this.scroll);
                this.insertBefore(child, this.children.head || void 0);
            } catch (err) {
                if (err instanceof $e9fc1a5fcc0c5a1a$var$ParchmentError) return;
                throw err;
            }
        });
    }
    deleteAt(index, length) {
        if (index === 0 && length === this.length()) return this.remove();
        this.children.forEachAt(index, length, (child, offset, childLength)=>{
            child.deleteAt(offset, childLength);
        });
    }
    descendant(criteria, index = 0) {
        const [child, offset] = this.children.find(index);
        return criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria ? [
            child,
            offset
        ] : child instanceof _ParentBlot ? child.descendant(criteria, offset) : [
            null,
            -1
        ];
    }
    descendants(criteria, index = 0, length = Number.MAX_VALUE) {
        let descendants = [], lengthLeft = length;
        return this.children.forEachAt(index, length, (child, childIndex, childLength)=>{
            (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) && descendants.push(child), child instanceof _ParentBlot && (descendants = descendants.concat(child.descendants(criteria, childIndex, lengthLeft))), lengthLeft -= childLength;
        }), descendants;
    }
    detach() {
        this.children.forEach((child)=>{
            child.detach();
        }), super.detach();
    }
    enforceAllowedChildren() {
        let done = !1;
        this.children.forEach((child)=>{
            done || this.statics.allowedChildren.some((def)=>child instanceof def) || (child.statics.scope === $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214.BLOCK_BLOT ? (child.next != null && this.splitAfter(child), child.prev != null && this.splitAfter(child.prev), child.parent.unwrap(), done = !0) : child instanceof _ParentBlot ? child.unwrap() : child.remove());
        });
    }
    formatAt(index, length, name, value) {
        this.children.forEachAt(index, length, (child, offset, childLength)=>{
            child.formatAt(offset, childLength, name, value);
        });
    }
    insertAt(index, value, def) {
        const [child, offset] = this.children.find(index);
        if (child) child.insertAt(offset, value, def);
        else {
            const blot = def == null ? this.scroll.create("text", value) : this.scroll.create(value, def);
            this.appendChild(blot);
        }
    }
    insertBefore(childBlot, refBlot) {
        childBlot.parent != null && childBlot.parent.children.remove(childBlot);
        let refDomNode = null;
        this.children.insertBefore(childBlot, refBlot || null), childBlot.parent = this, refBlot != null && (refDomNode = refBlot.domNode), (this.domNode.parentNode !== childBlot.domNode || this.domNode.nextSibling !== refDomNode) && this.domNode.insertBefore(childBlot.domNode, refDomNode), childBlot.attach();
    }
    length() {
        return this.children.reduce((memo, child)=>memo + child.length(), 0);
    }
    moveChildren(targetParent, refNode) {
        this.children.forEach((child)=>{
            targetParent.insertBefore(child, refNode);
        });
    }
    optimize(context) {
        if (super.optimize(context), this.enforceAllowedChildren(), this.uiNode != null && this.uiNode !== this.domNode.firstChild && this.domNode.insertBefore(this.uiNode, this.domNode.firstChild), this.children.length === 0) {
            if (this.statics.defaultChild != null) {
                const child = this.scroll.create(this.statics.defaultChild.blotName);
                this.appendChild(child);
            } else this.remove();
        }
    }
    path(index, inclusive = !1) {
        const [child, offset] = this.children.find(index, inclusive), position = [
            [
                this,
                index
            ]
        ];
        return child instanceof _ParentBlot ? position.concat(child.path(offset, inclusive)) : (child != null && position.push([
            child,
            offset
        ]), position);
    }
    removeChild(child) {
        this.children.remove(child);
    }
    replaceWith(name, value) {
        const replacement = typeof name == "string" ? this.scroll.create(name, value) : name;
        return replacement instanceof _ParentBlot && this.moveChildren(replacement), super.replaceWith(replacement);
    }
    split(index, force = !1) {
        if (!force) {
            if (index === 0) return this;
            if (index === this.length()) return this.next;
        }
        const after = this.clone();
        return this.parent && this.parent.insertBefore(after, this.next || void 0), this.children.forEachAt(index, this.length(), (child, offset, _length)=>{
            const split = child.split(offset, force);
            split != null && after.appendChild(split);
        }), after;
    }
    splitAfter(child) {
        const after = this.clone();
        for(; child.next != null;)after.appendChild(child.next);
        return this.parent && this.parent.insertBefore(after, this.next || void 0), after;
    }
    unwrap() {
        this.parent && this.moveChildren(this.parent, this.next || void 0), this.remove();
    }
    update(mutations, _context) {
        const addedNodes = [], removedNodes = [];
        mutations.forEach((mutation)=>{
            mutation.target === this.domNode && mutation.type === "childList" && (addedNodes.push(...mutation.addedNodes), removedNodes.push(...mutation.removedNodes));
        }), removedNodes.forEach((node)=>{
            if (node.parentNode != null && // @ts-expect-error Fix me later
            node.tagName !== "IFRAME" && document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) return;
            const blot = this.scroll.find(node);
            blot != null && (blot.domNode.parentNode == null || blot.domNode.parentNode === this.domNode) && blot.detach();
        }), addedNodes.filter((node)=>node.parentNode === this.domNode && node !== this.uiNode).sort((a, b)=>a === b ? 0 : a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? 1 : -1).forEach((node)=>{
            let refBlot = null;
            node.nextSibling != null && (refBlot = this.scroll.find(node.nextSibling));
            const blot = $e9fc1a5fcc0c5a1a$var$makeAttachedBlot(node, this.scroll);
            (blot.next !== refBlot || blot.next == null) && (blot.parent != null && blot.parent.removeChild(this), this.insertBefore(blot, refBlot || void 0));
        }), this.enforceAllowedChildren();
    }
};
$e9fc1a5fcc0c5a1a$var$_ParentBlot.uiClass = "";
let $e9fc1a5fcc0c5a1a$var$ParentBlot = $e9fc1a5fcc0c5a1a$var$_ParentBlot;
const $e9fc1a5fcc0c5a1a$export$e43113f0aad76fe = $e9fc1a5fcc0c5a1a$var$ParentBlot;
function $e9fc1a5fcc0c5a1a$var$isEqual(obj1, obj2) {
    if (Object.keys(obj1).length !== Object.keys(obj2).length) return !1;
    for(const prop in obj1)if (obj1[prop] !== obj2[prop]) return !1;
    return !0;
}
const $e9fc1a5fcc0c5a1a$var$_InlineBlot = class _InlineBlot extends $e9fc1a5fcc0c5a1a$export$e43113f0aad76fe {
    static create(value) {
        return super.create(value);
    }
    static formats(domNode, scroll) {
        const match2 = scroll.query(_InlineBlot.blotName);
        if (!(match2 != null && domNode.tagName === match2.tagName)) {
            if (typeof this.tagName == "string") return !0;
            if (Array.isArray(this.tagName)) return domNode.tagName.toLowerCase();
        }
    }
    constructor(scroll, domNode){
        super(scroll, domNode), this.attributes = new $e9fc1a5fcc0c5a1a$export$68ad86ab95e8de42(this.domNode);
    }
    format(name, value) {
        if (name === this.statics.blotName && !value) this.children.forEach((child)=>{
            child instanceof _InlineBlot || (child = child.wrap(_InlineBlot.blotName, !0)), this.attributes.copy(child);
        }), this.unwrap();
        else {
            const format = this.scroll.query(name, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214.INLINE);
            if (format == null) return;
            format instanceof $e9fc1a5fcc0c5a1a$export$217610c4183502d0 ? this.attributes.attribute(format, value) : value && (name !== this.statics.blotName || this.formats()[name] !== value) && this.replaceWith(name, value);
        }
    }
    formats() {
        const formats = this.attributes.values(), format = this.statics.formats(this.domNode, this.scroll);
        return format != null && (formats[this.statics.blotName] = format), formats;
    }
    formatAt(index, length, name, value) {
        this.formats()[name] != null || this.scroll.query(name, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214.ATTRIBUTE) ? this.isolate(index, length).format(name, value) : super.formatAt(index, length, name, value);
    }
    optimize(context) {
        super.optimize(context);
        const formats = this.formats();
        if (Object.keys(formats).length === 0) return this.unwrap();
        const next = this.next;
        next instanceof _InlineBlot && next.prev === this && $e9fc1a5fcc0c5a1a$var$isEqual(formats, next.formats()) && (next.moveChildren(this), next.remove());
    }
    replaceWith(name, value) {
        const replacement = super.replaceWith(name, value);
        return this.attributes.copy(replacement), replacement;
    }
    update(mutations, context) {
        super.update(mutations, context), mutations.some((mutation)=>mutation.target === this.domNode && mutation.type === "attributes") && this.attributes.build();
    }
    wrap(name, value) {
        const wrapper = super.wrap(name, value);
        return wrapper instanceof _InlineBlot && this.attributes.move(wrapper), wrapper;
    }
};
$e9fc1a5fcc0c5a1a$var$_InlineBlot.allowedChildren = [
    $e9fc1a5fcc0c5a1a$var$_InlineBlot,
    $e9fc1a5fcc0c5a1a$export$7420b9c542181544
], $e9fc1a5fcc0c5a1a$var$_InlineBlot.blotName = "inline", $e9fc1a5fcc0c5a1a$var$_InlineBlot.scope = $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214.INLINE_BLOT, $e9fc1a5fcc0c5a1a$var$_InlineBlot.tagName = "SPAN";
let $e9fc1a5fcc0c5a1a$var$InlineBlot = $e9fc1a5fcc0c5a1a$var$_InlineBlot;
const $e9fc1a5fcc0c5a1a$export$f67a34bc25a7a861 = $e9fc1a5fcc0c5a1a$var$InlineBlot, $e9fc1a5fcc0c5a1a$var$_BlockBlot = class _BlockBlot extends $e9fc1a5fcc0c5a1a$export$e43113f0aad76fe {
    static create(value) {
        return super.create(value);
    }
    static formats(domNode, scroll) {
        const match2 = scroll.query(_BlockBlot.blotName);
        if (!(match2 != null && domNode.tagName === match2.tagName)) {
            if (typeof this.tagName == "string") return !0;
            if (Array.isArray(this.tagName)) return domNode.tagName.toLowerCase();
        }
    }
    constructor(scroll, domNode){
        super(scroll, domNode), this.attributes = new $e9fc1a5fcc0c5a1a$export$68ad86ab95e8de42(this.domNode);
    }
    format(name, value) {
        const format = this.scroll.query(name, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214.BLOCK);
        format != null && (format instanceof $e9fc1a5fcc0c5a1a$export$217610c4183502d0 ? this.attributes.attribute(format, value) : name === this.statics.blotName && !value ? this.replaceWith(_BlockBlot.blotName) : value && (name !== this.statics.blotName || this.formats()[name] !== value) && this.replaceWith(name, value));
    }
    formats() {
        const formats = this.attributes.values(), format = this.statics.formats(this.domNode, this.scroll);
        return format != null && (formats[this.statics.blotName] = format), formats;
    }
    formatAt(index, length, name, value) {
        this.scroll.query(name, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214.BLOCK) != null ? this.format(name, value) : super.formatAt(index, length, name, value);
    }
    insertAt(index, value, def) {
        if (def == null || this.scroll.query(value, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214.INLINE) != null) super.insertAt(index, value, def);
        else {
            const after = this.split(index);
            if (after != null) {
                const blot = this.scroll.create(value, def);
                after.parent.insertBefore(blot, after);
            } else throw new Error("Attempt to insertAt after block boundaries");
        }
    }
    replaceWith(name, value) {
        const replacement = super.replaceWith(name, value);
        return this.attributes.copy(replacement), replacement;
    }
    update(mutations, context) {
        super.update(mutations, context), mutations.some((mutation)=>mutation.target === this.domNode && mutation.type === "attributes") && this.attributes.build();
    }
};
$e9fc1a5fcc0c5a1a$var$_BlockBlot.blotName = "block", $e9fc1a5fcc0c5a1a$var$_BlockBlot.scope = $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214.BLOCK_BLOT, $e9fc1a5fcc0c5a1a$var$_BlockBlot.tagName = "P", $e9fc1a5fcc0c5a1a$var$_BlockBlot.allowedChildren = [
    $e9fc1a5fcc0c5a1a$export$f67a34bc25a7a861,
    $e9fc1a5fcc0c5a1a$var$_BlockBlot,
    $e9fc1a5fcc0c5a1a$export$7420b9c542181544
];
let $e9fc1a5fcc0c5a1a$var$BlockBlot = $e9fc1a5fcc0c5a1a$var$_BlockBlot;
const $e9fc1a5fcc0c5a1a$export$4f7f03641f7bfc8c = $e9fc1a5fcc0c5a1a$var$BlockBlot, $e9fc1a5fcc0c5a1a$var$_ContainerBlot = class _ContainerBlot extends $e9fc1a5fcc0c5a1a$export$e43113f0aad76fe {
    checkMerge() {
        return this.next !== null && this.next.statics.blotName === this.statics.blotName;
    }
    deleteAt(index, length) {
        super.deleteAt(index, length), this.enforceAllowedChildren();
    }
    formatAt(index, length, name, value) {
        super.formatAt(index, length, name, value), this.enforceAllowedChildren();
    }
    insertAt(index, value, def) {
        super.insertAt(index, value, def), this.enforceAllowedChildren();
    }
    optimize(context) {
        super.optimize(context), this.children.length > 0 && this.next != null && this.checkMerge() && (this.next.moveChildren(this), this.next.remove());
    }
};
$e9fc1a5fcc0c5a1a$var$_ContainerBlot.blotName = "container", $e9fc1a5fcc0c5a1a$var$_ContainerBlot.scope = $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214.BLOCK_BLOT;
let $e9fc1a5fcc0c5a1a$var$ContainerBlot = $e9fc1a5fcc0c5a1a$var$_ContainerBlot;
const $e9fc1a5fcc0c5a1a$export$c898d510319704c0 = $e9fc1a5fcc0c5a1a$var$ContainerBlot;
class $e9fc1a5fcc0c5a1a$var$EmbedBlot extends $e9fc1a5fcc0c5a1a$export$7420b9c542181544 {
    static formats(_domNode, _scroll) {}
    format(name, value) {
        super.formatAt(0, this.length(), name, value);
    }
    formatAt(index, length, name, value) {
        index === 0 && length === this.length() ? this.format(name, value) : super.formatAt(index, length, name, value);
    }
    formats() {
        return this.statics.formats(this.domNode, this.scroll);
    }
}
const $e9fc1a5fcc0c5a1a$export$297a1fa96f55f00f = $e9fc1a5fcc0c5a1a$var$EmbedBlot, $e9fc1a5fcc0c5a1a$var$OBSERVER_CONFIG = {
    attributes: !0,
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
}, $e9fc1a5fcc0c5a1a$var$MAX_OPTIMIZE_ITERATIONS = 100, $e9fc1a5fcc0c5a1a$var$_ScrollBlot = class _ScrollBlot extends $e9fc1a5fcc0c5a1a$export$e43113f0aad76fe {
    constructor(registry, node){
        super(null, node), this.registry = registry, this.scroll = this, this.build(), this.observer = new MutationObserver((mutations)=>{
            this.update(mutations);
        }), this.observer.observe(this.domNode, $e9fc1a5fcc0c5a1a$var$OBSERVER_CONFIG), this.attach();
    }
    create(input, value) {
        return this.registry.create(this, input, value);
    }
    find(node, bubble = !1) {
        const blot = this.registry.find(node, bubble);
        return blot ? blot.scroll === this ? blot : bubble ? this.find(blot.scroll.domNode.parentNode, !0) : null : null;
    }
    query(query, scope = $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214.ANY) {
        return this.registry.query(query, scope);
    }
    register(...definitions) {
        return this.registry.register(...definitions);
    }
    build() {
        this.scroll != null && super.build();
    }
    detach() {
        super.detach(), this.observer.disconnect();
    }
    deleteAt(index, length) {
        this.update(), index === 0 && length === this.length() ? this.children.forEach((child)=>{
            child.remove();
        }) : super.deleteAt(index, length);
    }
    formatAt(index, length, name, value) {
        this.update(), super.formatAt(index, length, name, value);
    }
    insertAt(index, value, def) {
        this.update(), super.insertAt(index, value, def);
    }
    optimize(mutations = [], context = {}) {
        super.optimize(context);
        const mutationsMap = context.mutationsMap || /* @__PURE__ */ new WeakMap();
        let records = Array.from(this.observer.takeRecords());
        for(; records.length > 0;)mutations.push(records.pop());
        const mark = (blot, markParent = !0)=>{
            blot == null || blot === this || blot.domNode.parentNode != null && (mutationsMap.has(blot.domNode) || mutationsMap.set(blot.domNode, []), markParent && mark(blot.parent));
        }, optimize = (blot)=>{
            mutationsMap.has(blot.domNode) && (blot instanceof $e9fc1a5fcc0c5a1a$export$e43113f0aad76fe && blot.children.forEach(optimize), mutationsMap.delete(blot.domNode), blot.optimize(context));
        };
        let remaining = mutations;
        for(let i = 0; remaining.length > 0; i += 1){
            if (i >= $e9fc1a5fcc0c5a1a$var$MAX_OPTIMIZE_ITERATIONS) throw new Error("[Parchment] Maximum optimize iterations reached");
            for(remaining.forEach((mutation)=>{
                const blot = this.find(mutation.target, !0);
                blot != null && (blot.domNode === mutation.target && (mutation.type === "childList" ? (mark(this.find(mutation.previousSibling, !1)), Array.from(mutation.addedNodes).forEach((node)=>{
                    const child = this.find(node, !1);
                    mark(child, !1), child instanceof $e9fc1a5fcc0c5a1a$export$e43113f0aad76fe && child.children.forEach((grandChild)=>{
                        mark(grandChild, !1);
                    });
                })) : mutation.type === "attributes" && mark(blot.prev)), mark(blot));
            }), this.children.forEach(optimize), remaining = Array.from(this.observer.takeRecords()), records = remaining.slice(); records.length > 0;)mutations.push(records.pop());
        }
    }
    update(mutations, context = {}) {
        mutations = mutations || this.observer.takeRecords();
        const mutationsMap = /* @__PURE__ */ new WeakMap();
        mutations.map((mutation)=>{
            const blot = this.find(mutation.target, !0);
            return blot == null ? null : mutationsMap.has(blot.domNode) ? (mutationsMap.get(blot.domNode).push(mutation), null) : (mutationsMap.set(blot.domNode, [
                mutation
            ]), blot);
        }).forEach((blot)=>{
            blot != null && blot !== this && mutationsMap.has(blot.domNode) && blot.update(mutationsMap.get(blot.domNode) || [], context);
        }), context.mutationsMap = mutationsMap, mutationsMap.has(this.domNode) && super.update(mutationsMap.get(this.domNode), context), this.optimize(mutations, context);
    }
};
$e9fc1a5fcc0c5a1a$var$_ScrollBlot.blotName = "scroll", $e9fc1a5fcc0c5a1a$var$_ScrollBlot.defaultChild = $e9fc1a5fcc0c5a1a$export$4f7f03641f7bfc8c, $e9fc1a5fcc0c5a1a$var$_ScrollBlot.allowedChildren = [
    $e9fc1a5fcc0c5a1a$export$4f7f03641f7bfc8c,
    $e9fc1a5fcc0c5a1a$export$c898d510319704c0
], $e9fc1a5fcc0c5a1a$var$_ScrollBlot.scope = $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214.BLOCK_BLOT, $e9fc1a5fcc0c5a1a$var$_ScrollBlot.tagName = "DIV";
let $e9fc1a5fcc0c5a1a$var$ScrollBlot = $e9fc1a5fcc0c5a1a$var$_ScrollBlot;
const $e9fc1a5fcc0c5a1a$export$7175329dad7a46f1 = $e9fc1a5fcc0c5a1a$var$ScrollBlot, $e9fc1a5fcc0c5a1a$var$_TextBlot = class _TextBlot extends $e9fc1a5fcc0c5a1a$export$7420b9c542181544 {
    static create(value) {
        return document.createTextNode(value);
    }
    static value(domNode) {
        return domNode.data;
    }
    constructor(scroll, node){
        super(scroll, node), this.text = this.statics.value(this.domNode);
    }
    deleteAt(index, length) {
        this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
    }
    index(node, offset) {
        return this.domNode === node ? offset : -1;
    }
    insertAt(index, value, def) {
        def == null ? (this.text = this.text.slice(0, index) + value + this.text.slice(index), this.domNode.data = this.text) : super.insertAt(index, value, def);
    }
    length() {
        return this.text.length;
    }
    optimize(context) {
        super.optimize(context), this.text = this.statics.value(this.domNode), this.text.length === 0 ? this.remove() : this.next instanceof _TextBlot && this.next.prev === this && (this.insertAt(this.length(), this.next.value()), this.next.remove());
    }
    position(index, _inclusive = !1) {
        return [
            this.domNode,
            index
        ];
    }
    split(index, force = !1) {
        if (!force) {
            if (index === 0) return this;
            if (index === this.length()) return this.next;
        }
        const after = this.scroll.create(this.domNode.splitText(index));
        return this.parent.insertBefore(after, this.next || void 0), this.text = this.statics.value(this.domNode), after;
    }
    update(mutations, _context) {
        mutations.some((mutation)=>mutation.type === "characterData" && mutation.target === this.domNode) && (this.text = this.statics.value(this.domNode));
    }
    value() {
        return this.text;
    }
};
$e9fc1a5fcc0c5a1a$var$_TextBlot.blotName = "text", $e9fc1a5fcc0c5a1a$var$_TextBlot.scope = $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214.INLINE_BLOT;
let $e9fc1a5fcc0c5a1a$var$TextBlot = $e9fc1a5fcc0c5a1a$var$_TextBlot;
const $e9fc1a5fcc0c5a1a$export$10ac0c5716409de6 = $e9fc1a5fcc0c5a1a$var$TextBlot;


var $b0994a93e93413e9$exports = {};
"use strict";
Object.defineProperty($b0994a93e93413e9$exports, "__esModule", {
    value: true
});
$b0994a93e93413e9$exports.AttributeMap = $b0994a93e93413e9$exports.OpIterator = $b0994a93e93413e9$exports.Op = void 0;
var $74011372a575a487$exports = {};
/**
 * This library modifies the diff-patch-match library by Neil Fraser
 * by removing the patch and match functionality and certain advanced
 * options in the diff function. The original license is as follows:
 *
 * ===
 *
 * Diff Match and Patch
 *
 * Copyright 2006 Google Inc.
 * http://code.google.com/p/google-diff-match-patch/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */ var $74011372a575a487$var$DIFF_DELETE = -1;
var $74011372a575a487$var$DIFF_INSERT = 1;
var $74011372a575a487$var$DIFF_EQUAL = 0;
/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {Int|Object} [cursor_pos] Edit position in text1 or object with more info
 * @param {boolean} [cleanup] Apply semantic cleanup before returning.
 * @return {Array} Array of diff tuples.
 */ function $74011372a575a487$var$diff_main(text1, text2, cursor_pos, cleanup, _fix_unicode) {
    // Check for equality
    if (text1 === text2) {
        if (text1) return [
            [
                $74011372a575a487$var$DIFF_EQUAL,
                text1
            ]
        ];
        return [];
    }
    if (cursor_pos != null) {
        var editdiff = $74011372a575a487$var$find_cursor_edit_diff(text1, text2, cursor_pos);
        if (editdiff) return editdiff;
    }
    // Trim off common prefix (speedup).
    var commonlength = $74011372a575a487$var$diff_commonPrefix(text1, text2);
    var commonprefix = text1.substring(0, commonlength);
    text1 = text1.substring(commonlength);
    text2 = text2.substring(commonlength);
    // Trim off common suffix (speedup).
    commonlength = $74011372a575a487$var$diff_commonSuffix(text1, text2);
    var commonsuffix = text1.substring(text1.length - commonlength);
    text1 = text1.substring(0, text1.length - commonlength);
    text2 = text2.substring(0, text2.length - commonlength);
    // Compute the diff on the middle block.
    var diffs = $74011372a575a487$var$diff_compute_(text1, text2);
    // Restore the prefix and suffix.
    if (commonprefix) diffs.unshift([
        $74011372a575a487$var$DIFF_EQUAL,
        commonprefix
    ]);
    if (commonsuffix) diffs.push([
        $74011372a575a487$var$DIFF_EQUAL,
        commonsuffix
    ]);
    $74011372a575a487$var$diff_cleanupMerge(diffs, _fix_unicode);
    if (cleanup) $74011372a575a487$var$diff_cleanupSemantic(diffs);
    return diffs;
}
/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 */ function $74011372a575a487$var$diff_compute_(text1, text2) {
    var diffs;
    if (!text1) // Just add some text (speedup).
    return [
        [
            $74011372a575a487$var$DIFF_INSERT,
            text2
        ]
    ];
    if (!text2) // Just delete some text (speedup).
    return [
        [
            $74011372a575a487$var$DIFF_DELETE,
            text1
        ]
    ];
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    var i = longtext.indexOf(shorttext);
    if (i !== -1) {
        // Shorter text is inside the longer text (speedup).
        diffs = [
            [
                $74011372a575a487$var$DIFF_INSERT,
                longtext.substring(0, i)
            ],
            [
                $74011372a575a487$var$DIFF_EQUAL,
                shorttext
            ],
            [
                $74011372a575a487$var$DIFF_INSERT,
                longtext.substring(i + shorttext.length)
            ]
        ];
        // Swap insertions for deletions if diff is reversed.
        if (text1.length > text2.length) diffs[0][0] = diffs[2][0] = $74011372a575a487$var$DIFF_DELETE;
        return diffs;
    }
    if (shorttext.length === 1) // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [
        [
            $74011372a575a487$var$DIFF_DELETE,
            text1
        ],
        [
            $74011372a575a487$var$DIFF_INSERT,
            text2
        ]
    ];
    // Check to see if the problem can be split in two.
    var hm = $74011372a575a487$var$diff_halfMatch_(text1, text2);
    if (hm) {
        // A half-match was found, sort out the return data.
        var text1_a = hm[0];
        var text1_b = hm[1];
        var text2_a = hm[2];
        var text2_b = hm[3];
        var mid_common = hm[4];
        // Send both pairs off for separate processing.
        var diffs_a = $74011372a575a487$var$diff_main(text1_a, text2_a);
        var diffs_b = $74011372a575a487$var$diff_main(text1_b, text2_b);
        // Merge the results.
        return diffs_a.concat([
            [
                $74011372a575a487$var$DIFF_EQUAL,
                mid_common
            ]
        ], diffs_b);
    }
    return $74011372a575a487$var$diff_bisect_(text1, text2);
}
/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 * @private
 */ function $74011372a575a487$var$diff_bisect_(text1, text2) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    var max_d = Math.ceil((text1_length + text2_length) / 2);
    var v_offset = max_d;
    var v_length = 2 * max_d;
    var v1 = new Array(v_length);
    var v2 = new Array(v_length);
    // Setting all elements to -1 is faster in Chrome & Firefox than mixing
    // integers and undefined.
    for(var x = 0; x < v_length; x++){
        v1[x] = -1;
        v2[x] = -1;
    }
    v1[v_offset + 1] = 0;
    v2[v_offset + 1] = 0;
    var delta = text1_length - text2_length;
    // If the total number of characters is odd, then the front path will collide
    // with the reverse path.
    var front = delta % 2 !== 0;
    // Offsets for start and end of k loop.
    // Prevents mapping of space beyond the grid.
    var k1start = 0;
    var k1end = 0;
    var k2start = 0;
    var k2end = 0;
    for(var d = 0; d < max_d; d++){
        // Walk the front path one step.
        for(var k1 = -d + k1start; k1 <= d - k1end; k1 += 2){
            var k1_offset = v_offset + k1;
            var x1;
            if (k1 === -d || k1 !== d && v1[k1_offset - 1] < v1[k1_offset + 1]) x1 = v1[k1_offset + 1];
            else x1 = v1[k1_offset - 1] + 1;
            var y1 = x1 - k1;
            while(x1 < text1_length && y1 < text2_length && text1.charAt(x1) === text2.charAt(y1)){
                x1++;
                y1++;
            }
            v1[k1_offset] = x1;
            if (x1 > text1_length) // Ran off the right of the graph.
            k1end += 2;
            else if (y1 > text2_length) // Ran off the bottom of the graph.
            k1start += 2;
            else if (front) {
                var k2_offset = v_offset + delta - k1;
                if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] !== -1) {
                    // Mirror x2 onto top-left coordinate system.
                    var x2 = text1_length - v2[k2_offset];
                    if (x1 >= x2) // Overlap detected.
                    return $74011372a575a487$var$diff_bisectSplit_(text1, text2, x1, y1);
                }
            }
        }
        // Walk the reverse path one step.
        for(var k2 = -d + k2start; k2 <= d - k2end; k2 += 2){
            var k2_offset = v_offset + k2;
            var x2;
            if (k2 === -d || k2 !== d && v2[k2_offset - 1] < v2[k2_offset + 1]) x2 = v2[k2_offset + 1];
            else x2 = v2[k2_offset - 1] + 1;
            var y2 = x2 - k2;
            while(x2 < text1_length && y2 < text2_length && text1.charAt(text1_length - x2 - 1) === text2.charAt(text2_length - y2 - 1)){
                x2++;
                y2++;
            }
            v2[k2_offset] = x2;
            if (x2 > text1_length) // Ran off the left of the graph.
            k2end += 2;
            else if (y2 > text2_length) // Ran off the top of the graph.
            k2start += 2;
            else if (!front) {
                var k1_offset = v_offset + delta - k2;
                if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] !== -1) {
                    var x1 = v1[k1_offset];
                    var y1 = v_offset + x1 - k1_offset;
                    // Mirror x2 onto top-left coordinate system.
                    x2 = text1_length - x2;
                    if (x1 >= x2) // Overlap detected.
                    return $74011372a575a487$var$diff_bisectSplit_(text1, text2, x1, y1);
                }
            }
        }
    }
    // Diff took too long and hit the deadline or
    // number of diffs equals number of characters, no commonality at all.
    return [
        [
            $74011372a575a487$var$DIFF_DELETE,
            text1
        ],
        [
            $74011372a575a487$var$DIFF_INSERT,
            text2
        ]
    ];
}
/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @return {Array} Array of diff tuples.
 */ function $74011372a575a487$var$diff_bisectSplit_(text1, text2, x, y) {
    var text1a = text1.substring(0, x);
    var text2a = text2.substring(0, y);
    var text1b = text1.substring(x);
    var text2b = text2.substring(y);
    // Compute both diffs serially.
    var diffs = $74011372a575a487$var$diff_main(text1a, text2a);
    var diffsb = $74011372a575a487$var$diff_main(text1b, text2b);
    return diffs.concat(diffsb);
}
/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */ function $74011372a575a487$var$diff_commonPrefix(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 || text1.charAt(0) !== text2.charAt(0)) return 0;
    // Binary search.
    // Performance analysis: http://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerstart = 0;
    while(pointermin < pointermid){
        if (text1.substring(pointerstart, pointermid) == text2.substring(pointerstart, pointermid)) {
            pointermin = pointermid;
            pointerstart = pointermin;
        } else pointermax = pointermid;
        pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    if ($74011372a575a487$var$is_surrogate_pair_start(text1.charCodeAt(pointermid - 1))) pointermid--;
    return pointermid;
}
/**
 * Determine if the suffix of one string is the prefix of another.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of the first
 *     string and the start of the second string.
 * @private
 */ function $74011372a575a487$var$diff_commonOverlap_(text1, text2) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    // Eliminate the null case.
    if (text1_length == 0 || text2_length == 0) return 0;
    // Truncate the longer string.
    if (text1_length > text2_length) text1 = text1.substring(text1_length - text2_length);
    else if (text1_length < text2_length) text2 = text2.substring(0, text1_length);
    var text_length = Math.min(text1_length, text2_length);
    // Quick check for the worst case.
    if (text1 == text2) return text_length;
    // Start by looking for a single character match
    // and increase length until no match is found.
    // Performance analysis: http://neil.fraser.name/news/2010/11/04/
    var best = 0;
    var length = 1;
    while(true){
        var pattern = text1.substring(text_length - length);
        var found = text2.indexOf(pattern);
        if (found == -1) return best;
        length += found;
        if (found == 0 || text1.substring(text_length - length) == text2.substring(0, length)) {
            best = length;
            length++;
        }
    }
}
/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */ function $74011372a575a487$var$diff_commonSuffix(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 || text1.slice(-1) !== text2.slice(-1)) return 0;
    // Binary search.
    // Performance analysis: http://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerend = 0;
    while(pointermin < pointermid){
        if (text1.substring(text1.length - pointermid, text1.length - pointerend) == text2.substring(text2.length - pointermid, text2.length - pointerend)) {
            pointermin = pointermid;
            pointerend = pointermin;
        } else pointermax = pointermid;
        pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    if ($74011372a575a487$var$is_surrogate_pair_end(text1.charCodeAt(text1.length - pointermid))) pointermid--;
    return pointermid;
}
/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 */ function $74011372a575a487$var$diff_halfMatch_(text1, text2) {
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    if (longtext.length < 4 || shorttext.length * 2 < longtext.length) return null; // Pointless.
    /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */ function diff_halfMatchI_(longtext, shorttext, i) {
        // Start with a 1/4 length substring at position i as a seed.
        var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
        var j = -1;
        var best_common = "";
        var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
        while((j = shorttext.indexOf(seed, j + 1)) !== -1){
            var prefixLength = $74011372a575a487$var$diff_commonPrefix(longtext.substring(i), shorttext.substring(j));
            var suffixLength = $74011372a575a487$var$diff_commonSuffix(longtext.substring(0, i), shorttext.substring(0, j));
            if (best_common.length < suffixLength + prefixLength) {
                best_common = shorttext.substring(j - suffixLength, j) + shorttext.substring(j, j + prefixLength);
                best_longtext_a = longtext.substring(0, i - suffixLength);
                best_longtext_b = longtext.substring(i + prefixLength);
                best_shorttext_a = shorttext.substring(0, j - suffixLength);
                best_shorttext_b = shorttext.substring(j + prefixLength);
            }
        }
        if (best_common.length * 2 >= longtext.length) return [
            best_longtext_a,
            best_longtext_b,
            best_shorttext_a,
            best_shorttext_b,
            best_common
        ];
        else return null;
    }
    // First check if the second quarter is the seed for a half-match.
    var hm1 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 4));
    // Check again based on the third quarter.
    var hm2 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 2));
    var hm;
    if (!hm1 && !hm2) return null;
    else if (!hm2) hm = hm1;
    else if (!hm1) hm = hm2;
    else // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
    // A half-match was found, sort out the return data.
    var text1_a, text1_b, text2_a, text2_b;
    if (text1.length > text2.length) {
        text1_a = hm[0];
        text1_b = hm[1];
        text2_a = hm[2];
        text2_b = hm[3];
    } else {
        text2_a = hm[0];
        text2_b = hm[1];
        text1_a = hm[2];
        text1_b = hm[3];
    }
    var mid_common = hm[4];
    return [
        text1_a,
        text1_b,
        text2_a,
        text2_b,
        mid_common
    ];
}
/**
 * Reduce the number of edits by eliminating semantically trivial equalities.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ function $74011372a575a487$var$diff_cleanupSemantic(diffs) {
    var changes = false;
    var equalities = []; // Stack of indices where equalities are found.
    var equalitiesLength = 0; // Keeping our own length var is faster in JS.
    /** @type {?string} */ var lastequality = null;
    // Always equal to diffs[equalities[equalitiesLength - 1]][1]
    var pointer = 0; // Index of current position.
    // Number of characters that changed prior to the equality.
    var length_insertions1 = 0;
    var length_deletions1 = 0;
    // Number of characters that changed after the equality.
    var length_insertions2 = 0;
    var length_deletions2 = 0;
    while(pointer < diffs.length){
        if (diffs[pointer][0] == $74011372a575a487$var$DIFF_EQUAL) {
            // Equality found.
            equalities[equalitiesLength++] = pointer;
            length_insertions1 = length_insertions2;
            length_deletions1 = length_deletions2;
            length_insertions2 = 0;
            length_deletions2 = 0;
            lastequality = diffs[pointer][1];
        } else {
            // An insertion or deletion.
            if (diffs[pointer][0] == $74011372a575a487$var$DIFF_INSERT) length_insertions2 += diffs[pointer][1].length;
            else length_deletions2 += diffs[pointer][1].length;
            // Eliminate an equality that is smaller or equal to the edits on both
            // sides of it.
            if (lastequality && lastequality.length <= Math.max(length_insertions1, length_deletions1) && lastequality.length <= Math.max(length_insertions2, length_deletions2)) {
                // Duplicate record.
                diffs.splice(equalities[equalitiesLength - 1], 0, [
                    $74011372a575a487$var$DIFF_DELETE,
                    lastequality
                ]);
                // Change second copy to insert.
                diffs[equalities[equalitiesLength - 1] + 1][0] = $74011372a575a487$var$DIFF_INSERT;
                // Throw away the equality we just deleted.
                equalitiesLength--;
                // Throw away the previous equality (it needs to be reevaluated).
                equalitiesLength--;
                pointer = equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
                length_insertions1 = 0; // Reset the counters.
                length_deletions1 = 0;
                length_insertions2 = 0;
                length_deletions2 = 0;
                lastequality = null;
                changes = true;
            }
        }
        pointer++;
    }
    // Normalize the diff.
    if (changes) $74011372a575a487$var$diff_cleanupMerge(diffs);
    $74011372a575a487$var$diff_cleanupSemanticLossless(diffs);
    // Find any overlaps between deletions and insertions.
    // e.g: <del>abcxxx</del><ins>xxxdef</ins>
    //   -> <del>abc</del>xxx<ins>def</ins>
    // e.g: <del>xxxabc</del><ins>defxxx</ins>
    //   -> <ins>def</ins>xxx<del>abc</del>
    // Only extract an overlap if it is as big as the edit ahead or behind it.
    pointer = 1;
    while(pointer < diffs.length){
        if (diffs[pointer - 1][0] == $74011372a575a487$var$DIFF_DELETE && diffs[pointer][0] == $74011372a575a487$var$DIFF_INSERT) {
            var deletion = diffs[pointer - 1][1];
            var insertion = diffs[pointer][1];
            var overlap_length1 = $74011372a575a487$var$diff_commonOverlap_(deletion, insertion);
            var overlap_length2 = $74011372a575a487$var$diff_commonOverlap_(insertion, deletion);
            if (overlap_length1 >= overlap_length2) {
                if (overlap_length1 >= deletion.length / 2 || overlap_length1 >= insertion.length / 2) {
                    // Overlap found.  Insert an equality and trim the surrounding edits.
                    diffs.splice(pointer, 0, [
                        $74011372a575a487$var$DIFF_EQUAL,
                        insertion.substring(0, overlap_length1)
                    ]);
                    diffs[pointer - 1][1] = deletion.substring(0, deletion.length - overlap_length1);
                    diffs[pointer + 1][1] = insertion.substring(overlap_length1);
                    pointer++;
                }
            } else if (overlap_length2 >= deletion.length / 2 || overlap_length2 >= insertion.length / 2) {
                // Reverse overlap found.
                // Insert an equality and swap and trim the surrounding edits.
                diffs.splice(pointer, 0, [
                    $74011372a575a487$var$DIFF_EQUAL,
                    deletion.substring(0, overlap_length2)
                ]);
                diffs[pointer - 1][0] = $74011372a575a487$var$DIFF_INSERT;
                diffs[pointer - 1][1] = insertion.substring(0, insertion.length - overlap_length2);
                diffs[pointer + 1][0] = $74011372a575a487$var$DIFF_DELETE;
                diffs[pointer + 1][1] = deletion.substring(overlap_length2);
                pointer++;
            }
            pointer++;
        }
        pointer++;
    }
}
var $74011372a575a487$var$nonAlphaNumericRegex_ = /[^a-zA-Z0-9]/;
var $74011372a575a487$var$whitespaceRegex_ = /\s/;
var $74011372a575a487$var$linebreakRegex_ = /[\r\n]/;
var $74011372a575a487$var$blanklineEndRegex_ = /\n\r?\n$/;
var $74011372a575a487$var$blanklineStartRegex_ = /^\r?\n\r?\n/;
/**
 * Look for single edits surrounded on both sides by equalities
 * which can be shifted sideways to align the edit to a word boundary.
 * e.g: The c<ins>at c</ins>ame. -> The <ins>cat </ins>came.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ function $74011372a575a487$var$diff_cleanupSemanticLossless(diffs) {
    /**
   * Given two strings, compute a score representing whether the internal
   * boundary falls on logical boundaries.
   * Scores range from 6 (best) to 0 (worst).
   * Closure, but does not reference any external variables.
   * @param {string} one First string.
   * @param {string} two Second string.
   * @return {number} The score.
   * @private
   */ function diff_cleanupSemanticScore_(one, two) {
        if (!one || !two) // Edges are the best.
        return 6;
        // Each port of this function behaves slightly differently due to
        // subtle differences in each language's definition of things like
        // 'whitespace'.  Since this function's purpose is largely cosmetic,
        // the choice has been made to use each language's native features
        // rather than force total conformity.
        var char1 = one.charAt(one.length - 1);
        var char2 = two.charAt(0);
        var nonAlphaNumeric1 = char1.match($74011372a575a487$var$nonAlphaNumericRegex_);
        var nonAlphaNumeric2 = char2.match($74011372a575a487$var$nonAlphaNumericRegex_);
        var whitespace1 = nonAlphaNumeric1 && char1.match($74011372a575a487$var$whitespaceRegex_);
        var whitespace2 = nonAlphaNumeric2 && char2.match($74011372a575a487$var$whitespaceRegex_);
        var lineBreak1 = whitespace1 && char1.match($74011372a575a487$var$linebreakRegex_);
        var lineBreak2 = whitespace2 && char2.match($74011372a575a487$var$linebreakRegex_);
        var blankLine1 = lineBreak1 && one.match($74011372a575a487$var$blanklineEndRegex_);
        var blankLine2 = lineBreak2 && two.match($74011372a575a487$var$blanklineStartRegex_);
        if (blankLine1 || blankLine2) // Five points for blank lines.
        return 5;
        else if (lineBreak1 || lineBreak2) // Four points for line breaks.
        return 4;
        else if (nonAlphaNumeric1 && !whitespace1 && whitespace2) // Three points for end of sentences.
        return 3;
        else if (whitespace1 || whitespace2) // Two points for whitespace.
        return 2;
        else if (nonAlphaNumeric1 || nonAlphaNumeric2) // One point for non-alphanumeric.
        return 1;
        return 0;
    }
    var pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while(pointer < diffs.length - 1){
        if (diffs[pointer - 1][0] == $74011372a575a487$var$DIFF_EQUAL && diffs[pointer + 1][0] == $74011372a575a487$var$DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            var equality1 = diffs[pointer - 1][1];
            var edit = diffs[pointer][1];
            var equality2 = diffs[pointer + 1][1];
            // First, shift the edit as far left as possible.
            var commonOffset = $74011372a575a487$var$diff_commonSuffix(equality1, edit);
            if (commonOffset) {
                var commonString = edit.substring(edit.length - commonOffset);
                equality1 = equality1.substring(0, equality1.length - commonOffset);
                edit = commonString + edit.substring(0, edit.length - commonOffset);
                equality2 = commonString + equality2;
            }
            // Second, step character by character right, looking for the best fit.
            var bestEquality1 = equality1;
            var bestEdit = edit;
            var bestEquality2 = equality2;
            var bestScore = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
            while(edit.charAt(0) === equality2.charAt(0)){
                equality1 += edit.charAt(0);
                edit = edit.substring(1) + equality2.charAt(0);
                equality2 = equality2.substring(1);
                var score = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
                // The >= encourages trailing rather than leading whitespace on edits.
                if (score >= bestScore) {
                    bestScore = score;
                    bestEquality1 = equality1;
                    bestEdit = edit;
                    bestEquality2 = equality2;
                }
            }
            if (diffs[pointer - 1][1] != bestEquality1) {
                // We have an improvement, save it back to the diff.
                if (bestEquality1) diffs[pointer - 1][1] = bestEquality1;
                else {
                    diffs.splice(pointer - 1, 1);
                    pointer--;
                }
                diffs[pointer][1] = bestEdit;
                if (bestEquality2) diffs[pointer + 1][1] = bestEquality2;
                else {
                    diffs.splice(pointer + 1, 1);
                    pointer--;
                }
            }
        }
        pointer++;
    }
}
/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {Array} diffs Array of diff tuples.
 * @param {boolean} fix_unicode Whether to normalize to a unicode-correct diff
 */ function $74011372a575a487$var$diff_cleanupMerge(diffs, fix_unicode) {
    diffs.push([
        $74011372a575a487$var$DIFF_EQUAL,
        ""
    ]); // Add a dummy entry at the end.
    var pointer = 0;
    var count_delete = 0;
    var count_insert = 0;
    var text_delete = "";
    var text_insert = "";
    var commonlength;
    while(pointer < diffs.length){
        if (pointer < diffs.length - 1 && !diffs[pointer][1]) {
            diffs.splice(pointer, 1);
            continue;
        }
        switch(diffs[pointer][0]){
            case $74011372a575a487$var$DIFF_INSERT:
                count_insert++;
                text_insert += diffs[pointer][1];
                pointer++;
                break;
            case $74011372a575a487$var$DIFF_DELETE:
                count_delete++;
                text_delete += diffs[pointer][1];
                pointer++;
                break;
            case $74011372a575a487$var$DIFF_EQUAL:
                var previous_equality = pointer - count_insert - count_delete - 1;
                if (fix_unicode) {
                    // prevent splitting of unicode surrogate pairs.  when fix_unicode is true,
                    // we assume that the old and new text in the diff are complete and correct
                    // unicode-encoded JS strings, but the tuple boundaries may fall between
                    // surrogate pairs.  we fix this by shaving off stray surrogates from the end
                    // of the previous equality and the beginning of this equality.  this may create
                    // empty equalities or a common prefix or suffix.  for example, if AB and AC are
                    // emojis, `[[0, 'A'], [-1, 'BA'], [0, 'C']]` would turn into deleting 'ABAC' and
                    // inserting 'AC', and then the common suffix 'AC' will be eliminated.  in this
                    // particular case, both equalities go away, we absorb any previous inequalities,
                    // and we keep scanning for the next equality before rewriting the tuples.
                    if (previous_equality >= 0 && $74011372a575a487$var$ends_with_pair_start(diffs[previous_equality][1])) {
                        var stray = diffs[previous_equality][1].slice(-1);
                        diffs[previous_equality][1] = diffs[previous_equality][1].slice(0, -1);
                        text_delete = stray + text_delete;
                        text_insert = stray + text_insert;
                        if (!diffs[previous_equality][1]) {
                            // emptied out previous equality, so delete it and include previous delete/insert
                            diffs.splice(previous_equality, 1);
                            pointer--;
                            var k = previous_equality - 1;
                            if (diffs[k] && diffs[k][0] === $74011372a575a487$var$DIFF_INSERT) {
                                count_insert++;
                                text_insert = diffs[k][1] + text_insert;
                                k--;
                            }
                            if (diffs[k] && diffs[k][0] === $74011372a575a487$var$DIFF_DELETE) {
                                count_delete++;
                                text_delete = diffs[k][1] + text_delete;
                                k--;
                            }
                            previous_equality = k;
                        }
                    }
                    if ($74011372a575a487$var$starts_with_pair_end(diffs[pointer][1])) {
                        var stray = diffs[pointer][1].charAt(0);
                        diffs[pointer][1] = diffs[pointer][1].slice(1);
                        text_delete += stray;
                        text_insert += stray;
                    }
                }
                if (pointer < diffs.length - 1 && !diffs[pointer][1]) {
                    // for empty equality not at end, wait for next equality
                    diffs.splice(pointer, 1);
                    break;
                }
                if (text_delete.length > 0 || text_insert.length > 0) {
                    // note that diff_commonPrefix and diff_commonSuffix are unicode-aware
                    if (text_delete.length > 0 && text_insert.length > 0) {
                        // Factor out any common prefixes.
                        commonlength = $74011372a575a487$var$diff_commonPrefix(text_insert, text_delete);
                        if (commonlength !== 0) {
                            if (previous_equality >= 0) diffs[previous_equality][1] += text_insert.substring(0, commonlength);
                            else {
                                diffs.splice(0, 0, [
                                    $74011372a575a487$var$DIFF_EQUAL,
                                    text_insert.substring(0, commonlength)
                                ]);
                                pointer++;
                            }
                            text_insert = text_insert.substring(commonlength);
                            text_delete = text_delete.substring(commonlength);
                        }
                        // Factor out any common suffixes.
                        commonlength = $74011372a575a487$var$diff_commonSuffix(text_insert, text_delete);
                        if (commonlength !== 0) {
                            diffs[pointer][1] = text_insert.substring(text_insert.length - commonlength) + diffs[pointer][1];
                            text_insert = text_insert.substring(0, text_insert.length - commonlength);
                            text_delete = text_delete.substring(0, text_delete.length - commonlength);
                        }
                    }
                    // Delete the offending records and add the merged ones.
                    var n = count_insert + count_delete;
                    if (text_delete.length === 0 && text_insert.length === 0) {
                        diffs.splice(pointer - n, n);
                        pointer = pointer - n;
                    } else if (text_delete.length === 0) {
                        diffs.splice(pointer - n, n, [
                            $74011372a575a487$var$DIFF_INSERT,
                            text_insert
                        ]);
                        pointer = pointer - n + 1;
                    } else if (text_insert.length === 0) {
                        diffs.splice(pointer - n, n, [
                            $74011372a575a487$var$DIFF_DELETE,
                            text_delete
                        ]);
                        pointer = pointer - n + 1;
                    } else {
                        diffs.splice(pointer - n, n, [
                            $74011372a575a487$var$DIFF_DELETE,
                            text_delete
                        ], [
                            $74011372a575a487$var$DIFF_INSERT,
                            text_insert
                        ]);
                        pointer = pointer - n + 2;
                    }
                }
                if (pointer !== 0 && diffs[pointer - 1][0] === $74011372a575a487$var$DIFF_EQUAL) {
                    // Merge this equality with the previous one.
                    diffs[pointer - 1][1] += diffs[pointer][1];
                    diffs.splice(pointer, 1);
                } else pointer++;
                count_insert = 0;
                count_delete = 0;
                text_delete = "";
                text_insert = "";
                break;
        }
    }
    if (diffs[diffs.length - 1][1] === "") diffs.pop(); // Remove the dummy entry at the end.
    // Second pass: look for single edits surrounded on both sides by equalities
    // which can be shifted sideways to eliminate an equality.
    // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
    var changes = false;
    pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while(pointer < diffs.length - 1){
        if (diffs[pointer - 1][0] === $74011372a575a487$var$DIFF_EQUAL && diffs[pointer + 1][0] === $74011372a575a487$var$DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            if (diffs[pointer][1].substring(diffs[pointer][1].length - diffs[pointer - 1][1].length) === diffs[pointer - 1][1]) {
                // Shift the edit over the previous equality.
                diffs[pointer][1] = diffs[pointer - 1][1] + diffs[pointer][1].substring(0, diffs[pointer][1].length - diffs[pointer - 1][1].length);
                diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
                diffs.splice(pointer - 1, 1);
                changes = true;
            } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) == diffs[pointer + 1][1]) {
                // Shift the edit over the next equality.
                diffs[pointer - 1][1] += diffs[pointer + 1][1];
                diffs[pointer][1] = diffs[pointer][1].substring(diffs[pointer + 1][1].length) + diffs[pointer + 1][1];
                diffs.splice(pointer + 1, 1);
                changes = true;
            }
        }
        pointer++;
    }
    // If shifts were made, the diff needs reordering and another shift sweep.
    if (changes) $74011372a575a487$var$diff_cleanupMerge(diffs, fix_unicode);
}
function $74011372a575a487$var$is_surrogate_pair_start(charCode) {
    return charCode >= 0xd800 && charCode <= 0xdbff;
}
function $74011372a575a487$var$is_surrogate_pair_end(charCode) {
    return charCode >= 0xdc00 && charCode <= 0xdfff;
}
function $74011372a575a487$var$starts_with_pair_end(str) {
    return $74011372a575a487$var$is_surrogate_pair_end(str.charCodeAt(0));
}
function $74011372a575a487$var$ends_with_pair_start(str) {
    return $74011372a575a487$var$is_surrogate_pair_start(str.charCodeAt(str.length - 1));
}
function $74011372a575a487$var$remove_empty_tuples(tuples) {
    var ret = [];
    for(var i = 0; i < tuples.length; i++)if (tuples[i][1].length > 0) ret.push(tuples[i]);
    return ret;
}
function $74011372a575a487$var$make_edit_splice(before, oldMiddle, newMiddle, after) {
    if ($74011372a575a487$var$ends_with_pair_start(before) || $74011372a575a487$var$starts_with_pair_end(after)) return null;
    return $74011372a575a487$var$remove_empty_tuples([
        [
            $74011372a575a487$var$DIFF_EQUAL,
            before
        ],
        [
            $74011372a575a487$var$DIFF_DELETE,
            oldMiddle
        ],
        [
            $74011372a575a487$var$DIFF_INSERT,
            newMiddle
        ],
        [
            $74011372a575a487$var$DIFF_EQUAL,
            after
        ]
    ]);
}
function $74011372a575a487$var$find_cursor_edit_diff(oldText, newText, cursor_pos) {
    // note: this runs after equality check has ruled out exact equality
    var oldRange = typeof cursor_pos === "number" ? {
        index: cursor_pos,
        length: 0
    } : cursor_pos.oldRange;
    var newRange = typeof cursor_pos === "number" ? null : cursor_pos.newRange;
    // take into account the old and new selection to generate the best diff
    // possible for a text edit.  for example, a text change from "xxx" to "xx"
    // could be a delete or forwards-delete of any one of the x's, or the
    // result of selecting two of the x's and typing "x".
    var oldLength = oldText.length;
    var newLength = newText.length;
    if (oldRange.length === 0 && (newRange === null || newRange.length === 0)) {
        // see if we have an insert or delete before or after cursor
        var oldCursor = oldRange.index;
        var oldBefore = oldText.slice(0, oldCursor);
        var oldAfter = oldText.slice(oldCursor);
        var maybeNewCursor = newRange ? newRange.index : null;
        editBefore: {
            // is this an insert or delete right before oldCursor?
            var newCursor = oldCursor + newLength - oldLength;
            if (maybeNewCursor !== null && maybeNewCursor !== newCursor) break editBefore;
            if (newCursor < 0 || newCursor > newLength) break editBefore;
            var newBefore = newText.slice(0, newCursor);
            var newAfter = newText.slice(newCursor);
            if (newAfter !== oldAfter) break editBefore;
            var prefixLength = Math.min(oldCursor, newCursor);
            var oldPrefix = oldBefore.slice(0, prefixLength);
            var newPrefix = newBefore.slice(0, prefixLength);
            if (oldPrefix !== newPrefix) break editBefore;
            var oldMiddle = oldBefore.slice(prefixLength);
            var newMiddle = newBefore.slice(prefixLength);
            return $74011372a575a487$var$make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldAfter);
        }
        editAfter: {
            // is this an insert or delete right after oldCursor?
            if (maybeNewCursor !== null && maybeNewCursor !== oldCursor) break editAfter;
            var cursor = oldCursor;
            var newBefore = newText.slice(0, cursor);
            var newAfter = newText.slice(cursor);
            if (newBefore !== oldBefore) break editAfter;
            var suffixLength = Math.min(oldLength - cursor, newLength - cursor);
            var oldSuffix = oldAfter.slice(oldAfter.length - suffixLength);
            var newSuffix = newAfter.slice(newAfter.length - suffixLength);
            if (oldSuffix !== newSuffix) break editAfter;
            var oldMiddle = oldAfter.slice(0, oldAfter.length - suffixLength);
            var newMiddle = newAfter.slice(0, newAfter.length - suffixLength);
            return $74011372a575a487$var$make_edit_splice(oldBefore, oldMiddle, newMiddle, oldSuffix);
        }
    }
    if (oldRange.length > 0 && newRange && newRange.length === 0) replaceRange: {
        // see if diff could be a splice of the old selection range
        var oldPrefix = oldText.slice(0, oldRange.index);
        var oldSuffix = oldText.slice(oldRange.index + oldRange.length);
        var prefixLength = oldPrefix.length;
        var suffixLength = oldSuffix.length;
        if (newLength < prefixLength + suffixLength) break replaceRange;
        var newPrefix = newText.slice(0, prefixLength);
        var newSuffix = newText.slice(newLength - suffixLength);
        if (oldPrefix !== newPrefix || oldSuffix !== newSuffix) break replaceRange;
        var oldMiddle = oldText.slice(prefixLength, oldLength - suffixLength);
        var newMiddle = newText.slice(prefixLength, newLength - suffixLength);
        return $74011372a575a487$var$make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldSuffix);
    }
    return null;
}
function $74011372a575a487$var$diff(text1, text2, cursor_pos, cleanup) {
    // only pass fix_unicode=true at the top level, not when diff_main is
    // recursively invoked
    return $74011372a575a487$var$diff_main(text1, text2, cursor_pos, cleanup, true);
}
$74011372a575a487$var$diff.INSERT = $74011372a575a487$var$DIFF_INSERT;
$74011372a575a487$var$diff.DELETE = $74011372a575a487$var$DIFF_DELETE;
$74011372a575a487$var$diff.EQUAL = $74011372a575a487$var$DIFF_EQUAL;
$74011372a575a487$exports = $74011372a575a487$var$diff;



var $hkB5a = parcelRequire("hkB5a");

var $jpGem = parcelRequire("jpGem");
var $bef20ddbb475e122$exports = {};
"use strict";
Object.defineProperty($bef20ddbb475e122$exports, "__esModule", {
    value: true
});

var $hkB5a = parcelRequire("hkB5a");

var $jpGem = parcelRequire("jpGem");
var $bef20ddbb475e122$var$AttributeMap;
(function(AttributeMap) {
    function compose(a = {}, b = {}, keepNull = false) {
        if (typeof a !== 'object') a = {};
        if (typeof b !== 'object') b = {};
        let attributes = $hkB5a(b);
        if (!keepNull) attributes = Object.keys(attributes).reduce((copy, key)=>{
            if (attributes[key] != null) copy[key] = attributes[key];
            return copy;
        }, {});
        for(const key in a)if (a[key] !== undefined && b[key] === undefined) attributes[key] = a[key];
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.compose = compose;
    function diff(a = {}, b = {}) {
        if (typeof a !== 'object') a = {};
        if (typeof b !== 'object') b = {};
        const attributes = Object.keys(a).concat(Object.keys(b)).reduce((attrs, key)=>{
            if (!$jpGem(a[key], b[key])) attrs[key] = b[key] === undefined ? null : b[key];
            return attrs;
        }, {});
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.diff = diff;
    function invert(attr = {}, base = {}) {
        attr = attr || {};
        const baseInverted = Object.keys(base).reduce((memo, key)=>{
            if (base[key] !== attr[key] && attr[key] !== undefined) memo[key] = base[key];
            return memo;
        }, {});
        return Object.keys(attr).reduce((memo, key)=>{
            if (attr[key] !== base[key] && base[key] === undefined) memo[key] = null;
            return memo;
        }, baseInverted);
    }
    AttributeMap.invert = invert;
    function transform(a, b, priority = false) {
        if (typeof a !== 'object') return b;
        if (typeof b !== 'object') return undefined;
        if (!priority) return b; // b simply overwrites us without priority
        const attributes = Object.keys(b).reduce((attrs, key)=>{
            if (a[key] === undefined) attrs[key] = b[key]; // null is a valid value
            return attrs;
        }, {});
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.transform = transform;
})($bef20ddbb475e122$var$AttributeMap || ($bef20ddbb475e122$var$AttributeMap = {}));
$bef20ddbb475e122$exports.default = $bef20ddbb475e122$var$AttributeMap;


$b0994a93e93413e9$exports.AttributeMap = $bef20ddbb475e122$exports.default;
var $24280692bd6bc88c$exports = {};
"use strict";
Object.defineProperty($24280692bd6bc88c$exports, "__esModule", {
    value: true
});
var $24280692bd6bc88c$var$Op;
(function(Op) {
    function length(op) {
        if (typeof op.delete === 'number') return op.delete;
        else if (typeof op.retain === 'number') return op.retain;
        else if (typeof op.retain === 'object' && op.retain !== null) return 1;
        else return typeof op.insert === 'string' ? op.insert.length : 1;
    }
    Op.length = length;
})($24280692bd6bc88c$var$Op || ($24280692bd6bc88c$var$Op = {}));
$24280692bd6bc88c$exports.default = $24280692bd6bc88c$var$Op;


$b0994a93e93413e9$exports.Op = $24280692bd6bc88c$exports.default;
var $4f89e4ef240eac3a$exports = {};
"use strict";
Object.defineProperty($4f89e4ef240eac3a$exports, "__esModule", {
    value: true
});

class $4f89e4ef240eac3a$var$Iterator {
    constructor(ops){
        this.ops = ops;
        this.index = 0;
        this.offset = 0;
    }
    hasNext() {
        return this.peekLength() < Infinity;
    }
    next(length) {
        if (!length) length = Infinity;
        const nextOp = this.ops[this.index];
        if (nextOp) {
            const offset = this.offset;
            const opLength = $24280692bd6bc88c$exports.default.length(nextOp);
            if (length >= opLength - offset) {
                length = opLength - offset;
                this.index += 1;
                this.offset = 0;
            } else this.offset += length;
            if (typeof nextOp.delete === 'number') return {
                delete: length
            };
            else {
                const retOp = {};
                if (nextOp.attributes) retOp.attributes = nextOp.attributes;
                if (typeof nextOp.retain === 'number') retOp.retain = length;
                else if (typeof nextOp.retain === 'object' && nextOp.retain !== null) // offset should === 0, length should === 1
                retOp.retain = nextOp.retain;
                else if (typeof nextOp.insert === 'string') retOp.insert = nextOp.insert.substr(offset, length);
                else // offset should === 0, length should === 1
                retOp.insert = nextOp.insert;
                return retOp;
            }
        } else return {
            retain: Infinity
        };
    }
    peek() {
        return this.ops[this.index];
    }
    peekLength() {
        if (this.ops[this.index]) // Should never return 0 if our index is being managed correctly
        return $24280692bd6bc88c$exports.default.length(this.ops[this.index]) - this.offset;
        else return Infinity;
    }
    peekType() {
        const op = this.ops[this.index];
        if (op) {
            if (typeof op.delete === 'number') return 'delete';
            else if (typeof op.retain === 'number' || typeof op.retain === 'object' && op.retain !== null) return 'retain';
            else return 'insert';
        }
        return 'retain';
    }
    rest() {
        if (!this.hasNext()) return [];
        else if (this.offset === 0) return this.ops.slice(this.index);
        else {
            const offset = this.offset;
            const index = this.index;
            const next = this.next();
            const rest = this.ops.slice(this.index);
            this.offset = offset;
            this.index = index;
            return [
                next
            ].concat(rest);
        }
    }
}
$4f89e4ef240eac3a$exports.default = $4f89e4ef240eac3a$var$Iterator;


$b0994a93e93413e9$exports.OpIterator = $4f89e4ef240eac3a$exports.default;
const $b0994a93e93413e9$var$NULL_CHARACTER = String.fromCharCode(0); // Placeholder char for embed in diff()
const $b0994a93e93413e9$var$getEmbedTypeAndData = (a, b)=>{
    if (typeof a !== 'object' || a === null) throw new Error(`cannot retain a ${typeof a}`);
    if (typeof b !== 'object' || b === null) throw new Error(`cannot retain a ${typeof b}`);
    const embedType = Object.keys(a)[0];
    if (!embedType || embedType !== Object.keys(b)[0]) throw new Error(`embed types not matched: ${embedType} != ${Object.keys(b)[0]}`);
    return [
        embedType,
        a[embedType],
        b[embedType]
    ];
};
class $b0994a93e93413e9$var$Delta {
    constructor(ops){
        // Assume we are given a well formed ops
        if (Array.isArray(ops)) this.ops = ops;
        else if (ops != null && Array.isArray(ops.ops)) this.ops = ops.ops;
        else this.ops = [];
    }
    static registerEmbed(embedType, handler) {
        this.handlers[embedType] = handler;
    }
    static unregisterEmbed(embedType) {
        delete this.handlers[embedType];
    }
    static getHandler(embedType) {
        const handler = this.handlers[embedType];
        if (!handler) throw new Error(`no handlers for embed type "${embedType}"`);
        return handler;
    }
    insert(arg, attributes) {
        const newOp = {};
        if (typeof arg === 'string' && arg.length === 0) return this;
        newOp.insert = arg;
        if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) newOp.attributes = attributes;
        return this.push(newOp);
    }
    delete(length) {
        if (length <= 0) return this;
        return this.push({
            delete: length
        });
    }
    retain(length, attributes) {
        if (typeof length === 'number' && length <= 0) return this;
        const newOp = {
            retain: length
        };
        if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) newOp.attributes = attributes;
        return this.push(newOp);
    }
    push(newOp) {
        let index = this.ops.length;
        let lastOp = this.ops[index - 1];
        newOp = $hkB5a(newOp);
        if (typeof lastOp === 'object') {
            if (typeof newOp.delete === 'number' && typeof lastOp.delete === 'number') {
                this.ops[index - 1] = {
                    delete: lastOp.delete + newOp.delete
                };
                return this;
            }
            // Since it does not matter if we insert before or after deleting at the same index,
            // always prefer to insert first
            if (typeof lastOp.delete === 'number' && newOp.insert != null) {
                index -= 1;
                lastOp = this.ops[index - 1];
                if (typeof lastOp !== 'object') {
                    this.ops.unshift(newOp);
                    return this;
                }
            }
            if ($jpGem(newOp.attributes, lastOp.attributes)) {
                if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
                    this.ops[index - 1] = {
                        insert: lastOp.insert + newOp.insert
                    };
                    if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes;
                    return this;
                } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
                    this.ops[index - 1] = {
                        retain: lastOp.retain + newOp.retain
                    };
                    if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes;
                    return this;
                }
            }
        }
        if (index === this.ops.length) this.ops.push(newOp);
        else this.ops.splice(index, 0, newOp);
        return this;
    }
    chop() {
        const lastOp = this.ops[this.ops.length - 1];
        if (lastOp && typeof lastOp.retain === 'number' && !lastOp.attributes) this.ops.pop();
        return this;
    }
    filter(predicate) {
        return this.ops.filter(predicate);
    }
    forEach(predicate) {
        this.ops.forEach(predicate);
    }
    map(predicate) {
        return this.ops.map(predicate);
    }
    partition(predicate) {
        const passed = [];
        const failed = [];
        this.forEach((op)=>{
            const target = predicate(op) ? passed : failed;
            target.push(op);
        });
        return [
            passed,
            failed
        ];
    }
    reduce(predicate, initialValue) {
        return this.ops.reduce(predicate, initialValue);
    }
    changeLength() {
        return this.reduce((length, elem)=>{
            if (elem.insert) return length + $24280692bd6bc88c$exports.default.length(elem);
            else if (elem.delete) return length - elem.delete;
            return length;
        }, 0);
    }
    length() {
        return this.reduce((length, elem)=>{
            return length + $24280692bd6bc88c$exports.default.length(elem);
        }, 0);
    }
    slice(start = 0, end = Infinity) {
        const ops = [];
        const iter = new $4f89e4ef240eac3a$exports.default(this.ops);
        let index = 0;
        while(index < end && iter.hasNext()){
            let nextOp;
            if (index < start) nextOp = iter.next(start - index);
            else {
                nextOp = iter.next(end - index);
                ops.push(nextOp);
            }
            index += $24280692bd6bc88c$exports.default.length(nextOp);
        }
        return new $b0994a93e93413e9$var$Delta(ops);
    }
    compose(other) {
        const thisIter = new $4f89e4ef240eac3a$exports.default(this.ops);
        const otherIter = new $4f89e4ef240eac3a$exports.default(other.ops);
        const ops = [];
        const firstOther = otherIter.peek();
        if (firstOther != null && typeof firstOther.retain === 'number' && firstOther.attributes == null) {
            let firstLeft = firstOther.retain;
            while(thisIter.peekType() === 'insert' && thisIter.peekLength() <= firstLeft){
                firstLeft -= thisIter.peekLength();
                ops.push(thisIter.next());
            }
            if (firstOther.retain - firstLeft > 0) otherIter.next(firstOther.retain - firstLeft);
        }
        const delta = new $b0994a93e93413e9$var$Delta(ops);
        while(thisIter.hasNext() || otherIter.hasNext()){
            if (otherIter.peekType() === 'insert') delta.push(otherIter.next());
            else if (thisIter.peekType() === 'delete') delta.push(thisIter.next());
            else {
                const length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                const thisOp = thisIter.next(length);
                const otherOp = otherIter.next(length);
                if (otherOp.retain) {
                    const newOp = {};
                    if (typeof thisOp.retain === 'number') newOp.retain = typeof otherOp.retain === 'number' ? length : otherOp.retain;
                    else if (typeof otherOp.retain === 'number') {
                        if (thisOp.retain == null) newOp.insert = thisOp.insert;
                        else newOp.retain = thisOp.retain;
                    } else {
                        const action = thisOp.retain == null ? 'insert' : 'retain';
                        const [embedType, thisData, otherData] = $b0994a93e93413e9$var$getEmbedTypeAndData(thisOp[action], otherOp.retain);
                        const handler = $b0994a93e93413e9$var$Delta.getHandler(embedType);
                        newOp[action] = {
                            [embedType]: handler.compose(thisData, otherData, action === 'retain')
                        };
                    }
                    // Preserve null when composing with a retain, otherwise remove it for inserts
                    const attributes = $bef20ddbb475e122$exports.default.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
                    if (attributes) newOp.attributes = attributes;
                    delta.push(newOp);
                    // Optimization if rest of other is just retain
                    if (!otherIter.hasNext() && $jpGem(delta.ops[delta.ops.length - 1], newOp)) {
                        const rest = new $b0994a93e93413e9$var$Delta(thisIter.rest());
                        return delta.concat(rest).chop();
                    }
                // Other op should be delete, we could be an insert or retain
                // Insert + delete cancels out
                } else if (typeof otherOp.delete === 'number' && (typeof thisOp.retain === 'number' || typeof thisOp.retain === 'object' && thisOp.retain !== null)) delta.push(otherOp);
            }
        }
        return delta.chop();
    }
    concat(other) {
        const delta = new $b0994a93e93413e9$var$Delta(this.ops.slice());
        if (other.ops.length > 0) {
            delta.push(other.ops[0]);
            delta.ops = delta.ops.concat(other.ops.slice(1));
        }
        return delta;
    }
    diff(other, cursor) {
        if (this.ops === other.ops) return new $b0994a93e93413e9$var$Delta();
        const strings = [
            this,
            other
        ].map((delta)=>{
            return delta.map((op)=>{
                if (op.insert != null) return typeof op.insert === 'string' ? op.insert : $b0994a93e93413e9$var$NULL_CHARACTER;
                const prep = delta === other ? 'on' : 'with';
                throw new Error('diff() called ' + prep + ' non-document');
            }).join('');
        });
        const retDelta = new $b0994a93e93413e9$var$Delta();
        const diffResult = $74011372a575a487$exports(strings[0], strings[1], cursor, true);
        const thisIter = new $4f89e4ef240eac3a$exports.default(this.ops);
        const otherIter = new $4f89e4ef240eac3a$exports.default(other.ops);
        diffResult.forEach((component)=>{
            let length = component[1].length;
            while(length > 0){
                let opLength = 0;
                switch(component[0]){
                    case $74011372a575a487$exports.INSERT:
                        opLength = Math.min(otherIter.peekLength(), length);
                        retDelta.push(otherIter.next(opLength));
                        break;
                    case $74011372a575a487$exports.DELETE:
                        opLength = Math.min(length, thisIter.peekLength());
                        thisIter.next(opLength);
                        retDelta.delete(opLength);
                        break;
                    case $74011372a575a487$exports.EQUAL:
                        opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
                        const thisOp = thisIter.next(opLength);
                        const otherOp = otherIter.next(opLength);
                        if ($jpGem(thisOp.insert, otherOp.insert)) retDelta.retain(opLength, $bef20ddbb475e122$exports.default.diff(thisOp.attributes, otherOp.attributes));
                        else retDelta.push(otherOp).delete(opLength);
                        break;
                }
                length -= opLength;
            }
        });
        return retDelta.chop();
    }
    eachLine(predicate, newline = '\n') {
        const iter = new $4f89e4ef240eac3a$exports.default(this.ops);
        let line = new $b0994a93e93413e9$var$Delta();
        let i = 0;
        while(iter.hasNext()){
            if (iter.peekType() !== 'insert') return;
            const thisOp = iter.peek();
            const start = $24280692bd6bc88c$exports.default.length(thisOp) - iter.peekLength();
            const index = typeof thisOp.insert === 'string' ? thisOp.insert.indexOf(newline, start) - start : -1;
            if (index < 0) line.push(iter.next());
            else if (index > 0) line.push(iter.next(index));
            else {
                if (predicate(line, iter.next(1).attributes || {}, i) === false) return;
                i += 1;
                line = new $b0994a93e93413e9$var$Delta();
            }
        }
        if (line.length() > 0) predicate(line, {}, i);
    }
    invert(base) {
        const inverted = new $b0994a93e93413e9$var$Delta();
        this.reduce((baseIndex, op)=>{
            if (op.insert) inverted.delete($24280692bd6bc88c$exports.default.length(op));
            else if (typeof op.retain === 'number' && op.attributes == null) {
                inverted.retain(op.retain);
                return baseIndex + op.retain;
            } else if (op.delete || typeof op.retain === 'number') {
                const length = op.delete || op.retain;
                const slice = base.slice(baseIndex, baseIndex + length);
                slice.forEach((baseOp)=>{
                    if (op.delete) inverted.push(baseOp);
                    else if (op.retain && op.attributes) inverted.retain($24280692bd6bc88c$exports.default.length(baseOp), $bef20ddbb475e122$exports.default.invert(op.attributes, baseOp.attributes));
                });
                return baseIndex + length;
            } else if (typeof op.retain === 'object' && op.retain !== null) {
                const slice = base.slice(baseIndex, baseIndex + 1);
                const baseOp = new $4f89e4ef240eac3a$exports.default(slice.ops).next();
                const [embedType, opData, baseOpData] = $b0994a93e93413e9$var$getEmbedTypeAndData(op.retain, baseOp.insert);
                const handler = $b0994a93e93413e9$var$Delta.getHandler(embedType);
                inverted.retain({
                    [embedType]: handler.invert(opData, baseOpData)
                }, $bef20ddbb475e122$exports.default.invert(op.attributes, baseOp.attributes));
                return baseIndex + 1;
            }
            return baseIndex;
        }, 0);
        return inverted.chop();
    }
    transform(arg, priority = false) {
        priority = !!priority;
        if (typeof arg === 'number') return this.transformPosition(arg, priority);
        const other = arg;
        const thisIter = new $4f89e4ef240eac3a$exports.default(this.ops);
        const otherIter = new $4f89e4ef240eac3a$exports.default(other.ops);
        const delta = new $b0994a93e93413e9$var$Delta();
        while(thisIter.hasNext() || otherIter.hasNext()){
            if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) delta.retain($24280692bd6bc88c$exports.default.length(thisIter.next()));
            else if (otherIter.peekType() === 'insert') delta.push(otherIter.next());
            else {
                const length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                const thisOp = thisIter.next(length);
                const otherOp = otherIter.next(length);
                if (thisOp.delete) continue;
                else if (otherOp.delete) delta.push(otherOp);
                else {
                    const thisData = thisOp.retain;
                    const otherData = otherOp.retain;
                    let transformedData = typeof otherData === 'object' && otherData !== null ? otherData : length;
                    if (typeof thisData === 'object' && thisData !== null && typeof otherData === 'object' && otherData !== null) {
                        const embedType = Object.keys(thisData)[0];
                        if (embedType === Object.keys(otherData)[0]) {
                            const handler = $b0994a93e93413e9$var$Delta.getHandler(embedType);
                            if (handler) transformedData = {
                                [embedType]: handler.transform(thisData[embedType], otherData[embedType], priority)
                            };
                        }
                    }
                    // We retain either their retain or insert
                    delta.retain(transformedData, $bef20ddbb475e122$exports.default.transform(thisOp.attributes, otherOp.attributes, priority));
                }
            }
        }
        return delta.chop();
    }
    transformPosition(index, priority = false) {
        priority = !!priority;
        const thisIter = new $4f89e4ef240eac3a$exports.default(this.ops);
        let offset = 0;
        while(thisIter.hasNext() && offset <= index){
            const length = thisIter.peekLength();
            const nextType = thisIter.peekType();
            thisIter.next();
            if (nextType === 'delete') {
                index -= Math.min(length, index - offset);
                continue;
            } else if (nextType === 'insert' && (offset < index || !priority)) index += length;
            offset += length;
        }
        return index;
    }
}
$b0994a93e93413e9$var$Delta.Op = $24280692bd6bc88c$exports.default;
$b0994a93e93413e9$var$Delta.OpIterator = $4f89e4ef240eac3a$exports.default;
$b0994a93e93413e9$var$Delta.AttributeMap = $bef20ddbb475e122$exports.default;
$b0994a93e93413e9$var$Delta.handlers = {};
$b0994a93e93413e9$exports.default = $b0994a93e93413e9$var$Delta;
$b0994a93e93413e9$exports = $b0994a93e93413e9$var$Delta;
$b0994a93e93413e9$exports.default = $b0994a93e93413e9$var$Delta;



/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $fe340ff4c27eabd3$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $fe340ff4c27eabd3$export$2e2bcd8739ae039 = $fe340ff4c27eabd3$var$arrayEach;







/* Built-in method references for those with the same name as other `lodash` methods. */ var $f639837706ee4297$var$nativeKeys = (0, $025f1b7fefdfd289$export$2e2bcd8739ae039)(Object.keys, Object);
var $f639837706ee4297$export$2e2bcd8739ae039 = $f639837706ee4297$var$nativeKeys;


/** Used for built-in method references. */ var $e3e791d1c295bbfe$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e3e791d1c295bbfe$var$hasOwnProperty = $e3e791d1c295bbfe$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e3e791d1c295bbfe$var$baseKeys(object) {
    if (!(0, $3362d6d05c5dd3c7$export$2e2bcd8739ae039)(object)) return (0, $f639837706ee4297$export$2e2bcd8739ae039)(object);
    var result = [];
    for(var key in Object(object))if ($e3e791d1c295bbfe$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $e3e791d1c295bbfe$export$2e2bcd8739ae039 = $e3e791d1c295bbfe$var$baseKeys;



/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $19a27738ba71729f$var$keys(object) {
    return (0, $10c7eb5f791dfca9$export$2e2bcd8739ae039)(object) ? (0, $a1b6027477e5e7a5$export$2e2bcd8739ae039)(object) : (0, $e3e791d1c295bbfe$export$2e2bcd8739ae039)(object);
}
var $19a27738ba71729f$export$2e2bcd8739ae039 = $19a27738ba71729f$var$keys;


/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $d34f089a0c641c49$var$baseAssign(object, source) {
    return object && (0, $267eb7b1664a4334$export$2e2bcd8739ae039)(source, (0, $19a27738ba71729f$export$2e2bcd8739ae039)(source), object);
}
var $d34f089a0c641c49$export$2e2bcd8739ae039 = $d34f089a0c641c49$var$baseAssign;




/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $edd0b8b77c2af29b$var$baseAssignIn(object, source) {
    return object && (0, $267eb7b1664a4334$export$2e2bcd8739ae039)(source, (0, $dad844e55cc75ed8$export$2e2bcd8739ae039)(source), object);
}
var $edd0b8b77c2af29b$export$2e2bcd8739ae039 = $edd0b8b77c2af29b$var$baseAssignIn;



var $c84AI = parcelRequire("c84AI");


/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $e159781c52726750$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $e159781c52726750$export$2e2bcd8739ae039 = $e159781c52726750$var$arrayFilter;


/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $2710c49cf5cde30c$var$stubArray() {
    return [];
}
var $2710c49cf5cde30c$export$2e2bcd8739ae039 = $2710c49cf5cde30c$var$stubArray;


/** Used for built-in method references. */ var $ae1b29691daf723c$var$objectProto = Object.prototype;
/** Built-in value references. */ var $ae1b29691daf723c$var$propertyIsEnumerable = $ae1b29691daf723c$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ae1b29691daf723c$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $ae1b29691daf723c$var$getSymbols = !$ae1b29691daf723c$var$nativeGetSymbols ? (0, $2710c49cf5cde30c$export$2e2bcd8739ae039) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $e159781c52726750$export$2e2bcd8739ae039)($ae1b29691daf723c$var$nativeGetSymbols(object), function(symbol) {
        return $ae1b29691daf723c$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $ae1b29691daf723c$export$2e2bcd8739ae039 = $ae1b29691daf723c$var$getSymbols;


/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $a0fd2be509c764f0$var$copySymbols(source, object) {
    return (0, $267eb7b1664a4334$export$2e2bcd8739ae039)(source, (0, $ae1b29691daf723c$export$2e2bcd8739ae039)(source), object);
}
var $a0fd2be509c764f0$export$2e2bcd8739ae039 = $a0fd2be509c764f0$var$copySymbols;



/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $8f4a9952b0e7ce0d$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $8f4a9952b0e7ce0d$export$2e2bcd8739ae039 = $8f4a9952b0e7ce0d$var$arrayPush;





/* Built-in method references for those with the same name as other `lodash` methods. */ var $a203928a5a27f5eb$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $a203928a5a27f5eb$var$getSymbolsIn = !$a203928a5a27f5eb$var$nativeGetSymbols ? (0, $2710c49cf5cde30c$export$2e2bcd8739ae039) : function(object) {
    var result = [];
    while(object){
        (0, $8f4a9952b0e7ce0d$export$2e2bcd8739ae039)(result, (0, $ae1b29691daf723c$export$2e2bcd8739ae039)(object));
        object = (0, $7dc8997d1a06ff2e$export$2e2bcd8739ae039)(object);
    }
    return result;
};
var $a203928a5a27f5eb$export$2e2bcd8739ae039 = $a203928a5a27f5eb$var$getSymbolsIn;


/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $5d0725b2278bdafa$var$copySymbolsIn(source, object) {
    return (0, $267eb7b1664a4334$export$2e2bcd8739ae039)(source, (0, $a203928a5a27f5eb$export$2e2bcd8739ae039)(source), object);
}
var $5d0725b2278bdafa$export$2e2bcd8739ae039 = $5d0725b2278bdafa$var$copySymbolsIn;




/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7e096ed74fe45407$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $50159e231742c958$export$2e2bcd8739ae039)(object) ? result : (0, $8f4a9952b0e7ce0d$export$2e2bcd8739ae039)(result, symbolsFunc(object));
}
var $7e096ed74fe45407$export$2e2bcd8739ae039 = $7e096ed74fe45407$var$baseGetAllKeys;




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $843d9ecec42ce0fc$var$getAllKeys(object) {
    return (0, $7e096ed74fe45407$export$2e2bcd8739ae039)(object, (0, $19a27738ba71729f$export$2e2bcd8739ae039), (0, $ae1b29691daf723c$export$2e2bcd8739ae039));
}
var $843d9ecec42ce0fc$export$2e2bcd8739ae039 = $843d9ecec42ce0fc$var$getAllKeys;





/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $2f9ed1098b336cc7$var$getAllKeysIn(object) {
    return (0, $7e096ed74fe45407$export$2e2bcd8739ae039)(object, (0, $dad844e55cc75ed8$export$2e2bcd8739ae039), (0, $a203928a5a27f5eb$export$2e2bcd8739ae039));
}
var $2f9ed1098b336cc7$export$2e2bcd8739ae039 = $2f9ed1098b336cc7$var$getAllKeysIn;




var $hdL4c = parcelRequire("hdL4c");
/* Built-in method references that are verified to be native. */ var $1da436c65fc1cf1f$var$DataView = (0, $89b3b938d4180065$export$2e2bcd8739ae039)((0, $hdL4c.default), 'DataView');
var $1da436c65fc1cf1f$export$2e2bcd8739ae039 = $1da436c65fc1cf1f$var$DataView;





var $hdL4c = parcelRequire("hdL4c");
/* Built-in method references that are verified to be native. */ var $f13cc3efa9d19b87$var$Promise = (0, $89b3b938d4180065$export$2e2bcd8739ae039)((0, $hdL4c.default), 'Promise');
var $f13cc3efa9d19b87$export$2e2bcd8739ae039 = $f13cc3efa9d19b87$var$Promise;




var $hdL4c = parcelRequire("hdL4c");
/* Built-in method references that are verified to be native. */ var $04c3c31661f8e58d$var$Set = (0, $89b3b938d4180065$export$2e2bcd8739ae039)((0, $hdL4c.default), 'Set');
var $04c3c31661f8e58d$export$2e2bcd8739ae039 = $04c3c31661f8e58d$var$Set;




var $hdL4c = parcelRequire("hdL4c");
/* Built-in method references that are verified to be native. */ var $f29460f69ed6365d$var$WeakMap = (0, $89b3b938d4180065$export$2e2bcd8739ae039)((0, $hdL4c.default), 'WeakMap');
var $f29460f69ed6365d$export$2e2bcd8739ae039 = $f29460f69ed6365d$var$WeakMap;




/** `Object#toString` result references. */ var $71ed1aa3078499f7$var$mapTag = '[object Map]', $71ed1aa3078499f7$var$objectTag = '[object Object]', $71ed1aa3078499f7$var$promiseTag = '[object Promise]', $71ed1aa3078499f7$var$setTag = '[object Set]', $71ed1aa3078499f7$var$weakMapTag = '[object WeakMap]';
var $71ed1aa3078499f7$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $71ed1aa3078499f7$var$dataViewCtorString = (0, $3461967a505fe51b$export$2e2bcd8739ae039)((0, $1da436c65fc1cf1f$export$2e2bcd8739ae039)), $71ed1aa3078499f7$var$mapCtorString = (0, $3461967a505fe51b$export$2e2bcd8739ae039)((0, $ca11d0f0b14fe6e7$export$2e2bcd8739ae039)), $71ed1aa3078499f7$var$promiseCtorString = (0, $3461967a505fe51b$export$2e2bcd8739ae039)((0, $f13cc3efa9d19b87$export$2e2bcd8739ae039)), $71ed1aa3078499f7$var$setCtorString = (0, $3461967a505fe51b$export$2e2bcd8739ae039)((0, $04c3c31661f8e58d$export$2e2bcd8739ae039)), $71ed1aa3078499f7$var$weakMapCtorString = (0, $3461967a505fe51b$export$2e2bcd8739ae039)((0, $f29460f69ed6365d$export$2e2bcd8739ae039));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $71ed1aa3078499f7$var$getTag = (0, $4858f35ffd09f1fe$export$2e2bcd8739ae039);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $1da436c65fc1cf1f$export$2e2bcd8739ae039) && $71ed1aa3078499f7$var$getTag(new (0, $1da436c65fc1cf1f$export$2e2bcd8739ae039)(new ArrayBuffer(1))) != $71ed1aa3078499f7$var$dataViewTag || (0, $ca11d0f0b14fe6e7$export$2e2bcd8739ae039) && $71ed1aa3078499f7$var$getTag(new (0, $ca11d0f0b14fe6e7$export$2e2bcd8739ae039)) != $71ed1aa3078499f7$var$mapTag || (0, $f13cc3efa9d19b87$export$2e2bcd8739ae039) && $71ed1aa3078499f7$var$getTag((0, $f13cc3efa9d19b87$export$2e2bcd8739ae039).resolve()) != $71ed1aa3078499f7$var$promiseTag || (0, $04c3c31661f8e58d$export$2e2bcd8739ae039) && $71ed1aa3078499f7$var$getTag(new (0, $04c3c31661f8e58d$export$2e2bcd8739ae039)) != $71ed1aa3078499f7$var$setTag || (0, $f29460f69ed6365d$export$2e2bcd8739ae039) && $71ed1aa3078499f7$var$getTag(new (0, $f29460f69ed6365d$export$2e2bcd8739ae039)) != $71ed1aa3078499f7$var$weakMapTag) $71ed1aa3078499f7$var$getTag = function(value) {
    var result = (0, $4858f35ffd09f1fe$export$2e2bcd8739ae039)(value), Ctor = result == $71ed1aa3078499f7$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $3461967a505fe51b$export$2e2bcd8739ae039)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $71ed1aa3078499f7$var$dataViewCtorString:
            return $71ed1aa3078499f7$var$dataViewTag;
        case $71ed1aa3078499f7$var$mapCtorString:
            return $71ed1aa3078499f7$var$mapTag;
        case $71ed1aa3078499f7$var$promiseCtorString:
            return $71ed1aa3078499f7$var$promiseTag;
        case $71ed1aa3078499f7$var$setCtorString:
            return $71ed1aa3078499f7$var$setTag;
        case $71ed1aa3078499f7$var$weakMapCtorString:
            return $71ed1aa3078499f7$var$weakMapTag;
    }
    return result;
};
var $71ed1aa3078499f7$export$2e2bcd8739ae039 = $71ed1aa3078499f7$var$getTag;


/** Used for built-in method references. */ var $9fad495db7a3c8fd$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9fad495db7a3c8fd$var$hasOwnProperty = $9fad495db7a3c8fd$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $9fad495db7a3c8fd$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $9fad495db7a3c8fd$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $9fad495db7a3c8fd$export$2e2bcd8739ae039 = $9fad495db7a3c8fd$var$initCloneArray;




/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $2e9a26196738582e$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $b73f5b7b6417a77a$export$2e2bcd8739ae039)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $2e9a26196738582e$export$2e2bcd8739ae039 = $2e9a26196738582e$var$cloneDataView;


/** Used to match `RegExp` flags from their coerced string values. */ var $91ba54a5bbdcf0bc$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $91ba54a5bbdcf0bc$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $91ba54a5bbdcf0bc$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $91ba54a5bbdcf0bc$export$2e2bcd8739ae039 = $91ba54a5bbdcf0bc$var$cloneRegExp;



/** Used to convert symbols to primitives and strings. */ var $e04a40531cf5af4d$var$symbolProto = (0, $2dd6d42499abd1d4$export$2e2bcd8739ae039) ? (0, $2dd6d42499abd1d4$export$2e2bcd8739ae039).prototype : undefined, $e04a40531cf5af4d$var$symbolValueOf = $e04a40531cf5af4d$var$symbolProto ? $e04a40531cf5af4d$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $e04a40531cf5af4d$var$cloneSymbol(symbol) {
    return $e04a40531cf5af4d$var$symbolValueOf ? Object($e04a40531cf5af4d$var$symbolValueOf.call(symbol)) : {};
}
var $e04a40531cf5af4d$export$2e2bcd8739ae039 = $e04a40531cf5af4d$var$cloneSymbol;



/** `Object#toString` result references. */ var $2c4c746fd9599ce5$var$boolTag = '[object Boolean]', $2c4c746fd9599ce5$var$dateTag = '[object Date]', $2c4c746fd9599ce5$var$mapTag = '[object Map]', $2c4c746fd9599ce5$var$numberTag = '[object Number]', $2c4c746fd9599ce5$var$regexpTag = '[object RegExp]', $2c4c746fd9599ce5$var$setTag = '[object Set]', $2c4c746fd9599ce5$var$stringTag = '[object String]', $2c4c746fd9599ce5$var$symbolTag = '[object Symbol]';
var $2c4c746fd9599ce5$var$arrayBufferTag = '[object ArrayBuffer]', $2c4c746fd9599ce5$var$dataViewTag = '[object DataView]', $2c4c746fd9599ce5$var$float32Tag = '[object Float32Array]', $2c4c746fd9599ce5$var$float64Tag = '[object Float64Array]', $2c4c746fd9599ce5$var$int8Tag = '[object Int8Array]', $2c4c746fd9599ce5$var$int16Tag = '[object Int16Array]', $2c4c746fd9599ce5$var$int32Tag = '[object Int32Array]', $2c4c746fd9599ce5$var$uint8Tag = '[object Uint8Array]', $2c4c746fd9599ce5$var$uint8ClampedTag = '[object Uint8ClampedArray]', $2c4c746fd9599ce5$var$uint16Tag = '[object Uint16Array]', $2c4c746fd9599ce5$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $2c4c746fd9599ce5$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $2c4c746fd9599ce5$var$arrayBufferTag:
            return (0, $b73f5b7b6417a77a$export$2e2bcd8739ae039)(object);
        case $2c4c746fd9599ce5$var$boolTag:
        case $2c4c746fd9599ce5$var$dateTag:
            return new Ctor(+object);
        case $2c4c746fd9599ce5$var$dataViewTag:
            return (0, $2e9a26196738582e$export$2e2bcd8739ae039)(object, isDeep);
        case $2c4c746fd9599ce5$var$float32Tag:
        case $2c4c746fd9599ce5$var$float64Tag:
        case $2c4c746fd9599ce5$var$int8Tag:
        case $2c4c746fd9599ce5$var$int16Tag:
        case $2c4c746fd9599ce5$var$int32Tag:
        case $2c4c746fd9599ce5$var$uint8Tag:
        case $2c4c746fd9599ce5$var$uint8ClampedTag:
        case $2c4c746fd9599ce5$var$uint16Tag:
        case $2c4c746fd9599ce5$var$uint32Tag:
            return (0, $87add7998cc7c873$export$2e2bcd8739ae039)(object, isDeep);
        case $2c4c746fd9599ce5$var$mapTag:
            return new Ctor;
        case $2c4c746fd9599ce5$var$numberTag:
        case $2c4c746fd9599ce5$var$stringTag:
            return new Ctor(object);
        case $2c4c746fd9599ce5$var$regexpTag:
            return (0, $91ba54a5bbdcf0bc$export$2e2bcd8739ae039)(object);
        case $2c4c746fd9599ce5$var$setTag:
            return new Ctor;
        case $2c4c746fd9599ce5$var$symbolTag:
            return (0, $e04a40531cf5af4d$export$2e2bcd8739ae039)(object);
    }
}
var $2c4c746fd9599ce5$export$2e2bcd8739ae039 = $2c4c746fd9599ce5$var$initCloneByTag;





var $1hAGW = parcelRequire("1hAGW");


/** `Object#toString` result references. */ var $64ad107e222f9dd3$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $64ad107e222f9dd3$var$baseIsMap(value) {
    return (0, $748eab434a4ddaf0$export$2e2bcd8739ae039)(value) && (0, $71ed1aa3078499f7$export$2e2bcd8739ae039)(value) == $64ad107e222f9dd3$var$mapTag;
}
var $64ad107e222f9dd3$export$2e2bcd8739ae039 = $64ad107e222f9dd3$var$baseIsMap;




var $8fNPf = parcelRequire("8fNPf");
/* Node.js helper references. */ var $f3fed6ad1e0fa7f5$var$nodeIsMap = (0, $8fNPf.default) && (0, $8fNPf.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $f3fed6ad1e0fa7f5$var$isMap = $f3fed6ad1e0fa7f5$var$nodeIsMap ? (0, $9a3912be2c31c49c$export$2e2bcd8739ae039)($f3fed6ad1e0fa7f5$var$nodeIsMap) : (0, $64ad107e222f9dd3$export$2e2bcd8739ae039);
var $f3fed6ad1e0fa7f5$export$2e2bcd8739ae039 = $f3fed6ad1e0fa7f5$var$isMap;





/** `Object#toString` result references. */ var $d8a07bb306e5cc52$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $d8a07bb306e5cc52$var$baseIsSet(value) {
    return (0, $748eab434a4ddaf0$export$2e2bcd8739ae039)(value) && (0, $71ed1aa3078499f7$export$2e2bcd8739ae039)(value) == $d8a07bb306e5cc52$var$setTag;
}
var $d8a07bb306e5cc52$export$2e2bcd8739ae039 = $d8a07bb306e5cc52$var$baseIsSet;




var $8fNPf = parcelRequire("8fNPf");
/* Node.js helper references. */ var $f75e1335831b6cef$var$nodeIsSet = (0, $8fNPf.default) && (0, $8fNPf.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $f75e1335831b6cef$var$isSet = $f75e1335831b6cef$var$nodeIsSet ? (0, $9a3912be2c31c49c$export$2e2bcd8739ae039)($f75e1335831b6cef$var$nodeIsSet) : (0, $d8a07bb306e5cc52$export$2e2bcd8739ae039);
var $f75e1335831b6cef$export$2e2bcd8739ae039 = $f75e1335831b6cef$var$isSet;




/** Used to compose bitmasks for cloning. */ var $1fd8658881ea93e9$var$CLONE_DEEP_FLAG = 1, $1fd8658881ea93e9$var$CLONE_FLAT_FLAG = 2, $1fd8658881ea93e9$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $1fd8658881ea93e9$var$argsTag = '[object Arguments]', $1fd8658881ea93e9$var$arrayTag = '[object Array]', $1fd8658881ea93e9$var$boolTag = '[object Boolean]', $1fd8658881ea93e9$var$dateTag = '[object Date]', $1fd8658881ea93e9$var$errorTag = '[object Error]', $1fd8658881ea93e9$var$funcTag = '[object Function]', $1fd8658881ea93e9$var$genTag = '[object GeneratorFunction]', $1fd8658881ea93e9$var$mapTag = '[object Map]', $1fd8658881ea93e9$var$numberTag = '[object Number]', $1fd8658881ea93e9$var$objectTag = '[object Object]', $1fd8658881ea93e9$var$regexpTag = '[object RegExp]', $1fd8658881ea93e9$var$setTag = '[object Set]', $1fd8658881ea93e9$var$stringTag = '[object String]', $1fd8658881ea93e9$var$symbolTag = '[object Symbol]', $1fd8658881ea93e9$var$weakMapTag = '[object WeakMap]';
var $1fd8658881ea93e9$var$arrayBufferTag = '[object ArrayBuffer]', $1fd8658881ea93e9$var$dataViewTag = '[object DataView]', $1fd8658881ea93e9$var$float32Tag = '[object Float32Array]', $1fd8658881ea93e9$var$float64Tag = '[object Float64Array]', $1fd8658881ea93e9$var$int8Tag = '[object Int8Array]', $1fd8658881ea93e9$var$int16Tag = '[object Int16Array]', $1fd8658881ea93e9$var$int32Tag = '[object Int32Array]', $1fd8658881ea93e9$var$uint8Tag = '[object Uint8Array]', $1fd8658881ea93e9$var$uint8ClampedTag = '[object Uint8ClampedArray]', $1fd8658881ea93e9$var$uint16Tag = '[object Uint16Array]', $1fd8658881ea93e9$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $1fd8658881ea93e9$var$cloneableTags = {};
$1fd8658881ea93e9$var$cloneableTags[$1fd8658881ea93e9$var$argsTag] = $1fd8658881ea93e9$var$cloneableTags[$1fd8658881ea93e9$var$arrayTag] = $1fd8658881ea93e9$var$cloneableTags[$1fd8658881ea93e9$var$arrayBufferTag] = $1fd8658881ea93e9$var$cloneableTags[$1fd8658881ea93e9$var$dataViewTag] = $1fd8658881ea93e9$var$cloneableTags[$1fd8658881ea93e9$var$boolTag] = $1fd8658881ea93e9$var$cloneableTags[$1fd8658881ea93e9$var$dateTag] = $1fd8658881ea93e9$var$cloneableTags[$1fd8658881ea93e9$var$float32Tag] = $1fd8658881ea93e9$var$cloneableTags[$1fd8658881ea93e9$var$float64Tag] = $1fd8658881ea93e9$var$cloneableTags[$1fd8658881ea93e9$var$int8Tag] = $1fd8658881ea93e9$var$cloneableTags[$1fd8658881ea93e9$var$int16Tag] = $1fd8658881ea93e9$var$cloneableTags[$1fd8658881ea93e9$var$int32Tag] = $1fd8658881ea93e9$var$cloneableTags[$1fd8658881ea93e9$var$mapTag] = $1fd8658881ea93e9$var$cloneableTags[$1fd8658881ea93e9$var$numberTag] = $1fd8658881ea93e9$var$cloneableTags[$1fd8658881ea93e9$var$objectTag] = $1fd8658881ea93e9$var$cloneableTags[$1fd8658881ea93e9$var$regexpTag] = $1fd8658881ea93e9$var$cloneableTags[$1fd8658881ea93e9$var$setTag] = $1fd8658881ea93e9$var$cloneableTags[$1fd8658881ea93e9$var$stringTag] = $1fd8658881ea93e9$var$cloneableTags[$1fd8658881ea93e9$var$symbolTag] = $1fd8658881ea93e9$var$cloneableTags[$1fd8658881ea93e9$var$uint8Tag] = $1fd8658881ea93e9$var$cloneableTags[$1fd8658881ea93e9$var$uint8ClampedTag] = $1fd8658881ea93e9$var$cloneableTags[$1fd8658881ea93e9$var$uint16Tag] = $1fd8658881ea93e9$var$cloneableTags[$1fd8658881ea93e9$var$uint32Tag] = true;
$1fd8658881ea93e9$var$cloneableTags[$1fd8658881ea93e9$var$errorTag] = $1fd8658881ea93e9$var$cloneableTags[$1fd8658881ea93e9$var$funcTag] = $1fd8658881ea93e9$var$cloneableTags[$1fd8658881ea93e9$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $1fd8658881ea93e9$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $1fd8658881ea93e9$var$CLONE_DEEP_FLAG, isFlat = bitmask & $1fd8658881ea93e9$var$CLONE_FLAT_FLAG, isFull = bitmask & $1fd8658881ea93e9$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $b0c4b4ed3a4e0b7c$export$2e2bcd8739ae039)(value)) return value;
    var isArr = (0, $50159e231742c958$export$2e2bcd8739ae039)(value);
    if (isArr) {
        result = (0, $9fad495db7a3c8fd$export$2e2bcd8739ae039)(value);
        if (!isDeep) return (0, $ad1498f2a739ffba$export$2e2bcd8739ae039)(value, result);
    } else {
        var tag = (0, $71ed1aa3078499f7$export$2e2bcd8739ae039)(value), isFunc = tag == $1fd8658881ea93e9$var$funcTag || tag == $1fd8658881ea93e9$var$genTag;
        if ((0, $1hAGW.default)(value)) return (0, $c84AI.default)(value, isDeep);
        if (tag == $1fd8658881ea93e9$var$objectTag || tag == $1fd8658881ea93e9$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $9bde282ebc195a2f$export$2e2bcd8739ae039)(value);
            if (!isDeep) return isFlat ? (0, $5d0725b2278bdafa$export$2e2bcd8739ae039)(value, (0, $edd0b8b77c2af29b$export$2e2bcd8739ae039)(result, value)) : (0, $a0fd2be509c764f0$export$2e2bcd8739ae039)(value, (0, $d34f089a0c641c49$export$2e2bcd8739ae039)(result, value));
        } else {
            if (!$1fd8658881ea93e9$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $2c4c746fd9599ce5$export$2e2bcd8739ae039)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $645f86afd3e24a54$export$2e2bcd8739ae039));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $f75e1335831b6cef$export$2e2bcd8739ae039)(value)) value.forEach(function(subValue) {
        result.add($1fd8658881ea93e9$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $f3fed6ad1e0fa7f5$export$2e2bcd8739ae039)(value)) value.forEach(function(subValue, key) {
        result.set(key, $1fd8658881ea93e9$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $2f9ed1098b336cc7$export$2e2bcd8739ae039) : (0, $843d9ecec42ce0fc$export$2e2bcd8739ae039) : isFlat ? (0, $dad844e55cc75ed8$export$2e2bcd8739ae039) : (0, $19a27738ba71729f$export$2e2bcd8739ae039);
    var props = isArr ? undefined : keysFunc(value);
    (0, $fe340ff4c27eabd3$export$2e2bcd8739ae039)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $ef64f423664a300a$export$2e2bcd8739ae039)(result, key, $1fd8658881ea93e9$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $1fd8658881ea93e9$export$2e2bcd8739ae039 = $1fd8658881ea93e9$var$baseClone;


/** Used to compose bitmasks for cloning. */ var $97b34790ff67df55$var$CLONE_DEEP_FLAG = 1, $97b34790ff67df55$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $97b34790ff67df55$var$cloneDeep(value) {
    return (0, $1fd8658881ea93e9$export$2e2bcd8739ae039)(value, $97b34790ff67df55$var$CLONE_DEEP_FLAG | $97b34790ff67df55$var$CLONE_SYMBOLS_FLAG);
}
var $97b34790ff67df55$export$2e2bcd8739ae039 = $97b34790ff67df55$var$cloneDeep;



/** Used to stand-in for `undefined` hash values. */ var $18a1056568915b2c$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $18a1056568915b2c$var$setCacheAdd(value) {
    this.__data__.set(value, $18a1056568915b2c$var$HASH_UNDEFINED);
    return this;
}
var $18a1056568915b2c$export$2e2bcd8739ae039 = $18a1056568915b2c$var$setCacheAdd;


/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $0c425d617b1ac5ee$var$setCacheHas(value) {
    return this.__data__.has(value);
}
var $0c425d617b1ac5ee$export$2e2bcd8739ae039 = $0c425d617b1ac5ee$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $89988e28e9a231dd$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, $ff380ada07d2b751$export$2e2bcd8739ae039);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$89988e28e9a231dd$var$SetCache.prototype.add = $89988e28e9a231dd$var$SetCache.prototype.push = (0, $18a1056568915b2c$export$2e2bcd8739ae039);
$89988e28e9a231dd$var$SetCache.prototype.has = (0, $0c425d617b1ac5ee$export$2e2bcd8739ae039);
var $89988e28e9a231dd$export$2e2bcd8739ae039 = $89988e28e9a231dd$var$SetCache;


/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $0fdf27c2b3db516d$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
var $0fdf27c2b3db516d$export$2e2bcd8739ae039 = $0fdf27c2b3db516d$var$arraySome;


/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $8ca5c0bdc241b322$var$cacheHas(cache, key) {
    return cache.has(key);
}
var $8ca5c0bdc241b322$export$2e2bcd8739ae039 = $8ca5c0bdc241b322$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $4cd4e4872b7181d1$var$COMPARE_PARTIAL_FLAG = 1, $4cd4e4872b7181d1$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $4cd4e4872b7181d1$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $4cd4e4872b7181d1$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $4cd4e4872b7181d1$var$COMPARE_UNORDERED_FLAG ? new (0, $89988e28e9a231dd$export$2e2bcd8739ae039) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, $0fdf27c2b3db516d$export$2e2bcd8739ae039)(other, function(othValue, othIndex) {
                if (!(0, $8ca5c0bdc241b322$export$2e2bcd8739ae039)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
var $4cd4e4872b7181d1$export$2e2bcd8739ae039 = $4cd4e4872b7181d1$var$equalArrays;






/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $6a6e05ef0938479e$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
var $6a6e05ef0938479e$export$2e2bcd8739ae039 = $6a6e05ef0938479e$var$mapToArray;


/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $a0e6db00c398fa34$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
var $a0e6db00c398fa34$export$2e2bcd8739ae039 = $a0e6db00c398fa34$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $feb5e42634bf2469$var$COMPARE_PARTIAL_FLAG = 1, $feb5e42634bf2469$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $feb5e42634bf2469$var$boolTag = '[object Boolean]', $feb5e42634bf2469$var$dateTag = '[object Date]', $feb5e42634bf2469$var$errorTag = '[object Error]', $feb5e42634bf2469$var$mapTag = '[object Map]', $feb5e42634bf2469$var$numberTag = '[object Number]', $feb5e42634bf2469$var$regexpTag = '[object RegExp]', $feb5e42634bf2469$var$setTag = '[object Set]', $feb5e42634bf2469$var$stringTag = '[object String]', $feb5e42634bf2469$var$symbolTag = '[object Symbol]';
var $feb5e42634bf2469$var$arrayBufferTag = '[object ArrayBuffer]', $feb5e42634bf2469$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $feb5e42634bf2469$var$symbolProto = (0, $2dd6d42499abd1d4$export$2e2bcd8739ae039) ? (0, $2dd6d42499abd1d4$export$2e2bcd8739ae039).prototype : undefined, $feb5e42634bf2469$var$symbolValueOf = $feb5e42634bf2469$var$symbolProto ? $feb5e42634bf2469$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $feb5e42634bf2469$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $feb5e42634bf2469$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $feb5e42634bf2469$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, $3a305add339d255c$export$2e2bcd8739ae039)(object), new (0, $3a305add339d255c$export$2e2bcd8739ae039)(other))) return false;
            return true;
        case $feb5e42634bf2469$var$boolTag:
        case $feb5e42634bf2469$var$dateTag:
        case $feb5e42634bf2469$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, $b4e6bc06a7dbe23b$export$2e2bcd8739ae039)(+object, +other);
        case $feb5e42634bf2469$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $feb5e42634bf2469$var$regexpTag:
        case $feb5e42634bf2469$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $feb5e42634bf2469$var$mapTag:
            var convert = (0, $6a6e05ef0938479e$export$2e2bcd8739ae039);
        case $feb5e42634bf2469$var$setTag:
            var isPartial = bitmask & $feb5e42634bf2469$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, $a0e6db00c398fa34$export$2e2bcd8739ae039));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $feb5e42634bf2469$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, $4cd4e4872b7181d1$export$2e2bcd8739ae039)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $feb5e42634bf2469$var$symbolTag:
            if ($feb5e42634bf2469$var$symbolValueOf) return $feb5e42634bf2469$var$symbolValueOf.call(object) == $feb5e42634bf2469$var$symbolValueOf.call(other);
    }
    return false;
}
var $feb5e42634bf2469$export$2e2bcd8739ae039 = $feb5e42634bf2469$var$equalByTag;



/** Used to compose bitmasks for value comparisons. */ var $9913f394b2aaaf20$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $9913f394b2aaaf20$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9913f394b2aaaf20$var$hasOwnProperty = $9913f394b2aaaf20$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $9913f394b2aaaf20$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $9913f394b2aaaf20$var$COMPARE_PARTIAL_FLAG, objProps = (0, $843d9ecec42ce0fc$export$2e2bcd8739ae039)(object), objLength = objProps.length, othProps = (0, $843d9ecec42ce0fc$export$2e2bcd8739ae039)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $9913f394b2aaaf20$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
var $9913f394b2aaaf20$export$2e2bcd8739ae039 = $9913f394b2aaaf20$var$equalObjects;





var $1hAGW = parcelRequire("1hAGW");

/** Used to compose bitmasks for value comparisons. */ var $f495f2c0338e8cf5$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $f495f2c0338e8cf5$var$argsTag = '[object Arguments]', $f495f2c0338e8cf5$var$arrayTag = '[object Array]', $f495f2c0338e8cf5$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $f495f2c0338e8cf5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f495f2c0338e8cf5$var$hasOwnProperty = $f495f2c0338e8cf5$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $f495f2c0338e8cf5$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, $50159e231742c958$export$2e2bcd8739ae039)(object), othIsArr = (0, $50159e231742c958$export$2e2bcd8739ae039)(other), objTag = objIsArr ? $f495f2c0338e8cf5$var$arrayTag : (0, $71ed1aa3078499f7$export$2e2bcd8739ae039)(object), othTag = othIsArr ? $f495f2c0338e8cf5$var$arrayTag : (0, $71ed1aa3078499f7$export$2e2bcd8739ae039)(other);
    objTag = objTag == $f495f2c0338e8cf5$var$argsTag ? $f495f2c0338e8cf5$var$objectTag : objTag;
    othTag = othTag == $f495f2c0338e8cf5$var$argsTag ? $f495f2c0338e8cf5$var$objectTag : othTag;
    var objIsObj = objTag == $f495f2c0338e8cf5$var$objectTag, othIsObj = othTag == $f495f2c0338e8cf5$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, $1hAGW.default)(object)) {
        if (!(0, $1hAGW.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, $645f86afd3e24a54$export$2e2bcd8739ae039));
        return objIsArr || (0, $7632c8b302ab9506$export$2e2bcd8739ae039)(object) ? (0, $4cd4e4872b7181d1$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack) : (0, $feb5e42634bf2469$export$2e2bcd8739ae039)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $f495f2c0338e8cf5$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $f495f2c0338e8cf5$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $f495f2c0338e8cf5$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, $645f86afd3e24a54$export$2e2bcd8739ae039));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, $645f86afd3e24a54$export$2e2bcd8739ae039));
    return (0, $9913f394b2aaaf20$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack);
}
var $f495f2c0338e8cf5$export$2e2bcd8739ae039 = $f495f2c0338e8cf5$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $2000abd627edac0a$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, $748eab434a4ddaf0$export$2e2bcd8739ae039)(value) && !(0, $748eab434a4ddaf0$export$2e2bcd8739ae039)(other)) return value !== value && other !== other;
    return (0, $f495f2c0338e8cf5$export$2e2bcd8739ae039)(value, other, bitmask, customizer, $2000abd627edac0a$var$baseIsEqual, stack);
}
var $2000abd627edac0a$export$2e2bcd8739ae039 = $2000abd627edac0a$var$baseIsEqual;


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $ee28b6e7df1b1693$var$isEqual(value, other) {
    return (0, $2000abd627edac0a$export$2e2bcd8739ae039)(value, other);
}
var $ee28b6e7df1b1693$export$2e2bcd8739ae039 = $ee28b6e7df1b1693$var$isEqual;







class $e5579ce91e3096b0$var$Break extends (0, $e9fc1a5fcc0c5a1a$export$297a1fa96f55f00f) {
    static value() {
        return undefined;
    }
    optimize() {
        if (this.prev || this.next) this.remove();
    }
    length() {
        return 0;
    }
    value() {
        return '';
    }
}
$e5579ce91e3096b0$var$Break.blotName = 'break';
$e5579ce91e3096b0$var$Break.tagName = 'BR';
var $e5579ce91e3096b0$export$2e2bcd8739ae039 = $e5579ce91e3096b0$var$Break;





class $b5feff51aa4dee9f$export$2e2bcd8739ae039 extends (0, $e9fc1a5fcc0c5a1a$export$10ac0c5716409de6) {
}
// https://lodash.com/docs#escape
const $b5feff51aa4dee9f$var$entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
};
function $b5feff51aa4dee9f$export$96e6fc3a139b2555(text) {
    return text.replace(/[&<>"']/g, (s)=>$b5feff51aa4dee9f$var$entityMap[s]);
}


class $f5f023af83746731$var$Inline extends (0, $e9fc1a5fcc0c5a1a$export$f67a34bc25a7a861) {
    static allowedChildren = [
        $f5f023af83746731$var$Inline,
        (0, $e5579ce91e3096b0$export$2e2bcd8739ae039),
        (0, $e9fc1a5fcc0c5a1a$export$297a1fa96f55f00f),
        (0, $b5feff51aa4dee9f$export$2e2bcd8739ae039)
    ];
    // Lower index means deeper in the DOM tree, since not found (-1) is for embeds
    static order = [
        'cursor',
        'inline',
        // Must be lower
        'link',
        // Chrome wants <a> to be lower
        'underline',
        'strike',
        'italic',
        'bold',
        'script',
        'code' // Must be higher
    ];
    static compare(self, other) {
        const selfIndex = $f5f023af83746731$var$Inline.order.indexOf(self);
        const otherIndex = $f5f023af83746731$var$Inline.order.indexOf(other);
        if (selfIndex >= 0 || otherIndex >= 0) return selfIndex - otherIndex;
        if (self === other) return 0;
        if (self < other) return -1;
        return 1;
    }
    formatAt(index, length, name, value) {
        if ($f5f023af83746731$var$Inline.compare(this.statics.blotName, name) < 0 && this.scroll.query(name, (0, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214).BLOT)) {
            const blot = this.isolate(index, length);
            if (value) blot.wrap(name, value);
        } else super.formatAt(index, length, name, value);
    }
    optimize(context) {
        super.optimize(context);
        if (this.parent instanceof $f5f023af83746731$var$Inline && $f5f023af83746731$var$Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
            const parent = this.parent.isolate(this.offset(), this.length());
            // @ts-expect-error TODO: make isolate generic
            this.moveChildren(parent);
            parent.wrap(this);
        }
    }
}
var $f5f023af83746731$export$2e2bcd8739ae039 = $f5f023af83746731$var$Inline;



const $0d7ea5a8bdacfb09$var$NEWLINE_LENGTH = 1;
class $0d7ea5a8bdacfb09$export$2e2bcd8739ae039 extends (0, $e9fc1a5fcc0c5a1a$export$4f7f03641f7bfc8c) {
    cache = {};
    delta() {
        if (this.cache.delta == null) this.cache.delta = $0d7ea5a8bdacfb09$export$992ff47219af5a2b(this);
        return this.cache.delta;
    }
    deleteAt(index, length) {
        super.deleteAt(index, length);
        this.cache = {};
    }
    formatAt(index, length, name, value) {
        if (length <= 0) return;
        if (this.scroll.query(name, (0, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214).BLOCK)) {
            if (index + length === this.length()) this.format(name, value);
        } else super.formatAt(index, Math.min(length, this.length() - index - 1), name, value);
        this.cache = {};
    }
    insertAt(index, value, def) {
        if (def != null) {
            super.insertAt(index, value, def);
            this.cache = {};
            return;
        }
        if (value.length === 0) return;
        const lines = value.split('\n');
        const text = lines.shift();
        if (text.length > 0) {
            if (index < this.length() - 1 || this.children.tail == null) super.insertAt(Math.min(index, this.length() - 1), text);
            else this.children.tail.insertAt(this.children.tail.length(), text);
            this.cache = {};
        }
        // TODO: Fix this next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let block = this;
        lines.reduce((lineIndex, line)=>{
            // @ts-expect-error Fix me later
            block = block.split(lineIndex, true);
            block.insertAt(0, line);
            return line.length;
        }, index + text.length);
    }
    insertBefore(blot, ref) {
        const { head: head } = this.children;
        super.insertBefore(blot, ref);
        if (head instanceof (0, $e5579ce91e3096b0$export$2e2bcd8739ae039)) head.remove();
        this.cache = {};
    }
    length() {
        if (this.cache.length == null) this.cache.length = super.length() + $0d7ea5a8bdacfb09$var$NEWLINE_LENGTH;
        return this.cache.length;
    }
    moveChildren(target, ref) {
        super.moveChildren(target, ref);
        this.cache = {};
    }
    optimize(context) {
        super.optimize(context);
        this.cache = {};
    }
    path(index) {
        return super.path(index, true);
    }
    removeChild(child) {
        super.removeChild(child);
        this.cache = {};
    }
    split(index) {
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (force && (index === 0 || index >= this.length() - $0d7ea5a8bdacfb09$var$NEWLINE_LENGTH)) {
            const clone = this.clone();
            if (index === 0) {
                this.parent.insertBefore(clone, this);
                return this;
            }
            this.parent.insertBefore(clone, this.next);
            return clone;
        }
        const next = super.split(index, force);
        this.cache = {};
        return next;
    }
}
$0d7ea5a8bdacfb09$export$2e2bcd8739ae039.blotName = 'block';
$0d7ea5a8bdacfb09$export$2e2bcd8739ae039.tagName = 'P';
$0d7ea5a8bdacfb09$export$2e2bcd8739ae039.defaultChild = (0, $e5579ce91e3096b0$export$2e2bcd8739ae039);
$0d7ea5a8bdacfb09$export$2e2bcd8739ae039.allowedChildren = [
    (0, $e5579ce91e3096b0$export$2e2bcd8739ae039),
    (0, $f5f023af83746731$export$2e2bcd8739ae039),
    (0, $e9fc1a5fcc0c5a1a$export$297a1fa96f55f00f),
    (0, $b5feff51aa4dee9f$export$2e2bcd8739ae039)
];
class $0d7ea5a8bdacfb09$export$48b9f0688962d028 extends (0, $e9fc1a5fcc0c5a1a$export$297a1fa96f55f00f) {
    attach() {
        super.attach();
        this.attributes = new (0, $e9fc1a5fcc0c5a1a$export$68ad86ab95e8de42)(this.domNode);
    }
    delta() {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().insert(this.value(), {
            ...this.formats(),
            ...this.attributes.values()
        });
    }
    format(name, value) {
        const attribute = this.scroll.query(name, (0, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214).BLOCK_ATTRIBUTE);
        if (attribute != null) // @ts-expect-error TODO: Scroll#query() should return Attributor when scope is attribute
        this.attributes.attribute(attribute, value);
    }
    formatAt(index, length, name, value) {
        this.format(name, value);
    }
    insertAt(index, value, def) {
        if (def != null) {
            super.insertAt(index, value, def);
            return;
        }
        const lines = value.split('\n');
        const text = lines.pop();
        const blocks = lines.map((line)=>{
            const block = this.scroll.create($0d7ea5a8bdacfb09$export$2e2bcd8739ae039.blotName);
            block.insertAt(0, line);
            return block;
        });
        const ref = this.split(index);
        blocks.forEach((block)=>{
            this.parent.insertBefore(block, ref);
        });
        if (text) this.parent.insertBefore(this.scroll.create('text', text), ref);
    }
}
$0d7ea5a8bdacfb09$export$48b9f0688962d028.scope = (0, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214).BLOCK_BLOT;
// It is important for cursor behavior BlockEmbeds use tags that are block level elements
function $0d7ea5a8bdacfb09$export$992ff47219af5a2b(blot) {
    let filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return blot.descendants((0, $e9fc1a5fcc0c5a1a$export$7420b9c542181544)).reduce((delta, leaf)=>{
        if (leaf.length() === 0) return delta;
        return delta.insert(leaf.value(), $0d7ea5a8bdacfb09$export$e4bb5a6163449612(leaf, {}, filter));
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))()).insert('\n', $0d7ea5a8bdacfb09$export$e4bb5a6163449612(blot));
}
function $0d7ea5a8bdacfb09$export$e4bb5a6163449612(blot) {
    let formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (blot == null) return formats;
    if ('formats' in blot && typeof blot.formats === 'function') {
        formats = {
            ...formats,
            ...blot.formats()
        };
        if (filter) // exclude syntax highlighting from deltas and getFormat()
        delete formats['code-token'];
    }
    if (blot.parent == null || blot.parent.statics.blotName === 'scroll' || blot.parent.statics.scope !== blot.statics.scope) return formats;
    return $0d7ea5a8bdacfb09$export$e4bb5a6163449612(blot.parent, formats, filter);
}





class $fa8ee3ba40bbf9de$var$Cursor extends (0, $e9fc1a5fcc0c5a1a$export$297a1fa96f55f00f) {
    static blotName = 'cursor';
    static className = 'ql-cursor';
    static tagName = 'span';
    static CONTENTS = '\uFEFF';
    static value() {
        return undefined;
    }
    constructor(scroll, domNode, selection){
        super(scroll, domNode);
        this.selection = selection;
        this.textNode = document.createTextNode($fa8ee3ba40bbf9de$var$Cursor.CONTENTS);
        this.domNode.appendChild(this.textNode);
        this.savedLength = 0;
    }
    detach() {
        // super.detach() will also clear domNode.__blot
        if (this.parent != null) this.parent.removeChild(this);
    }
    format(name, value) {
        if (this.savedLength !== 0) {
            super.format(name, value);
            return;
        }
        // TODO: Fix this next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let target = this;
        let index = 0;
        while(target != null && target.statics.scope !== (0, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214).BLOCK_BLOT){
            index += target.offset(target.parent);
            target = target.parent;
        }
        if (target != null) {
            this.savedLength = $fa8ee3ba40bbf9de$var$Cursor.CONTENTS.length;
            // @ts-expect-error TODO: allow empty context in Parchment
            target.optimize();
            target.formatAt(index, $fa8ee3ba40bbf9de$var$Cursor.CONTENTS.length, name, value);
            this.savedLength = 0;
        }
    }
    index(node, offset) {
        if (node === this.textNode) return 0;
        return super.index(node, offset);
    }
    length() {
        return this.savedLength;
    }
    position() {
        return [
            this.textNode,
            this.textNode.data.length
        ];
    }
    remove() {
        super.remove();
        // @ts-expect-error Fix me later
        this.parent = null;
    }
    restore() {
        if (this.selection.composing || this.parent == null) return null;
        const range = this.selection.getNativeRange();
        // Browser may push down styles/nodes inside the cursor blot.
        // https://dvcs.w3.org/hg/editing/raw-file/tip/editing.html#push-down-values
        while(this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode)// @ts-expect-error Fix me later
        this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
        const prevTextBlot = this.prev instanceof (0, $b5feff51aa4dee9f$export$2e2bcd8739ae039) ? this.prev : null;
        const prevTextLength = prevTextBlot ? prevTextBlot.length() : 0;
        const nextTextBlot = this.next instanceof (0, $b5feff51aa4dee9f$export$2e2bcd8739ae039) ? this.next : null;
        // @ts-expect-error TODO: make TextBlot.text public
        const nextText = nextTextBlot ? nextTextBlot.text : '';
        const { textNode: textNode } = this;
        // take text from inside this blot and reset it
        const newText = textNode.data.split($fa8ee3ba40bbf9de$var$Cursor.CONTENTS).join('');
        textNode.data = $fa8ee3ba40bbf9de$var$Cursor.CONTENTS;
        // proactively merge TextBlots around cursor so that optimization
        // doesn't lose the cursor.  the reason we are here in cursor.restore
        // could be that the user clicked in prevTextBlot or nextTextBlot, or
        // the user typed something.
        let mergedTextBlot;
        if (prevTextBlot) {
            mergedTextBlot = prevTextBlot;
            if (newText || nextTextBlot) {
                prevTextBlot.insertAt(prevTextBlot.length(), newText + nextText);
                if (nextTextBlot) nextTextBlot.remove();
            }
        } else if (nextTextBlot) {
            mergedTextBlot = nextTextBlot;
            nextTextBlot.insertAt(0, newText);
        } else {
            const newTextNode = document.createTextNode(newText);
            mergedTextBlot = this.scroll.create(newTextNode);
            this.parent.insertBefore(mergedTextBlot, this);
        }
        this.remove();
        if (range) {
            // calculate selection to restore
            const remapOffset = (node, offset)=>{
                if (prevTextBlot && node === prevTextBlot.domNode) return offset;
                if (node === textNode) return prevTextLength + offset - 1;
                if (nextTextBlot && node === nextTextBlot.domNode) return prevTextLength + newText.length + offset;
                return null;
            };
            const start = remapOffset(range.start.node, range.start.offset);
            const end = remapOffset(range.end.node, range.end.offset);
            if (start !== null && end !== null) return {
                startNode: mergedTextBlot.domNode,
                startOffset: start,
                endNode: mergedTextBlot.domNode,
                endOffset: end
            };
        }
        return null;
    }
    update(mutations, context) {
        if (mutations.some((mutation)=>{
            return mutation.type === 'characterData' && mutation.target === this.textNode;
        })) {
            const range = this.restore();
            if (range) context.range = range;
        }
    }
    // Avoid .ql-cursor being a descendant of `<a/>`.
    // The reason is Safari pushes down `<a/>` on text insertion.
    // That will cause DOM nodes not sync with the model.
    //
    // For example ({I} is the caret), given the markup:
    //    <a><span class="ql-cursor">\uFEFF{I}</span></a>
    // When typing a char "x", `<a/>` will be pushed down inside the `<span>` first:
    //    <span class="ql-cursor"><a>\uFEFF{I}</a></span>
    // And then "x" will be inserted after `<a/>`:
    //    <span class="ql-cursor"><a>\uFEFF</a>d{I}</span>
    optimize(context) {
        // @ts-expect-error Fix me later
        super.optimize(context);
        let { parent: parent } = this;
        while(parent){
            if (parent.domNode.tagName === 'A') {
                this.savedLength = $fa8ee3ba40bbf9de$var$Cursor.CONTENTS.length;
                // @ts-expect-error TODO: make isolate generic
                parent.isolate(this.offset(parent), this.length()).unwrap();
                this.savedLength = 0;
                break;
            }
            parent = parent.parent;
        }
    }
    value() {
        return '';
    }
}
var $fa8ee3ba40bbf9de$export$2e2bcd8739ae039 = $fa8ee3ba40bbf9de$var$Cursor;





var $a5b2007ff789b3a4$exports = {};
'use strict';
var $a5b2007ff789b3a4$var$has = Object.prototype.hasOwnProperty, $a5b2007ff789b3a4$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $a5b2007ff789b3a4$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $a5b2007ff789b3a4$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $a5b2007ff789b3a4$var$Events().__proto__) $a5b2007ff789b3a4$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $a5b2007ff789b3a4$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $a5b2007ff789b3a4$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $a5b2007ff789b3a4$var$EE(fn, context || emitter, once), evt = $a5b2007ff789b3a4$var$prefix ? $a5b2007ff789b3a4$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $a5b2007ff789b3a4$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $a5b2007ff789b3a4$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $a5b2007ff789b3a4$var$EventEmitter() {
    this._events = new $a5b2007ff789b3a4$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $a5b2007ff789b3a4$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($a5b2007ff789b3a4$var$has.call(events, name)) names.push($a5b2007ff789b3a4$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $a5b2007ff789b3a4$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $a5b2007ff789b3a4$var$prefix ? $a5b2007ff789b3a4$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $a5b2007ff789b3a4$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $a5b2007ff789b3a4$var$prefix ? $a5b2007ff789b3a4$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $a5b2007ff789b3a4$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $a5b2007ff789b3a4$var$prefix ? $a5b2007ff789b3a4$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $a5b2007ff789b3a4$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $a5b2007ff789b3a4$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $a5b2007ff789b3a4$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $a5b2007ff789b3a4$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $a5b2007ff789b3a4$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $a5b2007ff789b3a4$var$prefix ? $a5b2007ff789b3a4$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $a5b2007ff789b3a4$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $a5b2007ff789b3a4$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $a5b2007ff789b3a4$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $a5b2007ff789b3a4$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $a5b2007ff789b3a4$var$prefix ? $a5b2007ff789b3a4$var$prefix + event : event;
        if (this._events[evt]) $a5b2007ff789b3a4$var$clearEvent(this, evt);
    } else {
        this._events = new $a5b2007ff789b3a4$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$a5b2007ff789b3a4$var$EventEmitter.prototype.off = $a5b2007ff789b3a4$var$EventEmitter.prototype.removeListener;
$a5b2007ff789b3a4$var$EventEmitter.prototype.addListener = $a5b2007ff789b3a4$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$a5b2007ff789b3a4$var$EventEmitter.prefixed = $a5b2007ff789b3a4$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$a5b2007ff789b3a4$var$EventEmitter.EventEmitter = $a5b2007ff789b3a4$var$EventEmitter;
$a5b2007ff789b3a4$exports = $a5b2007ff789b3a4$var$EventEmitter;


var $0973420badb96151$export$2e2bcd8739ae039 = new WeakMap();


const $7ec5affce32db05e$var$levels = [
    'error',
    'warn',
    'log',
    'info'
];
let $7ec5affce32db05e$var$level = 'warn';
function $7ec5affce32db05e$var$debug(method) {
    if ($7ec5affce32db05e$var$level) {
        if ($7ec5affce32db05e$var$levels.indexOf(method) <= $7ec5affce32db05e$var$levels.indexOf($7ec5affce32db05e$var$level)) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            console[method](...args); // eslint-disable-line no-console
        }
    }
}
function $7ec5affce32db05e$var$namespace(ns) {
    return $7ec5affce32db05e$var$levels.reduce((logger, method)=>{
        logger[method] = $7ec5affce32db05e$var$debug.bind(console, method, ns);
        return logger;
    }, {});
}
$7ec5affce32db05e$var$namespace.level = (newLevel)=>{
    $7ec5affce32db05e$var$level = newLevel;
};
$7ec5affce32db05e$var$debug.level = $7ec5affce32db05e$var$namespace.level;
var $7ec5affce32db05e$export$2e2bcd8739ae039 = $7ec5affce32db05e$var$namespace;


const $ba29015e3d87cf52$var$debug = (0, $7ec5affce32db05e$export$2e2bcd8739ae039)('quill:events');
const $ba29015e3d87cf52$var$EVENTS = [
    'selectionchange',
    'mousedown',
    'mouseup',
    'click'
];
$ba29015e3d87cf52$var$EVENTS.forEach((eventName)=>{
    document.addEventListener(eventName, function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        Array.from(document.querySelectorAll('.ql-container')).forEach((node)=>{
            const quill = (0, $0973420badb96151$export$2e2bcd8739ae039).get(node);
            if (quill && quill.emitter) quill.emitter.handleDOM(...args);
        });
    });
});
class $ba29015e3d87cf52$var$Emitter extends (0, $a5b2007ff789b3a4$exports.EventEmitter) {
    static events = {
        EDITOR_CHANGE: 'editor-change',
        SCROLL_BEFORE_UPDATE: 'scroll-before-update',
        SCROLL_BLOT_MOUNT: 'scroll-blot-mount',
        SCROLL_BLOT_UNMOUNT: 'scroll-blot-unmount',
        SCROLL_OPTIMIZE: 'scroll-optimize',
        SCROLL_UPDATE: 'scroll-update',
        SCROLL_EMBED_UPDATE: 'scroll-embed-update',
        SELECTION_CHANGE: 'selection-change',
        TEXT_CHANGE: 'text-change',
        COMPOSITION_BEFORE_START: 'composition-before-start',
        COMPOSITION_START: 'composition-start',
        COMPOSITION_BEFORE_END: 'composition-before-end',
        COMPOSITION_END: 'composition-end'
    };
    static sources = {
        API: 'api',
        SILENT: 'silent',
        USER: 'user'
    };
    constructor(){
        super();
        this.domListeners = {};
        this.on('error', $ba29015e3d87cf52$var$debug.error);
    }
    emit() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        $ba29015e3d87cf52$var$debug.log.call($ba29015e3d87cf52$var$debug, ...args);
        // @ts-expect-error
        return super.emit(...args);
    }
    handleDOM(event) {
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        (this.domListeners[event.type] || []).forEach((_ref)=>{
            let { node: node, handler: handler } = _ref;
            if (event.target === node || node.contains(event.target)) handler(event, ...args);
        });
    }
    listenDOM(eventName, node, handler) {
        if (!this.domListeners[eventName]) this.domListeners[eventName] = [];
        this.domListeners[eventName].push({
            node: node,
            handler: handler
        });
    }
}
var $ba29015e3d87cf52$export$2e2bcd8739ae039 = $ba29015e3d87cf52$var$Emitter;



const $89ce7bdd8fd0c5db$var$debug = (0, $7ec5affce32db05e$export$2e2bcd8739ae039)('quill:selection');
class $89ce7bdd8fd0c5db$export$9a58ef0d7ad3278c {
    constructor(index){
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        this.index = index;
        this.length = length;
    }
}
class $89ce7bdd8fd0c5db$var$Selection {
    constructor(scroll, emitter){
        this.emitter = emitter;
        this.scroll = scroll;
        this.composing = false;
        this.mouseDown = false;
        this.root = this.scroll.domNode;
        // @ts-expect-error
        this.cursor = this.scroll.create('cursor', this);
        // savedRange is last non-null range
        this.savedRange = new $89ce7bdd8fd0c5db$export$9a58ef0d7ad3278c(0, 0);
        this.lastRange = this.savedRange;
        this.lastNative = null;
        this.handleComposition();
        this.handleDragging();
        this.emitter.listenDOM('selectionchange', document, ()=>{
            if (!this.mouseDown && !this.composing) setTimeout(this.update.bind(this, (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.USER), 1);
        });
        this.emitter.on((0, $ba29015e3d87cf52$export$2e2bcd8739ae039).events.SCROLL_BEFORE_UPDATE, ()=>{
            if (!this.hasFocus()) return;
            const native = this.getNativeRange();
            if (native == null) return;
            if (native.start.node === this.cursor.textNode) return; // cursor.restore() will handle
            this.emitter.once((0, $ba29015e3d87cf52$export$2e2bcd8739ae039).events.SCROLL_UPDATE, (source, mutations)=>{
                try {
                    if (this.root.contains(native.start.node) && this.root.contains(native.end.node)) this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
                    const triggeredByTyping = mutations.some((mutation)=>mutation.type === 'characterData' || mutation.type === 'childList' || mutation.type === 'attributes' && mutation.target === this.root);
                    this.update(triggeredByTyping ? (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.SILENT : source);
                } catch (ignored) {
                // ignore
                }
            });
        });
        this.emitter.on((0, $ba29015e3d87cf52$export$2e2bcd8739ae039).events.SCROLL_OPTIMIZE, (mutations, context)=>{
            if (context.range) {
                const { startNode: startNode, startOffset: startOffset, endNode: endNode, endOffset: endOffset } = context.range;
                this.setNativeRange(startNode, startOffset, endNode, endOffset);
                this.update((0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.SILENT);
            }
        });
        this.update((0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.SILENT);
    }
    handleComposition() {
        this.emitter.on((0, $ba29015e3d87cf52$export$2e2bcd8739ae039).events.COMPOSITION_BEFORE_START, ()=>{
            this.composing = true;
        });
        this.emitter.on((0, $ba29015e3d87cf52$export$2e2bcd8739ae039).events.COMPOSITION_END, ()=>{
            this.composing = false;
            if (this.cursor.parent) {
                const range = this.cursor.restore();
                if (!range) return;
                setTimeout(()=>{
                    this.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
                }, 1);
            }
        });
    }
    handleDragging() {
        this.emitter.listenDOM('mousedown', document.body, ()=>{
            this.mouseDown = true;
        });
        this.emitter.listenDOM('mouseup', document.body, ()=>{
            this.mouseDown = false;
            this.update((0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.USER);
        });
    }
    focus() {
        if (this.hasFocus()) return;
        this.root.focus({
            preventScroll: true
        });
        this.setRange(this.savedRange);
    }
    format(format, value) {
        this.scroll.update();
        const nativeRange = this.getNativeRange();
        if (nativeRange == null || !nativeRange.native.collapsed || this.scroll.query(format, (0, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214).BLOCK)) return;
        if (nativeRange.start.node !== this.cursor.textNode) {
            const blot = this.scroll.find(nativeRange.start.node, false);
            if (blot == null) return;
            // TODO Give blot ability to not split
            if (blot instanceof (0, $e9fc1a5fcc0c5a1a$export$7420b9c542181544)) {
                const after = blot.split(nativeRange.start.offset);
                blot.parent.insertBefore(this.cursor, after);
            } else // @ts-expect-error TODO: nativeRange.start.node doesn't seem to match function signature
            blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
            this.cursor.attach();
        }
        this.cursor.format(format, value);
        this.scroll.optimize();
        this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
        this.update();
    }
    getBounds(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        const scrollLength = this.scroll.length();
        index = Math.min(index, scrollLength - 1);
        length = Math.min(index + length, scrollLength - 1) - index;
        let node;
        let [leaf, offset] = this.scroll.leaf(index);
        if (leaf == null) return null;
        if (length > 0 && offset === leaf.length()) {
            const [next] = this.scroll.leaf(index + 1);
            if (next) {
                const [line] = this.scroll.line(index);
                const [nextLine] = this.scroll.line(index + 1);
                if (line === nextLine) {
                    leaf = next;
                    offset = 0;
                }
            }
        }
        [node, offset] = leaf.position(offset, true);
        const range = document.createRange();
        if (length > 0) {
            range.setStart(node, offset);
            [leaf, offset] = this.scroll.leaf(index + length);
            if (leaf == null) return null;
            [node, offset] = leaf.position(offset, true);
            range.setEnd(node, offset);
            return range.getBoundingClientRect();
        }
        let side = 'left';
        let rect;
        if (node instanceof Text) {
            // Return null if the text node is empty because it is
            // not able to get a useful client rect:
            // https://github.com/w3c/csswg-drafts/issues/2514.
            // Empty text nodes are most likely caused by TextBlot#optimize()
            // not getting called when editor content changes.
            if (!node.data.length) return null;
            if (offset < node.data.length) {
                range.setStart(node, offset);
                range.setEnd(node, offset + 1);
            } else {
                range.setStart(node, offset - 1);
                range.setEnd(node, offset);
                side = 'right';
            }
            rect = range.getBoundingClientRect();
        } else {
            if (!(leaf.domNode instanceof Element)) return null;
            rect = leaf.domNode.getBoundingClientRect();
            if (offset > 0) side = 'right';
        }
        return {
            bottom: rect.top + rect.height,
            height: rect.height,
            left: rect[side],
            right: rect[side],
            top: rect.top,
            width: 0
        };
    }
    getNativeRange() {
        const selection = document.getSelection();
        if (selection == null || selection.rangeCount <= 0) return null;
        const nativeRange = selection.getRangeAt(0);
        if (nativeRange == null) return null;
        const range = this.normalizeNative(nativeRange);
        $89ce7bdd8fd0c5db$var$debug.info('getNativeRange', range);
        return range;
    }
    getRange() {
        const root = this.scroll.domNode;
        if ('isConnected' in root && !root.isConnected) // document.getSelection() forces layout on Blink, so we trend to
        // not calling it.
        return [
            null,
            null
        ];
        const normalized = this.getNativeRange();
        if (normalized == null) return [
            null,
            null
        ];
        const range = this.normalizedToRange(normalized);
        return [
            range,
            normalized
        ];
    }
    hasFocus() {
        return document.activeElement === this.root || document.activeElement != null && $89ce7bdd8fd0c5db$var$contains(this.root, document.activeElement);
    }
    normalizedToRange(range) {
        const positions = [
            [
                range.start.node,
                range.start.offset
            ]
        ];
        if (!range.native.collapsed) positions.push([
            range.end.node,
            range.end.offset
        ]);
        const indexes = positions.map((position)=>{
            const [node, offset] = position;
            const blot = this.scroll.find(node, true);
            // @ts-expect-error Fix me later
            const index = blot.offset(this.scroll);
            if (offset === 0) return index;
            if (blot instanceof (0, $e9fc1a5fcc0c5a1a$export$7420b9c542181544)) return index + blot.index(node, offset);
            // @ts-expect-error Fix me later
            return index + blot.length();
        });
        const end = Math.min(Math.max(...indexes), this.scroll.length() - 1);
        const start = Math.min(end, ...indexes);
        return new $89ce7bdd8fd0c5db$export$9a58ef0d7ad3278c(start, end - start);
    }
    normalizeNative(nativeRange) {
        if (!$89ce7bdd8fd0c5db$var$contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !$89ce7bdd8fd0c5db$var$contains(this.root, nativeRange.endContainer)) return null;
        const range = {
            start: {
                node: nativeRange.startContainer,
                offset: nativeRange.startOffset
            },
            end: {
                node: nativeRange.endContainer,
                offset: nativeRange.endOffset
            },
            native: nativeRange
        };
        [
            range.start,
            range.end
        ].forEach((position)=>{
            let { node: node, offset: offset } = position;
            while(!(node instanceof Text) && node.childNodes.length > 0){
                if (node.childNodes.length > offset) {
                    node = node.childNodes[offset];
                    offset = 0;
                } else if (node.childNodes.length === offset) {
                    // @ts-expect-error Fix me later
                    node = node.lastChild;
                    if (node instanceof Text) offset = node.data.length;
                    else if (node.childNodes.length > 0) // Container case
                    offset = node.childNodes.length;
                    else // Embed case
                    offset = node.childNodes.length + 1;
                } else break;
            }
            position.node = node;
            position.offset = offset;
        });
        return range;
    }
    rangeToNative(range) {
        const scrollLength = this.scroll.length();
        const getPosition = (index, inclusive)=>{
            index = Math.min(scrollLength - 1, index);
            const [leaf, leafOffset] = this.scroll.leaf(index);
            return leaf ? leaf.position(leafOffset, inclusive) : [
                null,
                -1
            ];
        };
        return [
            ...getPosition(range.index, false),
            ...getPosition(range.index + range.length, true)
        ];
    }
    setNativeRange(startNode, startOffset) {
        let endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
        let endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
        let force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
        $89ce7bdd8fd0c5db$var$debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);
        if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || // @ts-expect-error Fix me later
        endNode.parentNode == null)) return;
        const selection = document.getSelection();
        if (selection == null) return;
        if (startNode != null) {
            if (!this.hasFocus()) this.root.focus({
                preventScroll: true
            });
            const { native: native } = this.getNativeRange() || {};
            if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {
                if (startNode instanceof Element && startNode.tagName === 'BR') {
                    // @ts-expect-error Fix me later
                    startOffset = Array.from(startNode.parentNode.childNodes).indexOf(startNode);
                    startNode = startNode.parentNode;
                }
                if (endNode instanceof Element && endNode.tagName === 'BR') {
                    // @ts-expect-error Fix me later
                    endOffset = Array.from(endNode.parentNode.childNodes).indexOf(endNode);
                    endNode = endNode.parentNode;
                }
                const range = document.createRange();
                // @ts-expect-error Fix me later
                range.setStart(startNode, startOffset);
                // @ts-expect-error Fix me later
                range.setEnd(endNode, endOffset);
                selection.removeAllRanges();
                selection.addRange(range);
            }
        } else {
            selection.removeAllRanges();
            this.root.blur();
        }
    }
    setRange(range) {
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.API;
        if (typeof force === 'string') {
            source = force;
            force = false;
        }
        $89ce7bdd8fd0c5db$var$debug.info('setRange', range);
        if (range != null) {
            const args = this.rangeToNative(range);
            this.setNativeRange(...args, force);
        } else this.setNativeRange(null);
        this.update(source);
    }
    update() {
        let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.USER;
        const oldRange = this.lastRange;
        const [lastRange, nativeRange] = this.getRange();
        this.lastRange = lastRange;
        this.lastNative = nativeRange;
        if (this.lastRange != null) this.savedRange = this.lastRange;
        if (!(0, $ee28b6e7df1b1693$export$2e2bcd8739ae039)(oldRange, this.lastRange)) {
            if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
                const range = this.cursor.restore();
                if (range) this.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
            }
            const args = [
                (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).events.SELECTION_CHANGE,
                (0, $97b34790ff67df55$export$2e2bcd8739ae039)(this.lastRange),
                (0, $97b34790ff67df55$export$2e2bcd8739ae039)(oldRange),
                source
            ];
            this.emitter.emit((0, $ba29015e3d87cf52$export$2e2bcd8739ae039).events.EDITOR_CHANGE, ...args);
            if (source !== (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.SILENT) this.emitter.emit(...args);
        }
    }
}
function $89ce7bdd8fd0c5db$var$contains(parent, descendant) {
    try {
        // Firefox inserts inaccessible nodes around video elements
        descendant.parentNode; // eslint-disable-line @typescript-eslint/no-unused-expressions
    } catch (e) {
        return false;
    }
    return parent.contains(descendant);
}
var $89ce7bdd8fd0c5db$export$2e2bcd8739ae039 = $89ce7bdd8fd0c5db$var$Selection;


const $eed0b828523b347d$var$ASCII = /^[ -~]*$/;
class $eed0b828523b347d$var$Editor {
    constructor(scroll){
        this.scroll = scroll;
        this.delta = this.getDelta();
    }
    applyDelta(delta) {
        this.scroll.update();
        let scrollLength = this.scroll.length();
        this.scroll.batchStart();
        const normalizedDelta = $eed0b828523b347d$var$normalizeDelta(delta);
        const deleteDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))();
        const normalizedOps = $eed0b828523b347d$var$splitOpLines(normalizedDelta.ops.slice());
        normalizedOps.reduce((index, op)=>{
            const length = (0, $b0994a93e93413e9$exports.Op).length(op);
            let attributes = op.attributes || {};
            let isImplicitNewlinePrepended = false;
            let isImplicitNewlineAppended = false;
            if (op.insert != null) {
                deleteDelta.retain(length);
                if (typeof op.insert === 'string') {
                    const text = op.insert;
                    isImplicitNewlineAppended = !text.endsWith('\n') && (scrollLength <= index || !!this.scroll.descendant((0, $0d7ea5a8bdacfb09$export$48b9f0688962d028), index)[0]);
                    this.scroll.insertAt(index, text);
                    const [line, offset] = this.scroll.line(index);
                    let formats = (0, $e60eefbf4c36c7e0$export$2e2bcd8739ae039)({}, (0, $0d7ea5a8bdacfb09$export$e4bb5a6163449612)(line));
                    if (line instanceof (0, $0d7ea5a8bdacfb09$export$2e2bcd8739ae039)) {
                        const [leaf] = line.descendant((0, $e9fc1a5fcc0c5a1a$export$7420b9c542181544), offset);
                        if (leaf) formats = (0, $e60eefbf4c36c7e0$export$2e2bcd8739ae039)(formats, (0, $0d7ea5a8bdacfb09$export$e4bb5a6163449612)(leaf));
                    }
                    attributes = (0, $b0994a93e93413e9$exports.AttributeMap).diff(formats, attributes) || {};
                } else if (typeof op.insert === 'object') {
                    const key = Object.keys(op.insert)[0]; // There should only be one key
                    if (key == null) return index;
                    const isInlineEmbed = this.scroll.query(key, (0, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214).INLINE) != null;
                    if (isInlineEmbed) {
                        if (scrollLength <= index || !!this.scroll.descendant((0, $0d7ea5a8bdacfb09$export$48b9f0688962d028), index)[0]) isImplicitNewlineAppended = true;
                    } else if (index > 0) {
                        const [leaf, offset] = this.scroll.descendant((0, $e9fc1a5fcc0c5a1a$export$7420b9c542181544), index - 1);
                        if (leaf instanceof (0, $b5feff51aa4dee9f$export$2e2bcd8739ae039)) {
                            const text = leaf.value();
                            if (text[offset] !== '\n') isImplicitNewlinePrepended = true;
                        } else if (leaf instanceof (0, $e9fc1a5fcc0c5a1a$export$297a1fa96f55f00f) && leaf.statics.scope === (0, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214).INLINE_BLOT) isImplicitNewlinePrepended = true;
                    }
                    this.scroll.insertAt(index, key, op.insert[key]);
                    if (isInlineEmbed) {
                        const [leaf] = this.scroll.descendant((0, $e9fc1a5fcc0c5a1a$export$7420b9c542181544), index);
                        if (leaf) {
                            const formats = (0, $e60eefbf4c36c7e0$export$2e2bcd8739ae039)({}, (0, $0d7ea5a8bdacfb09$export$e4bb5a6163449612)(leaf));
                            attributes = (0, $b0994a93e93413e9$exports.AttributeMap).diff(formats, attributes) || {};
                        }
                    }
                }
                scrollLength += length;
            } else {
                deleteDelta.push(op);
                if (op.retain !== null && typeof op.retain === 'object') {
                    const key = Object.keys(op.retain)[0];
                    if (key == null) return index;
                    this.scroll.updateEmbedAt(index, key, op.retain[key]);
                }
            }
            Object.keys(attributes).forEach((name)=>{
                this.scroll.formatAt(index, length, name, attributes[name]);
            });
            const prependedLength = isImplicitNewlinePrepended ? 1 : 0;
            const addedLength = isImplicitNewlineAppended ? 1 : 0;
            scrollLength += prependedLength + addedLength;
            deleteDelta.retain(prependedLength);
            deleteDelta.delete(addedLength);
            return index + length + prependedLength + addedLength;
        }, 0);
        deleteDelta.reduce((index, op)=>{
            if (typeof op.delete === 'number') {
                this.scroll.deleteAt(index, op.delete);
                return index;
            }
            return index + (0, $b0994a93e93413e9$exports.Op).length(op);
        }, 0);
        this.scroll.batchEnd();
        this.scroll.optimize();
        return this.update(normalizedDelta);
    }
    deleteText(index, length) {
        this.scroll.deleteAt(index, length);
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().retain(index).delete(length));
    }
    formatLine(index, length) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.scroll.update();
        Object.keys(formats).forEach((format)=>{
            this.scroll.lines(index, Math.max(length, 1)).forEach((line)=>{
                line.format(format, formats[format]);
            });
        });
        this.scroll.optimize();
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().retain(index).retain(length, (0, $97b34790ff67df55$export$2e2bcd8739ae039)(formats));
        return this.update(delta);
    }
    formatText(index, length) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        Object.keys(formats).forEach((format)=>{
            this.scroll.formatAt(index, length, format, formats[format]);
        });
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().retain(index).retain(length, (0, $97b34790ff67df55$export$2e2bcd8739ae039)(formats));
        return this.update(delta);
    }
    getContents(index, length) {
        return this.delta.slice(index, index + length);
    }
    getDelta() {
        return this.scroll.lines().reduce((delta, line)=>{
            return delta.concat(line.delta());
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))());
    }
    getFormat(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let lines = [];
        let leaves = [];
        if (length === 0) this.scroll.path(index).forEach((path)=>{
            const [blot] = path;
            if (blot instanceof (0, $0d7ea5a8bdacfb09$export$2e2bcd8739ae039)) lines.push(blot);
            else if (blot instanceof (0, $e9fc1a5fcc0c5a1a$export$7420b9c542181544)) leaves.push(blot);
        });
        else {
            lines = this.scroll.lines(index, length);
            leaves = this.scroll.descendants((0, $e9fc1a5fcc0c5a1a$export$7420b9c542181544), index, length);
        }
        const [lineFormats, leafFormats] = [
            lines,
            leaves
        ].map((blots)=>{
            const blot = blots.shift();
            if (blot == null) return {};
            let formats = (0, $0d7ea5a8bdacfb09$export$e4bb5a6163449612)(blot);
            while(Object.keys(formats).length > 0){
                const blot = blots.shift();
                if (blot == null) return formats;
                formats = $eed0b828523b347d$var$combineFormats((0, $0d7ea5a8bdacfb09$export$e4bb5a6163449612)(blot), formats);
            }
            return formats;
        });
        return {
            ...lineFormats,
            ...leafFormats
        };
    }
    getHTML(index, length) {
        const [line, lineOffset] = this.scroll.line(index);
        if (line) {
            const lineLength = line.length();
            const isWithinLine = line.length() >= lineOffset + length;
            if (isWithinLine && !(lineOffset === 0 && length === lineLength)) return $eed0b828523b347d$var$convertHTML(line, lineOffset, length, true);
            return $eed0b828523b347d$var$convertHTML(this.scroll, index, length, true);
        }
        return '';
    }
    getText(index, length) {
        return this.getContents(index, length).filter((op)=>typeof op.insert === 'string').map((op)=>op.insert).join('');
    }
    insertContents(index, contents) {
        const normalizedDelta = $eed0b828523b347d$var$normalizeDelta(contents);
        const change = new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().retain(index).concat(normalizedDelta);
        this.scroll.insertContents(index, normalizedDelta);
        return this.update(change);
    }
    insertEmbed(index, embed, value) {
        this.scroll.insertAt(index, embed, value);
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().retain(index).insert({
            [embed]: value
        }));
    }
    insertText(index, text) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
        this.scroll.insertAt(index, text);
        Object.keys(formats).forEach((format)=>{
            this.scroll.formatAt(index, text.length, format, formats[format]);
        });
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().retain(index).insert(text, (0, $97b34790ff67df55$export$2e2bcd8739ae039)(formats)));
    }
    isBlank() {
        if (this.scroll.children.length === 0) return true;
        if (this.scroll.children.length > 1) return false;
        const blot = this.scroll.children.head;
        if (blot?.statics.blotName !== (0, $0d7ea5a8bdacfb09$export$2e2bcd8739ae039).blotName) return false;
        const block = blot;
        if (block.children.length > 1) return false;
        return block.children.head instanceof (0, $e5579ce91e3096b0$export$2e2bcd8739ae039);
    }
    removeFormat(index, length) {
        const text = this.getText(index, length);
        const [line, offset] = this.scroll.line(index + length);
        let suffixLength = 0;
        let suffix = new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))();
        if (line != null) {
            suffixLength = line.length() - offset;
            suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
        }
        const contents = this.getContents(index, length + suffixLength);
        const diff = contents.diff(new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().insert(text).concat(suffix));
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().retain(index).concat(diff);
        return this.applyDelta(delta);
    }
    update(change) {
        let mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        let selectionInfo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
        const oldDelta = this.delta;
        if (mutations.length === 1 && mutations[0].type === 'characterData' && // @ts-expect-error Fix me later
        mutations[0].target.data.match($eed0b828523b347d$var$ASCII) && this.scroll.find(mutations[0].target)) {
            // Optimization for character changes
            const textBlot = this.scroll.find(mutations[0].target);
            const formats = (0, $0d7ea5a8bdacfb09$export$e4bb5a6163449612)(textBlot);
            const index = textBlot.offset(this.scroll);
            // @ts-expect-error Fix me later
            const oldValue = mutations[0].oldValue.replace((0, $fa8ee3ba40bbf9de$export$2e2bcd8739ae039).CONTENTS, '');
            const oldText = new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().insert(oldValue);
            // @ts-expect-error
            const newText = new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().insert(textBlot.value());
            const relativeSelectionInfo = selectionInfo && {
                oldRange: $eed0b828523b347d$var$shiftRange(selectionInfo.oldRange, -index),
                newRange: $eed0b828523b347d$var$shiftRange(selectionInfo.newRange, -index)
            };
            const diffDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().retain(index).concat(oldText.diff(newText, relativeSelectionInfo));
            change = diffDelta.reduce((delta, op)=>{
                if (op.insert) return delta.insert(op.insert, formats);
                return delta.push(op);
            }, new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))());
            this.delta = oldDelta.compose(change);
        } else {
            this.delta = this.getDelta();
            if (!change || !(0, $ee28b6e7df1b1693$export$2e2bcd8739ae039)(oldDelta.compose(change), this.delta)) change = oldDelta.diff(this.delta, selectionInfo);
        }
        return change;
    }
}
function $eed0b828523b347d$var$convertListHTML(items, lastIndent, types) {
    if (items.length === 0) {
        const [endTag] = $eed0b828523b347d$var$getListType(types.pop());
        if (lastIndent <= 0) return `</li></${endTag}>`;
        return `</li></${endTag}>${$eed0b828523b347d$var$convertListHTML([], lastIndent - 1, types)}`;
    }
    const [{ child: child, offset: offset, length: length, indent: indent, type: type }, ...rest] = items;
    const [tag, attribute] = $eed0b828523b347d$var$getListType(type);
    if (indent > lastIndent) {
        types.push(type);
        if (indent === lastIndent + 1) return `<${tag}><li${attribute}>${$eed0b828523b347d$var$convertHTML(child, offset, length)}${$eed0b828523b347d$var$convertListHTML(rest, indent, types)}`;
        return `<${tag}><li>${$eed0b828523b347d$var$convertListHTML(items, lastIndent + 1, types)}`;
    }
    const previousType = types[types.length - 1];
    if (indent === lastIndent && type === previousType) return `</li><li${attribute}>${$eed0b828523b347d$var$convertHTML(child, offset, length)}${$eed0b828523b347d$var$convertListHTML(rest, indent, types)}`;
    const [endTag] = $eed0b828523b347d$var$getListType(types.pop());
    return `</li></${endTag}>${$eed0b828523b347d$var$convertListHTML(items, lastIndent - 1, types)}`;
}
function $eed0b828523b347d$var$convertHTML(blot, index, length) {
    let isRoot = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if ('html' in blot && typeof blot.html === 'function') return blot.html(index, length);
    if (blot instanceof (0, $b5feff51aa4dee9f$export$2e2bcd8739ae039)) {
        const escapedText = (0, $b5feff51aa4dee9f$export$96e6fc3a139b2555)(blot.value().slice(index, index + length));
        return escapedText.replaceAll(' ', '&nbsp;');
    }
    if (blot instanceof (0, $e9fc1a5fcc0c5a1a$export$e43113f0aad76fe)) {
        // TODO fix API
        if (blot.statics.blotName === 'list-container') {
            const items = [];
            blot.children.forEachAt(index, length, (child, offset, childLength)=>{
                const formats = 'formats' in child && typeof child.formats === 'function' ? child.formats() : {};
                items.push({
                    child: child,
                    offset: offset,
                    length: childLength,
                    indent: formats.indent || 0,
                    type: formats.list
                });
            });
            return $eed0b828523b347d$var$convertListHTML(items, -1, []);
        }
        const parts = [];
        blot.children.forEachAt(index, length, (child, offset, childLength)=>{
            parts.push($eed0b828523b347d$var$convertHTML(child, offset, childLength));
        });
        if (isRoot || blot.statics.blotName === 'list') return parts.join('');
        const { outerHTML: outerHTML, innerHTML: innerHTML } = blot.domNode;
        const [start, end] = outerHTML.split(`>${innerHTML}<`);
        // TODO cleanup
        if (start === '<table') return `<table style="border: 1px solid #000;">${parts.join('')}<${end}`;
        return `${start}>${parts.join('')}<${end}`;
    }
    return blot.domNode instanceof Element ? blot.domNode.outerHTML : '';
}
function $eed0b828523b347d$var$combineFormats(formats, combined) {
    return Object.keys(combined).reduce((merged, name)=>{
        if (formats[name] == null) return merged;
        const combinedValue = combined[name];
        if (combinedValue === formats[name]) merged[name] = combinedValue;
        else if (Array.isArray(combinedValue)) {
            if (combinedValue.indexOf(formats[name]) < 0) merged[name] = combinedValue.concat([
                formats[name]
            ]);
            else // If style already exists, don't add to an array, but don't lose other styles
            merged[name] = combinedValue;
        } else merged[name] = [
            combinedValue,
            formats[name]
        ];
        return merged;
    }, {});
}
function $eed0b828523b347d$var$getListType(type) {
    const tag = type === 'ordered' ? 'ol' : 'ul';
    switch(type){
        case 'checked':
            return [
                tag,
                ' data-list="checked"'
            ];
        case 'unchecked':
            return [
                tag,
                ' data-list="unchecked"'
            ];
        default:
            return [
                tag,
                ''
            ];
    }
}
function $eed0b828523b347d$var$normalizeDelta(delta) {
    return delta.reduce((normalizedDelta, op)=>{
        if (typeof op.insert === 'string') {
            const text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
            return normalizedDelta.insert(text, op.attributes);
        }
        return normalizedDelta.push(op);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))());
}
function $eed0b828523b347d$var$shiftRange(_ref, amount) {
    let { index: index, length: length } = _ref;
    return new (0, $89ce7bdd8fd0c5db$export$9a58ef0d7ad3278c)(index + amount, length);
}
function $eed0b828523b347d$var$splitOpLines(ops) {
    const split = [];
    ops.forEach((op)=>{
        if (typeof op.insert === 'string') {
            const lines = op.insert.split('\n');
            lines.forEach((line, index)=>{
                if (index) split.push({
                    insert: '\n',
                    attributes: op.attributes
                });
                if (line) split.push({
                    insert: line,
                    attributes: op.attributes
                });
            });
        } else split.push(op);
    });
    return split;
}
var $eed0b828523b347d$export$2e2bcd8739ae039 = $eed0b828523b347d$var$Editor;





class $ec73c86348f00d5d$var$Module {
    static DEFAULTS = {};
    constructor(quill){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.quill = quill;
        this.options = options;
    }
}
var $ec73c86348f00d5d$export$2e2bcd8739ae039 = $ec73c86348f00d5d$var$Module;





const $2533afcdc047b3ff$var$GUARD_TEXT = '\uFEFF';
class $2533afcdc047b3ff$var$Embed extends (0, $e9fc1a5fcc0c5a1a$export$297a1fa96f55f00f) {
    constructor(scroll, node){
        super(scroll, node);
        this.contentNode = document.createElement('span');
        this.contentNode.setAttribute('contenteditable', 'false');
        Array.from(this.domNode.childNodes).forEach((childNode)=>{
            this.contentNode.appendChild(childNode);
        });
        this.leftGuard = document.createTextNode($2533afcdc047b3ff$var$GUARD_TEXT);
        this.rightGuard = document.createTextNode($2533afcdc047b3ff$var$GUARD_TEXT);
        this.domNode.appendChild(this.leftGuard);
        this.domNode.appendChild(this.contentNode);
        this.domNode.appendChild(this.rightGuard);
    }
    index(node, offset) {
        if (node === this.leftGuard) return 0;
        if (node === this.rightGuard) return 1;
        return super.index(node, offset);
    }
    restore(node) {
        let range = null;
        let textNode;
        const text = node.data.split($2533afcdc047b3ff$var$GUARD_TEXT).join('');
        if (node === this.leftGuard) {
            if (this.prev instanceof (0, $b5feff51aa4dee9f$export$2e2bcd8739ae039)) {
                const prevLength = this.prev.length();
                this.prev.insertAt(prevLength, text);
                range = {
                    startNode: this.prev.domNode,
                    startOffset: prevLength + text.length
                };
            } else {
                textNode = document.createTextNode(text);
                this.parent.insertBefore(this.scroll.create(textNode), this);
                range = {
                    startNode: textNode,
                    startOffset: text.length
                };
            }
        } else if (node === this.rightGuard) {
            if (this.next instanceof (0, $b5feff51aa4dee9f$export$2e2bcd8739ae039)) {
                this.next.insertAt(0, text);
                range = {
                    startNode: this.next.domNode,
                    startOffset: text.length
                };
            } else {
                textNode = document.createTextNode(text);
                this.parent.insertBefore(this.scroll.create(textNode), this.next);
                range = {
                    startNode: textNode,
                    startOffset: text.length
                };
            }
        }
        node.data = $2533afcdc047b3ff$var$GUARD_TEXT;
        return range;
    }
    update(mutations, context) {
        mutations.forEach((mutation)=>{
            if (mutation.type === 'characterData' && (mutation.target === this.leftGuard || mutation.target === this.rightGuard)) {
                const range = this.restore(mutation.target);
                if (range) context.range = range;
            }
        });
    }
}
var $2533afcdc047b3ff$export$2e2bcd8739ae039 = $2533afcdc047b3ff$var$Embed;



class $b0d1d8a21567b43b$var$Composition {
    isComposing = false;
    constructor(scroll, emitter){
        this.scroll = scroll;
        this.emitter = emitter;
        this.setupListeners();
    }
    setupListeners() {
        this.scroll.domNode.addEventListener('compositionstart', (event)=>{
            if (!this.isComposing) this.handleCompositionStart(event);
        });
        this.scroll.domNode.addEventListener('compositionend', (event)=>{
            if (this.isComposing) // Webkit makes DOM changes after compositionend, so we use microtask to
            // ensure the order.
            // https://bugs.webkit.org/show_bug.cgi?id=31902
            queueMicrotask(()=>{
                this.handleCompositionEnd(event);
            });
        });
    }
    handleCompositionStart(event) {
        const blot = event.target instanceof Node ? this.scroll.find(event.target, true) : null;
        if (blot && !(blot instanceof (0, $2533afcdc047b3ff$export$2e2bcd8739ae039))) {
            this.emitter.emit((0, $ba29015e3d87cf52$export$2e2bcd8739ae039).events.COMPOSITION_BEFORE_START, event);
            this.scroll.batchStart();
            this.emitter.emit((0, $ba29015e3d87cf52$export$2e2bcd8739ae039).events.COMPOSITION_START, event);
            this.isComposing = true;
        }
    }
    handleCompositionEnd(event) {
        this.emitter.emit((0, $ba29015e3d87cf52$export$2e2bcd8739ae039).events.COMPOSITION_BEFORE_END, event);
        this.scroll.batchEnd();
        this.emitter.emit((0, $ba29015e3d87cf52$export$2e2bcd8739ae039).events.COMPOSITION_END, event);
        this.isComposing = false;
    }
}
var $b0d1d8a21567b43b$export$2e2bcd8739ae039 = $b0d1d8a21567b43b$var$Composition;


class $edba63c8388b93cb$var$Theme {
    static DEFAULTS = {
        modules: {}
    };
    static themes = {
        default: $edba63c8388b93cb$var$Theme
    };
    modules = {};
    constructor(quill, options){
        this.quill = quill;
        this.options = options;
    }
    init() {
        Object.keys(this.options.modules).forEach((name)=>{
            if (this.modules[name] == null) this.addModule(name);
        });
    }
    addModule(name) {
        // @ts-expect-error
        const ModuleClass = this.quill.constructor.import(`modules/${name}`);
        this.modules[name] = new ModuleClass(this.quill, this.options.modules[name] || {});
        return this.modules[name];
    }
}
var $edba63c8388b93cb$export$2e2bcd8739ae039 = $edba63c8388b93cb$var$Theme;


const $5a7e187ca57bad1b$var$getParentElement = (element)=>element.parentElement || element.getRootNode().host || null;
const $5a7e187ca57bad1b$var$getElementRect = (element)=>{
    const rect = element.getBoundingClientRect();
    const scaleX = 'offsetWidth' in element && Math.abs(rect.width) / element.offsetWidth || 1;
    const scaleY = 'offsetHeight' in element && Math.abs(rect.height) / element.offsetHeight || 1;
    return {
        top: rect.top,
        right: rect.left + element.clientWidth * scaleX,
        bottom: rect.top + element.clientHeight * scaleY,
        left: rect.left
    };
};
const $5a7e187ca57bad1b$var$paddingValueToInt = (value)=>{
    const number = parseInt(value, 10);
    return Number.isNaN(number) ? 0 : number;
};
// Follow the steps described in https://www.w3.org/TR/cssom-view-1/#element-scrolling-members,
// assuming that the scroll option is set to 'nearest'.
const $5a7e187ca57bad1b$var$getScrollDistance = (targetStart, targetEnd, scrollStart, scrollEnd, scrollPaddingStart, scrollPaddingEnd)=>{
    if (targetStart < scrollStart && targetEnd > scrollEnd) return 0;
    if (targetStart < scrollStart) return -(scrollStart - targetStart + scrollPaddingStart);
    if (targetEnd > scrollEnd) return targetEnd - targetStart > scrollEnd - scrollStart ? targetStart + scrollPaddingStart - scrollStart : targetEnd - scrollEnd + scrollPaddingEnd;
    return 0;
};
const $5a7e187ca57bad1b$var$scrollRectIntoView = (root, targetRect)=>{
    const document = root.ownerDocument;
    let rect = targetRect;
    let current = root;
    while(current){
        const isDocumentBody = current === document.body;
        const bounding = isDocumentBody ? {
            top: 0,
            right: window.visualViewport?.width ?? document.documentElement.clientWidth,
            bottom: window.visualViewport?.height ?? document.documentElement.clientHeight,
            left: 0
        } : $5a7e187ca57bad1b$var$getElementRect(current);
        const style = getComputedStyle(current);
        const scrollDistanceX = $5a7e187ca57bad1b$var$getScrollDistance(rect.left, rect.right, bounding.left, bounding.right, $5a7e187ca57bad1b$var$paddingValueToInt(style.scrollPaddingLeft), $5a7e187ca57bad1b$var$paddingValueToInt(style.scrollPaddingRight));
        const scrollDistanceY = $5a7e187ca57bad1b$var$getScrollDistance(rect.top, rect.bottom, bounding.top, bounding.bottom, $5a7e187ca57bad1b$var$paddingValueToInt(style.scrollPaddingTop), $5a7e187ca57bad1b$var$paddingValueToInt(style.scrollPaddingBottom));
        if (scrollDistanceX || scrollDistanceY) {
            if (isDocumentBody) document.defaultView?.scrollBy(scrollDistanceX, scrollDistanceY);
            else {
                const { scrollLeft: scrollLeft, scrollTop: scrollTop } = current;
                if (scrollDistanceY) current.scrollTop += scrollDistanceY;
                if (scrollDistanceX) current.scrollLeft += scrollDistanceX;
                const scrolledLeft = current.scrollLeft - scrollLeft;
                const scrolledTop = current.scrollTop - scrollTop;
                rect = {
                    left: rect.left - scrolledLeft,
                    top: rect.top - scrolledTop,
                    right: rect.right - scrolledLeft,
                    bottom: rect.bottom - scrolledTop
                };
            }
        }
        current = isDocumentBody || style.position === 'fixed' ? null : $5a7e187ca57bad1b$var$getParentElement(current);
    }
};
var $5a7e187ca57bad1b$export$2e2bcd8739ae039 = $5a7e187ca57bad1b$var$scrollRectIntoView;



const $397a77fbaa8d7bdf$var$MAX_REGISTER_ITERATIONS = 100;
const $397a77fbaa8d7bdf$var$CORE_FORMATS = [
    'block',
    'break',
    'cursor',
    'inline',
    'scroll',
    'text'
];
const $397a77fbaa8d7bdf$var$createRegistryWithFormats = (formats, sourceRegistry, debug)=>{
    const registry = new (0, $e9fc1a5fcc0c5a1a$export$4d9facee29974f3)();
    $397a77fbaa8d7bdf$var$CORE_FORMATS.forEach((name)=>{
        const coreBlot = sourceRegistry.query(name);
        if (coreBlot) registry.register(coreBlot);
    });
    formats.forEach((name)=>{
        let format = sourceRegistry.query(name);
        if (!format) debug.error(`Cannot register "${name}" specified in "formats" config. Are you sure it was registered?`);
        let iterations = 0;
        while(format){
            registry.register(format);
            format = 'blotName' in format ? format.requiredContainer ?? null : null;
            iterations += 1;
            if (iterations > $397a77fbaa8d7bdf$var$MAX_REGISTER_ITERATIONS) {
                debug.error(`Cycle detected in registering blot requiredContainer: "${name}"`);
                break;
            }
        }
    });
    return registry;
};
var $397a77fbaa8d7bdf$export$2e2bcd8739ae039 = $397a77fbaa8d7bdf$var$createRegistryWithFormats;


const $6deb74e67088b9aa$var$debug = (0, $7ec5affce32db05e$export$2e2bcd8739ae039)('quill');
const $6deb74e67088b9aa$export$bc58ce2776ecdb6f = new $e9fc1a5fcc0c5a1a$exports.Registry();
$e9fc1a5fcc0c5a1a$exports.ParentBlot.uiClass = 'ql-ui';
/**
 * Options for initializing a Quill instance
 */ /**
 * Similar to QuillOptions, but with all properties expanded to their default values,
 * and all selectors resolved to HTMLElements.
 */ class $6deb74e67088b9aa$export$2e2bcd8739ae039 {
    static DEFAULTS = {
        bounds: null,
        modules: {
            clipboard: true,
            keyboard: true,
            history: true,
            uploader: true
        },
        placeholder: '',
        readOnly: false,
        registry: $6deb74e67088b9aa$export$bc58ce2776ecdb6f,
        theme: 'default'
    };
    static events = (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).events;
    static sources = (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources;
    static version = "2.0.3";
    static imports = {
        delta: (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports))),
        parchment: $e9fc1a5fcc0c5a1a$exports,
        'core/module': (0, $ec73c86348f00d5d$export$2e2bcd8739ae039),
        'core/theme': (0, $edba63c8388b93cb$export$2e2bcd8739ae039)
    };
    static debug(limit) {
        if (limit === true) limit = 'log';
        (0, $7ec5affce32db05e$export$2e2bcd8739ae039).level(limit);
    }
    static find(node) {
        let bubble = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return (0, $0973420badb96151$export$2e2bcd8739ae039).get(node) || $6deb74e67088b9aa$export$bc58ce2776ecdb6f.find(node, bubble);
    }
    static import(name) {
        if (this.imports[name] == null) $6deb74e67088b9aa$var$debug.error(`Cannot import ${name}. Are you sure it was registered?`);
        return this.imports[name];
    }
    static register() {
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) !== 'string') {
            const target = arguments.length <= 0 ? undefined : arguments[0];
            const overwrite = !!(arguments.length <= 1 ? undefined : arguments[1]);
            const name = 'attrName' in target ? target.attrName : target.blotName;
            if (typeof name === 'string') // Shortcut for formats:
            // register(Blot | Attributor, overwrite)
            this.register(`formats/${name}`, target, overwrite);
            else Object.keys(target).forEach((key)=>{
                this.register(key, target[key], overwrite);
            });
        } else {
            const path = arguments.length <= 0 ? undefined : arguments[0];
            const target = arguments.length <= 1 ? undefined : arguments[1];
            const overwrite = !!(arguments.length <= 2 ? undefined : arguments[2]);
            if (this.imports[path] != null && !overwrite) $6deb74e67088b9aa$var$debug.warn(`Overwriting ${path} with`, target);
            this.imports[path] = target;
            if ((path.startsWith('blots/') || path.startsWith('formats/')) && target && typeof target !== 'boolean' && target.blotName !== 'abstract') $6deb74e67088b9aa$export$bc58ce2776ecdb6f.register(target);
            if (typeof target.register === 'function') target.register($6deb74e67088b9aa$export$bc58ce2776ecdb6f);
        }
    }
    constructor(container){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.options = $6deb74e67088b9aa$export$72ab7189806b6df5(container, options);
        this.container = this.options.container;
        if (this.container == null) {
            $6deb74e67088b9aa$var$debug.error('Invalid Quill container', container);
            return;
        }
        if (this.options.debug) $6deb74e67088b9aa$export$2e2bcd8739ae039.debug(this.options.debug);
        const html = this.container.innerHTML.trim();
        this.container.classList.add('ql-container');
        this.container.innerHTML = '';
        (0, $0973420badb96151$export$2e2bcd8739ae039).set(this.container, this);
        this.root = this.addContainer('ql-editor');
        this.root.classList.add('ql-blank');
        this.emitter = new (0, $ba29015e3d87cf52$export$2e2bcd8739ae039)();
        const scrollBlotName = $e9fc1a5fcc0c5a1a$exports.ScrollBlot.blotName;
        const ScrollBlot = this.options.registry.query(scrollBlotName);
        if (!ScrollBlot || !('blotName' in ScrollBlot)) throw new Error(`Cannot initialize Quill without "${scrollBlotName}" blot`);
        this.scroll = new ScrollBlot(this.options.registry, this.root, {
            emitter: this.emitter
        });
        this.editor = new (0, $eed0b828523b347d$export$2e2bcd8739ae039)(this.scroll);
        this.selection = new (0, $89ce7bdd8fd0c5db$export$2e2bcd8739ae039)(this.scroll, this.emitter);
        this.composition = new (0, $b0d1d8a21567b43b$export$2e2bcd8739ae039)(this.scroll, this.emitter);
        this.theme = new this.options.theme(this, this.options); // eslint-disable-line new-cap
        this.keyboard = this.theme.addModule('keyboard');
        this.clipboard = this.theme.addModule('clipboard');
        this.history = this.theme.addModule('history');
        this.uploader = this.theme.addModule('uploader');
        this.theme.addModule('input');
        this.theme.addModule('uiNode');
        this.theme.init();
        this.emitter.on((0, $ba29015e3d87cf52$export$2e2bcd8739ae039).events.EDITOR_CHANGE, (type)=>{
            if (type === (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).events.TEXT_CHANGE) this.root.classList.toggle('ql-blank', this.editor.isBlank());
        });
        this.emitter.on((0, $ba29015e3d87cf52$export$2e2bcd8739ae039).events.SCROLL_UPDATE, (source, mutations)=>{
            const oldRange = this.selection.lastRange;
            const [newRange] = this.selection.getRange();
            const selectionInfo = oldRange && newRange ? {
                oldRange: oldRange,
                newRange: newRange
            } : undefined;
            $6deb74e67088b9aa$var$modify.call(this, ()=>this.editor.update(null, mutations, selectionInfo), source);
        });
        this.emitter.on((0, $ba29015e3d87cf52$export$2e2bcd8739ae039).events.SCROLL_EMBED_UPDATE, (blot, delta)=>{
            const oldRange = this.selection.lastRange;
            const [newRange] = this.selection.getRange();
            const selectionInfo = oldRange && newRange ? {
                oldRange: oldRange,
                newRange: newRange
            } : undefined;
            $6deb74e67088b9aa$var$modify.call(this, ()=>{
                const change = new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().retain(blot.offset(this)).retain({
                    [blot.statics.blotName]: delta
                });
                return this.editor.update(change, [], selectionInfo);
            }, $6deb74e67088b9aa$export$2e2bcd8739ae039.sources.USER);
        });
        if (html) {
            const contents = this.clipboard.convert({
                html: `${html}<p><br></p>`,
                text: '\n'
            });
            this.setContents(contents);
        }
        this.history.clear();
        if (this.options.placeholder) this.root.setAttribute('data-placeholder', this.options.placeholder);
        if (this.options.readOnly) this.disable();
        this.allowReadOnlyEdits = false;
    }
    addContainer(container) {
        let refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        if (typeof container === 'string') {
            const className = container;
            container = document.createElement('div');
            container.classList.add(className);
        }
        this.container.insertBefore(container, refNode);
        return container;
    }
    blur() {
        this.selection.setRange(null);
    }
    deleteText(index, length, source) {
        // @ts-expect-error
        [index, length, , source] = $6deb74e67088b9aa$export$e336952123c0bccd(index, length, source);
        return $6deb74e67088b9aa$var$modify.call(this, ()=>{
            return this.editor.deleteText(index, length);
        }, source, index, -1 * length);
    }
    disable() {
        this.enable(false);
    }
    editReadOnly(modifier) {
        this.allowReadOnlyEdits = true;
        const value = modifier();
        this.allowReadOnlyEdits = false;
        return value;
    }
    enable() {
        let enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.scroll.enable(enabled);
        this.container.classList.toggle('ql-disabled', !enabled);
    }
    focus() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.selection.focus();
        if (!options.preventScroll) this.scrollSelectionIntoView();
    }
    format(name, value) {
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.API;
        return $6deb74e67088b9aa$var$modify.call(this, ()=>{
            const range = this.getSelection(true);
            let change = new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))();
            if (range == null) return change;
            if (this.scroll.query(name, $e9fc1a5fcc0c5a1a$exports.Scope.BLOCK)) change = this.editor.formatLine(range.index, range.length, {
                [name]: value
            });
            else if (range.length === 0) {
                this.selection.format(name, value);
                return change;
            } else change = this.editor.formatText(range.index, range.length, {
                [name]: value
            });
            this.setSelection(range, (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.SILENT);
            return change;
        }, source);
    }
    formatLine(index, length, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        [index, length, formats, source] = $6deb74e67088b9aa$export$e336952123c0bccd(index, length, // @ts-expect-error
        name, value, source);
        return $6deb74e67088b9aa$var$modify.call(this, ()=>{
            return this.editor.formatLine(index, length, formats);
        }, source, index, 0);
    }
    formatText(index, length, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        [index, length, formats, source] = $6deb74e67088b9aa$export$e336952123c0bccd(// @ts-expect-error
        index, length, name, value, source);
        return $6deb74e67088b9aa$var$modify.call(this, ()=>{
            return this.editor.formatText(index, length, formats);
        }, source, index, 0);
    }
    getBounds(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let bounds = null;
        if (typeof index === 'number') bounds = this.selection.getBounds(index, length);
        else bounds = this.selection.getBounds(index.index, index.length);
        if (!bounds) return null;
        const containerBounds = this.container.getBoundingClientRect();
        return {
            bottom: bounds.bottom - containerBounds.top,
            height: bounds.height,
            left: bounds.left - containerBounds.left,
            right: bounds.right - containerBounds.left,
            top: bounds.top - containerBounds.top,
            width: bounds.width
        };
    }
    getContents() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
        [index, length] = $6deb74e67088b9aa$export$e336952123c0bccd(index, length);
        return this.editor.getContents(index, length);
    }
    getFormat() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        if (typeof index === 'number') return this.editor.getFormat(index, length);
        return this.editor.getFormat(index.index, index.length);
    }
    getIndex(blot) {
        return blot.offset(this.scroll);
    }
    getLength() {
        return this.scroll.length();
    }
    getLeaf(index) {
        return this.scroll.leaf(index);
    }
    getLine(index) {
        return this.scroll.line(index);
    }
    getLines() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
        if (typeof index !== 'number') return this.scroll.lines(index.index, index.length);
        return this.scroll.lines(index, length);
    }
    getModule(name) {
        return this.theme.modules[name];
    }
    getSelection() {
        let focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (focus) this.focus();
        this.update(); // Make sure we access getRange with editor in consistent state
        return this.selection.getRange()[0];
    }
    getSemanticHTML() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 ? arguments[1] : undefined;
        if (typeof index === 'number') length = length ?? this.getLength() - index;
        // @ts-expect-error
        [index, length] = $6deb74e67088b9aa$export$e336952123c0bccd(index, length);
        return this.editor.getHTML(index, length);
    }
    getText() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 ? arguments[1] : undefined;
        if (typeof index === 'number') length = length ?? this.getLength() - index;
        // @ts-expect-error
        [index, length] = $6deb74e67088b9aa$export$e336952123c0bccd(index, length);
        return this.editor.getText(index, length);
    }
    hasFocus() {
        return this.selection.hasFocus();
    }
    insertEmbed(index, embed, value) {
        let source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $6deb74e67088b9aa$export$2e2bcd8739ae039.sources.API;
        return $6deb74e67088b9aa$var$modify.call(this, ()=>{
            return this.editor.insertEmbed(index, embed, value);
        }, source, index);
    }
    insertText(index, text, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        // @ts-expect-error
        [index, , formats, source] = $6deb74e67088b9aa$export$e336952123c0bccd(index, 0, name, value, source);
        return $6deb74e67088b9aa$var$modify.call(this, ()=>{
            return this.editor.insertText(index, text, formats);
        }, source, index, text.length);
    }
    isEnabled() {
        return this.scroll.isEnabled();
    }
    off() {
        return this.emitter.off(...arguments);
    }
    on() {
        return this.emitter.on(...arguments);
    }
    once() {
        return this.emitter.once(...arguments);
    }
    removeFormat(index, length, source) {
        [index, length, , source] = $6deb74e67088b9aa$export$e336952123c0bccd(index, length, source);
        return $6deb74e67088b9aa$var$modify.call(this, ()=>{
            return this.editor.removeFormat(index, length);
        }, source, index);
    }
    scrollRectIntoView(rect) {
        (0, $5a7e187ca57bad1b$export$2e2bcd8739ae039)(this.root, rect);
    }
    /**
   * @deprecated Use Quill#scrollSelectionIntoView() instead.
   */ scrollIntoView() {
        console.warn('Quill#scrollIntoView() has been deprecated and will be removed in the near future. Please use Quill#scrollSelectionIntoView() instead.');
        this.scrollSelectionIntoView();
    }
    /**
   * Scroll the current selection into the visible area.
   * If the selection is already visible, no scrolling will occur.
   */ scrollSelectionIntoView() {
        const range = this.selection.lastRange;
        const bounds = range && this.selection.getBounds(range.index, range.length);
        if (bounds) this.scrollRectIntoView(bounds);
    }
    setContents(delta) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.API;
        return $6deb74e67088b9aa$var$modify.call(this, ()=>{
            delta = new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))(delta);
            const length = this.getLength();
            // Quill will set empty editor to \n
            const delete1 = this.editor.deleteText(0, length);
            const applied = this.editor.insertContents(0, delta);
            // Remove extra \n from empty editor initialization
            const delete2 = this.editor.deleteText(this.getLength() - 1, 1);
            return delete1.compose(applied).compose(delete2);
        }, source);
    }
    setSelection(index, length, source) {
        if (index == null) // @ts-expect-error https://github.com/microsoft/TypeScript/issues/22609
        this.selection.setRange(null, length || $6deb74e67088b9aa$export$2e2bcd8739ae039.sources.API);
        else {
            // @ts-expect-error
            [index, length, , source] = $6deb74e67088b9aa$export$e336952123c0bccd(index, length, source);
            this.selection.setRange(new (0, $89ce7bdd8fd0c5db$export$9a58ef0d7ad3278c)(Math.max(0, index), length), source);
            if (source !== (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.SILENT) this.scrollSelectionIntoView();
        }
    }
    setText(text) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.API;
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().insert(text);
        return this.setContents(delta, source);
    }
    update() {
        let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.USER;
        const change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
        this.selection.update(source);
        // TODO this is usually undefined
        return change;
    }
    updateContents(delta) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.API;
        return $6deb74e67088b9aa$var$modify.call(this, ()=>{
            delta = new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))(delta);
            return this.editor.applyDelta(delta);
        }, source, true);
    }
}
function $6deb74e67088b9aa$var$resolveSelector(selector) {
    return typeof selector === 'string' ? document.querySelector(selector) : selector;
}
function $6deb74e67088b9aa$var$expandModuleConfig(config) {
    return Object.entries(config ?? {}).reduce((expanded, _ref)=>{
        let [key, value] = _ref;
        return {
            ...expanded,
            [key]: value === true ? {} : value
        };
    }, {});
}
function $6deb74e67088b9aa$var$omitUndefinedValuesFromOptions(obj) {
    return Object.fromEntries(Object.entries(obj).filter((entry)=>entry[1] !== undefined));
}
function $6deb74e67088b9aa$export$72ab7189806b6df5(containerOrSelector, options) {
    const container = $6deb74e67088b9aa$var$resolveSelector(containerOrSelector);
    if (!container) throw new Error('Invalid Quill container');
    const shouldUseDefaultTheme = !options.theme || options.theme === $6deb74e67088b9aa$export$2e2bcd8739ae039.DEFAULTS.theme;
    const theme = shouldUseDefaultTheme ? (0, $edba63c8388b93cb$export$2e2bcd8739ae039) : $6deb74e67088b9aa$export$2e2bcd8739ae039.import(`themes/${options.theme}`);
    if (!theme) throw new Error(`Invalid theme ${options.theme}. Did you register it?`);
    const { modules: quillModuleDefaults, ...quillDefaults } = $6deb74e67088b9aa$export$2e2bcd8739ae039.DEFAULTS;
    const { modules: themeModuleDefaults, ...themeDefaults } = theme.DEFAULTS;
    let userModuleOptions = $6deb74e67088b9aa$var$expandModuleConfig(options.modules);
    // Special case toolbar shorthand
    if (userModuleOptions != null && userModuleOptions.toolbar && userModuleOptions.toolbar.constructor !== Object) userModuleOptions = {
        ...userModuleOptions,
        toolbar: {
            container: userModuleOptions.toolbar
        }
    };
    const modules = (0, $e60eefbf4c36c7e0$export$2e2bcd8739ae039)({}, $6deb74e67088b9aa$var$expandModuleConfig(quillModuleDefaults), $6deb74e67088b9aa$var$expandModuleConfig(themeModuleDefaults), userModuleOptions);
    const config = {
        ...quillDefaults,
        ...$6deb74e67088b9aa$var$omitUndefinedValuesFromOptions(themeDefaults),
        ...$6deb74e67088b9aa$var$omitUndefinedValuesFromOptions(options)
    };
    let registry = options.registry;
    if (registry) {
        if (options.formats) $6deb74e67088b9aa$var$debug.warn('Ignoring "formats" option because "registry" is specified');
    } else registry = options.formats ? (0, $397a77fbaa8d7bdf$export$2e2bcd8739ae039)(options.formats, config.registry, $6deb74e67088b9aa$var$debug) : config.registry;
    return {
        ...config,
        registry: registry,
        container: container,
        theme: theme,
        modules: Object.entries(modules).reduce((modulesWithDefaults, _ref2)=>{
            let [name, value] = _ref2;
            if (!value) return modulesWithDefaults;
            const moduleClass = $6deb74e67088b9aa$export$2e2bcd8739ae039.import(`modules/${name}`);
            if (moduleClass == null) {
                $6deb74e67088b9aa$var$debug.error(`Cannot load ${name} module. Are you sure you registered it?`);
                return modulesWithDefaults;
            }
            return {
                ...modulesWithDefaults,
                // @ts-expect-error
                [name]: (0, $e60eefbf4c36c7e0$export$2e2bcd8739ae039)({}, moduleClass.DEFAULTS || {}, value)
            };
        }, {}),
        bounds: $6deb74e67088b9aa$var$resolveSelector(config.bounds)
    };
}
// Handle selection preservation and TEXT_CHANGE emission
// common to modification APIs
function $6deb74e67088b9aa$var$modify(modifier, source, index, shift) {
    if (!this.isEnabled() && source === (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.USER && !this.allowReadOnlyEdits) return new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))();
    let range = index == null ? null : this.getSelection();
    const oldDelta = this.editor.delta;
    const change = modifier();
    if (range != null) {
        if (index === true) index = range.index; // eslint-disable-line prefer-destructuring
        if (shift == null) range = $6deb74e67088b9aa$var$shiftRange(range, change, source);
        else if (shift !== 0) // @ts-expect-error index should always be number
        range = $6deb74e67088b9aa$var$shiftRange(range, index, shift, source);
        this.setSelection(range, (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.SILENT);
    }
    if (change.length() > 0) {
        const args = [
            (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).events.TEXT_CHANGE,
            change,
            oldDelta,
            source
        ];
        this.emitter.emit((0, $ba29015e3d87cf52$export$2e2bcd8739ae039).events.EDITOR_CHANGE, ...args);
        if (source !== (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.SILENT) this.emitter.emit(...args);
    }
    return change;
}
function $6deb74e67088b9aa$export$e336952123c0bccd(index, length, name, value, source) {
    let formats = {};
    // @ts-expect-error
    if (typeof index.index === 'number' && typeof index.length === 'number') {
        // Allow for throwaway end (used by insertText/insertEmbed)
        if (typeof length !== 'number') {
            // @ts-expect-error
            source = value;
            value = name;
            name = length;
            // @ts-expect-error
            length = index.length; // eslint-disable-line prefer-destructuring
            // @ts-expect-error
            index = index.index; // eslint-disable-line prefer-destructuring
        } else {
            // @ts-expect-error
            length = index.length; // eslint-disable-line prefer-destructuring
            // @ts-expect-error
            index = index.index; // eslint-disable-line prefer-destructuring
        }
    } else if (typeof length !== 'number') {
        // @ts-expect-error
        source = value;
        value = name;
        name = length;
        length = 0;
    }
    // Handle format being object, two format name/value strings or excluded
    if (typeof name === 'object') {
        // @ts-expect-error Fix me later
        formats = name;
        // @ts-expect-error
        source = value;
    } else if (typeof name === 'string') {
        if (value != null) formats[name] = value;
        else // @ts-expect-error
        source = name;
    }
    // Handle optional source
    source = source || (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.API;
    // @ts-expect-error
    return [
        index,
        length,
        formats,
        source
    ];
}
function $6deb74e67088b9aa$var$shiftRange(range, index, lengthOrSource, source) {
    const length = typeof lengthOrSource === 'number' ? lengthOrSource : 0;
    if (range == null) return null;
    let start;
    let end;
    // @ts-expect-error -- TODO: add a better type guard around `index`
    if (index && typeof index.transformPosition === 'function') [start, end] = [
        range.index,
        range.index + range.length
    ].map((pos)=>// @ts-expect-error -- TODO: add a better type guard around `index`
        index.transformPosition(pos, source !== (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.USER));
    else [start, end] = [
        range.index,
        range.index + range.length
    ].map((pos)=>{
        // @ts-expect-error -- TODO: add a better type guard around `index`
        if (pos < index || pos === index && source === (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.USER) return pos;
        if (length >= 0) return pos + length;
        // @ts-expect-error -- TODO: add a better type guard around `index`
        return Math.max(index, pos + length);
    });
    return new (0, $89ce7bdd8fd0c5db$export$9a58ef0d7ad3278c)(start, end - start);
}





class $bbaa9603c8327354$var$Container extends (0, $e9fc1a5fcc0c5a1a$export$c898d510319704c0) {
}
var $bbaa9603c8327354$export$2e2bcd8739ae039 = $bbaa9603c8327354$var$Container;











function $bebd5b95c8bd05a9$var$isLine(blot) {
    return blot instanceof (0, $0d7ea5a8bdacfb09$export$2e2bcd8739ae039) || blot instanceof (0, $0d7ea5a8bdacfb09$export$48b9f0688962d028);
}
function $bebd5b95c8bd05a9$var$isUpdatable(blot) {
    return typeof blot.updateContent === 'function';
}
class $bebd5b95c8bd05a9$var$Scroll extends (0, $e9fc1a5fcc0c5a1a$export$7175329dad7a46f1) {
    static blotName = 'scroll';
    static className = 'ql-editor';
    static tagName = 'DIV';
    static defaultChild = (0, $0d7ea5a8bdacfb09$export$2e2bcd8739ae039);
    static allowedChildren = [
        (0, $0d7ea5a8bdacfb09$export$2e2bcd8739ae039),
        (0, $0d7ea5a8bdacfb09$export$48b9f0688962d028),
        (0, $bbaa9603c8327354$export$2e2bcd8739ae039)
    ];
    constructor(registry, domNode, _ref){
        let { emitter: emitter } = _ref;
        super(registry, domNode);
        this.emitter = emitter;
        this.batch = false;
        this.optimize();
        this.enable();
        this.domNode.addEventListener('dragstart', (e)=>this.handleDragStart(e));
    }
    batchStart() {
        if (!Array.isArray(this.batch)) this.batch = [];
    }
    batchEnd() {
        if (!this.batch) return;
        const mutations = this.batch;
        this.batch = false;
        this.update(mutations);
    }
    emitMount(blot) {
        this.emitter.emit((0, $ba29015e3d87cf52$export$2e2bcd8739ae039).events.SCROLL_BLOT_MOUNT, blot);
    }
    emitUnmount(blot) {
        this.emitter.emit((0, $ba29015e3d87cf52$export$2e2bcd8739ae039).events.SCROLL_BLOT_UNMOUNT, blot);
    }
    emitEmbedUpdate(blot, change) {
        this.emitter.emit((0, $ba29015e3d87cf52$export$2e2bcd8739ae039).events.SCROLL_EMBED_UPDATE, blot, change);
    }
    deleteAt(index, length) {
        const [first, offset] = this.line(index);
        const [last] = this.line(index + length);
        super.deleteAt(index, length);
        if (last != null && first !== last && offset > 0) {
            if (first instanceof (0, $0d7ea5a8bdacfb09$export$48b9f0688962d028) || last instanceof (0, $0d7ea5a8bdacfb09$export$48b9f0688962d028)) {
                this.optimize();
                return;
            }
            const ref = last.children.head instanceof (0, $e5579ce91e3096b0$export$2e2bcd8739ae039) ? null : last.children.head;
            // @ts-expect-error
            first.moveChildren(last, ref);
            // @ts-expect-error
            first.remove();
        }
        this.optimize();
    }
    enable() {
        let enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.domNode.setAttribute('contenteditable', enabled ? 'true' : 'false');
    }
    formatAt(index, length, format, value) {
        super.formatAt(index, length, format, value);
        this.optimize();
    }
    insertAt(index, value, def) {
        if (index >= this.length()) {
            if (def == null || this.scroll.query(value, (0, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214).BLOCK) == null) {
                const blot = this.scroll.create(this.statics.defaultChild.blotName);
                this.appendChild(blot);
                if (def == null && value.endsWith('\n')) blot.insertAt(0, value.slice(0, -1), def);
                else blot.insertAt(0, value, def);
            } else {
                const embed = this.scroll.create(value, def);
                this.appendChild(embed);
            }
        } else super.insertAt(index, value, def);
        this.optimize();
    }
    insertBefore(blot, ref) {
        if (blot.statics.scope === (0, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214).INLINE_BLOT) {
            const wrapper = this.scroll.create(this.statics.defaultChild.blotName);
            wrapper.appendChild(blot);
            super.insertBefore(wrapper, ref);
        } else super.insertBefore(blot, ref);
    }
    insertContents(index, delta) {
        const renderBlocks = this.deltaToRenderBlocks(delta.concat(new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().insert('\n')));
        const last = renderBlocks.pop();
        if (last == null) return;
        this.batchStart();
        const first = renderBlocks.shift();
        if (first) {
            const shouldInsertNewlineChar = first.type === 'block' && (first.delta.length() === 0 || !this.descendant((0, $0d7ea5a8bdacfb09$export$48b9f0688962d028), index)[0] && index < this.length());
            const delta = first.type === 'block' ? first.delta : new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().insert({
                [first.key]: first.value
            });
            $bebd5b95c8bd05a9$var$insertInlineContents(this, index, delta);
            const newlineCharLength = first.type === 'block' ? 1 : 0;
            const lineEndIndex = index + delta.length() + newlineCharLength;
            if (shouldInsertNewlineChar) this.insertAt(lineEndIndex - 1, '\n');
            const formats = (0, $0d7ea5a8bdacfb09$export$e4bb5a6163449612)(this.line(index)[0]);
            const attributes = (0, $b0994a93e93413e9$exports.AttributeMap).diff(formats, first.attributes) || {};
            Object.keys(attributes).forEach((name)=>{
                this.formatAt(lineEndIndex - 1, 1, name, attributes[name]);
            });
            index = lineEndIndex;
        }
        let [refBlot, refBlotOffset] = this.children.find(index);
        if (renderBlocks.length) {
            if (refBlot) {
                refBlot = refBlot.split(refBlotOffset);
                refBlotOffset = 0;
            }
            renderBlocks.forEach((renderBlock)=>{
                if (renderBlock.type === 'block') {
                    const block = this.createBlock(renderBlock.attributes, refBlot || undefined);
                    $bebd5b95c8bd05a9$var$insertInlineContents(block, 0, renderBlock.delta);
                } else {
                    const blockEmbed = this.create(renderBlock.key, renderBlock.value);
                    this.insertBefore(blockEmbed, refBlot || undefined);
                    Object.keys(renderBlock.attributes).forEach((name)=>{
                        blockEmbed.format(name, renderBlock.attributes[name]);
                    });
                }
            });
        }
        if (last.type === 'block' && last.delta.length()) {
            const offset = refBlot ? refBlot.offset(refBlot.scroll) + refBlotOffset : this.length();
            $bebd5b95c8bd05a9$var$insertInlineContents(this, offset, last.delta);
        }
        this.batchEnd();
        this.optimize();
    }
    isEnabled() {
        return this.domNode.getAttribute('contenteditable') === 'true';
    }
    leaf(index) {
        const last = this.path(index).pop();
        if (!last) return [
            null,
            -1
        ];
        const [blot, offset] = last;
        return blot instanceof (0, $e9fc1a5fcc0c5a1a$export$7420b9c542181544) ? [
            blot,
            offset
        ] : [
            null,
            -1
        ];
    }
    line(index) {
        if (index === this.length()) return this.line(index - 1);
        // @ts-expect-error TODO: make descendant() generic
        return this.descendant($bebd5b95c8bd05a9$var$isLine, index);
    }
    lines() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
        const getLines = (blot, blotIndex, blotLength)=>{
            let lines = [];
            let lengthLeft = blotLength;
            blot.children.forEachAt(blotIndex, blotLength, (child, childIndex, childLength)=>{
                if ($bebd5b95c8bd05a9$var$isLine(child)) lines.push(child);
                else if (child instanceof (0, $e9fc1a5fcc0c5a1a$export$c898d510319704c0)) lines = lines.concat(getLines(child, childIndex, lengthLeft));
                lengthLeft -= childLength;
            });
            return lines;
        };
        return getLines(this, index, length);
    }
    optimize() {
        let mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.batch) return;
        super.optimize(mutations, context);
        if (mutations.length > 0) this.emitter.emit((0, $ba29015e3d87cf52$export$2e2bcd8739ae039).events.SCROLL_OPTIMIZE, mutations, context);
    }
    path(index) {
        return super.path(index).slice(1); // Exclude self
    }
    remove() {
    // Never remove self
    }
    update(mutations) {
        if (this.batch) {
            if (Array.isArray(mutations)) this.batch = this.batch.concat(mutations);
            return;
        }
        let source = (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.USER;
        if (typeof mutations === 'string') source = mutations;
        if (!Array.isArray(mutations)) mutations = this.observer.takeRecords();
        mutations = mutations.filter((_ref2)=>{
            let { target: target } = _ref2;
            const blot = this.find(target, true);
            return blot && !$bebd5b95c8bd05a9$var$isUpdatable(blot);
        });
        if (mutations.length > 0) this.emitter.emit((0, $ba29015e3d87cf52$export$2e2bcd8739ae039).events.SCROLL_BEFORE_UPDATE, source, mutations);
        super.update(mutations.concat([])); // pass copy
        if (mutations.length > 0) this.emitter.emit((0, $ba29015e3d87cf52$export$2e2bcd8739ae039).events.SCROLL_UPDATE, source, mutations);
    }
    updateEmbedAt(index, key, change) {
        // Currently it only supports top-level embeds (BlockEmbed).
        // We can update `ParentBlot` in parchment to support inline embeds.
        const [blot] = this.descendant((b)=>b instanceof (0, $0d7ea5a8bdacfb09$export$48b9f0688962d028), index);
        if (blot && blot.statics.blotName === key && $bebd5b95c8bd05a9$var$isUpdatable(blot)) blot.updateContent(change);
    }
    handleDragStart(event) {
        event.preventDefault();
    }
    deltaToRenderBlocks(delta) {
        const renderBlocks = [];
        let currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))();
        delta.forEach((op)=>{
            const insert = op?.insert;
            if (!insert) return;
            if (typeof insert === 'string') {
                const splitted = insert.split('\n');
                splitted.slice(0, -1).forEach((text)=>{
                    currentBlockDelta.insert(text, op.attributes);
                    renderBlocks.push({
                        type: 'block',
                        delta: currentBlockDelta,
                        attributes: op.attributes ?? {}
                    });
                    currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))();
                });
                const last = splitted[splitted.length - 1];
                if (last) currentBlockDelta.insert(last, op.attributes);
            } else {
                const key = Object.keys(insert)[0];
                if (!key) return;
                if (this.query(key, (0, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214).INLINE)) currentBlockDelta.push(op);
                else {
                    if (currentBlockDelta.length()) renderBlocks.push({
                        type: 'block',
                        delta: currentBlockDelta,
                        attributes: {}
                    });
                    currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))();
                    renderBlocks.push({
                        type: 'blockEmbed',
                        key: key,
                        value: insert[key],
                        attributes: op.attributes ?? {}
                    });
                }
            }
        });
        if (currentBlockDelta.length()) renderBlocks.push({
            type: 'block',
            delta: currentBlockDelta,
            attributes: {}
        });
        return renderBlocks;
    }
    createBlock(attributes, refBlot) {
        let blotName;
        const formats = {};
        Object.entries(attributes).forEach((_ref3)=>{
            let [key, value] = _ref3;
            const isBlockBlot = this.query(key, (0, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214).BLOCK & (0, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214).BLOT) != null;
            if (isBlockBlot) blotName = key;
            else formats[key] = value;
        });
        const block = this.create(blotName || this.statics.defaultChild.blotName, blotName ? attributes[blotName] : undefined);
        this.insertBefore(block, refBlot || undefined);
        const length = block.length();
        Object.entries(formats).forEach((_ref4)=>{
            let [key, value] = _ref4;
            block.formatAt(0, length, key, value);
        });
        return block;
    }
}
function $bebd5b95c8bd05a9$var$insertInlineContents(parent, index, inlineContents) {
    inlineContents.reduce((index, op)=>{
        const length = (0, $b0994a93e93413e9$exports.Op).length(op);
        let attributes = op.attributes || {};
        if (op.insert != null) {
            if (typeof op.insert === 'string') {
                const text = op.insert;
                parent.insertAt(index, text);
                const [leaf] = parent.descendant((0, $e9fc1a5fcc0c5a1a$export$7420b9c542181544), index);
                const formats = (0, $0d7ea5a8bdacfb09$export$e4bb5a6163449612)(leaf);
                attributes = (0, $b0994a93e93413e9$exports.AttributeMap).diff(formats, attributes) || {};
            } else if (typeof op.insert === 'object') {
                const key = Object.keys(op.insert)[0]; // There should only be one key
                if (key == null) return index;
                parent.insertAt(index, key, op.insert[key]);
                const isInlineEmbed = parent.scroll.query(key, (0, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214).INLINE) != null;
                if (isInlineEmbed) {
                    const [leaf] = parent.descendant((0, $e9fc1a5fcc0c5a1a$export$7420b9c542181544), index);
                    const formats = (0, $0d7ea5a8bdacfb09$export$e4bb5a6163449612)(leaf);
                    attributes = (0, $b0994a93e93413e9$exports.AttributeMap).diff(formats, attributes) || {};
                }
            }
        }
        Object.keys(attributes).forEach((key)=>{
            parent.formatAt(index, length, key, attributes[key]);
        });
        return index + length;
    }, index);
}
var $bebd5b95c8bd05a9$export$2e2bcd8739ae039 = $bebd5b95c8bd05a9$var$Scroll;










const $7bbd20231ffd3fe4$var$config = {
    scope: (0, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214).BLOCK,
    whitelist: [
        'right',
        'center',
        'justify'
    ]
};
const $7bbd20231ffd3fe4$export$2ef0f9fb04a51388 = new (0, $e9fc1a5fcc0c5a1a$export$217610c4183502d0)('align', 'align', $7bbd20231ffd3fe4$var$config);
const $7bbd20231ffd3fe4$export$7f3685f5846c07da = new (0, $e9fc1a5fcc0c5a1a$export$651d45509677cf07)('align', 'ql-align', $7bbd20231ffd3fe4$var$config);
const $7bbd20231ffd3fe4$export$d2060f5d114c9fe8 = new (0, $e9fc1a5fcc0c5a1a$export$7c8099bbfe87b94d)('align', 'text-align', $7bbd20231ffd3fe4$var$config);




class $7fcf066ad76fb835$export$c992e3369f248f6e extends (0, $e9fc1a5fcc0c5a1a$export$7c8099bbfe87b94d) {
    value(domNode) {
        let value = super.value(domNode);
        if (!value.startsWith('rgb(')) return value;
        value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
        const hex = value.split(',').map((component)=>`00${parseInt(component, 10).toString(16)}`.slice(-2)).join('');
        return `#${hex}`;
    }
}
const $7fcf066ad76fb835$export$42795dcf0ec6f3c8 = new (0, $e9fc1a5fcc0c5a1a$export$651d45509677cf07)('color', 'ql-color', {
    scope: (0, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214).INLINE
});
const $7fcf066ad76fb835$export$1415f56796d9a5a9 = new $7fcf066ad76fb835$export$c992e3369f248f6e('color', 'color', {
    scope: (0, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214).INLINE
});


const $190265f2765c8959$export$8aa96c8963152b12 = new (0, $e9fc1a5fcc0c5a1a$export$651d45509677cf07)('background', 'ql-bg', {
    scope: (0, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214).INLINE
});
const $190265f2765c8959$export$dc1cbcab4c682ef = new (0, $7fcf066ad76fb835$export$c992e3369f248f6e)('background', 'background-color', {
    scope: (0, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214).INLINE
});









class $9751ae0c93fde05d$export$3b131632d3d15165 extends (0, $bbaa9603c8327354$export$2e2bcd8739ae039) {
    static create(value) {
        const domNode = super.create(value);
        domNode.setAttribute('spellcheck', 'false');
        return domNode;
    }
    code(index, length) {
        return this.children// @ts-expect-error
        .map((child)=>child.length() <= 1 ? '' : child.domNode.innerText).join('\n').slice(index, index + length);
    }
    html(index, length) {
        // `\n`s are needed in order to support empty lines at the beginning and the end.
        // https://html.spec.whatwg.org/multipage/syntax.html#element-restrictions
        return `<pre>\n${(0, $b5feff51aa4dee9f$export$96e6fc3a139b2555)(this.code(index, length))}\n</pre>`;
    }
}
class $9751ae0c93fde05d$export$2e2bcd8739ae039 extends (0, $0d7ea5a8bdacfb09$export$2e2bcd8739ae039) {
    static TAB = '  ';
    static register() {
        (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).register($9751ae0c93fde05d$export$3b131632d3d15165);
    }
}
class $9751ae0c93fde05d$export$52f0f02147b12c03 extends (0, $f5f023af83746731$export$2e2bcd8739ae039) {
}
$9751ae0c93fde05d$export$52f0f02147b12c03.blotName = 'code';
$9751ae0c93fde05d$export$52f0f02147b12c03.tagName = 'CODE';
$9751ae0c93fde05d$export$2e2bcd8739ae039.blotName = 'code-block';
$9751ae0c93fde05d$export$2e2bcd8739ae039.className = 'ql-code-block';
$9751ae0c93fde05d$export$2e2bcd8739ae039.tagName = 'DIV';
$9751ae0c93fde05d$export$3b131632d3d15165.blotName = 'code-block-container';
$9751ae0c93fde05d$export$3b131632d3d15165.className = 'ql-code-block-container';
$9751ae0c93fde05d$export$3b131632d3d15165.tagName = 'DIV';
$9751ae0c93fde05d$export$3b131632d3d15165.allowedChildren = [
    $9751ae0c93fde05d$export$2e2bcd8739ae039
];
$9751ae0c93fde05d$export$2e2bcd8739ae039.allowedChildren = [
    (0, $b5feff51aa4dee9f$export$2e2bcd8739ae039),
    (0, $e5579ce91e3096b0$export$2e2bcd8739ae039),
    (0, $fa8ee3ba40bbf9de$export$2e2bcd8739ae039)
];
$9751ae0c93fde05d$export$2e2bcd8739ae039.requiredContainer = $9751ae0c93fde05d$export$3b131632d3d15165;




const $41d2f21a51fc0de9$var$config = {
    scope: (0, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214).BLOCK,
    whitelist: [
        'rtl'
    ]
};
const $41d2f21a51fc0de9$export$4158215dafad9efa = new (0, $e9fc1a5fcc0c5a1a$export$217610c4183502d0)('direction', 'dir', $41d2f21a51fc0de9$var$config);
const $41d2f21a51fc0de9$export$630028b3af294dec = new (0, $e9fc1a5fcc0c5a1a$export$651d45509677cf07)('direction', 'ql-direction', $41d2f21a51fc0de9$var$config);
const $41d2f21a51fc0de9$export$175979e518d1dfd1 = new (0, $e9fc1a5fcc0c5a1a$export$7c8099bbfe87b94d)('direction', 'direction', $41d2f21a51fc0de9$var$config);



const $42d0307cd7072280$var$config = {
    scope: (0, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214).INLINE,
    whitelist: [
        'serif',
        'monospace'
    ]
};
const $42d0307cd7072280$export$78a99ee601572ab = new (0, $e9fc1a5fcc0c5a1a$export$651d45509677cf07)('font', 'ql-font', $42d0307cd7072280$var$config);
class $42d0307cd7072280$var$FontStyleAttributor extends (0, $e9fc1a5fcc0c5a1a$export$7c8099bbfe87b94d) {
    value(node) {
        return super.value(node).replace(/["']/g, '');
    }
}
const $42d0307cd7072280$export$23b468d4ca3f8c96 = new $42d0307cd7072280$var$FontStyleAttributor('font', 'font-family', $42d0307cd7072280$var$config);



const $83686b6faef4e652$export$c84684d52bca9684 = new (0, $e9fc1a5fcc0c5a1a$export$651d45509677cf07)('size', 'ql-size', {
    scope: (0, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214).INLINE,
    whitelist: [
        'small',
        'large',
        'huge'
    ]
});
const $83686b6faef4e652$export$5443b95a30e89ac5 = new (0, $e9fc1a5fcc0c5a1a$export$7c8099bbfe87b94d)('size', 'font-size', {
    scope: (0, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214).INLINE,
    whitelist: [
        '10px',
        '18px',
        '32px'
    ]
});








const $64631a418ea76ef4$var$debug = (0, $7ec5affce32db05e$export$2e2bcd8739ae039)('quill:keyboard');
const $64631a418ea76ef4$export$34a157fc58f3dd07 = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';
class $64631a418ea76ef4$export$2e2bcd8739ae039 extends (0, $ec73c86348f00d5d$export$2e2bcd8739ae039) {
    static match(evt, binding) {
        if ([
            'altKey',
            'ctrlKey',
            'metaKey',
            'shiftKey'
        ].some((key)=>{
            return !!binding[key] !== evt[key] && binding[key] !== null;
        })) return false;
        return binding.key === evt.key || binding.key === evt.which;
    }
    constructor(quill, options){
        super(quill, options);
        this.bindings = {};
        // @ts-expect-error Fix me later
        Object.keys(this.options.bindings).forEach((name)=>{
            // @ts-expect-error Fix me later
            if (this.options.bindings[name]) // @ts-expect-error Fix me later
            this.addBinding(this.options.bindings[name]);
        });
        this.addBinding({
            key: 'Enter',
            shiftKey: null
        }, this.handleEnter);
        this.addBinding({
            key: 'Enter',
            metaKey: null,
            ctrlKey: null,
            altKey: null
        }, ()=>{});
        if (/Firefox/i.test(navigator.userAgent)) {
            // Need to handle delete and backspace for Firefox in the general case #1171
            this.addBinding({
                key: 'Backspace'
            }, {
                collapsed: true
            }, this.handleBackspace);
            this.addBinding({
                key: 'Delete'
            }, {
                collapsed: true
            }, this.handleDelete);
        } else {
            this.addBinding({
                key: 'Backspace'
            }, {
                collapsed: true,
                prefix: /^.?$/
            }, this.handleBackspace);
            this.addBinding({
                key: 'Delete'
            }, {
                collapsed: true,
                suffix: /^.?$/
            }, this.handleDelete);
        }
        this.addBinding({
            key: 'Backspace'
        }, {
            collapsed: false
        }, this.handleDeleteRange);
        this.addBinding({
            key: 'Delete'
        }, {
            collapsed: false
        }, this.handleDeleteRange);
        this.addBinding({
            key: 'Backspace',
            altKey: null,
            ctrlKey: null,
            metaKey: null,
            shiftKey: null
        }, {
            collapsed: true,
            offset: 0
        }, this.handleBackspace);
        this.listen();
    }
    addBinding(keyBinding) {
        let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const binding = $64631a418ea76ef4$export$a3295358bff77e(keyBinding);
        if (binding == null) {
            $64631a418ea76ef4$var$debug.warn('Attempted to add invalid keyboard binding', binding);
            return;
        }
        if (typeof context === 'function') context = {
            handler: context
        };
        if (typeof handler === 'function') handler = {
            handler: handler
        };
        const keys = Array.isArray(binding.key) ? binding.key : [
            binding.key
        ];
        keys.forEach((key)=>{
            const singleBinding = {
                ...binding,
                key: key,
                ...context,
                ...handler
            };
            this.bindings[singleBinding.key] = this.bindings[singleBinding.key] || [];
            this.bindings[singleBinding.key].push(singleBinding);
        });
    }
    listen() {
        this.quill.root.addEventListener('keydown', (evt)=>{
            if (evt.defaultPrevented || evt.isComposing) return;
            // evt.isComposing is false when pressing Enter/Backspace when composing in Safari
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            const isComposing = evt.keyCode === 229 && (evt.key === 'Enter' || evt.key === 'Backspace');
            if (isComposing) return;
            const bindings = (this.bindings[evt.key] || []).concat(this.bindings[evt.which] || []);
            const matches = bindings.filter((binding)=>$64631a418ea76ef4$export$2e2bcd8739ae039.match(evt, binding));
            if (matches.length === 0) return;
            // @ts-expect-error
            const blot = (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).find(evt.target, true);
            if (blot && blot.scroll !== this.quill.scroll) return;
            const range = this.quill.getSelection();
            if (range == null || !this.quill.hasFocus()) return;
            const [line, offset] = this.quill.getLine(range.index);
            const [leafStart, offsetStart] = this.quill.getLeaf(range.index);
            const [leafEnd, offsetEnd] = range.length === 0 ? [
                leafStart,
                offsetStart
            ] : this.quill.getLeaf(range.index + range.length);
            const prefixText = leafStart instanceof (0, $e9fc1a5fcc0c5a1a$export$10ac0c5716409de6) ? leafStart.value().slice(0, offsetStart) : '';
            const suffixText = leafEnd instanceof (0, $e9fc1a5fcc0c5a1a$export$10ac0c5716409de6) ? leafEnd.value().slice(offsetEnd) : '';
            const curContext = {
                collapsed: range.length === 0,
                // @ts-expect-error Fix me later
                empty: range.length === 0 && line.length() <= 1,
                format: this.quill.getFormat(range),
                line: line,
                offset: offset,
                prefix: prefixText,
                suffix: suffixText,
                event: evt
            };
            const prevented = matches.some((binding)=>{
                if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
                if (binding.empty != null && binding.empty !== curContext.empty) return false;
                if (binding.offset != null && binding.offset !== curContext.offset) return false;
                if (Array.isArray(binding.format)) {
                    // any format is present
                    if (binding.format.every((name)=>curContext.format[name] == null)) return false;
                } else if (typeof binding.format === 'object') {
                    // all formats must match
                    if (!Object.keys(binding.format).every((name)=>{
                        // @ts-expect-error Fix me later
                        if (binding.format[name] === true) return curContext.format[name] != null;
                        // @ts-expect-error Fix me later
                        if (binding.format[name] === false) return curContext.format[name] == null;
                        // @ts-expect-error Fix me later
                        return (0, $ee28b6e7df1b1693$export$2e2bcd8739ae039)(binding.format[name], curContext.format[name]);
                    })) return false;
                }
                if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
                if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
                // @ts-expect-error Fix me later
                return binding.handler.call(this, range, curContext, binding) !== true;
            });
            if (prevented) evt.preventDefault();
        });
    }
    handleBackspace(range, context) {
        // Check for astral symbols
        const length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
        if (range.index === 0 || this.quill.getLength() <= 1) return;
        let formats = {};
        const [line] = this.quill.getLine(range.index);
        let delta = new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().retain(range.index - length).delete(length);
        if (context.offset === 0) {
            // Always deleting newline here, length always 1
            const [prev] = this.quill.getLine(range.index - 1);
            if (prev) {
                const isPrevLineEmpty = prev.statics.blotName === 'block' && prev.length() <= 1;
                if (!isPrevLineEmpty) {
                    // @ts-expect-error Fix me later
                    const curFormats = line.formats();
                    const prevFormats = this.quill.getFormat(range.index - 1, 1);
                    formats = (0, $b0994a93e93413e9$exports.AttributeMap).diff(curFormats, prevFormats) || {};
                    if (Object.keys(formats).length > 0) {
                        // line.length() - 1 targets \n in line, another -1 for newline being deleted
                        const formatDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))()// @ts-expect-error Fix me later
                        .retain(range.index + line.length() - 2).retain(1, formats);
                        delta = delta.compose(formatDelta);
                    }
                }
            }
        }
        this.quill.updateContents(delta, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
        this.quill.focus();
    }
    handleDelete(range, context) {
        // Check for astral symbols
        const length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
        if (range.index >= this.quill.getLength() - length) return;
        let formats = {};
        const [line] = this.quill.getLine(range.index);
        let delta = new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().retain(range.index).delete(length);
        // @ts-expect-error Fix me later
        if (context.offset >= line.length() - 1) {
            const [next] = this.quill.getLine(range.index + 1);
            if (next) {
                // @ts-expect-error Fix me later
                const curFormats = line.formats();
                const nextFormats = this.quill.getFormat(range.index, 1);
                formats = (0, $b0994a93e93413e9$exports.AttributeMap).diff(curFormats, nextFormats) || {};
                if (Object.keys(formats).length > 0) delta = delta.retain(next.length() - 1).retain(1, formats);
            }
        }
        this.quill.updateContents(delta, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
        this.quill.focus();
    }
    handleDeleteRange(range) {
        $64631a418ea76ef4$export$a6c813797f379898({
            range: range,
            quill: this.quill
        });
        this.quill.focus();
    }
    handleEnter(range, context) {
        const lineFormats = Object.keys(context.format).reduce((formats, format)=>{
            if (this.quill.scroll.query(format, (0, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214).BLOCK) && !Array.isArray(context.format[format])) formats[format] = context.format[format];
            return formats;
        }, {});
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().retain(range.index).delete(range.length).insert('\n', lineFormats);
        this.quill.updateContents(delta, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
        this.quill.setSelection(range.index + 1, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.SILENT);
        this.quill.focus();
    }
}
const $64631a418ea76ef4$var$defaultOptions = {
    bindings: {
        bold: $64631a418ea76ef4$var$makeFormatHandler('bold'),
        italic: $64631a418ea76ef4$var$makeFormatHandler('italic'),
        underline: $64631a418ea76ef4$var$makeFormatHandler('underline'),
        indent: {
            // highlight tab or tab at beginning of list, indent or blockquote
            key: 'Tab',
            format: [
                'blockquote',
                'indent',
                'list'
            ],
            handler (range, context) {
                if (context.collapsed && context.offset !== 0) return true;
                this.quill.format('indent', '+1', (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
                return false;
            }
        },
        outdent: {
            key: 'Tab',
            shiftKey: true,
            format: [
                'blockquote',
                'indent',
                'list'
            ],
            // highlight tab or tab at beginning of list, indent or blockquote
            handler (range, context) {
                if (context.collapsed && context.offset !== 0) return true;
                this.quill.format('indent', '-1', (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
                return false;
            }
        },
        'outdent backspace': {
            key: 'Backspace',
            collapsed: true,
            shiftKey: null,
            metaKey: null,
            ctrlKey: null,
            altKey: null,
            format: [
                'indent',
                'list'
            ],
            offset: 0,
            handler (range, context) {
                if (context.format.indent != null) this.quill.format('indent', '-1', (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
                else if (context.format.list != null) this.quill.format('list', false, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
            }
        },
        'indent code-block': $64631a418ea76ef4$var$makeCodeBlockHandler(true),
        'outdent code-block': $64631a418ea76ef4$var$makeCodeBlockHandler(false),
        'remove tab': {
            key: 'Tab',
            shiftKey: true,
            collapsed: true,
            prefix: /\t$/,
            handler (range) {
                this.quill.deleteText(range.index - 1, 1, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
            }
        },
        tab: {
            key: 'Tab',
            handler (range, context) {
                if (context.format.table) return true;
                this.quill.history.cutoff();
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().retain(range.index).delete(range.length).insert('\t');
                this.quill.updateContents(delta, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
                this.quill.history.cutoff();
                this.quill.setSelection(range.index + 1, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.SILENT);
                return false;
            }
        },
        'blockquote empty enter': {
            key: 'Enter',
            collapsed: true,
            format: [
                'blockquote'
            ],
            empty: true,
            handler () {
                this.quill.format('blockquote', false, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
            }
        },
        'list empty enter': {
            key: 'Enter',
            collapsed: true,
            format: [
                'list'
            ],
            empty: true,
            handler (range, context) {
                const formats = {
                    list: false
                };
                if (context.format.indent) formats.indent = false;
                this.quill.formatLine(range.index, range.length, formats, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
            }
        },
        'checklist enter': {
            key: 'Enter',
            collapsed: true,
            format: {
                list: 'checked'
            },
            handler (range) {
                const [line, offset] = this.quill.getLine(range.index);
                const formats = {
                    // @ts-expect-error Fix me later
                    ...line.formats(),
                    list: 'checked'
                };
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().retain(range.index).insert('\n', formats)// @ts-expect-error Fix me later
                .retain(line.length() - offset - 1).retain(1, {
                    list: 'unchecked'
                });
                this.quill.updateContents(delta, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
                this.quill.setSelection(range.index + 1, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.SILENT);
                this.quill.scrollSelectionIntoView();
            }
        },
        'header enter': {
            key: 'Enter',
            collapsed: true,
            format: [
                'header'
            ],
            suffix: /^$/,
            handler (range, context) {
                const [line, offset] = this.quill.getLine(range.index);
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().retain(range.index).insert('\n', context.format)// @ts-expect-error Fix me later
                .retain(line.length() - offset - 1).retain(1, {
                    header: null
                });
                this.quill.updateContents(delta, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
                this.quill.setSelection(range.index + 1, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.SILENT);
                this.quill.scrollSelectionIntoView();
            }
        },
        'table backspace': {
            key: 'Backspace',
            format: [
                'table'
            ],
            collapsed: true,
            offset: 0,
            handler () {}
        },
        'table delete': {
            key: 'Delete',
            format: [
                'table'
            ],
            collapsed: true,
            suffix: /^$/,
            handler () {}
        },
        'table enter': {
            key: 'Enter',
            shiftKey: null,
            format: [
                'table'
            ],
            handler (range) {
                const module = this.quill.getModule('table');
                if (module) {
                    // @ts-expect-error
                    const [table, row, cell, offset] = module.getTable(range);
                    const shift = $64631a418ea76ef4$var$tableSide(table, row, cell, offset);
                    if (shift == null) return;
                    let index = table.offset();
                    if (shift < 0) {
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().retain(index).insert('\n');
                        this.quill.updateContents(delta, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
                        this.quill.setSelection(range.index + 1, range.length, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.SILENT);
                    } else if (shift > 0) {
                        index += table.length();
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().retain(index).insert('\n');
                        this.quill.updateContents(delta, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
                        this.quill.setSelection(index, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
                    }
                }
            }
        },
        'table tab': {
            key: 'Tab',
            shiftKey: null,
            format: [
                'table'
            ],
            handler (range, context) {
                const { event: event, line: cell } = context;
                const offset = cell.offset(this.quill.scroll);
                if (event.shiftKey) this.quill.setSelection(offset - 1, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
                else this.quill.setSelection(offset + cell.length(), (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
            }
        },
        'list autofill': {
            key: ' ',
            shiftKey: null,
            collapsed: true,
            format: {
                'code-block': false,
                blockquote: false,
                table: false
            },
            prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
            handler (range, context) {
                if (this.quill.scroll.query('list') == null) return true;
                const { length: length } = context.prefix;
                const [line, offset] = this.quill.getLine(range.index);
                if (offset > length) return true;
                let value;
                switch(context.prefix.trim()){
                    case '[]':
                    case '[ ]':
                        value = 'unchecked';
                        break;
                    case '[x]':
                        value = 'checked';
                        break;
                    case '-':
                    case '*':
                        value = 'bullet';
                        break;
                    default:
                        value = 'ordered';
                }
                this.quill.insertText(range.index, ' ', (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
                this.quill.history.cutoff();
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().retain(range.index - offset).delete(length + 1)// @ts-expect-error Fix me later
                .retain(line.length() - 2 - offset).retain(1, {
                    list: value
                });
                this.quill.updateContents(delta, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
                this.quill.history.cutoff();
                this.quill.setSelection(range.index - length, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.SILENT);
                return false;
            }
        },
        'code exit': {
            key: 'Enter',
            collapsed: true,
            format: [
                'code-block'
            ],
            prefix: /^$/,
            suffix: /^\s*$/,
            handler (range) {
                const [line, offset] = this.quill.getLine(range.index);
                let numLines = 2;
                let cur = line;
                while(cur != null && cur.length() <= 1 && cur.formats()['code-block']){
                    // @ts-expect-error
                    cur = cur.prev;
                    numLines -= 1;
                    // Requisite prev lines are empty
                    if (numLines <= 0) {
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))()// @ts-expect-error Fix me later
                        .retain(range.index + line.length() - offset - 2).retain(1, {
                            'code-block': null
                        }).delete(1);
                        this.quill.updateContents(delta, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
                        this.quill.setSelection(range.index - 1, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.SILENT);
                        return false;
                    }
                }
                return true;
            }
        },
        'embed left': $64631a418ea76ef4$var$makeEmbedArrowHandler('ArrowLeft', false),
        'embed left shift': $64631a418ea76ef4$var$makeEmbedArrowHandler('ArrowLeft', true),
        'embed right': $64631a418ea76ef4$var$makeEmbedArrowHandler('ArrowRight', false),
        'embed right shift': $64631a418ea76ef4$var$makeEmbedArrowHandler('ArrowRight', true),
        'table down': $64631a418ea76ef4$var$makeTableArrowHandler(false),
        'table up': $64631a418ea76ef4$var$makeTableArrowHandler(true)
    }
};
$64631a418ea76ef4$export$2e2bcd8739ae039.DEFAULTS = $64631a418ea76ef4$var$defaultOptions;
function $64631a418ea76ef4$var$makeCodeBlockHandler(indent) {
    return {
        key: 'Tab',
        shiftKey: !indent,
        format: {
            'code-block': true
        },
        handler (range, _ref) {
            let { event: event } = _ref;
            const CodeBlock = this.quill.scroll.query('code-block');
            // @ts-expect-error
            const { TAB: TAB } = CodeBlock;
            if (range.length === 0 && !event.shiftKey) {
                this.quill.insertText(range.index, TAB, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
                this.quill.setSelection(range.index + TAB.length, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.SILENT);
                return;
            }
            const lines = range.length === 0 ? this.quill.getLines(range.index, 1) : this.quill.getLines(range);
            let { index: index, length: length } = range;
            lines.forEach((line, i)=>{
                if (indent) {
                    line.insertAt(0, TAB);
                    if (i === 0) index += TAB.length;
                    else length += TAB.length;
                // @ts-expect-error Fix me later
                } else if (line.domNode.textContent.startsWith(TAB)) {
                    line.deleteAt(0, TAB.length);
                    if (i === 0) index -= TAB.length;
                    else length -= TAB.length;
                }
            });
            this.quill.update((0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
            this.quill.setSelection(index, length, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.SILENT);
        }
    };
}
function $64631a418ea76ef4$var$makeEmbedArrowHandler(key, shiftKey) {
    const where = key === 'ArrowLeft' ? 'prefix' : 'suffix';
    return {
        key: key,
        shiftKey: shiftKey,
        altKey: null,
        [where]: /^$/,
        handler (range) {
            let { index: index } = range;
            if (key === 'ArrowRight') index += range.length + 1;
            const [leaf] = this.quill.getLeaf(index);
            if (!(leaf instanceof (0, $e9fc1a5fcc0c5a1a$export$297a1fa96f55f00f))) return true;
            if (key === 'ArrowLeft') {
                if (shiftKey) this.quill.setSelection(range.index - 1, range.length + 1, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
                else this.quill.setSelection(range.index - 1, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
            } else if (shiftKey) this.quill.setSelection(range.index, range.length + 1, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
            else this.quill.setSelection(range.index + range.length + 1, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
            return false;
        }
    };
}
function $64631a418ea76ef4$var$makeFormatHandler(format) {
    return {
        key: format[0],
        shortKey: true,
        handler (range, context) {
            this.quill.format(format, !context.format[format], (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
        }
    };
}
function $64631a418ea76ef4$var$makeTableArrowHandler(up) {
    return {
        key: up ? 'ArrowUp' : 'ArrowDown',
        collapsed: true,
        format: [
            'table'
        ],
        handler (range, context) {
            // TODO move to table module
            const key = up ? 'prev' : 'next';
            const cell = context.line;
            const targetRow = cell.parent[key];
            if (targetRow != null) {
                if (targetRow.statics.blotName === 'table-row') {
                    // @ts-expect-error
                    let targetCell = targetRow.children.head;
                    let cur = cell;
                    while(cur.prev != null){
                        // @ts-expect-error
                        cur = cur.prev;
                        targetCell = targetCell.next;
                    }
                    const index = targetCell.offset(this.quill.scroll) + Math.min(context.offset, targetCell.length() - 1);
                    this.quill.setSelection(index, 0, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
                }
            } else {
                // @ts-expect-error
                const targetLine = cell.table()[key];
                if (targetLine != null) {
                    if (up) this.quill.setSelection(targetLine.offset(this.quill.scroll) + targetLine.length() - 1, 0, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
                    else this.quill.setSelection(targetLine.offset(this.quill.scroll), 0, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
                }
            }
            return false;
        }
    };
}
function $64631a418ea76ef4$export$a3295358bff77e(binding) {
    if (typeof binding === 'string' || typeof binding === 'number') binding = {
        key: binding
    };
    else if (typeof binding === 'object') binding = (0, $97b34790ff67df55$export$2e2bcd8739ae039)(binding);
    else return null;
    if (binding.shortKey) {
        binding[$64631a418ea76ef4$export$34a157fc58f3dd07] = binding.shortKey;
        delete binding.shortKey;
    }
    return binding;
}
// TODO: Move into quill.ts or editor.ts
function $64631a418ea76ef4$export$a6c813797f379898(_ref2) {
    let { quill: quill, range: range } = _ref2;
    const lines = quill.getLines(range);
    let formats = {};
    if (lines.length > 1) {
        const firstFormats = lines[0].formats();
        const lastFormats = lines[lines.length - 1].formats();
        formats = (0, $b0994a93e93413e9$exports.AttributeMap).diff(lastFormats, firstFormats) || {};
    }
    quill.deleteText(range, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
    if (Object.keys(formats).length > 0) quill.formatLine(range.index, 1, formats, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
    quill.setSelection(range.index, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.SILENT);
}
function $64631a418ea76ef4$var$tableSide(_table, row, cell, offset) {
    if (row.prev == null && row.next == null) {
        if (cell.prev == null && cell.next == null) return offset === 0 ? -1 : 1;
        return cell.prev == null ? -1 : 1;
    }
    if (row.prev == null) return -1;
    if (row.next == null) return 1;
    return null;
}


const $fe2e8d0347192c2e$var$normalWeightRegexp = /font-weight:\s*normal/;
const $fe2e8d0347192c2e$var$blockTagNames = [
    'P',
    'OL',
    'UL'
];
const $fe2e8d0347192c2e$var$isBlockElement = (element)=>{
    return element && $fe2e8d0347192c2e$var$blockTagNames.includes(element.tagName);
};
const $fe2e8d0347192c2e$var$normalizeEmptyLines = (doc)=>{
    Array.from(doc.querySelectorAll('br')).filter((br)=>$fe2e8d0347192c2e$var$isBlockElement(br.previousElementSibling) && $fe2e8d0347192c2e$var$isBlockElement(br.nextElementSibling)).forEach((br)=>{
        br.parentNode?.removeChild(br);
    });
};
const $fe2e8d0347192c2e$var$normalizeFontWeight = (doc)=>{
    Array.from(doc.querySelectorAll('b[style*="font-weight"]')).filter((node)=>node.getAttribute('style')?.match($fe2e8d0347192c2e$var$normalWeightRegexp)).forEach((node)=>{
        const fragment = doc.createDocumentFragment();
        fragment.append(...node.childNodes);
        node.parentNode?.replaceChild(fragment, node);
    });
};
function $fe2e8d0347192c2e$export$2e2bcd8739ae039(doc) {
    if (doc.querySelector('[id^="docs-internal-guid-"]')) {
        $fe2e8d0347192c2e$var$normalizeFontWeight(doc);
        $fe2e8d0347192c2e$var$normalizeEmptyLines(doc);
    }
}


const $e5fc6560ec2c5ab9$var$ignoreRegexp = /\bmso-list:[^;]*ignore/i;
const $e5fc6560ec2c5ab9$var$idRegexp = /\bmso-list:[^;]*\bl(\d+)/i;
const $e5fc6560ec2c5ab9$var$indentRegexp = /\bmso-list:[^;]*\blevel(\d+)/i;
const $e5fc6560ec2c5ab9$var$parseListItem = (element, html)=>{
    const style = element.getAttribute('style');
    const idMatch = style?.match($e5fc6560ec2c5ab9$var$idRegexp);
    if (!idMatch) return null;
    const id = Number(idMatch[1]);
    const indentMatch = style?.match($e5fc6560ec2c5ab9$var$indentRegexp);
    const indent = indentMatch ? Number(indentMatch[1]) : 1;
    const typeRegexp = new RegExp(`@list l${id}:level${indent}\\s*\\{[^\\}]*mso-level-number-format:\\s*([\\w-]+)`, 'i');
    const typeMatch = html.match(typeRegexp);
    const type = typeMatch && typeMatch[1] === 'bullet' ? 'bullet' : 'ordered';
    return {
        id: id,
        indent: indent,
        type: type,
        element: element
    };
};
// list items are represented as `p` tags with styles like `mso-list: l0 level1` where:
// 1. "0" in "l0" means the list item id;
// 2. "1" in "level1" means the indent level, starting from 1.
const $e5fc6560ec2c5ab9$var$normalizeListItem = (doc)=>{
    const msoList = Array.from(doc.querySelectorAll('[style*=mso-list]'));
    const ignored = [];
    const others = [];
    msoList.forEach((node)=>{
        const shouldIgnore = (node.getAttribute('style') || '').match($e5fc6560ec2c5ab9$var$ignoreRegexp);
        if (shouldIgnore) ignored.push(node);
        else others.push(node);
    });
    // Each list item contains a marker wrapped with "mso-list: Ignore".
    ignored.forEach((node)=>node.parentNode?.removeChild(node));
    // The list stype is not defined inline with the tag, instead, it's in the
    // style tag so we need to pass the html as a string.
    const html = doc.documentElement.innerHTML;
    const listItems = others.map((element)=>$e5fc6560ec2c5ab9$var$parseListItem(element, html)).filter((parsed)=>parsed);
    while(listItems.length){
        const childListItems = [];
        let current = listItems.shift();
        // Group continuous items into the same group (aka "ul")
        while(current){
            childListItems.push(current);
            current = listItems.length && listItems[0]?.element === current.element.nextElementSibling && // Different id means the next item doesn't belong to this group.
            listItems[0].id === current.id ? listItems.shift() : null;
        }
        const ul = document.createElement('ul');
        childListItems.forEach((listItem)=>{
            const li = document.createElement('li');
            li.setAttribute('data-list', listItem.type);
            if (listItem.indent > 1) li.setAttribute('class', `ql-indent-${listItem.indent - 1}`);
            li.innerHTML = listItem.element.innerHTML;
            ul.appendChild(li);
        });
        const element = childListItems[0]?.element;
        const { parentNode: parentNode } = element ?? {};
        if (element) parentNode?.replaceChild(ul, element);
        childListItems.slice(1).forEach((_ref)=>{
            let { element: e } = _ref;
            parentNode?.removeChild(e);
        });
    }
};
function $e5fc6560ec2c5ab9$export$2e2bcd8739ae039(doc) {
    if (doc.documentElement.getAttribute('xmlns:w') === 'urn:schemas-microsoft-com:office:word') $e5fc6560ec2c5ab9$var$normalizeListItem(doc);
}


const $988ec164e1707202$var$NORMALIZERS = [
    (0, $e5fc6560ec2c5ab9$export$2e2bcd8739ae039),
    (0, $fe2e8d0347192c2e$export$2e2bcd8739ae039)
];
const $988ec164e1707202$var$normalizeExternalHTML = (doc)=>{
    if (doc.documentElement) $988ec164e1707202$var$NORMALIZERS.forEach((normalize)=>{
        normalize(doc);
    });
};
var $988ec164e1707202$export$2e2bcd8739ae039 = $988ec164e1707202$var$normalizeExternalHTML;


const $8a2e015722259c42$var$debug = (0, $7ec5affce32db05e$export$2e2bcd8739ae039)('quill:clipboard');
const $8a2e015722259c42$var$CLIPBOARD_CONFIG = [
    [
        Node.TEXT_NODE,
        $8a2e015722259c42$export$9b884371b5570711
    ],
    [
        Node.TEXT_NODE,
        $8a2e015722259c42$export$c695b9637111f586
    ],
    [
        'br',
        $8a2e015722259c42$var$matchBreak
    ],
    [
        Node.ELEMENT_NODE,
        $8a2e015722259c42$export$c695b9637111f586
    ],
    [
        Node.ELEMENT_NODE,
        $8a2e015722259c42$export$e9719de873a22c03
    ],
    [
        Node.ELEMENT_NODE,
        $8a2e015722259c42$export$7da59a717dc94488
    ],
    [
        Node.ELEMENT_NODE,
        $8a2e015722259c42$var$matchStyles
    ],
    [
        'li',
        $8a2e015722259c42$var$matchIndent
    ],
    [
        'ol, ul',
        $8a2e015722259c42$var$matchList
    ],
    [
        'pre',
        $8a2e015722259c42$var$matchCodeBlock
    ],
    [
        'tr',
        $8a2e015722259c42$var$matchTable
    ],
    [
        'b',
        $8a2e015722259c42$var$createMatchAlias('bold')
    ],
    [
        'i',
        $8a2e015722259c42$var$createMatchAlias('italic')
    ],
    [
        'strike',
        $8a2e015722259c42$var$createMatchAlias('strike')
    ],
    [
        'style',
        $8a2e015722259c42$var$matchIgnore
    ]
];
const $8a2e015722259c42$var$ATTRIBUTE_ATTRIBUTORS = [
    (0, $7bbd20231ffd3fe4$export$2ef0f9fb04a51388),
    (0, $41d2f21a51fc0de9$export$4158215dafad9efa)
].reduce((memo, attr)=>{
    memo[attr.keyName] = attr;
    return memo;
}, {});
const $8a2e015722259c42$var$STYLE_ATTRIBUTORS = [
    (0, $7bbd20231ffd3fe4$export$d2060f5d114c9fe8),
    (0, $190265f2765c8959$export$dc1cbcab4c682ef),
    (0, $7fcf066ad76fb835$export$1415f56796d9a5a9),
    (0, $41d2f21a51fc0de9$export$175979e518d1dfd1),
    (0, $42d0307cd7072280$export$23b468d4ca3f8c96),
    (0, $83686b6faef4e652$export$5443b95a30e89ac5)
].reduce((memo, attr)=>{
    memo[attr.keyName] = attr;
    return memo;
}, {});
class $8a2e015722259c42$export$2e2bcd8739ae039 extends (0, $ec73c86348f00d5d$export$2e2bcd8739ae039) {
    static DEFAULTS = {
        matchers: []
    };
    constructor(quill, options){
        super(quill, options);
        this.quill.root.addEventListener('copy', (e)=>this.onCaptureCopy(e, false));
        this.quill.root.addEventListener('cut', (e)=>this.onCaptureCopy(e, true));
        this.quill.root.addEventListener('paste', this.onCapturePaste.bind(this));
        this.matchers = [];
        $8a2e015722259c42$var$CLIPBOARD_CONFIG.concat(this.options.matchers ?? []).forEach((_ref)=>{
            let [selector, matcher] = _ref;
            this.addMatcher(selector, matcher);
        });
    }
    addMatcher(selector, matcher) {
        this.matchers.push([
            selector,
            matcher
        ]);
    }
    convert(_ref2) {
        let { html: html, text: text } = _ref2;
        let formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (formats[(0, $9751ae0c93fde05d$export$2e2bcd8739ae039).blotName]) return new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().insert(text || '', {
            [(0, $9751ae0c93fde05d$export$2e2bcd8739ae039).blotName]: formats[(0, $9751ae0c93fde05d$export$2e2bcd8739ae039).blotName]
        });
        if (!html) return new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().insert(text || '', formats);
        const delta = this.convertHTML(html);
        // Remove trailing newline
        if ($8a2e015722259c42$var$deltaEndsWith(delta, '\n') && (delta.ops[delta.ops.length - 1].attributes == null || formats.table)) return delta.compose(new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().retain(delta.length() - 1).delete(1));
        return delta;
    }
    normalizeHTML(doc) {
        (0, $988ec164e1707202$export$2e2bcd8739ae039)(doc);
    }
    convertHTML(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        this.normalizeHTML(doc);
        const container = doc.body;
        const nodeMatches = new WeakMap();
        const [elementMatchers, textMatchers] = this.prepareMatching(container, nodeMatches);
        return $8a2e015722259c42$export$df3f009e3d155b20(this.quill.scroll, container, elementMatchers, textMatchers, nodeMatches);
    }
    dangerouslyPasteHTML(index, html) {
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.API;
        if (typeof index === 'string') {
            const delta = this.convert({
                html: index,
                text: ''
            });
            // @ts-expect-error
            this.quill.setContents(delta, html);
            this.quill.setSelection(0, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.SILENT);
        } else {
            const paste = this.convert({
                html: html,
                text: ''
            });
            this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().retain(index).concat(paste), source);
            this.quill.setSelection(index + paste.length(), (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.SILENT);
        }
    }
    onCaptureCopy(e) {
        let isCut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (e.defaultPrevented) return;
        e.preventDefault();
        const [range] = this.quill.selection.getRange();
        if (range == null) return;
        const { html: html, text: text } = this.onCopy(range, isCut);
        e.clipboardData?.setData('text/plain', text);
        e.clipboardData?.setData('text/html', html);
        if (isCut) (0, $64631a418ea76ef4$export$a6c813797f379898)({
            range: range,
            quill: this.quill
        });
    }
    /*
   * https://www.iana.org/assignments/media-types/text/uri-list
   */ normalizeURIList(urlList) {
        return urlList.split(/\r?\n/)// Ignore all comments
        .filter((url)=>url[0] !== '#').join('\n');
    }
    onCapturePaste(e) {
        if (e.defaultPrevented || !this.quill.isEnabled()) return;
        e.preventDefault();
        const range = this.quill.getSelection(true);
        if (range == null) return;
        const html = e.clipboardData?.getData('text/html');
        let text = e.clipboardData?.getData('text/plain');
        if (!html && !text) {
            const urlList = e.clipboardData?.getData('text/uri-list');
            if (urlList) text = this.normalizeURIList(urlList);
        }
        const files = Array.from(e.clipboardData?.files || []);
        if (!html && files.length > 0) {
            this.quill.uploader.upload(range, files);
            return;
        }
        if (html && files.length > 0) {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            if (doc.body.childElementCount === 1 && doc.body.firstElementChild?.tagName === 'IMG') {
                this.quill.uploader.upload(range, files);
                return;
            }
        }
        this.onPaste(range, {
            html: html,
            text: text
        });
    }
    onCopy(range) {
        const text = this.quill.getText(range);
        const html = this.quill.getSemanticHTML(range);
        return {
            html: html,
            text: text
        };
    }
    onPaste(range, _ref3) {
        let { text: text, html: html } = _ref3;
        const formats = this.quill.getFormat(range.index);
        const pastedDelta = this.convert({
            text: text,
            html: html
        }, formats);
        $8a2e015722259c42$var$debug.log('onPaste', pastedDelta, {
            text: text,
            html: html
        });
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().retain(range.index).delete(range.length).concat(pastedDelta);
        this.quill.updateContents(delta, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
        // range.length contributes to delta.length()
        this.quill.setSelection(delta.length() - range.length, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.SILENT);
        this.quill.scrollSelectionIntoView();
    }
    prepareMatching(container, nodeMatches) {
        const elementMatchers = [];
        const textMatchers = [];
        this.matchers.forEach((pair)=>{
            const [selector, matcher] = pair;
            switch(selector){
                case Node.TEXT_NODE:
                    textMatchers.push(matcher);
                    break;
                case Node.ELEMENT_NODE:
                    elementMatchers.push(matcher);
                    break;
                default:
                    Array.from(container.querySelectorAll(selector)).forEach((node)=>{
                        if (nodeMatches.has(node)) {
                            const matches = nodeMatches.get(node);
                            matches?.push(matcher);
                        } else nodeMatches.set(node, [
                            matcher
                        ]);
                    });
                    break;
            }
        });
        return [
            elementMatchers,
            textMatchers
        ];
    }
}
function $8a2e015722259c42$var$applyFormat(delta, format, value, scroll) {
    if (!scroll.query(format)) return delta;
    return delta.reduce((newDelta, op)=>{
        if (!op.insert) return newDelta;
        if (op.attributes && op.attributes[format]) return newDelta.push(op);
        const formats = value ? {
            [format]: value
        } : {};
        return newDelta.insert(op.insert, {
            ...formats,
            ...op.attributes
        });
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))());
}
function $8a2e015722259c42$var$deltaEndsWith(delta, text) {
    let endText = '';
    for(let i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i // eslint-disable-line no-plusplus
    ){
        const op = delta.ops[i];
        if (typeof op.insert !== 'string') break;
        endText = op.insert + endText;
    }
    return endText.slice(-1 * text.length) === text;
}
function $8a2e015722259c42$var$isLine(node, scroll) {
    if (!(node instanceof Element)) return false;
    const match = scroll.query(node);
    // @ts-expect-error
    if (match && match.prototype instanceof (0, $e9fc1a5fcc0c5a1a$export$297a1fa96f55f00f)) return false;
    return [
        'address',
        'article',
        'blockquote',
        'canvas',
        'dd',
        'div',
        'dl',
        'dt',
        'fieldset',
        'figcaption',
        'figure',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'header',
        'iframe',
        'li',
        'main',
        'nav',
        'ol',
        'output',
        'p',
        'pre',
        'section',
        'table',
        'td',
        'tr',
        'ul',
        'video'
    ].includes(node.tagName.toLowerCase());
}
function $8a2e015722259c42$var$isBetweenInlineElements(node, scroll) {
    return node.previousElementSibling && node.nextElementSibling && !$8a2e015722259c42$var$isLine(node.previousElementSibling, scroll) && !$8a2e015722259c42$var$isLine(node.nextElementSibling, scroll);
}
const $8a2e015722259c42$var$preNodes = new WeakMap();
function $8a2e015722259c42$var$isPre(node) {
    if (node == null) return false;
    if (!$8a2e015722259c42$var$preNodes.has(node)) {
        // @ts-expect-error
        if (node.tagName === 'PRE') $8a2e015722259c42$var$preNodes.set(node, true);
        else $8a2e015722259c42$var$preNodes.set(node, $8a2e015722259c42$var$isPre(node.parentNode));
    }
    return $8a2e015722259c42$var$preNodes.get(node);
}
function $8a2e015722259c42$export$df3f009e3d155b20(scroll, node, elementMatchers, textMatchers, nodeMatches) {
    // Post-order
    if (node.nodeType === node.TEXT_NODE) return textMatchers.reduce((delta, matcher)=>{
        return matcher(node, delta, scroll);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))());
    if (node.nodeType === node.ELEMENT_NODE) return Array.from(node.childNodes || []).reduce((delta, childNode)=>{
        let childrenDelta = $8a2e015722259c42$export$df3f009e3d155b20(scroll, childNode, elementMatchers, textMatchers, nodeMatches);
        if (childNode.nodeType === node.ELEMENT_NODE) {
            childrenDelta = elementMatchers.reduce((reducedDelta, matcher)=>{
                return matcher(childNode, reducedDelta, scroll);
            }, childrenDelta);
            childrenDelta = (nodeMatches.get(childNode) || []).reduce((reducedDelta, matcher)=>{
                return matcher(childNode, reducedDelta, scroll);
            }, childrenDelta);
        }
        return delta.concat(childrenDelta);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))());
    return new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))();
}
function $8a2e015722259c42$var$createMatchAlias(format) {
    return (_node, delta, scroll)=>{
        return $8a2e015722259c42$var$applyFormat(delta, format, true, scroll);
    };
}
function $8a2e015722259c42$export$7da59a717dc94488(node, delta, scroll) {
    const attributes = (0, $e9fc1a5fcc0c5a1a$export$217610c4183502d0).keys(node);
    const classes = (0, $e9fc1a5fcc0c5a1a$export$651d45509677cf07).keys(node);
    const styles = (0, $e9fc1a5fcc0c5a1a$export$7c8099bbfe87b94d).keys(node);
    const formats = {};
    attributes.concat(classes).concat(styles).forEach((name)=>{
        let attr = scroll.query(name, (0, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214).ATTRIBUTE);
        if (attr != null) {
            formats[attr.attrName] = attr.value(node);
            if (formats[attr.attrName]) return;
        }
        attr = $8a2e015722259c42$var$ATTRIBUTE_ATTRIBUTORS[name];
        if (attr != null && (attr.attrName === name || attr.keyName === name)) formats[attr.attrName] = attr.value(node) || undefined;
        attr = $8a2e015722259c42$var$STYLE_ATTRIBUTORS[name];
        if (attr != null && (attr.attrName === name || attr.keyName === name)) {
            attr = $8a2e015722259c42$var$STYLE_ATTRIBUTORS[name];
            formats[attr.attrName] = attr.value(node) || undefined;
        }
    });
    return Object.entries(formats).reduce((newDelta, _ref4)=>{
        let [name, value] = _ref4;
        return $8a2e015722259c42$var$applyFormat(newDelta, name, value, scroll);
    }, delta);
}
function $8a2e015722259c42$export$e9719de873a22c03(node, delta, scroll) {
    const match = scroll.query(node);
    if (match == null) return delta;
    // @ts-expect-error
    if (match.prototype instanceof (0, $e9fc1a5fcc0c5a1a$export$297a1fa96f55f00f)) {
        const embed = {};
        // @ts-expect-error
        const value = match.value(node);
        if (value != null) {
            // @ts-expect-error
            embed[match.blotName] = value;
            // @ts-expect-error
            return new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().insert(embed, match.formats(node, scroll));
        }
    } else {
        // @ts-expect-error
        if (match.prototype instanceof (0, $e9fc1a5fcc0c5a1a$export$4f7f03641f7bfc8c) && !$8a2e015722259c42$var$deltaEndsWith(delta, '\n')) delta.insert('\n');
        if ('blotName' in match && 'formats' in match && typeof match.formats === 'function') return $8a2e015722259c42$var$applyFormat(delta, match.blotName, match.formats(node, scroll), scroll);
    }
    return delta;
}
function $8a2e015722259c42$var$matchBreak(node, delta) {
    if (!$8a2e015722259c42$var$deltaEndsWith(delta, '\n')) delta.insert('\n');
    return delta;
}
function $8a2e015722259c42$var$matchCodeBlock(node, delta, scroll) {
    const match = scroll.query('code-block');
    const language = match && 'formats' in match && typeof match.formats === 'function' ? match.formats(node, scroll) : true;
    return $8a2e015722259c42$var$applyFormat(delta, 'code-block', language, scroll);
}
function $8a2e015722259c42$var$matchIgnore() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))();
}
function $8a2e015722259c42$var$matchIndent(node, delta, scroll) {
    const match = scroll.query(node);
    if (match == null || // @ts-expect-error
    match.blotName !== 'list' || !$8a2e015722259c42$var$deltaEndsWith(delta, '\n')) return delta;
    let indent = -1;
    let parent = node.parentNode;
    while(parent != null){
        // @ts-expect-error
        if ([
            'OL',
            'UL'
        ].includes(parent.tagName)) indent += 1;
        parent = parent.parentNode;
    }
    if (indent <= 0) return delta;
    return delta.reduce((composed, op)=>{
        if (!op.insert) return composed;
        if (op.attributes && typeof op.attributes.indent === 'number') return composed.push(op);
        return composed.insert(op.insert, {
            indent: indent,
            ...op.attributes || {}
        });
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))());
}
function $8a2e015722259c42$var$matchList(node, delta, scroll) {
    const element = node;
    let list = element.tagName === 'OL' ? 'ordered' : 'bullet';
    const checkedAttr = element.getAttribute('data-checked');
    if (checkedAttr) list = checkedAttr === 'true' ? 'checked' : 'unchecked';
    return $8a2e015722259c42$var$applyFormat(delta, 'list', list, scroll);
}
function $8a2e015722259c42$export$c695b9637111f586(node, delta, scroll) {
    if (!$8a2e015722259c42$var$deltaEndsWith(delta, '\n')) {
        if ($8a2e015722259c42$var$isLine(node, scroll) && (node.childNodes.length > 0 || node instanceof HTMLParagraphElement)) return delta.insert('\n');
        if (delta.length() > 0 && node.nextSibling) {
            let nextSibling = node.nextSibling;
            while(nextSibling != null){
                if ($8a2e015722259c42$var$isLine(nextSibling, scroll)) return delta.insert('\n');
                const match = scroll.query(nextSibling);
                // @ts-expect-error
                if (match && match.prototype instanceof (0, $0d7ea5a8bdacfb09$export$48b9f0688962d028)) return delta.insert('\n');
                nextSibling = nextSibling.firstChild;
            }
        }
    }
    return delta;
}
function $8a2e015722259c42$var$matchStyles(node, delta, scroll) {
    const formats = {};
    const style = node.style || {};
    if (style.fontStyle === 'italic') formats.italic = true;
    if (style.textDecoration === 'underline') formats.underline = true;
    if (style.textDecoration === 'line-through') formats.strike = true;
    if (style.fontWeight?.startsWith('bold') || // @ts-expect-error Fix me later
    parseInt(style.fontWeight, 10) >= 700) formats.bold = true;
    delta = Object.entries(formats).reduce((newDelta, _ref5)=>{
        let [name, value] = _ref5;
        return $8a2e015722259c42$var$applyFormat(newDelta, name, value, scroll);
    }, delta);
    // @ts-expect-error
    if (parseFloat(style.textIndent || 0) > 0) // Could be 0.5in
    return new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().insert('\t').concat(delta);
    return delta;
}
function $8a2e015722259c42$var$matchTable(node, delta, scroll) {
    const table = node.parentElement?.tagName === 'TABLE' ? node.parentElement : node.parentElement?.parentElement;
    if (table != null) {
        const rows = Array.from(table.querySelectorAll('tr'));
        const row = rows.indexOf(node) + 1;
        return $8a2e015722259c42$var$applyFormat(delta, 'table', row, scroll);
    }
    return delta;
}
function $8a2e015722259c42$export$9b884371b5570711(node, delta, scroll) {
    // @ts-expect-error
    let text = node.data;
    // Word represents empty line with <o:p>&nbsp;</o:p>
    if (node.parentElement?.tagName === 'O:P') return delta.insert(text.trim());
    if (!$8a2e015722259c42$var$isPre(node)) {
        if (text.trim().length === 0 && text.includes('\n') && !$8a2e015722259c42$var$isBetweenInlineElements(node, scroll)) return delta;
        // convert all non-nbsp whitespace into regular space
        text = text.replace(/[^\S\u00a0]/g, ' ');
        // collapse consecutive spaces into one
        text = text.replace(/ {2,}/g, ' ');
        if (node.previousSibling == null && node.parentElement != null && $8a2e015722259c42$var$isLine(node.parentElement, scroll) || node.previousSibling instanceof Element && $8a2e015722259c42$var$isLine(node.previousSibling, scroll)) // block structure means we don't need leading space
        text = text.replace(/^ /, '');
        if (node.nextSibling == null && node.parentElement != null && $8a2e015722259c42$var$isLine(node.parentElement, scroll) || node.nextSibling instanceof Element && $8a2e015722259c42$var$isLine(node.nextSibling, scroll)) // block structure means we don't need trailing space
        text = text.replace(/ $/, '');
        // done removing whitespace and can normalize all to regular space
        text = text.replaceAll('\u00a0', ' ');
    }
    return delta.insert(text);
}





class $b1af08678fe2654b$export$2e2bcd8739ae039 extends (0, $ec73c86348f00d5d$export$2e2bcd8739ae039) {
    static DEFAULTS = {
        delay: 1000,
        maxStack: 100,
        userOnly: false
    };
    lastRecorded = 0;
    ignoreChange = false;
    stack = {
        undo: [],
        redo: []
    };
    currentRange = null;
    constructor(quill, options){
        super(quill, options);
        this.quill.on((0, $6deb74e67088b9aa$export$2e2bcd8739ae039).events.EDITOR_CHANGE, (eventName, value, oldValue, source)=>{
            if (eventName === (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).events.SELECTION_CHANGE) {
                if (value && source !== (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.SILENT) this.currentRange = value;
            } else if (eventName === (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).events.TEXT_CHANGE) {
                if (!this.ignoreChange) {
                    if (!this.options.userOnly || source === (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER) this.record(value, oldValue);
                    else this.transform(value);
                }
                this.currentRange = $b1af08678fe2654b$var$transformRange(this.currentRange, value);
            }
        });
        this.quill.keyboard.addBinding({
            key: 'z',
            shortKey: true
        }, this.undo.bind(this));
        this.quill.keyboard.addBinding({
            key: [
                'z',
                'Z'
            ],
            shortKey: true,
            shiftKey: true
        }, this.redo.bind(this));
        if (/Win/i.test(navigator.platform)) this.quill.keyboard.addBinding({
            key: 'y',
            shortKey: true
        }, this.redo.bind(this));
        this.quill.root.addEventListener('beforeinput', (event)=>{
            if (event.inputType === 'historyUndo') {
                this.undo();
                event.preventDefault();
            } else if (event.inputType === 'historyRedo') {
                this.redo();
                event.preventDefault();
            }
        });
    }
    change(source, dest) {
        if (this.stack[source].length === 0) return;
        const item = this.stack[source].pop();
        if (!item) return;
        const base = this.quill.getContents();
        const inverseDelta = item.delta.invert(base);
        this.stack[dest].push({
            delta: inverseDelta,
            range: $b1af08678fe2654b$var$transformRange(item.range, inverseDelta)
        });
        this.lastRecorded = 0;
        this.ignoreChange = true;
        this.quill.updateContents(item.delta, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
        this.ignoreChange = false;
        this.restoreSelection(item);
    }
    clear() {
        this.stack = {
            undo: [],
            redo: []
        };
    }
    cutoff() {
        this.lastRecorded = 0;
    }
    record(changeDelta, oldDelta) {
        if (changeDelta.ops.length === 0) return;
        this.stack.redo = [];
        let undoDelta = changeDelta.invert(oldDelta);
        let undoRange = this.currentRange;
        const timestamp = Date.now();
        if (// @ts-expect-error Fix me later
        this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
            const item = this.stack.undo.pop();
            if (item) {
                undoDelta = undoDelta.compose(item.delta);
                undoRange = item.range;
            }
        } else this.lastRecorded = timestamp;
        if (undoDelta.length() === 0) return;
        this.stack.undo.push({
            delta: undoDelta,
            range: undoRange
        });
        // @ts-expect-error Fix me later
        if (this.stack.undo.length > this.options.maxStack) this.stack.undo.shift();
    }
    redo() {
        this.change('redo', 'undo');
    }
    transform(delta) {
        $b1af08678fe2654b$var$transformStack(this.stack.undo, delta);
        $b1af08678fe2654b$var$transformStack(this.stack.redo, delta);
    }
    undo() {
        this.change('undo', 'redo');
    }
    restoreSelection(stackItem) {
        if (stackItem.range) this.quill.setSelection(stackItem.range, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
        else {
            const index = $b1af08678fe2654b$export$64042f78dc41d29e(this.quill.scroll, stackItem.delta);
            this.quill.setSelection(index, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
        }
    }
}
function $b1af08678fe2654b$var$transformStack(stack, delta) {
    let remoteDelta = delta;
    for(let i = stack.length - 1; i >= 0; i -= 1){
        const oldItem = stack[i];
        stack[i] = {
            delta: remoteDelta.transform(oldItem.delta, true),
            range: oldItem.range && $b1af08678fe2654b$var$transformRange(oldItem.range, remoteDelta)
        };
        remoteDelta = oldItem.delta.transform(remoteDelta);
        if (stack[i].delta.length() === 0) stack.splice(i, 1);
    }
}
function $b1af08678fe2654b$var$endsWithNewlineChange(scroll, delta) {
    const lastOp = delta.ops[delta.ops.length - 1];
    if (lastOp == null) return false;
    if (lastOp.insert != null) return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
    if (lastOp.attributes != null) return Object.keys(lastOp.attributes).some((attr)=>{
        return scroll.query(attr, (0, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214).BLOCK) != null;
    });
    return false;
}
function $b1af08678fe2654b$export$64042f78dc41d29e(scroll, delta) {
    const deleteLength = delta.reduce((length, op)=>{
        return length + (op.delete || 0);
    }, 0);
    let changeIndex = delta.length() - deleteLength;
    if ($b1af08678fe2654b$var$endsWithNewlineChange(scroll, delta)) changeIndex -= 1;
    return changeIndex;
}
function $b1af08678fe2654b$var$transformRange(range, delta) {
    if (!range) return range;
    const start = delta.transformPosition(range.index);
    const end = delta.transformPosition(range.index + range.length);
    return {
        index: start,
        length: end - start
    };
}






class $3ce7f12f9f76d306$var$Uploader extends (0, $ec73c86348f00d5d$export$2e2bcd8739ae039) {
    constructor(quill, options){
        super(quill, options);
        quill.root.addEventListener('drop', (e)=>{
            e.preventDefault();
            let native = null;
            if (document.caretRangeFromPoint) native = document.caretRangeFromPoint(e.clientX, e.clientY);
            else if (document.caretPositionFromPoint) {
                // @ts-expect-error
                const position = document.caretPositionFromPoint(e.clientX, e.clientY);
                native = document.createRange();
                native.setStart(position.offsetNode, position.offset);
                native.setEnd(position.offsetNode, position.offset);
            }
            const normalized = native && quill.selection.normalizeNative(native);
            if (normalized) {
                const range = quill.selection.normalizedToRange(normalized);
                if (e.dataTransfer?.files) this.upload(range, e.dataTransfer.files);
            }
        });
    }
    upload(range, files) {
        const uploads = [];
        Array.from(files).forEach((file)=>{
            if (file && this.options.mimetypes?.includes(file.type)) uploads.push(file);
        });
        if (uploads.length > 0) // @ts-expect-error Fix me later
        this.options.handler.call(this, range, uploads);
    }
}
$3ce7f12f9f76d306$var$Uploader.DEFAULTS = {
    mimetypes: [
        'image/png',
        'image/jpeg'
    ],
    handler (range, files) {
        if (!this.quill.scroll.query('image')) return;
        const promises = files.map((file)=>{
            return new Promise((resolve)=>{
                const reader = new FileReader();
                reader.onload = ()=>{
                    resolve(reader.result);
                };
                reader.readAsDataURL(file);
            });
        });
        Promise.all(promises).then((images)=>{
            const update = images.reduce((delta, image)=>{
                return delta.insert({
                    image: image
                });
            }, new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().retain(range.index).delete(range.length));
            this.quill.updateContents(update, (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.USER);
            this.quill.setSelection(range.index + images.length, (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.SILENT);
        });
    }
};
var $3ce7f12f9f76d306$export$2e2bcd8739ae039 = $3ce7f12f9f76d306$var$Uploader;







const $aa88bf1dbd89e1f6$var$INSERT_TYPES = [
    'insertText',
    'insertReplacementText'
];
class $aa88bf1dbd89e1f6$var$Input extends (0, $ec73c86348f00d5d$export$2e2bcd8739ae039) {
    constructor(quill, options){
        super(quill, options);
        quill.root.addEventListener('beforeinput', (event)=>{
            this.handleBeforeInput(event);
        });
        // Gboard with English input on Android triggers `compositionstart` sometimes even
        // users are not going to type anything.
        if (!/Android/i.test(navigator.userAgent)) quill.on((0, $6deb74e67088b9aa$export$2e2bcd8739ae039).events.COMPOSITION_BEFORE_START, ()=>{
            this.handleCompositionStart();
        });
    }
    deleteRange(range) {
        (0, $64631a418ea76ef4$export$a6c813797f379898)({
            range: range,
            quill: this.quill
        });
    }
    replaceText(range) {
        let text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        if (range.length === 0) return false;
        if (text) {
            // Follow the native behavior that inherits the formats of the first character
            const formats = this.quill.getFormat(range.index, 1);
            this.deleteRange(range);
            this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().retain(range.index).insert(text, formats), (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
        } else this.deleteRange(range);
        this.quill.setSelection(range.index + text.length, 0, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.SILENT);
        return true;
    }
    handleBeforeInput(event) {
        if (this.quill.composition.isComposing || event.defaultPrevented || !$aa88bf1dbd89e1f6$var$INSERT_TYPES.includes(event.inputType)) return;
        const staticRange = event.getTargetRanges ? event.getTargetRanges()[0] : null;
        if (!staticRange || staticRange.collapsed === true) return;
        const text = $aa88bf1dbd89e1f6$var$getPlainTextFromInputEvent(event);
        if (text == null) return;
        const normalized = this.quill.selection.normalizeNative(staticRange);
        const range = normalized ? this.quill.selection.normalizedToRange(normalized) : null;
        if (range && this.replaceText(range, text)) event.preventDefault();
    }
    handleCompositionStart() {
        const range = this.quill.getSelection();
        if (range) this.replaceText(range);
    }
}
function $aa88bf1dbd89e1f6$var$getPlainTextFromInputEvent(event) {
    // When `inputType` is "insertText":
    // - `event.data` should be string (Safari uses `event.dataTransfer`).
    // - `event.dataTransfer` should be null.
    // When `inputType` is "insertReplacementText":
    // - `event.data` should be null.
    // - `event.dataTransfer` should contain "text/plain" data.
    if (typeof event.data === 'string') return event.data;
    if (event.dataTransfer?.types.includes('text/plain')) return event.dataTransfer.getData('text/plain');
    return null;
}
var $aa88bf1dbd89e1f6$export$2e2bcd8739ae039 = $aa88bf1dbd89e1f6$var$Input;





const $bb24a772e041bddc$var$isMac = /Mac/i.test(navigator.platform);
const $bb24a772e041bddc$export$b6cc50769bf06658 = 100;
// A loose check to determine if the shortcut can move the caret before a UI node:
// <ANY_PARENT>[CARET]<div class="ql-ui"></div>[CONTENT]</ANY_PARENT>
const $bb24a772e041bddc$var$canMoveCaretBeforeUINode = (event)=>{
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight' || // RTL scripts or moving from the end of the previous line
    event.key === 'ArrowUp' || event.key === 'ArrowDown' || event.key === 'Home') return true;
    if ($bb24a772e041bddc$var$isMac && event.key === 'a' && event.ctrlKey === true) return true;
    return false;
};
class $bb24a772e041bddc$var$UINode extends (0, $ec73c86348f00d5d$export$2e2bcd8739ae039) {
    isListening = false;
    selectionChangeDeadline = 0;
    constructor(quill, options){
        super(quill, options);
        this.handleArrowKeys();
        this.handleNavigationShortcuts();
    }
    handleArrowKeys() {
        this.quill.keyboard.addBinding({
            key: [
                'ArrowLeft',
                'ArrowRight'
            ],
            offset: 0,
            shiftKey: null,
            handler (range, _ref) {
                let { line: line, event: event } = _ref;
                if (!(line instanceof (0, $e9fc1a5fcc0c5a1a$export$e43113f0aad76fe)) || !line.uiNode) return true;
                const isRTL = getComputedStyle(line.domNode)['direction'] === 'rtl';
                if (isRTL && event.key !== 'ArrowRight' || !isRTL && event.key !== 'ArrowLeft') return true;
                this.quill.setSelection(range.index - 1, range.length + (event.shiftKey ? 1 : 0), (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
                return false;
            }
        });
    }
    handleNavigationShortcuts() {
        this.quill.root.addEventListener('keydown', (event)=>{
            if (!event.defaultPrevented && $bb24a772e041bddc$var$canMoveCaretBeforeUINode(event)) this.ensureListeningToSelectionChange();
        });
    }
    /**
   * We only listen to the `selectionchange` event when
   * there is an intention of moving the caret to the beginning using shortcuts.
   * This is primarily implemented to prevent infinite loops, as we are changing
   * the selection within the handler of a `selectionchange` event.
   */ ensureListeningToSelectionChange() {
        this.selectionChangeDeadline = Date.now() + $bb24a772e041bddc$export$b6cc50769bf06658;
        if (this.isListening) return;
        this.isListening = true;
        const listener = ()=>{
            this.isListening = false;
            if (Date.now() <= this.selectionChangeDeadline) this.handleSelectionChange();
        };
        document.addEventListener('selectionchange', listener, {
            once: true
        });
    }
    handleSelectionChange() {
        const selection = document.getSelection();
        if (!selection) return;
        const range = selection.getRangeAt(0);
        if (range.collapsed !== true || range.startOffset !== 0) return;
        const line = this.quill.scroll.find(range.startContainer);
        if (!(line instanceof (0, $e9fc1a5fcc0c5a1a$export$e43113f0aad76fe)) || !line.uiNode) return;
        const newRange = document.createRange();
        newRange.setStartAfter(line.uiNode);
        newRange.setEndAfter(line.uiNode);
        selection.removeAllRanges();
        selection.addRange(newRange);
    }
}
var $bb24a772e041bddc$export$2e2bcd8739ae039 = $bb24a772e041bddc$var$UINode;



(0, $6deb74e67088b9aa$export$2e2bcd8739ae039).register({
    'blots/block': (0, $0d7ea5a8bdacfb09$export$2e2bcd8739ae039),
    'blots/block/embed': (0, $0d7ea5a8bdacfb09$export$48b9f0688962d028),
    'blots/break': (0, $e5579ce91e3096b0$export$2e2bcd8739ae039),
    'blots/container': (0, $bbaa9603c8327354$export$2e2bcd8739ae039),
    'blots/cursor': (0, $fa8ee3ba40bbf9de$export$2e2bcd8739ae039),
    'blots/embed': (0, $2533afcdc047b3ff$export$2e2bcd8739ae039),
    'blots/inline': (0, $f5f023af83746731$export$2e2bcd8739ae039),
    'blots/scroll': (0, $bebd5b95c8bd05a9$export$2e2bcd8739ae039),
    'blots/text': (0, $b5feff51aa4dee9f$export$2e2bcd8739ae039),
    'modules/clipboard': (0, $8a2e015722259c42$export$2e2bcd8739ae039),
    'modules/history': (0, $b1af08678fe2654b$export$2e2bcd8739ae039),
    'modules/keyboard': (0, $64631a418ea76ef4$export$2e2bcd8739ae039),
    'modules/uploader': (0, $3ce7f12f9f76d306$export$2e2bcd8739ae039),
    'modules/input': (0, $aa88bf1dbd89e1f6$export$2e2bcd8739ae039),
    'modules/uiNode': (0, $bb24a772e041bddc$export$2e2bcd8739ae039)
});
var $5c4d0d03149a5034$export$2e2bcd8739ae039 = (0, $6deb74e67088b9aa$export$2e2bcd8739ae039);





class $44302badf55e41ef$var$IndentAttributor extends (0, $e9fc1a5fcc0c5a1a$export$651d45509677cf07) {
    add(node, value) {
        let normalizedValue = 0;
        if (value === '+1' || value === '-1') {
            const indent = this.value(node) || 0;
            normalizedValue = value === '+1' ? indent + 1 : indent - 1;
        } else if (typeof value === 'number') normalizedValue = value;
        if (normalizedValue === 0) {
            this.remove(node);
            return true;
        }
        return super.add(node, normalizedValue.toString());
    }
    canAdd(node, value) {
        return super.canAdd(node, value) || super.canAdd(node, parseInt(value, 10));
    }
    value(node) {
        return parseInt(super.value(node), 10) || undefined; // Don't return NaN
    }
}
const $44302badf55e41ef$var$IndentClass = new $44302badf55e41ef$var$IndentAttributor('indent', 'ql-indent', {
    scope: (0, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214).BLOCK,
    // @ts-expect-error
    whitelist: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8
    ]
});
var $44302badf55e41ef$export$2e2bcd8739ae039 = $44302badf55e41ef$var$IndentClass;



class $fdecb6ec12c02442$var$Blockquote extends (0, $0d7ea5a8bdacfb09$export$2e2bcd8739ae039) {
    static blotName = 'blockquote';
    static tagName = 'blockquote';
}
var $fdecb6ec12c02442$export$2e2bcd8739ae039 = $fdecb6ec12c02442$var$Blockquote;



class $fff68e5f0c5de88d$var$Header extends (0, $0d7ea5a8bdacfb09$export$2e2bcd8739ae039) {
    static blotName = 'header';
    static tagName = [
        'H1',
        'H2',
        'H3',
        'H4',
        'H5',
        'H6'
    ];
    static formats(domNode) {
        return this.tagName.indexOf(domNode.tagName) + 1;
    }
}
var $fff68e5f0c5de88d$export$2e2bcd8739ae039 = $fff68e5f0c5de88d$var$Header;





class $8a2a751148cb2657$export$122a2a667e12876b extends (0, $bbaa9603c8327354$export$2e2bcd8739ae039) {
}
$8a2a751148cb2657$export$122a2a667e12876b.blotName = 'list-container';
$8a2a751148cb2657$export$122a2a667e12876b.tagName = 'OL';
class $8a2a751148cb2657$export$2e2bcd8739ae039 extends (0, $0d7ea5a8bdacfb09$export$2e2bcd8739ae039) {
    static create(value) {
        const node = super.create();
        node.setAttribute('data-list', value);
        return node;
    }
    static formats(domNode) {
        return domNode.getAttribute('data-list') || undefined;
    }
    static register() {
        (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).register($8a2a751148cb2657$export$122a2a667e12876b);
    }
    constructor(scroll, domNode){
        super(scroll, domNode);
        const ui = domNode.ownerDocument.createElement('span');
        const listEventHandler = (e)=>{
            if (!scroll.isEnabled()) return;
            const format = this.statics.formats(domNode, scroll);
            if (format === 'checked') {
                this.format('list', 'unchecked');
                e.preventDefault();
            } else if (format === 'unchecked') {
                this.format('list', 'checked');
                e.preventDefault();
            }
        };
        ui.addEventListener('mousedown', listEventHandler);
        ui.addEventListener('touchstart', listEventHandler);
        this.attachUI(ui);
    }
    format(name, value) {
        if (name === this.statics.blotName && value) this.domNode.setAttribute('data-list', value);
        else super.format(name, value);
    }
}
$8a2a751148cb2657$export$2e2bcd8739ae039.blotName = 'list';
$8a2a751148cb2657$export$2e2bcd8739ae039.tagName = 'LI';
$8a2a751148cb2657$export$122a2a667e12876b.allowedChildren = [
    $8a2a751148cb2657$export$2e2bcd8739ae039
];
$8a2a751148cb2657$export$2e2bcd8739ae039.requiredContainer = $8a2a751148cb2657$export$122a2a667e12876b;







class $610031d7908e35de$var$Bold extends (0, $f5f023af83746731$export$2e2bcd8739ae039) {
    static blotName = 'bold';
    static tagName = [
        'STRONG',
        'B'
    ];
    static create() {
        return super.create();
    }
    static formats() {
        return true;
    }
    optimize(context) {
        super.optimize(context);
        if (this.domNode.tagName !== this.statics.tagName[0]) this.replaceWith(this.statics.blotName);
    }
}
var $610031d7908e35de$export$2e2bcd8739ae039 = $610031d7908e35de$var$Bold;



class $e5756b465b0daeb1$var$Italic extends (0, $610031d7908e35de$export$2e2bcd8739ae039) {
    static blotName = 'italic';
    static tagName = [
        'EM',
        'I'
    ];
}
var $e5756b465b0daeb1$export$2e2bcd8739ae039 = $e5756b465b0daeb1$var$Italic;



class $4fd0b869b911350e$export$2e2bcd8739ae039 extends (0, $f5f023af83746731$export$2e2bcd8739ae039) {
    static blotName = 'link';
    static tagName = 'A';
    static SANITIZED_URL = 'about:blank';
    static PROTOCOL_WHITELIST = [
        'http',
        'https',
        'mailto',
        'tel',
        'sms'
    ];
    static create(value) {
        const node = super.create(value);
        node.setAttribute('href', this.sanitize(value));
        node.setAttribute('rel', 'noopener noreferrer');
        node.setAttribute('target', '_blank');
        return node;
    }
    static formats(domNode) {
        return domNode.getAttribute('href');
    }
    static sanitize(url) {
        return $4fd0b869b911350e$export$83d2e9e3e4ee39ed(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
    }
    format(name, value) {
        if (name !== this.statics.blotName || !value) super.format(name, value);
        else // @ts-expect-error
        this.domNode.setAttribute('href', this.constructor.sanitize(value));
    }
}
function $4fd0b869b911350e$export$83d2e9e3e4ee39ed(url, protocols) {
    const anchor = document.createElement('a');
    anchor.href = url;
    const protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
    return protocols.indexOf(protocol) > -1;
}



class $5f36da2647e8384e$var$Script extends (0, $f5f023af83746731$export$2e2bcd8739ae039) {
    static blotName = 'script';
    static tagName = [
        'SUB',
        'SUP'
    ];
    static create(value) {
        if (value === 'super') return document.createElement('sup');
        if (value === 'sub') return document.createElement('sub');
        return super.create(value);
    }
    static formats(domNode) {
        if (domNode.tagName === 'SUB') return 'sub';
        if (domNode.tagName === 'SUP') return 'super';
        return undefined;
    }
}
var $5f36da2647e8384e$export$2e2bcd8739ae039 = $5f36da2647e8384e$var$Script;



class $b99750cbcefeb7ff$var$Strike extends (0, $610031d7908e35de$export$2e2bcd8739ae039) {
    static blotName = 'strike';
    static tagName = [
        'S',
        'STRIKE'
    ];
}
var $b99750cbcefeb7ff$export$2e2bcd8739ae039 = $b99750cbcefeb7ff$var$Strike;



class $29ca8040b4238447$var$Underline extends (0, $f5f023af83746731$export$2e2bcd8739ae039) {
    static blotName = 'underline';
    static tagName = 'U';
}
var $29ca8040b4238447$export$2e2bcd8739ae039 = $29ca8040b4238447$var$Underline;



class $440dac071ad25b22$var$Formula extends (0, $2533afcdc047b3ff$export$2e2bcd8739ae039) {
    static blotName = 'formula';
    static className = 'ql-formula';
    static tagName = 'SPAN';
    static create(value) {
        // @ts-expect-error
        if (window.katex == null) throw new Error('Formula module requires KaTeX.');
        const node = super.create(value);
        if (typeof value === 'string') {
            // @ts-expect-error
            window.katex.render(value, node, {
                throwOnError: false,
                errorColor: '#f00'
            });
            node.setAttribute('data-value', value);
        }
        return node;
    }
    static value(domNode) {
        return domNode.getAttribute('data-value');
    }
    html() {
        const { formula: formula } = this.value();
        return `<span>${formula}</span>`;
    }
}
var $440dac071ad25b22$export$2e2bcd8739ae039 = $440dac071ad25b22$var$Formula;




const $007703bef43f07c2$var$ATTRIBUTES = [
    'alt',
    'height',
    'width'
];
class $007703bef43f07c2$var$Image extends (0, $e9fc1a5fcc0c5a1a$export$297a1fa96f55f00f) {
    static blotName = 'image';
    static tagName = 'IMG';
    static create(value) {
        const node = super.create(value);
        if (typeof value === 'string') node.setAttribute('src', this.sanitize(value));
        return node;
    }
    static formats(domNode) {
        return $007703bef43f07c2$var$ATTRIBUTES.reduce((formats, attribute)=>{
            if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
            return formats;
        }, {});
    }
    static match(url) {
        return /\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url);
    }
    static sanitize(url) {
        return (0, $4fd0b869b911350e$export$83d2e9e3e4ee39ed)(url, [
            'http',
            'https',
            'data'
        ]) ? url : '//:0';
    }
    static value(domNode) {
        return domNode.getAttribute('src');
    }
    format(name, value) {
        if ($007703bef43f07c2$var$ATTRIBUTES.indexOf(name) > -1) {
            if (value) this.domNode.setAttribute(name, value);
            else this.domNode.removeAttribute(name);
        } else super.format(name, value);
    }
}
var $007703bef43f07c2$export$2e2bcd8739ae039 = $007703bef43f07c2$var$Image;




const $9e318b5c7d13ab52$var$ATTRIBUTES = [
    'height',
    'width'
];
class $9e318b5c7d13ab52$var$Video extends (0, $0d7ea5a8bdacfb09$export$48b9f0688962d028) {
    static blotName = 'video';
    static className = 'ql-video';
    static tagName = 'IFRAME';
    static create(value) {
        const node = super.create(value);
        node.setAttribute('frameborder', '0');
        node.setAttribute('allowfullscreen', 'true');
        node.setAttribute('src', this.sanitize(value));
        return node;
    }
    static formats(domNode) {
        return $9e318b5c7d13ab52$var$ATTRIBUTES.reduce((formats, attribute)=>{
            if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
            return formats;
        }, {});
    }
    static sanitize(url) {
        return (0, $4fd0b869b911350e$export$2e2bcd8739ae039).sanitize(url);
    }
    static value(domNode) {
        return domNode.getAttribute('src');
    }
    format(name, value) {
        if ($9e318b5c7d13ab52$var$ATTRIBUTES.indexOf(name) > -1) {
            if (value) this.domNode.setAttribute(name, value);
            else this.domNode.removeAttribute(name);
        } else super.format(name, value);
    }
    html() {
        const { video: video } = this.value();
        return `<a href="${video}">${video}</a>`;
    }
}
var $9e318b5c7d13ab52$export$2e2bcd8739ae039 = $9e318b5c7d13ab52$var$Video;














const $21a99c560fedc334$var$TokenAttributor = new (0, $e9fc1a5fcc0c5a1a$export$651d45509677cf07)('code-token', 'hljs', {
    scope: (0, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214).INLINE
});
class $21a99c560fedc334$export$9460eee64f276be7 extends (0, $f5f023af83746731$export$2e2bcd8739ae039) {
    static formats(node, scroll) {
        while(node != null && node !== scroll.domNode){
            if (node.classList && node.classList.contains((0, $9751ae0c93fde05d$export$2e2bcd8739ae039).className)) // @ts-expect-error
            return super.formats(node, scroll);
            // @ts-expect-error
            node = node.parentNode;
        }
        return undefined;
    }
    constructor(scroll, domNode, value){
        // @ts-expect-error
        super(scroll, domNode, value);
        $21a99c560fedc334$var$TokenAttributor.add(this.domNode, value);
    }
    format(format, value) {
        if (format !== $21a99c560fedc334$export$9460eee64f276be7.blotName) super.format(format, value);
        else if (value) $21a99c560fedc334$var$TokenAttributor.add(this.domNode, value);
        else {
            $21a99c560fedc334$var$TokenAttributor.remove(this.domNode);
            this.domNode.classList.remove(this.statics.className);
        }
    }
    optimize() {
        // @ts-expect-error
        super.optimize(...arguments);
        if (!$21a99c560fedc334$var$TokenAttributor.value(this.domNode)) this.unwrap();
    }
}
$21a99c560fedc334$export$9460eee64f276be7.blotName = 'code-token';
$21a99c560fedc334$export$9460eee64f276be7.className = 'ql-token';
class $21a99c560fedc334$export$6c415d1fdae3dfdb extends (0, $9751ae0c93fde05d$export$2e2bcd8739ae039) {
    static create(value) {
        const domNode = super.create(value);
        if (typeof value === 'string') domNode.setAttribute('data-language', value);
        return domNode;
    }
    static formats(domNode) {
        // @ts-expect-error
        return domNode.getAttribute('data-language') || 'plain';
    }
    static register() {}
    format(name, value) {
        if (name === this.statics.blotName && value) // @ts-expect-error
        this.domNode.setAttribute('data-language', value);
        else super.format(name, value);
    }
    replaceWith(name, value) {
        this.formatAt(0, this.length(), $21a99c560fedc334$export$9460eee64f276be7.blotName, false);
        return super.replaceWith(name, value);
    }
}
class $21a99c560fedc334$var$SyntaxCodeBlockContainer extends (0, $9751ae0c93fde05d$export$3b131632d3d15165) {
    attach() {
        super.attach();
        this.forceNext = false;
        // @ts-expect-error
        this.scroll.emitMount(this);
    }
    format(name, value) {
        if (name === $21a99c560fedc334$export$6c415d1fdae3dfdb.blotName) {
            this.forceNext = true;
            this.children.forEach((child)=>{
                // @ts-expect-error
                child.format(name, value);
            });
        }
    }
    formatAt(index, length, name, value) {
        if (name === $21a99c560fedc334$export$6c415d1fdae3dfdb.blotName) this.forceNext = true;
        super.formatAt(index, length, name, value);
    }
    highlight(highlight) {
        let forced = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (this.children.head == null) return;
        const nodes = Array.from(this.domNode.childNodes).filter((node)=>node !== this.uiNode);
        const text = `${nodes.map((node)=>node.textContent).join('\n')}\n`;
        const language = $21a99c560fedc334$export$6c415d1fdae3dfdb.formats(this.children.head.domNode);
        if (forced || this.forceNext || this.cachedText !== text) {
            if (text.trim().length > 0 || this.cachedText == null) {
                const oldDelta = this.children.reduce((delta, child)=>{
                    // @ts-expect-error
                    return delta.concat((0, $0d7ea5a8bdacfb09$export$992ff47219af5a2b)(child, false));
                }, new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))());
                const delta = highlight(text, language);
                oldDelta.diff(delta).reduce((index, _ref)=>{
                    let { retain: retain, attributes: attributes } = _ref;
                    // Should be all retains
                    if (!retain) return index;
                    if (attributes) Object.keys(attributes).forEach((format)=>{
                        if ([
                            $21a99c560fedc334$export$6c415d1fdae3dfdb.blotName,
                            $21a99c560fedc334$export$9460eee64f276be7.blotName
                        ].includes(format)) // @ts-expect-error
                        this.formatAt(index, retain, format, attributes[format]);
                    });
                    // @ts-expect-error
                    return index + retain;
                }, 0);
            }
            this.cachedText = text;
            this.forceNext = false;
        }
    }
    html(index, length) {
        const [codeBlock] = this.children.find(index);
        const language = codeBlock ? $21a99c560fedc334$export$6c415d1fdae3dfdb.formats(codeBlock.domNode) : 'plain';
        return `<pre data-language="${language}">\n${(0, $b5feff51aa4dee9f$export$96e6fc3a139b2555)(this.code(index, length))}\n</pre>`;
    }
    optimize(context) {
        super.optimize(context);
        if (this.parent != null && this.children.head != null && this.uiNode != null) {
            const language = $21a99c560fedc334$export$6c415d1fdae3dfdb.formats(this.children.head.domNode);
            // @ts-expect-error
            if (language !== this.uiNode.value) // @ts-expect-error
            this.uiNode.value = language;
        }
    }
}
$21a99c560fedc334$var$SyntaxCodeBlockContainer.allowedChildren = [
    $21a99c560fedc334$export$6c415d1fdae3dfdb
];
$21a99c560fedc334$export$6c415d1fdae3dfdb.requiredContainer = $21a99c560fedc334$var$SyntaxCodeBlockContainer;
$21a99c560fedc334$export$6c415d1fdae3dfdb.allowedChildren = [
    $21a99c560fedc334$export$9460eee64f276be7,
    (0, $fa8ee3ba40bbf9de$export$2e2bcd8739ae039),
    (0, $b5feff51aa4dee9f$export$2e2bcd8739ae039),
    (0, $e5579ce91e3096b0$export$2e2bcd8739ae039)
];
const $21a99c560fedc334$var$highlight = (lib, language, text)=>{
    if (typeof lib.versionString === 'string') {
        const majorVersion = lib.versionString.split('.')[0];
        if (parseInt(majorVersion, 10) >= 11) return lib.highlight(text, {
            language: language
        }).value;
    }
    return lib.highlight(language, text).value;
};
class $21a99c560fedc334$export$2e2bcd8739ae039 extends (0, $ec73c86348f00d5d$export$2e2bcd8739ae039) {
    static register() {
        (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).register($21a99c560fedc334$export$9460eee64f276be7, true);
        (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).register($21a99c560fedc334$export$6c415d1fdae3dfdb, true);
        (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).register($21a99c560fedc334$var$SyntaxCodeBlockContainer, true);
    }
    constructor(quill, options){
        super(quill, options);
        if (this.options.hljs == null) throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
        // @ts-expect-error Fix me later
        this.languages = this.options.languages.reduce((memo, _ref2)=>{
            let { key: key } = _ref2;
            memo[key] = true;
            return memo;
        }, {});
        this.highlightBlot = this.highlightBlot.bind(this);
        this.initListener();
        this.initTimer();
    }
    initListener() {
        this.quill.on((0, $6deb74e67088b9aa$export$2e2bcd8739ae039).events.SCROLL_BLOT_MOUNT, (blot)=>{
            if (!(blot instanceof $21a99c560fedc334$var$SyntaxCodeBlockContainer)) return;
            const select = this.quill.root.ownerDocument.createElement('select');
            // @ts-expect-error Fix me later
            this.options.languages.forEach((_ref3)=>{
                let { key: key, label: label } = _ref3;
                const option = select.ownerDocument.createElement('option');
                option.textContent = label;
                option.setAttribute('value', key);
                select.appendChild(option);
            });
            select.addEventListener('change', ()=>{
                blot.format($21a99c560fedc334$export$6c415d1fdae3dfdb.blotName, select.value);
                this.quill.root.focus(); // Prevent scrolling
                this.highlight(blot, true);
            });
            if (blot.uiNode == null) {
                blot.attachUI(select);
                if (blot.children.head) select.value = $21a99c560fedc334$export$6c415d1fdae3dfdb.formats(blot.children.head.domNode);
            }
        });
    }
    initTimer() {
        let timer = null;
        this.quill.on((0, $6deb74e67088b9aa$export$2e2bcd8739ae039).events.SCROLL_OPTIMIZE, ()=>{
            if (timer) clearTimeout(timer);
            timer = setTimeout(()=>{
                this.highlight();
                timer = null;
            }, this.options.interval);
        });
    }
    highlight() {
        let blot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (this.quill.selection.composing) return;
        this.quill.update((0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
        const range = this.quill.getSelection();
        const blots = blot == null ? this.quill.scroll.descendants($21a99c560fedc334$var$SyntaxCodeBlockContainer) : [
            blot
        ];
        blots.forEach((container)=>{
            container.highlight(this.highlightBlot, force);
        });
        this.quill.update((0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.SILENT);
        if (range != null) this.quill.setSelection(range, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.SILENT);
    }
    highlightBlot(text) {
        let language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'plain';
        language = this.languages[language] ? language : 'plain';
        if (language === 'plain') return (0, $b5feff51aa4dee9f$export$96e6fc3a139b2555)(text).split('\n').reduce((delta, line, i)=>{
            if (i !== 0) delta.insert('\n', {
                [(0, $9751ae0c93fde05d$export$2e2bcd8739ae039).blotName]: language
            });
            return delta.insert(line);
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))());
        const container = this.quill.root.ownerDocument.createElement('div');
        container.classList.add((0, $9751ae0c93fde05d$export$2e2bcd8739ae039).className);
        container.innerHTML = $21a99c560fedc334$var$highlight(this.options.hljs, language, text);
        return (0, $8a2e015722259c42$export$df3f009e3d155b20)(this.quill.scroll, container, [
            (node, delta)=>{
                // @ts-expect-error
                const value = $21a99c560fedc334$var$TokenAttributor.value(node);
                if (value) return delta.compose(new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().retain(delta.length(), {
                    [$21a99c560fedc334$export$9460eee64f276be7.blotName]: value
                }));
                return delta;
            }
        ], [
            (node, delta)=>{
                // @ts-expect-error
                return node.data.split('\n').reduce((memo, nodeText, i)=>{
                    if (i !== 0) memo.insert('\n', {
                        [(0, $9751ae0c93fde05d$export$2e2bcd8739ae039).blotName]: language
                    });
                    return memo.insert(nodeText);
                }, delta);
            }
        ], new WeakMap());
    }
}
$21a99c560fedc334$export$2e2bcd8739ae039.DEFAULTS = {
    hljs: (()=>{
        return window.hljs;
    })(),
    interval: 1000,
    languages: [
        {
            key: 'plain',
            label: 'Plain'
        },
        {
            key: 'bash',
            label: 'Bash'
        },
        {
            key: 'cpp',
            label: 'C++'
        },
        {
            key: 'cs',
            label: 'C#'
        },
        {
            key: 'css',
            label: 'CSS'
        },
        {
            key: 'diff',
            label: 'Diff'
        },
        {
            key: 'xml',
            label: 'HTML/XML'
        },
        {
            key: 'java',
            label: 'Java'
        },
        {
            key: 'javascript',
            label: 'JavaScript'
        },
        {
            key: 'markdown',
            label: 'Markdown'
        },
        {
            key: 'php',
            label: 'PHP'
        },
        {
            key: 'python',
            label: 'Python'
        },
        {
            key: 'ruby',
            label: 'Ruby'
        },
        {
            key: 'sql',
            label: 'SQL'
        }
    ]
};







class $4773a5ef422b51ba$export$1e4baea7053fc0e3 extends (0, $0d7ea5a8bdacfb09$export$2e2bcd8739ae039) {
    static blotName = 'table';
    static tagName = 'TD';
    static create(value) {
        const node = super.create();
        if (value) node.setAttribute('data-row', value);
        else node.setAttribute('data-row', $4773a5ef422b51ba$export$9bd6f73cbe857f1b());
        return node;
    }
    static formats(domNode) {
        if (domNode.hasAttribute('data-row')) return domNode.getAttribute('data-row');
        return undefined;
    }
    cellOffset() {
        if (this.parent) return this.parent.children.indexOf(this);
        return -1;
    }
    format(name, value) {
        if (name === $4773a5ef422b51ba$export$1e4baea7053fc0e3.blotName && value) this.domNode.setAttribute('data-row', value);
        else super.format(name, value);
    }
    row() {
        return this.parent;
    }
    rowOffset() {
        if (this.row()) return this.row().rowOffset();
        return -1;
    }
    table() {
        return this.row() && this.row().table();
    }
}
class $4773a5ef422b51ba$export$b05581f4e764e162 extends (0, $bbaa9603c8327354$export$2e2bcd8739ae039) {
    static blotName = 'table-row';
    static tagName = 'TR';
    checkMerge() {
        // @ts-expect-error
        if (super.checkMerge() && this.next.children.head != null) {
            // @ts-expect-error
            const thisHead = this.children.head.formats();
            // @ts-expect-error
            const thisTail = this.children.tail.formats();
            // @ts-expect-error
            const nextHead = this.next.children.head.formats();
            // @ts-expect-error
            const nextTail = this.next.children.tail.formats();
            return thisHead.table === thisTail.table && thisHead.table === nextHead.table && thisHead.table === nextTail.table;
        }
        return false;
    }
    optimize(context) {
        super.optimize(context);
        this.children.forEach((child)=>{
            if (child.next == null) return;
            const childFormats = child.formats();
            const nextFormats = child.next.formats();
            if (childFormats.table !== nextFormats.table) {
                const next = this.splitAfter(child);
                if (next) // @ts-expect-error TODO: parameters of optimize() should be a optional
                next.optimize();
                // We might be able to merge with prev now
                if (this.prev) // @ts-expect-error TODO: parameters of optimize() should be a optional
                this.prev.optimize();
            }
        });
    }
    rowOffset() {
        if (this.parent) return this.parent.children.indexOf(this);
        return -1;
    }
    table() {
        return this.parent && this.parent.parent;
    }
}
class $4773a5ef422b51ba$export$76ccd210b9029917 extends (0, $bbaa9603c8327354$export$2e2bcd8739ae039) {
    static blotName = 'table-body';
    static tagName = 'TBODY';
}
class $4773a5ef422b51ba$export$f2c3aea42b2a048f extends (0, $bbaa9603c8327354$export$2e2bcd8739ae039) {
    static blotName = 'table-container';
    static tagName = 'TABLE';
    balanceCells() {
        const rows = this.descendants($4773a5ef422b51ba$export$b05581f4e764e162);
        const maxColumns = rows.reduce((max, row)=>{
            return Math.max(row.children.length, max);
        }, 0);
        rows.forEach((row)=>{
            new Array(maxColumns - row.children.length).fill(0).forEach(()=>{
                let value;
                if (row.children.head != null) value = $4773a5ef422b51ba$export$1e4baea7053fc0e3.formats(row.children.head.domNode);
                const blot = this.scroll.create($4773a5ef422b51ba$export$1e4baea7053fc0e3.blotName, value);
                row.appendChild(blot);
                // @ts-expect-error TODO: parameters of optimize() should be a optional
                blot.optimize(); // Add break blot
            });
        });
    }
    cells(column) {
        return this.rows().map((row)=>row.children.at(column));
    }
    deleteColumn(index) {
        // @ts-expect-error
        const [body] = this.descendant($4773a5ef422b51ba$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        body.children.forEach((row)=>{
            const cell = row.children.at(index);
            if (cell != null) cell.remove();
        });
    }
    insertColumn(index) {
        // @ts-expect-error
        const [body] = this.descendant($4773a5ef422b51ba$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        body.children.forEach((row)=>{
            const ref = row.children.at(index);
            // @ts-expect-error
            const value = $4773a5ef422b51ba$export$1e4baea7053fc0e3.formats(row.children.head.domNode);
            const cell = this.scroll.create($4773a5ef422b51ba$export$1e4baea7053fc0e3.blotName, value);
            row.insertBefore(cell, ref);
        });
    }
    insertRow(index) {
        // @ts-expect-error
        const [body] = this.descendant($4773a5ef422b51ba$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        const id = $4773a5ef422b51ba$export$9bd6f73cbe857f1b();
        const row = this.scroll.create($4773a5ef422b51ba$export$b05581f4e764e162.blotName);
        body.children.head.children.forEach(()=>{
            const cell = this.scroll.create($4773a5ef422b51ba$export$1e4baea7053fc0e3.blotName, id);
            row.appendChild(cell);
        });
        const ref = body.children.at(index);
        body.insertBefore(row, ref);
    }
    rows() {
        const body = this.children.head;
        if (body == null) return [];
        return body.children.map((row)=>row);
    }
}
$4773a5ef422b51ba$export$f2c3aea42b2a048f.allowedChildren = [
    $4773a5ef422b51ba$export$76ccd210b9029917
];
$4773a5ef422b51ba$export$76ccd210b9029917.requiredContainer = $4773a5ef422b51ba$export$f2c3aea42b2a048f;
$4773a5ef422b51ba$export$76ccd210b9029917.allowedChildren = [
    $4773a5ef422b51ba$export$b05581f4e764e162
];
$4773a5ef422b51ba$export$b05581f4e764e162.requiredContainer = $4773a5ef422b51ba$export$76ccd210b9029917;
$4773a5ef422b51ba$export$b05581f4e764e162.allowedChildren = [
    $4773a5ef422b51ba$export$1e4baea7053fc0e3
];
$4773a5ef422b51ba$export$1e4baea7053fc0e3.requiredContainer = $4773a5ef422b51ba$export$b05581f4e764e162;
function $4773a5ef422b51ba$export$9bd6f73cbe857f1b() {
    const id = Math.random().toString(36).slice(2, 6);
    return `row-${id}`;
}


class $99b978f13d6ff033$var$Table extends (0, $ec73c86348f00d5d$export$2e2bcd8739ae039) {
    static register() {
        (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).register((0, $4773a5ef422b51ba$export$1e4baea7053fc0e3));
        (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).register((0, $4773a5ef422b51ba$export$b05581f4e764e162));
        (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).register((0, $4773a5ef422b51ba$export$76ccd210b9029917));
        (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).register((0, $4773a5ef422b51ba$export$f2c3aea42b2a048f));
    }
    constructor(){
        super(...arguments);
        this.listenBalanceCells();
    }
    balanceTables() {
        this.quill.scroll.descendants((0, $4773a5ef422b51ba$export$f2c3aea42b2a048f)).forEach((table)=>{
            table.balanceCells();
        });
    }
    deleteColumn() {
        const [table, , cell] = this.getTable();
        if (cell == null) return;
        // @ts-expect-error
        table.deleteColumn(cell.cellOffset());
        this.quill.update((0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
    }
    deleteRow() {
        const [, row] = this.getTable();
        if (row == null) return;
        row.remove();
        this.quill.update((0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
    }
    deleteTable() {
        const [table] = this.getTable();
        if (table == null) return;
        // @ts-expect-error
        const offset = table.offset();
        // @ts-expect-error
        table.remove();
        this.quill.update((0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
        this.quill.setSelection(offset, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.SILENT);
    }
    getTable() {
        let range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.quill.getSelection();
        if (range == null) return [
            null,
            null,
            null,
            -1
        ];
        const [cell, offset] = this.quill.getLine(range.index);
        if (cell == null || cell.statics.blotName !== (0, $4773a5ef422b51ba$export$1e4baea7053fc0e3).blotName) return [
            null,
            null,
            null,
            -1
        ];
        const row = cell.parent;
        const table = row.parent.parent;
        // @ts-expect-error
        return [
            table,
            row,
            cell,
            offset
        ];
    }
    insertColumn(offset) {
        const range = this.quill.getSelection();
        if (!range) return;
        const [table, row, cell] = this.getTable(range);
        if (cell == null) return;
        const column = cell.cellOffset();
        table.insertColumn(column + offset);
        this.quill.update((0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
        let shift = row.rowOffset();
        if (offset === 0) shift += 1;
        this.quill.setSelection(range.index + shift, range.length, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.SILENT);
    }
    insertColumnLeft() {
        this.insertColumn(0);
    }
    insertColumnRight() {
        this.insertColumn(1);
    }
    insertRow(offset) {
        const range = this.quill.getSelection();
        if (!range) return;
        const [table, row, cell] = this.getTable(range);
        if (cell == null) return;
        const index = row.rowOffset();
        table.insertRow(index + offset);
        this.quill.update((0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
        if (offset > 0) this.quill.setSelection(range, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.SILENT);
        else this.quill.setSelection(range.index + row.children.length, range.length, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.SILENT);
    }
    insertRowAbove() {
        this.insertRow(0);
    }
    insertRowBelow() {
        this.insertRow(1);
    }
    insertTable(rows, columns) {
        const range = this.quill.getSelection();
        if (range == null) return;
        const delta = new Array(rows).fill(0).reduce((memo)=>{
            const text = new Array(columns).fill('\n').join('');
            return memo.insert(text, {
                table: (0, $4773a5ef422b51ba$export$9bd6f73cbe857f1b)()
            });
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))().retain(range.index));
        this.quill.updateContents(delta, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
        this.quill.setSelection(range.index, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.SILENT);
        this.balanceTables();
    }
    listenBalanceCells() {
        this.quill.on((0, $6deb74e67088b9aa$export$2e2bcd8739ae039).events.SCROLL_OPTIMIZE, (mutations)=>{
            mutations.some((mutation)=>{
                if ([
                    'TD',
                    'TR',
                    'TBODY',
                    'TABLE'
                ].includes(mutation.target.tagName)) {
                    this.quill.once((0, $6deb74e67088b9aa$export$2e2bcd8739ae039).events.TEXT_CHANGE, (delta, old, source)=>{
                        if (source !== (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER) return;
                        this.balanceTables();
                    });
                    return true;
                }
                return false;
            });
        });
    }
}
var $99b978f13d6ff033$export$2e2bcd8739ae039 = $99b978f13d6ff033$var$Table;







const $b3a95f3cb1593e89$var$debug = (0, $7ec5affce32db05e$export$2e2bcd8739ae039)('quill:toolbar');
class $b3a95f3cb1593e89$export$2e2bcd8739ae039 extends (0, $ec73c86348f00d5d$export$2e2bcd8739ae039) {
    constructor(quill, options){
        super(quill, options);
        if (Array.isArray(this.options.container)) {
            const container = document.createElement('div');
            container.setAttribute('role', 'toolbar');
            $b3a95f3cb1593e89$export$faadaf0198b97fbe(container, this.options.container);
            quill.container?.parentNode?.insertBefore(container, quill.container);
            this.container = container;
        } else if (typeof this.options.container === 'string') this.container = document.querySelector(this.options.container);
        else this.container = this.options.container;
        if (!(this.container instanceof HTMLElement)) {
            $b3a95f3cb1593e89$var$debug.error('Container required for toolbar', this.options);
            return;
        }
        this.container.classList.add('ql-toolbar');
        this.controls = [];
        this.handlers = {};
        if (this.options.handlers) Object.keys(this.options.handlers).forEach((format)=>{
            const handler = this.options.handlers?.[format];
            if (handler) this.addHandler(format, handler);
        });
        Array.from(this.container.querySelectorAll('button, select')).forEach((input)=>{
            // @ts-expect-error
            this.attach(input);
        });
        this.quill.on((0, $6deb74e67088b9aa$export$2e2bcd8739ae039).events.EDITOR_CHANGE, ()=>{
            const [range] = this.quill.selection.getRange(); // quill.getSelection triggers update
            this.update(range);
        });
    }
    addHandler(format, handler) {
        this.handlers[format] = handler;
    }
    attach(input) {
        let format = Array.from(input.classList).find((className)=>{
            return className.indexOf('ql-') === 0;
        });
        if (!format) return;
        format = format.slice(3);
        if (input.tagName === 'BUTTON') input.setAttribute('type', 'button');
        if (this.handlers[format] == null && this.quill.scroll.query(format) == null) {
            $b3a95f3cb1593e89$var$debug.warn('ignoring attaching to nonexistent format', format, input);
            return;
        }
        const eventName = input.tagName === 'SELECT' ? 'change' : 'click';
        input.addEventListener(eventName, (e)=>{
            let value;
            if (input.tagName === 'SELECT') {
                // @ts-expect-error
                if (input.selectedIndex < 0) return;
                // @ts-expect-error
                const selected = input.options[input.selectedIndex];
                if (selected.hasAttribute('selected')) value = false;
                else value = selected.value || false;
            } else {
                if (input.classList.contains('ql-active')) value = false;
                else // @ts-expect-error
                value = input.value || !input.hasAttribute('value');
                e.preventDefault();
            }
            this.quill.focus();
            const [range] = this.quill.selection.getRange();
            if (this.handlers[format] != null) this.handlers[format].call(this, value);
            else if (// @ts-expect-error
            this.quill.scroll.query(format).prototype instanceof (0, $e9fc1a5fcc0c5a1a$export$297a1fa96f55f00f)) {
                value = prompt(`Enter ${format}`); // eslint-disable-line no-alert
                if (!value) return;
                this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($b0994a93e93413e9$exports)))()// @ts-expect-error Fix me later
                .retain(range.index)// @ts-expect-error Fix me later
                .delete(range.length).insert({
                    [format]: value
                }), (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
            } else this.quill.format(format, value, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
            this.update(range);
        });
        this.controls.push([
            format,
            input
        ]);
    }
    update(range) {
        const formats = range == null ? {} : this.quill.getFormat(range);
        this.controls.forEach((pair)=>{
            const [format, input] = pair;
            if (input.tagName === 'SELECT') {
                let option = null;
                if (range == null) option = null;
                else if (formats[format] == null) option = input.querySelector('option[selected]');
                else if (!Array.isArray(formats[format])) {
                    let value = formats[format];
                    if (typeof value === 'string') value = value.replace(/"/g, '\\"');
                    option = input.querySelector(`option[value="${value}"]`);
                }
                if (option == null) {
                    // @ts-expect-error TODO fix me later
                    input.value = ''; // TODO make configurable?
                    // @ts-expect-error TODO fix me later
                    input.selectedIndex = -1;
                } else option.selected = true;
            } else if (range == null) {
                input.classList.remove('ql-active');
                input.setAttribute('aria-pressed', 'false');
            } else if (input.hasAttribute('value')) {
                // both being null should match (default values)
                // '1' should match with 1 (headers)
                const value = formats[format];
                const isActive = value === input.getAttribute('value') || value != null && value.toString() === input.getAttribute('value') || value == null && !input.getAttribute('value');
                input.classList.toggle('ql-active', isActive);
                input.setAttribute('aria-pressed', isActive.toString());
            } else {
                const isActive = formats[format] != null;
                input.classList.toggle('ql-active', isActive);
                input.setAttribute('aria-pressed', isActive.toString());
            }
        });
    }
}
$b3a95f3cb1593e89$export$2e2bcd8739ae039.DEFAULTS = {};
function $b3a95f3cb1593e89$var$addButton(container, format, value) {
    const input = document.createElement('button');
    input.setAttribute('type', 'button');
    input.classList.add(`ql-${format}`);
    input.setAttribute('aria-pressed', 'false');
    if (value != null) {
        input.value = value;
        input.setAttribute('aria-label', `${format}: ${value}`);
    } else input.setAttribute('aria-label', format);
    container.appendChild(input);
}
function $b3a95f3cb1593e89$export$faadaf0198b97fbe(container, groups) {
    if (!Array.isArray(groups[0])) // @ts-expect-error
    groups = [
        groups
    ];
    groups.forEach((controls)=>{
        const group = document.createElement('span');
        group.classList.add('ql-formats');
        controls.forEach((control)=>{
            if (typeof control === 'string') $b3a95f3cb1593e89$var$addButton(group, control);
            else {
                const format = Object.keys(control)[0];
                const value = control[format];
                if (Array.isArray(value)) $b3a95f3cb1593e89$var$addSelect(group, format, value);
                else $b3a95f3cb1593e89$var$addButton(group, format, value);
            }
        });
        container.appendChild(group);
    });
}
function $b3a95f3cb1593e89$var$addSelect(container, format, values) {
    const input = document.createElement('select');
    input.classList.add(`ql-${format}`);
    values.forEach((value)=>{
        const option = document.createElement('option');
        if (value !== false) option.setAttribute('value', String(value));
        else option.setAttribute('selected', 'selected');
        input.appendChild(option);
    });
    container.appendChild(input);
}
$b3a95f3cb1593e89$export$2e2bcd8739ae039.DEFAULTS = {
    container: null,
    handlers: {
        clean () {
            const range = this.quill.getSelection();
            if (range == null) return;
            if (range.length === 0) {
                const formats = this.quill.getFormat();
                Object.keys(formats).forEach((name)=>{
                    // Clean functionality in existing apps only clean inline formats
                    if (this.quill.scroll.query(name, (0, $e9fc1a5fcc0c5a1a$export$775b6bb06e53a214).INLINE) != null) this.quill.format(name, false, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
                });
            } else this.quill.removeFormat(range.index, range.length, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
        },
        direction (value) {
            const { align: align } = this.quill.getFormat();
            if (value === 'rtl' && align == null) this.quill.format('align', 'right', (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
            else if (!value && align === 'right') this.quill.format('align', false, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
            this.quill.format('direction', value, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
        },
        indent (value) {
            const range = this.quill.getSelection();
            // @ts-expect-error
            const formats = this.quill.getFormat(range);
            // @ts-expect-error
            const indent = parseInt(formats.indent || 0, 10);
            if (value === '+1' || value === '-1') {
                let modifier = value === '+1' ? 1 : -1;
                if (formats.direction === 'rtl') modifier *= -1;
                this.quill.format('indent', indent + modifier, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
            }
        },
        link (value) {
            if (value === true) value = prompt('Enter link URL:'); // eslint-disable-line no-alert
            this.quill.format('link', value, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
        },
        list (value) {
            const range = this.quill.getSelection();
            // @ts-expect-error
            const formats = this.quill.getFormat(range);
            if (value === 'check') {
                if (formats.list === 'checked' || formats.list === 'unchecked') this.quill.format('list', false, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
                else this.quill.format('list', 'unchecked', (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
            } else this.quill.format('list', value, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
        }
    }
};


const $2470f66f4bdbe1a0$var$alignLeftIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"13\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"9\" y1=\"4\" y2=\"4\"/></svg>";
const $2470f66f4bdbe1a0$var$alignCenterIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"14\" x2=\"4\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"12\" x2=\"6\" y1=\"4\" y2=\"4\"/></svg>";
const $2470f66f4bdbe1a0$var$alignRightIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"5\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"9\" y1=\"4\" y2=\"4\"/></svg>";
const $2470f66f4bdbe1a0$var$alignJustifyIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"4\" y2=\"4\"/></svg>";
const $2470f66f4bdbe1a0$var$backgroundIcon = "<svg viewbox=\"0 0 18 18\"><g class=\"ql-fill ql-color-label\"><polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"/><rect height=\"1\" width=\"1\" x=\"4\" y=\"4\"/><polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"6\"/><rect height=\"1\" width=\"1\" x=\"3\" y=\"5\"/><rect height=\"1\" width=\"1\" x=\"4\" y=\"7\"/><polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"12\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"9\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"15\"/><polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"/><rect height=\"1\" width=\"1\" x=\"3\" y=\"8\"/><path d=\"M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z\"/><path d=\"M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z\"/><path d=\"M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z\"/><rect height=\"1\" width=\"1\" x=\"12\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"11\" y=\"3\"/><path d=\"M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"3\"/><rect height=\"1\" width=\"1\" x=\"6\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"3\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"5\" y=\"3\"/><rect height=\"1\" width=\"1\" x=\"9\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"14\"/><polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"/><rect height=\"1\" width=\"1\" x=\"13\" y=\"7\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"5\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"6\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"8\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"9\"/><path d=\"M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"3\"/><polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"12\" y=\"5\"/><rect height=\"1\" width=\"1\" x=\"13\" y=\"4\"/><polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"/><rect height=\"1\" width=\"1\" x=\"9\" y=\"14\"/><rect height=\"1\" width=\"1\" x=\"8\" y=\"15\"/><path d=\"M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z\"/><rect height=\"1\" width=\"1\" x=\"5\" y=\"15\"/><path d=\"M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z\"/><rect height=\"1\" width=\"1\" x=\"11\" y=\"15\"/><path d=\"M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"15\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"11\"/></g><polyline class=\"ql-stroke\" points=\"5.5 13 9 5 12.5 13\"/><line class=\"ql-stroke\" x1=\"11.63\" x2=\"6.38\" y1=\"11\" y2=\"11\"/></svg>";
const $2470f66f4bdbe1a0$var$blockquoteIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-fill ql-stroke\" height=\"3\" width=\"3\" x=\"4\" y=\"5\"/><rect class=\"ql-fill ql-stroke\" height=\"3\" width=\"3\" x=\"11\" y=\"5\"/><path class=\"ql-even ql-fill ql-stroke\" d=\"M7,8c0,4.031-3,5-3,5\"/><path class=\"ql-even ql-fill ql-stroke\" d=\"M14,8c0,4.031-3,5-3,5\"/></svg>";
const $2470f66f4bdbe1a0$var$boldIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-stroke\" d=\"M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z\"/><path class=\"ql-stroke\" d=\"M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z\"/></svg>";
const $2470f66f4bdbe1a0$var$cleanIcon = "<svg class=\"\" viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"5\" x2=\"13\" y1=\"3\" y2=\"3\"/><line class=\"ql-stroke\" x1=\"6\" x2=\"9.35\" y1=\"12\" y2=\"3\"/><line class=\"ql-stroke\" x1=\"11\" x2=\"15\" y1=\"11\" y2=\"15\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"11\" y1=\"11\" y2=\"15\"/><rect class=\"ql-fill\" height=\"1\" rx=\"0.5\" ry=\"0.5\" width=\"7\" x=\"2\" y=\"14\"/></svg>";
const $2470f66f4bdbe1a0$var$codeIcon = "<svg viewbox=\"0 0 18 18\"><polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"/><polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"/><line class=\"ql-stroke\" x1=\"10\" x2=\"8\" y1=\"5\" y2=\"13\"/></svg>";
const $2470f66f4bdbe1a0$var$colorIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-color-label ql-stroke ql-transparent\" x1=\"3\" x2=\"15\" y1=\"15\" y2=\"15\"/><polyline class=\"ql-stroke\" points=\"5.5 11 9 3 12.5 11\"/><line class=\"ql-stroke\" x1=\"11.63\" x2=\"6.38\" y1=\"9\" y2=\"9\"/></svg>";
const $2470f66f4bdbe1a0$var$directionLeftToRightIcon = "<svg viewbox=\"0 0 18 18\"><polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"/><line class=\"ql-stroke ql-fill\" x1=\"15\" x2=\"11\" y1=\"4\" y2=\"4\"/><path class=\"ql-fill\" d=\"M11,3a3,3,0,0,0,0,6h1V3H11Z\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"11\" y=\"4\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"13\" y=\"4\"/></svg>";
const $2470f66f4bdbe1a0$var$directionRightToLeftIcon = "<svg viewbox=\"0 0 18 18\"><polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"/><line class=\"ql-stroke ql-fill\" x1=\"9\" x2=\"5\" y1=\"4\" y2=\"4\"/><path class=\"ql-fill\" d=\"M5,3A3,3,0,0,0,5,9H6V3H5Z\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"5\" y=\"4\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"7\" y=\"4\"/></svg>";
const $2470f66f4bdbe1a0$var$formulaIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z\"/><rect class=\"ql-fill\" height=\"1.6\" rx=\"0.8\" ry=\"0.8\" width=\"5\" x=\"5.15\" y=\"6.2\"/><path class=\"ql-fill\" d=\"M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z\"/></svg>";
const $2470f66f4bdbe1a0$var$headerIcon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z\"/></svg>";
const $2470f66f4bdbe1a0$var$header2Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z\"/></svg>";
const $2470f66f4bdbe1a0$var$header3Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M16.65186,12.30664a2.6742,2.6742,0,0,1-2.915,2.68457,3.96592,3.96592,0,0,1-2.25537-.6709.56007.56007,0,0,1-.13232-.83594L11.64648,13c.209-.34082.48389-.36328.82471-.1543a2.32654,2.32654,0,0,0,1.12256.33008c.71484,0,1.12207-.35156,1.12207-.78125,0-.61523-.61621-.86816-1.46338-.86816H13.2085a.65159.65159,0,0,1-.68213-.41895l-.05518-.10937a.67114.67114,0,0,1,.14307-.78125l.71533-.86914a8.55289,8.55289,0,0,1,.68213-.7373V8.58887a3.93913,3.93913,0,0,1-.748.05469H11.9873a.54085.54085,0,0,1-.605-.60547V7.59863a.54085.54085,0,0,1,.605-.60547h3.75146a.53773.53773,0,0,1,.60547.59375v.17676a1.03723,1.03723,0,0,1-.27539.748L14.74854,10.0293A2.31132,2.31132,0,0,1,16.65186,12.30664ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z\"/></svg>";
const $2470f66f4bdbe1a0$var$header4Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm7.05371,7.96582v.38477c0,.39648-.165.60547-.46191.60547h-.47314v1.29785a.54085.54085,0,0,1-.605.60547h-.69336a.54085.54085,0,0,1-.605-.60547V12.95605H11.333a.5412.5412,0,0,1-.60547-.60547v-.15332a1.199,1.199,0,0,1,.22021-.748l2.56348-4.05957a.7819.7819,0,0,1,.72607-.39648h1.27637a.54085.54085,0,0,1,.605.60547v3.7627h.33008A.54055.54055,0,0,1,17.05371,11.96582ZM14.28125,8.7207h-.022a4.18969,4.18969,0,0,1-.38525.81348l-1.188,1.80469v.02246h1.5293V9.60059A7.04058,7.04058,0,0,1,14.28125,8.7207Z\"/></svg>";
const $2470f66f4bdbe1a0$var$header5Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M16.74023,12.18555a2.75131,2.75131,0,0,1-2.91553,2.80566,3.908,3.908,0,0,1-2.25537-.68164.54809.54809,0,0,1-.13184-.8252L11.73438,13c.209-.34082.48389-.36328.8252-.1543a2.23757,2.23757,0,0,0,1.1001.33008,1.01827,1.01827,0,0,0,1.1001-.96777c0-.61621-.53906-.97949-1.25439-.97949a2.15554,2.15554,0,0,0-.64893.09961,1.15209,1.15209,0,0,1-.814.01074l-.12109-.04395a.64116.64116,0,0,1-.45117-.71484l.231-3.00391a.56666.56666,0,0,1,.62744-.583H15.541a.54085.54085,0,0,1,.605.60547v.43945a.54085.54085,0,0,1-.605.60547H13.41748l-.04395.72559a1.29306,1.29306,0,0,1-.04395.30859h.022a2.39776,2.39776,0,0,1,.57227-.07715A2.53266,2.53266,0,0,1,16.74023,12.18555ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z\"/></svg>";
const $2470f66f4bdbe1a0$var$header6Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M14.51758,9.64453a1.85627,1.85627,0,0,0-1.24316.38477H13.252a1.73532,1.73532,0,0,1,1.72754-1.4082,2.66491,2.66491,0,0,1,.5498.06641c.35254.05469.57227.01074.70508-.40723l.16406-.5166a.53393.53393,0,0,0-.373-.75977,4.83723,4.83723,0,0,0-1.17773-.14258c-2.43164,0-3.7627,2.17773-3.7627,4.43359,0,2.47559,1.60645,3.69629,3.19043,3.69629A2.70585,2.70585,0,0,0,16.96,12.19727,2.43861,2.43861,0,0,0,14.51758,9.64453Zm-.23047,3.58691c-.67187,0-1.22168-.81445-1.22168-1.45215,0-.47363.30762-.583.72559-.583.96875,0,1.27734.59375,1.27734,1.12207A.82182.82182,0,0,1,14.28711,13.23145ZM10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Z\"/></svg>";
const $2470f66f4bdbe1a0$var$italicIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"7\" x2=\"13\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"5\" x2=\"11\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"8\" x2=\"10\" y1=\"14\" y2=\"4\"/></svg>";
const $2470f66f4bdbe1a0$var$imageIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-stroke\" height=\"10\" width=\"12\" x=\"3\" y=\"4\"/><circle class=\"ql-fill\" cx=\"6\" cy=\"7\" r=\"1\"/><polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"/></svg>";
const $2470f66f4bdbe1a0$var$indentIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"9\" y2=\"9\"/><polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"/></svg>";
const $2470f66f4bdbe1a0$var$outdentIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"9\" y2=\"9\"/><polyline class=\"ql-stroke\" points=\"5 7 5 11 3 9 5 7\"/></svg>";
const $2470f66f4bdbe1a0$var$linkIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"7\" x2=\"11\" y1=\"7\" y2=\"11\"/><path class=\"ql-even ql-stroke\" d=\"M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z\"/><path class=\"ql-even ql-stroke\" d=\"M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z\"/></svg>";
const $2470f66f4bdbe1a0$var$listBulletIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"6\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"6\" x2=\"15\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"6\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"3\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"3\" y1=\"14\" y2=\"14\"/></svg>";
const $2470f66f4bdbe1a0$var$listCheckIcon = "<svg class=\"\" viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"4\" y2=\"4\"/><polyline class=\"ql-stroke\" points=\"3 4 4 5 6 3\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"14\" y2=\"14\"/><polyline class=\"ql-stroke\" points=\"3 14 4 15 6 13\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"9\" y2=\"9\"/><polyline class=\"ql-stroke\" points=\"3 9 4 10 6 8\"/></svg>";
const $2470f66f4bdbe1a0$var$listOrderedIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"7\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"7\" x2=\"15\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"7\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke ql-thin\" x1=\"2.5\" x2=\"4.5\" y1=\"5.5\" y2=\"5.5\"/><path class=\"ql-fill\" d=\"M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z\"/><path class=\"ql-stroke ql-thin\" d=\"M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156\"/><path class=\"ql-stroke ql-thin\" d=\"M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109\"/></svg>";
const $2470f66f4bdbe1a0$var$subscriptIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z\"/><path class=\"ql-fill\" d=\"M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z\"/></svg>";
const $2470f66f4bdbe1a0$var$superscriptIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z\"/><path class=\"ql-fill\" d=\"M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z\"/></svg>";
const $2470f66f4bdbe1a0$var$strikeIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke ql-thin\" x1=\"15.5\" x2=\"2.5\" y1=\"8.5\" y2=\"9.5\"/><path class=\"ql-fill\" d=\"M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z\"/><path class=\"ql-fill\" d=\"M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z\"/></svg>";
const $2470f66f4bdbe1a0$var$tableIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-stroke\" height=\"12\" width=\"12\" x=\"3\" y=\"3\"/><rect class=\"ql-fill\" height=\"2\" width=\"3\" x=\"5\" y=\"5\"/><rect class=\"ql-fill\" height=\"2\" width=\"4\" x=\"9\" y=\"5\"/><g class=\"ql-fill ql-transparent\"><rect height=\"2\" width=\"3\" x=\"5\" y=\"8\"/><rect height=\"2\" width=\"4\" x=\"9\" y=\"8\"/><rect height=\"2\" width=\"3\" x=\"5\" y=\"11\"/><rect height=\"2\" width=\"4\" x=\"9\" y=\"11\"/></g></svg>";
const $2470f66f4bdbe1a0$var$underlineIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-stroke\" d=\"M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3\"/><rect class=\"ql-fill\" height=\"1\" rx=\"0.5\" ry=\"0.5\" width=\"12\" x=\"3\" y=\"15\"/></svg>";
const $2470f66f4bdbe1a0$var$videoIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-stroke\" height=\"12\" width=\"12\" x=\"3\" y=\"3\"/><rect class=\"ql-fill\" height=\"12\" width=\"1\" x=\"5\" y=\"3\"/><rect class=\"ql-fill\" height=\"12\" width=\"1\" x=\"12\" y=\"3\"/><rect class=\"ql-fill\" height=\"2\" width=\"8\" x=\"5\" y=\"8\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"5\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"7\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"10\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"12\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"5\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"7\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"10\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"12\"/></svg>";
var $2470f66f4bdbe1a0$export$2e2bcd8739ae039 = {
    align: {
        '': $2470f66f4bdbe1a0$var$alignLeftIcon,
        center: $2470f66f4bdbe1a0$var$alignCenterIcon,
        right: $2470f66f4bdbe1a0$var$alignRightIcon,
        justify: $2470f66f4bdbe1a0$var$alignJustifyIcon
    },
    background: $2470f66f4bdbe1a0$var$backgroundIcon,
    blockquote: $2470f66f4bdbe1a0$var$blockquoteIcon,
    bold: $2470f66f4bdbe1a0$var$boldIcon,
    clean: $2470f66f4bdbe1a0$var$cleanIcon,
    code: $2470f66f4bdbe1a0$var$codeIcon,
    'code-block': $2470f66f4bdbe1a0$var$codeIcon,
    color: $2470f66f4bdbe1a0$var$colorIcon,
    direction: {
        '': $2470f66f4bdbe1a0$var$directionLeftToRightIcon,
        rtl: $2470f66f4bdbe1a0$var$directionRightToLeftIcon
    },
    formula: $2470f66f4bdbe1a0$var$formulaIcon,
    header: {
        '1': $2470f66f4bdbe1a0$var$headerIcon,
        '2': $2470f66f4bdbe1a0$var$header2Icon,
        '3': $2470f66f4bdbe1a0$var$header3Icon,
        '4': $2470f66f4bdbe1a0$var$header4Icon,
        '5': $2470f66f4bdbe1a0$var$header5Icon,
        '6': $2470f66f4bdbe1a0$var$header6Icon
    },
    italic: $2470f66f4bdbe1a0$var$italicIcon,
    image: $2470f66f4bdbe1a0$var$imageIcon,
    indent: {
        '+1': $2470f66f4bdbe1a0$var$indentIcon,
        '-1': $2470f66f4bdbe1a0$var$outdentIcon
    },
    link: $2470f66f4bdbe1a0$var$linkIcon,
    list: {
        bullet: $2470f66f4bdbe1a0$var$listBulletIcon,
        check: $2470f66f4bdbe1a0$var$listCheckIcon,
        ordered: $2470f66f4bdbe1a0$var$listOrderedIcon
    },
    script: {
        sub: $2470f66f4bdbe1a0$var$subscriptIcon,
        super: $2470f66f4bdbe1a0$var$superscriptIcon
    },
    strike: $2470f66f4bdbe1a0$var$strikeIcon,
    table: $2470f66f4bdbe1a0$var$tableIcon,
    underline: $2470f66f4bdbe1a0$var$underlineIcon,
    video: $2470f66f4bdbe1a0$var$videoIcon
};


const $e72566574ad77262$var$DropdownIcon = "<svg viewbox=\"0 0 18 18\"><polygon class=\"ql-stroke\" points=\"7 11 9 13 11 11 7 11\"/><polygon class=\"ql-stroke\" points=\"7 7 9 5 11 7 7 7\"/></svg>";
let $e72566574ad77262$var$optionsCounter = 0;
function $e72566574ad77262$var$toggleAriaAttribute(element, attribute) {
    element.setAttribute(attribute, `${!(element.getAttribute(attribute) === 'true')}`);
}
class $e72566574ad77262$var$Picker {
    constructor(select){
        this.select = select;
        this.container = document.createElement('span');
        this.buildPicker();
        this.select.style.display = 'none';
        // @ts-expect-error Fix me later
        this.select.parentNode.insertBefore(this.container, this.select);
        this.label.addEventListener('mousedown', ()=>{
            this.togglePicker();
        });
        this.label.addEventListener('keydown', (event)=>{
            switch(event.key){
                case 'Enter':
                    this.togglePicker();
                    break;
                case 'Escape':
                    this.escape();
                    event.preventDefault();
                    break;
                default:
            }
        });
        this.select.addEventListener('change', this.update.bind(this));
    }
    togglePicker() {
        this.container.classList.toggle('ql-expanded');
        // Toggle aria-expanded and aria-hidden to make the picker accessible
        $e72566574ad77262$var$toggleAriaAttribute(this.label, 'aria-expanded');
        // @ts-expect-error
        $e72566574ad77262$var$toggleAriaAttribute(this.options, 'aria-hidden');
    }
    buildItem(option) {
        const item = document.createElement('span');
        // @ts-expect-error
        item.tabIndex = '0';
        item.setAttribute('role', 'button');
        item.classList.add('ql-picker-item');
        const value = option.getAttribute('value');
        if (value) item.setAttribute('data-value', value);
        if (option.textContent) item.setAttribute('data-label', option.textContent);
        item.addEventListener('click', ()=>{
            this.selectItem(item, true);
        });
        item.addEventListener('keydown', (event)=>{
            switch(event.key){
                case 'Enter':
                    this.selectItem(item, true);
                    event.preventDefault();
                    break;
                case 'Escape':
                    this.escape();
                    event.preventDefault();
                    break;
                default:
            }
        });
        return item;
    }
    buildLabel() {
        const label = document.createElement('span');
        label.classList.add('ql-picker-label');
        label.innerHTML = $e72566574ad77262$var$DropdownIcon;
        // @ts-expect-error
        label.tabIndex = '0';
        label.setAttribute('role', 'button');
        label.setAttribute('aria-expanded', 'false');
        this.container.appendChild(label);
        return label;
    }
    buildOptions() {
        const options = document.createElement('span');
        options.classList.add('ql-picker-options');
        // Don't want screen readers to read this until options are visible
        options.setAttribute('aria-hidden', 'true');
        // @ts-expect-error
        options.tabIndex = '-1';
        // Need a unique id for aria-controls
        options.id = `ql-picker-options-${$e72566574ad77262$var$optionsCounter}`;
        $e72566574ad77262$var$optionsCounter += 1;
        this.label.setAttribute('aria-controls', options.id);
        // @ts-expect-error
        this.options = options;
        Array.from(this.select.options).forEach((option)=>{
            const item = this.buildItem(option);
            options.appendChild(item);
            if (option.selected === true) this.selectItem(item);
        });
        this.container.appendChild(options);
    }
    buildPicker() {
        Array.from(this.select.attributes).forEach((item)=>{
            this.container.setAttribute(item.name, item.value);
        });
        this.container.classList.add('ql-picker');
        this.label = this.buildLabel();
        this.buildOptions();
    }
    escape() {
        // Close menu and return focus to trigger label
        this.close();
        // Need setTimeout for accessibility to ensure that the browser executes
        // focus on the next process thread and after any DOM content changes
        setTimeout(()=>this.label.focus(), 1);
    }
    close() {
        this.container.classList.remove('ql-expanded');
        this.label.setAttribute('aria-expanded', 'false');
        // @ts-expect-error
        this.options.setAttribute('aria-hidden', 'true');
    }
    selectItem(item) {
        let trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        const selected = this.container.querySelector('.ql-selected');
        if (item === selected) return;
        if (selected != null) selected.classList.remove('ql-selected');
        if (item == null) return;
        item.classList.add('ql-selected');
        // @ts-expect-error Fix me later
        this.select.selectedIndex = Array.from(item.parentNode.children).indexOf(item);
        if (item.hasAttribute('data-value')) // @ts-expect-error Fix me later
        this.label.setAttribute('data-value', item.getAttribute('data-value'));
        else this.label.removeAttribute('data-value');
        if (item.hasAttribute('data-label')) // @ts-expect-error Fix me later
        this.label.setAttribute('data-label', item.getAttribute('data-label'));
        else this.label.removeAttribute('data-label');
        if (trigger) {
            this.select.dispatchEvent(new Event('change'));
            this.close();
        }
    }
    update() {
        let option;
        if (this.select.selectedIndex > -1) {
            const item = // @ts-expect-error Fix me later
            this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
            option = this.select.options[this.select.selectedIndex];
            // @ts-expect-error
            this.selectItem(item);
        } else this.selectItem(null);
        const isActive = option != null && option !== this.select.querySelector('option[selected]');
        this.label.classList.toggle('ql-active', isActive);
    }
}
var $e72566574ad77262$export$2e2bcd8739ae039 = $e72566574ad77262$var$Picker;



class $0146ce344c2320cb$var$ColorPicker extends (0, $e72566574ad77262$export$2e2bcd8739ae039) {
    constructor(select, label){
        super(select);
        this.label.innerHTML = label;
        this.container.classList.add('ql-color-picker');
        Array.from(this.container.querySelectorAll('.ql-picker-item')).slice(0, 7).forEach((item)=>{
            item.classList.add('ql-primary');
        });
    }
    buildItem(option) {
        const item = super.buildItem(option);
        item.style.backgroundColor = option.getAttribute('value') || '';
        return item;
    }
    selectItem(item, trigger) {
        super.selectItem(item, trigger);
        const colorLabel = this.label.querySelector('.ql-color-label');
        const value = item ? item.getAttribute('data-value') || '' : '';
        if (colorLabel) {
            if (colorLabel.tagName === 'line') colorLabel.style.stroke = value;
            else colorLabel.style.fill = value;
        }
    }
}
var $0146ce344c2320cb$export$2e2bcd8739ae039 = $0146ce344c2320cb$var$ColorPicker;



class $7aa5648e4401f9cb$var$IconPicker extends (0, $e72566574ad77262$export$2e2bcd8739ae039) {
    constructor(select, icons){
        super(select);
        this.container.classList.add('ql-icon-picker');
        Array.from(this.container.querySelectorAll('.ql-picker-item')).forEach((item)=>{
            item.innerHTML = icons[item.getAttribute('data-value') || ''];
        });
        this.defaultItem = this.container.querySelector('.ql-selected');
        this.selectItem(this.defaultItem);
    }
    selectItem(target, trigger) {
        super.selectItem(target, trigger);
        const item = target || this.defaultItem;
        if (item != null) {
            if (this.label.innerHTML === item.innerHTML) return;
            this.label.innerHTML = item.innerHTML;
        }
    }
}
var $7aa5648e4401f9cb$export$2e2bcd8739ae039 = $7aa5648e4401f9cb$var$IconPicker;


const $ca08744a7134d72c$var$isScrollable = (el)=>{
    const { overflowY: overflowY } = getComputedStyle(el, null);
    return overflowY !== 'visible' && overflowY !== 'clip';
};
class $ca08744a7134d72c$var$Tooltip {
    constructor(quill, boundsContainer){
        this.quill = quill;
        this.boundsContainer = boundsContainer || document.body;
        this.root = quill.addContainer('ql-tooltip');
        // @ts-expect-error
        this.root.innerHTML = this.constructor.TEMPLATE;
        if ($ca08744a7134d72c$var$isScrollable(this.quill.root)) this.quill.root.addEventListener('scroll', ()=>{
            this.root.style.marginTop = `${-1 * this.quill.root.scrollTop}px`;
        });
        this.hide();
    }
    hide() {
        this.root.classList.add('ql-hidden');
    }
    position(reference) {
        const left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
        // root.scrollTop should be 0 if scrollContainer !== root
        const top = reference.bottom + this.quill.root.scrollTop;
        this.root.style.left = `${left}px`;
        this.root.style.top = `${top}px`;
        this.root.classList.remove('ql-flip');
        const containerBounds = this.boundsContainer.getBoundingClientRect();
        const rootBounds = this.root.getBoundingClientRect();
        let shift = 0;
        if (rootBounds.right > containerBounds.right) {
            shift = containerBounds.right - rootBounds.right;
            this.root.style.left = `${left + shift}px`;
        }
        if (rootBounds.left < containerBounds.left) {
            shift = containerBounds.left - rootBounds.left;
            this.root.style.left = `${left + shift}px`;
        }
        if (rootBounds.bottom > containerBounds.bottom) {
            const height = rootBounds.bottom - rootBounds.top;
            const verticalShift = reference.bottom - reference.top + height;
            this.root.style.top = `${top - verticalShift}px`;
            this.root.classList.add('ql-flip');
        }
        return shift;
    }
    show() {
        this.root.classList.remove('ql-editing');
        this.root.classList.remove('ql-hidden');
    }
}
var $ca08744a7134d72c$export$2e2bcd8739ae039 = $ca08744a7134d72c$var$Tooltip;











const $2dbb93d44018f276$var$ALIGNS = [
    false,
    'center',
    'right',
    'justify'
];
const $2dbb93d44018f276$var$COLORS = [
    '#000000',
    '#e60000',
    '#ff9900',
    '#ffff00',
    '#008a00',
    '#0066cc',
    '#9933ff',
    '#ffffff',
    '#facccc',
    '#ffebcc',
    '#ffffcc',
    '#cce8cc',
    '#cce0f5',
    '#ebd6ff',
    '#bbbbbb',
    '#f06666',
    '#ffc266',
    '#ffff66',
    '#66b966',
    '#66a3e0',
    '#c285ff',
    '#888888',
    '#a10000',
    '#b26b00',
    '#b2b200',
    '#006100',
    '#0047b2',
    '#6b24b2',
    '#444444',
    '#5c0000',
    '#663d00',
    '#666600',
    '#003700',
    '#002966',
    '#3d1466'
];
const $2dbb93d44018f276$var$FONTS = [
    false,
    'serif',
    'monospace'
];
const $2dbb93d44018f276$var$HEADERS = [
    '1',
    '2',
    '3',
    false
];
const $2dbb93d44018f276$var$SIZES = [
    'small',
    false,
    'large',
    'huge'
];
class $2dbb93d44018f276$export$2e2bcd8739ae039 extends (0, $edba63c8388b93cb$export$2e2bcd8739ae039) {
    constructor(quill, options){
        super(quill, options);
        const listener = (e)=>{
            if (!document.body.contains(quill.root)) {
                document.body.removeEventListener('click', listener);
                return;
            }
            if (this.tooltip != null && // @ts-expect-error
            !this.tooltip.root.contains(e.target) && // @ts-expect-error
            document.activeElement !== this.tooltip.textbox && !this.quill.hasFocus()) this.tooltip.hide();
            if (this.pickers != null) this.pickers.forEach((picker)=>{
                // @ts-expect-error
                if (!picker.container.contains(e.target)) picker.close();
            });
        };
        quill.emitter.listenDOM('click', document.body, listener);
    }
    addModule(name) {
        const module = super.addModule(name);
        if (name === 'toolbar') // @ts-expect-error
        this.extendToolbar(module);
        return module;
    }
    buildButtons(buttons, icons) {
        Array.from(buttons).forEach((button)=>{
            const className = button.getAttribute('class') || '';
            className.split(/\s+/).forEach((name)=>{
                if (!name.startsWith('ql-')) return;
                name = name.slice(3);
                if (icons[name] == null) return;
                if (name === 'direction') // @ts-expect-error
                button.innerHTML = icons[name][''] + icons[name].rtl;
                else if (typeof icons[name] === 'string') // @ts-expect-error
                button.innerHTML = icons[name];
                else {
                    // @ts-expect-error
                    const value = button.value || '';
                    // @ts-expect-error
                    if (value != null && icons[name][value]) // @ts-expect-error
                    button.innerHTML = icons[name][value];
                }
            });
        });
    }
    buildPickers(selects, icons) {
        this.pickers = Array.from(selects).map((select)=>{
            if (select.classList.contains('ql-align')) {
                if (select.querySelector('option') == null) $2dbb93d44018f276$var$fillSelect(select, $2dbb93d44018f276$var$ALIGNS);
                if (typeof icons.align === 'object') return new (0, $7aa5648e4401f9cb$export$2e2bcd8739ae039)(select, icons.align);
            }
            if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
                const format = select.classList.contains('ql-background') ? 'background' : 'color';
                if (select.querySelector('option') == null) $2dbb93d44018f276$var$fillSelect(select, $2dbb93d44018f276$var$COLORS, format === 'background' ? '#ffffff' : '#000000');
                return new (0, $0146ce344c2320cb$export$2e2bcd8739ae039)(select, icons[format]);
            }
            if (select.querySelector('option') == null) {
                if (select.classList.contains('ql-font')) $2dbb93d44018f276$var$fillSelect(select, $2dbb93d44018f276$var$FONTS);
                else if (select.classList.contains('ql-header')) $2dbb93d44018f276$var$fillSelect(select, $2dbb93d44018f276$var$HEADERS);
                else if (select.classList.contains('ql-size')) $2dbb93d44018f276$var$fillSelect(select, $2dbb93d44018f276$var$SIZES);
            }
            return new (0, $e72566574ad77262$export$2e2bcd8739ae039)(select);
        });
        const update = ()=>{
            this.pickers.forEach((picker)=>{
                picker.update();
            });
        };
        this.quill.on((0, $ba29015e3d87cf52$export$2e2bcd8739ae039).events.EDITOR_CHANGE, update);
    }
}
$2dbb93d44018f276$export$2e2bcd8739ae039.DEFAULTS = (0, $e60eefbf4c36c7e0$export$2e2bcd8739ae039)({}, (0, $edba63c8388b93cb$export$2e2bcd8739ae039).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                formula () {
                    this.quill.theme.tooltip.edit('formula');
                },
                image () {
                    let fileInput = this.container.querySelector('input.ql-image[type=file]');
                    if (fileInput == null) {
                        fileInput = document.createElement('input');
                        fileInput.setAttribute('type', 'file');
                        fileInput.setAttribute('accept', this.quill.uploader.options.mimetypes.join(', '));
                        fileInput.classList.add('ql-image');
                        fileInput.addEventListener('change', ()=>{
                            const range = this.quill.getSelection(true);
                            this.quill.uploader.upload(range, fileInput.files);
                            fileInput.value = '';
                        });
                        this.container.appendChild(fileInput);
                    }
                    fileInput.click();
                },
                video () {
                    this.quill.theme.tooltip.edit('video');
                }
            }
        }
    }
});
class $2dbb93d44018f276$export$ba0102162f9e195c extends (0, $ca08744a7134d72c$export$2e2bcd8739ae039) {
    constructor(quill, boundsContainer){
        super(quill, boundsContainer);
        this.textbox = this.root.querySelector('input[type="text"]');
        this.listen();
    }
    listen() {
        // @ts-expect-error Fix me later
        this.textbox.addEventListener('keydown', (event)=>{
            if (event.key === 'Enter') {
                this.save();
                event.preventDefault();
            } else if (event.key === 'Escape') {
                this.cancel();
                event.preventDefault();
            }
        });
    }
    cancel() {
        this.hide();
        this.restoreFocus();
    }
    edit() {
        let mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
        let preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        this.root.classList.remove('ql-hidden');
        this.root.classList.add('ql-editing');
        if (this.textbox == null) return;
        if (preview != null) this.textbox.value = preview;
        else if (mode !== this.root.getAttribute('data-mode')) this.textbox.value = '';
        const bounds = this.quill.getBounds(this.quill.selection.savedRange);
        if (bounds != null) this.position(bounds);
        this.textbox.select();
        this.textbox.setAttribute('placeholder', this.textbox.getAttribute(`data-${mode}`) || '');
        this.root.setAttribute('data-mode', mode);
    }
    restoreFocus() {
        this.quill.focus({
            preventScroll: true
        });
    }
    save() {
        // @ts-expect-error Fix me later
        let { value: value } = this.textbox;
        switch(this.root.getAttribute('data-mode')){
            case 'link':
                {
                    const { scrollTop: scrollTop } = this.quill.root;
                    if (this.linkRange) {
                        this.quill.formatText(this.linkRange, 'link', value, (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.USER);
                        delete this.linkRange;
                    } else {
                        this.restoreFocus();
                        this.quill.format('link', value, (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.USER);
                    }
                    this.quill.root.scrollTop = scrollTop;
                    break;
                }
            case 'video':
                value = $2dbb93d44018f276$var$extractVideoUrl(value);
            // eslint-disable-next-line no-fallthrough
            case 'formula':
                {
                    if (!value) break;
                    const range = this.quill.getSelection(true);
                    if (range != null) {
                        const index = range.index + range.length;
                        this.quill.insertEmbed(index, // @ts-expect-error Fix me later
                        this.root.getAttribute('data-mode'), value, (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.USER);
                        if (this.root.getAttribute('data-mode') === 'formula') this.quill.insertText(index + 1, ' ', (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.USER);
                        this.quill.setSelection(index + 2, (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.USER);
                    }
                    break;
                }
            default:
        }
        // @ts-expect-error Fix me later
        this.textbox.value = '';
        this.hide();
    }
}
function $2dbb93d44018f276$var$extractVideoUrl(url) {
    let match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
    if (match) return `${match[1] || 'https'}://www.youtube.com/embed/${match[2]}?showinfo=0`;
    // eslint-disable-next-line no-cond-assign
    if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) return `${match[1] || 'https'}://player.vimeo.com/video/${match[2]}/`;
    return url;
}
function $2dbb93d44018f276$var$fillSelect(select, values) {
    let defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    values.forEach((value)=>{
        const option = document.createElement('option');
        if (value === defaultValue) option.setAttribute('selected', 'selected');
        else option.setAttribute('value', String(value));
        select.appendChild(option);
    });
}





const $51cedb9b3593e7db$var$TOOLBAR_CONFIG = [
    [
        'bold',
        'italic',
        'link'
    ],
    [
        {
            header: 1
        },
        {
            header: 2
        },
        'blockquote'
    ]
];
class $51cedb9b3593e7db$export$572b56f7a5e9813a extends (0, $2dbb93d44018f276$export$ba0102162f9e195c) {
    static TEMPLATE = [
        '<span class="ql-tooltip-arrow"></span>',
        '<div class="ql-tooltip-editor">',
        '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
        '<a class="ql-close"></a>',
        '</div>'
    ].join('');
    constructor(quill, bounds){
        super(quill, bounds);
        this.quill.on((0, $ba29015e3d87cf52$export$2e2bcd8739ae039).events.EDITOR_CHANGE, (type, range, oldRange, source)=>{
            if (type !== (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).events.SELECTION_CHANGE) return;
            if (range != null && range.length > 0 && source === (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.USER) {
                this.show();
                // Lock our width so we will expand beyond our offsetParent boundaries
                this.root.style.left = '0px';
                this.root.style.width = '';
                this.root.style.width = `${this.root.offsetWidth}px`;
                const lines = this.quill.getLines(range.index, range.length);
                if (lines.length === 1) {
                    const bounds = this.quill.getBounds(range);
                    if (bounds != null) this.position(bounds);
                } else {
                    const lastLine = lines[lines.length - 1];
                    const index = this.quill.getIndex(lastLine);
                    const length = Math.min(lastLine.length() - 1, range.index + range.length - index);
                    const indexBounds = this.quill.getBounds(new (0, $89ce7bdd8fd0c5db$export$9a58ef0d7ad3278c)(index, length));
                    if (indexBounds != null) this.position(indexBounds);
                }
            } else if (document.activeElement !== this.textbox && this.quill.hasFocus()) this.hide();
        });
    }
    listen() {
        super.listen();
        // @ts-expect-error Fix me later
        this.root.querySelector('.ql-close').addEventListener('click', ()=>{
            this.root.classList.remove('ql-editing');
        });
        this.quill.on((0, $ba29015e3d87cf52$export$2e2bcd8739ae039).events.SCROLL_OPTIMIZE, ()=>{
            // Let selection be restored by toolbar handlers before repositioning
            setTimeout(()=>{
                if (this.root.classList.contains('ql-hidden')) return;
                const range = this.quill.getSelection();
                if (range != null) {
                    const bounds = this.quill.getBounds(range);
                    if (bounds != null) this.position(bounds);
                }
            }, 1);
        });
    }
    cancel() {
        this.show();
    }
    position(reference) {
        const shift = super.position(reference);
        const arrow = this.root.querySelector('.ql-tooltip-arrow');
        // @ts-expect-error
        arrow.style.marginLeft = '';
        if (shift !== 0) // @ts-expect-error
        arrow.style.marginLeft = `${-1 * shift - arrow.offsetWidth / 2}px`;
        return shift;
    }
}
class $51cedb9b3593e7db$export$2e2bcd8739ae039 extends (0, $2dbb93d44018f276$export$2e2bcd8739ae039) {
    constructor(quill, options){
        if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = $51cedb9b3593e7db$var$TOOLBAR_CONFIG;
        super(quill, options);
        this.quill.container.classList.add('ql-bubble');
    }
    extendToolbar(toolbar) {
        // @ts-expect-error
        this.tooltip = new $51cedb9b3593e7db$export$572b56f7a5e9813a(this.quill, this.options.bounds);
        if (toolbar.container != null) {
            this.tooltip.root.appendChild(toolbar.container);
            this.buildButtons(toolbar.container.querySelectorAll('button'), (0, $2470f66f4bdbe1a0$export$2e2bcd8739ae039));
            this.buildPickers(toolbar.container.querySelectorAll('select'), (0, $2470f66f4bdbe1a0$export$2e2bcd8739ae039));
        }
    }
}
$51cedb9b3593e7db$export$2e2bcd8739ae039.DEFAULTS = (0, $e60eefbf4c36c7e0$export$2e2bcd8739ae039)({}, (0, $2dbb93d44018f276$export$2e2bcd8739ae039).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                link (value) {
                    if (!value) this.quill.format('link', false, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
                    else // @ts-expect-error
                    this.quill.theme.tooltip.edit();
                }
            }
        }
    }
});









const $8ce15944b058c9a7$var$TOOLBAR_CONFIG = [
    [
        {
            header: [
                '1',
                '2',
                '3',
                false
            ]
        }
    ],
    [
        'bold',
        'italic',
        'underline',
        'link'
    ],
    [
        {
            list: 'ordered'
        },
        {
            list: 'bullet'
        }
    ],
    [
        'clean'
    ]
];
class $8ce15944b058c9a7$var$SnowTooltip extends (0, $2dbb93d44018f276$export$ba0102162f9e195c) {
    static TEMPLATE = [
        '<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>',
        '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
        '<a class="ql-action"></a>',
        '<a class="ql-remove"></a>'
    ].join('');
    preview = this.root.querySelector('a.ql-preview');
    listen() {
        super.listen();
        // @ts-expect-error Fix me later
        this.root.querySelector('a.ql-action').addEventListener('click', (event)=>{
            if (this.root.classList.contains('ql-editing')) this.save();
            else // @ts-expect-error Fix me later
            this.edit('link', this.preview.textContent);
            event.preventDefault();
        });
        // @ts-expect-error Fix me later
        this.root.querySelector('a.ql-remove').addEventListener('click', (event)=>{
            if (this.linkRange != null) {
                const range = this.linkRange;
                this.restoreFocus();
                this.quill.formatText(range, 'link', false, (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.USER);
                delete this.linkRange;
            }
            event.preventDefault();
            this.hide();
        });
        this.quill.on((0, $ba29015e3d87cf52$export$2e2bcd8739ae039).events.SELECTION_CHANGE, (range, oldRange, source)=>{
            if (range == null) return;
            if (range.length === 0 && source === (0, $ba29015e3d87cf52$export$2e2bcd8739ae039).sources.USER) {
                const [link, offset] = this.quill.scroll.descendant((0, $4fd0b869b911350e$export$2e2bcd8739ae039), range.index);
                if (link != null) {
                    this.linkRange = new (0, $89ce7bdd8fd0c5db$export$9a58ef0d7ad3278c)(range.index - offset, link.length());
                    const preview = (0, $4fd0b869b911350e$export$2e2bcd8739ae039).formats(link.domNode);
                    // @ts-expect-error Fix me later
                    this.preview.textContent = preview;
                    // @ts-expect-error Fix me later
                    this.preview.setAttribute('href', preview);
                    this.show();
                    const bounds = this.quill.getBounds(this.linkRange);
                    if (bounds != null) this.position(bounds);
                    return;
                }
            } else delete this.linkRange;
            this.hide();
        });
    }
    show() {
        super.show();
        this.root.removeAttribute('data-mode');
    }
}
class $8ce15944b058c9a7$var$SnowTheme extends (0, $2dbb93d44018f276$export$2e2bcd8739ae039) {
    constructor(quill, options){
        if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = $8ce15944b058c9a7$var$TOOLBAR_CONFIG;
        super(quill, options);
        this.quill.container.classList.add('ql-snow');
    }
    extendToolbar(toolbar) {
        if (toolbar.container != null) {
            toolbar.container.classList.add('ql-snow');
            this.buildButtons(toolbar.container.querySelectorAll('button'), (0, $2470f66f4bdbe1a0$export$2e2bcd8739ae039));
            this.buildPickers(toolbar.container.querySelectorAll('select'), (0, $2470f66f4bdbe1a0$export$2e2bcd8739ae039));
            // @ts-expect-error
            this.tooltip = new $8ce15944b058c9a7$var$SnowTooltip(this.quill, this.options.bounds);
            if (toolbar.container.querySelector('.ql-link')) this.quill.keyboard.addBinding({
                key: 'k',
                shortKey: true
            }, (_range, context)=>{
                toolbar.handlers.link.call(toolbar, !context.format.link);
            });
        }
    }
}
$8ce15944b058c9a7$var$SnowTheme.DEFAULTS = (0, $e60eefbf4c36c7e0$export$2e2bcd8739ae039)({}, (0, $2dbb93d44018f276$export$2e2bcd8739ae039).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                link (value) {
                    if (value) {
                        const range = this.quill.getSelection();
                        if (range == null || range.length === 0) return;
                        let preview = this.quill.getText(range);
                        if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) preview = `mailto:${preview}`;
                        // @ts-expect-error
                        const { tooltip: tooltip } = this.quill.theme;
                        tooltip.edit('link', preview);
                    } else this.quill.format('link', false, (0, $6deb74e67088b9aa$export$2e2bcd8739ae039).sources.USER);
                }
            }
        }
    }
});
var $8ce15944b058c9a7$export$2e2bcd8739ae039 = $8ce15944b058c9a7$var$SnowTheme;


(0, $5c4d0d03149a5034$export$2e2bcd8739ae039).register({
    'attributors/attribute/direction': (0, $41d2f21a51fc0de9$export$4158215dafad9efa),
    'attributors/class/align': (0, $7bbd20231ffd3fe4$export$7f3685f5846c07da),
    'attributors/class/background': (0, $190265f2765c8959$export$8aa96c8963152b12),
    'attributors/class/color': (0, $7fcf066ad76fb835$export$42795dcf0ec6f3c8),
    'attributors/class/direction': (0, $41d2f21a51fc0de9$export$630028b3af294dec),
    'attributors/class/font': (0, $42d0307cd7072280$export$78a99ee601572ab),
    'attributors/class/size': (0, $83686b6faef4e652$export$c84684d52bca9684),
    'attributors/style/align': (0, $7bbd20231ffd3fe4$export$d2060f5d114c9fe8),
    'attributors/style/background': (0, $190265f2765c8959$export$dc1cbcab4c682ef),
    'attributors/style/color': (0, $7fcf066ad76fb835$export$1415f56796d9a5a9),
    'attributors/style/direction': (0, $41d2f21a51fc0de9$export$175979e518d1dfd1),
    'attributors/style/font': (0, $42d0307cd7072280$export$23b468d4ca3f8c96),
    'attributors/style/size': (0, $83686b6faef4e652$export$5443b95a30e89ac5)
}, true);
(0, $5c4d0d03149a5034$export$2e2bcd8739ae039).register({
    'formats/align': (0, $7bbd20231ffd3fe4$export$7f3685f5846c07da),
    'formats/direction': (0, $41d2f21a51fc0de9$export$630028b3af294dec),
    'formats/indent': (0, $44302badf55e41ef$export$2e2bcd8739ae039),
    'formats/background': (0, $190265f2765c8959$export$dc1cbcab4c682ef),
    'formats/color': (0, $7fcf066ad76fb835$export$1415f56796d9a5a9),
    'formats/font': (0, $42d0307cd7072280$export$78a99ee601572ab),
    'formats/size': (0, $83686b6faef4e652$export$c84684d52bca9684),
    'formats/blockquote': (0, $fdecb6ec12c02442$export$2e2bcd8739ae039),
    'formats/code-block': (0, $9751ae0c93fde05d$export$2e2bcd8739ae039),
    'formats/header': (0, $fff68e5f0c5de88d$export$2e2bcd8739ae039),
    'formats/list': (0, $8a2a751148cb2657$export$2e2bcd8739ae039),
    'formats/bold': (0, $610031d7908e35de$export$2e2bcd8739ae039),
    'formats/code': (0, $9751ae0c93fde05d$export$52f0f02147b12c03),
    'formats/italic': (0, $e5756b465b0daeb1$export$2e2bcd8739ae039),
    'formats/link': (0, $4fd0b869b911350e$export$2e2bcd8739ae039),
    'formats/script': (0, $5f36da2647e8384e$export$2e2bcd8739ae039),
    'formats/strike': (0, $b99750cbcefeb7ff$export$2e2bcd8739ae039),
    'formats/underline': (0, $29ca8040b4238447$export$2e2bcd8739ae039),
    'formats/formula': (0, $440dac071ad25b22$export$2e2bcd8739ae039),
    'formats/image': (0, $007703bef43f07c2$export$2e2bcd8739ae039),
    'formats/video': (0, $9e318b5c7d13ab52$export$2e2bcd8739ae039),
    'modules/syntax': (0, $21a99c560fedc334$export$2e2bcd8739ae039),
    'modules/table': (0, $99b978f13d6ff033$export$2e2bcd8739ae039),
    'modules/toolbar': (0, $b3a95f3cb1593e89$export$2e2bcd8739ae039),
    'themes/bubble': (0, $51cedb9b3593e7db$export$2e2bcd8739ae039),
    'themes/snow': (0, $8ce15944b058c9a7$export$2e2bcd8739ae039),
    'ui/icons': (0, $2470f66f4bdbe1a0$export$2e2bcd8739ae039),
    'ui/picker': (0, $e72566574ad77262$export$2e2bcd8739ae039),
    'ui/icon-picker': (0, $7aa5648e4401f9cb$export$2e2bcd8739ae039),
    'ui/color-picker': (0, $0146ce344c2320cb$export$2e2bcd8739ae039),
    'ui/tooltip': (0, $ca08744a7134d72c$export$2e2bcd8739ae039)
}, true);
var $4e85d92c73aaab1b$export$2e2bcd8739ae039 = (0, $5c4d0d03149a5034$export$2e2bcd8739ae039);




const $c638fd68af85a519$export$3f3b4272299f29de = ()=>{
    const QUILL_EL = document.querySelectorAll(".quill-inner");
    // Replace icons
    let icons = (0, $4e85d92c73aaab1b$export$2e2bcd8739ae039).import("ui/icons");
    icons["bold"] = '<i class="ph ph-text-b"></i>';
    icons["italic"] = '<i class="ph ph-text-italic"></i>';
    icons["underline"] = '<i class="ph ph-text-underline"></i>';
    icons["link"] = '<i class="ph ph-link"></i>';
    icons["image"] = '<i class="ph ph-image"></i>';
    icons["list"]["ordered"] = '<i class="ph ph-list-numbers"></i>';
    icons["list"]["bullet"] = '<i class="ph ph-list-bullets"></i>';
    if (QUILL_EL.length > 0) QUILL_EL.forEach((item)=>{
        let placeholder = item.getAttribute("data-placeholder");
        new (0, $4e85d92c73aaab1b$export$2e2bcd8739ae039)(item, {
            modules: {
                toolbar: [
                    [
                        "bold",
                        "italic",
                        "underline"
                    ],
                    [
                        {
                            list: "ordered"
                        },
                        {
                            list: "bullet"
                        }
                    ],
                    [
                        "link",
                        "image"
                    ]
                ]
            },
            placeholder: placeholder,
            theme: "snow"
        });
    });
};



var $8URGW = parcelRequire("8URGW");
const $eccbe3a1ca6cfff6$export$565dcf582cc7e325 = ()=>{
    // Popovers
    const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
    const popoverList = [
        ...popoverTriggerList
    ].map((popoverTriggerEl)=>new $8URGW.Popover(popoverTriggerEl));
    // Tooltips
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltipList = [
        ...tooltipTriggerList
    ].map((tooltipTriggerEl)=>new $8URGW.Tooltip(tooltipTriggerEl));
};


"use strict";
var $edc6d6d2a3ea6fb9$export$126649350cd02471;
(function(PipsMode) {
    PipsMode["Range"] = "range";
    PipsMode["Steps"] = "steps";
    PipsMode["Positions"] = "positions";
    PipsMode["Count"] = "count";
    PipsMode["Values"] = "values";
})($edc6d6d2a3ea6fb9$export$126649350cd02471 || ($edc6d6d2a3ea6fb9$export$126649350cd02471 = {}));
var $edc6d6d2a3ea6fb9$export$ab20e68cdcd7a4fc;
(function(PipsType) {
    PipsType[PipsType["None"] = -1] = "None";
    PipsType[PipsType["NoValue"] = 0] = "NoValue";
    PipsType[PipsType["LargeValue"] = 1] = "LargeValue";
    PipsType[PipsType["SmallValue"] = 2] = "SmallValue";
})($edc6d6d2a3ea6fb9$export$ab20e68cdcd7a4fc || ($edc6d6d2a3ea6fb9$export$ab20e68cdcd7a4fc = {}));
//region Helper Methods
function $edc6d6d2a3ea6fb9$var$isValidFormatter(entry) {
    return $edc6d6d2a3ea6fb9$var$isValidPartialFormatter(entry) && typeof entry.from === "function";
}
function $edc6d6d2a3ea6fb9$var$isValidPartialFormatter(entry) {
    // partial formatters only need a to function and not a from function
    return typeof entry === "object" && typeof entry.to === "function";
}
function $edc6d6d2a3ea6fb9$var$removeElement(el) {
    el.parentElement.removeChild(el);
}
function $edc6d6d2a3ea6fb9$var$isSet(value) {
    return value !== null && value !== undefined;
}
// Bindable version
function $edc6d6d2a3ea6fb9$var$preventDefault(e) {
    e.preventDefault();
}
// Removes duplicates from an array.
function $edc6d6d2a3ea6fb9$var$unique(array) {
    return array.filter(function(a) {
        return !this[a] ? this[a] = true : false;
    }, {});
}
// Round a value to the closest 'to'.
function $edc6d6d2a3ea6fb9$var$closest(value, to) {
    return Math.round(value / to) * to;
}
// Current position of an element relative to the document.
function $edc6d6d2a3ea6fb9$var$offset(elem, orientation) {
    var rect = elem.getBoundingClientRect();
    var doc = elem.ownerDocument;
    var docElem = doc.documentElement;
    var pageOffset = $edc6d6d2a3ea6fb9$var$getPageOffset(doc);
    // getBoundingClientRect contains left scroll in Chrome on Android.
    // I haven't found a feature detection that proves this. Worst case
    // scenario on mis-match: the 'tap' feature on horizontal sliders breaks.
    if (/webkit.*Chrome.*Mobile/i.test(navigator.userAgent)) pageOffset.x = 0;
    return orientation ? rect.top + pageOffset.y - docElem.clientTop : rect.left + pageOffset.x - docElem.clientLeft;
}
// Checks whether a value is numerical.
function $edc6d6d2a3ea6fb9$var$isNumeric(a) {
    return typeof a === "number" && !isNaN(a) && isFinite(a);
}
// Sets a class and removes it after [duration] ms.
function $edc6d6d2a3ea6fb9$var$addClassFor(element, className, duration) {
    if (duration > 0) {
        $edc6d6d2a3ea6fb9$var$addClass(element, className);
        setTimeout(function() {
            $edc6d6d2a3ea6fb9$var$removeClass(element, className);
        }, duration);
    }
}
// Limits a value to 0 - 100
function $edc6d6d2a3ea6fb9$var$limit(a) {
    return Math.max(Math.min(a, 100), 0);
}
// Wraps a variable as an array, if it isn't one yet.
// Note that an input array is returned by reference!
function $edc6d6d2a3ea6fb9$var$asArray(a) {
    return Array.isArray(a) ? a : [
        a
    ];
}
// Counts decimals
function $edc6d6d2a3ea6fb9$var$countDecimals(numStr) {
    numStr = String(numStr);
    var pieces = numStr.split(".");
    return pieces.length > 1 ? pieces[1].length : 0;
}
// http://youmightnotneedjquery.com/#add_class
function $edc6d6d2a3ea6fb9$var$addClass(el, className) {
    if (el.classList && !/\s/.test(className)) el.classList.add(className);
    else el.className += " " + className;
}
// http://youmightnotneedjquery.com/#remove_class
function $edc6d6d2a3ea6fb9$var$removeClass(el, className) {
    if (el.classList && !/\s/.test(className)) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp("(^|\\b)" + className.split(" ").join("|") + "(\\b|$)", "gi"), " ");
}
// https://plainjs.com/javascript/attributes/adding-removing-and-testing-for-classes-9/
function $edc6d6d2a3ea6fb9$var$hasClass(el, className) {
    return el.classList ? el.classList.contains(className) : new RegExp("\\b" + className + "\\b").test(el.className);
}
// https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollY#Notes
function $edc6d6d2a3ea6fb9$var$getPageOffset(doc) {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (doc.compatMode || "") === "CSS1Compat";
    var x = supportPageOffset ? window.pageXOffset : isCSS1Compat ? doc.documentElement.scrollLeft : doc.body.scrollLeft;
    var y = supportPageOffset ? window.pageYOffset : isCSS1Compat ? doc.documentElement.scrollTop : doc.body.scrollTop;
    return {
        x: x,
        y: y
    };
}
// we provide a function to compute constants instead
// of accessing window.* as soon as the module needs it
// so that we do not compute anything if not needed
function $edc6d6d2a3ea6fb9$var$getActions() {
    // Determine the events to bind. IE11 implements pointerEvents without
    // a prefix, which breaks compatibility with the IE10 implementation.
    return window.navigator.pointerEnabled ? {
        start: "pointerdown",
        move: "pointermove",
        end: "pointerup"
    } : window.navigator.msPointerEnabled ? {
        start: "MSPointerDown",
        move: "MSPointerMove",
        end: "MSPointerUp"
    } : {
        start: "mousedown touchstart",
        move: "mousemove touchmove",
        end: "mouseup touchend"
    };
}
// https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
// Issue #785
function $edc6d6d2a3ea6fb9$var$getSupportsPassive() {
    var supportsPassive = false;
    /* eslint-disable */ try {
        var opts = Object.defineProperty({}, "passive", {
            get: function() {
                supportsPassive = true;
            }
        });
        // @ts-ignore
        window.addEventListener("test", null, opts);
    } catch (e) {}
    /* eslint-enable */ return supportsPassive;
}
function $edc6d6d2a3ea6fb9$var$getSupportsTouchActionNone() {
    return window.CSS && CSS.supports && CSS.supports("touch-action", "none");
}
//endregion
//region Range Calculation
// Determine the size of a sub-range in relation to a full range.
function $edc6d6d2a3ea6fb9$var$subRangeRatio(pa, pb) {
    return 100 / (pb - pa);
}
// (percentage) How many percent is this value of this range?
function $edc6d6d2a3ea6fb9$var$fromPercentage(range, value, startRange) {
    return value * 100 / (range[startRange + 1] - range[startRange]);
}
// (percentage) Where is this value on this range?
function $edc6d6d2a3ea6fb9$var$toPercentage(range, value) {
    return $edc6d6d2a3ea6fb9$var$fromPercentage(range, range[0] < 0 ? value + Math.abs(range[0]) : value - range[0], 0);
}
// (value) How much is this percentage on this range?
function $edc6d6d2a3ea6fb9$var$isPercentage(range, value) {
    return value * (range[1] - range[0]) / 100 + range[0];
}
function $edc6d6d2a3ea6fb9$var$getJ(value, arr) {
    var j = 1;
    while(value >= arr[j])j += 1;
    return j;
}
// (percentage) Input a value, find where, on a scale of 0-100, it applies.
function $edc6d6d2a3ea6fb9$var$toStepping(xVal, xPct, value) {
    if (value >= xVal.slice(-1)[0]) return 100;
    var j = $edc6d6d2a3ea6fb9$var$getJ(value, xVal);
    var va = xVal[j - 1];
    var vb = xVal[j];
    var pa = xPct[j - 1];
    var pb = xPct[j];
    return pa + $edc6d6d2a3ea6fb9$var$toPercentage([
        va,
        vb
    ], value) / $edc6d6d2a3ea6fb9$var$subRangeRatio(pa, pb);
}
// (value) Input a percentage, find where it is on the specified range.
function $edc6d6d2a3ea6fb9$var$fromStepping(xVal, xPct, value) {
    // There is no range group that fits 100
    if (value >= 100) return xVal.slice(-1)[0];
    var j = $edc6d6d2a3ea6fb9$var$getJ(value, xPct);
    var va = xVal[j - 1];
    var vb = xVal[j];
    var pa = xPct[j - 1];
    var pb = xPct[j];
    return $edc6d6d2a3ea6fb9$var$isPercentage([
        va,
        vb
    ], (value - pa) * $edc6d6d2a3ea6fb9$var$subRangeRatio(pa, pb));
}
// (percentage) Get the step that applies at a certain value.
function $edc6d6d2a3ea6fb9$var$getStep(xPct, xSteps, snap, value) {
    if (value === 100) return value;
    var j = $edc6d6d2a3ea6fb9$var$getJ(value, xPct);
    var a = xPct[j - 1];
    var b = xPct[j];
    // If 'snap' is set, steps are used as fixed points on the slider.
    if (snap) {
        // Find the closest position, a or b.
        if (value - a > (b - a) / 2) return b;
        return a;
    }
    if (!xSteps[j - 1]) return value;
    return xPct[j - 1] + $edc6d6d2a3ea6fb9$var$closest(value - xPct[j - 1], xSteps[j - 1]);
}
//endregion
//region Spectrum
var $edc6d6d2a3ea6fb9$var$Spectrum = /** @class */ function() {
    function Spectrum(entry, snap, singleStep) {
        this.xPct = [];
        this.xVal = [];
        this.xSteps = [];
        this.xNumSteps = [];
        this.xHighestCompleteStep = [];
        this.xSteps = [
            singleStep || false
        ];
        this.xNumSteps = [
            false
        ];
        this.snap = snap;
        var index;
        var ordered = [];
        // Map the object keys to an array.
        Object.keys(entry).forEach(function(index) {
            ordered.push([
                $edc6d6d2a3ea6fb9$var$asArray(entry[index]),
                index
            ]);
        });
        // Sort all entries by value (numeric sort).
        ordered.sort(function(a, b) {
            return a[0][0] - b[0][0];
        });
        // Convert all entries to subranges.
        for(index = 0; index < ordered.length; index++)this.handleEntryPoint(ordered[index][1], ordered[index][0]);
        // Store the actual step values.
        // xSteps is sorted in the same order as xPct and xVal.
        this.xNumSteps = this.xSteps.slice(0);
        // Convert all numeric steps to the percentage of the subrange they represent.
        for(index = 0; index < this.xNumSteps.length; index++)this.handleStepPoint(index, this.xNumSteps[index]);
    }
    Spectrum.prototype.getDistance = function(value) {
        var distances = [];
        for(var index = 0; index < this.xNumSteps.length - 1; index++)distances[index] = $edc6d6d2a3ea6fb9$var$fromPercentage(this.xVal, value, index);
        return distances;
    };
    // Calculate the percentual distance over the whole scale of ranges.
    // direction: 0 = backwards / 1 = forwards
    Spectrum.prototype.getAbsoluteDistance = function(value, distances, direction) {
        var xPct_index = 0;
        // Calculate range where to start calculation
        if (value < this.xPct[this.xPct.length - 1]) while(value > this.xPct[xPct_index + 1])xPct_index++;
        else if (value === this.xPct[this.xPct.length - 1]) xPct_index = this.xPct.length - 2;
        // If looking backwards and the value is exactly at a range separator then look one range further
        if (!direction && value === this.xPct[xPct_index + 1]) xPct_index++;
        if (distances === null) distances = [];
        var start_factor;
        var rest_factor = 1;
        var rest_rel_distance = distances[xPct_index];
        var range_pct = 0;
        var rel_range_distance = 0;
        var abs_distance_counter = 0;
        var range_counter = 0;
        // Calculate what part of the start range the value is
        if (direction) start_factor = (value - this.xPct[xPct_index]) / (this.xPct[xPct_index + 1] - this.xPct[xPct_index]);
        else start_factor = (this.xPct[xPct_index + 1] - value) / (this.xPct[xPct_index + 1] - this.xPct[xPct_index]);
        // Do until the complete distance across ranges is calculated
        while(rest_rel_distance > 0){
            // Calculate the percentage of total range
            range_pct = this.xPct[xPct_index + 1 + range_counter] - this.xPct[xPct_index + range_counter];
            // Detect if the margin, padding or limit is larger then the current range and calculate
            if (distances[xPct_index + range_counter] * rest_factor + 100 - start_factor * 100 > 100) {
                // If larger then take the percentual distance of the whole range
                rel_range_distance = range_pct * start_factor;
                // Rest factor of relative percentual distance still to be calculated
                rest_factor = (rest_rel_distance - 100 * start_factor) / distances[xPct_index + range_counter];
                // Set start factor to 1 as for next range it does not apply.
                start_factor = 1;
            } else {
                // If smaller or equal then take the percentual distance of the calculate percentual part of that range
                rel_range_distance = distances[xPct_index + range_counter] * range_pct / 100 * rest_factor;
                // No rest left as the rest fits in current range
                rest_factor = 0;
            }
            if (direction) {
                abs_distance_counter = abs_distance_counter - rel_range_distance;
                // Limit range to first range when distance becomes outside of minimum range
                if (this.xPct.length + range_counter >= 1) range_counter--;
            } else {
                abs_distance_counter = abs_distance_counter + rel_range_distance;
                // Limit range to last range when distance becomes outside of maximum range
                if (this.xPct.length - range_counter >= 1) range_counter++;
            }
            // Rest of relative percentual distance still to be calculated
            rest_rel_distance = distances[xPct_index + range_counter] * rest_factor;
        }
        return value + abs_distance_counter;
    };
    Spectrum.prototype.toStepping = function(value) {
        value = $edc6d6d2a3ea6fb9$var$toStepping(this.xVal, this.xPct, value);
        return value;
    };
    Spectrum.prototype.fromStepping = function(value) {
        return $edc6d6d2a3ea6fb9$var$fromStepping(this.xVal, this.xPct, value);
    };
    Spectrum.prototype.getStep = function(value) {
        value = $edc6d6d2a3ea6fb9$var$getStep(this.xPct, this.xSteps, this.snap, value);
        return value;
    };
    Spectrum.prototype.getDefaultStep = function(value, isDown, size) {
        var j = $edc6d6d2a3ea6fb9$var$getJ(value, this.xPct);
        // When at the top or stepping down, look at the previous sub-range
        if (value === 100 || isDown && value === this.xPct[j - 1]) j = Math.max(j - 1, 1);
        return (this.xVal[j] - this.xVal[j - 1]) / size;
    };
    Spectrum.prototype.getNearbySteps = function(value) {
        var j = $edc6d6d2a3ea6fb9$var$getJ(value, this.xPct);
        return {
            stepBefore: {
                startValue: this.xVal[j - 2],
                step: this.xNumSteps[j - 2],
                highestStep: this.xHighestCompleteStep[j - 2]
            },
            thisStep: {
                startValue: this.xVal[j - 1],
                step: this.xNumSteps[j - 1],
                highestStep: this.xHighestCompleteStep[j - 1]
            },
            stepAfter: {
                startValue: this.xVal[j],
                step: this.xNumSteps[j],
                highestStep: this.xHighestCompleteStep[j]
            }
        };
    };
    Spectrum.prototype.countStepDecimals = function() {
        var stepDecimals = this.xNumSteps.map($edc6d6d2a3ea6fb9$var$countDecimals);
        return Math.max.apply(null, stepDecimals);
    };
    Spectrum.prototype.hasNoSize = function() {
        return this.xVal[0] === this.xVal[this.xVal.length - 1];
    };
    // Outside testing
    Spectrum.prototype.convert = function(value) {
        return this.getStep(this.toStepping(value));
    };
    Spectrum.prototype.handleEntryPoint = function(index, value) {
        var percentage;
        // Covert min/max syntax to 0 and 100.
        if (index === "min") percentage = 0;
        else if (index === "max") percentage = 100;
        else percentage = parseFloat(index);
        // Check for correct input.
        if (!$edc6d6d2a3ea6fb9$var$isNumeric(percentage) || !$edc6d6d2a3ea6fb9$var$isNumeric(value[0])) throw new Error("noUiSlider: 'range' value isn't numeric.");
        // Store values.
        this.xPct.push(percentage);
        this.xVal.push(value[0]);
        var value1 = Number(value[1]);
        // NaN will evaluate to false too, but to keep
        // logging clear, set step explicitly. Make sure
        // not to override the 'step' setting with false.
        if (!percentage) {
            if (!isNaN(value1)) this.xSteps[0] = value1;
        } else this.xSteps.push(isNaN(value1) ? false : value1);
        this.xHighestCompleteStep.push(0);
    };
    Spectrum.prototype.handleStepPoint = function(i, n) {
        // Ignore 'false' stepping.
        if (!n) return;
        // Step over zero-length ranges (#948);
        if (this.xVal[i] === this.xVal[i + 1]) {
            this.xSteps[i] = this.xHighestCompleteStep[i] = this.xVal[i];
            return;
        }
        // Factor to range ratio
        this.xSteps[i] = $edc6d6d2a3ea6fb9$var$fromPercentage([
            this.xVal[i],
            this.xVal[i + 1]
        ], n, 0) / $edc6d6d2a3ea6fb9$var$subRangeRatio(this.xPct[i], this.xPct[i + 1]);
        var totalSteps = (this.xVal[i + 1] - this.xVal[i]) / this.xNumSteps[i];
        var highestStep = Math.ceil(Number(totalSteps.toFixed(3)) - 1);
        var step = this.xVal[i] + this.xNumSteps[i] * highestStep;
        this.xHighestCompleteStep[i] = step;
    };
    return Spectrum;
}();
//endregion
//region Options
/*	Every input option is tested and parsed. This will prevent
    endless validation in internal methods. These tests are
    structured with an item for every option available. An
    option can be marked as required by setting the 'r' flag.
    The testing function is provided with three arguments:
        - The provided value for the option;
        - A reference to the options object;
        - The name for the option;

    The testing function returns false when an error is detected,
    or true when everything is OK. It can also modify the option
    object, to make sure all values can be correctly looped elsewhere. */ //region Defaults
var $edc6d6d2a3ea6fb9$var$defaultFormatter = {
    to: function(value) {
        return value === undefined ? "" : value.toFixed(2);
    },
    from: Number
};
var $edc6d6d2a3ea6fb9$export$c1c0562ec8379000 = {
    target: "target",
    base: "base",
    origin: "origin",
    handle: "handle",
    handleLower: "handle-lower",
    handleUpper: "handle-upper",
    touchArea: "touch-area",
    horizontal: "horizontal",
    vertical: "vertical",
    background: "background",
    connect: "connect",
    connects: "connects",
    ltr: "ltr",
    rtl: "rtl",
    textDirectionLtr: "txt-dir-ltr",
    textDirectionRtl: "txt-dir-rtl",
    draggable: "draggable",
    drag: "state-drag",
    tap: "state-tap",
    active: "active",
    tooltip: "tooltip",
    pips: "pips",
    pipsHorizontal: "pips-horizontal",
    pipsVertical: "pips-vertical",
    marker: "marker",
    markerHorizontal: "marker-horizontal",
    markerVertical: "marker-vertical",
    markerNormal: "marker-normal",
    markerLarge: "marker-large",
    markerSub: "marker-sub",
    value: "value",
    valueHorizontal: "value-horizontal",
    valueVertical: "value-vertical",
    valueNormal: "value-normal",
    valueLarge: "value-large",
    valueSub: "value-sub"
};
// Namespaces of internal event listeners
var $edc6d6d2a3ea6fb9$var$INTERNAL_EVENT_NS = {
    tooltips: ".__tooltips",
    aria: ".__aria"
};
//endregion
function $edc6d6d2a3ea6fb9$var$testStep(parsed, entry) {
    if (!$edc6d6d2a3ea6fb9$var$isNumeric(entry)) throw new Error("noUiSlider: 'step' is not numeric.");
    // The step option can still be used to set stepping
    // for linear sliders. Overwritten if set in 'range'.
    parsed.singleStep = entry;
}
function $edc6d6d2a3ea6fb9$var$testKeyboardPageMultiplier(parsed, entry) {
    if (!$edc6d6d2a3ea6fb9$var$isNumeric(entry)) throw new Error("noUiSlider: 'keyboardPageMultiplier' is not numeric.");
    parsed.keyboardPageMultiplier = entry;
}
function $edc6d6d2a3ea6fb9$var$testKeyboardMultiplier(parsed, entry) {
    if (!$edc6d6d2a3ea6fb9$var$isNumeric(entry)) throw new Error("noUiSlider: 'keyboardMultiplier' is not numeric.");
    parsed.keyboardMultiplier = entry;
}
function $edc6d6d2a3ea6fb9$var$testKeyboardDefaultStep(parsed, entry) {
    if (!$edc6d6d2a3ea6fb9$var$isNumeric(entry)) throw new Error("noUiSlider: 'keyboardDefaultStep' is not numeric.");
    parsed.keyboardDefaultStep = entry;
}
function $edc6d6d2a3ea6fb9$var$testRange(parsed, entry) {
    // Filter incorrect input.
    if (typeof entry !== "object" || Array.isArray(entry)) throw new Error("noUiSlider: 'range' is not an object.");
    // Catch missing start or end.
    if (entry.min === undefined || entry.max === undefined) throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");
    parsed.spectrum = new $edc6d6d2a3ea6fb9$var$Spectrum(entry, parsed.snap || false, parsed.singleStep);
}
function $edc6d6d2a3ea6fb9$var$testStart(parsed, entry) {
    entry = $edc6d6d2a3ea6fb9$var$asArray(entry);
    // Validate input. Values aren't tested, as the public .val method
    // will always provide a valid location.
    if (!Array.isArray(entry) || !entry.length) throw new Error("noUiSlider: 'start' option is incorrect.");
    // Store the number of handles.
    parsed.handles = entry.length;
    // When the slider is initialized, the .val method will
    // be called with the start options.
    parsed.start = entry;
}
function $edc6d6d2a3ea6fb9$var$testSnap(parsed, entry) {
    if (typeof entry !== "boolean") throw new Error("noUiSlider: 'snap' option must be a boolean.");
    // Enforce 100% stepping within subranges.
    parsed.snap = entry;
}
function $edc6d6d2a3ea6fb9$var$testAnimate(parsed, entry) {
    if (typeof entry !== "boolean") throw new Error("noUiSlider: 'animate' option must be a boolean.");
    // Enforce 100% stepping within subranges.
    parsed.animate = entry;
}
function $edc6d6d2a3ea6fb9$var$testAnimationDuration(parsed, entry) {
    if (typeof entry !== "number") throw new Error("noUiSlider: 'animationDuration' option must be a number.");
    parsed.animationDuration = entry;
}
function $edc6d6d2a3ea6fb9$var$testConnect(parsed, entry) {
    var connect = [
        false
    ];
    var i;
    // Map legacy options
    if (entry === "lower") entry = [
        true,
        false
    ];
    else if (entry === "upper") entry = [
        false,
        true
    ];
    // Handle boolean options
    if (entry === true || entry === false) {
        for(i = 1; i < parsed.handles; i++)connect.push(entry);
        connect.push(false);
    } else if (!Array.isArray(entry) || !entry.length || entry.length !== parsed.handles + 1) throw new Error("noUiSlider: 'connect' option doesn't match handle count.");
    else connect = entry;
    parsed.connect = connect;
}
function $edc6d6d2a3ea6fb9$var$testOrientation(parsed, entry) {
    // Set orientation to an a numerical value for easy
    // array selection.
    switch(entry){
        case "horizontal":
            parsed.ort = 0;
            break;
        case "vertical":
            parsed.ort = 1;
            break;
        default:
            throw new Error("noUiSlider: 'orientation' option is invalid.");
    }
}
function $edc6d6d2a3ea6fb9$var$testMargin(parsed, entry) {
    if (!$edc6d6d2a3ea6fb9$var$isNumeric(entry)) throw new Error("noUiSlider: 'margin' option must be numeric.");
    // Issue #582
    if (entry === 0) return;
    parsed.margin = parsed.spectrum.getDistance(entry);
}
function $edc6d6d2a3ea6fb9$var$testLimit(parsed, entry) {
    if (!$edc6d6d2a3ea6fb9$var$isNumeric(entry)) throw new Error("noUiSlider: 'limit' option must be numeric.");
    parsed.limit = parsed.spectrum.getDistance(entry);
    if (!parsed.limit || parsed.handles < 2) throw new Error("noUiSlider: 'limit' option is only supported on linear sliders with 2 or more handles.");
}
function $edc6d6d2a3ea6fb9$var$testPadding(parsed, entry) {
    var index;
    if (!$edc6d6d2a3ea6fb9$var$isNumeric(entry) && !Array.isArray(entry)) throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
    if (Array.isArray(entry) && !(entry.length === 2 || $edc6d6d2a3ea6fb9$var$isNumeric(entry[0]) || $edc6d6d2a3ea6fb9$var$isNumeric(entry[1]))) throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
    if (entry === 0) return;
    if (!Array.isArray(entry)) entry = [
        entry,
        entry
    ];
    // 'getDistance' returns false for invalid values.
    parsed.padding = [
        parsed.spectrum.getDistance(entry[0]),
        parsed.spectrum.getDistance(entry[1])
    ];
    for(index = 0; index < parsed.spectrum.xNumSteps.length - 1; index++){
        // last "range" can't contain step size as it is purely an endpoint.
        if (parsed.padding[0][index] < 0 || parsed.padding[1][index] < 0) throw new Error("noUiSlider: 'padding' option must be a positive number(s).");
    }
    var totalPadding = entry[0] + entry[1];
    var firstValue = parsed.spectrum.xVal[0];
    var lastValue = parsed.spectrum.xVal[parsed.spectrum.xVal.length - 1];
    if (totalPadding / (lastValue - firstValue) > 1) throw new Error("noUiSlider: 'padding' option must not exceed 100% of the range.");
}
function $edc6d6d2a3ea6fb9$var$testDirection(parsed, entry) {
    // Set direction as a numerical value for easy parsing.
    // Invert connection for RTL sliders, so that the proper
    // handles get the connect/background classes.
    switch(entry){
        case "ltr":
            parsed.dir = 0;
            break;
        case "rtl":
            parsed.dir = 1;
            break;
        default:
            throw new Error("noUiSlider: 'direction' option was not recognized.");
    }
}
function $edc6d6d2a3ea6fb9$var$testBehaviour(parsed, entry) {
    // Make sure the input is a string.
    if (typeof entry !== "string") throw new Error("noUiSlider: 'behaviour' must be a string containing options.");
    // Check if the string contains any keywords.
    // None are required.
    var tap = entry.indexOf("tap") >= 0;
    var drag = entry.indexOf("drag") >= 0;
    var fixed = entry.indexOf("fixed") >= 0;
    var snap = entry.indexOf("snap") >= 0;
    var hover = entry.indexOf("hover") >= 0;
    var unconstrained = entry.indexOf("unconstrained") >= 0;
    var invertConnects = entry.indexOf("invert-connects") >= 0;
    var dragAll = entry.indexOf("drag-all") >= 0;
    var smoothSteps = entry.indexOf("smooth-steps") >= 0;
    if (fixed) {
        if (parsed.handles !== 2) throw new Error("noUiSlider: 'fixed' behaviour must be used with 2 handles");
        // Use margin to enforce fixed state
        $edc6d6d2a3ea6fb9$var$testMargin(parsed, parsed.start[1] - parsed.start[0]);
    }
    if (invertConnects && parsed.handles !== 2) throw new Error("noUiSlider: 'invert-connects' behaviour must be used with 2 handles");
    if (unconstrained && (parsed.margin || parsed.limit)) throw new Error("noUiSlider: 'unconstrained' behaviour cannot be used with margin or limit");
    parsed.events = {
        tap: tap || snap,
        drag: drag,
        dragAll: dragAll,
        smoothSteps: smoothSteps,
        fixed: fixed,
        snap: snap,
        hover: hover,
        unconstrained: unconstrained,
        invertConnects: invertConnects
    };
}
function $edc6d6d2a3ea6fb9$var$testTooltips(parsed, entry) {
    if (entry === false) return;
    if (entry === true || $edc6d6d2a3ea6fb9$var$isValidPartialFormatter(entry)) {
        parsed.tooltips = [];
        for(var i = 0; i < parsed.handles; i++)parsed.tooltips.push(entry);
    } else {
        entry = $edc6d6d2a3ea6fb9$var$asArray(entry);
        if (entry.length !== parsed.handles) throw new Error("noUiSlider: must pass a formatter for all handles.");
        entry.forEach(function(formatter) {
            if (typeof formatter !== "boolean" && !$edc6d6d2a3ea6fb9$var$isValidPartialFormatter(formatter)) throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.");
        });
        parsed.tooltips = entry;
    }
}
function $edc6d6d2a3ea6fb9$var$testHandleAttributes(parsed, entry) {
    if (entry.length !== parsed.handles) throw new Error("noUiSlider: must pass a attributes for all handles.");
    parsed.handleAttributes = entry;
}
function $edc6d6d2a3ea6fb9$var$testAriaFormat(parsed, entry) {
    if (!$edc6d6d2a3ea6fb9$var$isValidPartialFormatter(entry)) throw new Error("noUiSlider: 'ariaFormat' requires 'to' method.");
    parsed.ariaFormat = entry;
}
function $edc6d6d2a3ea6fb9$var$testFormat(parsed, entry) {
    if (!$edc6d6d2a3ea6fb9$var$isValidFormatter(entry)) throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.");
    parsed.format = entry;
}
function $edc6d6d2a3ea6fb9$var$testKeyboardSupport(parsed, entry) {
    if (typeof entry !== "boolean") throw new Error("noUiSlider: 'keyboardSupport' option must be a boolean.");
    parsed.keyboardSupport = entry;
}
function $edc6d6d2a3ea6fb9$var$testDocumentElement(parsed, entry) {
    // This is an advanced option. Passed values are used without validation.
    parsed.documentElement = entry;
}
function $edc6d6d2a3ea6fb9$var$testCssPrefix(parsed, entry) {
    if (typeof entry !== "string" && entry !== false) throw new Error("noUiSlider: 'cssPrefix' must be a string or `false`.");
    parsed.cssPrefix = entry;
}
function $edc6d6d2a3ea6fb9$var$testCssClasses(parsed, entry) {
    if (typeof entry !== "object") throw new Error("noUiSlider: 'cssClasses' must be an object.");
    if (typeof parsed.cssPrefix === "string") {
        parsed.cssClasses = {};
        Object.keys(entry).forEach(function(key) {
            parsed.cssClasses[key] = parsed.cssPrefix + entry[key];
        });
    } else parsed.cssClasses = entry;
}
// Test all developer settings and parse to assumption-safe values.
function $edc6d6d2a3ea6fb9$var$testOptions(options) {
    // To prove a fix for #537, freeze options here.
    // If the object is modified, an error will be thrown.
    // Object.freeze(options);
    var parsed = {
        margin: null,
        limit: null,
        padding: null,
        animate: true,
        animationDuration: 300,
        ariaFormat: $edc6d6d2a3ea6fb9$var$defaultFormatter,
        format: $edc6d6d2a3ea6fb9$var$defaultFormatter
    };
    // Tests are executed in the order they are presented here.
    var tests = {
        step: {
            r: false,
            t: $edc6d6d2a3ea6fb9$var$testStep
        },
        keyboardPageMultiplier: {
            r: false,
            t: $edc6d6d2a3ea6fb9$var$testKeyboardPageMultiplier
        },
        keyboardMultiplier: {
            r: false,
            t: $edc6d6d2a3ea6fb9$var$testKeyboardMultiplier
        },
        keyboardDefaultStep: {
            r: false,
            t: $edc6d6d2a3ea6fb9$var$testKeyboardDefaultStep
        },
        start: {
            r: true,
            t: $edc6d6d2a3ea6fb9$var$testStart
        },
        connect: {
            r: true,
            t: $edc6d6d2a3ea6fb9$var$testConnect
        },
        direction: {
            r: true,
            t: $edc6d6d2a3ea6fb9$var$testDirection
        },
        snap: {
            r: false,
            t: $edc6d6d2a3ea6fb9$var$testSnap
        },
        animate: {
            r: false,
            t: $edc6d6d2a3ea6fb9$var$testAnimate
        },
        animationDuration: {
            r: false,
            t: $edc6d6d2a3ea6fb9$var$testAnimationDuration
        },
        range: {
            r: true,
            t: $edc6d6d2a3ea6fb9$var$testRange
        },
        orientation: {
            r: false,
            t: $edc6d6d2a3ea6fb9$var$testOrientation
        },
        margin: {
            r: false,
            t: $edc6d6d2a3ea6fb9$var$testMargin
        },
        limit: {
            r: false,
            t: $edc6d6d2a3ea6fb9$var$testLimit
        },
        padding: {
            r: false,
            t: $edc6d6d2a3ea6fb9$var$testPadding
        },
        behaviour: {
            r: true,
            t: $edc6d6d2a3ea6fb9$var$testBehaviour
        },
        ariaFormat: {
            r: false,
            t: $edc6d6d2a3ea6fb9$var$testAriaFormat
        },
        format: {
            r: false,
            t: $edc6d6d2a3ea6fb9$var$testFormat
        },
        tooltips: {
            r: false,
            t: $edc6d6d2a3ea6fb9$var$testTooltips
        },
        keyboardSupport: {
            r: true,
            t: $edc6d6d2a3ea6fb9$var$testKeyboardSupport
        },
        documentElement: {
            r: false,
            t: $edc6d6d2a3ea6fb9$var$testDocumentElement
        },
        cssPrefix: {
            r: true,
            t: $edc6d6d2a3ea6fb9$var$testCssPrefix
        },
        cssClasses: {
            r: true,
            t: $edc6d6d2a3ea6fb9$var$testCssClasses
        },
        handleAttributes: {
            r: false,
            t: $edc6d6d2a3ea6fb9$var$testHandleAttributes
        }
    };
    var defaults = {
        connect: false,
        direction: "ltr",
        behaviour: "tap",
        orientation: "horizontal",
        keyboardSupport: true,
        cssPrefix: "noUi-",
        cssClasses: $edc6d6d2a3ea6fb9$export$c1c0562ec8379000,
        keyboardPageMultiplier: 5,
        keyboardMultiplier: 1,
        keyboardDefaultStep: 10
    };
    // AriaFormat defaults to regular format, if any.
    if (options.format && !options.ariaFormat) options.ariaFormat = options.format;
    // Run all options through a testing mechanism to ensure correct
    // input. It should be noted that options might get modified to
    // be handled properly. E.g. wrapping integers in arrays.
    Object.keys(tests).forEach(function(name) {
        // If the option isn't set, but it is required, throw an error.
        if (!$edc6d6d2a3ea6fb9$var$isSet(options[name]) && defaults[name] === undefined) {
            if (tests[name].r) throw new Error("noUiSlider: '" + name + "' is required.");
            return;
        }
        tests[name].t(parsed, !$edc6d6d2a3ea6fb9$var$isSet(options[name]) ? defaults[name] : options[name]);
    });
    // Forward pips options
    parsed.pips = options.pips;
    // All recent browsers accept unprefixed transform.
    // We need -ms- for IE9 and -webkit- for older Android;
    // Assume use of -webkit- if unprefixed and -ms- are not supported.
    // https://caniuse.com/#feat=transforms2d
    var d = document.createElement("div");
    var msPrefix = d.style.msTransform !== undefined;
    var noPrefix = d.style.transform !== undefined;
    parsed.transformRule = noPrefix ? "transform" : msPrefix ? "msTransform" : "webkitTransform";
    // Pips don't move, so we can place them using left/top.
    var styles = [
        [
            "left",
            "top"
        ],
        [
            "right",
            "bottom"
        ]
    ];
    parsed.style = styles[parsed.dir][parsed.ort];
    return parsed;
}
//endregion
function $edc6d6d2a3ea6fb9$var$scope(target, options, originalOptions) {
    var actions = $edc6d6d2a3ea6fb9$var$getActions();
    var supportsTouchActionNone = $edc6d6d2a3ea6fb9$var$getSupportsTouchActionNone();
    var supportsPassive = supportsTouchActionNone && $edc6d6d2a3ea6fb9$var$getSupportsPassive();
    // All variables local to 'scope' are prefixed with 'scope_'
    // Slider DOM Nodes
    var scope_Target = target;
    var scope_Base;
    var scope_ConnectBase;
    var scope_Handles;
    var scope_Connects;
    var scope_Pips;
    var scope_Tooltips;
    // Slider state values
    var scope_Spectrum = options.spectrum;
    var scope_Values = [];
    var scope_Locations = [];
    var scope_HandleNumbers = [];
    var scope_ActiveHandlesCount = 0;
    var scope_Events = {};
    var scope_ConnectsInverted = false;
    // Document Nodes
    var scope_Document = target.ownerDocument;
    var scope_DocumentElement = options.documentElement || scope_Document.documentElement;
    var scope_Body = scope_Document.body;
    // For horizontal sliders in standard ltr documents,
    // make .noUi-origin overflow to the left so the document doesn't scroll.
    var scope_DirOffset = scope_Document.dir === "rtl" || options.ort === 1 ? 0 : 100;
    // Creates a node, adds it to target, returns the new node.
    function addNodeTo(addTarget, className) {
        var div = scope_Document.createElement("div");
        if (className) $edc6d6d2a3ea6fb9$var$addClass(div, className);
        addTarget.appendChild(div);
        return div;
    }
    // Append a origin to the base
    function addOrigin(base, handleNumber) {
        var origin = addNodeTo(base, options.cssClasses.origin);
        var handle = addNodeTo(origin, options.cssClasses.handle);
        addNodeTo(handle, options.cssClasses.touchArea);
        handle.setAttribute("data-handle", String(handleNumber));
        if (options.keyboardSupport) {
            // https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex
            // 0 = focusable and reachable
            handle.setAttribute("tabindex", "0");
            handle.addEventListener("keydown", function(event) {
                return eventKeydown(event, handleNumber);
            });
        }
        if (options.handleAttributes !== undefined) {
            var attributes_1 = options.handleAttributes[handleNumber];
            Object.keys(attributes_1).forEach(function(attribute) {
                handle.setAttribute(attribute, attributes_1[attribute]);
            });
        }
        handle.setAttribute("role", "slider");
        handle.setAttribute("aria-orientation", options.ort ? "vertical" : "horizontal");
        if (handleNumber === 0) $edc6d6d2a3ea6fb9$var$addClass(handle, options.cssClasses.handleLower);
        else if (handleNumber === options.handles - 1) $edc6d6d2a3ea6fb9$var$addClass(handle, options.cssClasses.handleUpper);
        origin.handle = handle;
        return origin;
    }
    // Insert nodes for connect elements
    function addConnect(base, add) {
        if (!add) return false;
        return addNodeTo(base, options.cssClasses.connect);
    }
    // Add handles to the slider base.
    function addElements(connectOptions, base) {
        scope_ConnectBase = addNodeTo(base, options.cssClasses.connects);
        scope_Handles = [];
        scope_Connects = [];
        scope_Connects.push(addConnect(scope_ConnectBase, connectOptions[0]));
        // [::::O====O====O====]
        // connectOptions = [0, 1, 1, 1]
        for(var i = 0; i < options.handles; i++){
            // Keep a list of all added handles.
            scope_Handles.push(addOrigin(base, i));
            scope_HandleNumbers[i] = i;
            scope_Connects.push(addConnect(scope_ConnectBase, connectOptions[i + 1]));
        }
    }
    // Initialize a single slider.
    function addSlider(addTarget) {
        // Apply classes and data to the target.
        $edc6d6d2a3ea6fb9$var$addClass(addTarget, options.cssClasses.target);
        if (options.dir === 0) $edc6d6d2a3ea6fb9$var$addClass(addTarget, options.cssClasses.ltr);
        else $edc6d6d2a3ea6fb9$var$addClass(addTarget, options.cssClasses.rtl);
        if (options.ort === 0) $edc6d6d2a3ea6fb9$var$addClass(addTarget, options.cssClasses.horizontal);
        else $edc6d6d2a3ea6fb9$var$addClass(addTarget, options.cssClasses.vertical);
        var textDirection = getComputedStyle(addTarget).direction;
        if (textDirection === "rtl") $edc6d6d2a3ea6fb9$var$addClass(addTarget, options.cssClasses.textDirectionRtl);
        else $edc6d6d2a3ea6fb9$var$addClass(addTarget, options.cssClasses.textDirectionLtr);
        return addNodeTo(addTarget, options.cssClasses.base);
    }
    function addTooltip(handle, handleNumber) {
        if (!options.tooltips || !options.tooltips[handleNumber]) return false;
        return addNodeTo(handle.firstChild, options.cssClasses.tooltip);
    }
    function isSliderDisabled() {
        return scope_Target.hasAttribute("disabled");
    }
    // Disable the slider dragging if any handle is disabled
    function isHandleDisabled(handleNumber) {
        var handleOrigin = scope_Handles[handleNumber];
        return handleOrigin.hasAttribute("disabled");
    }
    function disable(handleNumber) {
        if (handleNumber !== null && handleNumber !== undefined) {
            scope_Handles[handleNumber].setAttribute("disabled", "");
            scope_Handles[handleNumber].handle.removeAttribute("tabindex");
        } else {
            scope_Target.setAttribute("disabled", "");
            scope_Handles.forEach(function(handle) {
                handle.handle.removeAttribute("tabindex");
            });
        }
    }
    function enable(handleNumber) {
        if (handleNumber !== null && handleNumber !== undefined) {
            scope_Handles[handleNumber].removeAttribute("disabled");
            scope_Handles[handleNumber].handle.setAttribute("tabindex", "0");
        } else {
            scope_Target.removeAttribute("disabled");
            scope_Handles.forEach(function(handle) {
                handle.removeAttribute("disabled");
                handle.handle.setAttribute("tabindex", "0");
            });
        }
    }
    function removeTooltips() {
        if (scope_Tooltips) {
            removeEvent("update" + $edc6d6d2a3ea6fb9$var$INTERNAL_EVENT_NS.tooltips);
            scope_Tooltips.forEach(function(tooltip) {
                if (tooltip) $edc6d6d2a3ea6fb9$var$removeElement(tooltip);
            });
            scope_Tooltips = null;
        }
    }
    // The tooltips option is a shorthand for using the 'update' event.
    function tooltips() {
        removeTooltips();
        // Tooltips are added with options.tooltips in original order.
        scope_Tooltips = scope_Handles.map(addTooltip);
        bindEvent("update" + $edc6d6d2a3ea6fb9$var$INTERNAL_EVENT_NS.tooltips, function(values, handleNumber, unencoded) {
            if (!scope_Tooltips || !options.tooltips) return;
            if (scope_Tooltips[handleNumber] === false) return;
            var formattedValue = values[handleNumber];
            if (options.tooltips[handleNumber] !== true) formattedValue = options.tooltips[handleNumber].to(unencoded[handleNumber]);
            scope_Tooltips[handleNumber].innerHTML = formattedValue;
        });
    }
    function aria() {
        removeEvent("update" + $edc6d6d2a3ea6fb9$var$INTERNAL_EVENT_NS.aria);
        bindEvent("update" + $edc6d6d2a3ea6fb9$var$INTERNAL_EVENT_NS.aria, function(values, handleNumber, unencoded, tap, positions) {
            // Update Aria Values for all handles, as a change in one changes min and max values for the next.
            scope_HandleNumbers.forEach(function(index) {
                var handle = scope_Handles[index];
                var min = checkHandlePosition(scope_Locations, index, 0, true, true, true);
                var max = checkHandlePosition(scope_Locations, index, 100, true, true, true);
                var now = positions[index];
                // Formatted value for display
                var text = String(options.ariaFormat.to(unencoded[index]));
                // Map to slider range values
                min = scope_Spectrum.fromStepping(min).toFixed(1);
                max = scope_Spectrum.fromStepping(max).toFixed(1);
                now = scope_Spectrum.fromStepping(now).toFixed(1);
                handle.children[0].setAttribute("aria-valuemin", min);
                handle.children[0].setAttribute("aria-valuemax", max);
                handle.children[0].setAttribute("aria-valuenow", now);
                handle.children[0].setAttribute("aria-valuetext", text);
            });
        });
    }
    function getGroup(pips) {
        // Use the range.
        if (pips.mode === $edc6d6d2a3ea6fb9$export$126649350cd02471.Range || pips.mode === $edc6d6d2a3ea6fb9$export$126649350cd02471.Steps) return scope_Spectrum.xVal;
        if (pips.mode === $edc6d6d2a3ea6fb9$export$126649350cd02471.Count) {
            if (pips.values < 2) throw new Error("noUiSlider: 'values' (>= 2) required for mode 'count'.");
            // Divide 0 - 100 in 'count' parts.
            var interval = pips.values - 1;
            var spread = 100 / interval;
            var values = [];
            // List these parts and have them handled as 'positions'.
            while(interval--)values[interval] = interval * spread;
            values.push(100);
            return mapToRange(values, pips.stepped);
        }
        if (pips.mode === $edc6d6d2a3ea6fb9$export$126649350cd02471.Positions) // Map all percentages to on-range values.
        return mapToRange(pips.values, pips.stepped);
        if (pips.mode === $edc6d6d2a3ea6fb9$export$126649350cd02471.Values) {
            // If the value must be stepped, it needs to be converted to a percentage first.
            if (pips.stepped) return pips.values.map(function(value) {
                // Convert to percentage, apply step, return to value.
                return scope_Spectrum.fromStepping(scope_Spectrum.getStep(scope_Spectrum.toStepping(value)));
            });
            // Otherwise, we can simply use the values.
            return pips.values;
        }
        return []; // pips.mode = never
    }
    function mapToRange(values, stepped) {
        return values.map(function(value) {
            return scope_Spectrum.fromStepping(stepped ? scope_Spectrum.getStep(value) : value);
        });
    }
    function generateSpread(pips) {
        function safeIncrement(value, increment) {
            // Avoid floating point variance by dropping the smallest decimal places.
            return Number((value + increment).toFixed(7));
        }
        var group = getGroup(pips);
        var indexes = {};
        var firstInRange = scope_Spectrum.xVal[0];
        var lastInRange = scope_Spectrum.xVal[scope_Spectrum.xVal.length - 1];
        var ignoreFirst = false;
        var ignoreLast = false;
        var prevPct = 0;
        // Create a copy of the group, sort it and filter away all duplicates.
        group = $edc6d6d2a3ea6fb9$var$unique(group.slice().sort(function(a, b) {
            return a - b;
        }));
        // Make sure the range starts with the first element.
        if (group[0] !== firstInRange) {
            group.unshift(firstInRange);
            ignoreFirst = true;
        }
        // Likewise for the last one.
        if (group[group.length - 1] !== lastInRange) {
            group.push(lastInRange);
            ignoreLast = true;
        }
        group.forEach(function(current, index) {
            // Get the current step and the lower + upper positions.
            var step;
            var i;
            var q;
            var low = current;
            var high = group[index + 1];
            var newPct;
            var pctDifference;
            var pctPos;
            var type;
            var steps;
            var realSteps;
            var stepSize;
            var isSteps = pips.mode === $edc6d6d2a3ea6fb9$export$126649350cd02471.Steps;
            // When using 'steps' mode, use the provided steps.
            // Otherwise, we'll step on to the next subrange.
            if (isSteps) step = scope_Spectrum.xNumSteps[index];
            // Default to a 'full' step.
            if (!step) step = high - low;
            // If high is undefined we are at the last subrange. Make sure it iterates once (#1088)
            if (high === undefined) high = low;
            // Make sure step isn't 0, which would cause an infinite loop (#654)
            step = Math.max(step, 0.0000001);
            // Find all steps in the subrange.
            for(i = low; i <= high; i = safeIncrement(i, step)){
                // Get the percentage value for the current step,
                // calculate the size for the subrange.
                newPct = scope_Spectrum.toStepping(i);
                pctDifference = newPct - prevPct;
                steps = pctDifference / (pips.density || 1);
                realSteps = Math.round(steps);
                // This ratio represents the amount of percentage-space a point indicates.
                // For a density 1 the points/percentage = 1. For density 2, that percentage needs to be re-divided.
                // Round the percentage offset to an even number, then divide by two
                // to spread the offset on both sides of the range.
                stepSize = pctDifference / realSteps;
                // Divide all points evenly, adding the correct number to this subrange.
                // Run up to <= so that 100% gets a point, event if ignoreLast is set.
                for(q = 1; q <= realSteps; q += 1){
                    // The ratio between the rounded value and the actual size might be ~1% off.
                    // Correct the percentage offset by the number of points
                    // per subrange. density = 1 will result in 100 points on the
                    // full range, 2 for 50, 4 for 25, etc.
                    pctPos = prevPct + q * stepSize;
                    indexes[pctPos.toFixed(5)] = [
                        scope_Spectrum.fromStepping(pctPos),
                        0
                    ];
                }
                // Determine the point type.
                type = group.indexOf(i) > -1 ? $edc6d6d2a3ea6fb9$export$ab20e68cdcd7a4fc.LargeValue : isSteps ? $edc6d6d2a3ea6fb9$export$ab20e68cdcd7a4fc.SmallValue : $edc6d6d2a3ea6fb9$export$ab20e68cdcd7a4fc.NoValue;
                // Enforce the 'ignoreFirst' option by overwriting the type for 0.
                if (!index && ignoreFirst && i !== high) type = 0;
                if (!(i === high && ignoreLast)) // Mark the 'type' of this point. 0 = plain, 1 = real value, 2 = step value.
                indexes[newPct.toFixed(5)] = [
                    i,
                    type
                ];
                // Update the percentage count.
                prevPct = newPct;
            }
        });
        return indexes;
    }
    function addMarking(spread, filterFunc, formatter) {
        var _a, _b;
        var element = scope_Document.createElement("div");
        var valueSizeClasses = (_a = {}, _a[$edc6d6d2a3ea6fb9$export$ab20e68cdcd7a4fc.None] = "", _a[$edc6d6d2a3ea6fb9$export$ab20e68cdcd7a4fc.NoValue] = options.cssClasses.valueNormal, _a[$edc6d6d2a3ea6fb9$export$ab20e68cdcd7a4fc.LargeValue] = options.cssClasses.valueLarge, _a[$edc6d6d2a3ea6fb9$export$ab20e68cdcd7a4fc.SmallValue] = options.cssClasses.valueSub, _a);
        var markerSizeClasses = (_b = {}, _b[$edc6d6d2a3ea6fb9$export$ab20e68cdcd7a4fc.None] = "", _b[$edc6d6d2a3ea6fb9$export$ab20e68cdcd7a4fc.NoValue] = options.cssClasses.markerNormal, _b[$edc6d6d2a3ea6fb9$export$ab20e68cdcd7a4fc.LargeValue] = options.cssClasses.markerLarge, _b[$edc6d6d2a3ea6fb9$export$ab20e68cdcd7a4fc.SmallValue] = options.cssClasses.markerSub, _b);
        var valueOrientationClasses = [
            options.cssClasses.valueHorizontal,
            options.cssClasses.valueVertical
        ];
        var markerOrientationClasses = [
            options.cssClasses.markerHorizontal,
            options.cssClasses.markerVertical
        ];
        $edc6d6d2a3ea6fb9$var$addClass(element, options.cssClasses.pips);
        $edc6d6d2a3ea6fb9$var$addClass(element, options.ort === 0 ? options.cssClasses.pipsHorizontal : options.cssClasses.pipsVertical);
        function getClasses(type, source) {
            var a = source === options.cssClasses.value;
            var orientationClasses = a ? valueOrientationClasses : markerOrientationClasses;
            var sizeClasses = a ? valueSizeClasses : markerSizeClasses;
            return source + " " + orientationClasses[options.ort] + " " + sizeClasses[type];
        }
        function addSpread(offset, value, type) {
            // Apply the filter function, if it is set.
            type = filterFunc ? filterFunc(value, type) : type;
            if (type === $edc6d6d2a3ea6fb9$export$ab20e68cdcd7a4fc.None) return;
            // Add a marker for every point
            var node = addNodeTo(element, false);
            node.className = getClasses(type, options.cssClasses.marker);
            node.style[options.style] = offset + "%";
            // Values are only appended for points marked '1' or '2'.
            if (type > $edc6d6d2a3ea6fb9$export$ab20e68cdcd7a4fc.NoValue) {
                node = addNodeTo(element, false);
                node.className = getClasses(type, options.cssClasses.value);
                node.setAttribute("data-value", String(value));
                node.style[options.style] = offset + "%";
                node.innerHTML = String(formatter.to(value));
            }
        }
        // Append all points.
        Object.keys(spread).forEach(function(offset) {
            addSpread(offset, spread[offset][0], spread[offset][1]);
        });
        return element;
    }
    function removePips() {
        if (scope_Pips) {
            $edc6d6d2a3ea6fb9$var$removeElement(scope_Pips);
            scope_Pips = null;
        }
    }
    function pips(pips) {
        // Fix #669
        removePips();
        var spread = generateSpread(pips);
        var filter = pips.filter;
        var format = pips.format || {
            to: function(value) {
                return String(Math.round(value));
            }
        };
        scope_Pips = scope_Target.appendChild(addMarking(spread, filter, format));
        return scope_Pips;
    }
    // Shorthand for base dimensions.
    function baseSize() {
        var rect = scope_Base.getBoundingClientRect();
        var alt = "offset" + [
            "Width",
            "Height"
        ][options.ort];
        return options.ort === 0 ? rect.width || scope_Base[alt] : rect.height || scope_Base[alt];
    }
    // Handler for attaching events trough a proxy.
    function attachEvent(events, element, callback, data) {
        // This function can be used to 'filter' events to the slider.
        // element is a node, not a nodeList
        var method = function(event) {
            var e = fixEvent(event, data.pageOffset, data.target || element);
            // fixEvent returns false if this event has a different target
            // when handling (multi-) touch events;
            if (!e) return false;
            // doNotReject is passed by all end events to make sure released touches
            // are not rejected, leaving the slider "stuck" to the cursor;
            if (isSliderDisabled() && !data.doNotReject) return false;
            // Stop if an active 'tap' transition is taking place.
            if ($edc6d6d2a3ea6fb9$var$hasClass(scope_Target, options.cssClasses.tap) && !data.doNotReject) return false;
            // Ignore right or middle clicks on start #454
            if (events === actions.start && e.buttons !== undefined && e.buttons > 1) return false;
            // Ignore right or middle clicks on start #454
            if (data.hover && e.buttons) return false;
            // 'supportsPassive' is only true if a browser also supports touch-action: none in CSS.
            // iOS safari does not, so it doesn't get to benefit from passive scrolling. iOS does support
            // touch-action: manipulation, but that allows panning, which breaks
            // sliders after zooming/on non-responsive pages.
            // See: https://bugs.webkit.org/show_bug.cgi?id=133112
            if (!supportsPassive) e.preventDefault();
            e.calcPoint = e.points[options.ort];
            // Call the event handler with the event [ and additional data ].
            callback(e, data);
            return;
        };
        var methods = [];
        // Bind a closure on the target for every event type.
        events.split(" ").forEach(function(eventName) {
            element.addEventListener(eventName, method, supportsPassive ? {
                passive: true
            } : false);
            methods.push([
                eventName,
                method
            ]);
        });
        return methods;
    }
    // Provide a clean event with standardized offset values.
    function fixEvent(e, pageOffset, eventTarget) {
        // Filter the event to register the type, which can be
        // touch, mouse or pointer. Offset changes need to be
        // made on an event specific basis.
        var touch = e.type.indexOf("touch") === 0;
        var mouse = e.type.indexOf("mouse") === 0;
        var pointer = e.type.indexOf("pointer") === 0;
        var x = 0;
        var y = 0;
        // IE10 implemented pointer events with a prefix;
        if (e.type.indexOf("MSPointer") === 0) pointer = true;
        // Erroneous events seem to be passed in occasionally on iOS/iPadOS after user finishes interacting with
        // the slider. They appear to be of type MouseEvent, yet they don't have usual properties set. Ignore
        // events that have no touches or buttons associated with them. (#1057, #1079, #1095)
        if (e.type === "mousedown" && !e.buttons && !e.touches) return false;
        // The only thing one handle should be concerned about is the touches that originated on top of it.
        if (touch) {
            // Returns true if a touch originated on the target.
            var isTouchOnTarget = function(checkTouch) {
                var target = checkTouch.target;
                return target === eventTarget || eventTarget.contains(target) || e.composed && e.composedPath().shift() === eventTarget;
            };
            // In the case of touchstart events, we need to make sure there is still no more than one
            // touch on the target so we look amongst all touches.
            if (e.type === "touchstart") {
                var targetTouches = Array.prototype.filter.call(e.touches, isTouchOnTarget);
                // Do not support more than one touch per handle.
                if (targetTouches.length > 1) return false;
                x = targetTouches[0].pageX;
                y = targetTouches[0].pageY;
            } else {
                // In the other cases, find on changedTouches is enough.
                var targetTouch = Array.prototype.find.call(e.changedTouches, isTouchOnTarget);
                // Cancel if the target touch has not moved.
                if (!targetTouch) return false;
                x = targetTouch.pageX;
                y = targetTouch.pageY;
            }
        }
        pageOffset = pageOffset || $edc6d6d2a3ea6fb9$var$getPageOffset(scope_Document);
        if (mouse || pointer) {
            x = e.clientX + pageOffset.x;
            y = e.clientY + pageOffset.y;
        }
        e.pageOffset = pageOffset;
        e.points = [
            x,
            y
        ];
        e.cursor = mouse || pointer; // Fix #435
        return e;
    }
    // Translate a coordinate in the document to a percentage on the slider
    function calcPointToPercentage(calcPoint) {
        var location = calcPoint - $edc6d6d2a3ea6fb9$var$offset(scope_Base, options.ort);
        var proposal = location * 100 / baseSize();
        // Clamp proposal between 0% and 100%
        // Out-of-bound coordinates may occur when .noUi-base pseudo-elements
        // are used (e.g. contained handles feature)
        proposal = $edc6d6d2a3ea6fb9$var$limit(proposal);
        return options.dir ? 100 - proposal : proposal;
    }
    // Find handle closest to a certain percentage on the slider
    function getClosestHandle(clickedPosition) {
        var smallestDifference = 100;
        var handleNumber = false;
        scope_Handles.forEach(function(handle, index) {
            // Disabled handles are ignored
            if (isHandleDisabled(index)) return;
            var handlePosition = scope_Locations[index];
            var differenceWithThisHandle = Math.abs(handlePosition - clickedPosition);
            // Initial state
            var clickAtEdge = differenceWithThisHandle === 100 && smallestDifference === 100;
            // Difference with this handle is smaller than the previously checked handle
            var isCloser = differenceWithThisHandle < smallestDifference;
            var isCloserAfter = differenceWithThisHandle <= smallestDifference && clickedPosition > handlePosition;
            if (isCloser || isCloserAfter || clickAtEdge) {
                handleNumber = index;
                smallestDifference = differenceWithThisHandle;
            }
        });
        return handleNumber;
    }
    // Fire 'end' when a mouse or pen leaves the document.
    function documentLeave(event, data) {
        if (event.type === "mouseout" && event.target.nodeName === "HTML" && event.relatedTarget === null) eventEnd(event, data);
    }
    // Handle movement on document for handle and range drag.
    function eventMove(event, data) {
        // Fix #498
        // Check value of .buttons in 'start' to work around a bug in IE10 mobile (data.buttonsProperty).
        // https://connect.microsoft.com/IE/feedback/details/927005/mobile-ie10-windows-phone-buttons-property-of-pointermove-event-always-zero
        // IE9 has .buttons and .which zero on mousemove.
        // Firefox breaks the spec MDN defines.
        if (navigator.appVersion.indexOf("MSIE 9") === -1 && event.buttons === 0 && data.buttonsProperty !== 0) return eventEnd(event, data);
        // Check if we are moving up or down
        var movement = (options.dir ? -1 : 1) * (event.calcPoint - data.startCalcPoint);
        // Convert the movement into a percentage of the slider width/height
        var proposal = movement * 100 / data.baseSize;
        moveHandles(movement > 0, proposal, data.locations, data.handleNumbers, data.connect);
    }
    // Unbind move events on document, call callbacks.
    function eventEnd(event, data) {
        // The handle is no longer active, so remove the class.
        if (data.handle) {
            $edc6d6d2a3ea6fb9$var$removeClass(data.handle, options.cssClasses.active);
            scope_ActiveHandlesCount -= 1;
        }
        // Unbind the move and end events, which are added on 'start'.
        data.listeners.forEach(function(c) {
            scope_DocumentElement.removeEventListener(c[0], c[1]);
        });
        if (scope_ActiveHandlesCount === 0) {
            // Remove dragging class.
            $edc6d6d2a3ea6fb9$var$removeClass(scope_Target, options.cssClasses.drag);
            setZindex();
            // Remove cursor styles and text-selection events bound to the body.
            if (event.cursor) {
                scope_Body.style.cursor = "";
                scope_Body.removeEventListener("selectstart", $edc6d6d2a3ea6fb9$var$preventDefault);
            }
        }
        if (options.events.smoothSteps) {
            data.handleNumbers.forEach(function(handleNumber) {
                setHandle(handleNumber, scope_Locations[handleNumber], true, true, false, false);
            });
            data.handleNumbers.forEach(function(handleNumber) {
                fireEvent("update", handleNumber);
            });
        }
        data.handleNumbers.forEach(function(handleNumber) {
            fireEvent("change", handleNumber);
            fireEvent("set", handleNumber);
            fireEvent("end", handleNumber);
        });
    }
    // Bind move events on document.
    function eventStart(event, data) {
        // Ignore event if any handle is disabled
        if (data.handleNumbers.some(isHandleDisabled)) return;
        var handle;
        if (data.handleNumbers.length === 1) {
            var handleOrigin = scope_Handles[data.handleNumbers[0]];
            handle = handleOrigin.children[0];
            scope_ActiveHandlesCount += 1;
            // Mark the handle as 'active' so it can be styled.
            $edc6d6d2a3ea6fb9$var$addClass(handle, options.cssClasses.active);
        }
        // A drag should never propagate up to the 'tap' event.
        event.stopPropagation();
        // Record the event listeners.
        var listeners = [];
        // Attach the move and end events.
        var moveEvent = attachEvent(actions.move, scope_DocumentElement, eventMove, {
            // The event target has changed so we need to propagate the original one so that we keep
            // relying on it to extract target touches.
            target: event.target,
            handle: handle,
            connect: data.connect,
            listeners: listeners,
            startCalcPoint: event.calcPoint,
            baseSize: baseSize(),
            pageOffset: event.pageOffset,
            handleNumbers: data.handleNumbers,
            buttonsProperty: event.buttons,
            locations: scope_Locations.slice()
        });
        var endEvent = attachEvent(actions.end, scope_DocumentElement, eventEnd, {
            target: event.target,
            handle: handle,
            listeners: listeners,
            doNotReject: true,
            handleNumbers: data.handleNumbers
        });
        var outEvent = attachEvent("mouseout", scope_DocumentElement, documentLeave, {
            target: event.target,
            handle: handle,
            listeners: listeners,
            doNotReject: true,
            handleNumbers: data.handleNumbers
        });
        // We want to make sure we pushed the listeners in the listener list rather than creating
        // a new one as it has already been passed to the event handlers.
        listeners.push.apply(listeners, moveEvent.concat(endEvent, outEvent));
        // Text selection isn't an issue on touch devices,
        // so adding cursor styles can be skipped.
        if (event.cursor) {
            // Prevent the 'I' cursor and extend the range-drag cursor.
            scope_Body.style.cursor = getComputedStyle(event.target).cursor;
            // Mark the target with a dragging state.
            if (scope_Handles.length > 1) $edc6d6d2a3ea6fb9$var$addClass(scope_Target, options.cssClasses.drag);
            // Prevent text selection when dragging the handles.
            // In noUiSlider <= 9.2.0, this was handled by calling preventDefault on mouse/touch start/move,
            // which is scroll blocking. The selectstart event is supported by FireFox starting from version 52,
            // meaning the only holdout is iOS Safari. This doesn't matter: text selection isn't triggered there.
            // The 'cursor' flag is false.
            // See: http://caniuse.com/#search=selectstart
            scope_Body.addEventListener("selectstart", $edc6d6d2a3ea6fb9$var$preventDefault, false);
        }
        data.handleNumbers.forEach(function(handleNumber) {
            fireEvent("start", handleNumber);
        });
    }
    // Move closest handle to tapped location.
    function eventTap(event) {
        // The tap event shouldn't propagate up
        event.stopPropagation();
        var proposal = calcPointToPercentage(event.calcPoint);
        var handleNumber = getClosestHandle(proposal);
        // Tackle the case that all handles are 'disabled'.
        if (handleNumber === false) return;
        // Flag the slider as it is now in a transitional state.
        // Transition takes a configurable amount of ms (default 300). Re-enable the slider after that.
        if (!options.events.snap) $edc6d6d2a3ea6fb9$var$addClassFor(scope_Target, options.cssClasses.tap, options.animationDuration);
        setHandle(handleNumber, proposal, true, true);
        setZindex();
        fireEvent("slide", handleNumber, true);
        fireEvent("update", handleNumber, true);
        if (!options.events.snap) {
            fireEvent("change", handleNumber, true);
            fireEvent("set", handleNumber, true);
        } else eventStart(event, {
            handleNumbers: [
                handleNumber
            ]
        });
    }
    // Fires a 'hover' event for a hovered mouse/pen position.
    function eventHover(event) {
        var proposal = calcPointToPercentage(event.calcPoint);
        var to = scope_Spectrum.getStep(proposal);
        var value = scope_Spectrum.fromStepping(to);
        Object.keys(scope_Events).forEach(function(targetEvent) {
            if ("hover" === targetEvent.split(".")[0]) scope_Events[targetEvent].forEach(function(callback) {
                callback.call(scope_Self, value);
            });
        });
    }
    // Handles keydown on focused handles
    // Don't move the document when pressing arrow keys on focused handles
    function eventKeydown(event, handleNumber) {
        if (isSliderDisabled() || isHandleDisabled(handleNumber)) return false;
        var horizontalKeys = [
            "Left",
            "Right"
        ];
        var verticalKeys = [
            "Down",
            "Up"
        ];
        var largeStepKeys = [
            "PageDown",
            "PageUp"
        ];
        var edgeKeys = [
            "Home",
            "End"
        ];
        if (options.dir && !options.ort) // On an right-to-left slider, the left and right keys act inverted
        horizontalKeys.reverse();
        else if (options.ort && !options.dir) {
            // On a top-to-bottom slider, the up and down keys act inverted
            verticalKeys.reverse();
            largeStepKeys.reverse();
        }
        // Strip "Arrow" for IE compatibility. https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
        var key = event.key.replace("Arrow", "");
        var isLargeDown = key === largeStepKeys[0];
        var isLargeUp = key === largeStepKeys[1];
        var isDown = key === verticalKeys[0] || key === horizontalKeys[0] || isLargeDown;
        var isUp = key === verticalKeys[1] || key === horizontalKeys[1] || isLargeUp;
        var isMin = key === edgeKeys[0];
        var isMax = key === edgeKeys[1];
        if (!isDown && !isUp && !isMin && !isMax) return true;
        event.preventDefault();
        var to;
        if (isUp || isDown) {
            var direction = isDown ? 0 : 1;
            var steps = getNextStepsForHandle(handleNumber);
            var step = steps[direction];
            // At the edge of a slider, do nothing
            if (step === null) return false;
            // No step set, use the default of 10% of the sub-range
            if (step === false) step = scope_Spectrum.getDefaultStep(scope_Locations[handleNumber], isDown, options.keyboardDefaultStep);
            if (isLargeUp || isLargeDown) step *= options.keyboardPageMultiplier;
            else step *= options.keyboardMultiplier;
            // Step over zero-length ranges (#948);
            step = Math.max(step, 0.0000001);
            // Decrement for down steps
            step = (isDown ? -1 : 1) * step;
            to = scope_Values[handleNumber] + step;
        } else if (isMax) // End key
        to = options.spectrum.xVal[options.spectrum.xVal.length - 1];
        else // Home key
        to = options.spectrum.xVal[0];
        setHandle(handleNumber, scope_Spectrum.toStepping(to), true, true);
        fireEvent("slide", handleNumber);
        fireEvent("update", handleNumber);
        fireEvent("change", handleNumber);
        fireEvent("set", handleNumber);
        return false;
    }
    // Attach events to several slider parts.
    function bindSliderEvents(behaviour) {
        // Attach the standard drag event to the handles.
        if (!behaviour.fixed) scope_Handles.forEach(function(handle, index) {
            // These events are only bound to the visual handle
            // element, not the 'real' origin element.
            attachEvent(actions.start, handle.children[0], eventStart, {
                handleNumbers: [
                    index
                ]
            });
        });
        // Attach the tap event to the slider base.
        if (behaviour.tap) attachEvent(actions.start, scope_Base, eventTap, {});
        // Fire hover events
        if (behaviour.hover) attachEvent(actions.move, scope_Base, eventHover, {
            hover: true
        });
        // Make the range draggable.
        if (behaviour.drag) scope_Connects.forEach(function(connect, index) {
            if (connect === false || index === 0 || index === scope_Connects.length - 1) return;
            var handleBefore = scope_Handles[index - 1];
            var handleAfter = scope_Handles[index];
            var eventHolders = [
                connect
            ];
            var handlesToDrag = [
                handleBefore,
                handleAfter
            ];
            var handleNumbersToDrag = [
                index - 1,
                index
            ];
            $edc6d6d2a3ea6fb9$var$addClass(connect, options.cssClasses.draggable);
            // When the range is fixed, the entire range can
            // be dragged by the handles. The handle in the first
            // origin will propagate the start event upward,
            // but it needs to be bound manually on the other.
            if (behaviour.fixed) {
                eventHolders.push(handleBefore.children[0]);
                eventHolders.push(handleAfter.children[0]);
            }
            if (behaviour.dragAll) {
                handlesToDrag = scope_Handles;
                handleNumbersToDrag = scope_HandleNumbers;
            }
            eventHolders.forEach(function(eventHolder) {
                attachEvent(actions.start, eventHolder, eventStart, {
                    handles: handlesToDrag,
                    handleNumbers: handleNumbersToDrag,
                    connect: connect
                });
            });
        });
    }
    // Attach an event to this slider, possibly including a namespace
    function bindEvent(namespacedEvent, callback) {
        scope_Events[namespacedEvent] = scope_Events[namespacedEvent] || [];
        scope_Events[namespacedEvent].push(callback);
        // If the event bound is 'update,' fire it immediately for all handles.
        if (namespacedEvent.split(".")[0] === "update") scope_Handles.forEach(function(a, index) {
            fireEvent("update", index);
        });
    }
    function isInternalNamespace(namespace) {
        return namespace === $edc6d6d2a3ea6fb9$var$INTERNAL_EVENT_NS.aria || namespace === $edc6d6d2a3ea6fb9$var$INTERNAL_EVENT_NS.tooltips;
    }
    // Undo attachment of event
    function removeEvent(namespacedEvent) {
        var event = namespacedEvent && namespacedEvent.split(".")[0];
        var namespace = event ? namespacedEvent.substring(event.length) : namespacedEvent;
        Object.keys(scope_Events).forEach(function(bind) {
            var tEvent = bind.split(".")[0];
            var tNamespace = bind.substring(tEvent.length);
            if ((!event || event === tEvent) && (!namespace || namespace === tNamespace)) // only delete protected internal event if intentional
            {
                if (!isInternalNamespace(tNamespace) || namespace === tNamespace) delete scope_Events[bind];
            }
        });
    }
    // External event handling
    function fireEvent(eventName, handleNumber, tap) {
        Object.keys(scope_Events).forEach(function(targetEvent) {
            var eventType = targetEvent.split(".")[0];
            if (eventName === eventType) scope_Events[targetEvent].forEach(function(callback) {
                callback.call(// Use the slider public API as the scope ('this')
                scope_Self, // Return values as array, so arg_1[arg_2] is always valid.
                scope_Values.map(options.format.to), // Handle index, 0 or 1
                handleNumber, // Un-formatted slider values
                scope_Values.slice(), // Event is fired by tap, true or false
                tap || false, // Left offset of the handle, in relation to the slider
                scope_Locations.slice(), // add the slider public API to an accessible parameter when this is unavailable
                scope_Self);
            });
        });
    }
    // Split out the handle positioning logic so the Move event can use it, too
    function checkHandlePosition(reference, handleNumber, to, lookBackward, lookForward, getValue, smoothSteps) {
        var distance;
        // For sliders with multiple handles, limit movement to the other handle.
        // Apply the margin option by adding it to the handle positions.
        if (scope_Handles.length > 1 && !options.events.unconstrained) {
            if (lookBackward && handleNumber > 0) {
                distance = scope_Spectrum.getAbsoluteDistance(reference[handleNumber - 1], options.margin, false);
                to = Math.max(to, distance);
            }
            if (lookForward && handleNumber < scope_Handles.length - 1) {
                distance = scope_Spectrum.getAbsoluteDistance(reference[handleNumber + 1], options.margin, true);
                to = Math.min(to, distance);
            }
        }
        // The limit option has the opposite effect, limiting handles to a
        // maximum distance from another. Limit must be > 0, as otherwise
        // handles would be unmovable.
        if (scope_Handles.length > 1 && options.limit) {
            if (lookBackward && handleNumber > 0) {
                distance = scope_Spectrum.getAbsoluteDistance(reference[handleNumber - 1], options.limit, false);
                to = Math.min(to, distance);
            }
            if (lookForward && handleNumber < scope_Handles.length - 1) {
                distance = scope_Spectrum.getAbsoluteDistance(reference[handleNumber + 1], options.limit, true);
                to = Math.max(to, distance);
            }
        }
        // The padding option keeps the handles a certain distance from the
        // edges of the slider. Padding must be > 0.
        if (options.padding) {
            if (handleNumber === 0) {
                distance = scope_Spectrum.getAbsoluteDistance(0, options.padding[0], false);
                to = Math.max(to, distance);
            }
            if (handleNumber === scope_Handles.length - 1) {
                distance = scope_Spectrum.getAbsoluteDistance(100, options.padding[1], true);
                to = Math.min(to, distance);
            }
        }
        if (!smoothSteps) to = scope_Spectrum.getStep(to);
        // Limit percentage to the 0 - 100 range
        to = $edc6d6d2a3ea6fb9$var$limit(to);
        // Return false if handle can't move
        if (to === reference[handleNumber] && !getValue) return false;
        return to;
    }
    // Uses slider orientation to create CSS rules. a = base value;
    function inRuleOrder(v, a) {
        var o = options.ort;
        return (o ? a : v) + ", " + (o ? v : a);
    }
    // Moves handle(s) by a percentage
    // (bool, % to move, [% where handle started, ...], [index in scope_Handles, ...])
    function moveHandles(upward, proposal, locations, handleNumbers, connect) {
        var proposals = locations.slice();
        // Store first handle now, so we still have it in case handleNumbers is reversed
        var firstHandle = handleNumbers[0];
        var smoothSteps = options.events.smoothSteps;
        var b = [
            !upward,
            upward
        ];
        var f = [
            upward,
            !upward
        ];
        // Copy handleNumbers so we don't change the dataset
        handleNumbers = handleNumbers.slice();
        // Check to see which handle is 'leading'.
        // If that one can't move the second can't either.
        if (upward) handleNumbers.reverse();
        // Step 1: get the maximum percentage that any of the handles can move
        if (handleNumbers.length > 1) handleNumbers.forEach(function(handleNumber, o) {
            var to = checkHandlePosition(proposals, handleNumber, proposals[handleNumber] + proposal, b[o], f[o], false, smoothSteps);
            // Stop if one of the handles can't move.
            if (to === false) proposal = 0;
            else {
                proposal = to - proposals[handleNumber];
                proposals[handleNumber] = to;
            }
        });
        else b = f = [
            true
        ];
        var state = false;
        // Step 2: Try to set the handles with the found percentage
        handleNumbers.forEach(function(handleNumber, o) {
            state = setHandle(handleNumber, locations[handleNumber] + proposal, b[o], f[o], false, smoothSteps) || state;
        });
        // Step 3: If a handle moved, fire events
        if (state) {
            handleNumbers.forEach(function(handleNumber) {
                fireEvent("update", handleNumber);
                fireEvent("slide", handleNumber);
            });
            // If target is a connect, then fire drag event
            if (connect != undefined) fireEvent("drag", firstHandle);
        }
    }
    // Takes a base value and an offset. This offset is used for the connect bar size.
    // In the initial design for this feature, the origin element was 1% wide.
    // Unfortunately, a rounding bug in Chrome makes it impossible to implement this feature
    // in this manner: https://bugs.chromium.org/p/chromium/issues/detail?id=798223
    function transformDirection(a, b) {
        return options.dir ? 100 - a - b : a;
    }
    // Updates scope_Locations and scope_Values, updates visual state
    function updateHandlePosition(handleNumber, to) {
        // Update locations.
        scope_Locations[handleNumber] = to;
        // Convert the value to the slider stepping/range.
        scope_Values[handleNumber] = scope_Spectrum.fromStepping(to);
        var translation = transformDirection(to, 0) - scope_DirOffset;
        var translateRule = "translate(" + inRuleOrder(translation + "%", "0") + ")";
        scope_Handles[handleNumber].style[options.transformRule] = translateRule;
        // sanity check for at least 2 handles (e.g. during setup)
        if (options.events.invertConnects && scope_Locations.length > 1) {
            // check if handles passed each other, but don't match the ConnectsInverted state
            var handlesAreInOrder = scope_Locations.every(function(position, index, locations) {
                return index === 0 || position >= locations[index - 1];
            });
            if (scope_ConnectsInverted !== !handlesAreInOrder) {
                // invert connects when handles pass each other
                invertConnects();
                // invertConnects already updates all connect elements
                return;
            }
        }
        updateConnect(handleNumber);
        updateConnect(handleNumber + 1);
        if (scope_ConnectsInverted) {
            // When connects are inverted, we also have to update adjacent connects
            updateConnect(handleNumber - 1);
            updateConnect(handleNumber + 2);
        }
    }
    // Handles before the slider middle are stacked later = higher,
    // Handles after the middle later is lower
    // [[7] [8] .......... | .......... [5] [4]
    function setZindex() {
        scope_HandleNumbers.forEach(function(handleNumber) {
            var dir = scope_Locations[handleNumber] > 50 ? -1 : 1;
            var zIndex = 3 + (scope_Handles.length + dir * handleNumber);
            scope_Handles[handleNumber].style.zIndex = String(zIndex);
        });
    }
    // Test suggested values and apply margin, step.
    // if exactInput is true, don't run checkHandlePosition, then the handle can be placed in between steps (#436)
    function setHandle(handleNumber, to, lookBackward, lookForward, exactInput, smoothSteps) {
        if (!exactInput) to = checkHandlePosition(scope_Locations, handleNumber, to, lookBackward, lookForward, false, smoothSteps);
        if (to === false) return false;
        updateHandlePosition(handleNumber, to);
        return true;
    }
    // Updates style attribute for connect nodes
    function updateConnect(index) {
        // Skip connects set to false
        if (!scope_Connects[index]) return;
        // Create a copy of locations, so we can sort them for the local scope logic
        var locations = scope_Locations.slice();
        if (scope_ConnectsInverted) locations.sort(function(a, b) {
            return a - b;
        });
        var l = 0;
        var h = 100;
        if (index !== 0) l = locations[index - 1];
        if (index !== scope_Connects.length - 1) h = locations[index];
        // We use two rules:
        // 'translate' to change the left/top offset;
        // 'scale' to change the width of the element;
        // As the element has a width of 100%, a translation of 100% is equal to 100% of the parent (.noUi-base)
        var connectWidth = h - l;
        var translateRule = "translate(" + inRuleOrder(transformDirection(l, connectWidth) + "%", "0") + ")";
        var scaleRule = "scale(" + inRuleOrder(connectWidth / 100, "1") + ")";
        scope_Connects[index].style[options.transformRule] = translateRule + " " + scaleRule;
    }
    // Parses value passed to .set method. Returns current value if not parse-able.
    function resolveToValue(to, handleNumber) {
        // Setting with null indicates an 'ignore'.
        // Inputting 'false' is invalid.
        if (to === null || to === false || to === undefined) return scope_Locations[handleNumber];
        // If a formatted number was passed, attempt to decode it.
        if (typeof to === "number") to = String(to);
        to = options.format.from(to);
        if (to !== false) to = scope_Spectrum.toStepping(to);
        // If parsing the number failed, use the current value.
        if (to === false || isNaN(to)) return scope_Locations[handleNumber];
        return to;
    }
    // Set the slider value.
    function valueSet(input, fireSetEvent, exactInput) {
        var values = $edc6d6d2a3ea6fb9$var$asArray(input);
        var isInit = scope_Locations[0] === undefined;
        // Event fires by default
        fireSetEvent = fireSetEvent === undefined ? true : fireSetEvent;
        // Animation is optional.
        // Make sure the initial values were set before using animated placement.
        if (options.animate && !isInit) $edc6d6d2a3ea6fb9$var$addClassFor(scope_Target, options.cssClasses.tap, options.animationDuration);
        // First pass, without lookAhead but with lookBackward. Values are set from left to right.
        scope_HandleNumbers.forEach(function(handleNumber) {
            setHandle(handleNumber, resolveToValue(values[handleNumber], handleNumber), true, false, exactInput);
        });
        var i = scope_HandleNumbers.length === 1 ? 0 : 1;
        // Spread handles evenly across the slider if the range has no size (min=max)
        if (isInit && scope_Spectrum.hasNoSize()) {
            exactInput = true;
            scope_Locations[0] = 0;
            if (scope_HandleNumbers.length > 1) {
                var space_1 = 100 / (scope_HandleNumbers.length - 1);
                scope_HandleNumbers.forEach(function(handleNumber) {
                    scope_Locations[handleNumber] = handleNumber * space_1;
                });
            }
        }
        // Secondary passes. Now that all base values are set, apply constraints.
        // Iterate all handles to ensure constraints are applied for the entire slider (Issue #1009)
        for(; i < scope_HandleNumbers.length; ++i)scope_HandleNumbers.forEach(function(handleNumber) {
            setHandle(handleNumber, scope_Locations[handleNumber], true, true, exactInput);
        });
        setZindex();
        scope_HandleNumbers.forEach(function(handleNumber) {
            fireEvent("update", handleNumber);
            // Fire the event only for handles that received a new value, as per #579
            if (values[handleNumber] !== null && fireSetEvent) fireEvent("set", handleNumber);
        });
    }
    // Reset slider to initial values
    function valueReset(fireSetEvent) {
        valueSet(options.start, fireSetEvent);
    }
    // Set value for a single handle
    function valueSetHandle(handleNumber, value, fireSetEvent, exactInput) {
        // Ensure numeric input
        handleNumber = Number(handleNumber);
        if (!(handleNumber >= 0 && handleNumber < scope_HandleNumbers.length)) throw new Error("noUiSlider: invalid handle number, got: " + handleNumber);
        // Look both backward and forward, since we don't want this handle to "push" other handles (#960);
        // The exactInput argument can be used to ignore slider stepping (#436)
        setHandle(handleNumber, resolveToValue(value, handleNumber), true, true, exactInput);
        fireEvent("update", handleNumber);
        if (fireSetEvent) fireEvent("set", handleNumber);
    }
    // Get the slider value.
    function valueGet(unencoded) {
        if (unencoded === void 0) unencoded = false;
        if (unencoded) // return a copy of the raw values
        return scope_Values.length === 1 ? scope_Values[0] : scope_Values.slice(0);
        var values = scope_Values.map(options.format.to);
        // If only one handle is used, return a single value.
        if (values.length === 1) return values[0];
        return values;
    }
    // Removes classes from the root and empties it.
    function destroy() {
        // remove protected internal listeners
        removeEvent($edc6d6d2a3ea6fb9$var$INTERNAL_EVENT_NS.aria);
        removeEvent($edc6d6d2a3ea6fb9$var$INTERNAL_EVENT_NS.tooltips);
        Object.keys(options.cssClasses).forEach(function(key) {
            $edc6d6d2a3ea6fb9$var$removeClass(scope_Target, options.cssClasses[key]);
        });
        while(scope_Target.firstChild)scope_Target.removeChild(scope_Target.firstChild);
        delete scope_Target.noUiSlider;
    }
    function getNextStepsForHandle(handleNumber) {
        var location = scope_Locations[handleNumber];
        var nearbySteps = scope_Spectrum.getNearbySteps(location);
        var value = scope_Values[handleNumber];
        var increment = nearbySteps.thisStep.step;
        var decrement = null;
        // If snapped, directly use defined step value
        if (options.snap) return [
            value - nearbySteps.stepBefore.startValue || null,
            nearbySteps.stepAfter.startValue - value || null
        ];
        // If the next value in this step moves into the next step,
        // the increment is the start of the next step - the current value
        if (increment !== false) {
            if (value + increment > nearbySteps.stepAfter.startValue) increment = nearbySteps.stepAfter.startValue - value;
        }
        // If the value is beyond the starting point
        if (value > nearbySteps.thisStep.startValue) decrement = nearbySteps.thisStep.step;
        else if (nearbySteps.stepBefore.step === false) decrement = false;
        else decrement = value - nearbySteps.stepBefore.highestStep;
        // Now, if at the slider edges, there is no in/decrement
        if (location === 100) increment = null;
        else if (location === 0) decrement = null;
        // As per #391, the comparison for the decrement step can have some rounding issues.
        var stepDecimals = scope_Spectrum.countStepDecimals();
        // Round per #391
        if (increment !== null && increment !== false) increment = Number(increment.toFixed(stepDecimals));
        if (decrement !== null && decrement !== false) decrement = Number(decrement.toFixed(stepDecimals));
        return [
            decrement,
            increment
        ];
    }
    // Get the current step size for the slider.
    function getNextSteps() {
        return scope_HandleNumbers.map(getNextStepsForHandle);
    }
    // Updatable: margin, limit, padding, step, range, animate, snap
    function updateOptions(optionsToUpdate, fireSetEvent) {
        // Spectrum is created using the range, snap, direction and step options.
        // 'snap' and 'step' can be updated.
        // If 'snap' and 'step' are not passed, they should remain unchanged.
        var v = valueGet();
        var updateAble = [
            "margin",
            "limit",
            "padding",
            "range",
            "animate",
            "snap",
            "step",
            "format",
            "pips",
            "tooltips",
            "connect"
        ];
        // Only change options that we're actually passed to update.
        updateAble.forEach(function(name) {
            // Check for undefined. null removes the value.
            if (optionsToUpdate[name] !== undefined) originalOptions[name] = optionsToUpdate[name];
        });
        var newOptions = $edc6d6d2a3ea6fb9$var$testOptions(originalOptions);
        // Load new options into the slider state
        updateAble.forEach(function(name) {
            if (optionsToUpdate[name] !== undefined) options[name] = newOptions[name];
        });
        scope_Spectrum = newOptions.spectrum;
        // Limit, margin and padding depend on the spectrum but are stored outside of it. (#677)
        options.margin = newOptions.margin;
        options.limit = newOptions.limit;
        options.padding = newOptions.padding;
        // Update pips, removes existing.
        if (options.pips) pips(options.pips);
        else removePips();
        // Update tooltips, removes existing.
        if (options.tooltips) tooltips();
        else removeTooltips();
        // Invalidate the current positioning so valueSet forces an update.
        scope_Locations = [];
        valueSet($edc6d6d2a3ea6fb9$var$isSet(optionsToUpdate.start) ? optionsToUpdate.start : v, fireSetEvent);
        // Update connects only if it was set
        if (optionsToUpdate.connect) updateConnectOption();
    }
    function updateConnectOption() {
        // IE supported way of removing children including event handlers
        while(scope_ConnectBase.firstChild)scope_ConnectBase.removeChild(scope_ConnectBase.firstChild);
        // Adding new connects according to the new connect options
        for(var i = 0; i <= options.handles; i++){
            scope_Connects[i] = addConnect(scope_ConnectBase, options.connect[i]);
            updateConnect(i);
        }
        // re-adding drag events for the new connect elements
        // to ignore the other events we have to negate the 'if (!behaviour.fixed)' check
        bindSliderEvents({
            drag: options.events.drag,
            fixed: true
        });
    }
    // Invert options for connect handles
    function invertConnects() {
        scope_ConnectsInverted = !scope_ConnectsInverted;
        $edc6d6d2a3ea6fb9$var$testConnect(options, // inverse the connect boolean array
        options.connect.map(function(b) {
            return !b;
        }));
        updateConnectOption();
    }
    // Initialization steps
    function setupSlider() {
        // Create the base element, initialize HTML and set classes.
        // Add handles and connect elements.
        scope_Base = addSlider(scope_Target);
        addElements(options.connect, scope_Base);
        // Attach user events.
        bindSliderEvents(options.events);
        // Use the public value method to set the start values.
        valueSet(options.start);
        if (options.pips) pips(options.pips);
        if (options.tooltips) tooltips();
        aria();
    }
    setupSlider();
    var scope_Self = {
        destroy: destroy,
        steps: getNextSteps,
        on: bindEvent,
        off: removeEvent,
        get: valueGet,
        set: valueSet,
        setHandle: valueSetHandle,
        reset: valueReset,
        disable: disable,
        enable: enable,
        // Exposed for unit testing, don't use this in your application.
        __moveHandles: function(upward, proposal, handleNumbers) {
            moveHandles(upward, proposal, scope_Locations, handleNumbers);
        },
        options: originalOptions,
        updateOptions: updateOptions,
        target: scope_Target,
        removePips: removePips,
        removeTooltips: removeTooltips,
        getPositions: function() {
            return scope_Locations.slice();
        },
        getTooltips: function() {
            return scope_Tooltips;
        },
        getOrigins: function() {
            return scope_Handles;
        },
        pips: pips
    };
    return scope_Self;
}
// Run the standard initializer
function $edc6d6d2a3ea6fb9$export$185802fd694ee1f5(target, originalOptions) {
    if (!target || !target.nodeName) throw new Error("noUiSlider: create requires a single element, got: " + target);
    // Throw an error if the slider was already initialized.
    if (target.noUiSlider) throw new Error("noUiSlider: Slider was already initialized.");
    // Test the options and create the slider environment;
    var options = $edc6d6d2a3ea6fb9$var$testOptions(originalOptions);
    var api = $edc6d6d2a3ea6fb9$var$scope(target, options, originalOptions);
    target.noUiSlider = api;
    return api;
}
var $edc6d6d2a3ea6fb9$export$2e2bcd8739ae039 = {
    // Exposed for unit testing, don't use this in your application.
    __spectrum: $edc6d6d2a3ea6fb9$var$Spectrum,
    // A reference to the default classes, allows global changes.
    // Use the cssClasses option for changes to one slider.
    cssClasses: $edc6d6d2a3ea6fb9$export$c1c0562ec8379000,
    create: $edc6d6d2a3ea6fb9$export$185802fd694ee1f5
};



const $cbe8ad03059288e1$export$b38bf4f33e9e4c25 = ()=>{
    const SLIDER_BASIC = document.getElementById("slider-basic");
    const SLIDER_RANGE = document.getElementById("slider-range");
    if (SLIDER_BASIC) {
        (0, $edc6d6d2a3ea6fb9$export$2e2bcd8739ae039).create(SLIDER_BASIC, {
            start: [
                20
            ],
            connect: "lower",
            range: {
                min: 0,
                max: 100
            }
        });
        SLIDER_BASIC.noUiSlider.on("update", function(values, handle) {
            document.getElementById("slider-basic-input").value = values[handle];
        });
    }
    if (SLIDER_RANGE) {
        const SLIDER_RANGER_UPPER = document.getElementById("slider-range-upper-input");
        const SLIDER_RANGER_LOWER = document.getElementById("slider-range-lower-input");
        const SLIDER_RANGER_INPUTS = [
            SLIDER_RANGER_UPPER,
            SLIDER_RANGER_LOWER
        ];
        (0, $edc6d6d2a3ea6fb9$export$2e2bcd8739ae039).create(SLIDER_RANGE, {
            start: [
                30,
                70
            ],
            connect: true,
            range: {
                min: 0,
                max: 100
            }
        });
        SLIDER_RANGE.noUiSlider.on("update", function(values, handle) {
            SLIDER_RANGER_INPUTS[handle].value = values[handle];
        });
    }
};


// Clamps a value between an upper and lower bound.
// We use ternary operators because it makes the minified code
// 2 times shorter then `Math.min(Math.max(a,b),c)`
const $95bbae6a8d1f7f9a$export$7d15b64cf5a3a4c4 = (number, min = 0, max = 1)=>{
    return number > max ? max : number < min ? min : number;
};
const $95bbae6a8d1f7f9a$export$2077e0241d6afd3c = (number, digits = 0, base = Math.pow(10, digits))=>{
    return Math.round(base * number) / base;
};


/**
 * Valid CSS <angle> units.
 * https://developer.mozilla.org/en-US/docs/Web/CSS/angle
 */ const $a9cf2169b9b928b8$var$angleUnits = {
    grad: 0.9,
    turn: 360,
    rad: 360 / (Math.PI * 2)
};
const $a9cf2169b9b928b8$export$b46408e00e83b492 = (hex)=>$a9cf2169b9b928b8$export$f4deeebdec6065f9($a9cf2169b9b928b8$export$9665a07d9187b414(hex));
const $a9cf2169b9b928b8$export$9665a07d9187b414 = (hex)=>{
    if (hex[0] === '#') hex = hex.substring(1);
    if (hex.length < 6) return {
        r: parseInt(hex[0] + hex[0], 16),
        g: parseInt(hex[1] + hex[1], 16),
        b: parseInt(hex[2] + hex[2], 16),
        a: hex.length === 4 ? (0, $95bbae6a8d1f7f9a$export$2077e0241d6afd3c)(parseInt(hex[3] + hex[3], 16) / 255, 2) : 1
    };
    return {
        r: parseInt(hex.substring(0, 2), 16),
        g: parseInt(hex.substring(2, 4), 16),
        b: parseInt(hex.substring(4, 6), 16),
        a: hex.length === 8 ? (0, $95bbae6a8d1f7f9a$export$2077e0241d6afd3c)(parseInt(hex.substring(6, 8), 16) / 255, 2) : 1
    };
};
const $a9cf2169b9b928b8$export$7c374483fd1c382f = (value, unit = 'deg')=>{
    return Number(value) * ($a9cf2169b9b928b8$var$angleUnits[unit] || 1);
};
const $a9cf2169b9b928b8$export$f1cc23c1d78956ee = (hslString)=>{
    const matcher = /hsla?\(?\s*(-?\d*\.?\d+)(deg|rad|grad|turn)?[,\s]+(-?\d*\.?\d+)%?[,\s]+(-?\d*\.?\d+)%?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i;
    const match = matcher.exec(hslString);
    if (!match) return {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
    return $a9cf2169b9b928b8$export$cad8462dfe655319({
        h: $a9cf2169b9b928b8$export$7c374483fd1c382f(match[1], match[2]),
        s: Number(match[3]),
        l: Number(match[4]),
        a: match[5] === undefined ? 1 : Number(match[5]) / (match[6] ? 100 : 1)
    });
};
const $a9cf2169b9b928b8$export$da6b3453e45f3684 = $a9cf2169b9b928b8$export$f1cc23c1d78956ee;
const $a9cf2169b9b928b8$export$cad8462dfe655319 = ({ h: h, s: s, l: l, a: a })=>{
    s *= (l < 50 ? l : 100 - l) / 100;
    return {
        h: h,
        s: s > 0 ? 2 * s / (l + s) * 100 : 0,
        v: l + s,
        a: a
    };
};
const $a9cf2169b9b928b8$export$8f550ac642b2adec = (hsva)=>$a9cf2169b9b928b8$export$ffee5509a14af63d($a9cf2169b9b928b8$export$e41dcd4e52af69bc(hsva));
const $a9cf2169b9b928b8$export$ea93620c892f6b62 = ({ h: h, s: s, v: v, a: a })=>{
    const hh = (200 - s) * v / 100;
    return {
        h: (0, $95bbae6a8d1f7f9a$export$2077e0241d6afd3c)(h),
        s: (0, $95bbae6a8d1f7f9a$export$2077e0241d6afd3c)(hh > 0 && hh < 200 ? s * v / 100 / (hh <= 100 ? hh : 200 - hh) * 100 : 0),
        l: (0, $95bbae6a8d1f7f9a$export$2077e0241d6afd3c)(hh / 2),
        a: (0, $95bbae6a8d1f7f9a$export$2077e0241d6afd3c)(a, 2)
    };
};
const $a9cf2169b9b928b8$export$d4f32970db1e882f = (hsva)=>{
    const { h: h, s: s, v: v } = $a9cf2169b9b928b8$export$e238eb0805b2bdfe(hsva);
    return `hsv(${h}, ${s}%, ${v}%)`;
};
const $a9cf2169b9b928b8$export$31b9c8c33b563570 = (hsva)=>{
    const { h: h, s: s, v: v, a: a } = $a9cf2169b9b928b8$export$e238eb0805b2bdfe(hsva);
    return `hsva(${h}, ${s}%, ${v}%, ${a})`;
};
const $a9cf2169b9b928b8$export$5088895f11133875 = (hsva)=>{
    const { h: h, s: s, l: l } = $a9cf2169b9b928b8$export$ea93620c892f6b62(hsva);
    return `hsl(${h}, ${s}%, ${l}%)`;
};
const $a9cf2169b9b928b8$export$9d8fe27c1d6d5ed0 = (hsva)=>{
    const { h: h, s: s, l: l, a: a } = $a9cf2169b9b928b8$export$ea93620c892f6b62(hsva);
    return `hsla(${h}, ${s}%, ${l}%, ${a})`;
};
const $a9cf2169b9b928b8$export$e41dcd4e52af69bc = ({ h: h, s: s, v: v, a: a })=>{
    h = h / 360 * 6;
    s = s / 100;
    v = v / 100;
    const hh = Math.floor(h), b = v * (1 - s), c = v * (1 - (h - hh) * s), d = v * (1 - (1 - h + hh) * s), module = hh % 6;
    return {
        r: (0, $95bbae6a8d1f7f9a$export$2077e0241d6afd3c)([
            v,
            c,
            b,
            b,
            d,
            v
        ][module] * 255),
        g: (0, $95bbae6a8d1f7f9a$export$2077e0241d6afd3c)([
            d,
            v,
            v,
            c,
            b,
            b
        ][module] * 255),
        b: (0, $95bbae6a8d1f7f9a$export$2077e0241d6afd3c)([
            b,
            b,
            d,
            v,
            v,
            c
        ][module] * 255),
        a: (0, $95bbae6a8d1f7f9a$export$2077e0241d6afd3c)(a, 2)
    };
};
const $a9cf2169b9b928b8$export$48759cfe1e576e90 = (hsva)=>{
    const { r: r, g: g, b: b } = $a9cf2169b9b928b8$export$e41dcd4e52af69bc(hsva);
    return `rgb(${r}, ${g}, ${b})`;
};
const $a9cf2169b9b928b8$export$4f8847fa6078ef9d = (hsva)=>{
    const { r: r, g: g, b: b, a: a } = $a9cf2169b9b928b8$export$e41dcd4e52af69bc(hsva);
    return `rgba(${r}, ${g}, ${b}, ${a})`;
};
const $a9cf2169b9b928b8$export$b2d5debb615cb646 = (hsvString)=>{
    const matcher = /hsva?\(?\s*(-?\d*\.?\d+)(deg|rad|grad|turn)?[,\s]+(-?\d*\.?\d+)%?[,\s]+(-?\d*\.?\d+)%?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i;
    const match = matcher.exec(hsvString);
    if (!match) return {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
    return $a9cf2169b9b928b8$export$e238eb0805b2bdfe({
        h: $a9cf2169b9b928b8$export$7c374483fd1c382f(match[1], match[2]),
        s: Number(match[3]),
        v: Number(match[4]),
        a: match[5] === undefined ? 1 : Number(match[5]) / (match[6] ? 100 : 1)
    });
};
const $a9cf2169b9b928b8$export$6b2bc07f8f228168 = $a9cf2169b9b928b8$export$b2d5debb615cb646;
const $a9cf2169b9b928b8$export$8a47db680f105266 = (rgbaString)=>{
    const matcher = /rgba?\(?\s*(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i;
    const match = matcher.exec(rgbaString);
    if (!match) return {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
    return $a9cf2169b9b928b8$export$f4deeebdec6065f9({
        r: Number(match[1]) / (match[2] ? 100 / 255 : 1),
        g: Number(match[3]) / (match[4] ? 100 / 255 : 1),
        b: Number(match[5]) / (match[6] ? 100 / 255 : 1),
        a: match[7] === undefined ? 1 : Number(match[7]) / (match[8] ? 100 : 1)
    });
};
const $a9cf2169b9b928b8$export$43c951a6cd314995 = $a9cf2169b9b928b8$export$8a47db680f105266;
const $a9cf2169b9b928b8$var$format = (number)=>{
    const hex = number.toString(16);
    return hex.length < 2 ? '0' + hex : hex;
};
const $a9cf2169b9b928b8$export$ffee5509a14af63d = ({ r: r, g: g, b: b, a: a })=>{
    const alphaHex = a < 1 ? $a9cf2169b9b928b8$var$format((0, $95bbae6a8d1f7f9a$export$2077e0241d6afd3c)(a * 255)) : '';
    return '#' + $a9cf2169b9b928b8$var$format(r) + $a9cf2169b9b928b8$var$format(g) + $a9cf2169b9b928b8$var$format(b) + alphaHex;
};
const $a9cf2169b9b928b8$export$f4deeebdec6065f9 = ({ r: r, g: g, b: b, a: a })=>{
    const max = Math.max(r, g, b);
    const delta = max - Math.min(r, g, b);
    // prettier-ignore
    const hh = delta ? max === r ? (g - b) / delta : max === g ? 2 + (b - r) / delta : 4 + (r - g) / delta : 0;
    return {
        h: (0, $95bbae6a8d1f7f9a$export$2077e0241d6afd3c)(60 * (hh < 0 ? hh + 6 : hh)),
        s: (0, $95bbae6a8d1f7f9a$export$2077e0241d6afd3c)(max ? delta / max * 100 : 0),
        v: (0, $95bbae6a8d1f7f9a$export$2077e0241d6afd3c)(max / 255 * 100),
        a: a
    };
};
const $a9cf2169b9b928b8$export$e238eb0805b2bdfe = (hsva)=>({
        h: (0, $95bbae6a8d1f7f9a$export$2077e0241d6afd3c)(hsva.h),
        s: (0, $95bbae6a8d1f7f9a$export$2077e0241d6afd3c)(hsva.s),
        v: (0, $95bbae6a8d1f7f9a$export$2077e0241d6afd3c)(hsva.v),
        a: (0, $95bbae6a8d1f7f9a$export$2077e0241d6afd3c)(hsva.a, 2)
    });
const $a9cf2169b9b928b8$export$e1a7c5bad5659d47 = ({ r: r, g: g, b: b })=>({
        r: r,
        g: g,
        b: b
    });
const $a9cf2169b9b928b8$export$933a8dde080f58ff = ({ h: h, s: s, l: l })=>({
        h: h,
        s: s,
        l: l
    });
const $a9cf2169b9b928b8$export$fc6c9f0fcd96330f = (hsva)=>{
    const { h: h, s: s, v: v } = $a9cf2169b9b928b8$export$e238eb0805b2bdfe(hsva);
    return {
        h: h,
        s: s,
        v: v
    };
};


const $948fb3f75fb142e3$export$2123f06676026de7 = (first, second)=>{
    if (first === second) return true;
    for(const prop in first){
        // The following allows for a type-safe calling of this function (first & second have to be HSL, HSV, or RGB)
        // with type-unsafe iterating over object keys. TS does not allow this without an index (`[key: string]: number`)
        // on an object to define how iteration is normally done. To ensure extra keys are not allowed on our types,
        // we must cast our object to unknown (as RGB demands `r` be a key, while `Record<string, x>` does not care if
        // there is or not), and then as a type TS can iterate over.
        if (first[prop] !== second[prop]) return false;
    }
    return true;
};
const $948fb3f75fb142e3$export$6ece4d09186dd7d4 = (first, second)=>{
    return first.replace(/\s/g, '') === second.replace(/\s/g, '');
};
const $948fb3f75fb142e3$export$30c81f1d8f88a836 = (first, second)=>{
    if (first.toLowerCase() === second.toLowerCase()) return true;
    // To compare colors like `#FFF` and `ffffff` we convert them into RGB objects
    return $948fb3f75fb142e3$export$2123f06676026de7((0, $a9cf2169b9b928b8$export$9665a07d9187b414)(first), (0, $a9cf2169b9b928b8$export$9665a07d9187b414)(second));
};


const $7eec6d90285327fd$var$cache = {};
const $7eec6d90285327fd$export$5dfe2efd653fcea4 = (html)=>{
    let template = $7eec6d90285327fd$var$cache[html];
    if (!template) {
        template = document.createElement('template');
        template.innerHTML = html;
        $7eec6d90285327fd$var$cache[html] = template;
    }
    return template;
};
const $7eec6d90285327fd$export$46ff36df9b99bc25 = (target, type, detail)=>{
    target.dispatchEvent(new CustomEvent(type, {
        bubbles: true,
        detail: detail
    }));
};




let $fdf92c567e092278$var$hasTouched = false;
// Check if an event was triggered by touch
const $fdf92c567e092278$var$isTouch = (e)=>'touches' in e;
// Prevent mobile browsers from handling mouse events (conflicting with touch ones).
// If we detected a touch interaction before, we prefer reacting to touch events only.
const $fdf92c567e092278$var$isValid = (event)=>{
    if ($fdf92c567e092278$var$hasTouched && !$fdf92c567e092278$var$isTouch(event)) return false;
    if (!$fdf92c567e092278$var$hasTouched) $fdf92c567e092278$var$hasTouched = $fdf92c567e092278$var$isTouch(event);
    return true;
};
const $fdf92c567e092278$var$pointerMove = (target, event)=>{
    const pointer = $fdf92c567e092278$var$isTouch(event) ? event.touches[0] : event;
    const rect = target.el.getBoundingClientRect();
    (0, $7eec6d90285327fd$export$46ff36df9b99bc25)(target.el, 'move', target.getMove({
        x: (0, $95bbae6a8d1f7f9a$export$7d15b64cf5a3a4c4)((pointer.pageX - (rect.left + window.pageXOffset)) / rect.width),
        y: (0, $95bbae6a8d1f7f9a$export$7d15b64cf5a3a4c4)((pointer.pageY - (rect.top + window.pageYOffset)) / rect.height)
    }));
};
const $fdf92c567e092278$var$keyMove = (target, event)=>{
    // We use `keyCode` instead of `key` to reduce the size of the library.
    const keyCode = event.keyCode;
    // Ignore all keys except arrow ones, Page Up, Page Down, Home and End.
    if (keyCode > 40 || target.xy && keyCode < 37 || keyCode < 33) return;
    // Do not scroll page by keys when color picker element has focus.
    event.preventDefault();
    // Send relative offset to the parent component.
    (0, $7eec6d90285327fd$export$46ff36df9b99bc25)(target.el, 'move', target.getMove({
        x: keyCode === 39 // Arrow Right
         ? 0.01 : keyCode === 37 // Arrow Left
         ? -0.01 : keyCode === 34 // Page Down
         ? 0.05 : keyCode === 33 // Page Up
         ? -0.05 : keyCode === 35 // End
         ? 1 : keyCode === 36 // Home
         ? -1 : 0,
        y: keyCode === 40 // Arrow down
         ? 0.01 : keyCode === 38 // Arrow Up
         ? -0.01 : 0
    }, true));
};
class $fdf92c567e092278$export$472062a354075cee {
    constructor(root, part, aria, xy){
        const template = (0, $7eec6d90285327fd$export$5dfe2efd653fcea4)(`<div role="slider" tabindex="0" part="${part}" ${aria}><div part="${part}-pointer"></div></div>`);
        root.appendChild(template.content.cloneNode(true));
        const el = root.querySelector(`[part=${part}]`);
        el.addEventListener('mousedown', this);
        el.addEventListener('touchstart', this);
        el.addEventListener('keydown', this);
        this.el = el;
        this.xy = xy;
        this.nodes = [
            el.firstChild,
            el
        ];
    }
    set dragging(state) {
        const toggleEvent = state ? document.addEventListener : document.removeEventListener;
        toggleEvent($fdf92c567e092278$var$hasTouched ? 'touchmove' : 'mousemove', this);
        toggleEvent($fdf92c567e092278$var$hasTouched ? 'touchend' : 'mouseup', this);
    }
    handleEvent(event) {
        switch(event.type){
            case 'mousedown':
            case 'touchstart':
                event.preventDefault();
                // event.button is 0 in mousedown for left button activation
                if (!$fdf92c567e092278$var$isValid(event) || !$fdf92c567e092278$var$hasTouched && event.button != 0) return;
                this.el.focus();
                $fdf92c567e092278$var$pointerMove(this, event);
                this.dragging = true;
                break;
            case 'mousemove':
            case 'touchmove':
                event.preventDefault();
                $fdf92c567e092278$var$pointerMove(this, event);
                break;
            case 'mouseup':
            case 'touchend':
                this.dragging = false;
                break;
            case 'keydown':
                $fdf92c567e092278$var$keyMove(this, event);
                break;
        }
    }
    style(styles) {
        styles.forEach((style, i)=>{
            for(const p in style)this.nodes[i].style.setProperty(p, style[p]);
        });
    }
}




class $4800700a581c0d2d$export$3e22a96a58989a47 extends (0, $fdf92c567e092278$export$472062a354075cee) {
    constructor(root){
        super(root, 'hue', 'aria-label="Hue" aria-valuemin="0" aria-valuemax="360"', false);
    }
    update({ h: h }) {
        this.h = h;
        this.style([
            {
                left: `${h / 360 * 100}%`,
                color: (0, $a9cf2169b9b928b8$export$5088895f11133875)({
                    h: h,
                    s: 100,
                    v: 100,
                    a: 1
                })
            }
        ]);
        this.el.setAttribute('aria-valuenow', `${(0, $95bbae6a8d1f7f9a$export$2077e0241d6afd3c)(h)}`);
    }
    getMove(offset, key) {
        // Hue measured in degrees of the color circle ranging from 0 to 360
        return {
            h: key ? (0, $95bbae6a8d1f7f9a$export$7d15b64cf5a3a4c4)(this.h + offset.x * 360, 0, 360) : 360 * offset.x
        };
    }
}





class $3f3da12fb6587a6d$export$c4dbe12ffaee3c8e extends (0, $fdf92c567e092278$export$472062a354075cee) {
    constructor(root){
        super(root, 'saturation', 'aria-label="Color"', true);
    }
    update(hsva) {
        this.hsva = hsva;
        this.style([
            {
                top: `${100 - hsva.v}%`,
                left: `${hsva.s}%`,
                color: (0, $a9cf2169b9b928b8$export$5088895f11133875)(hsva)
            },
            {
                'background-color': (0, $a9cf2169b9b928b8$export$5088895f11133875)({
                    h: hsva.h,
                    s: 100,
                    v: 100,
                    a: 1
                })
            }
        ]);
        this.el.setAttribute('aria-valuetext', `Saturation ${(0, $95bbae6a8d1f7f9a$export$2077e0241d6afd3c)(hsva.s)}%, Brightness ${(0, $95bbae6a8d1f7f9a$export$2077e0241d6afd3c)(hsva.v)}%`);
    }
    getMove(offset, key) {
        // Saturation and brightness always fit into [0, 100] range
        return {
            s: key ? (0, $95bbae6a8d1f7f9a$export$7d15b64cf5a3a4c4)(this.hsva.s + offset.x * 100, 0, 100) : offset.x * 100,
            v: key ? (0, $95bbae6a8d1f7f9a$export$7d15b64cf5a3a4c4)(this.hsva.v - offset.y * 100, 0, 100) : Math.round(100 - offset.y * 100)
        };
    }
}


var $58ff6eff66b23cb5$export$2e2bcd8739ae039 = `:host{display:flex;flex-direction:column;position:relative;width:200px;height:200px;user-select:none;-webkit-user-select:none;cursor:default}:host([hidden]){display:none!important}[role=slider]{position:relative;touch-action:none;user-select:none;-webkit-user-select:none;outline:0}[role=slider]:last-child{border-radius:0 0 8px 8px}[part$=pointer]{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;display:flex;place-content:center center;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}[part$=pointer]::after{content:"";width:100%;height:100%;border-radius:inherit;background-color:currentColor}[role=slider]:focus [part$=pointer]{transform:translate(-50%,-50%) scale(1.1)}`;


var $4171751d7279420f$export$2e2bcd8739ae039 = `[part=hue]{flex:0 0 24px;background:linear-gradient(to right,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red 100%)}[part=hue-pointer]{top:50%;z-index:2}`;


var $11db78e32ac9c5ee$export$2e2bcd8739ae039 = `[part=saturation]{flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(to top,#000,transparent),linear-gradient(to right,#fff,rgba(255,255,255,0));box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}[part=saturation-pointer]{z-index:3}`;


const $bec3438b92ba4b21$var$$isSame = Symbol('same');
const $bec3438b92ba4b21$var$$color = Symbol('color');
const $bec3438b92ba4b21$var$$hsva = Symbol('hsva');
const $bec3438b92ba4b21$var$$update = Symbol('update');
const $bec3438b92ba4b21$var$$parts = Symbol('parts');
const $bec3438b92ba4b21$export$639d3bf3586a8ae1 = Symbol('css');
const $bec3438b92ba4b21$export$6892090d606d23aa = Symbol('sliders');
class $bec3438b92ba4b21$export$9feb1bc2e5f1ccb3 extends HTMLElement {
    static get observedAttributes() {
        return [
            'color'
        ];
    }
    get [$bec3438b92ba4b21$export$639d3bf3586a8ae1]() {
        return [
            (0, $58ff6eff66b23cb5$export$2e2bcd8739ae039),
            (0, $4171751d7279420f$export$2e2bcd8739ae039),
            (0, $11db78e32ac9c5ee$export$2e2bcd8739ae039)
        ];
    }
    get [$bec3438b92ba4b21$export$6892090d606d23aa]() {
        return [
            (0, $3f3da12fb6587a6d$export$c4dbe12ffaee3c8e),
            (0, $4800700a581c0d2d$export$3e22a96a58989a47)
        ];
    }
    get color() {
        return this[$bec3438b92ba4b21$var$$color];
    }
    set color(newColor) {
        if (!this[$bec3438b92ba4b21$var$$isSame](newColor)) {
            const newHsva = this.colorModel.toHsva(newColor);
            this[$bec3438b92ba4b21$var$$update](newHsva);
            this[$bec3438b92ba4b21$var$$color] = newColor;
        }
    }
    constructor(){
        super();
        const template = (0, $7eec6d90285327fd$export$5dfe2efd653fcea4)(`<style>${this[$bec3438b92ba4b21$export$639d3bf3586a8ae1].join('')}</style>`);
        const root = this.attachShadow({
            mode: 'open'
        });
        root.appendChild(template.content.cloneNode(true));
        root.addEventListener('move', this);
        this[$bec3438b92ba4b21$var$$parts] = this[$bec3438b92ba4b21$export$6892090d606d23aa].map((slider)=>new slider(root));
    }
    connectedCallback() {
        // A user may set a property on an _instance_ of an element,
        // before its prototype has been connected to this class.
        // If so, we need to run it through the proper class setter.
        if (this.hasOwnProperty('color')) {
            const value = this.color;
            delete this['color'];
            this.color = value;
        } else if (!this.color) this.color = this.colorModel.defaultColor;
    }
    attributeChangedCallback(_attr, _oldVal, newVal) {
        const color = this.colorModel.fromAttr(newVal);
        if (!this[$bec3438b92ba4b21$var$$isSame](color)) this.color = color;
    }
    handleEvent(event) {
        // Merge the current HSV color object with updated params.
        const oldHsva = this[$bec3438b92ba4b21$var$$hsva];
        const newHsva = {
            ...oldHsva,
            ...event.detail
        };
        this[$bec3438b92ba4b21$var$$update](newHsva);
        let newColor;
        if (!(0, $948fb3f75fb142e3$export$2123f06676026de7)(newHsva, oldHsva) && !this[$bec3438b92ba4b21$var$$isSame](newColor = this.colorModel.fromHsva(newHsva))) {
            this[$bec3438b92ba4b21$var$$color] = newColor;
            (0, $7eec6d90285327fd$export$46ff36df9b99bc25)(this, 'color-changed', {
                value: newColor
            });
        }
    }
    [$bec3438b92ba4b21$var$$isSame](color) {
        return this.color && this.colorModel.equal(color, this.color);
    }
    [$bec3438b92ba4b21$var$$update](hsva) {
        this[$bec3438b92ba4b21$var$$hsva] = hsva;
        this[$bec3438b92ba4b21$var$$parts].forEach((part)=>part.update(hsva));
    }
}




const $e4f03e8b1ae87d06$var$colorModel = {
    defaultColor: '#000',
    toHsva: (0, $a9cf2169b9b928b8$export$b46408e00e83b492),
    fromHsva: ({ h: h, s: s, v: v })=>(0, $a9cf2169b9b928b8$export$8f550ac642b2adec)({
            h: h,
            s: s,
            v: v,
            a: 1
        }),
    equal: (0, $948fb3f75fb142e3$export$30c81f1d8f88a836),
    fromAttr: (color)=>color
};
class $e4f03e8b1ae87d06$export$aac89129a4eb37b4 extends (0, $bec3438b92ba4b21$export$9feb1bc2e5f1ccb3) {
    get colorModel() {
        return $e4f03e8b1ae87d06$var$colorModel;
    }
}


class $140a8674e56d257f$export$a3bc3c32746e9f3a extends (0, $e4f03e8b1ae87d06$export$aac89129a4eb37b4) {
}
customElements.define('hex-color-picker', $140a8674e56d257f$export$a3bc3c32746e9f3a);





const $b8c94251d8681097$var$colorModel = {
    defaultColor: 'hsl(0, 0%, 0%)',
    toHsva: (0, $a9cf2169b9b928b8$export$da6b3453e45f3684),
    fromHsva: (0, $a9cf2169b9b928b8$export$5088895f11133875),
    equal: (0, $948fb3f75fb142e3$export$6ece4d09186dd7d4),
    fromAttr: (color)=>color
};
class $b8c94251d8681097$export$898be2d0ea41bd67 extends (0, $bec3438b92ba4b21$export$9feb1bc2e5f1ccb3) {
    get colorModel() {
        return $b8c94251d8681097$var$colorModel;
    }
}


class $9e812daadb7a45d4$export$f4f988c96ece960 extends (0, $b8c94251d8681097$export$898be2d0ea41bd67) {
}
customElements.define('hsl-string-color-picker', $9e812daadb7a45d4$export$f4f988c96ece960);






class $03057d9b089f593d$export$b3d0ceb706f8af43 extends (0, $fdf92c567e092278$export$472062a354075cee) {
    constructor(root){
        super(root, 'alpha', 'aria-label="Alpha" aria-valuemin="0" aria-valuemax="1"', false);
    }
    update(hsva) {
        this.hsva = hsva;
        const colorFrom = (0, $a9cf2169b9b928b8$export$9d8fe27c1d6d5ed0)({
            ...hsva,
            a: 0
        });
        const colorTo = (0, $a9cf2169b9b928b8$export$9d8fe27c1d6d5ed0)({
            ...hsva,
            a: 1
        });
        const value = hsva.a * 100;
        this.style([
            {
                left: `${value}%`,
                color: (0, $a9cf2169b9b928b8$export$9d8fe27c1d6d5ed0)(hsva)
            },
            {
                '--gradient': `linear-gradient(90deg, ${colorFrom}, ${colorTo}`
            }
        ]);
        const v = (0, $95bbae6a8d1f7f9a$export$2077e0241d6afd3c)(value);
        this.el.setAttribute('aria-valuenow', `${v}`);
        this.el.setAttribute('aria-valuetext', `${v}%`);
    }
    getMove(offset, key) {
        // Alpha always fit into [0, 1] range
        return {
            a: key ? (0, $95bbae6a8d1f7f9a$export$7d15b64cf5a3a4c4)(this.hsva.a + offset.x) : offset.x
        };
    }
}


var $30b3c62d4d502623$export$2e2bcd8739ae039 = `[part=alpha]{flex:0 0 24px}[part=alpha]::after{display:block;content:"";position:absolute;top:0;left:0;right:0;bottom:0;border-radius:inherit;background-image:var(--gradient);box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}[part^=alpha]{background-color:#fff;background-image:url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><rect x="8" width="8" height="8"/><rect y="8" width="8" height="8"/></svg>')}[part=alpha-pointer]{top:50%}`;


class $03e2a96f14b3d78a$export$140fbb69603eb3d extends (0, $bec3438b92ba4b21$export$9feb1bc2e5f1ccb3) {
    get [(0, $bec3438b92ba4b21$export$639d3bf3586a8ae1)]() {
        return [
            ...super[0, $bec3438b92ba4b21$export$639d3bf3586a8ae1],
            (0, $30b3c62d4d502623$export$2e2bcd8739ae039)
        ];
    }
    get [(0, $bec3438b92ba4b21$export$6892090d606d23aa)]() {
        return [
            ...super[0, $bec3438b92ba4b21$export$6892090d606d23aa],
            (0, $03057d9b089f593d$export$b3d0ceb706f8af43)
        ];
    }
}




const $e5249315b40ba182$var$colorModel = {
    defaultColor: 'rgba(0, 0, 0, 1)',
    toHsva: (0, $a9cf2169b9b928b8$export$8a47db680f105266),
    fromHsva: (0, $a9cf2169b9b928b8$export$4f8847fa6078ef9d),
    equal: (0, $948fb3f75fb142e3$export$6ece4d09186dd7d4),
    fromAttr: (color)=>color
};
class $e5249315b40ba182$export$6d272aebd7e85caa extends (0, $03e2a96f14b3d78a$export$140fbb69603eb3d) {
    get colorModel() {
        return $e5249315b40ba182$var$colorModel;
    }
}


class $95e4cd4f25a116d2$export$be07dcc7abc11a36 extends (0, $e5249315b40ba182$export$6d272aebd7e85caa) {
}
customElements.define('rgba-string-color-picker', $95e4cd4f25a116d2$export$be07dcc7abc11a36);


const $994058d01def34af$export$fd9a8359a728871b = ()=>{
    const HEX_EL = document.querySelector("hex-color-picker");
    const HEX_INPUT_EL = document.getElementById("hex-input");
    const HSL_EL = document.querySelector("hsl-string-color-picker");
    const HSL_INPUT_EL = document.getElementById("hsl-input");
    const RGBA_EL = document.querySelector("rgba-string-color-picker");
    const RGBA_INPUT_EL = document.getElementById("rgba-input");
    if (HEX_EL) HEX_EL.addEventListener("color-changed", (event)=>{
        const newColor = event.detail.value;
        HEX_INPUT_EL.value = newColor;
    });
    if (HSL_EL) HSL_EL.addEventListener("color-changed", (event)=>{
        const newColor = event.detail.value;
        HSL_INPUT_EL.value = newColor;
    });
    if (RGBA_EL) RGBA_EL.addEventListener("color-changed", (event)=>{
        const newColor = event.detail.value;
        RGBA_INPUT_EL.value = newColor;
    });
};


const $93f414669e9c583a$export$4e1d9a3b5c360fd3 = (table, rowCount, checkbox = false)=>{
    const headers = [
        ...checkbox ? [
            "Select"
        ] : [],
        "Name",
        "Country",
        "Ext",
        "Start Date",
        "Completions (%)"
    ];
    const countries = [
        "USA",
        "India",
        "UK",
        "Canada",
        "Australia",
        "Germany",
        "France",
        "Italy",
        "Spain",
        "Japan",
        "China",
        "Brazil",
        "Russia",
        "South Africa",
        "Mexico",
        "Netherlands",
        "Sweden",
        "Norway",
        "Denmark",
        "Argentina",
        "South Korea",
        "Turkey",
        "Switzerland",
        "New Zealand",
        "Saudi Arabia"
    ];
    // Generate data
    const data = Array.from({
        length: rowCount
    }, ()=>({
            Select: "",
            Name: `User ${Math.floor(Math.random() * 1000)}`,
            Country: countries[Math.floor(Math.random() * countries.length)],
            Ext: `${Math.floor(10000 + Math.random() * 90000)}`,
            "Start Date": `${String(Math.floor(1 + Math.random() * 28)).padStart(2, "0")}/${String(Math.floor(1 + Math.random() * 12)).padStart(2, "0")}/202${Math.floor(0 + Math.random() * 4)}`,
            "Completions (%)": `${Math.floor(50 + Math.random() * 50)}%`
        }));
    // Create thead
    const thead = document.createElement("thead");
    const headerRow = document.createElement("tr");
    headers.forEach((header)=>{
        const th = document.createElement("th");
        th.textContent = header;
        headerRow.appendChild(th);
    });
    thead.appendChild(headerRow);
    table.appendChild(thead);
    // Create tbody
    const tbody = document.createElement("tbody");
    data.forEach((row)=>{
        const tr = document.createElement("tr");
        headers.forEach((header)=>{
            const td = document.createElement("td");
            td.textContent = row[header];
            tr.appendChild(td);
        });
        tbody.appendChild(tr);
    });
    table.appendChild(tbody);
};


const $a7031b6d2b9a785f$export$a6cdc56e425d0d0a = (t)=>"[object Object]" === Object.prototype.toString.call(t), $a7031b6d2b9a785f$export$952e1d8683e4d0c4 = (e)=>{
    let s = !1;
    try {
        s = JSON.parse(e);
    } catch (t) {
        return !1;
    }
    return !(null === s || !Array.isArray(s) && !$a7031b6d2b9a785f$export$a6cdc56e425d0d0a(s)) && s;
}, $a7031b6d2b9a785f$export$c8a8987d4410bf2d = (t, e)=>{
    const s = document.createElement(t);
    if (e && "object" == typeof e) for(const t in e)"html" === t ? s.innerHTML = e[t] : s.setAttribute(t, e[t]);
    return s;
}, $a7031b6d2b9a785f$var$i = (t)=>[
        "#text",
        "#comment"
    ].includes(t.nodeName) ? t.data : t.childNodes ? t.childNodes.map((t)=>$a7031b6d2b9a785f$var$i(t)).join("") : "", $a7031b6d2b9a785f$var$n = (t)=>{
    if (null == t) return "";
    if (t.hasOwnProperty("text") || t.hasOwnProperty("data")) {
        const e = t;
        return e.text ?? $a7031b6d2b9a785f$var$n(e.data);
    }
    return t.hasOwnProperty("nodeName") ? $a7031b6d2b9a785f$var$i(t) : String(t);
}, $a7031b6d2b9a785f$var$a = function(t) {
    return t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}, $a7031b6d2b9a785f$var$o = function(t, e) {
    let s = 0, i = 0;
    for(; s < t + 1;)e[i].hidden || (s += 1), i += 1;
    return i - 1;
}, $a7031b6d2b9a785f$var$r = function(t) {
    const e = {};
    if (t) for (const s of t)e[s.name] = s.value;
    return e;
}, $a7031b6d2b9a785f$var$l = (t)=>t ? t.trim().split(" ").map((t)=>`.${t}`).join("") : null, $a7031b6d2b9a785f$var$d = (t, e)=>{
    const s = e?.split(" ").some((e)=>!t.classList.contains(e));
    return !s;
}, $a7031b6d2b9a785f$var$c = (t, e)=>t ? e ? `${t} ${e}` : t : e || "", $a7031b6d2b9a785f$var$h = function(t, e = 300) {
    let s;
    return (...i)=>{
        clearTimeout(s), s = window.setTimeout(()=>t(), e);
    };
};
var $a7031b6d2b9a785f$var$u = function() {
    return $a7031b6d2b9a785f$var$u = Object.assign || function(t) {
        for(var e, s = arguments, i = 1, n = arguments.length; i < n; i++)for(var a in e = s[i])Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
        return t;
    }, $a7031b6d2b9a785f$var$u.apply(this, arguments);
};
function $a7031b6d2b9a785f$var$p(t, e, s) {
    if (s || 2 === arguments.length) for(var i, n = 0, a = e.length; n < a; n++)!i && n in e || (i || (i = Array.prototype.slice.call(e, 0, n)), i[n] = e[n]);
    return t.concat(i || Array.prototype.slice.call(e));
}
"function" == typeof SuppressedError && SuppressedError;
var $a7031b6d2b9a785f$var$f = function() {
    function t(t) {
        void 0 === t && (t = {});
        var e = this;
        Object.entries(t).forEach(function(t) {
            var s = t[0], i = t[1];
            return e[s] = i;
        });
    }
    return t.prototype.toString = function() {
        return JSON.stringify(this);
    }, t.prototype.setValue = function(t, e) {
        return this[t] = e, this;
    }, t;
}();
function $a7031b6d2b9a785f$var$m(t) {
    for(var e = arguments, s = [], i = 1; i < arguments.length; i++)s[i - 1] = e[i];
    return null != t && s.some(function(e) {
        var s, i;
        return "function" == typeof (null === (i = null === (s = null == t ? void 0 : t.ownerDocument) || void 0 === s ? void 0 : s.defaultView) || void 0 === i ? void 0 : i[e]) && t instanceof t.ownerDocument.defaultView[e];
    });
}
function $a7031b6d2b9a785f$var$g(t, e, s) {
    var i;
    return "#text" === t.nodeName ? i = s.document.createTextNode(t.data) : "#comment" === t.nodeName ? i = s.document.createComment(t.data) : (e ? (i = s.document.createElementNS("http://www.w3.org/2000/svg", t.nodeName), "foreignObject" === t.nodeName && (e = !1)) : "svg" === t.nodeName.toLowerCase() ? (i = s.document.createElementNS("http://www.w3.org/2000/svg", "svg"), e = !0) : i = s.document.createElement(t.nodeName), t.attributes && Object.entries(t.attributes).forEach(function(t) {
        var e = t[0], s = t[1];
        return i.setAttribute(e, s);
    }), t.childNodes && t.childNodes.forEach(function(t) {
        return i.appendChild($a7031b6d2b9a785f$var$g(t, e, s));
    }), s.valueDiffing && (t.value && $a7031b6d2b9a785f$var$m(i, "HTMLButtonElement", "HTMLDataElement", "HTMLInputElement", "HTMLLIElement", "HTMLMeterElement", "HTMLOptionElement", "HTMLProgressElement", "HTMLParamElement") && (i.value = t.value), t.checked && $a7031b6d2b9a785f$var$m(i, "HTMLInputElement") && (i.checked = t.checked), t.selected && $a7031b6d2b9a785f$var$m(i, "HTMLOptionElement") && (i.selected = t.selected))), i;
}
var $a7031b6d2b9a785f$var$b = function(t, e) {
    for(e = e.slice(); e.length > 0;){
        var s = e.splice(0, 1)[0];
        t = t.childNodes[s];
    }
    return t;
};
function $a7031b6d2b9a785f$var$v(t, e, s) {
    var i, n, a, o = e[s._const.action], r = e[s._const.route];
    [
        s._const.addElement,
        s._const.addTextElement
    ].includes(o) || (i = $a7031b6d2b9a785f$var$b(t, r));
    var l = {
        diff: e,
        node: i
    };
    if (s.preDiffApply(l)) return !0;
    switch(o){
        case s._const.addAttribute:
            if (!i || !$a7031b6d2b9a785f$var$m(i, "Element")) return !1;
            i.setAttribute(e[s._const.name], e[s._const.value]);
            break;
        case s._const.modifyAttribute:
            if (!i || !$a7031b6d2b9a785f$var$m(i, "Element")) return !1;
            i.setAttribute(e[s._const.name], e[s._const.newValue]), $a7031b6d2b9a785f$var$m(i, "HTMLInputElement") && "value" === e[s._const.name] && (i.value = e[s._const.newValue]);
            break;
        case s._const.removeAttribute:
            if (!i || !$a7031b6d2b9a785f$var$m(i, "Element")) return !1;
            i.removeAttribute(e[s._const.name]);
            break;
        case s._const.modifyTextElement:
            if (!i || !$a7031b6d2b9a785f$var$m(i, "Text")) return !1;
            s.textDiff(i, i.data, e[s._const.oldValue], e[s._const.newValue]), $a7031b6d2b9a785f$var$m(i.parentNode, "HTMLTextAreaElement") && (i.parentNode.value = e[s._const.newValue]);
            break;
        case s._const.modifyValue:
            if (!i || void 0 === i.value) return !1;
            i.value = e[s._const.newValue];
            break;
        case s._const.modifyComment:
            if (!i || !$a7031b6d2b9a785f$var$m(i, "Comment")) return !1;
            s.textDiff(i, i.data, e[s._const.oldValue], e[s._const.newValue]);
            break;
        case s._const.modifyChecked:
            if (!i || void 0 === i.checked) return !1;
            i.checked = e[s._const.newValue];
            break;
        case s._const.modifySelected:
            if (!i || void 0 === i.selected) return !1;
            i.selected = e[s._const.newValue];
            break;
        case s._const.replaceElement:
            var d = "svg" === e[s._const.newValue].nodeName.toLowerCase() || "http://www.w3.org/2000/svg" === i.parentNode.namespaceURI;
            i.parentNode.replaceChild($a7031b6d2b9a785f$var$g(e[s._const.newValue], d, s), i);
            break;
        case s._const.relocateGroup:
            $a7031b6d2b9a785f$var$p([], new Array(e[s._const.groupLength]), !0).map(function() {
                return i.removeChild(i.childNodes[e[s._const.from]]);
            }).forEach(function(t, n) {
                0 === n && (a = i.childNodes[e[s._const.to]]), i.insertBefore(t, a || null);
            });
            break;
        case s._const.removeElement:
            i.parentNode.removeChild(i);
            break;
        case s._const.addElement:
            var c = (u = r.slice()).splice(u.length - 1, 1)[0];
            if (!$a7031b6d2b9a785f$var$m(i = $a7031b6d2b9a785f$var$b(t, u), "Element")) return !1;
            i.insertBefore($a7031b6d2b9a785f$var$g(e[s._const.element], "http://www.w3.org/2000/svg" === i.namespaceURI, s), i.childNodes[c] || null);
            break;
        case s._const.removeTextElement:
            if (!i || 3 !== i.nodeType) return !1;
            var h = i.parentNode;
            h.removeChild(i), $a7031b6d2b9a785f$var$m(h, "HTMLTextAreaElement") && (h.value = "");
            break;
        case s._const.addTextElement:
            var u;
            c = (u = r.slice()).splice(u.length - 1, 1)[0];
            if (n = s.document.createTextNode(e[s._const.value]), !(i = $a7031b6d2b9a785f$var$b(t, u)).childNodes) return !1;
            i.insertBefore(n, i.childNodes[c] || null), $a7031b6d2b9a785f$var$m(i.parentNode, "HTMLTextAreaElement") && (i.parentNode.value = e[s._const.value]);
            break;
        default:
            console.log("unknown action");
    }
    return s.postDiffApply({
        diff: l.diff,
        node: l.node,
        newNode: n
    }), !0;
}
function $a7031b6d2b9a785f$var$_(t, e, s) {
    var i = t[e];
    t[e] = t[s], t[s] = i;
}
function $a7031b6d2b9a785f$var$w(t, e, s) {
    (e = e.slice()).reverse(), e.forEach(function(e) {
        !function(t, e, s) {
            switch(e[s._const.action]){
                case s._const.addAttribute:
                    e[s._const.action] = s._const.removeAttribute, $a7031b6d2b9a785f$var$v(t, e, s);
                    break;
                case s._const.modifyAttribute:
                    $a7031b6d2b9a785f$var$_(e, s._const.oldValue, s._const.newValue), $a7031b6d2b9a785f$var$v(t, e, s);
                    break;
                case s._const.removeAttribute:
                    e[s._const.action] = s._const.addAttribute, $a7031b6d2b9a785f$var$v(t, e, s);
                    break;
                case s._const.modifyTextElement:
                case s._const.modifyValue:
                case s._const.modifyComment:
                case s._const.modifyChecked:
                case s._const.modifySelected:
                case s._const.replaceElement:
                    $a7031b6d2b9a785f$var$_(e, s._const.oldValue, s._const.newValue), $a7031b6d2b9a785f$var$v(t, e, s);
                    break;
                case s._const.relocateGroup:
                    $a7031b6d2b9a785f$var$_(e, s._const.from, s._const.to), $a7031b6d2b9a785f$var$v(t, e, s);
                    break;
                case s._const.removeElement:
                    e[s._const.action] = s._const.addElement, $a7031b6d2b9a785f$var$v(t, e, s);
                    break;
                case s._const.addElement:
                    e[s._const.action] = s._const.removeElement, $a7031b6d2b9a785f$var$v(t, e, s);
                    break;
                case s._const.removeTextElement:
                    e[s._const.action] = s._const.addTextElement, $a7031b6d2b9a785f$var$v(t, e, s);
                    break;
                case s._const.addTextElement:
                    e[s._const.action] = s._const.removeTextElement, $a7031b6d2b9a785f$var$v(t, e, s);
                    break;
                default:
                    console.log("unknown action");
            }
        }(t, e, s);
    });
}
var $a7031b6d2b9a785f$var$y = function(t) {
    var e = [];
    return e.push(t.nodeName), "#text" !== t.nodeName && "#comment" !== t.nodeName && t.attributes && (t.attributes.class && e.push("".concat(t.nodeName, ".").concat(t.attributes.class.replace(/ /g, "."))), t.attributes.id && e.push("".concat(t.nodeName, "#").concat(t.attributes.id))), e;
}, $a7031b6d2b9a785f$var$M = function(t) {
    var e = {}, s = {};
    return t.forEach(function(t) {
        $a7031b6d2b9a785f$var$y(t).forEach(function(t) {
            var i = t in e;
            i || t in s ? i && (delete e[t], s[t] = !0) : e[t] = !0;
        });
    }), e;
}, $a7031b6d2b9a785f$var$D = function(t, e) {
    var s = $a7031b6d2b9a785f$var$M(t), i = $a7031b6d2b9a785f$var$M(e), n = {};
    return Object.keys(s).forEach(function(t) {
        i[t] && (n[t] = !0);
    }), n;
}, $a7031b6d2b9a785f$var$N = function(t) {
    return delete t.outerDone, delete t.innerDone, delete t.valueDone, !t.childNodes || t.childNodes.every($a7031b6d2b9a785f$var$N);
}, $a7031b6d2b9a785f$var$O = function(t) {
    if (Object.prototype.hasOwnProperty.call(t, "data")) return {
        nodeName: "#text" === t.nodeName ? "#text" : "#comment",
        data: t.data
    };
    var e = {
        nodeName: t.nodeName
    };
    return Object.prototype.hasOwnProperty.call(t, "attributes") && (e.attributes = $a7031b6d2b9a785f$var$u({}, t.attributes)), Object.prototype.hasOwnProperty.call(t, "checked") && (e.checked = t.checked), Object.prototype.hasOwnProperty.call(t, "value") && (e.value = t.value), Object.prototype.hasOwnProperty.call(t, "selected") && (e.selected = t.selected), Object.prototype.hasOwnProperty.call(t, "childNodes") && (e.childNodes = t.childNodes.map(function(t) {
        return $a7031b6d2b9a785f$var$O(t);
    })), e;
}, $a7031b6d2b9a785f$var$x = function(t, e) {
    if (![
        "nodeName",
        "value",
        "checked",
        "selected",
        "data"
    ].every(function(s) {
        return t[s] === e[s];
    })) return !1;
    if (Object.prototype.hasOwnProperty.call(t, "data")) return !0;
    if (Boolean(t.attributes) !== Boolean(e.attributes)) return !1;
    if (Boolean(t.childNodes) !== Boolean(e.childNodes)) return !1;
    if (t.attributes) {
        var s = Object.keys(t.attributes), i = Object.keys(e.attributes);
        if (s.length !== i.length) return !1;
        if (!s.every(function(s) {
            return t.attributes[s] === e.attributes[s];
        })) return !1;
    }
    if (t.childNodes) {
        if (t.childNodes.length !== e.childNodes.length) return !1;
        if (!t.childNodes.every(function(t, s) {
            return $a7031b6d2b9a785f$var$x(t, e.childNodes[s]);
        })) return !1;
    }
    return !0;
}, $a7031b6d2b9a785f$var$E = function(t, e, s, i, n) {
    if (void 0 === n && (n = !1), !t || !e) return !1;
    if (t.nodeName !== e.nodeName) return !1;
    if ([
        "#text",
        "#comment"
    ].includes(t.nodeName)) return !!n || t.data === e.data;
    if (t.nodeName in s) return !0;
    if (t.attributes && e.attributes) {
        if (t.attributes.id) {
            if (t.attributes.id !== e.attributes.id) return !1;
            if ("".concat(t.nodeName, "#").concat(t.attributes.id) in s) return !0;
        }
        if (t.attributes.class && t.attributes.class === e.attributes.class) {
            if ("".concat(t.nodeName, ".").concat(t.attributes.class.replace(/ /g, ".")) in s) return !0;
        }
    }
    if (i) return !0;
    var a = t.childNodes ? t.childNodes.slice().reverse() : [], o = e.childNodes ? e.childNodes.slice().reverse() : [];
    if (a.length !== o.length) return !1;
    if (n) return a.every(function(t, e) {
        return t.nodeName === o[e].nodeName;
    });
    var r = $a7031b6d2b9a785f$var$D(a, o);
    return a.every(function(t, e) {
        return $a7031b6d2b9a785f$var$E(t, o[e], r, !0, !0);
    });
}, $a7031b6d2b9a785f$var$V = function(t, e) {
    return $a7031b6d2b9a785f$var$p([], new Array(t), !0).map(function() {
        return e;
    });
}, $a7031b6d2b9a785f$var$$ = function(t, e) {
    for(var s = t.childNodes ? t.childNodes : [], i = e.childNodes ? e.childNodes : [], n = $a7031b6d2b9a785f$var$V(s.length, !1), a = $a7031b6d2b9a785f$var$V(i.length, !1), o = [], r = function() {
        return arguments[1];
    }, l = !1, d = function() {
        var t = function(t, e, s, i) {
            var n = 0, a = [], o = t.length, r = e.length, l = $a7031b6d2b9a785f$var$p([], new Array(o + 1), !0).map(function() {
                return [];
            }), d = $a7031b6d2b9a785f$var$D(t, e), c = o === r;
            c && t.some(function(t, s) {
                var i = $a7031b6d2b9a785f$var$y(t), n = $a7031b6d2b9a785f$var$y(e[s]);
                return i.length !== n.length ? (c = !1, !0) : (i.some(function(t, e) {
                    if (t !== n[e]) return c = !1, !0;
                }), !c || void 0);
            });
            for(var h = 0; h < o; h++)for(var u = t[h], f = 0; f < r; f++){
                var m = e[f];
                s[h] || i[f] || !$a7031b6d2b9a785f$var$E(u, m, d, c) ? l[h + 1][f + 1] = 0 : (l[h + 1][f + 1] = l[h][f] ? l[h][f] + 1 : 1, l[h + 1][f + 1] >= n && (n = l[h + 1][f + 1], a = [
                    h + 1,
                    f + 1
                ]));
            }
            return 0 !== n && {
                oldValue: a[0] - n,
                newValue: a[1] - n,
                length: n
            };
        }(s, i, n, a);
        t ? (o.push(t), $a7031b6d2b9a785f$var$p([], new Array(t.length), !0).map(r).forEach(function(e) {
            return function(t, e, s, i) {
                t[s.oldValue + i] = !0, e[s.newValue + i] = !0;
            }(n, a, t, e);
        })) : l = !0;
    }; !l;)d();
    return t.subsets = o, t.subsetsAge = 100, o;
}, $a7031b6d2b9a785f$var$C = function() {
    function t() {
        this.list = [];
    }
    return t.prototype.add = function(t) {
        var e;
        (e = this.list).push.apply(e, t);
    }, t.prototype.forEach = function(t) {
        this.list.forEach(function(e) {
            return t(e);
        });
    }, t;
}();
function $a7031b6d2b9a785f$var$k(t, e) {
    var s, i, n = t;
    for(e = e.slice(); e.length > 0;)i = e.splice(0, 1)[0], s = n, n = n.childNodes ? n.childNodes[i] : void 0;
    return {
        node: n,
        parentNode: s,
        nodeIndex: i
    };
}
function $a7031b6d2b9a785f$var$S(t, e, s) {
    return e.forEach(function(e) {
        !function(t, e, s) {
            var i, n, a, o;
            if (![
                s._const.addElement,
                s._const.addTextElement
            ].includes(e[s._const.action])) {
                var r = $a7031b6d2b9a785f$var$k(t, e[s._const.route]);
                n = r.node, a = r.parentNode, o = r.nodeIndex;
            }
            var l, d, c = [], h = {
                diff: e,
                node: n
            };
            if (s.preVirtualDiffApply(h)) return !0;
            switch(e[s._const.action]){
                case s._const.addAttribute:
                    n.attributes || (n.attributes = {}), n.attributes[e[s._const.name]] = e[s._const.value], "checked" === e[s._const.name] ? n.checked = !0 : "selected" === e[s._const.name] ? n.selected = !0 : "INPUT" === n.nodeName && "value" === e[s._const.name] && (n.value = e[s._const.value]);
                    break;
                case s._const.modifyAttribute:
                    n.attributes[e[s._const.name]] = e[s._const.newValue];
                    break;
                case s._const.removeAttribute:
                    delete n.attributes[e[s._const.name]], 0 === Object.keys(n.attributes).length && delete n.attributes, "checked" === e[s._const.name] ? n.checked = !1 : "selected" === e[s._const.name] ? delete n.selected : "INPUT" === n.nodeName && "value" === e[s._const.name] && delete n.value;
                    break;
                case s._const.modifyTextElement:
                    n.data = e[s._const.newValue], "TEXTAREA" === a.nodeName && (a.value = e[s._const.newValue]);
                    break;
                case s._const.modifyValue:
                    n.value = e[s._const.newValue];
                    break;
                case s._const.modifyComment:
                    n.data = e[s._const.newValue];
                    break;
                case s._const.modifyChecked:
                    n.checked = e[s._const.newValue];
                    break;
                case s._const.modifySelected:
                    n.selected = e[s._const.newValue];
                    break;
                case s._const.replaceElement:
                    l = $a7031b6d2b9a785f$var$O(e[s._const.newValue]), a.childNodes[o] = l;
                    break;
                case s._const.relocateGroup:
                    n.childNodes.splice(e[s._const.from], e[s._const.groupLength]).reverse().forEach(function(t) {
                        return n.childNodes.splice(e[s._const.to], 0, t);
                    }), n.subsets && n.subsets.forEach(function(t) {
                        if (e[s._const.from] < e[s._const.to] && t.oldValue <= e[s._const.to] && t.oldValue > e[s._const.from]) t.oldValue -= e[s._const.groupLength], (i = t.oldValue + t.length - e[s._const.to]) > 0 && (c.push({
                            oldValue: e[s._const.to] + e[s._const.groupLength],
                            newValue: t.newValue + t.length - i,
                            length: i
                        }), t.length -= i);
                        else if (e[s._const.from] > e[s._const.to] && t.oldValue > e[s._const.to] && t.oldValue < e[s._const.from]) {
                            var i;
                            t.oldValue += e[s._const.groupLength], (i = t.oldValue + t.length - e[s._const.to]) > 0 && (c.push({
                                oldValue: e[s._const.to] + e[s._const.groupLength],
                                newValue: t.newValue + t.length - i,
                                length: i
                            }), t.length -= i);
                        } else t.oldValue === e[s._const.from] && (t.oldValue = e[s._const.to]);
                    });
                    break;
                case s._const.removeElement:
                    a.childNodes.splice(o, 1), a.subsets && a.subsets.forEach(function(t) {
                        t.oldValue > o ? t.oldValue -= 1 : t.oldValue === o ? t.delete = !0 : t.oldValue < o && t.oldValue + t.length > o && (t.oldValue + t.length - 1 === o ? t.length-- : (c.push({
                            newValue: t.newValue + o - t.oldValue,
                            oldValue: o,
                            length: t.length - o + t.oldValue - 1
                        }), t.length = o - t.oldValue));
                    }), n = a;
                    break;
                case s._const.addElement:
                    var u = (d = e[s._const.route].slice()).splice(d.length - 1, 1)[0];
                    n = null === (i = $a7031b6d2b9a785f$var$k(t, d)) || void 0 === i ? void 0 : i.node, l = $a7031b6d2b9a785f$var$O(e[s._const.element]), n.childNodes || (n.childNodes = []), u >= n.childNodes.length ? n.childNodes.push(l) : n.childNodes.splice(u, 0, l), n.subsets && n.subsets.forEach(function(t) {
                        if (t.oldValue >= u) t.oldValue += 1;
                        else if (t.oldValue < u && t.oldValue + t.length > u) {
                            var e = t.oldValue + t.length - u;
                            c.push({
                                newValue: t.newValue + t.length - e,
                                oldValue: u + 1,
                                length: e
                            }), t.length -= e;
                        }
                    });
                    break;
                case s._const.removeTextElement:
                    a.childNodes.splice(o, 1), "TEXTAREA" === a.nodeName && delete a.value, a.subsets && a.subsets.forEach(function(t) {
                        t.oldValue > o ? t.oldValue -= 1 : t.oldValue === o ? t.delete = !0 : t.oldValue < o && t.oldValue + t.length > o && (t.oldValue + t.length - 1 === o ? t.length-- : (c.push({
                            newValue: t.newValue + o - t.oldValue,
                            oldValue: o,
                            length: t.length - o + t.oldValue - 1
                        }), t.length = o - t.oldValue));
                    }), n = a;
                    break;
                case s._const.addTextElement:
                    var p = (d = e[s._const.route].slice()).splice(d.length - 1, 1)[0];
                    l = {
                        nodeName: "#text",
                        data: e[s._const.value]
                    }, (n = $a7031b6d2b9a785f$var$k(t, d).node).childNodes || (n.childNodes = []), p >= n.childNodes.length ? n.childNodes.push(l) : n.childNodes.splice(p, 0, l), "TEXTAREA" === n.nodeName && (n.value = e[s._const.newValue]), n.subsets && n.subsets.forEach(function(t) {
                        if (t.oldValue >= p && (t.oldValue += 1), t.oldValue < p && t.oldValue + t.length > p) {
                            var e = t.oldValue + t.length - p;
                            c.push({
                                newValue: t.newValue + t.length - e,
                                oldValue: p + 1,
                                length: e
                            }), t.length -= e;
                        }
                    });
                    break;
                default:
                    console.log("unknown action");
            }
            n.subsets && (n.subsets = n.subsets.filter(function(t) {
                return !t.delete && t.oldValue !== t.newValue;
            }), c.length && (n.subsets = n.subsets.concat(c))), s.postVirtualDiffApply({
                node: h.node,
                diff: h.diff,
                newNode: l
            });
        }(t, e, s);
    }), !0;
}
function $a7031b6d2b9a785f$var$T(t, e) {
    void 0 === e && (e = {
        valueDiffing: !0
    });
    var s = {
        nodeName: t.nodeName
    };
    if ($a7031b6d2b9a785f$var$m(t, "Text", "Comment")) s.data = t.data;
    else {
        if (t.attributes && t.attributes.length > 0) s.attributes = {}, Array.prototype.slice.call(t.attributes).forEach(function(t) {
            return s.attributes[t.name] = t.value;
        });
        if (t.childNodes && t.childNodes.length > 0) s.childNodes = [], Array.prototype.slice.call(t.childNodes).forEach(function(t) {
            return s.childNodes.push($a7031b6d2b9a785f$var$T(t, e));
        });
        e.valueDiffing && ($a7031b6d2b9a785f$var$m(t, "HTMLTextAreaElement") && (s.value = t.value), $a7031b6d2b9a785f$var$m(t, "HTMLInputElement") && [
            "radio",
            "checkbox"
        ].includes(t.type.toLowerCase()) && void 0 !== t.checked ? s.checked = t.checked : $a7031b6d2b9a785f$var$m(t, "HTMLButtonElement", "HTMLDataElement", "HTMLInputElement", "HTMLLIElement", "HTMLMeterElement", "HTMLOptionElement", "HTMLProgressElement", "HTMLParamElement") && (s.value = t.value), $a7031b6d2b9a785f$var$m(t, "HTMLOptionElement") && (s.selected = t.selected));
    }
    return s;
}
var $a7031b6d2b9a785f$var$A = /<\s*\/*[a-zA-Z:_][a-zA-Z0-9:_\-.]*\s*(?:"[^"]*"['"]*|'[^']*'['"]*|[^'"/>])*\/*\s*>|<!--(?:.|\n|\r)*?-->/g, $a7031b6d2b9a785f$var$L = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $a7031b6d2b9a785f$var$P(t) {
    return t.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&");
}
var $a7031b6d2b9a785f$var$R = {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    menuItem: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
}, $a7031b6d2b9a785f$var$H = function(t, e) {
    var s = {
        nodeName: "",
        attributes: {}
    }, i = !1, n = t.match(/<\/?([^\s]+?)[/\s>]/);
    if (n && (s.nodeName = e || "svg" === n[1] ? n[1] : n[1].toUpperCase(), ($a7031b6d2b9a785f$var$R[n[1]] || "/" === t.charAt(t.length - 2)) && (i = !0), s.nodeName.startsWith("!--"))) {
        var a = t.indexOf("--\x3e");
        return {
            type: "comment",
            node: {
                nodeName: "#comment",
                data: -1 !== a ? t.slice(4, a) : ""
            },
            voidElement: i
        };
    }
    for(var o = new RegExp($a7031b6d2b9a785f$var$L), r = null, l = !1; !l;)if (null === (r = o.exec(t))) l = !0;
    else if (r[0].trim()) {
        if (r[1]) {
            var d = r[1].trim(), c = [
                d,
                ""
            ];
            d.indexOf("=") > -1 && (c = d.split("=")), s.attributes[c[0]] = c[1], o.lastIndex--;
        } else r[2] && (s.attributes[r[2]] = r[3].trim().substring(1, r[3].length - 1));
    }
    return {
        type: "tag",
        node: s,
        voidElement: i
    };
}, $a7031b6d2b9a785f$var$I = function(t, e) {
    void 0 === e && (e = {
        valueDiffing: !0,
        caseSensitive: !1
    });
    var s, i = [], n = -1, a = [], o = !1;
    if (0 !== t.indexOf("<")) {
        var r = t.indexOf("<");
        i.push({
            nodeName: "#text",
            data: -1 === r ? t : t.substring(0, r)
        });
    }
    return t.replace($a7031b6d2b9a785f$var$A, function(r, l) {
        var d = "/" !== r.charAt(1), c = r.startsWith("\x3c!--"), h = l + r.length, u = t.charAt(h);
        if (c) {
            var p = $a7031b6d2b9a785f$var$H(r, e.caseSensitive).node;
            if (n < 0) return i.push(p), "";
            var f = a[n];
            return f && p.nodeName && (f.node.childNodes || (f.node.childNodes = []), f.node.childNodes.push(p)), "";
        }
        if (d) {
            if ("svg" === (s = $a7031b6d2b9a785f$var$H(r, e.caseSensitive || o)).node.nodeName && (o = !0), n++, !s.voidElement && u && "<" !== u) {
                s.node.childNodes || (s.node.childNodes = []);
                var m = $a7031b6d2b9a785f$var$P(t.slice(h, t.indexOf("<", h)));
                s.node.childNodes.push({
                    nodeName: "#text",
                    data: m
                }), e.valueDiffing && "TEXTAREA" === s.node.nodeName && (s.node.value = m);
            }
            0 === n && s.node.nodeName && i.push(s.node);
            var g = a[n - 1];
            g && s.node.nodeName && (g.node.childNodes || (g.node.childNodes = []), g.node.childNodes.push(s.node)), a[n] = s;
        }
        if ((!d || s.voidElement) && (n > -1 && (s.voidElement || e.caseSensitive && s.node.nodeName === r.slice(2, -1) || !e.caseSensitive && s.node.nodeName.toUpperCase() === r.slice(2, -1).toUpperCase()) && --n > -1 && ("svg" === s.node.nodeName && (o = !1), s = a[n]), "<" !== u && u)) {
            var b = -1 === n ? i : a[n].node.childNodes || [], v = t.indexOf("<", h);
            m = $a7031b6d2b9a785f$var$P(t.slice(h, -1 === v ? void 0 : v));
            b.push({
                nodeName: "#text",
                data: m
            });
        }
        return "";
    }), i[0];
}, $a7031b6d2b9a785f$var$Y = function() {
    function t(t, e, s) {
        this.options = s, this.t1 = "undefined" != typeof Element && $a7031b6d2b9a785f$var$m(t, "Element") ? $a7031b6d2b9a785f$var$T(t, this.options) : "string" == typeof t ? $a7031b6d2b9a785f$var$I(t, this.options) : JSON.parse(JSON.stringify(t)), this.t2 = "undefined" != typeof Element && $a7031b6d2b9a785f$var$m(e, "Element") ? $a7031b6d2b9a785f$var$T(e, this.options) : "string" == typeof e ? $a7031b6d2b9a785f$var$I(e, this.options) : JSON.parse(JSON.stringify(e)), this.diffcount = 0, this.foundAll = !1, this.debug && (this.t1Orig = "undefined" != typeof Element && $a7031b6d2b9a785f$var$m(t, "Element") ? $a7031b6d2b9a785f$var$T(t, this.options) : "string" == typeof t ? $a7031b6d2b9a785f$var$I(t, this.options) : JSON.parse(JSON.stringify(t)), this.t2Orig = "undefined" != typeof Element && $a7031b6d2b9a785f$var$m(e, "Element") ? $a7031b6d2b9a785f$var$T(e, this.options) : "string" == typeof e ? $a7031b6d2b9a785f$var$I(e, this.options) : JSON.parse(JSON.stringify(e))), this.tracker = new $a7031b6d2b9a785f$var$C;
    }
    return t.prototype.init = function() {
        return this.findDiffs(this.t1, this.t2);
    }, t.prototype.findDiffs = function(t, e) {
        var s;
        do {
            if (this.options.debug && (this.diffcount += 1, this.diffcount > this.options.diffcap)) throw new Error("surpassed diffcap:".concat(JSON.stringify(this.t1Orig), " -> ").concat(JSON.stringify(this.t2Orig)));
            0 === (s = this.findNextDiff(t, e, [])).length && ($a7031b6d2b9a785f$var$x(t, e) || (this.foundAll ? console.error("Could not find remaining diffs!") : (this.foundAll = !0, $a7031b6d2b9a785f$var$N(t), s = this.findNextDiff(t, e, [])))), s.length > 0 && (this.foundAll = !1, this.tracker.add(s), $a7031b6d2b9a785f$var$S(t, s, this.options));
        }while (s.length > 0);
        return this.tracker.list;
    }, t.prototype.findNextDiff = function(t, e, s) {
        var i, n;
        if (this.options.maxDepth && s.length > this.options.maxDepth) return [];
        if (!t.outerDone) {
            if (i = this.findOuterDiff(t, e, s), this.options.filterOuterDiff && (n = this.options.filterOuterDiff(t, e, i)) && (i = n), i.length > 0) return t.outerDone = !0, i;
            t.outerDone = !0;
        }
        if (Object.prototype.hasOwnProperty.call(t, "data")) return [];
        if (!t.innerDone) {
            if ((i = this.findInnerDiff(t, e, s)).length > 0) return i;
            t.innerDone = !0;
        }
        if (this.options.valueDiffing && !t.valueDone) {
            if ((i = this.findValueDiff(t, e, s)).length > 0) return t.valueDone = !0, i;
            t.valueDone = !0;
        }
        return [];
    }, t.prototype.findOuterDiff = function(t, e, s) {
        var i, n, a, o, r, l, d = [];
        if (t.nodeName !== e.nodeName) {
            if (!s.length) throw new Error("Top level nodes have to be of the same kind.");
            return [
                (new $a7031b6d2b9a785f$var$f).setValue(this.options._const.action, this.options._const.replaceElement).setValue(this.options._const.oldValue, $a7031b6d2b9a785f$var$O(t)).setValue(this.options._const.newValue, $a7031b6d2b9a785f$var$O(e)).setValue(this.options._const.route, s)
            ];
        }
        if (s.length && this.options.diffcap < Math.abs((t.childNodes || []).length - (e.childNodes || []).length)) return [
            (new $a7031b6d2b9a785f$var$f).setValue(this.options._const.action, this.options._const.replaceElement).setValue(this.options._const.oldValue, $a7031b6d2b9a785f$var$O(t)).setValue(this.options._const.newValue, $a7031b6d2b9a785f$var$O(e)).setValue(this.options._const.route, s)
        ];
        if (Object.prototype.hasOwnProperty.call(t, "data") && t.data !== e.data) return "#text" === t.nodeName ? [
            (new $a7031b6d2b9a785f$var$f).setValue(this.options._const.action, this.options._const.modifyTextElement).setValue(this.options._const.route, s).setValue(this.options._const.oldValue, t.data).setValue(this.options._const.newValue, e.data)
        ] : [
            (new $a7031b6d2b9a785f$var$f).setValue(this.options._const.action, this.options._const.modifyComment).setValue(this.options._const.route, s).setValue(this.options._const.oldValue, t.data).setValue(this.options._const.newValue, e.data)
        ];
        for(n = t.attributes ? Object.keys(t.attributes).sort() : [], a = e.attributes ? Object.keys(e.attributes).sort() : [], o = n.length, l = 0; l < o; l++)i = n[l], -1 === (r = a.indexOf(i)) ? d.push((new $a7031b6d2b9a785f$var$f).setValue(this.options._const.action, this.options._const.removeAttribute).setValue(this.options._const.route, s).setValue(this.options._const.name, i).setValue(this.options._const.value, t.attributes[i])) : (a.splice(r, 1), t.attributes[i] !== e.attributes[i] && d.push((new $a7031b6d2b9a785f$var$f).setValue(this.options._const.action, this.options._const.modifyAttribute).setValue(this.options._const.route, s).setValue(this.options._const.name, i).setValue(this.options._const.oldValue, t.attributes[i]).setValue(this.options._const.newValue, e.attributes[i])));
        for(o = a.length, l = 0; l < o; l++)i = a[l], d.push((new $a7031b6d2b9a785f$var$f).setValue(this.options._const.action, this.options._const.addAttribute).setValue(this.options._const.route, s).setValue(this.options._const.name, i).setValue(this.options._const.value, e.attributes[i]));
        return d;
    }, t.prototype.findInnerDiff = function(t, e, s) {
        var i = t.childNodes ? t.childNodes.slice() : [], n = e.childNodes ? e.childNodes.slice() : [], a = Math.max(i.length, n.length), o = Math.abs(i.length - n.length), r = [], l = 0;
        if (!this.options.maxChildCount || a < this.options.maxChildCount) {
            var d = Boolean(t.subsets && t.subsetsAge--), c = d ? t.subsets : t.childNodes && e.childNodes ? $a7031b6d2b9a785f$var$$(t, e) : [];
            if (c.length > 0 && (r = this.attemptGroupRelocation(t, e, c, s, d)).length > 0) return r;
        }
        for(var h = 0; h < a; h += 1){
            var u = i[h], p = n[h];
            o && (u && !p ? "#text" === u.nodeName ? (r.push((new $a7031b6d2b9a785f$var$f).setValue(this.options._const.action, this.options._const.removeTextElement).setValue(this.options._const.route, s.concat(l)).setValue(this.options._const.value, u.data)), l -= 1) : (r.push((new $a7031b6d2b9a785f$var$f).setValue(this.options._const.action, this.options._const.removeElement).setValue(this.options._const.route, s.concat(l)).setValue(this.options._const.element, $a7031b6d2b9a785f$var$O(u))), l -= 1) : p && !u && ("#text" === p.nodeName ? r.push((new $a7031b6d2b9a785f$var$f).setValue(this.options._const.action, this.options._const.addTextElement).setValue(this.options._const.route, s.concat(l)).setValue(this.options._const.value, p.data)) : r.push((new $a7031b6d2b9a785f$var$f).setValue(this.options._const.action, this.options._const.addElement).setValue(this.options._const.route, s.concat(l)).setValue(this.options._const.element, $a7031b6d2b9a785f$var$O(p))))), u && p && (!this.options.maxChildCount || a < this.options.maxChildCount ? r = r.concat(this.findNextDiff(u, p, s.concat(l))) : $a7031b6d2b9a785f$var$x(u, p) || (i.length > n.length ? ("#text" === u.nodeName ? r.push((new $a7031b6d2b9a785f$var$f).setValue(this.options._const.action, this.options._const.removeTextElement).setValue(this.options._const.route, s.concat(l)).setValue(this.options._const.value, u.data)) : r.push((new $a7031b6d2b9a785f$var$f).setValue(this.options._const.action, this.options._const.removeElement).setValue(this.options._const.element, $a7031b6d2b9a785f$var$O(u)).setValue(this.options._const.route, s.concat(l))), i.splice(h, 1), h -= 1, l -= 1, o -= 1) : i.length < n.length ? (r = r.concat([
                (new $a7031b6d2b9a785f$var$f).setValue(this.options._const.action, this.options._const.addElement).setValue(this.options._const.element, $a7031b6d2b9a785f$var$O(p)).setValue(this.options._const.route, s.concat(l))
            ]), i.splice(h, 0, $a7031b6d2b9a785f$var$O(p)), o -= 1) : r = r.concat([
                (new $a7031b6d2b9a785f$var$f).setValue(this.options._const.action, this.options._const.replaceElement).setValue(this.options._const.oldValue, $a7031b6d2b9a785f$var$O(u)).setValue(this.options._const.newValue, $a7031b6d2b9a785f$var$O(p)).setValue(this.options._const.route, s.concat(l))
            ]))), l += 1;
        }
        return t.innerDone = !0, r;
    }, t.prototype.attemptGroupRelocation = function(t, e, s, i, n) {
        for(var a, o, r, l, d, c = function(t, e, s) {
            var i = t.childNodes ? $a7031b6d2b9a785f$var$V(t.childNodes.length, !0) : [], n = e.childNodes ? $a7031b6d2b9a785f$var$V(e.childNodes.length, !0) : [], a = 0;
            return s.forEach(function(t) {
                for(var e = t.oldValue + t.length, s = t.newValue + t.length, o = t.oldValue; o < e; o += 1)i[o] = a;
                for(o = t.newValue; o < s; o += 1)n[o] = a;
                a += 1;
            }), {
                gaps1: i,
                gaps2: n
            };
        }(t, e, s), h = c.gaps1, u = c.gaps2, p = t.childNodes.slice(), m = e.childNodes.slice(), g = Math.min(h.length, u.length), b = [], v = 0, _ = 0; v < g; _ += 1, v += 1)if (!n || !0 !== h[v] && !0 !== u[v]) {
            if (!0 === h[_]) {
                if ("#text" === (l = p[_]).nodeName) {
                    if ("#text" === m[v].nodeName) {
                        if (l.data !== m[v].data) {
                            for(var w = _; p.length > w + 1 && "#text" === p[w + 1].nodeName;)if (w += 1, m[v].data === p[w].data) {
                                d = !0;
                                break;
                            }
                            d || b.push((new $a7031b6d2b9a785f$var$f).setValue(this.options._const.action, this.options._const.modifyTextElement).setValue(this.options._const.route, i.concat(_)).setValue(this.options._const.oldValue, l.data).setValue(this.options._const.newValue, m[v].data));
                        }
                    } else b.push((new $a7031b6d2b9a785f$var$f).setValue(this.options._const.action, this.options._const.removeTextElement).setValue(this.options._const.route, i.concat(_)).setValue(this.options._const.value, l.data)), h.splice(_, 1), p.splice(_, 1), g = Math.min(h.length, u.length), _ -= 1, v -= 1;
                } else !0 === u[v] ? b.push((new $a7031b6d2b9a785f$var$f).setValue(this.options._const.action, this.options._const.replaceElement).setValue(this.options._const.oldValue, $a7031b6d2b9a785f$var$O(l)).setValue(this.options._const.newValue, $a7031b6d2b9a785f$var$O(m[v])).setValue(this.options._const.route, i.concat(_))) : (b.push((new $a7031b6d2b9a785f$var$f).setValue(this.options._const.action, this.options._const.removeElement).setValue(this.options._const.route, i.concat(_)).setValue(this.options._const.element, $a7031b6d2b9a785f$var$O(l))), h.splice(_, 1), p.splice(_, 1), g = Math.min(h.length, u.length), _ -= 1, v -= 1);
            } else if (!0 === u[v]) "#text" === (l = m[v]).nodeName ? (b.push((new $a7031b6d2b9a785f$var$f).setValue(this.options._const.action, this.options._const.addTextElement).setValue(this.options._const.route, i.concat(_)).setValue(this.options._const.value, l.data)), h.splice(_, 0, !0), p.splice(_, 0, {
                nodeName: "#text",
                data: l.data
            }), g = Math.min(h.length, u.length)) : (b.push((new $a7031b6d2b9a785f$var$f).setValue(this.options._const.action, this.options._const.addElement).setValue(this.options._const.route, i.concat(_)).setValue(this.options._const.element, $a7031b6d2b9a785f$var$O(l))), h.splice(_, 0, !0), p.splice(_, 0, $a7031b6d2b9a785f$var$O(l)), g = Math.min(h.length, u.length));
            else if (h[_] !== u[v]) {
                if (b.length > 0) return b;
                if (r = s[h[_]], (o = Math.min(r.newValue, p.length - r.length)) !== r.oldValue) {
                    a = !1;
                    for(var y = 0; y < r.length; y += 1)$a7031b6d2b9a785f$var$E(p[o + y], p[r.oldValue + y], {}, !1, !0) || (a = !0);
                    if (a) return [
                        (new $a7031b6d2b9a785f$var$f).setValue(this.options._const.action, this.options._const.relocateGroup).setValue(this.options._const.groupLength, r.length).setValue(this.options._const.from, r.oldValue).setValue(this.options._const.to, o).setValue(this.options._const.route, i)
                    ];
                }
            }
        }
        return b;
    }, t.prototype.findValueDiff = function(t, e, s) {
        var i = [];
        return t.selected !== e.selected && i.push((new $a7031b6d2b9a785f$var$f).setValue(this.options._const.action, this.options._const.modifySelected).setValue(this.options._const.oldValue, t.selected).setValue(this.options._const.newValue, e.selected).setValue(this.options._const.route, s)), (t.value || e.value) && t.value !== e.value && "OPTION" !== t.nodeName && i.push((new $a7031b6d2b9a785f$var$f).setValue(this.options._const.action, this.options._const.modifyValue).setValue(this.options._const.oldValue, t.value || "").setValue(this.options._const.newValue, e.value || "").setValue(this.options._const.route, s)), t.checked !== e.checked && i.push((new $a7031b6d2b9a785f$var$f).setValue(this.options._const.action, this.options._const.modifyChecked).setValue(this.options._const.oldValue, t.checked).setValue(this.options._const.newValue, e.checked).setValue(this.options._const.route, s)), i;
    }, t;
}(), $a7031b6d2b9a785f$var$j = {
    debug: !1,
    diffcap: 10,
    maxDepth: !1,
    maxChildCount: 50,
    valueDiffing: !0,
    textDiff: function(t, e, s, i) {
        t.data = i;
    },
    preVirtualDiffApply: function() {},
    postVirtualDiffApply: function() {},
    preDiffApply: function() {},
    postDiffApply: function() {},
    filterOuterDiff: null,
    compress: !1,
    _const: !1,
    document: !("undefined" == typeof window || !window.document) && window.document,
    components: []
}, $a7031b6d2b9a785f$var$F = function() {
    function t(t) {
        if (void 0 === t && (t = {}), Object.entries($a7031b6d2b9a785f$var$j).forEach(function(e) {
            var s = e[0], i = e[1];
            Object.prototype.hasOwnProperty.call(t, s) || (t[s] = i);
        }), !t._const) {
            var e = [
                "addAttribute",
                "modifyAttribute",
                "removeAttribute",
                "modifyTextElement",
                "relocateGroup",
                "removeElement",
                "addElement",
                "removeTextElement",
                "addTextElement",
                "replaceElement",
                "modifyValue",
                "modifyChecked",
                "modifySelected",
                "modifyComment",
                "action",
                "route",
                "oldValue",
                "newValue",
                "element",
                "group",
                "groupLength",
                "from",
                "to",
                "name",
                "value",
                "data",
                "attributes",
                "nodeName",
                "childNodes",
                "checked",
                "selected"
            ], s = {};
            t.compress ? e.forEach(function(t, e) {
                return s[t] = e;
            }) : e.forEach(function(t) {
                return s[t] = t;
            }), t._const = s;
        }
        this.options = t;
    }
    return t.prototype.apply = function(t, e) {
        return function(t, e, s) {
            return e.every(function(e) {
                return $a7031b6d2b9a785f$var$v(t, e, s);
            });
        }(t, e, this.options);
    }, t.prototype.undo = function(t, e) {
        return $a7031b6d2b9a785f$var$w(t, e, this.options);
    }, t.prototype.diff = function(t, e) {
        return new $a7031b6d2b9a785f$var$Y(t, e, this.options).init();
    }, t;
}();
const $a7031b6d2b9a785f$var$q = (t, e, s, { classes: i, format: n, hiddenHeader: a, sortable: o, scrollY: r, type: l }, { noColumnWidths: d, unhideHeader: h })=>({
        nodeName: "TR",
        childNodes: t.map((t, u)=>{
            const p = e[u] || {
                type: l,
                format: n,
                sortable: !0,
                searchable: !0
            };
            if (p.hidden) return;
            const f = t.attributes ? {
                ...t.attributes
            } : {};
            if (p.sortable && o && (!r.length || h) && (p.filter ? f["data-filterable"] = "true" : f["data-sortable"] = "true"), p.headerClass && (f.class = $a7031b6d2b9a785f$var$c(f.class, p.headerClass)), s.sort && s.sort.column === u) {
                const t = "asc" === s.sort.dir ? i.ascending : i.descending;
                f.class = $a7031b6d2b9a785f$var$c(f.class, t), f["aria-sort"] = "asc" === s.sort.dir ? "ascending" : "descending";
            } else s.filters[u] && (f.class = $a7031b6d2b9a785f$var$c(f.class, i.filterActive));
            if (s.widths[u] && !d) {
                const t = `width: ${s.widths[u]}%;`;
                f.style = $a7031b6d2b9a785f$var$c(f.style, t);
            }
            if (r.length && !h) {
                const t = "padding-bottom: 0;padding-top: 0;border: 0;";
                f.style = $a7031b6d2b9a785f$var$c(f.style, t);
            }
            const m = "html" === t.type ? t.data : [
                {
                    nodeName: "#text",
                    data: t.text ?? String(t.data)
                }
            ];
            return {
                nodeName: "TH",
                attributes: f,
                childNodes: !a && !r.length || h ? p.sortable && o ? [
                    {
                        nodeName: "BUTTON",
                        attributes: {
                            class: p.filter ? i.filter : i.sorter
                        },
                        childNodes: m
                    }
                ] : m : [
                    {
                        nodeName: "#text",
                        data: ""
                    }
                ]
            };
        }).filter((t)=>t)
    }), $a7031b6d2b9a785f$var$B = (t, e, s, i, a, o, { classes: r, hiddenHeader: l, header: d, footer: h, format: u, sortable: p, scrollY: f, type: m, rowRender: g, tabIndex: b }, { noColumnWidths: v, unhideHeader: _, renderHeader: w }, y, M)=>{
    const D = {
        nodeName: "TABLE",
        attributes: {
            ...t
        },
        childNodes: [
            {
                nodeName: "TBODY",
                childNodes: s.map(({ row: t, index: e })=>{
                    const s = {
                        nodeName: "TR",
                        attributes: {
                            ...t.attributes,
                            "data-index": String(e)
                        },
                        childNodes: t.cells.map((t, s)=>{
                            const o = i[s] || {
                                type: m,
                                format: u,
                                sortable: !0,
                                searchable: !0
                            };
                            if (o.hidden) return;
                            const r = {
                                nodeName: "TD",
                                attributes: t.attributes ? {
                                    ...t.attributes
                                } : {},
                                childNodes: "html" === o.type ? t.data : [
                                    {
                                        nodeName: "#text",
                                        data: $a7031b6d2b9a785f$var$n(t)
                                    }
                                ]
                            };
                            if (d || h || !a.widths[s] || v || (r.attributes.style = $a7031b6d2b9a785f$var$c(r.attributes.style, `width: ${a.widths[s]}%;`)), o.cellClass && (r.attributes.class = $a7031b6d2b9a785f$var$c(r.attributes.class, o.cellClass)), o.render) {
                                const i = o.render(t.data, r, e, s);
                                if (i) {
                                    if ("string" != typeof i) return i;
                                    {
                                        const t = $a7031b6d2b9a785f$var$I(`<td>${i}</td>`);
                                        1 === t.childNodes.length && [
                                            "#text",
                                            "#comment"
                                        ].includes(t.childNodes[0].nodeName) ? r.childNodes[0].data = i : r.childNodes = t.childNodes;
                                    }
                                }
                            }
                            return r;
                        }).filter((t)=>t)
                    };
                    if (e === o && (s.attributes.class = $a7031b6d2b9a785f$var$c(s.attributes.class, r.cursor)), g) {
                        const i = g(t, s, e);
                        if (i) {
                            if ("string" != typeof i) return i;
                            {
                                const t = $a7031b6d2b9a785f$var$I(`<tr>${i}</tr>`);
                                !t.childNodes || 1 === t.childNodes.length && [
                                    "#text",
                                    "#comment"
                                ].includes(t.childNodes[0].nodeName) ? s.childNodes[0].data = i : s.childNodes = t.childNodes;
                            }
                        }
                    }
                    return s;
                })
            }
        ]
    };
    if (D.attributes.class = $a7031b6d2b9a785f$var$c(D.attributes.class, r.table), d || h || w) {
        const t = $a7031b6d2b9a785f$var$q(e, i, a, {
            classes: r,
            hiddenHeader: l,
            sortable: p,
            scrollY: f
        }, {
            noColumnWidths: v,
            unhideHeader: _
        });
        if (d || w) {
            const e = {
                nodeName: "THEAD",
                childNodes: [
                    t
                ]
            };
            !f.length && !l || _ || (e.attributes = {
                style: "height: 0px;"
            }), D.childNodes.unshift(e);
        }
        if (h) {
            const e = {
                nodeName: "TFOOT",
                childNodes: [
                    d ? structuredClone(t) : t
                ]
            };
            !f.length && !l || _ || (e.attributes = {
                style: "height: 0px;"
            }), D.childNodes.push(e);
        }
    }
    return y.forEach((t)=>D.childNodes.push(t)), M.forEach((t)=>D.childNodes.push(t)), !1 !== b && (D.attributes.tabindex = String(b)), D;
};
"undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self && self;
function $a7031b6d2b9a785f$var$z(t) {
    return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var $a7031b6d2b9a785f$var$U = {
    exports: {}
}, $a7031b6d2b9a785f$var$W = $a7031b6d2b9a785f$var$z($a7031b6d2b9a785f$var$U.exports = function() {
    var t = 1e3, e = 6e4, s = 36e5, i = "millisecond", n = "second", a = "minute", o = "hour", r = "day", l = "week", d = "month", c = "quarter", h = "year", u = "date", p = "Invalid Date", f = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, m = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, g = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], s = t % 100;
            return "[" + t + (e[(s - 20) % 10] || e[s] || e[0]) + "]";
        }
    }, b = function(t, e, s) {
        var i = String(t);
        return !i || i.length >= e ? t : "" + Array(e + 1 - i.length).join(s) + t;
    }, v = {
        s: b,
        z: function(t) {
            var e = -t.utcOffset(), s = Math.abs(e), i = Math.floor(s / 60), n = s % 60;
            return (e <= 0 ? "+" : "-") + b(i, 2, "0") + ":" + b(n, 2, "0");
        },
        m: function t(e, s) {
            if (e.date() < s.date()) return -t(s, e);
            var i = 12 * (s.year() - e.year()) + (s.month() - e.month()), n = e.clone().add(i, d), a = s - n < 0, o = e.clone().add(i + (a ? -1 : 1), d);
            return +(-(i + (s - n) / (a ? n - o : o - n)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: d,
                y: h,
                w: l,
                d: r,
                D: u,
                h: o,
                m: a,
                s: n,
                ms: i,
                Q: c
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, _ = "en", w = {};
    w[_] = g;
    var y = "$isDayjsObject", M = function(t) {
        return t instanceof x || !(!t || !t[y]);
    }, D = function t(e, s, i) {
        var n;
        if (!e) return _;
        if ("string" == typeof e) {
            var a = e.toLowerCase();
            w[a] && (n = a), s && (w[a] = s, n = a);
            var o = e.split("-");
            if (!n && o.length > 1) return t(o[0]);
        } else {
            var r = e.name;
            w[r] = e, n = r;
        }
        return !i && n && (_ = n), n || !i && _;
    }, N = function(t, e) {
        if (M(t)) return t.clone();
        var s = "object" == typeof e ? e : {};
        return s.date = t, s.args = arguments, new x(s);
    }, O = v;
    O.l = D, O.i = M, O.w = function(t, e) {
        return N(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var x = function() {
        function g(t) {
            this.$L = D(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[y] = !0;
        }
        var b = g.prototype;
        return b.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, s = t.utc;
                if (null === e) return new Date(NaN);
                if (O.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var i = e.match(f);
                    if (i) {
                        var n = i[2] - 1 || 0, a = (i[7] || "0").substring(0, 3);
                        return s ? new Date(Date.UTC(i[1], n, i[3] || 1, i[4] || 0, i[5] || 0, i[6] || 0, a)) : new Date(i[1], n, i[3] || 1, i[4] || 0, i[5] || 0, i[6] || 0, a);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, b.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, b.$utils = function() {
            return O;
        }, b.isValid = function() {
            return !(this.$d.toString() === p);
        }, b.isSame = function(t, e) {
            var s = N(t);
            return this.startOf(e) <= s && s <= this.endOf(e);
        }, b.isAfter = function(t, e) {
            return N(t) < this.startOf(e);
        }, b.isBefore = function(t, e) {
            return this.endOf(e) < N(t);
        }, b.$g = function(t, e, s) {
            return O.u(t) ? this[e] : this.set(s, t);
        }, b.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, b.valueOf = function() {
            return this.$d.getTime();
        }, b.startOf = function(t, e) {
            var s = this, i = !!O.u(e) || e, c = O.p(t), p = function(t, e) {
                var n = O.w(s.$u ? Date.UTC(s.$y, e, t) : new Date(s.$y, e, t), s);
                return i ? n : n.endOf(r);
            }, f = function(t, e) {
                return O.w(s.toDate()[t].apply(s.toDate("s"), (i ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), s);
            }, m = this.$W, g = this.$M, b = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(c){
                case h:
                    return i ? p(1, 0) : p(31, 11);
                case d:
                    return i ? p(1, g) : p(0, g + 1);
                case l:
                    var _ = this.$locale().weekStart || 0, w = (m < _ ? m + 7 : m) - _;
                    return p(i ? b - w : b + (6 - w), g);
                case r:
                case u:
                    return f(v + "Hours", 0);
                case o:
                    return f(v + "Minutes", 1);
                case a:
                    return f(v + "Seconds", 2);
                case n:
                    return f(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, b.endOf = function(t) {
            return this.startOf(t, !1);
        }, b.$set = function(t, e) {
            var s, l = O.p(t), c = "set" + (this.$u ? "UTC" : ""), p = (s = {}, s[r] = c + "Date", s[u] = c + "Date", s[d] = c + "Month", s[h] = c + "FullYear", s[o] = c + "Hours", s[a] = c + "Minutes", s[n] = c + "Seconds", s[i] = c + "Milliseconds", s)[l], f = l === r ? this.$D + (e - this.$W) : e;
            if (l === d || l === h) {
                var m = this.clone().set(u, 1);
                m.$d[p](f), m.init(), this.$d = m.set(u, Math.min(this.$D, m.daysInMonth())).$d;
            } else p && this.$d[p](f);
            return this.init(), this;
        }, b.set = function(t, e) {
            return this.clone().$set(t, e);
        }, b.get = function(t) {
            return this[O.p(t)]();
        }, b.add = function(i, c) {
            var u, p = this;
            i = Number(i);
            var f = O.p(c), m = function(t) {
                var e = N(p);
                return O.w(e.date(e.date() + Math.round(t * i)), p);
            };
            if (f === d) return this.set(d, this.$M + i);
            if (f === h) return this.set(h, this.$y + i);
            if (f === r) return m(1);
            if (f === l) return m(7);
            var g = (u = {}, u[a] = e, u[o] = s, u[n] = t, u)[f] || 1, b = this.$d.getTime() + i * g;
            return O.w(b, this);
        }, b.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, b.format = function(t) {
            var e = this, s = this.$locale();
            if (!this.isValid()) return s.invalidDate || p;
            var i = t || "YYYY-MM-DDTHH:mm:ssZ", n = O.z(this), a = this.$H, o = this.$m, r = this.$M, l = s.weekdays, d = s.months, c = s.meridiem, h = function(t, s, n, a) {
                return t && (t[s] || t(e, i)) || n[s].slice(0, a);
            }, u = function(t) {
                return O.s(a % 12 || 12, t, "0");
            }, f = c || function(t, e, s) {
                var i = t < 12 ? "AM" : "PM";
                return s ? i.toLowerCase() : i;
            };
            return i.replace(m, function(t, i) {
                return i || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return O.s(e.$y, 4, "0");
                        case "M":
                            return r + 1;
                        case "MM":
                            return O.s(r + 1, 2, "0");
                        case "MMM":
                            return h(s.monthsShort, r, d, 3);
                        case "MMMM":
                            return h(d, r);
                        case "D":
                            return e.$D;
                        case "DD":
                            return O.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(s.weekdaysMin, e.$W, l, 2);
                        case "ddd":
                            return h(s.weekdaysShort, e.$W, l, 3);
                        case "dddd":
                            return l[e.$W];
                        case "H":
                            return String(a);
                        case "HH":
                            return O.s(a, 2, "0");
                        case "h":
                            return u(1);
                        case "hh":
                            return u(2);
                        case "a":
                            return f(a, o, !0);
                        case "A":
                            return f(a, o, !1);
                        case "m":
                            return String(o);
                        case "mm":
                            return O.s(o, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return O.s(e.$s, 2, "0");
                        case "SSS":
                            return O.s(e.$ms, 3, "0");
                        case "Z":
                            return n;
                    }
                    return null;
                }(t) || n.replace(":", "");
            });
        }, b.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, b.diff = function(i, u, p) {
            var f, m = this, g = O.p(u), b = N(i), v = (b.utcOffset() - this.utcOffset()) * e, _ = this - b, w = function() {
                return O.m(m, b);
            };
            switch(g){
                case h:
                    f = w() / 12;
                    break;
                case d:
                    f = w();
                    break;
                case c:
                    f = w() / 3;
                    break;
                case l:
                    f = (_ - v) / 6048e5;
                    break;
                case r:
                    f = (_ - v) / 864e5;
                    break;
                case o:
                    f = _ / s;
                    break;
                case a:
                    f = _ / e;
                    break;
                case n:
                    f = _ / t;
                    break;
                default:
                    f = _;
            }
            return p ? f : O.a(f);
        }, b.daysInMonth = function() {
            return this.endOf(d).$D;
        }, b.$locale = function() {
            return w[this.$L];
        }, b.locale = function(t, e) {
            if (!t) return this.$L;
            var s = this.clone(), i = D(t, e, !0);
            return i && (s.$L = i), s;
        }, b.clone = function() {
            return O.w(this.$d, this);
        }, b.toDate = function() {
            return new Date(this.valueOf());
        }, b.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, b.toISOString = function() {
            return this.$d.toISOString();
        }, b.toString = function() {
            return this.$d.toUTCString();
        }, g;
    }(), E = x.prototype;
    return N.prototype = E, [
        [
            "$ms",
            i
        ],
        [
            "$s",
            n
        ],
        [
            "$m",
            a
        ],
        [
            "$H",
            o
        ],
        [
            "$W",
            r
        ],
        [
            "$M",
            d
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            u
        ]
    ].forEach(function(t) {
        E[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), N.extend = function(t, e) {
        return t.$i || (t(e, x, N), t.$i = !0), N;
    }, N.locale = D, N.isDayjs = M, N.unix = function(t) {
        return N(1e3 * t);
    }, N.en = w[_], N.Ls = w, N.p = {}, N;
}()), $a7031b6d2b9a785f$var$J = {
    exports: {}
}, $a7031b6d2b9a785f$var$Q = $a7031b6d2b9a785f$var$z($a7031b6d2b9a785f$var$J.exports = function() {
    var t = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    }, e = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, s = /\d\d/, i = /\d\d?/, n = /\d*[^-_:/,()\s\d]+/, a = {}, o = function(t) {
        return (t = +t) + (t > 68 ? 1900 : 2e3);
    }, r = function(t) {
        return function(e) {
            this[t] = +e;
        };
    }, l = [
        /[+-]\d\d:?(\d\d)?|Z/,
        function(t) {
            (this.zone || (this.zone = {})).offset = function(t) {
                if (!t) return 0;
                if ("Z" === t) return 0;
                var e = t.match(/([+-]|\d\d)/g), s = 60 * e[1] + (+e[2] || 0);
                return 0 === s ? 0 : "+" === e[0] ? -s : s;
            }(t);
        }
    ], d = function(t) {
        var e = a[t];
        return e && (e.indexOf ? e : e.s.concat(e.f));
    }, c = function(t, e) {
        var s, i = a.meridiem;
        if (i) {
            for(var n = 1; n <= 24; n += 1)if (t.indexOf(i(n, 0, e)) > -1) {
                s = n > 12;
                break;
            }
        } else s = t === (e ? "pm" : "PM");
        return s;
    }, h = {
        A: [
            n,
            function(t) {
                this.afternoon = c(t, !1);
            }
        ],
        a: [
            n,
            function(t) {
                this.afternoon = c(t, !0);
            }
        ],
        S: [
            /\d/,
            function(t) {
                this.milliseconds = 100 * +t;
            }
        ],
        SS: [
            s,
            function(t) {
                this.milliseconds = 10 * +t;
            }
        ],
        SSS: [
            /\d{3}/,
            function(t) {
                this.milliseconds = +t;
            }
        ],
        s: [
            i,
            r("seconds")
        ],
        ss: [
            i,
            r("seconds")
        ],
        m: [
            i,
            r("minutes")
        ],
        mm: [
            i,
            r("minutes")
        ],
        H: [
            i,
            r("hours")
        ],
        h: [
            i,
            r("hours")
        ],
        HH: [
            i,
            r("hours")
        ],
        hh: [
            i,
            r("hours")
        ],
        D: [
            i,
            r("day")
        ],
        DD: [
            s,
            r("day")
        ],
        Do: [
            n,
            function(t) {
                var e = a.ordinal, s = t.match(/\d+/);
                if (this.day = s[0], e) for(var i = 1; i <= 31; i += 1)e(i).replace(/\[|\]/g, "") === t && (this.day = i);
            }
        ],
        M: [
            i,
            r("month")
        ],
        MM: [
            s,
            r("month")
        ],
        MMM: [
            n,
            function(t) {
                var e = d("months"), s = (d("monthsShort") || e.map(function(t) {
                    return t.slice(0, 3);
                })).indexOf(t) + 1;
                if (s < 1) throw new Error;
                this.month = s % 12 || s;
            }
        ],
        MMMM: [
            n,
            function(t) {
                var e = d("months").indexOf(t) + 1;
                if (e < 1) throw new Error;
                this.month = e % 12 || e;
            }
        ],
        Y: [
            /[+-]?\d+/,
            r("year")
        ],
        YY: [
            s,
            function(t) {
                this.year = o(t);
            }
        ],
        YYYY: [
            /\d{4}/,
            r("year")
        ],
        Z: l,
        ZZ: l
    };
    function u(s) {
        var i, n;
        i = s, n = a && a.formats;
        for(var o = (s = i.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(e, s, i) {
            var a = i && i.toUpperCase();
            return s || n[i] || t[i] || n[a].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(t, e, s) {
                return e || s.slice(1);
            });
        })).match(e), r = o.length, l = 0; l < r; l += 1){
            var d = o[l], c = h[d], u = c && c[0], p = c && c[1];
            o[l] = p ? {
                regex: u,
                parser: p
            } : d.replace(/^\[|\]$/g, "");
        }
        return function(t) {
            for(var e = {}, s = 0, i = 0; s < r; s += 1){
                var n = o[s];
                if ("string" == typeof n) i += n.length;
                else {
                    var a = n.regex, l = n.parser, d = t.slice(i), c = a.exec(d)[0];
                    l.call(e, c), t = t.replace(c, "");
                }
            }
            return function(t) {
                var e = t.afternoon;
                if (void 0 !== e) {
                    var s = t.hours;
                    e ? s < 12 && (t.hours += 12) : 12 === s && (t.hours = 0), delete t.afternoon;
                }
            }(e), e;
        };
    }
    return function(t, e, s) {
        s.p.customParseFormat = !0, t && t.parseTwoDigitYear && (o = t.parseTwoDigitYear);
        var i = e.prototype, n = i.parse;
        i.parse = function(t) {
            var e = t.date, i = t.utc, o = t.args;
            this.$u = i;
            var r = o[1];
            if ("string" == typeof r) {
                var l = !0 === o[2], d = !0 === o[3], c = l || d, h = o[2];
                d && (h = o[2]), a = this.$locale(), !l && h && (a = s.Ls[h]), this.$d = function(t, e, s) {
                    try {
                        if ([
                            "x",
                            "X"
                        ].indexOf(e) > -1) return new Date(("X" === e ? 1e3 : 1) * t);
                        var i = u(e)(t), n = i.year, a = i.month, o = i.day, r = i.hours, l = i.minutes, d = i.seconds, c = i.milliseconds, h = i.zone, p = new Date, f = o || (n || a ? 1 : p.getDate()), m = n || p.getFullYear(), g = 0;
                        n && !a || (g = a > 0 ? a - 1 : p.getMonth());
                        var b = r || 0, v = l || 0, _ = d || 0, w = c || 0;
                        return h ? new Date(Date.UTC(m, g, f, b, v, _, w + 60 * h.offset * 1e3)) : s ? new Date(Date.UTC(m, g, f, b, v, _, w)) : new Date(m, g, f, b, v, _, w);
                    } catch (t) {
                        return new Date("");
                    }
                }(e, r, i), this.init(), h && !0 !== h && (this.$L = this.locale(h).$L), c && e != this.format(r) && (this.$d = new Date("")), a = {};
            } else if (r instanceof Array) for(var p = r.length, f = 1; f <= p; f += 1){
                o[1] = r[f - 1];
                var m = s.apply(this, o);
                if (m.isValid()) {
                    this.$d = m.$d, this.$L = m.$L, this.init();
                    break;
                }
                f === p && (this.$d = new Date(""));
            }
            else n.call(this, t);
        };
    };
}());
$a7031b6d2b9a785f$var$W.extend($a7031b6d2b9a785f$var$Q);
const $a7031b6d2b9a785f$var$X = (t, e)=>{
    let s;
    if (e) switch(e){
        case "ISO_8601":
            s = t;
            break;
        case "RFC_2822":
            s = $a7031b6d2b9a785f$var$W(t.slice(5), "DD MMM YYYY HH:mm:ss ZZ").unix();
            break;
        case "MYSQL":
            s = $a7031b6d2b9a785f$var$W(t, "YYYY-MM-DD hh:mm:ss").unix();
            break;
        case "UNIX":
            s = $a7031b6d2b9a785f$var$W(t).unix();
            break;
        default:
            s = $a7031b6d2b9a785f$var$W(t, e, !0).valueOf();
    }
    return s;
}, $a7031b6d2b9a785f$var$Z = (t, e)=>{
    if (t?.constructor === Object && Object.prototype.hasOwnProperty.call(t, "data") && !Object.keys(t).find((t)=>![
            "text",
            "order",
            "data",
            "attributes"
        ].includes(t))) return t;
    const s = {
        data: t
    };
    switch(e.type){
        case "string":
            "string" != typeof t && (s.text = String(s.data), s.order = s.text);
            break;
        case "date":
            e.format && (s.order = $a7031b6d2b9a785f$var$X(String(s.data), e.format));
            break;
        case "number":
            s.text = String(s.data), s.data = parseFloat(s.data), s.order = s.data;
            break;
        case "html":
            {
                const t = Array.isArray(s.data) ? {
                    nodeName: "TD",
                    childNodes: s.data
                } : $a7031b6d2b9a785f$var$I(`<td>${String(s.data)}</td>`);
                s.data = t.childNodes || [];
                const e = $a7031b6d2b9a785f$var$i(t);
                s.text = e, s.order = e;
                break;
            }
        case "boolean":
            "string" == typeof s.data && (s.data = s.data.toLowerCase().trim()), s.data = ![
                "false",
                !1,
                null,
                void 0,
                0
            ].includes(s.data), s.order = s.data ? 1 : 0, s.text = String(s.data);
            break;
        case "other":
            s.text = "", s.order = 0;
            break;
        default:
            s.text = JSON.stringify(s.data);
    }
    return s;
}, $a7031b6d2b9a785f$var$G = (t)=>{
    if (t instanceof Object && t.constructor === Object && t.hasOwnProperty("data") && ("string" == typeof t.text || "string" == typeof t.data)) return t;
    const e = {
        data: t
    };
    if ("string" == typeof t) {
        if (t.length) {
            const s = $a7031b6d2b9a785f$var$I(`<th>${t}</th>`);
            if (s.childNodes && (1 !== s.childNodes.length || "#text" !== s.childNodes[0].nodeName)) {
                e.data = s.childNodes, e.type = "html";
                const t = $a7031b6d2b9a785f$var$i(s);
                e.text = t;
            }
        }
    } else [
        null,
        void 0
    ].includes(t) ? e.text = "" : e.text = JSON.stringify(t);
    return e;
}, $a7031b6d2b9a785f$var$K = (t, e, s, n, a)=>{
    const o = {
        data: [],
        headings: []
    };
    if (t.headings) o.headings = t.headings.map((t)=>$a7031b6d2b9a785f$var$G(t));
    else if (e?.tHead) o.headings = Array.from(e.tHead.querySelectorAll("th")).map((t, e)=>{
        const o = ((t)=>{
            const e = $a7031b6d2b9a785f$var$T(t, {
                valueDiffing: !1
            });
            let s;
            return s = !e.childNodes || 1 === e.childNodes.length && "#text" === e.childNodes[0].nodeName ? {
                data: t.innerText,
                type: "string"
            } : {
                data: e.childNodes,
                type: "html",
                text: $a7031b6d2b9a785f$var$i(e)
            }, s.attributes = e.attributes, s;
        })(t);
        s[e] || (s[e] = {
            type: n,
            format: a,
            searchable: !0,
            sortable: !0
        });
        const r = s[e];
        return "false" !== t.dataset.sortable?.trim().toLowerCase() && "false" !== t.dataset.sort?.trim().toLowerCase() || (r.sortable = !1), "false" === t.dataset.searchable?.trim().toLowerCase() && (r.searchable = !1), "true" !== t.dataset.hidden?.trim().toLowerCase() && "true" !== t.getAttribute("hidden")?.trim().toLowerCase() || (r.hidden = !0), [
            "number",
            "string",
            "html",
            "date",
            "boolean",
            "other"
        ].includes(t.dataset.type) && (r.type = t.dataset.type, "date" === r.type && t.dataset.format && (r.format = t.dataset.format)), o;
    });
    else if (t.data?.length) {
        const e = t.data[0], s = Array.isArray(e) ? e : e.cells;
        o.headings = s.map((t)=>$a7031b6d2b9a785f$var$G(""));
    } else e?.tBodies.length && (o.headings = Array.from(e.tBodies[0].rows[0].cells).map((t)=>$a7031b6d2b9a785f$var$G("")));
    for(let t = 0; t < o.headings.length; t++)s[t] || (s[t] = {
        type: n,
        format: a,
        sortable: !0,
        searchable: !0
    });
    if (t.data) {
        const e = o.headings.map((t)=>t.data ? String(t.data) : t.text);
        o.data = t.data.map((t)=>{
            let i, n;
            return Array.isArray(t) ? (i = {}, n = t) : t.hasOwnProperty("cells") && Object.keys(t).every((t)=>[
                    "cells",
                    "attributes"
                ].includes(t)) ? (i = t.attributes, n = t.cells) : (i = {}, n = [], Object.entries(t).forEach(([t, s])=>{
                const i = e.indexOf(t);
                i > -1 && (n[i] = s);
            })), {
                attributes: i,
                cells: n.map((t, e)=>$a7031b6d2b9a785f$var$Z(t, s[e]))
            };
        });
    } else e?.tBodies?.length && (o.data = Array.from(e.tBodies[0].rows).map((t)=>({
            attributes: $a7031b6d2b9a785f$var$r(t.attributes),
            cells: Array.from(t.cells).map((t, e)=>{
                const i = t.dataset.content ? $a7031b6d2b9a785f$var$Z(t.dataset.content, s[e]) : ((t, e)=>{
                    let s;
                    switch(e.type){
                        case "string":
                            s = {
                                data: t.innerText
                            };
                            break;
                        case "date":
                            {
                                const i = t.innerText;
                                s = {
                                    data: i,
                                    order: $a7031b6d2b9a785f$var$X(i, e.format)
                                };
                                break;
                            }
                        case "number":
                            {
                                const e = parseFloat(t.innerText);
                                s = {
                                    data: e,
                                    order: e,
                                    text: t.innerText
                                };
                                break;
                            }
                        case "boolean":
                            {
                                const e = ![
                                    "false",
                                    "0",
                                    "null",
                                    "undefined"
                                ].includes(t.innerText.toLowerCase().trim());
                                s = {
                                    data: e,
                                    text: e ? "1" : "0",
                                    order: e ? 1 : 0
                                };
                                break;
                            }
                        default:
                            s = {
                                data: $a7031b6d2b9a785f$var$T(t, {
                                    valueDiffing: !1
                                }).childNodes || [],
                                text: t.innerText,
                                order: t.innerText
                            };
                    }
                    return s.attributes = $a7031b6d2b9a785f$var$r(t.attributes), s;
                })(t, s[e]);
                return t.dataset.order && (i.order = isNaN(parseFloat(t.dataset.order)) ? t.dataset.order : parseFloat(t.dataset.order)), i;
            })
        })));
    if (o.data.length && o.data[0].cells.length !== o.headings.length) throw new Error("Data heading length mismatch.");
    return o;
};
class $a7031b6d2b9a785f$var$tt {
    cursor;
    dt;
    constructor(t){
        this.dt = t, this.cursor = !1;
    }
    setCursor(t = !1) {
        if (t === this.cursor) return;
        const e = this.cursor;
        if (this.cursor = t, this.dt._renderTable(), !1 !== t && this.dt.options.scrollY) {
            const t = $a7031b6d2b9a785f$var$l(this.dt.options.classes.cursor), e = this.dt.dom.querySelector(`tr${t}`);
            e && e.scrollIntoView({
                block: "nearest"
            });
        }
        this.dt.emit("datatable.cursormove", this.cursor, e);
    }
    add(t) {
        if (!Array.isArray(t) || t.length < 1) return;
        const e = {
            cells: t.map((t, e)=>{
                const s = this.dt.columns.settings[e];
                return $a7031b6d2b9a785f$var$Z(t, s);
            })
        };
        this.dt.data.data.push(e), this.dt.hasRows = !0, this.dt.update(!0);
    }
    remove(t) {
        if (!Array.isArray(t)) return this.remove([
            t
        ]);
        this.dt.data.data = this.dt.data.data.filter((e, s)=>!t.includes(s)), this.dt.data.data.length || (this.dt.hasRows = !1), this.dt.update(!0);
    }
    findRowIndex(t, e) {
        return this.dt.data.data.findIndex((s)=>{
            const i = s.cells[t];
            return $a7031b6d2b9a785f$var$n(i).toLowerCase().includes(String(e).toLowerCase());
        });
    }
    findRow(t, e) {
        const s = this.findRowIndex(t, e);
        if (s < 0) return {
            index: -1,
            row: null,
            cols: []
        };
        const i = this.dt.data.data[s], n = i.cells.map((t)=>t.data);
        return {
            index: s,
            row: i,
            cols: n
        };
    }
    updateRow(t, e) {
        const s = {
            cells: e.map((t, e)=>{
                const s = this.dt.columns.settings[e];
                return $a7031b6d2b9a785f$var$Z(t, s);
            })
        };
        this.dt.data.data.splice(t, 1, s), this.dt.update(!0);
    }
}
class $a7031b6d2b9a785f$var$et {
    dt;
    settings;
    _state;
    constructor(t){
        this.dt = t, this.init();
    }
    init() {
        [this.settings, this._state] = ((t = [], e, s)=>{
            let i = [], n = !1;
            const a = [];
            return t.forEach((t)=>{
                (Array.isArray(t.select) ? t.select : [
                    t.select
                ]).forEach((o)=>{
                    i[o] ? t.type && (i[o].type = t.type) : i[o] = {
                        type: t.type || e,
                        sortable: !0,
                        searchable: !0
                    };
                    const r = i[o];
                    t.render && (r.render = t.render), t.format ? r.format = t.format : "date" === t.type && (r.format = s), t.cellClass && (r.cellClass = t.cellClass), t.headerClass && (r.headerClass = t.headerClass), t.locale && (r.locale = t.locale), !1 === t.sortable ? r.sortable = !1 : (t.numeric && (r.numeric = t.numeric), t.caseFirst && (r.caseFirst = t.caseFirst)), !1 === t.searchable ? r.searchable = !1 : t.sensitivity && (r.sensitivity = t.sensitivity), (r.searchable || r.sortable) && void 0 !== t.ignorePunctuation && (r.ignorePunctuation = t.ignorePunctuation), t.searchMethod && (r.searchMethod = t.searchMethod), t.hidden && (r.hidden = !0), t.filter && (r.filter = t.filter), t.sortSequence && (r.sortSequence = t.sortSequence), t.sort && (t.filter ? a[o] = t.sort : n = {
                        column: o,
                        dir: t.sort
                    }), void 0 !== t.searchItemSeparator && (r.searchItemSeparator = t.searchItemSeparator);
                });
            }), i = i.map((t)=>t || {
                    type: e,
                    format: "date" === e ? s : void 0,
                    sortable: !0,
                    searchable: !0
                }), [
                i,
                {
                    filters: a,
                    sort: n,
                    widths: []
                }
            ];
        })(this.dt.options.columns, this.dt.options.type, this.dt.options.format);
    }
    get(t) {
        return t < 0 || t >= this.size() ? null : {
            ...this.settings[t]
        };
    }
    size() {
        return this.settings.length;
    }
    swap(t) {
        if (2 === t.length) {
            const e = this.dt.data.headings.map((t, e)=>e), s = t[0], i = t[1], n = e[i];
            return e[i] = e[s], e[s] = n, this.order(e);
        }
    }
    order(t) {
        this.dt.data.headings = t.map((t)=>this.dt.data.headings[t]), this.dt.data.data.forEach((e)=>e.cells = t.map((t)=>e.cells[t])), this.settings = t.map((t)=>this.settings[t]), this.dt.update();
    }
    hide(t) {
        Array.isArray(t) || (t = [
            t
        ]), t.length && (t.forEach((t)=>{
            this.settings[t] || (this.settings[t] = {
                type: "string"
            });
            this.settings[t].hidden = !0;
        }), this.dt.update());
    }
    show(t) {
        Array.isArray(t) || (t = [
            t
        ]), t.length && (t.forEach((t)=>{
            this.settings[t] || (this.settings[t] = {
                type: "string",
                sortable: !0
            });
            delete this.settings[t].hidden;
        }), this.dt.update());
    }
    visible(t) {
        return void 0 === t && (t = [
            ...Array(this.dt.data.headings.length).keys()
        ]), Array.isArray(t) ? t.map((t)=>!this.settings[t]?.hidden) : !this.settings[t]?.hidden;
    }
    add(t) {
        const e = this.dt.data.headings.length;
        if (this.dt.data.headings = this.dt.data.headings.concat([
            $a7031b6d2b9a785f$var$G(t.heading)
        ]), this.dt.data.data.forEach((e, s)=>{
            e.cells = e.cells.concat([
                $a7031b6d2b9a785f$var$Z(t.data[s], t)
            ]);
        }), this.settings[e] = {
            type: t.type || "string",
            sortable: !0,
            searchable: !0
        }, t.type || t.format || t.sortable || t.render || t.filter) {
            const s = this.settings[e];
            t.render && (s.render = t.render), t.format && (s.format = t.format), t.cellClass && (s.cellClass = t.cellClass), t.headerClass && (s.headerClass = t.headerClass), t.locale && (s.locale = t.locale), !1 === t.sortable ? s.sortable = !1 : (t.numeric && (s.numeric = t.numeric), t.caseFirst && (s.caseFirst = t.caseFirst)), !1 === t.searchable ? s.searchable = !1 : t.sensitivity && (s.sensitivity = t.sensitivity), (s.searchable || s.sortable) && t.ignorePunctuation && (s.ignorePunctuation = t.ignorePunctuation), t.hidden && (s.hidden = !0), t.filter && (s.filter = t.filter), t.sortSequence && (s.sortSequence = t.sortSequence);
        }
        this.dt.update(!0);
    }
    remove(t) {
        Array.isArray(t) || (t = [
            t
        ]), this.dt.data.headings = this.dt.data.headings.filter((e, s)=>!t.includes(s)), this.dt.data.data.forEach((e)=>e.cells = e.cells.filter((e, s)=>!t.includes(s))), this.dt.update(!0);
    }
    filter(t, e = !1) {
        if (!this.settings[t]?.filter?.length) return;
        const s = this._state.filters[t];
        let i;
        if (s) {
            let e = !1;
            i = this.settings[t].filter.find((t)=>!!e || (t === s && (e = !0), !1));
        } else {
            const e = this.settings[t].filter;
            i = e ? e[0] : void 0;
        }
        i ? this._state.filters[t] = i : s && (this._state.filters[t] = void 0), this.dt._currentPage = 1, this.dt.update(), e || this.dt.emit("datatable.filter", t, i);
    }
    sort(t, e, s = !1) {
        const i = this.settings[t];
        if (s || this.dt.emit("datatable.sorting", t, e), !e) {
            const s = !(!this._state.sort || this._state.sort.column !== t) && this._state.sort?.dir, n = i?.sortSequence || [
                "asc",
                "desc"
            ];
            if (s) {
                const t = n.indexOf(s);
                e = -1 === t ? n[0] || "asc" : t === n.length - 1 ? n[0] : n[t + 1];
            } else e = n.length ? n[0] : "asc";
        }
        const a = !![
            "string",
            "html"
        ].includes(i.type) && new Intl.Collator(i.locale || this.dt.options.locale, {
            usage: "sort",
            numeric: i.numeric || this.dt.options.numeric,
            caseFirst: i.caseFirst || this.dt.options.caseFirst,
            ignorePunctuation: i.ignorePunctuation || this.dt.options.ignorePunctuation
        });
        this.dt.data.data.sort((s, i)=>{
            const o = s.cells[t], r = i.cells[t];
            let l = o.order ?? $a7031b6d2b9a785f$var$n(o), d = r.order ?? $a7031b6d2b9a785f$var$n(r);
            if ("desc" === e) {
                const t = l;
                l = d, d = t;
            }
            return a && "number" != typeof l && "number" != typeof d ? a.compare(String(l), String(d)) : l < d ? -1 : l > d ? 1 : 0;
        }), this._state.sort = {
            column: t,
            dir: e
        }, this.dt._searchQueries.length ? (this.dt.multiSearch(this.dt._searchQueries), this.dt.emit("datatable.sort", t, e)) : s || (this.dt._currentPage = 1, this.dt.update(), this.dt.emit("datatable.sort", t, e));
    }
    _measureWidths() {
        const t = this.dt.data.headings.filter((t, e)=>!this.settings[e]?.hidden);
        if ((this.dt.options.scrollY.length || this.dt.options.fixedColumns) && t?.length) {
            this._state.widths = [];
            const t = {
                noPaging: !0
            };
            if (this.dt.options.header || this.dt.options.footer) {
                this.dt.options.scrollY.length && (t.unhideHeader = !0), this.dt.headerDOM && this.dt.headerDOM.parentElement.removeChild(this.dt.headerDOM), t.noColumnWidths = !0, this.dt._renderTable(t);
                const e = Array.from(this.dt.dom.querySelector("thead, tfoot")?.firstElementChild?.querySelectorAll("th") || []);
                let s = 0;
                const i = this.dt.data.headings.map((t, i)=>{
                    if (this.settings[i]?.hidden) return 0;
                    const n = e[s].offsetWidth;
                    return s += 1, n;
                }), n = i.reduce((t, e)=>t + e, 0);
                this._state.widths = i.map((t)=>t / n * 100);
            } else {
                t.renderHeader = !0, this.dt._renderTable(t);
                const e = Array.from(this.dt.dom.querySelector("thead, tfoot")?.firstElementChild?.querySelectorAll("th") || []);
                let s = 0;
                const i = this.dt.data.headings.map((t, i)=>{
                    if (this.settings[i]?.hidden) return 0;
                    const n = e[s].offsetWidth;
                    return s += 1, n;
                }), n = i.reduce((t, e)=>t + e, 0);
                this._state.widths = i.map((t)=>t / n * 100);
            }
            this.dt._renderTable();
        }
    }
}
const $a7031b6d2b9a785f$var$st = {
    sortable: !0,
    locale: "en",
    numeric: !0,
    caseFirst: "false",
    searchable: !0,
    sensitivity: "base",
    ignorePunctuation: !0,
    destroyable: !0,
    searchItemSeparator: "",
    searchQuerySeparator: " ",
    searchAnd: !1,
    searchMethod: !1,
    data: {},
    type: "html",
    format: "YYYY-MM-DD",
    columns: [],
    paging: !0,
    perPage: 10,
    perPageSelect: [
        5,
        10,
        15,
        20,
        25
    ],
    nextPrev: !0,
    firstLast: !1,
    prevText: "\u2039",
    nextText: "\u203A",
    firstText: "\xab",
    lastText: "\xbb",
    ellipsisText: "\u2026",
    truncatePager: !0,
    pagerDelta: 2,
    scrollY: "",
    fixedColumns: !0,
    fixedHeight: !1,
    footer: !1,
    header: !0,
    hiddenHeader: !1,
    caption: void 0,
    rowNavigation: !1,
    rowSelectionKeys: [
        "Enter",
        " "
    ],
    tabIndex: !1,
    pagerRender: !1,
    rowRender: !1,
    tableRender: !1,
    diffDomOptions: {
        valueDiffing: !1
    },
    labels: {
        placeholder: "Search...",
        searchTitle: "Search within table",
        perPage: "entries per page",
        pageTitle: "Page {page}",
        noRows: "No entries found",
        noResults: "No results match your search query",
        info: "Showing {start} to {end} of {rows} entries"
    },
    template: (t, e)=>`<div class='${t.classes.top}'>\n    ${t.paging && t.perPageSelect ? `<div class='${t.classes.dropdown}'>\n            <label>\n                <select class='${t.classes.selector}' name="per-page"></select> ${t.labels.perPage}\n            </label>\n        </div>` : ""}\n    ${t.searchable ? `<div class='${t.classes.search}'>\n            <input class='${t.classes.input}' placeholder='${t.labels.placeholder}' type='search' name="search" title='${t.labels.searchTitle}'${e.id ? ` aria-controls="${e.id}"` : ""}>\n        </div>` : ""}\n</div>\n<div class='${t.classes.container}'${t.scrollY.length ? ` style='height: ${t.scrollY}; overflow-Y: auto;'` : ""}></div>\n<div class='${t.classes.bottom}'>\n    ${t.paging ? `<div class='${t.classes.info}'></div>` : ""}\n    <nav class='${t.classes.pagination}'></nav>\n</div>`,
    classes: {
        active: "datatable-active",
        ascending: "datatable-ascending",
        bottom: "datatable-bottom",
        container: "datatable-container",
        cursor: "datatable-cursor",
        descending: "datatable-descending",
        disabled: "datatable-disabled",
        dropdown: "datatable-dropdown",
        ellipsis: "datatable-ellipsis",
        filter: "datatable-filter",
        filterActive: "datatable-filter-active",
        empty: "datatable-empty",
        headercontainer: "datatable-headercontainer",
        hidden: "datatable-hidden",
        info: "datatable-info",
        input: "datatable-input",
        loading: "datatable-loading",
        pagination: "datatable-pagination",
        paginationList: "datatable-pagination-list",
        paginationListItem: "datatable-pagination-list-item",
        paginationListItemLink: "datatable-pagination-list-item-link",
        search: "datatable-search",
        selector: "datatable-selector",
        sorter: "datatable-sorter",
        table: "datatable-table",
        top: "datatable-top",
        wrapper: "datatable-wrapper"
    }
}, $a7031b6d2b9a785f$var$it = (t, e, s, i = {})=>({
        nodeName: "LI",
        attributes: {
            class: i.active && !i.hidden ? `${s.classes.paginationListItem} ${s.classes.active}` : i.hidden ? `${s.classes.paginationListItem} ${s.classes.hidden} ${s.classes.disabled}` : s.classes.paginationListItem
        },
        childNodes: [
            {
                nodeName: "BUTTON",
                attributes: {
                    "data-page": String(t),
                    class: s.classes.paginationListItemLink,
                    "aria-label": s.labels.pageTitle.replace("{page}", String(t))
                },
                childNodes: [
                    {
                        nodeName: "#text",
                        data: e
                    }
                ]
            }
        ]
    }), $a7031b6d2b9a785f$var$nt = (t, e, s, i, n)=>{
    let a = [];
    if (n.firstLast && a.push($a7031b6d2b9a785f$var$it(1, n.firstText, n)), n.nextPrev) {
        const e = t ? 1 : s - 1;
        a.push($a7031b6d2b9a785f$var$it(e, n.prevText, n, {
            hidden: t
        }));
    }
    let o = [
        ...Array(i).keys()
    ].map((t)=>$a7031b6d2b9a785f$var$it(t + 1, String(t + 1), n, {
            active: t === s - 1
        }));
    if (n.truncatePager && (o = ((t, e, s, i)=>{
        const n = i.pagerDelta, a = i.classes, o = i.ellipsisText, r = 2 * n;
        let l = e - n, d = e + n;
        e < 4 - n + r ? d = 3 + r : e > s - (3 - n + r) && (l = s - (2 + r));
        const c = [];
        for(let e = 1; e <= s; e++)if (1 == e || e == s || e >= l && e <= d) {
            const s = t[e - 1];
            c.push(s);
        }
        let h;
        const u = [];
        return c.forEach((e)=>{
            const s = parseInt(e.childNodes[0].attributes["data-page"], 10);
            if (h) {
                const e = parseInt(h.childNodes[0].attributes["data-page"], 10);
                if (s - e == 2) u.push(t[e]);
                else if (s - e != 1) {
                    const t = {
                        nodeName: "LI",
                        attributes: {
                            class: `${a.paginationListItem} ${a.ellipsis} ${a.disabled}`
                        },
                        childNodes: [
                            {
                                nodeName: "BUTTON",
                                attributes: {
                                    class: a.paginationListItemLink
                                },
                                childNodes: [
                                    {
                                        nodeName: "#text",
                                        data: o
                                    }
                                ]
                            }
                        ]
                    };
                    u.push(t);
                }
            }
            u.push(e), h = e;
        }), u;
    })(o, s, i, n)), a = a.concat(o), n.nextPrev) {
        const t = e ? i : s + 1;
        a.push($a7031b6d2b9a785f$var$it(t, n.nextText, n, {
            hidden: e
        }));
    }
    n.firstLast && a.push($a7031b6d2b9a785f$var$it(i, n.lastText, n));
    return {
        nodeName: "UL",
        attributes: {
            class: n.classes.paginationList
        },
        childNodes: o.length > 1 ? a : []
    };
};
class $a7031b6d2b9a785f$export$df30df7ec97b32b5 {
    columns;
    containerDOM;
    _currentPage;
    data;
    _dd;
    dom;
    _events;
    hasHeadings;
    hasRows;
    headerDOM;
    _initialHTML;
    initialized;
    _label;
    lastPage;
    _listeners;
    onFirstPage;
    onLastPage;
    options;
    _pagerDOMs;
    _virtualPagerDOM;
    pages;
    _rect;
    rows;
    _searchData;
    _searchQueries;
    _tableAttributes;
    _tableFooters;
    _tableCaptions;
    totalPages;
    _virtualDOM;
    _virtualHeaderDOM;
    wrapperDOM;
    constructor(t, e = {}){
        const s = "string" == typeof t ? document.querySelector(t) : t;
        s instanceof HTMLTableElement ? this.dom = s : (this.dom = document.createElement("table"), s.appendChild(this.dom));
        const i = {
            ...$a7031b6d2b9a785f$var$st.diffDomOptions,
            ...e.diffDomOptions
        }, n = {
            ...$a7031b6d2b9a785f$var$st.labels,
            ...e.labels
        }, a = {
            ...$a7031b6d2b9a785f$var$st.classes,
            ...e.classes
        };
        this.options = {
            ...$a7031b6d2b9a785f$var$st,
            ...e,
            diffDomOptions: i,
            labels: n,
            classes: a
        }, this._initialHTML = this.options.destroyable ? s.outerHTML : "", this.options.tabIndex ? this.dom.tabIndex = this.options.tabIndex : this.options.rowNavigation && -1 === this.dom.tabIndex && (this.dom.tabIndex = 0), this._listeners = {
            onResize: ()=>this._onResize()
        }, this._dd = new $a7031b6d2b9a785f$var$F(this.options.diffDomOptions || {}), this.initialized = !1, this._events = {}, this._currentPage = 0, this.onFirstPage = !0, this.hasHeadings = !1, this.hasRows = !1, this._searchQueries = [], this.init();
    }
    init() {
        if (this.initialized || $a7031b6d2b9a785f$var$d(this.dom, this.options.classes.table)) return !1;
        this._virtualDOM = $a7031b6d2b9a785f$var$T(this.dom, this.options.diffDomOptions || {}), this._tableAttributes = {
            ...this._virtualDOM.attributes
        }, this._tableFooters = this._virtualDOM.childNodes?.filter((t)=>"TFOOT" === t.nodeName) ?? [], this._tableCaptions = this._virtualDOM.childNodes?.filter((t)=>"CAPTION" === t.nodeName) ?? [], void 0 !== this.options.caption && this._tableCaptions.push({
            nodeName: "CAPTION",
            childNodes: [
                {
                    nodeName: "#text",
                    data: this.options.caption
                }
            ]
        }), this.rows = new $a7031b6d2b9a785f$var$tt(this), this.columns = new $a7031b6d2b9a785f$var$et(this), this.data = $a7031b6d2b9a785f$var$K(this.options.data, this.dom, this.columns.settings, this.options.type, this.options.format), this._render(), setTimeout(()=>{
            this.emit("datatable.init"), this.initialized = !0;
        }, 10);
    }
    _render() {
        this.wrapperDOM = $a7031b6d2b9a785f$export$c8a8987d4410bf2d("div", {
            class: `${this.options.classes.wrapper} ${this.options.classes.loading}`
        }), this.wrapperDOM.innerHTML = this.options.template(this.options, this.dom);
        const t = $a7031b6d2b9a785f$var$l(this.options.classes.selector), e = this.wrapperDOM.querySelector(`select${t}`);
        e && this.options.paging && this.options.perPageSelect ? this.options.perPageSelect.forEach((t)=>{
            const [s, i] = Array.isArray(t) ? [
                t[0],
                t[1]
            ] : [
                String(t),
                t
            ], n = i === this.options.perPage, a = new Option(s, String(i), n, n);
            e.appendChild(a);
        }) : e && e.parentElement.removeChild(e);
        const i = $a7031b6d2b9a785f$var$l(this.options.classes.container);
        this.containerDOM = this.wrapperDOM.querySelector(i), this._pagerDOMs = [];
        const n = $a7031b6d2b9a785f$var$l(this.options.classes.pagination);
        Array.from(this.wrapperDOM.querySelectorAll(n)).forEach((t)=>{
            t instanceof HTMLElement && (t.innerHTML = `<ul class="${this.options.classes.paginationList}"></ul>`, this._pagerDOMs.push(t.firstElementChild));
        }), this._virtualPagerDOM = {
            nodeName: "UL",
            attributes: {
                class: this.options.classes.paginationList
            }
        };
        const a = $a7031b6d2b9a785f$var$l(this.options.classes.info);
        this._label = this.wrapperDOM.querySelector(a), this.dom.parentElement.replaceChild(this.wrapperDOM, this.dom), this.containerDOM.appendChild(this.dom), this._rect = this.dom.getBoundingClientRect(), this._fixHeight(), this.options.header || this.wrapperDOM.classList.add("no-header"), this.options.footer || this.wrapperDOM.classList.add("no-footer"), this.options.sortable && this.wrapperDOM.classList.add("sortable"), this.options.searchable && this.wrapperDOM.classList.add("searchable"), this.options.fixedHeight && this.wrapperDOM.classList.add("fixed-height"), this.options.fixedColumns && this.wrapperDOM.classList.add("fixed-columns"), this._bindEvents(), this.columns._state.sort && this.columns.sort(this.columns._state.sort.column, this.columns._state.sort.dir, !0), this.update(!0);
    }
    _renderTable(t = {}) {
        let e;
        e = (this.options.paging || this._searchQueries.length || this.columns._state.filters.length) && this._currentPage && this.pages.length && !t.noPaging ? this.pages[this._currentPage - 1] : this.data.data.map((t, e)=>({
                row: t,
                index: e
            }));
        let s = $a7031b6d2b9a785f$var$B(this._tableAttributes, this.data.headings, e, this.columns.settings, this.columns._state, this.rows.cursor, this.options, t, this._tableFooters, this._tableCaptions);
        if (this.options.tableRender) {
            const t = this.options.tableRender(this.data, s, "main");
            t && (s = t);
        }
        const i = this._dd.diff(this._virtualDOM, s);
        this._dd.apply(this.dom, i), this._virtualDOM = s;
    }
    _renderPage(t = !1) {
        this.hasRows && this.totalPages ? (this._currentPage > this.totalPages && (this._currentPage = 1), this._renderTable(), this.onFirstPage = 1 === this._currentPage, this.onLastPage = this._currentPage === this.lastPage) : this.setMessage(this.options.labels.noRows);
        let e, s = 0, i = 0, n = 0;
        if (this.totalPages && (s = this._currentPage - 1, i = s * this.options.perPage, n = i + this.pages[s].length, i += 1, e = this._searchQueries.length ? this._searchData.length : this.data.data.length), this._label && this.options.labels.info.length) {
            const t = this.options.labels.info.replace("{start}", String(i)).replace("{end}", String(n)).replace("{page}", String(this._currentPage)).replace("{pages}", String(this.totalPages)).replace("{rows}", String(e));
            this._label.innerHTML = e ? t : "";
        }
        if (1 == this._currentPage && this._fixHeight(), this.options.rowNavigation && this._currentPage && (!this.rows.cursor || !this.pages[this._currentPage - 1].find((t)=>t.index === this.rows.cursor))) {
            const e = this.pages[this._currentPage - 1];
            e.length && (t ? this.rows.setCursor(e[e.length - 1].index) : this.rows.setCursor(e[0].index));
        }
    }
    _renderPagers() {
        if (!this.options.paging) return;
        let t = $a7031b6d2b9a785f$var$nt(this.onFirstPage, this.onLastPage, this._currentPage, this.totalPages, this.options);
        if (this.options.pagerRender) {
            const e = this.options.pagerRender([
                this.onFirstPage,
                this.onLastPage,
                this._currentPage,
                this.totalPages
            ], t);
            e && (t = e);
        }
        const e = this._dd.diff(this._virtualPagerDOM, t);
        this._pagerDOMs.forEach((t)=>{
            this._dd.apply(t, e);
        }), this._virtualPagerDOM = t;
    }
    _renderSeparateHeader() {
        const t = this.dom.parentElement;
        this.headerDOM || (this.headerDOM = document.createElement("div"), this._virtualHeaderDOM = {
            nodeName: "DIV"
        }), t.parentElement.insertBefore(this.headerDOM, t);
        let e = {
            nodeName: "TABLE",
            attributes: this._tableAttributes,
            childNodes: [
                {
                    nodeName: "THEAD",
                    childNodes: [
                        $a7031b6d2b9a785f$var$q(this.data.headings, this.columns.settings, this.columns._state, this.options, {
                            unhideHeader: !0
                        })
                    ]
                }
            ]
        };
        if (e.attributes.class = $a7031b6d2b9a785f$var$c(e.attributes.class, this.options.classes.table), this.options.tableRender) {
            const t = this.options.tableRender(this.data, e, "header");
            t && (e = t);
        }
        const s = {
            nodeName: "DIV",
            attributes: {
                class: this.options.classes.headercontainer
            },
            childNodes: [
                e
            ]
        }, i = this._dd.diff(this._virtualHeaderDOM, s);
        this._dd.apply(this.headerDOM, i), this._virtualHeaderDOM = s;
        const n = this.headerDOM.firstElementChild.clientWidth - this.dom.clientWidth;
        if (n) {
            const t = structuredClone(this._virtualHeaderDOM);
            t.attributes.style = `padding-right: ${n}px;`;
            const e = this._dd.diff(this._virtualHeaderDOM, t);
            this._dd.apply(this.headerDOM, e), this._virtualHeaderDOM = t;
        }
        t.scrollHeight > t.clientHeight && (t.style.overflowY = "scroll");
    }
    _bindEvents() {
        if (this.options.perPageSelect) {
            const t = $a7031b6d2b9a785f$var$l(this.options.classes.selector), e = this.wrapperDOM.querySelector(t);
            e && e instanceof HTMLSelectElement && e.addEventListener("change", ()=>{
                this.emit("datatable.perpage:before", this.options.perPage), this.options.perPage = parseInt(e.value, 10), this.update(), this._fixHeight(), this.emit("datatable.perpage", this.options.perPage);
            }, !1);
        }
        this.options.searchable && this.wrapperDOM.addEventListener("input", (t)=>{
            const e = $a7031b6d2b9a785f$var$l(this.options.classes.input), s = t.target;
            if (!(s instanceof HTMLInputElement && s.matches(e))) return;
            t.preventDefault();
            const i = [];
            if (Array.from(this.wrapperDOM.querySelectorAll(e)).filter((t)=>t.value.length).forEach((t)=>{
                const e = t.dataset.and || this.options.searchAnd, s = t.dataset.querySeparator || this.options.searchQuerySeparator ? t.value.split(this.options.searchQuerySeparator) : [
                    t.value
                ];
                e ? s.forEach((e)=>{
                    t.dataset.columns ? i.push({
                        terms: [
                            e
                        ],
                        columns: JSON.parse(t.dataset.columns)
                    }) : i.push({
                        terms: [
                            e
                        ],
                        columns: void 0
                    });
                }) : t.dataset.columns ? i.push({
                    terms: s,
                    columns: JSON.parse(t.dataset.columns)
                }) : i.push({
                    terms: s,
                    columns: void 0
                });
            }), 1 === i.length && 1 === i[0].terms.length) {
                const t = i[0];
                this.search(t.terms[0], t.columns);
            } else this.multiSearch(i);
        }), this.wrapperDOM.addEventListener("click", (t)=>{
            const e = t.target.closest("a, button");
            if (e) {
                if (e.hasAttribute("data-page")) this.page(parseInt(e.getAttribute("data-page"), 10)), t.preventDefault();
                else if ($a7031b6d2b9a785f$var$d(e, this.options.classes.sorter)) {
                    const s = Array.from(e.parentElement.parentElement.children).indexOf(e.parentElement), i = $a7031b6d2b9a785f$var$o(s, this.columns.settings);
                    this.columns.sort(i), t.preventDefault();
                } else if ($a7031b6d2b9a785f$var$d(e, this.options.classes.filter)) {
                    const s = Array.from(e.parentElement.parentElement.children).indexOf(e.parentElement), i = $a7031b6d2b9a785f$var$o(s, this.columns.settings);
                    this.columns.filter(i), t.preventDefault();
                }
            }
        }, !1), this.options.rowNavigation && this.dom.addEventListener("keydown", (t)=>{
            if ("ArrowUp" === t.key) {
                let e;
                t.preventDefault(), t.stopPropagation(), this.pages[this._currentPage - 1].find((t)=>t.index === this.rows.cursor || (e = t, !1)), e ? this.rows.setCursor(e.index) : this.onFirstPage || this.page(this._currentPage - 1, !0);
            } else if ("ArrowDown" === t.key) {
                let e;
                t.preventDefault(), t.stopPropagation();
                const s = this.pages[this._currentPage - 1].find((t)=>!!e || (t.index === this.rows.cursor && (e = !0), !1));
                s ? this.rows.setCursor(s.index) : this.onLastPage || this.page(this._currentPage + 1);
            } else this.options.rowSelectionKeys.includes(t.key) && this.emit("datatable.selectrow", this.rows.cursor, t, !0);
        }), this.dom.addEventListener("mousedown", (t)=>{
            const e = t.target;
            if (!(e instanceof Element)) return;
            const s = Array.from(this.dom.querySelectorAll("tbody > tr")).find((t)=>t.contains(e));
            s && s instanceof HTMLElement && this.emit("datatable.selectrow", parseInt(s.dataset.index, 10), t, this.dom.matches(":focus"));
        }), window.addEventListener("resize", this._listeners.onResize);
    }
    _onResize = $a7031b6d2b9a785f$var$h(()=>{
        this._rect = this.containerDOM.getBoundingClientRect(), this._rect.width && this.update(!0);
    }, 250);
    destroy() {
        if (this.options.destroyable) {
            if (this.wrapperDOM) {
                const t = this.wrapperDOM.parentElement;
                if (t) {
                    const e = $a7031b6d2b9a785f$export$c8a8987d4410bf2d("div");
                    e.innerHTML = this._initialHTML;
                    const i = e.firstElementChild;
                    t.replaceChild(i, this.wrapperDOM), this.dom = i;
                } else this.options.classes.table?.split(" ").forEach((t)=>this.wrapperDOM.classList.remove(t));
            }
            window.removeEventListener("resize", this._listeners.onResize), this.initialized = !1;
        }
    }
    update(t = !1) {
        this.emit("datatable.update:before"), t && (this.columns._measureWidths(), this.hasRows = Boolean(this.data.data.length), this.hasHeadings = Boolean(this.data.headings.length)), this.options.classes.empty?.split(" ").forEach((t)=>this.wrapperDOM.classList.remove(t)), this._paginate(), this._renderPage(), this._renderPagers(), this.options.scrollY.length && this._renderSeparateHeader(), this.emit("datatable.update");
    }
    _paginate() {
        let t = this.data.data.map((t, e)=>({
                row: t,
                index: e
            }));
        return this._searchQueries.length && (t = [], this._searchData.forEach((e)=>t.push({
                index: e,
                row: this.data.data[e]
            }))), this.columns._state.filters.length && this.columns._state.filters.forEach((e, s)=>{
            e && (t = t.filter((t)=>{
                const i = t.row.cells[s];
                return "function" == typeof e ? e(i.data) : $a7031b6d2b9a785f$var$n(i) === e;
            }));
        }), this.options.paging && this.options.perPage > 0 ? this.pages = t.map((e, s)=>s % this.options.perPage == 0 ? t.slice(s, s + this.options.perPage) : null).filter((t)=>t) : this.pages = [
            t
        ], this.totalPages = this.lastPage = this.pages.length, this._currentPage || (this._currentPage = 1), this.totalPages;
    }
    _fixHeight() {
        this.options.fixedHeight && (this.containerDOM.style.height = null, this._rect = this.containerDOM.getBoundingClientRect(), this.containerDOM.style.height = `${this._rect.height}px`);
    }
    search(t, e, s = "search") {
        if (this.emit("datatable.search:before", t, this._searchData), !t.length) return this._currentPage = 1, this._searchQueries = [], this._searchData = [], this.update(), this.emit("datatable.search", "", []), this.wrapperDOM.classList.remove("search-results"), !1;
        this.multiSearch([
            {
                terms: [
                    t
                ],
                columns: e || void 0
            }
        ], s), this.emit("datatable.search", t, this._searchData);
    }
    multiSearch(t, e = "search") {
        if (!this.hasRows) return !1;
        this._currentPage = 1, this._searchData = [];
        let s = t.map((t)=>({
                columns: t.columns,
                terms: t.terms.map((t)=>t.trim()).filter((t)=>t),
                source: e
            })).filter((t)=>t.terms.length);
        if (this.emit("datatable.multisearch:before", s, this._searchData), e.length && (s = s.concat(this._searchQueries.filter((t)=>t.source !== e))), this._searchQueries = s, !s.length) return this.update(), this.emit("datatable.multisearch", s, this._searchData), this.wrapperDOM.classList.remove("search-results"), !1;
        const i = s.map((t)=>this.columns.settings.map((e, s)=>{
                if (e.hidden || !e.searchable || t.columns && !t.columns.includes(s)) return !1;
                let i = t.terms;
                const n = e.sensitivity || this.options.sensitivity;
                [
                    "base",
                    "accent"
                ].includes(n) && (i = i.map((t)=>t.toLowerCase())), [
                    "base",
                    "case"
                ].includes(n) && (i = i.map((t)=>t.normalize("NFD").replace(/\p{Diacritic}/gu, "")));
                return (e.ignorePunctuation ?? this.options.ignorePunctuation) && (i = i.map((t)=>t.replace(/[.,/#!$%^&*;:{}=-_`~()]/g, ""))), i;
            }));
        this.data.data.forEach((t, e)=>{
            const a = t.cells.map((t, e)=>{
                const s = this.columns.settings[e];
                if (s.searchMethod || this.options.searchMethod) return t;
                let i = $a7031b6d2b9a785f$var$n(t).trim();
                if (i.length) {
                    const t = s.sensitivity || this.options.sensitivity;
                    [
                        "base",
                        "accent"
                    ].includes(t) && (i = i.toLowerCase()), [
                        "base",
                        "case"
                    ].includes(t) && (i = i.normalize("NFD").replace(/\p{Diacritic}/gu, ""));
                    (s.ignorePunctuation ?? this.options.ignorePunctuation) && (i = i.replace(/[.,/#!$%^&*;:{}=-_`~()]/g, ""));
                }
                const a = s.searchItemSeparator || this.options.searchItemSeparator;
                return a ? i.split(a) : [
                    i
                ];
            });
            i.every((e, i)=>e.find((e, n)=>{
                    if (!e) return !1;
                    const o = this.columns.settings[n].searchMethod || this.options.searchMethod;
                    return o ? o(e, a[n], t, n, s[i].source) : e.find((t)=>a[n].find((e)=>e.includes(t)));
                })) && this._searchData.push(e);
        }), this.wrapperDOM.classList.add("search-results"), this._searchData.length ? this.update() : (this.wrapperDOM.classList.remove("search-results"), this.setMessage(this.options.labels.noResults)), this.emit("datatable.multisearch", s, this._searchData);
    }
    page(t, e = !1) {
        return this.emit("datatable.page:before", t), t !== this._currentPage && (isNaN(t) || (this._currentPage = t), !(t > this.pages.length || t < 0) && (this._renderPage(e), this._renderPagers(), void this.emit("datatable.page", t)));
    }
    insert(e) {
        let s = [];
        if (Array.isArray(e)) {
            const t = this.data.headings.map((t)=>t.data ? String(t.data) : t.text);
            e.forEach((e, i)=>{
                const n = [];
                Object.entries(e).forEach(([e, s])=>{
                    const a = t.indexOf(e);
                    a > -1 ? n[a] = $a7031b6d2b9a785f$var$Z(s, this.columns.settings[a]) : this.hasHeadings || this.hasRows || 0 !== i || (n[t.length] = $a7031b6d2b9a785f$var$Z(s, this.columns.settings[t.length]), t.push(e), this.data.headings.push($a7031b6d2b9a785f$var$G(e)));
                }), s.push({
                    cells: n
                });
            });
        } else $a7031b6d2b9a785f$export$a6cdc56e425d0d0a(e) && (!e.headings || this.hasHeadings || this.hasRows ? e.data && Array.isArray(e.data) && (s = e.data.map((t)=>{
            let e, s;
            return Array.isArray(t) ? (e = {}, s = t) : (e = t.attributes, s = t.cells), {
                attributes: e,
                cells: s.map((t, e)=>$a7031b6d2b9a785f$var$Z(t, this.columns.settings[e]))
            };
        })) : this.data = $a7031b6d2b9a785f$var$K(e, void 0, this.columns.settings, this.options.type, this.options.format));
        s.length && s.forEach((t)=>this.data.data.push(t)), this.hasHeadings = Boolean(this.data.headings.length), this.columns._state.sort && this.columns.sort(this.columns._state.sort.column, this.columns._state.sort.dir, !0), this.update(!0);
    }
    refresh() {
        if (this.emit("datatable.refresh:before"), this.options.searchable) {
            const t = $a7031b6d2b9a785f$var$l(this.options.classes.input);
            Array.from(this.wrapperDOM.querySelectorAll(t)).forEach((t)=>t.value = ""), this._searchQueries = [];
        }
        this._currentPage = 1, this.onFirstPage = !0, this.update(!0), this.emit("datatable.refresh");
    }
    print() {
        const t = $a7031b6d2b9a785f$export$c8a8987d4410bf2d("table");
        let e = $a7031b6d2b9a785f$var$B(this._tableAttributes, this.data.headings, this.data.data.map((t, e)=>({
                row: t,
                index: e
            })), this.columns.settings, this.columns._state, !1, this.options, {
            noColumnWidths: !0,
            unhideHeader: !0
        }, this._tableFooters, this._tableCaptions);
        if (this.options.tableRender) {
            const t = this.options.tableRender(this.data, e, "print");
            t && (e = t);
        }
        const i = this._dd.diff({
            nodeName: "TABLE"
        }, e);
        this._dd.apply(t, i);
        const n = window.open();
        n.document.body.appendChild(t), n.print();
    }
    setMessage(t) {
        const e = this.data.headings.filter((t, e)=>!this.columns.settings[e]?.hidden).length || 1;
        this.options.classes.empty?.split(" ").forEach((t)=>this.wrapperDOM.classList.add(t)), this._label && (this._label.innerHTML = ""), this.totalPages = 0, this._renderPagers();
        let s = {
            nodeName: "TABLE",
            attributes: this._tableAttributes,
            childNodes: [
                {
                    nodeName: "THEAD",
                    childNodes: [
                        $a7031b6d2b9a785f$var$q(this.data.headings, this.columns.settings, this.columns._state, this.options, {})
                    ]
                },
                {
                    nodeName: "TBODY",
                    childNodes: [
                        {
                            nodeName: "TR",
                            childNodes: [
                                {
                                    nodeName: "TD",
                                    attributes: {
                                        class: this.options.classes.empty,
                                        colspan: String(e)
                                    },
                                    childNodes: [
                                        {
                                            nodeName: "#text",
                                            data: t
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        };
        if (this._tableFooters.forEach((t)=>s.childNodes.push(t)), this._tableCaptions.forEach((t)=>s.childNodes.push(t)), s.attributes.class = $a7031b6d2b9a785f$var$c(s.attributes.class, this.options.classes.table), this.options.tableRender) {
            const t = this.options.tableRender(this.data, s, "message");
            t && (s = t);
        }
        const i = this._dd.diff(this._virtualDOM, s);
        this._dd.apply(this.dom, i), this._virtualDOM = s;
    }
    on(t, e) {
        this._events[t] = this._events[t] || [], this._events[t].push(e);
    }
    off(t, e) {
        t in this._events != !1 && this._events[t].splice(this._events[t].indexOf(e), 1);
    }
    emit(t, ...e) {
        if (t in this._events != !1) for(let s = 0; s < this._events[t].length; s++)this._events[t][s](...e);
    }
}
const $a7031b6d2b9a785f$export$c16cbdf0ccc11c4f = function(e) {
    let s;
    if (!$a7031b6d2b9a785f$export$a6cdc56e425d0d0a(e)) return !1;
    const i = {
        lineDelimiter: "\n",
        columnDelimiter: ",",
        removeDoubleQuotes: !1,
        ...e
    };
    if (i.data.length) {
        s = {
            data: []
        };
        const t = i.data.split(i.lineDelimiter);
        if (t.length && (i.headings && (s.headings = t[0].split(i.columnDelimiter), i.removeDoubleQuotes && (s.headings = s.headings.map((t)=>t.trim().replace(/(^"|"$)/g, ""))), t.shift()), t.forEach((t, e)=>{
            s.data[e] = [];
            const n = t.split(i.columnDelimiter);
            n.length && n.forEach((t)=>{
                i.removeDoubleQuotes && (t = t.trim().replace(/(^"|"$)/g, "")), s.data[e].push(t);
            });
        })), s) return s;
    }
    return !1;
}, $a7031b6d2b9a785f$export$abac216fee92eb99 = function(s) {
    let i;
    if (!$a7031b6d2b9a785f$export$a6cdc56e425d0d0a(s)) return !1;
    const n = {
        data: "",
        ...s
    };
    if (n.data.length || $a7031b6d2b9a785f$export$a6cdc56e425d0d0a(n.data)) {
        const t = !!$a7031b6d2b9a785f$export$952e1d8683e4d0c4(n.data) && JSON.parse(n.data);
        if (t ? (i = {
            headings: [],
            data: []
        }, t.forEach((t, e)=>{
            i.data[e] = [], Object.entries(t).forEach(([t, s])=>{
                i.headings.includes(t) || i.headings.push(t), i.data[e].push(s);
            });
        })) : console.warn("That's not valid JSON!"), i) return i;
    }
    return !1;
}, $a7031b6d2b9a785f$export$4d42112fb1387bd = function(e, s = {}) {
    if (!e.hasHeadings && !e.hasRows) return !1;
    if (!$a7031b6d2b9a785f$export$a6cdc56e425d0d0a(s)) return !1;
    const i = {
        download: !0,
        skipColumn: [],
        lineDelimiter: "\n",
        columnDelimiter: ",",
        ...s
    }, a = (t)=>!i.skipColumn.includes(t) && !e.columns.settings[t]?.hidden, o = e.data.headings.filter((t, e)=>a(e)).map((t)=>t.text ?? t.data);
    let r;
    if (i.selection) {
        if (Array.isArray(i.selection)) {
            r = [];
            for(let t = 0; t < i.selection.length; t++)r = r.concat(e.pages[i.selection[t] - 1].map((t)=>t.row));
        } else r = e.pages[i.selection - 1].map((t)=>t.row);
    } else r = e.data.data;
    let l = [];
    if (l[0] = o, l = l.concat(r.map((t)=>t.cells.filter((t, e)=>a(e)).map((t)=>$a7031b6d2b9a785f$var$n(t)))), l.length) {
        let t = "";
        if (l.forEach((e)=>{
            e.forEach((e)=>{
                "string" == typeof e && (e = (e = (e = (e = (e = e.trim()).replace(/\s{2,}/g, " ")).replace(/\n/g, "  ")).replace(/"/g, '""')).replace(/#/g, "%23")).includes(",") && (e = `"${e}"`), t += e + i.columnDelimiter;
            }), t = t.trim().substring(0, t.length - 1), t += i.lineDelimiter;
        }), t = t.trim().substring(0, t.length - 1), i.download) {
            const e = document.createElement("a");
            e.href = encodeURI(`data:text/csv;charset=utf-8,${t}`), e.download = `${i.filename || "datatable_export"}.csv`, document.body.appendChild(e), e.click(), document.body.removeChild(e);
        }
        return t;
    }
    return !1;
}, $a7031b6d2b9a785f$export$9a13a592817af225 = function(e, s = {}) {
    if (!e.hasHeadings && !e.hasRows) return !1;
    if (!$a7031b6d2b9a785f$export$a6cdc56e425d0d0a(s)) return !1;
    const i = {
        download: !0,
        skipColumn: [],
        replacer: null,
        space: 4,
        ...s
    }, a = (t)=>!i.skipColumn.includes(t) && !e.columns.settings[t]?.hidden;
    let o;
    if (i.selection) {
        if (Array.isArray(i.selection)) {
            o = [];
            for(let t = 0; t < i.selection.length; t++)o = o.concat(e.pages[i.selection[t] - 1].map((t)=>t.row));
        } else o = e.pages[i.selection - 1].map((t)=>t.row);
    } else o = e.data.data;
    const r = o.map((t)=>t.cells.filter((t, e)=>a(e)).map((t)=>$a7031b6d2b9a785f$var$n(t))), l = e.data.headings.filter((t, e)=>a(e)).map((t)=>t.text ?? String(t.data));
    if (r.length) {
        const t = [];
        r.forEach((e, s)=>{
            t[s] = t[s] || {}, e.forEach((e, i)=>{
                t[s][l[i]] = e;
            });
        });
        const e = JSON.stringify(t, i.replacer, i.space);
        if (i.download) {
            const t = new Blob([
                e
            ], {
                type: "data:application/json;charset=utf-8"
            }), s = URL.createObjectURL(t), n = document.createElement("a");
            n.href = s, n.download = `${i.filename || "datatable_export"}.json`, document.body.appendChild(n), n.click(), document.body.removeChild(n), URL.revokeObjectURL(s);
        }
        return e;
    }
    return !1;
}, $a7031b6d2b9a785f$export$d0e132fdc46cb310 = function(e, s = {}) {
    if (!e.hasHeadings && !e.hasRows) return !1;
    if (!$a7031b6d2b9a785f$export$a6cdc56e425d0d0a(s)) return !1;
    const i = {
        download: !0,
        skipColumn: [],
        tableName: "myTable",
        ...s
    }, a = (t)=>!i.skipColumn.includes(t) && !e.columns.settings[t]?.hidden;
    let o = [];
    if (i.selection) {
        if (Array.isArray(i.selection)) for(let t = 0; t < i.selection.length; t++)o = o.concat(e.pages[i.selection[t] - 1].map((t)=>t.row));
        else o = e.pages[i.selection - 1].map((t)=>t.row);
    } else o = e.data.data;
    const r = o.map((t)=>t.cells.filter((t, e)=>a(e)).map((t)=>$a7031b6d2b9a785f$var$n(t))), l = e.data.headings.filter((t, e)=>a(e)).map((t)=>t.text ?? String(t.data));
    if (r.length) {
        let t = `INSERT INTO \`${i.tableName}\` (`;
        if (l.forEach((e)=>{
            t += `\`${e}\`,`;
        }), t = t.trim().substring(0, t.length - 1), t += ") VALUES ", r.forEach((e)=>{
            t += "(", e.forEach((e)=>{
                t += "string" == typeof e ? `"${e}",` : `${e},`;
            }), t = t.trim().substring(0, t.length - 1), t += "),";
        }), t = t.trim().substring(0, t.length - 1), t += ";", i.download && (t = `data:application/sql;charset=utf-8,${t}`), i.download) {
            const e = document.createElement("a");
            e.href = encodeURI(t), e.download = `${i.filename || "datatable_export"}.sql`, document.body.appendChild(e), e.click(), document.body.removeChild(e);
        }
        return t;
    }
    return !1;
}, $a7031b6d2b9a785f$export$56a1cef83e3a6c65 = function(e, s = {}) {
    if (!e.hasHeadings && !e.hasRows) return !1;
    if (!$a7031b6d2b9a785f$export$a6cdc56e425d0d0a(s)) return !1;
    const i = {
        download: !0,
        skipColumn: [],
        lineDelimiter: "\n",
        columnDelimiter: ",",
        ...s
    }, a = (t)=>!i.skipColumn.includes(t) && !e.columns.settings[t]?.hidden, o = e.data.headings.filter((t, e)=>a(e)).map((t)=>t.text ?? t.data);
    let r;
    if (i.selection) {
        if (Array.isArray(i.selection)) {
            r = [];
            for(let t = 0; t < i.selection.length; t++)r = r.concat(e.pages[i.selection[t] - 1].map((t)=>t.row));
        } else r = e.pages[i.selection - 1].map((t)=>t.row);
    } else r = e.data.data;
    let l = [];
    if (l[0] = o, l = l.concat(r.map((t)=>t.cells.filter((t, e)=>a(e)).map((t)=>$a7031b6d2b9a785f$var$n(t)))), l.length) {
        let t = "";
        if (l.forEach((e)=>{
            e.forEach((e)=>{
                "string" == typeof e && (e = (e = (e = (e = (e = e.trim()).replace(/\s{2,}/g, " ")).replace(/\n/g, "  ")).replace(/"/g, '""')).replace(/#/g, "%23")).includes(",") && (e = `"${e}"`), t += e + i.columnDelimiter;
            }), t = t.trim().substring(0, t.length - 1), t += i.lineDelimiter;
        }), t = t.trim().substring(0, t.length - 1), i.download && (t = `data:text/csv;charset=utf-8,${t}`), i.download) {
            const e = document.createElement("a");
            e.href = encodeURI(t), e.download = `${i.filename || "datatable_export"}.txt`, document.body.appendChild(e), e.click(), document.body.removeChild(e);
        }
        return t;
    }
    return !1;
}, $a7031b6d2b9a785f$var$ut = {
    classes: {
        row: "datatable-editor-row",
        form: "datatable-editor-form",
        item: "datatable-editor-item",
        menu: "datatable-editor-menu",
        save: "datatable-editor-save",
        block: "datatable-editor-block",
        cancel: "datatable-editor-cancel",
        close: "datatable-editor-close",
        inner: "datatable-editor-inner",
        input: "datatable-editor-input",
        label: "datatable-editor-label",
        modal: "datatable-editor-modal",
        action: "datatable-editor-action",
        header: "datatable-editor-header",
        wrapper: "datatable-editor-wrapper",
        editable: "datatable-editor-editable",
        container: "datatable-editor-container",
        separator: "datatable-editor-separator"
    },
    labels: {
        closeX: "x",
        editCell: "Edit Cell",
        editRow: "Edit Row",
        removeRow: "Remove Row",
        reallyRemove: "Are you sure?",
        reallyCancel: "Do you really want to cancel?",
        save: "Save",
        cancel: "Cancel"
    },
    cancelModal: (t)=>confirm(t.options.labels.reallyCancel),
    inline: !0,
    hiddenColumns: !1,
    contextMenu: !0,
    clickEvent: "dblclick",
    excludeColumns: [],
    menuItems: [
        {
            text: (t)=>t.options.labels.editCell,
            action: (t, e)=>{
                if (!(t.event.target instanceof Element)) return;
                const s = t.event.target.closest("td");
                return t.editCell(s);
            }
        },
        {
            text: (t)=>t.options.labels.editRow,
            action: (t, e)=>{
                if (!(t.event.target instanceof Element)) return;
                const s = t.event.target.closest("tr");
                return t.editRow(s);
            }
        },
        {
            separator: !0
        },
        {
            text: (t)=>t.options.labels.removeRow,
            action: (t, e)=>{
                if (t.event.target instanceof Element && confirm(t.options.labels.reallyRemove)) {
                    const e = t.event.target.closest("tr");
                    t.removeRow(e);
                }
            }
        }
    ]
};
class $a7031b6d2b9a785f$var$pt {
    menuOpen;
    containerDOM;
    data;
    disabled;
    dt;
    editing;
    editingCell;
    editingRow;
    event;
    events;
    initialized;
    limits;
    menuDOM;
    modalDOM;
    options;
    originalRowRender;
    rect;
    wrapperDOM;
    constructor(t, e = {}){
        this.dt = t, this.options = {
            ...$a7031b6d2b9a785f$var$ut,
            ...e
        };
    }
    init() {
        this.initialized || (this.options.classes.editable?.split(" ").forEach((t)=>this.dt.wrapperDOM.classList.add(t)), this.options.inline && (this.originalRowRender = this.dt.options.rowRender, this.dt.options.rowRender = (t, e, s)=>{
            let i = this.rowRender(t, e, s);
            return this.originalRowRender && (i = this.originalRowRender(t, i, s)), i;
        }), this.options.contextMenu && (this.containerDOM = $a7031b6d2b9a785f$export$c8a8987d4410bf2d("div", {
            id: this.options.classes.container
        }), this.wrapperDOM = $a7031b6d2b9a785f$export$c8a8987d4410bf2d("div", {
            class: this.options.classes.wrapper
        }), this.menuDOM = $a7031b6d2b9a785f$export$c8a8987d4410bf2d("ul", {
            class: this.options.classes.menu
        }), this.options.menuItems && this.options.menuItems.length && this.options.menuItems.forEach((t)=>{
            const e = $a7031b6d2b9a785f$export$c8a8987d4410bf2d("li", {
                class: t.separator ? this.options.classes.separator : this.options.classes.item
            });
            if (!t.separator) {
                const i = $a7031b6d2b9a785f$export$c8a8987d4410bf2d("a", {
                    class: this.options.classes.action,
                    href: t.url || "#",
                    html: "function" == typeof t.text ? t.text(this) : t.text
                });
                e.appendChild(i), t.action && "function" == typeof t.action && i.addEventListener("click", (e)=>{
                    e.preventDefault(), t.action(this, e);
                });
            }
            this.menuDOM.appendChild(e);
        }), this.wrapperDOM.appendChild(this.menuDOM), this.containerDOM.appendChild(this.wrapperDOM), this.updateMenu()), this.data = {}, this.menuOpen = !1, this.editing = !1, this.editingRow = !1, this.editingCell = !1, this.bindEvents(), setTimeout(()=>{
            this.initialized = !0, this.dt.emit("editable.init");
        }, 10));
    }
    bindEvents() {
        this.events = {
            keydown: this.keydown.bind(this),
            click: this.click.bind(this)
        }, this.dt.dom.addEventListener(this.options.clickEvent, this.events.click), document.addEventListener("keydown", this.events.keydown), this.options.contextMenu && (this.events.context = this.context.bind(this), this.events.updateMenu = this.updateMenu.bind(this), this.events.dismissMenu = this.dismissMenu.bind(this), this.events.reset = $a7031b6d2b9a785f$var$h(()=>this.events.updateMenu(), 50), this.dt.dom.addEventListener("contextmenu", this.events.context), document.addEventListener("click", this.events.dismissMenu), window.addEventListener("resize", this.events.reset), window.addEventListener("scroll", this.events.reset));
    }
    context(t) {
        const e = t.target;
        if (!(e instanceof Element)) return;
        this.event = t;
        const s = e.closest("tbody td");
        if (!this.disabled && s) {
            t.preventDefault();
            let e = t.pageX, s = t.pageY;
            e > this.limits.x && (e -= this.rect.width), s > this.limits.y && (s -= this.rect.height), this.wrapperDOM.style.top = `${s}px`, this.wrapperDOM.style.left = `${e}px`, this.openMenu(), this.updateMenu();
        }
    }
    click(t) {
        const e = t.target;
        if (e instanceof Element) {
            if (this.editing && this.data && this.editingCell) {
                const t = $a7031b6d2b9a785f$var$l(this.options.classes.input), e = this.modalDOM ? this.modalDOM.querySelector(`input${t}[type=text]`) : this.dt.wrapperDOM.querySelector(`input${t}[type=text]`);
                this.saveCell(e.value);
            } else if (!this.editing) {
                const s = e.closest("tbody td");
                s && (this.editCell(s), t.preventDefault());
            }
        }
    }
    keydown(t) {
        const e = $a7031b6d2b9a785f$var$l(this.options.classes.input);
        if (this.modalDOM) {
            if ("Escape" === t.key) this.options.cancelModal(this) && this.closeModal();
            else if ("Enter" === t.key) {
                if (this.editingCell) {
                    const t = this.modalDOM.querySelector(`input${e}[type=text]`);
                    this.saveCell(t.value);
                } else {
                    const t = Array.from(this.modalDOM.querySelectorAll(`input${e}[type=text]`)).map((t)=>t.value.trim());
                    this.saveRow(t, this.data.row);
                }
            }
        } else if (this.editing && this.data) {
            if ("Enter" === t.key) {
                if (this.editingCell) {
                    const t = this.dt.wrapperDOM.querySelector(`input${e}[type=text]`);
                    this.saveCell(t.value);
                } else if (this.editingRow) {
                    const t = Array.from(this.dt.wrapperDOM.querySelectorAll(`input${e}[type=text]`)).map((t)=>t.value.trim());
                    this.saveRow(t, this.data.row);
                }
            } else "Escape" === t.key && (this.editingCell ? this.saveCell(this.data.content) : this.editingRow && this.saveRow(null, this.data.row));
        }
    }
    editCell(t) {
        const e = $a7031b6d2b9a785f$var$o(t.cellIndex, this.dt.columns.settings);
        if (this.options.excludeColumns.includes(e)) return void this.closeMenu();
        const s = parseInt(t.parentElement.dataset.index, 10), i = this.dt.data.data[s].cells[e];
        this.data = {
            cell: i,
            rowIndex: s,
            columnIndex: e,
            content: $a7031b6d2b9a785f$var$n(i)
        }, this.editing = !0, this.editingCell = !0, this.options.inline ? this.dt.update() : this.editCellModal(), this.closeMenu();
    }
    editCellModal() {
        const t = this.data.cell, e = this.data.columnIndex, i = this.dt.data.headings[e].text || String(this.dt.data.headings[e].data), o = [
            `<div class='${this.options.classes.inner}'>`,
            `<div class='${this.options.classes.header}'>`,
            `<h4>${this.options.labels.editCell}</h4>`,
            `<button class='${this.options.classes.close}' type='button' data-editor-cancel>${this.options.labels.closeX}</button>`,
            " </div>",
            `<div class='${this.options.classes.block}'>`,
            `<form class='${this.options.classes.form}'>`,
            `<div class='${this.options.classes.row}'>`,
            `<label class='${this.options.classes.label}'>${$a7031b6d2b9a785f$var$a(i)}</label>`,
            `<input class='${this.options.classes.input}' value='${$a7031b6d2b9a785f$var$a($a7031b6d2b9a785f$var$n(t))}' type='text'>`,
            "</div>",
            `<div class='${this.options.classes.row}'>`,
            `<button class='${this.options.classes.cancel}' type='button' data-editor-cancel>${this.options.labels.cancel}</button>`,
            `<button class='${this.options.classes.save}' type='button' data-editor-save>${this.options.labels.save}</button>`,
            "</div>",
            "</form>",
            "</div>",
            "</div>"
        ].join(""), r = $a7031b6d2b9a785f$export$c8a8987d4410bf2d("div", {
            class: this.options.classes.modal,
            html: o
        });
        this.modalDOM = r, this.openModal();
        const d = $a7031b6d2b9a785f$var$l(this.options.classes.input), c = r.querySelector(`input${d}[type=text]`);
        c.focus(), c.selectionStart = c.selectionEnd = c.value.length, r.addEventListener("click", (t)=>{
            const e = t.target;
            e instanceof Element && (e.hasAttribute("data-editor-cancel") ? (t.preventDefault(), this.options.cancelModal(this) && this.closeModal()) : e.hasAttribute("data-editor-save") && (t.preventDefault(), this.saveCell(c.value)));
        });
    }
    saveCell(t) {
        const e = this.data.content, s = this.dt.columns.settings[this.data.columnIndex].type || this.dt.options.type, i = t.trim();
        let n;
        if ("number" === s) n = {
            data: parseFloat(i)
        };
        else if ("boolean" === s) n = [
            "",
            "false",
            "0"
        ].includes(i) ? {
            data: !1,
            text: "false",
            order: 0
        } : {
            data: !0,
            text: "true",
            order: 1
        };
        else if ("html" === s) n = {
            data: [
                {
                    nodeName: "#text",
                    data: t
                }
            ],
            text: t,
            order: t
        };
        else if ("string" === s) n = {
            data: t
        };
        else if ("date" === s) {
            const e = this.dt.columns.settings[this.data.columnIndex].format || this.dt.options.format;
            n = {
                data: t,
                order: $a7031b6d2b9a785f$var$X(String(t), e)
            };
        } else n = {
            data: t
        };
        this.dt.data.data[this.data.rowIndex].cells[this.data.columnIndex] = n, this.closeModal();
        const a = this.data.rowIndex, o = this.data.columnIndex;
        this.data = {}, this.dt.update(!0), this.editing = !1, this.editingCell = !1, this.dt.emit("editable.save.cell", t, e, a, o);
    }
    editRow(t) {
        if (!t || "TR" !== t.nodeName || this.editing) return;
        const e = parseInt(t.dataset.index, 10), s = this.dt.data.data[e];
        this.data = {
            row: s.cells,
            rowIndex: e
        }, this.editing = !0, this.editingRow = !0, this.options.inline ? this.dt.update() : this.editRowModal(), this.closeMenu();
    }
    editRowModal() {
        const t = this.data.row, e = [
            `<div class='${this.options.classes.inner}'>`,
            `<div class='${this.options.classes.header}'>`,
            `<h4>${this.options.labels.editRow}</h4>`,
            `<button class='${this.options.classes.close}' type='button' data-editor-cancel>${this.options.labels.closeX}</button>`,
            " </div>",
            `<div class='${this.options.classes.block}'>`,
            `<form class='${this.options.classes.form}'>`,
            `<div class='${this.options.classes.row}'>`,
            `<button class='${this.options.classes.cancel}' type='button' data-editor-cancel>${this.options.labels.cancel}</button>`,
            `<button class='${this.options.classes.save}' type='button' data-editor-save>${this.options.labels.save}</button>`,
            "</div>",
            "</form>",
            "</div>",
            "</div>"
        ].join(""), i = $a7031b6d2b9a785f$export$c8a8987d4410bf2d("div", {
            class: this.options.classes.modal,
            html: e
        }), o = i.firstElementChild;
        if (!o) return;
        const r = o.lastElementChild?.firstElementChild;
        if (!r) return;
        t.forEach((t, e)=>{
            const i = this.dt.columns.settings[e];
            if ((!i.hidden || i.hidden && this.options.hiddenColumns) && !this.options.excludeColumns.includes(e)) {
                const i = this.dt.data.headings[e].text || String(this.dt.data.headings[e].data);
                r.insertBefore($a7031b6d2b9a785f$export$c8a8987d4410bf2d("div", {
                    class: this.options.classes.row,
                    html: [
                        `<div class='${this.options.classes.row}'>`,
                        `<label class='${this.options.classes.label}'>${$a7031b6d2b9a785f$var$a(i)}</label>`,
                        `<input class='${this.options.classes.input}' value='${$a7031b6d2b9a785f$var$a($a7031b6d2b9a785f$var$n(t))}' type='text'>`,
                        "</div>"
                    ].join("")
                }), r.lastElementChild);
            }
        }), this.modalDOM = i, this.openModal();
        const d = $a7031b6d2b9a785f$var$l(this.options.classes.input), c = Array.from(r.querySelectorAll(`input${d}[type=text]`));
        i.addEventListener("click", (t)=>{
            const e = t.target;
            if (e instanceof Element) {
                if (e.hasAttribute("data-editor-cancel")) this.options.cancelModal(this) && this.closeModal();
                else if (e.hasAttribute("data-editor-save")) {
                    const t = c.map((t)=>t.value.trim());
                    this.saveRow(t, this.data.row);
                }
            }
        });
    }
    saveRow(t, e) {
        const s = e.map((t)=>$a7031b6d2b9a785f$var$n(t)), i = this.dt.data.data[this.data.rowIndex];
        if (t) {
            let s = 0;
            i.cells = e.map((e, i)=>{
                if (this.options.excludeColumns.includes(i) || this.dt.columns.settings[i].hidden) return e;
                const n = this.dt.columns.settings[i].type || this.dt.options.type, a = t[s++];
                let o;
                if ("number" === n) o = {
                    data: parseFloat(a)
                };
                else if ("boolean" === n) o = [
                    "",
                    "false",
                    "0"
                ].includes(a) ? {
                    data: !1,
                    text: "false",
                    order: 0
                } : {
                    data: !0,
                    text: "true",
                    order: 1
                };
                else if ("html" === n) o = {
                    data: [
                        {
                            nodeName: "#text",
                            data: a
                        }
                    ],
                    text: a,
                    order: a
                };
                else if ("string" === n) o = {
                    data: a
                };
                else if ("date" === n) {
                    const t = this.dt.columns.settings[i].format || this.dt.options.format;
                    o = {
                        data: a,
                        order: $a7031b6d2b9a785f$var$X(String(a), t)
                    };
                } else o = {
                    data: a
                };
                return o;
            });
        }
        const a = i.cells.map((t)=>$a7031b6d2b9a785f$var$n(t));
        this.data = {}, this.dt.update(!0), this.closeModal(), this.editing = !1, this.dt.emit("editable.save.row", a, s, e);
    }
    openModal() {
        this.modalDOM && document.body.appendChild(this.modalDOM);
    }
    closeModal() {
        this.editing && this.modalDOM && (document.body.removeChild(this.modalDOM), this.modalDOM = this.editing = this.editingRow = this.editingCell = !1);
    }
    removeRow(t) {
        if (!t || "TR" !== t.nodeName || this.editing) return;
        const e = parseInt(t.dataset.index, 10);
        this.dt.rows.remove(e), this.closeMenu();
    }
    updateMenu() {
        const t = window.scrollX || window.pageXOffset, e = window.scrollY || window.pageYOffset;
        this.rect = this.wrapperDOM.getBoundingClientRect(), this.limits = {
            x: window.innerWidth + t - this.rect.width,
            y: window.innerHeight + e - this.rect.height
        };
    }
    dismissMenu(t) {
        const e = t.target;
        if (!(e instanceof Element) || this.wrapperDOM.contains(e)) return;
        let s = !0;
        if (this.editing) {
            const t = $a7031b6d2b9a785f$var$l(this.options.classes.input);
            s = !e.matches(`input${t}[type=text]`);
        }
        s && this.closeMenu();
    }
    openMenu() {
        if (this.editing && this.data && this.editingCell) {
            const t = $a7031b6d2b9a785f$var$l(this.options.classes.input), e = this.modalDOM ? this.modalDOM.querySelector(`input${t}[type=text]`) : this.dt.wrapperDOM.querySelector(`input${t}[type=text]`);
            this.saveCell(e.value);
        }
        document.body.appendChild(this.containerDOM), this.menuOpen = !0, this.dt.emit("editable.context.open");
    }
    closeMenu() {
        this.menuOpen && (this.menuOpen = !1, document.body.removeChild(this.containerDOM), this.dt.emit("editable.context.close"));
    }
    destroy() {
        this.dt.dom.removeEventListener(this.options.clickEvent, this.events.click), this.dt.dom.removeEventListener("contextmenu", this.events.context), document.removeEventListener("click", this.events.dismissMenu), document.removeEventListener("keydown", this.events.keydown), window.removeEventListener("resize", this.events.reset), window.removeEventListener("scroll", this.events.reset), document.body.contains(this.containerDOM) && document.body.removeChild(this.containerDOM), this.options.inline && (this.dt.options.rowRender = this.originalRowRender), this.initialized = !1;
    }
    rowRender(t, e, s) {
        if (!this.data || this.data.rowIndex !== s) return e;
        if (this.editingCell) e.childNodes[function(t, e) {
            let s = t, i = 0;
            for(; i < t;)e[i].hidden && (s -= 1), i++;
            return s;
        }(this.data.columnIndex, this.dt.columns.settings)].childNodes = [
            {
                nodeName: "INPUT",
                attributes: {
                    type: "text",
                    value: this.data.content,
                    class: this.options.classes.input
                }
            }
        ];
        else e.childNodes.forEach((s, i)=>{
            const n = $a7031b6d2b9a785f$var$o(i, this.dt.columns.settings), r = t[n];
            if (!this.options.excludeColumns.includes(n)) e.childNodes[i].childNodes = [
                {
                    nodeName: "INPUT",
                    attributes: {
                        type: "text",
                        value: $a7031b6d2b9a785f$var$a(r.text || String(r.data) || ""),
                        class: this.options.classes.input
                    }
                }
            ];
        });
        return e;
    }
}
const $a7031b6d2b9a785f$export$7a017232fba6110a = function(t, e = {}) {
    const s = new $a7031b6d2b9a785f$var$pt(t, e);
    return t.initialized ? s.init() : t.on("datatable.init", ()=>s.init()), s;
}, $a7031b6d2b9a785f$var$mt = {
    classes: {
        button: "datatable-column-filter-button",
        menu: "datatable-column-filter-menu",
        container: "datatable-column-filter-container",
        wrapper: "datatable-column-filter-wrapper"
    },
    labels: {
        button: "Filter columns within the table"
    },
    hiddenColumns: []
};
class $a7031b6d2b9a785f$var$gt {
    addedButtonDOM;
    menuOpen;
    buttonDOM;
    dt;
    events;
    initialized;
    options;
    menuDOM;
    containerDOM;
    wrapperDOM;
    limits;
    rect;
    event;
    constructor(t, e = {}){
        this.dt = t, this.options = {
            ...$a7031b6d2b9a785f$var$mt,
            ...e
        };
    }
    init() {
        if (this.initialized) return;
        const t = $a7031b6d2b9a785f$var$l(this.options.classes.button);
        let e = this.dt.wrapperDOM.querySelector(t);
        if (!e) {
            e = $a7031b6d2b9a785f$export$c8a8987d4410bf2d("button", {
                class: this.options.classes.button,
                html: "\u25A6"
            });
            const t = $a7031b6d2b9a785f$var$l(this.dt.options.classes.search), i = this.dt.wrapperDOM.querySelector(t);
            i ? i.appendChild(e) : this.dt.wrapperDOM.appendChild(e), this.addedButtonDOM = !0;
        }
        this.buttonDOM = e, this.containerDOM = $a7031b6d2b9a785f$export$c8a8987d4410bf2d("div", {
            id: this.options.classes.container
        }), this.wrapperDOM = $a7031b6d2b9a785f$export$c8a8987d4410bf2d("div", {
            class: this.options.classes.wrapper
        }), this.menuDOM = $a7031b6d2b9a785f$export$c8a8987d4410bf2d("ul", {
            class: this.options.classes.menu,
            html: this.dt.data.headings.map((t, e)=>{
                const s = this.dt.columns.settings[e];
                return this.options.hiddenColumns.includes(e) ? "" : `<li data-column="${e}">\n                        <input type="checkbox" value="${t.text || t.data}" ${s.hidden ? "" : "checked=''"}>\n                        <label>\n                            ${t.text || t.data}\n                        </label>\n                    </li>`;
            }).join("")
        }), this.wrapperDOM.appendChild(this.menuDOM), this.containerDOM.appendChild(this.wrapperDOM), this._measureSpace(), this._bind(), this.initialized = !0;
    }
    dismiss() {
        this.addedButtonDOM && this.buttonDOM.parentElement && this.buttonDOM.parentElement.removeChild(this.buttonDOM), document.removeEventListener("click", this.events.click);
    }
    _bind() {
        this.events = {
            click: this._click.bind(this)
        }, document.addEventListener("click", this.events.click);
    }
    _openMenu() {
        document.body.appendChild(this.containerDOM), this._measureSpace(), this.menuOpen = !0, this.dt.emit("columnFilter.menu.open");
    }
    _closeMenu() {
        this.menuOpen && (this.menuOpen = !1, document.body.removeChild(this.containerDOM), this.dt.emit("columnFilter.menu.close"));
    }
    _measureSpace() {
        const t = window.scrollX || window.pageXOffset, e = window.scrollY || window.pageYOffset;
        this.rect = this.wrapperDOM.getBoundingClientRect(), this.limits = {
            x: window.innerWidth + t - this.rect.width,
            y: window.innerHeight + e - this.rect.height
        };
    }
    _click(t) {
        const e = t.target;
        if (e instanceof Element) {
            if (this.event = t, this.buttonDOM.contains(e)) {
                if (t.preventDefault(), this.menuOpen) return void this._closeMenu();
                this._openMenu();
                let e = t.pageX, s = t.pageY;
                e > this.limits.x && (e -= this.rect.width), s > this.limits.y && (s -= this.rect.height), this.wrapperDOM.style.top = `${s}px`, this.wrapperDOM.style.left = `${e}px`;
            } else if (this.menuDOM.contains(e)) {
                const t = $a7031b6d2b9a785f$var$l(this.options.classes.menu), s = e.closest(`${t} > li`);
                if (!s) return;
                const i = s.querySelector("input[type=checkbox]");
                i.contains(e) || (i.checked = !i.checked);
                const n = Number(s.dataset.column);
                i.checked ? this.dt.columns.show([
                    n
                ]) : this.dt.columns.hide([
                    n
                ]);
            } else this.menuOpen && this._closeMenu();
        }
    }
}
const $a7031b6d2b9a785f$export$75be0def1bfab7b1 = function(t, e = {}) {
    const s = new $a7031b6d2b9a785f$var$gt(t, e);
    return t.initialized ? s.init() : t.on("datatable.init", ()=>s.init()), s;
};


const $10157cca0bb4dfb4$export$658dbe9fb20a4a65 = ()=>{
    const TABLE_BASIC = document.getElementById("datatable-basic");
    if (TABLE_BASIC) {
        // Generate table
        (0, $93f414669e9c583a$export$4e1d9a3b5c360fd3)(TABLE_BASIC, 100);
        // Initiate datatable
        setTimeout(()=>{
            let dataTable = new (0, $a7031b6d2b9a785f$export$df30df7ec97b32b5)(TABLE_BASIC);
        });
    }
};




const $1e293ee8d6058e7e$var$exportCustomCSV = function(dataTable, userOptions = {}) {
    // A modified CSV export that includes a row of minuses at the start and end.
    const clonedUserOptions = {
        ...userOptions
    };
    clonedUserOptions.download = false;
    const csv = (0, $a7031b6d2b9a785f$export$4d42112fb1387bd)(dataTable, clonedUserOptions);
    // If CSV didn't work, exit.
    if (!csv) return false;
    const defaults = {
        download: true,
        lineDelimiter: "\n",
        columnDelimiter: ";"
    };
    const options = {
        ...defaults,
        ...clonedUserOptions
    };
    const separatorRow = Array(dataTable.data.headings.filter((_heading, index)=>!dataTable.columns.settings[index]?.hidden).length).fill("-").join(options.columnDelimiter);
    const str = `${separatorRow}${options.lineDelimiter}${csv}${options.lineDelimiter}${separatorRow}`;
    if (userOptions.download) {
        // Create a link to trigger the download
        const link = document.createElement("a");
        link.href = encodeURI(`data:text/csv;charset=utf-8,${str}`);
        link.download = `${options.filename || "datatable_export"}.txt`;
        // Append the link
        document.body.appendChild(link);
        // Trigger the download
        link.click();
        // Remove the link
        document.body.removeChild(link);
    }
    return str;
};
const $1e293ee8d6058e7e$export$6739dba5f0edf6b4 = ()=>{
    const TABLE_EXPORT = document.getElementById("datatable-export");
    let dataTable;
    if (TABLE_EXPORT) {
        // Generate table
        (0, $93f414669e9c583a$export$4e1d9a3b5c360fd3)(TABLE_EXPORT, 100);
        // Initiate datatable
        setTimeout(()=>{
            dataTable = new (0, $a7031b6d2b9a785f$export$df30df7ec97b32b5)(TABLE_EXPORT);
        });
        document.getElementById("export-csv").addEventListener("click", ()=>{
            (0, $a7031b6d2b9a785f$export$4d42112fb1387bd)(dataTable, {
                download: true,
                lineDelimiter: "\n",
                columnDelimiter: ";"
            });
        });
        document.getElementById("export-sql").addEventListener("click", ()=>{
            (0, $a7031b6d2b9a785f$export$d0e132fdc46cb310)(dataTable, {
                download: true,
                tableName: "export_table"
            });
        });
        document.getElementById("export-txt").addEventListener("click", ()=>{
            (0, $a7031b6d2b9a785f$export$56a1cef83e3a6c65)(dataTable, {
                download: true
            });
        });
        document.getElementById("export-json").addEventListener("click", ()=>{
            (0, $a7031b6d2b9a785f$export$9a13a592817af225)(dataTable, {
                download: true,
                space: 3
            });
        });
        document.getElementById("export-custom").addEventListener("click", ()=>{
            $1e293ee8d6058e7e$var$exportCustomCSV(dataTable, {
                download: true
            });
        });
    }
};




const $5f4e22f5ef200e8a$export$9d9ea8dbe2f59d9a = ()=>{
    const TABLE_FILTER = document.getElementById("datatable-filter");
    if (TABLE_FILTER) {
        // Generate table
        (0, $93f414669e9c583a$export$4e1d9a3b5c360fd3)(TABLE_FILTER, 100);
        // Initiate datatable
        setTimeout(()=>{
            window.dt = new (0, $a7031b6d2b9a785f$export$df30df7ec97b32b5)(TABLE_FILTER, {
                perPageSelect: [
                    10,
                    50,
                    [
                        "All",
                        -1
                    ]
                ],
                columns: [
                    {
                        select: 2,
                        sortSequence: [
                            "desc",
                            "asc"
                        ]
                    },
                    {
                        select: 3,
                        sortSequence: [
                            "desc"
                        ]
                    }
                ],
                tableRender: (_data, table, type)=>{
                    if (type === "print") return table;
                    const tHead = table.childNodes[0];
                    const filterHeaders = {
                        nodeName: "TR",
                        childNodes: tHead.childNodes[0].childNodes.map((_th, index)=>({
                                nodeName: "TH",
                                childNodes: [
                                    {
                                        nodeName: "INPUT",
                                        attributes: {
                                            class: "datatable-input",
                                            type: "search",
                                            "data-columns": `[${index}]`,
                                            placeHolder: "Search..."
                                        }
                                    }
                                ]
                            }))
                    };
                    tHead.childNodes.push(filterHeaders);
                    return table;
                }
            });
        });
    }
};




const $afb98260d46aeb49$export$ef85b9a81e16cb26 = ()=>{
    const TABLE_CHECKBOX = document.getElementById("datatable-toggle");
    if (TABLE_CHECKBOX) {
        // Generate table
        (0, $93f414669e9c583a$export$4e1d9a3b5c360fd3)(TABLE_CHECKBOX, 100, true);
        // Initiate datatable
        const datatable = new (0, $a7031b6d2b9a785f$export$df30df7ec97b32b5)(TABLE_CHECKBOX, {
            rowRender: (rowValue, tr, _index)=>{
                if (!tr.attributes) tr.attributes = {};
                tr.attributes["data-name"] = rowValue.cells[1].data[0].data;
                return tr;
            },
            columns: [
                {
                    select: 0,
                    sortable: false,
                    render: (value, _td, _rowIndex, _cellIndex)=>`<span class="checkbox fs-2 text-body-secondary ph ${value ? "ph-square" : "ph-check-square"}"></span>`
                }
            ]
        });
        datatable.dom.addEventListener("click", (event)=>{
            if (event.target.matches("span.checkbox")) {
                event.preventDefault();
                event.stopPropagation();
                const name = event.target.parentElement.parentElement.dataset.name;
                const index = parseInt(event.target.parentElement.parentElement.dataset.index, 10);
                const row = datatable.data.data[index];
                const cell = row.cells[0];
                const checked = cell.data;
                cell.data = !checked;
                datatable.update();
                // Timeout used for the checkbox to have time to update and show as checked. It is not required.
                setTimeout(()=>alert(`"${name}" has been ${checked ? "checked" : "unchecked"}.`), 10);
            }
        });
        window.datatable = datatable;
    }
};




const $eba3ea957fe5b72a$export$d63176c007b6bfe = ()=>{
    const TABLE_SCROLL = document.getElementById("datatable-scroll");
    if (TABLE_SCROLL) {
        // Generate table
        (0, $93f414669e9c583a$export$4e1d9a3b5c360fd3)(TABLE_SCROLL, 100);
        // Initiate datatable
        setTimeout(()=>{
            let dataTable = new (0, $a7031b6d2b9a785f$export$df30df7ec97b32b5)(TABLE_SCROLL, {
                paging: false,
                scrollY: "30vh",
                rowNavigation: true,
                tabIndex: 1
            });
        });
    }
};



/*!
 * OverlayScrollbars
 * Version: 2.11.5
 *
 * Copyright (c) Rene Haas | KingSora.
 * https://github.com/KingSora
 *
 * Released under the MIT license.
 */ const $7ed7ccaa27a98189$var$createCache = (t, n)=>{
    const { o: o, i: s, u: e } = t;
    let c = o;
    let r;
    const cacheUpdateContextual = (t, n)=>{
        const o = c;
        const i = t;
        const l = n || (s ? !s(o, i) : o !== i);
        if (l || e) {
            c = i;
            r = o;
        }
        return [
            c,
            l,
            r
        ];
    };
    const cacheUpdateIsolated = (t)=>cacheUpdateContextual(n(c, r), t);
    const getCurrentCache = (t)=>[
            c,
            !!t,
            r
        ];
    return [
        n ? cacheUpdateIsolated : cacheUpdateContextual,
        getCurrentCache
    ];
};
const $7ed7ccaa27a98189$var$t = typeof window !== "undefined" && typeof HTMLElement !== "undefined" && !!window.document;
const $7ed7ccaa27a98189$var$n = $7ed7ccaa27a98189$var$t ? window : {};
const $7ed7ccaa27a98189$var$o = Math.max;
const $7ed7ccaa27a98189$var$s = Math.min;
const $7ed7ccaa27a98189$var$e = Math.round;
const $7ed7ccaa27a98189$var$c = Math.abs;
const $7ed7ccaa27a98189$var$r = Math.sign;
const $7ed7ccaa27a98189$var$i = $7ed7ccaa27a98189$var$n.cancelAnimationFrame;
const $7ed7ccaa27a98189$var$l = $7ed7ccaa27a98189$var$n.requestAnimationFrame;
const $7ed7ccaa27a98189$var$a = $7ed7ccaa27a98189$var$n.setTimeout;
const $7ed7ccaa27a98189$var$u = $7ed7ccaa27a98189$var$n.clearTimeout;
const $7ed7ccaa27a98189$var$getApi = (t)=>typeof $7ed7ccaa27a98189$var$n[t] !== "undefined" ? $7ed7ccaa27a98189$var$n[t] : void 0;
const $7ed7ccaa27a98189$var$f = $7ed7ccaa27a98189$var$getApi("MutationObserver");
const $7ed7ccaa27a98189$var$_ = $7ed7ccaa27a98189$var$getApi("IntersectionObserver");
const $7ed7ccaa27a98189$var$d = $7ed7ccaa27a98189$var$getApi("ResizeObserver");
const $7ed7ccaa27a98189$var$p = $7ed7ccaa27a98189$var$getApi("ScrollTimeline");
const $7ed7ccaa27a98189$var$isUndefined = (t)=>t === void 0;
const $7ed7ccaa27a98189$var$isNull = (t)=>t === null;
const $7ed7ccaa27a98189$var$isNumber = (t)=>typeof t === "number";
const $7ed7ccaa27a98189$var$isString = (t)=>typeof t === "string";
const $7ed7ccaa27a98189$var$isBoolean = (t)=>typeof t === "boolean";
const $7ed7ccaa27a98189$var$isFunction = (t)=>typeof t === "function";
const $7ed7ccaa27a98189$var$isArray = (t)=>Array.isArray(t);
const $7ed7ccaa27a98189$var$isObject = (t)=>typeof t === "object" && !$7ed7ccaa27a98189$var$isArray(t) && !$7ed7ccaa27a98189$var$isNull(t);
const $7ed7ccaa27a98189$var$isArrayLike = (t)=>{
    const n = !!t && t.length;
    const o = $7ed7ccaa27a98189$var$isNumber(n) && n > -1 && n % 1 == 0;
    return $7ed7ccaa27a98189$var$isArray(t) || !$7ed7ccaa27a98189$var$isFunction(t) && o ? n > 0 && $7ed7ccaa27a98189$var$isObject(t) ? n - 1 in t : true : false;
};
const $7ed7ccaa27a98189$var$isPlainObject = (t)=>!!t && t.constructor === Object;
const $7ed7ccaa27a98189$var$isHTMLElement = (t)=>t instanceof HTMLElement;
const $7ed7ccaa27a98189$var$isElement = (t)=>t instanceof Element;
const $7ed7ccaa27a98189$var$animationCurrentTime = ()=>performance.now();
const $7ed7ccaa27a98189$var$animateNumber = (t, n, s, e, c)=>{
    let r = 0;
    const a = $7ed7ccaa27a98189$var$animationCurrentTime();
    const u = $7ed7ccaa27a98189$var$o(0, s);
    const frame = (s)=>{
        const i = $7ed7ccaa27a98189$var$animationCurrentTime();
        const f = i - a;
        const _ = f >= u;
        const d = s ? 1 : 1 - ($7ed7ccaa27a98189$var$o(0, a + u - i) / u || 0);
        const p = (n - t) * ($7ed7ccaa27a98189$var$isFunction(c) ? c(d, d * u, 0, 1, u) : d) + t;
        const v = _ || d === 1;
        if (e) e(p, d, v);
        r = v ? 0 : $7ed7ccaa27a98189$var$l(()=>frame());
    };
    frame();
    return (t)=>{
        $7ed7ccaa27a98189$var$i(r);
        if (t) frame(t);
    };
};
function $7ed7ccaa27a98189$var$each(t, n) {
    if ($7ed7ccaa27a98189$var$isArrayLike(t)) for(let o = 0; o < t.length; o++){
        if (n(t[o], o, t) === false) break;
    }
    else if (t) $7ed7ccaa27a98189$var$each(Object.keys(t), (o)=>n(t[o], o, t));
    return t;
}
const $7ed7ccaa27a98189$var$inArray = (t, n)=>t.indexOf(n) >= 0;
const $7ed7ccaa27a98189$var$concat = (t, n)=>t.concat(n);
const $7ed7ccaa27a98189$var$push = (t, n, o)=>{
    if (!$7ed7ccaa27a98189$var$isString(n) && $7ed7ccaa27a98189$var$isArrayLike(n)) Array.prototype.push.apply(t, n);
    else t.push(n);
    return t;
};
const $7ed7ccaa27a98189$var$from = (t)=>Array.from(t || []);
const $7ed7ccaa27a98189$var$createOrKeepArray = (t)=>{
    if ($7ed7ccaa27a98189$var$isArray(t)) return t;
    return !$7ed7ccaa27a98189$var$isString(t) && $7ed7ccaa27a98189$var$isArrayLike(t) ? $7ed7ccaa27a98189$var$from(t) : [
        t
    ];
};
const $7ed7ccaa27a98189$var$isEmptyArray = (t)=>!!t && !t.length;
const $7ed7ccaa27a98189$var$deduplicateArray = (t)=>$7ed7ccaa27a98189$var$from(new Set(t));
const $7ed7ccaa27a98189$var$runEachAndClear = (t, n, o)=>{
    const runFn = (t)=>t ? t.apply(void 0, n || []) : true;
    $7ed7ccaa27a98189$var$each(t, runFn);
    if (!o) t.length = 0;
};
const $7ed7ccaa27a98189$var$v = "paddingTop";
const $7ed7ccaa27a98189$var$g = "paddingRight";
const $7ed7ccaa27a98189$var$h = "paddingLeft";
const $7ed7ccaa27a98189$var$b = "paddingBottom";
const $7ed7ccaa27a98189$var$w = "marginLeft";
const $7ed7ccaa27a98189$var$y = "marginRight";
const $7ed7ccaa27a98189$var$S = "marginBottom";
const $7ed7ccaa27a98189$var$m = "overflowX";
const $7ed7ccaa27a98189$var$O = "overflowY";
const $7ed7ccaa27a98189$var$C = "width";
const $7ed7ccaa27a98189$var$$ = "height";
const $7ed7ccaa27a98189$var$x = "visible";
const $7ed7ccaa27a98189$var$H = "hidden";
const $7ed7ccaa27a98189$var$E = "scroll";
const $7ed7ccaa27a98189$var$capitalizeFirstLetter = (t)=>{
    const n = String(t || "");
    return n ? n[0].toUpperCase() + n.slice(1) : "";
};
const $7ed7ccaa27a98189$var$equal = (t, n, o, s)=>{
    if (t && n) {
        let s = true;
        $7ed7ccaa27a98189$var$each(o, (o)=>{
            const e = t[o];
            const c = n[o];
            if (e !== c) s = false;
        });
        return s;
    }
    return false;
};
const $7ed7ccaa27a98189$var$equalWH = (t, n)=>$7ed7ccaa27a98189$var$equal(t, n, [
        "w",
        "h"
    ]);
const $7ed7ccaa27a98189$var$equalXY = (t, n)=>$7ed7ccaa27a98189$var$equal(t, n, [
        "x",
        "y"
    ]);
const $7ed7ccaa27a98189$var$equalTRBL = (t, n)=>$7ed7ccaa27a98189$var$equal(t, n, [
        "t",
        "r",
        "b",
        "l"
    ]);
const $7ed7ccaa27a98189$var$bind = (t, ...n)=>t.bind(0, ...n);
const $7ed7ccaa27a98189$var$selfClearTimeout = (t)=>{
    let n;
    const o = t ? $7ed7ccaa27a98189$var$a : $7ed7ccaa27a98189$var$l;
    const s = t ? $7ed7ccaa27a98189$var$u : $7ed7ccaa27a98189$var$i;
    return [
        (e)=>{
            s(n);
            n = o(()=>e(), $7ed7ccaa27a98189$var$isFunction(t) ? t() : t);
        },
        ()=>s(n)
    ];
};
const $7ed7ccaa27a98189$var$getDebouncer = (t)=>{
    const n = $7ed7ccaa27a98189$var$isFunction(t) ? t() : t;
    if ($7ed7ccaa27a98189$var$isNumber(n)) {
        const t = n ? $7ed7ccaa27a98189$var$a : $7ed7ccaa27a98189$var$l;
        const o = n ? $7ed7ccaa27a98189$var$u : $7ed7ccaa27a98189$var$i;
        return (s)=>{
            const e = t(()=>s(), n);
            return ()=>{
                o(e);
            };
        };
    }
    return n && n._;
};
const $7ed7ccaa27a98189$var$debounce = (t, n)=>{
    const { p: o, v: s, S: e, m: c } = n || {};
    let r;
    let i;
    let l;
    let a;
    let u;
    const f = function invokeFunctionToDebounce(n) {
        if (i) i();
        if (r) r();
        u = i = r = l = void 0;
        t.apply(this, n);
    };
    const mergeParms = (t)=>c && l ? c(l, t) : t;
    const flush = ()=>{
        if (i) f(mergeParms(a) || a);
    };
    const _ = function debouncedFn() {
        const t = $7ed7ccaa27a98189$var$from(arguments);
        const n = $7ed7ccaa27a98189$var$getDebouncer(o);
        if (n) {
            const o = $7ed7ccaa27a98189$var$getDebouncer(s);
            const c = mergeParms(t);
            const _ = c || t;
            const d = f.bind(0, _);
            if (i) i();
            if (e && !u) {
                d();
                u = true;
                i = n(()=>u = void 0);
            } else {
                i = n(d);
                if (o && !r) r = o(flush);
            }
            l = a = _;
        } else f(t);
    };
    _.O = flush;
    return _;
};
const $7ed7ccaa27a98189$var$hasOwnProperty = (t, n)=>Object.prototype.hasOwnProperty.call(t, n);
const $7ed7ccaa27a98189$var$keys = (t)=>t ? Object.keys(t) : [];
const $7ed7ccaa27a98189$var$assignDeep = (t, n, o, s, e, c, r)=>{
    const i = [
        n,
        o,
        s,
        e,
        c,
        r
    ];
    if ((typeof t !== "object" || $7ed7ccaa27a98189$var$isNull(t)) && !$7ed7ccaa27a98189$var$isFunction(t)) t = {};
    $7ed7ccaa27a98189$var$each(i, (n)=>{
        $7ed7ccaa27a98189$var$each(n, (o, s)=>{
            const e = n[s];
            if (t === e) return true;
            const c = $7ed7ccaa27a98189$var$isArray(e);
            if (e && $7ed7ccaa27a98189$var$isPlainObject(e)) {
                const n = t[s];
                let o = n;
                if (c && !$7ed7ccaa27a98189$var$isArray(n)) o = [];
                else if (!c && !$7ed7ccaa27a98189$var$isPlainObject(n)) o = {};
                t[s] = $7ed7ccaa27a98189$var$assignDeep(o, e);
            } else t[s] = c ? e.slice() : e;
        });
    });
    return t;
};
const $7ed7ccaa27a98189$var$removeUndefinedProperties = (t, n)=>$7ed7ccaa27a98189$var$each($7ed7ccaa27a98189$var$assignDeep({}, t), (t, n, o)=>{
        if (t === void 0) delete o[n];
        else if (t && $7ed7ccaa27a98189$var$isPlainObject(t)) o[n] = $7ed7ccaa27a98189$var$removeUndefinedProperties(t);
    });
const $7ed7ccaa27a98189$var$isEmptyObject = (t)=>!$7ed7ccaa27a98189$var$keys(t).length;
const $7ed7ccaa27a98189$var$noop = ()=>{};
const $7ed7ccaa27a98189$var$capNumber = (t, n, e)=>$7ed7ccaa27a98189$var$o(t, $7ed7ccaa27a98189$var$s(n, e));
const $7ed7ccaa27a98189$var$getDomTokensArray = (t)=>$7ed7ccaa27a98189$var$deduplicateArray(($7ed7ccaa27a98189$var$isArray(t) ? t : (t || "").split(" ")).filter((t)=>t));
const $7ed7ccaa27a98189$var$getAttr = (t, n)=>t && t.getAttribute(n);
const $7ed7ccaa27a98189$var$hasAttr = (t, n)=>t && t.hasAttribute(n);
const $7ed7ccaa27a98189$var$setAttrs = (t, n, o)=>{
    $7ed7ccaa27a98189$var$each($7ed7ccaa27a98189$var$getDomTokensArray(n), (n)=>{
        if (t) t.setAttribute(n, String(o || ""));
    });
};
const $7ed7ccaa27a98189$var$removeAttrs = (t, n)=>{
    $7ed7ccaa27a98189$var$each($7ed7ccaa27a98189$var$getDomTokensArray(n), (n)=>t && t.removeAttribute(n));
};
const $7ed7ccaa27a98189$var$domTokenListAttr = (t, n)=>{
    const o = $7ed7ccaa27a98189$var$getDomTokensArray($7ed7ccaa27a98189$var$getAttr(t, n));
    const s = $7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$setAttrs, t, n);
    const domTokenListOperation = (t, n)=>{
        const s = new Set(o);
        $7ed7ccaa27a98189$var$each($7ed7ccaa27a98189$var$getDomTokensArray(t), (t)=>{
            s[n](t);
        });
        return $7ed7ccaa27a98189$var$from(s).join(" ");
    };
    return {
        C: (t)=>s(domTokenListOperation(t, "delete")),
        $: (t)=>s(domTokenListOperation(t, "add")),
        H: (t)=>{
            const n = $7ed7ccaa27a98189$var$getDomTokensArray(t);
            return n.reduce((t, n)=>t && o.includes(n), n.length > 0);
        }
    };
};
const $7ed7ccaa27a98189$var$removeAttrClass = (t, n, o)=>{
    $7ed7ccaa27a98189$var$domTokenListAttr(t, n).C(o);
    return $7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$addAttrClass, t, n, o);
};
const $7ed7ccaa27a98189$var$addAttrClass = (t, n, o)=>{
    $7ed7ccaa27a98189$var$domTokenListAttr(t, n).$(o);
    return $7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$removeAttrClass, t, n, o);
};
const $7ed7ccaa27a98189$var$addRemoveAttrClass = (t, n, o, s)=>(s ? $7ed7ccaa27a98189$var$addAttrClass : $7ed7ccaa27a98189$var$removeAttrClass)(t, n, o);
const $7ed7ccaa27a98189$var$hasAttrClass = (t, n, o)=>$7ed7ccaa27a98189$var$domTokenListAttr(t, n).H(o);
const $7ed7ccaa27a98189$var$createDomTokenListClass = (t)=>$7ed7ccaa27a98189$var$domTokenListAttr(t, "class");
const $7ed7ccaa27a98189$var$removeClass = (t, n)=>{
    $7ed7ccaa27a98189$var$createDomTokenListClass(t).C(n);
};
const $7ed7ccaa27a98189$var$addClass = (t, n)=>{
    $7ed7ccaa27a98189$var$createDomTokenListClass(t).$(n);
    return $7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$removeClass, t, n);
};
const $7ed7ccaa27a98189$var$find = (t, n)=>{
    const o = n ? $7ed7ccaa27a98189$var$isElement(n) && n : document;
    return o ? $7ed7ccaa27a98189$var$from(o.querySelectorAll(t)) : [];
};
const $7ed7ccaa27a98189$var$findFirst = (t, n)=>{
    const o = n ? $7ed7ccaa27a98189$var$isElement(n) && n : document;
    return o && o.querySelector(t);
};
const $7ed7ccaa27a98189$var$is = (t, n)=>$7ed7ccaa27a98189$var$isElement(t) && t.matches(n);
const $7ed7ccaa27a98189$var$isBodyElement = (t)=>$7ed7ccaa27a98189$var$is(t, "body");
const $7ed7ccaa27a98189$var$contents = (t)=>t ? $7ed7ccaa27a98189$var$from(t.childNodes) : [];
const $7ed7ccaa27a98189$var$parent = (t)=>t && t.parentElement;
const $7ed7ccaa27a98189$var$closest = (t, n)=>$7ed7ccaa27a98189$var$isElement(t) && t.closest(n);
const $7ed7ccaa27a98189$var$getFocusedElement = (t)=>document.activeElement;
const $7ed7ccaa27a98189$var$liesBetween = (t, n, o)=>{
    const s = $7ed7ccaa27a98189$var$closest(t, n);
    const e = t && $7ed7ccaa27a98189$var$findFirst(o, s);
    const c = $7ed7ccaa27a98189$var$closest(e, n) === s;
    return s && e ? s === t || e === t || c && $7ed7ccaa27a98189$var$closest($7ed7ccaa27a98189$var$closest(t, o), n) !== s : false;
};
const $7ed7ccaa27a98189$var$removeElements = (t)=>{
    $7ed7ccaa27a98189$var$each($7ed7ccaa27a98189$var$createOrKeepArray(t), (t)=>{
        const n = $7ed7ccaa27a98189$var$parent(t);
        if (t && n) n.removeChild(t);
    });
};
const $7ed7ccaa27a98189$var$appendChildren = (t, n)=>$7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$removeElements, t && n && $7ed7ccaa27a98189$var$each($7ed7ccaa27a98189$var$createOrKeepArray(n), (n)=>{
        if (n) t.appendChild(n);
    }));
let $7ed7ccaa27a98189$var$z;
const $7ed7ccaa27a98189$var$getTrustedTypePolicy = ()=>$7ed7ccaa27a98189$var$z;
const $7ed7ccaa27a98189$var$setTrustedTypePolicy = (t)=>{
    $7ed7ccaa27a98189$var$z = t;
};
const $7ed7ccaa27a98189$var$createDiv = (t)=>{
    const n = document.createElement("div");
    $7ed7ccaa27a98189$var$setAttrs(n, "class", t);
    return n;
};
const $7ed7ccaa27a98189$var$createDOM = (t)=>{
    const n = $7ed7ccaa27a98189$var$createDiv();
    const o = $7ed7ccaa27a98189$var$getTrustedTypePolicy();
    const s = t.trim();
    n.innerHTML = o ? o.createHTML(s) : s;
    return $7ed7ccaa27a98189$var$each($7ed7ccaa27a98189$var$contents(n), (t)=>$7ed7ccaa27a98189$var$removeElements(t));
};
const $7ed7ccaa27a98189$var$getCSSVal = (t, n)=>t.getPropertyValue(n) || t[n] || "";
const $7ed7ccaa27a98189$var$validFiniteNumber = (t)=>{
    const n = t || 0;
    return isFinite(n) ? n : 0;
};
const $7ed7ccaa27a98189$var$parseToZeroOrNumber = (t)=>$7ed7ccaa27a98189$var$validFiniteNumber(parseFloat(t || ""));
const $7ed7ccaa27a98189$var$roundCssNumber = (t)=>Math.round(t * 1e4) / 1e4;
const $7ed7ccaa27a98189$var$numberToCssPx = (t)=>`${$7ed7ccaa27a98189$var$roundCssNumber($7ed7ccaa27a98189$var$validFiniteNumber(t))}px`;
function $7ed7ccaa27a98189$var$setStyles(t, n) {
    t && n && $7ed7ccaa27a98189$var$each(n, (n, o)=>{
        try {
            const s = t.style;
            const e = $7ed7ccaa27a98189$var$isNull(n) || $7ed7ccaa27a98189$var$isBoolean(n) ? "" : $7ed7ccaa27a98189$var$isNumber(n) ? $7ed7ccaa27a98189$var$numberToCssPx(n) : n;
            if (o.indexOf("--") === 0) s.setProperty(o, e);
            else s[o] = e;
        } catch (s) {}
    });
}
function $7ed7ccaa27a98189$var$getStyles(t, o, s) {
    const e = $7ed7ccaa27a98189$var$isString(o);
    let c = e ? "" : {};
    if (t) {
        const r = $7ed7ccaa27a98189$var$n.getComputedStyle(t, s) || t.style;
        c = e ? $7ed7ccaa27a98189$var$getCSSVal(r, o) : $7ed7ccaa27a98189$var$from(o).reduce((t, n)=>{
            t[n] = $7ed7ccaa27a98189$var$getCSSVal(r, n);
            return t;
        }, c);
    }
    return c;
}
const $7ed7ccaa27a98189$var$topRightBottomLeft = (t, n, o)=>{
    const s = n ? `${n}-` : "";
    const e = o ? `-${o}` : "";
    const c = `${s}top${e}`;
    const r = `${s}right${e}`;
    const i = `${s}bottom${e}`;
    const l = `${s}left${e}`;
    const a = $7ed7ccaa27a98189$var$getStyles(t, [
        c,
        r,
        i,
        l
    ]);
    return {
        t: $7ed7ccaa27a98189$var$parseToZeroOrNumber(a[c]),
        r: $7ed7ccaa27a98189$var$parseToZeroOrNumber(a[r]),
        b: $7ed7ccaa27a98189$var$parseToZeroOrNumber(a[i]),
        l: $7ed7ccaa27a98189$var$parseToZeroOrNumber(a[l])
    };
};
const $7ed7ccaa27a98189$var$getTrasformTranslateValue = (t, n)=>`translate${$7ed7ccaa27a98189$var$isObject(t) ? `(${t.x},${t.y})` : `${n ? "X" : "Y"}(${t})`}`;
const $7ed7ccaa27a98189$var$elementHasDimensions = (t)=>!!(t.offsetWidth || t.offsetHeight || t.getClientRects().length);
const $7ed7ccaa27a98189$var$T = {
    w: 0,
    h: 0
};
const $7ed7ccaa27a98189$var$getElmWidthHeightProperty = (t, n)=>n ? {
        w: n[`${t}Width`],
        h: n[`${t}Height`]
    } : $7ed7ccaa27a98189$var$T;
const $7ed7ccaa27a98189$var$getWindowSize = (t)=>$7ed7ccaa27a98189$var$getElmWidthHeightProperty("inner", t || $7ed7ccaa27a98189$var$n);
const $7ed7ccaa27a98189$var$I = $7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$getElmWidthHeightProperty, "offset");
const $7ed7ccaa27a98189$var$A = $7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$getElmWidthHeightProperty, "client");
const $7ed7ccaa27a98189$var$D = $7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$getElmWidthHeightProperty, "scroll");
const $7ed7ccaa27a98189$var$getFractionalSize = (t)=>{
    const n = parseFloat($7ed7ccaa27a98189$var$getStyles(t, $7ed7ccaa27a98189$var$C)) || 0;
    const o = parseFloat($7ed7ccaa27a98189$var$getStyles(t, $7ed7ccaa27a98189$var$$)) || 0;
    return {
        w: n - $7ed7ccaa27a98189$var$e(n),
        h: o - $7ed7ccaa27a98189$var$e(o)
    };
};
const $7ed7ccaa27a98189$var$getBoundingClientRect = (t)=>t.getBoundingClientRect();
const $7ed7ccaa27a98189$var$hasDimensions = (t)=>!!t && $7ed7ccaa27a98189$var$elementHasDimensions(t);
const $7ed7ccaa27a98189$var$domRectHasDimensions = (t)=>!!(t && (t[$7ed7ccaa27a98189$var$$] || t[$7ed7ccaa27a98189$var$C]));
const $7ed7ccaa27a98189$var$domRectAppeared = (t, n)=>{
    const o = $7ed7ccaa27a98189$var$domRectHasDimensions(t);
    const s = $7ed7ccaa27a98189$var$domRectHasDimensions(n);
    return !s && o;
};
const $7ed7ccaa27a98189$var$removeEventListener = (t, n, o, s)=>{
    $7ed7ccaa27a98189$var$each($7ed7ccaa27a98189$var$getDomTokensArray(n), (n)=>{
        if (t) t.removeEventListener(n, o, s);
    });
};
const $7ed7ccaa27a98189$var$addEventListener = (t, n, o, s)=>{
    var e;
    const c = (e = s && s.T) != null ? e : true;
    const r = s && s.I || false;
    const i = s && s.A || false;
    const l = {
        passive: c,
        capture: r
    };
    return $7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$runEachAndClear, $7ed7ccaa27a98189$var$getDomTokensArray(n).map((n)=>{
        const s = i ? (e)=>{
            $7ed7ccaa27a98189$var$removeEventListener(t, n, s, r);
            if (o) o(e);
        } : o;
        if (t) t.addEventListener(n, s, l);
        return $7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$removeEventListener, t, n, s, r);
    }));
};
const $7ed7ccaa27a98189$var$stopPropagation = (t)=>t.stopPropagation();
const $7ed7ccaa27a98189$var$preventDefault = (t)=>t.preventDefault();
const $7ed7ccaa27a98189$var$stopAndPrevent = (t)=>$7ed7ccaa27a98189$var$stopPropagation(t) || $7ed7ccaa27a98189$var$preventDefault(t);
const $7ed7ccaa27a98189$var$scrollElementTo = (t, n)=>{
    const { x: o, y: s } = $7ed7ccaa27a98189$var$isNumber(n) ? {
        x: n,
        y: n
    } : n || {};
    $7ed7ccaa27a98189$var$isNumber(o) && (t.scrollLeft = o);
    $7ed7ccaa27a98189$var$isNumber(s) && (t.scrollTop = s);
};
const $7ed7ccaa27a98189$var$getElementScroll = (t)=>({
        x: t.scrollLeft,
        y: t.scrollTop
    });
const $7ed7ccaa27a98189$var$getZeroScrollCoordinates = ()=>({
        D: {
            x: 0,
            y: 0
        },
        M: {
            x: 0,
            y: 0
        }
    });
const $7ed7ccaa27a98189$var$sanitizeScrollCoordinates = (t, n)=>{
    const { D: o, M: s } = t;
    const { w: e, h: i } = n;
    const sanitizeAxis = (t, n, o)=>{
        let s = $7ed7ccaa27a98189$var$r(t) * o;
        let e = $7ed7ccaa27a98189$var$r(n) * o;
        if (s === e) {
            const o = $7ed7ccaa27a98189$var$c(t);
            const r = $7ed7ccaa27a98189$var$c(n);
            e = o > r ? 0 : e;
            s = o < r ? 0 : s;
        }
        s = s === e ? 0 : s;
        return [
            s + 0,
            e + 0
        ];
    };
    const [l, a] = sanitizeAxis(o.x, s.x, e);
    const [u, f] = sanitizeAxis(o.y, s.y, i);
    return {
        D: {
            x: l,
            y: u
        },
        M: {
            x: a,
            y: f
        }
    };
};
const $7ed7ccaa27a98189$var$isDefaultDirectionScrollCoordinates = ({ D: t, M: n })=>{
    const getAxis = (t, n)=>t === 0 && t <= n;
    return {
        x: getAxis(t.x, n.x),
        y: getAxis(t.y, n.y)
    };
};
const $7ed7ccaa27a98189$var$getScrollCoordinatesPercent = ({ D: t, M: n }, o)=>{
    const getAxis = (t, n, o)=>$7ed7ccaa27a98189$var$capNumber(0, 1, (t - o) / (t - n) || 0);
    return {
        x: getAxis(t.x, n.x, o.x),
        y: getAxis(t.y, n.y, o.y)
    };
};
const $7ed7ccaa27a98189$var$focusElement = (t)=>{
    if (t && t.focus) t.focus({
        preventScroll: true
    });
};
const $7ed7ccaa27a98189$var$manageListener = (t, n)=>{
    $7ed7ccaa27a98189$var$each($7ed7ccaa27a98189$var$createOrKeepArray(n), t);
};
const $7ed7ccaa27a98189$var$createEventListenerHub = (t)=>{
    const n = new Map;
    const removeEvent = (t, o)=>{
        if (t) {
            const s = n.get(t);
            $7ed7ccaa27a98189$var$manageListener((t)=>{
                if (s) s[t ? "delete" : "clear"](t);
            }, o);
        } else {
            n.forEach((t)=>{
                t.clear();
            });
            n.clear();
        }
    };
    const addEvent = (t, o)=>{
        if ($7ed7ccaa27a98189$var$isString(t)) {
            const s = n.get(t) || new Set;
            n.set(t, s);
            $7ed7ccaa27a98189$var$manageListener((t)=>{
                if ($7ed7ccaa27a98189$var$isFunction(t)) s.add(t);
            }, o);
            return $7ed7ccaa27a98189$var$bind(removeEvent, t, o);
        }
        if ($7ed7ccaa27a98189$var$isBoolean(o) && o) removeEvent();
        const s = $7ed7ccaa27a98189$var$keys(t);
        const e = [];
        $7ed7ccaa27a98189$var$each(s, (n)=>{
            const o = t[n];
            if (o) $7ed7ccaa27a98189$var$push(e, addEvent(n, o));
        });
        return $7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$runEachAndClear, e);
    };
    const triggerEvent = (t, o)=>{
        $7ed7ccaa27a98189$var$each($7ed7ccaa27a98189$var$from(n.get(t)), (t)=>{
            if (o && !$7ed7ccaa27a98189$var$isEmptyArray(o)) t.apply(0, o);
            else t();
        });
    };
    addEvent(t || {});
    return [
        addEvent,
        removeEvent,
        triggerEvent
    ];
};
const $7ed7ccaa27a98189$var$M = {};
const $7ed7ccaa27a98189$var$k = {};
const $7ed7ccaa27a98189$var$addPlugins = (t)=>{
    $7ed7ccaa27a98189$var$each(t, (t)=>$7ed7ccaa27a98189$var$each(t, (n, o)=>{
            $7ed7ccaa27a98189$var$M[o] = t[o];
        }));
};
const $7ed7ccaa27a98189$var$registerPluginModuleInstances = (t, n, o)=>$7ed7ccaa27a98189$var$keys(t).map((s)=>{
        const { static: e, instance: c } = t[s];
        const [r, i, l] = o || [];
        const a = o ? c : e;
        if (a) {
            const t = o ? a(r, i, n) : a(n);
            return (l || $7ed7ccaa27a98189$var$k)[s] = t;
        }
    });
const $7ed7ccaa27a98189$var$getStaticPluginModuleInstance = (t)=>$7ed7ccaa27a98189$var$k[t];
const $7ed7ccaa27a98189$var$R = "__osOptionsValidationPlugin";
const $7ed7ccaa27a98189$var$V = `data-overlayscrollbars`;
const $7ed7ccaa27a98189$var$L = "os-environment";
const $7ed7ccaa27a98189$var$U = `${$7ed7ccaa27a98189$var$L}-scrollbar-hidden`;
const $7ed7ccaa27a98189$var$P = `${$7ed7ccaa27a98189$var$V}-initialize`;
const $7ed7ccaa27a98189$var$N = "noClipping";
const $7ed7ccaa27a98189$var$q = `${$7ed7ccaa27a98189$var$V}-body`;
const $7ed7ccaa27a98189$var$B = $7ed7ccaa27a98189$var$V;
const $7ed7ccaa27a98189$var$F = "host";
const $7ed7ccaa27a98189$var$j = `${$7ed7ccaa27a98189$var$V}-viewport`;
const $7ed7ccaa27a98189$var$X = $7ed7ccaa27a98189$var$m;
const $7ed7ccaa27a98189$var$Y = $7ed7ccaa27a98189$var$O;
const $7ed7ccaa27a98189$var$W = "arrange";
const $7ed7ccaa27a98189$var$J = "measuring";
const $7ed7ccaa27a98189$var$G = "scrolling";
const $7ed7ccaa27a98189$var$K = "scrollbarHidden";
const $7ed7ccaa27a98189$var$Q = "noContent";
const $7ed7ccaa27a98189$var$Z = `${$7ed7ccaa27a98189$var$V}-padding`;
const $7ed7ccaa27a98189$var$tt = `${$7ed7ccaa27a98189$var$V}-content`;
const $7ed7ccaa27a98189$var$nt = "os-size-observer";
const $7ed7ccaa27a98189$var$ot = `${$7ed7ccaa27a98189$var$nt}-appear`;
const $7ed7ccaa27a98189$var$st = `${$7ed7ccaa27a98189$var$nt}-listener`;
const $7ed7ccaa27a98189$var$et = `${$7ed7ccaa27a98189$var$st}-scroll`;
const $7ed7ccaa27a98189$var$ct = `${$7ed7ccaa27a98189$var$st}-item`;
const $7ed7ccaa27a98189$var$rt = `${$7ed7ccaa27a98189$var$ct}-final`;
const $7ed7ccaa27a98189$var$it = "os-trinsic-observer";
const $7ed7ccaa27a98189$var$lt = "os-theme-none";
const $7ed7ccaa27a98189$var$at = "os-scrollbar";
const $7ed7ccaa27a98189$var$ut = `${$7ed7ccaa27a98189$var$at}-rtl`;
const $7ed7ccaa27a98189$var$ft = `${$7ed7ccaa27a98189$var$at}-horizontal`;
const $7ed7ccaa27a98189$var$_t = `${$7ed7ccaa27a98189$var$at}-vertical`;
const $7ed7ccaa27a98189$var$dt = `${$7ed7ccaa27a98189$var$at}-track`;
const $7ed7ccaa27a98189$var$pt = `${$7ed7ccaa27a98189$var$at}-handle`;
const $7ed7ccaa27a98189$var$vt = `${$7ed7ccaa27a98189$var$at}-visible`;
const $7ed7ccaa27a98189$var$gt = `${$7ed7ccaa27a98189$var$at}-cornerless`;
const $7ed7ccaa27a98189$var$ht = `${$7ed7ccaa27a98189$var$at}-interaction`;
const $7ed7ccaa27a98189$var$bt = `${$7ed7ccaa27a98189$var$at}-unusable`;
const $7ed7ccaa27a98189$var$wt = `${$7ed7ccaa27a98189$var$at}-auto-hide`;
const $7ed7ccaa27a98189$var$yt = `${$7ed7ccaa27a98189$var$wt}-hidden`;
const $7ed7ccaa27a98189$var$St = `${$7ed7ccaa27a98189$var$at}-wheel`;
const $7ed7ccaa27a98189$var$mt = `${$7ed7ccaa27a98189$var$dt}-interactive`;
const $7ed7ccaa27a98189$var$Ot = `${$7ed7ccaa27a98189$var$pt}-interactive`;
const $7ed7ccaa27a98189$var$Ct = "__osSizeObserverPlugin";
const $7ed7ccaa27a98189$export$c327021fb99a6481 = /* @__PURE__ */ (()=>({
        [$7ed7ccaa27a98189$var$Ct]: {
            static: ()=>(t, n, o)=>{
                    const s = 3333333;
                    const e = "scroll";
                    const c = $7ed7ccaa27a98189$var$createDOM(`<div class="${$7ed7ccaa27a98189$var$ct}" dir="ltr"><div class="${$7ed7ccaa27a98189$var$ct}"><div class="${$7ed7ccaa27a98189$var$rt}"></div></div><div class="${$7ed7ccaa27a98189$var$ct}"><div class="${$7ed7ccaa27a98189$var$rt}" style="width: 200%; height: 200%"></div></div></div>`);
                    const r = c[0];
                    const a = r.lastChild;
                    const u = r.firstChild;
                    const f = u == null ? void 0 : u.firstChild;
                    let _ = $7ed7ccaa27a98189$var$I(r);
                    let d = _;
                    let p = false;
                    let v;
                    const reset = ()=>{
                        $7ed7ccaa27a98189$var$scrollElementTo(u, s);
                        $7ed7ccaa27a98189$var$scrollElementTo(a, s);
                    };
                    const onResized = (t)=>{
                        v = 0;
                        if (p) {
                            _ = d;
                            n(t === true);
                        }
                    };
                    const onScroll = (t)=>{
                        d = $7ed7ccaa27a98189$var$I(r);
                        p = !t || !$7ed7ccaa27a98189$var$equalWH(d, _);
                        if (t) {
                            $7ed7ccaa27a98189$var$stopPropagation(t);
                            if (p && !v) {
                                $7ed7ccaa27a98189$var$i(v);
                                v = $7ed7ccaa27a98189$var$l(onResized);
                            }
                        } else onResized(t === false);
                        reset();
                    };
                    const g = [
                        $7ed7ccaa27a98189$var$appendChildren(t, c),
                        $7ed7ccaa27a98189$var$addEventListener(u, e, onScroll),
                        $7ed7ccaa27a98189$var$addEventListener(a, e, onScroll)
                    ];
                    $7ed7ccaa27a98189$var$addClass(t, $7ed7ccaa27a98189$var$et);
                    $7ed7ccaa27a98189$var$setStyles(f, {
                        [$7ed7ccaa27a98189$var$C]: s,
                        [$7ed7ccaa27a98189$var$$]: s
                    });
                    $7ed7ccaa27a98189$var$l(reset);
                    return [
                        o ? $7ed7ccaa27a98189$var$bind(onScroll, false) : reset,
                        g
                    ];
                }
        }
    }))();
const $7ed7ccaa27a98189$var$getShowNativeOverlaidScrollbars = (t, n)=>{
    const { k: o } = n;
    const [s, e] = t("showNativeOverlaidScrollbars");
    return [
        s && o.x && o.y,
        e
    ];
};
const $7ed7ccaa27a98189$var$overflowIsVisible = (t)=>t.indexOf($7ed7ccaa27a98189$var$x) === 0;
const $7ed7ccaa27a98189$var$overflowBehaviorToOverflowStyle = (t)=>t.replace(`${$7ed7ccaa27a98189$var$x}-`, "");
const $7ed7ccaa27a98189$var$overflowCssValueToOverflowStyle = (t, n)=>{
    if (t === "auto") return n ? $7ed7ccaa27a98189$var$E : $7ed7ccaa27a98189$var$H;
    const o = t || $7ed7ccaa27a98189$var$H;
    return [
        $7ed7ccaa27a98189$var$H,
        $7ed7ccaa27a98189$var$E,
        $7ed7ccaa27a98189$var$x
    ].includes(o) ? o : $7ed7ccaa27a98189$var$H;
};
const $7ed7ccaa27a98189$var$getElementOverflowStyle = (t, n)=>{
    const { overflowX: o, overflowY: s } = $7ed7ccaa27a98189$var$getStyles(t, [
        $7ed7ccaa27a98189$var$m,
        $7ed7ccaa27a98189$var$O
    ]);
    return {
        x: $7ed7ccaa27a98189$var$overflowCssValueToOverflowStyle(o, n.x),
        y: $7ed7ccaa27a98189$var$overflowCssValueToOverflowStyle(s, n.y)
    };
};
const $7ed7ccaa27a98189$var$xt = "__osScrollbarsHidingPlugin";
const $7ed7ccaa27a98189$export$8c9a9f9ae72a1689 = /* @__PURE__ */ (()=>({
        [$7ed7ccaa27a98189$var$xt]: {
            static: ()=>({
                    R: (t, n, o, s, e)=>{
                        const { V: c, L: r } = t;
                        const { U: i, k: l, P: a } = s;
                        const u = !c && !i && (l.x || l.y);
                        const [f] = $7ed7ccaa27a98189$var$getShowNativeOverlaidScrollbars(e, s);
                        const _getViewportOverflowHideOffset = (t)=>{
                            const n = i || f ? 0 : 42;
                            const getHideOffsetPerAxis = (t, o, s)=>{
                                const e = t ? n : s;
                                const c = o && !i ? e : 0;
                                const r = t && !!n;
                                return [
                                    c,
                                    r
                                ];
                            };
                            const [o, s] = getHideOffsetPerAxis(l.x, t.x === $7ed7ccaa27a98189$var$E, a.x);
                            const [e, c] = getHideOffsetPerAxis(l.y, t.y === $7ed7ccaa27a98189$var$E, a.y);
                            return {
                                N: {
                                    x: o,
                                    y: e
                                },
                                q: {
                                    x: s,
                                    y: c
                                }
                            };
                        };
                        const _hideNativeScrollbars = (t)=>{
                            if (!c) {
                                const { B: s } = o;
                                const e = $7ed7ccaa27a98189$var$assignDeep({}, {
                                    [$7ed7ccaa27a98189$var$y]: 0,
                                    [$7ed7ccaa27a98189$var$S]: 0,
                                    [$7ed7ccaa27a98189$var$w]: 0
                                });
                                const { N: c, q: r } = _getViewportOverflowHideOffset(t);
                                const { x: i, y: l } = r;
                                const { x: a, y: f } = c;
                                const { F: _ } = n;
                                const d = s ? $7ed7ccaa27a98189$var$w : $7ed7ccaa27a98189$var$y;
                                const p = s ? $7ed7ccaa27a98189$var$h : $7ed7ccaa27a98189$var$g;
                                const v = _[d];
                                const m = _[$7ed7ccaa27a98189$var$S];
                                const O = _[p];
                                const $ = _[$7ed7ccaa27a98189$var$b];
                                e[$7ed7ccaa27a98189$var$C] = `calc(100% + ${f + v * -1}px)`;
                                e[d] = -f + v;
                                e[$7ed7ccaa27a98189$var$S] = -a + m;
                                if (u) {
                                    e[p] = O + (l ? f : 0);
                                    e[$7ed7ccaa27a98189$var$b] = $ + (i ? a : 0);
                                }
                                return e;
                            }
                        };
                        const _arrangeViewport = (t, s, e)=>{
                            if (u) {
                                const { F: c } = n;
                                const { N: i, q: l } = _getViewportOverflowHideOffset(t);
                                const { x: a, y: u } = l;
                                const { x: f, y: _ } = i;
                                const { B: d } = o;
                                const p = d ? $7ed7ccaa27a98189$var$g : $7ed7ccaa27a98189$var$h;
                                const v = c[p];
                                const b = c.paddingTop;
                                const w = s.w + e.w;
                                const y = s.h + e.h;
                                const S = {
                                    w: _ && u ? `${_ + w - v}px` : "",
                                    h: f && a ? `${f + y - b}px` : ""
                                };
                                $7ed7ccaa27a98189$var$setStyles(r, {
                                    "--os-vaw": S.w,
                                    "--os-vah": S.h
                                });
                            }
                            return u;
                        };
                        const _undoViewportArrange = ()=>{
                            if (u) {
                                const { j: t, F: o } = n;
                                const s = $7ed7ccaa27a98189$var$getElementOverflowStyle(r, t);
                                const { q: e } = _getViewportOverflowHideOffset(s);
                                const { x: c, y: i } = e;
                                const l = {};
                                const assignProps = (t)=>$7ed7ccaa27a98189$var$each(t, (t)=>{
                                        l[t] = o[t];
                                    });
                                if (c) assignProps([
                                    $7ed7ccaa27a98189$var$S,
                                    $7ed7ccaa27a98189$var$v,
                                    $7ed7ccaa27a98189$var$b
                                ]);
                                if (i) assignProps([
                                    $7ed7ccaa27a98189$var$w,
                                    $7ed7ccaa27a98189$var$y,
                                    $7ed7ccaa27a98189$var$h,
                                    $7ed7ccaa27a98189$var$g
                                ]);
                                const a = $7ed7ccaa27a98189$var$getStyles(r, $7ed7ccaa27a98189$var$keys(l));
                                const u = $7ed7ccaa27a98189$var$removeAttrClass(r, $7ed7ccaa27a98189$var$j, $7ed7ccaa27a98189$var$W);
                                $7ed7ccaa27a98189$var$setStyles(r, l);
                                return ()=>{
                                    $7ed7ccaa27a98189$var$setStyles(r, $7ed7ccaa27a98189$var$assignDeep({}, a, _hideNativeScrollbars(s)));
                                    u();
                                };
                            }
                            return $7ed7ccaa27a98189$var$noop;
                        };
                        return {
                            X: _arrangeViewport,
                            Y: _undoViewportArrange,
                            W: _hideNativeScrollbars
                        };
                    }
                })
        }
    }))();
const $7ed7ccaa27a98189$var$Et = "__osClickScrollPlugin";
const $7ed7ccaa27a98189$export$1a35b83948406b62 = /* @__PURE__ */ (()=>({
        [$7ed7ccaa27a98189$var$Et]: {
            static: ()=>(t, n, o, s)=>{
                    let e = false;
                    let c = $7ed7ccaa27a98189$var$noop;
                    const r = 133;
                    const i = 222;
                    const [l, a] = $7ed7ccaa27a98189$var$selfClearTimeout(r);
                    const u = Math.sign(n);
                    const f = o * u;
                    const _ = f / 2;
                    const easing = (t)=>1 - (1 - t) * (1 - t);
                    const easedEndPressAnimation = (n, o)=>$7ed7ccaa27a98189$var$animateNumber(n, o, i, t, easing);
                    const linearPressAnimation = (o, s)=>$7ed7ccaa27a98189$var$animateNumber(o, n - f, r * s, (o, s, e)=>{
                            t(o);
                            if (e) c = easedEndPressAnimation(o, n);
                        });
                    const d = $7ed7ccaa27a98189$var$animateNumber(0, f, i, (r, i, a)=>{
                        t(r);
                        if (a) {
                            s(e);
                            if (!e) {
                                const t = n - r;
                                const s = Math.sign(t - _) === u;
                                if (s) l(()=>{
                                    const s = t - f;
                                    const e = Math.sign(s) === u;
                                    c = e ? linearPressAnimation(r, Math.abs(s) / o) : easedEndPressAnimation(r, n);
                                });
                            }
                        }
                    }, easing);
                    return (t)=>{
                        e = true;
                        if (t) d();
                        a();
                        c();
                    };
                }
        }
    }))();
const $7ed7ccaa27a98189$var$opsStringify = (t)=>JSON.stringify(t, (t, n)=>{
        if ($7ed7ccaa27a98189$var$isFunction(n)) throw 0;
        return n;
    });
const $7ed7ccaa27a98189$var$getPropByPath = (t, n)=>t ? `${n}`.split(".").reduce((t, n)=>t && $7ed7ccaa27a98189$var$hasOwnProperty(t, n) ? t[n] : void 0, t) : void 0;
const $7ed7ccaa27a98189$var$Tt = {
    paddingAbsolute: false,
    showNativeOverlaidScrollbars: false,
    update: {
        elementEvents: [
            [
                "img",
                "load"
            ]
        ],
        debounce: [
            0,
            33
        ],
        attributes: null,
        ignoreMutation: null
    },
    overflow: {
        x: "scroll",
        y: "scroll"
    },
    scrollbars: {
        theme: "os-theme-dark",
        visibility: "auto",
        autoHide: "never",
        autoHideDelay: 1300,
        autoHideSuspend: false,
        dragScroll: true,
        clickScroll: false,
        pointers: [
            "mouse",
            "touch",
            "pen"
        ]
    }
};
const $7ed7ccaa27a98189$var$getOptionsDiff = (t, n)=>{
    const o = {};
    const s = $7ed7ccaa27a98189$var$concat($7ed7ccaa27a98189$var$keys(n), $7ed7ccaa27a98189$var$keys(t));
    $7ed7ccaa27a98189$var$each(s, (s)=>{
        const e = t[s];
        const c = n[s];
        if ($7ed7ccaa27a98189$var$isObject(e) && $7ed7ccaa27a98189$var$isObject(c)) {
            $7ed7ccaa27a98189$var$assignDeep(o[s] = {}, $7ed7ccaa27a98189$var$getOptionsDiff(e, c));
            if ($7ed7ccaa27a98189$var$isEmptyObject(o[s])) delete o[s];
        } else if ($7ed7ccaa27a98189$var$hasOwnProperty(n, s) && c !== e) {
            let t = true;
            if ($7ed7ccaa27a98189$var$isArray(e) || $7ed7ccaa27a98189$var$isArray(c)) try {
                if ($7ed7ccaa27a98189$var$opsStringify(e) === $7ed7ccaa27a98189$var$opsStringify(c)) t = false;
            } catch (r) {}
            if (t) o[s] = c;
        }
    });
    return o;
};
const $7ed7ccaa27a98189$var$createOptionCheck = (t, n, o)=>(s)=>[
            $7ed7ccaa27a98189$var$getPropByPath(t, s),
            o || $7ed7ccaa27a98189$var$getPropByPath(n, s) !== void 0
        ];
let $7ed7ccaa27a98189$var$It;
const $7ed7ccaa27a98189$var$getNonce = ()=>$7ed7ccaa27a98189$var$It;
const $7ed7ccaa27a98189$var$setNonce = (t)=>{
    $7ed7ccaa27a98189$var$It = t;
};
let $7ed7ccaa27a98189$var$At;
const $7ed7ccaa27a98189$var$createEnvironment = ()=>{
    const getNativeScrollbarSize = (t, n, o)=>{
        $7ed7ccaa27a98189$var$appendChildren(document.body, t);
        $7ed7ccaa27a98189$var$appendChildren(document.body, t);
        const s = $7ed7ccaa27a98189$var$A(t);
        const e = $7ed7ccaa27a98189$var$I(t);
        const c = $7ed7ccaa27a98189$var$getFractionalSize(n);
        if (o) $7ed7ccaa27a98189$var$removeElements(t);
        return {
            x: e.h - s.h + c.h,
            y: e.w - s.w + c.w
        };
    };
    const getNativeScrollbarsHiding = (t)=>{
        let n = false;
        const o = $7ed7ccaa27a98189$var$addClass(t, $7ed7ccaa27a98189$var$U);
        try {
            n = $7ed7ccaa27a98189$var$getStyles(t, "scrollbar-width") === "none" || $7ed7ccaa27a98189$var$getStyles(t, "display", "::-webkit-scrollbar") === "none";
        } catch (s) {}
        o();
        return n;
    };
    const t = `.${$7ed7ccaa27a98189$var$L}{scroll-behavior:auto!important;position:fixed;opacity:0;visibility:hidden;overflow:scroll;height:200px;width:200px;z-index:-1}.${$7ed7ccaa27a98189$var$L} div{width:200%;height:200%;margin:10px 0}.${$7ed7ccaa27a98189$var$U}{scrollbar-width:none!important}.${$7ed7ccaa27a98189$var$U}::-webkit-scrollbar,.${$7ed7ccaa27a98189$var$U}::-webkit-scrollbar-corner{appearance:none!important;display:none!important;width:0!important;height:0!important}`;
    const o = $7ed7ccaa27a98189$var$createDOM(`<div class="${$7ed7ccaa27a98189$var$L}"><div></div><style>${t}</style></div>`);
    const s = o[0];
    const e = s.firstChild;
    const c = s.lastChild;
    const r = $7ed7ccaa27a98189$var$getNonce();
    if (r) c.nonce = r;
    const [i, , l] = $7ed7ccaa27a98189$var$createEventListenerHub();
    const [a, u] = $7ed7ccaa27a98189$var$createCache({
        o: getNativeScrollbarSize(s, e),
        i: $7ed7ccaa27a98189$var$equalXY
    }, $7ed7ccaa27a98189$var$bind(getNativeScrollbarSize, s, e, true));
    const [f] = u();
    const _ = getNativeScrollbarsHiding(s);
    const d = {
        x: f.x === 0,
        y: f.y === 0
    };
    const v = {
        elements: {
            host: null,
            padding: !_,
            viewport: (t)=>_ && $7ed7ccaa27a98189$var$isBodyElement(t) && t,
            content: false
        },
        scrollbars: {
            slot: true
        },
        cancel: {
            nativeScrollbarsOverlaid: false,
            body: null
        }
    };
    const g = $7ed7ccaa27a98189$var$assignDeep({}, $7ed7ccaa27a98189$var$Tt);
    const h = $7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$assignDeep, {}, g);
    const b = $7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$assignDeep, {}, v);
    const w = {
        P: f,
        k: d,
        U: _,
        J: !!$7ed7ccaa27a98189$var$p,
        G: $7ed7ccaa27a98189$var$bind(i, "r"),
        K: b,
        Z: (t)=>$7ed7ccaa27a98189$var$assignDeep(v, t) && b(),
        tt: h,
        nt: (t)=>$7ed7ccaa27a98189$var$assignDeep(g, t) && h(),
        ot: $7ed7ccaa27a98189$var$assignDeep({}, v),
        st: $7ed7ccaa27a98189$var$assignDeep({}, g)
    };
    $7ed7ccaa27a98189$var$removeAttrs(s, "style");
    $7ed7ccaa27a98189$var$removeElements(s);
    $7ed7ccaa27a98189$var$addEventListener($7ed7ccaa27a98189$var$n, "resize", ()=>{
        l("r", []);
    });
    if ($7ed7ccaa27a98189$var$isFunction($7ed7ccaa27a98189$var$n.matchMedia) && !_ && (!d.x || !d.y)) {
        const addZoomListener = (t)=>{
            const o = $7ed7ccaa27a98189$var$n.matchMedia(`(resolution: ${$7ed7ccaa27a98189$var$n.devicePixelRatio}dppx)`);
            $7ed7ccaa27a98189$var$addEventListener(o, "change", ()=>{
                t();
                addZoomListener(t);
            }, {
                A: true
            });
        };
        addZoomListener(()=>{
            const [t, n] = a();
            $7ed7ccaa27a98189$var$assignDeep(w.P, t);
            l("r", [
                n
            ]);
        });
    }
    return w;
};
const $7ed7ccaa27a98189$var$getEnvironment = ()=>{
    if (!$7ed7ccaa27a98189$var$At) $7ed7ccaa27a98189$var$At = $7ed7ccaa27a98189$var$createEnvironment();
    return $7ed7ccaa27a98189$var$At;
};
const $7ed7ccaa27a98189$var$createEventContentChange = (t, n, o)=>{
    let s = false;
    const e = o ? new WeakMap : false;
    const destroy = ()=>{
        s = true;
    };
    const updateElements = (c)=>{
        if (e && o) {
            const r = o.map((n)=>{
                const [o, s] = n || [];
                const e = s && o ? (c || $7ed7ccaa27a98189$var$find)(o, t) : [];
                return [
                    e,
                    s
                ];
            });
            $7ed7ccaa27a98189$var$each(r, (o)=>$7ed7ccaa27a98189$var$each(o[0], (c)=>{
                    const r = o[1];
                    const i = e.get(c) || [];
                    const l = t.contains(c);
                    if (l && r) {
                        const t = $7ed7ccaa27a98189$var$addEventListener(c, r, (o)=>{
                            if (s) {
                                t();
                                e.delete(c);
                            } else n(o);
                        });
                        e.set(c, $7ed7ccaa27a98189$var$push(i, t));
                    } else {
                        $7ed7ccaa27a98189$var$runEachAndClear(i);
                        e.delete(c);
                    }
                }));
        }
    };
    updateElements();
    return [
        destroy,
        updateElements
    ];
};
const $7ed7ccaa27a98189$var$createDOMObserver = (t, n, o, s)=>{
    let e = false;
    const { et: c, ct: r, rt: i, it: l, lt: a, ut: u } = s || {};
    const _ = $7ed7ccaa27a98189$var$debounce(()=>e && o(true), {
        p: 33,
        v: 99
    });
    const [d, p] = $7ed7ccaa27a98189$var$createEventContentChange(t, _, i);
    const v = c || [];
    const g = r || [];
    const h = $7ed7ccaa27a98189$var$concat(v, g);
    const observerCallback = (e, c)=>{
        if (!$7ed7ccaa27a98189$var$isEmptyArray(c)) {
            const r = a || $7ed7ccaa27a98189$var$noop;
            const i = u || $7ed7ccaa27a98189$var$noop;
            const f = [];
            const _ = [];
            let d = false;
            let v = false;
            $7ed7ccaa27a98189$var$each(c, (o)=>{
                const { attributeName: e, target: c, type: a, oldValue: u, addedNodes: p, removedNodes: h } = o;
                const b = a === "attributes";
                const w = a === "childList";
                const y = t === c;
                const S = b && e;
                const m = S && $7ed7ccaa27a98189$var$getAttr(c, e || "");
                const O = $7ed7ccaa27a98189$var$isString(m) ? m : null;
                const C = S && u !== O;
                const $ = $7ed7ccaa27a98189$var$inArray(g, e) && C;
                if (n && (w || !y)) {
                    const n = b && C;
                    const a = n && l && $7ed7ccaa27a98189$var$is(c, l);
                    const _ = a ? !r(c, e, u, O) : !b || n;
                    const d = _ && !i(o, !!a, t, s);
                    $7ed7ccaa27a98189$var$each(p, (t)=>$7ed7ccaa27a98189$var$push(f, t));
                    $7ed7ccaa27a98189$var$each(h, (t)=>$7ed7ccaa27a98189$var$push(f, t));
                    v = v || d;
                }
                if (!n && y && C && !r(c, e, u, O)) {
                    $7ed7ccaa27a98189$var$push(_, e);
                    d = d || $;
                }
            });
            p((t)=>$7ed7ccaa27a98189$var$deduplicateArray(f).reduce((n, o)=>{
                    $7ed7ccaa27a98189$var$push(n, $7ed7ccaa27a98189$var$find(t, o));
                    return $7ed7ccaa27a98189$var$is(o, t) ? $7ed7ccaa27a98189$var$push(n, o) : n;
                }, []));
            if (n) {
                if (!e && v) o(false);
                return [
                    false
                ];
            }
            if (!$7ed7ccaa27a98189$var$isEmptyArray(_) || d) {
                const t = [
                    $7ed7ccaa27a98189$var$deduplicateArray(_),
                    d
                ];
                if (!e) o.apply(0, t);
                return t;
            }
        }
    };
    const b = new $7ed7ccaa27a98189$var$f($7ed7ccaa27a98189$var$bind(observerCallback, false));
    return [
        ()=>{
            b.observe(t, {
                attributes: true,
                attributeOldValue: true,
                attributeFilter: h,
                subtree: n,
                childList: n,
                characterData: n
            });
            e = true;
            return ()=>{
                if (e) {
                    d();
                    b.disconnect();
                    e = false;
                }
            };
        },
        ()=>{
            if (e) {
                _.O();
                return observerCallback(true, b.takeRecords());
            }
        }
    ];
};
let $7ed7ccaa27a98189$var$Dt = null;
const $7ed7ccaa27a98189$var$createSizeObserver = (t, n, o)=>{
    const { ft: s } = o || {};
    const e = $7ed7ccaa27a98189$var$getStaticPluginModuleInstance($7ed7ccaa27a98189$var$Ct);
    const [c] = $7ed7ccaa27a98189$var$createCache({
        o: false,
        u: true
    });
    return ()=>{
        const o = [];
        const r = $7ed7ccaa27a98189$var$createDOM(`<div class="${$7ed7ccaa27a98189$var$nt}"><div class="${$7ed7ccaa27a98189$var$st}"></div></div>`);
        const i = r[0];
        const l = i.firstChild;
        const onSizeChangedCallbackProxy = (t)=>{
            const o = $7ed7ccaa27a98189$var$isArray(t) && !$7ed7ccaa27a98189$var$isEmptyArray(t);
            let s = false;
            let e = false;
            if (o) {
                const n = t[0];
                const [o, , r] = c(n.contentRect);
                const i = $7ed7ccaa27a98189$var$domRectHasDimensions(o);
                e = $7ed7ccaa27a98189$var$domRectAppeared(o, r);
                s = !e && !i;
            } else e = t === true;
            if (!s) n({
                _t: true,
                ft: e
            });
        };
        if ($7ed7ccaa27a98189$var$d) {
            if (!$7ed7ccaa27a98189$var$isBoolean($7ed7ccaa27a98189$var$Dt)) {
                const n = new $7ed7ccaa27a98189$var$d($7ed7ccaa27a98189$var$noop);
                n.observe(t, {
                    get box () {
                        $7ed7ccaa27a98189$var$Dt = true;
                    }
                });
                $7ed7ccaa27a98189$var$Dt = $7ed7ccaa27a98189$var$Dt || false;
                n.disconnect();
            }
            const n = $7ed7ccaa27a98189$var$debounce(onSizeChangedCallbackProxy, {
                p: 0,
                v: 0
            });
            const resizeObserverCallback = (t)=>n(t);
            const s = new $7ed7ccaa27a98189$var$d(resizeObserverCallback);
            s.observe($7ed7ccaa27a98189$var$Dt ? t : l);
            $7ed7ccaa27a98189$var$push(o, [
                ()=>{
                    s.disconnect();
                },
                !$7ed7ccaa27a98189$var$Dt && $7ed7ccaa27a98189$var$appendChildren(t, i)
            ]);
            if ($7ed7ccaa27a98189$var$Dt) {
                const n = new $7ed7ccaa27a98189$var$d(resizeObserverCallback);
                n.observe(t, {
                    box: "border-box"
                });
                $7ed7ccaa27a98189$var$push(o, ()=>n.disconnect());
            }
        } else if (e) {
            const [n, c] = e(l, onSizeChangedCallbackProxy, s);
            $7ed7ccaa27a98189$var$push(o, $7ed7ccaa27a98189$var$concat([
                $7ed7ccaa27a98189$var$addClass(i, $7ed7ccaa27a98189$var$ot),
                $7ed7ccaa27a98189$var$addEventListener(i, "animationstart", n),
                $7ed7ccaa27a98189$var$appendChildren(t, i)
            ], c));
        } else return $7ed7ccaa27a98189$var$noop;
        return $7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$runEachAndClear, o);
    };
};
const $7ed7ccaa27a98189$var$createTrinsicObserver = (t, n)=>{
    let o;
    const isHeightIntrinsic = (t)=>t.h === 0 || t.isIntersecting || t.intersectionRatio > 0;
    const s = $7ed7ccaa27a98189$var$createDiv($7ed7ccaa27a98189$var$it);
    const [e] = $7ed7ccaa27a98189$var$createCache({
        o: false
    });
    const triggerOnTrinsicChangedCallback = (t, o)=>{
        if (t) {
            const s = e(isHeightIntrinsic(t));
            const [, c] = s;
            return c && !o && n(s) && [
                s
            ];
        }
    };
    const intersectionObserverCallback = (t, n)=>triggerOnTrinsicChangedCallback(n.pop(), t);
    return [
        ()=>{
            const n = [];
            if ($7ed7ccaa27a98189$var$_) {
                o = new $7ed7ccaa27a98189$var$_($7ed7ccaa27a98189$var$bind(intersectionObserverCallback, false), {
                    root: t
                });
                o.observe(s);
                $7ed7ccaa27a98189$var$push(n, ()=>{
                    o.disconnect();
                });
            } else {
                const onSizeChanged = ()=>{
                    const t = $7ed7ccaa27a98189$var$I(s);
                    triggerOnTrinsicChangedCallback(t);
                };
                $7ed7ccaa27a98189$var$push(n, $7ed7ccaa27a98189$var$createSizeObserver(s, onSizeChanged)());
                onSizeChanged();
            }
            return $7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$runEachAndClear, $7ed7ccaa27a98189$var$push(n, $7ed7ccaa27a98189$var$appendChildren(t, s)));
        },
        ()=>o && intersectionObserverCallback(true, o.takeRecords())
    ];
};
const $7ed7ccaa27a98189$var$createObserversSetup = (t, n, o, s)=>{
    let e;
    let c;
    let r;
    let i;
    let l;
    let a;
    const u = `[${$7ed7ccaa27a98189$var$B}]`;
    const f = `[${$7ed7ccaa27a98189$var$j}]`;
    const _ = [
        "id",
        "class",
        "style",
        "open",
        "wrap",
        "cols",
        "rows"
    ];
    const { dt: p, vt: v, L: g, gt: h, ht: b, V: w, bt: y, wt: S, yt: m, St: O } = t;
    const getDirectionIsRTL = (t)=>$7ed7ccaa27a98189$var$getStyles(t, "direction") === "rtl";
    const C = {
        Ot: false,
        B: getDirectionIsRTL(p)
    };
    const $ = $7ed7ccaa27a98189$var$getEnvironment();
    const x = $7ed7ccaa27a98189$var$getStaticPluginModuleInstance($7ed7ccaa27a98189$var$xt);
    const [H] = $7ed7ccaa27a98189$var$createCache({
        i: $7ed7ccaa27a98189$var$equalWH,
        o: {
            w: 0,
            h: 0
        }
    }, ()=>{
        const s = x && x.R(t, n, C, $, o).Y;
        const e = y && w;
        const c = !e && $7ed7ccaa27a98189$var$hasAttrClass(v, $7ed7ccaa27a98189$var$B, $7ed7ccaa27a98189$var$N);
        const r = !w && S($7ed7ccaa27a98189$var$W);
        const i = r && $7ed7ccaa27a98189$var$getElementScroll(h);
        const l = i && O();
        const a = m($7ed7ccaa27a98189$var$J, c);
        const u = r && s && s();
        const f = $7ed7ccaa27a98189$var$D(g);
        const _ = $7ed7ccaa27a98189$var$getFractionalSize(g);
        if (u) u();
        $7ed7ccaa27a98189$var$scrollElementTo(h, i);
        if (l) l();
        if (c) a();
        return {
            w: f.w + _.w,
            h: f.h + _.h
        };
    });
    const E = $7ed7ccaa27a98189$var$debounce(s, {
        p: ()=>e,
        v: ()=>c,
        m (t, n) {
            const [o] = t;
            const [s] = n;
            return [
                $7ed7ccaa27a98189$var$concat($7ed7ccaa27a98189$var$keys(o), $7ed7ccaa27a98189$var$keys(s)).reduce((t, n)=>{
                    t[n] = o[n] || s[n];
                    return t;
                }, {})
            ];
        }
    });
    const setDirection = (t)=>{
        const n = getDirectionIsRTL(p);
        $7ed7ccaa27a98189$var$assignDeep(t, {
            Ct: a !== n
        });
        $7ed7ccaa27a98189$var$assignDeep(C, {
            B: n
        });
        a = n;
    };
    const onTrinsicChanged = (t, n)=>{
        const [o, e] = t;
        const c = {
            $t: e
        };
        $7ed7ccaa27a98189$var$assignDeep(C, {
            Ot: o
        });
        if (!n) s(c);
        return c;
    };
    const onSizeChanged = ({ _t: t, ft: n })=>{
        const o = t && !n;
        const e = !o && $.U ? E : s;
        const c = {
            _t: t || n,
            ft: n
        };
        setDirection(c);
        e(c);
    };
    const onContentMutation = (t, n)=>{
        const [, o] = H();
        const e = {
            xt: o
        };
        setDirection(e);
        const c = t ? s : E;
        if (o && !n) c(e);
        return e;
    };
    const onHostMutation = (t, n, o)=>{
        const s = {
            Ht: n
        };
        setDirection(s);
        if (n && !o) E(s);
        return s;
    };
    const [z, T] = b ? $7ed7ccaa27a98189$var$createTrinsicObserver(v, onTrinsicChanged) : [];
    const I = !w && $7ed7ccaa27a98189$var$createSizeObserver(v, onSizeChanged, {
        ft: true
    });
    const [A, M] = $7ed7ccaa27a98189$var$createDOMObserver(v, false, onHostMutation, {
        ct: _,
        et: _
    });
    const k = w && $7ed7ccaa27a98189$var$d && new $7ed7ccaa27a98189$var$d((t)=>{
        const n = t[t.length - 1].contentRect;
        onSizeChanged({
            _t: true,
            ft: $7ed7ccaa27a98189$var$domRectAppeared(n, l)
        });
        l = n;
    });
    const R = $7ed7ccaa27a98189$var$debounce(()=>{
        const [, t] = H();
        s({
            xt: t,
            _t: y
        });
    }, {
        p: 222,
        S: true
    });
    return [
        ()=>{
            if (k) k.observe(v);
            const t = I && I();
            const n = z && z();
            const o = A();
            const s = $.G((t)=>{
                if (t) E({
                    Et: t
                });
                else R();
            });
            return ()=>{
                if (k) k.disconnect();
                if (t) t();
                if (n) n();
                if (i) i();
                o();
                s();
            };
        },
        ({ zt: t, Tt: n, It: o })=>{
            const s = {};
            const [l] = t("update.ignoreMutation");
            const [a, d] = t("update.attributes");
            const [p, v] = t("update.elementEvents");
            const [h, y] = t("update.debounce");
            const S = v || d;
            const m = n || o;
            const ignoreMutationFromOptions = (t)=>$7ed7ccaa27a98189$var$isFunction(l) && l(t);
            if (S) {
                if (r) r();
                if (i) i();
                const [t, n] = $7ed7ccaa27a98189$var$createDOMObserver(b || g, true, onContentMutation, {
                    et: $7ed7ccaa27a98189$var$concat(_, a || []),
                    rt: p,
                    it: u,
                    ut: (t, n)=>{
                        const { target: o, attributeName: s } = t;
                        const e = !n && s && !w ? $7ed7ccaa27a98189$var$liesBetween(o, u, f) : false;
                        return e || !!$7ed7ccaa27a98189$var$closest(o, `.${$7ed7ccaa27a98189$var$at}`) || !!ignoreMutationFromOptions(t);
                    }
                });
                i = t();
                r = n;
            }
            if (y) {
                E.O();
                if ($7ed7ccaa27a98189$var$isArray(h)) {
                    const t = h[0];
                    const n = h[1];
                    e = $7ed7ccaa27a98189$var$isNumber(t) && t;
                    c = $7ed7ccaa27a98189$var$isNumber(n) && n;
                } else if ($7ed7ccaa27a98189$var$isNumber(h)) {
                    e = h;
                    c = false;
                } else {
                    e = false;
                    c = false;
                }
            }
            if (m) {
                const t = M();
                const n = T && T();
                const o = r && r();
                if (t) $7ed7ccaa27a98189$var$assignDeep(s, onHostMutation(t[0], t[1], m));
                if (n) $7ed7ccaa27a98189$var$assignDeep(s, onTrinsicChanged(n[0], m));
                if (o) $7ed7ccaa27a98189$var$assignDeep(s, onContentMutation(o[0], m));
            }
            setDirection(s);
            return s;
        },
        C
    ];
};
const $7ed7ccaa27a98189$var$resolveInitialization = (t, n)=>$7ed7ccaa27a98189$var$isFunction(n) ? n.apply(0, t) : n;
const $7ed7ccaa27a98189$var$staticInitializationElement = (t, n, o, s)=>{
    const e = $7ed7ccaa27a98189$var$isUndefined(s) ? o : s;
    const c = $7ed7ccaa27a98189$var$resolveInitialization(t, e);
    return c || n.apply(0, t);
};
const $7ed7ccaa27a98189$var$dynamicInitializationElement = (t, n, o, s)=>{
    const e = $7ed7ccaa27a98189$var$isUndefined(s) ? o : s;
    const c = $7ed7ccaa27a98189$var$resolveInitialization(t, e);
    return !!c && ($7ed7ccaa27a98189$var$isHTMLElement(c) ? c : n.apply(0, t));
};
const $7ed7ccaa27a98189$var$cancelInitialization = (t, n)=>{
    const { nativeScrollbarsOverlaid: o, body: s } = n || {};
    const { k: e, U: c, K: r } = $7ed7ccaa27a98189$var$getEnvironment();
    const { nativeScrollbarsOverlaid: i, body: l } = r().cancel;
    const a = o != null ? o : i;
    const u = $7ed7ccaa27a98189$var$isUndefined(s) ? l : s;
    const f = (e.x || e.y) && a;
    const _ = t && ($7ed7ccaa27a98189$var$isNull(u) ? !c : u);
    return !!f || !!_;
};
const $7ed7ccaa27a98189$var$createScrollbarsSetupElements = (t, n, o, s)=>{
    const e = "--os-viewport-percent";
    const c = "--os-scroll-percent";
    const r = "--os-scroll-direction";
    const { K: i } = $7ed7ccaa27a98189$var$getEnvironment();
    const { scrollbars: l } = i();
    const { slot: a } = l;
    const { dt: u, vt: f, L: _, At: d, gt: v, bt: g, V: h } = n;
    const { scrollbars: b } = d ? {} : t;
    const { slot: w } = b || {};
    const y = [];
    const S = [];
    const m = [];
    const O = $7ed7ccaa27a98189$var$dynamicInitializationElement([
        u,
        f,
        _
    ], ()=>h && g ? u : f, a, w);
    const initScrollTimeline = (t)=>{
        if ($7ed7ccaa27a98189$var$p) {
            let n = null;
            let s = [];
            const e = new $7ed7ccaa27a98189$var$p({
                source: v,
                axis: t
            });
            const cancelAnimation = ()=>{
                if (n) n.cancel();
                n = null;
            };
            const _setScrollPercentAnimation = (c)=>{
                const { Dt: r } = o;
                const i = $7ed7ccaa27a98189$var$isDefaultDirectionScrollCoordinates(r)[t];
                const l = t === "x";
                const a = [
                    $7ed7ccaa27a98189$var$getTrasformTranslateValue(0, l),
                    $7ed7ccaa27a98189$var$getTrasformTranslateValue(`calc(100cq${l ? "w" : "h"} + -100%)`, l)
                ];
                const u = i ? a : a.reverse();
                if (s[0] === u[0] && s[1] === u[1]) return cancelAnimation;
                cancelAnimation();
                s = u;
                n = c.Mt.animate({
                    clear: [
                        "left"
                    ],
                    transform: u
                }, {
                    timeline: e
                });
                return cancelAnimation;
            };
            return {
                kt: _setScrollPercentAnimation
            };
        }
    };
    const C = {
        x: initScrollTimeline("x"),
        y: initScrollTimeline("y")
    };
    const getViewportPercent = ()=>{
        const { Rt: t, Vt: n } = o;
        const getAxisValue = (t, n)=>$7ed7ccaa27a98189$var$capNumber(0, 1, t / (t + n) || 0);
        return {
            x: getAxisValue(n.x, t.x),
            y: getAxisValue(n.y, t.y)
        };
    };
    const scrollbarStructureAddRemoveClass = (t, n, o)=>{
        const s = o ? $7ed7ccaa27a98189$var$addClass : $7ed7ccaa27a98189$var$removeClass;
        $7ed7ccaa27a98189$var$each(t, (t)=>{
            s(t.Lt, n);
        });
    };
    const scrollbarStyle = (t, n)=>{
        $7ed7ccaa27a98189$var$each(t, (t)=>{
            const [o, s] = n(t);
            $7ed7ccaa27a98189$var$setStyles(o, s);
        });
    };
    const scrollbarsAddRemoveClass = (t, n, o)=>{
        const s = $7ed7ccaa27a98189$var$isBoolean(o);
        const e = s ? o : true;
        const c = s ? !o : true;
        if (e) scrollbarStructureAddRemoveClass(S, t, n);
        if (c) scrollbarStructureAddRemoveClass(m, t, n);
    };
    const refreshScrollbarsHandleLength = ()=>{
        const t = getViewportPercent();
        const createScrollbarStyleFn = (t)=>(n)=>[
                    n.Lt,
                    {
                        [e]: $7ed7ccaa27a98189$var$roundCssNumber(t) + ""
                    }
                ];
        scrollbarStyle(S, createScrollbarStyleFn(t.x));
        scrollbarStyle(m, createScrollbarStyleFn(t.y));
    };
    const refreshScrollbarsHandleOffset = ()=>{
        if (!$7ed7ccaa27a98189$var$p) {
            const { Dt: t } = o;
            const n = $7ed7ccaa27a98189$var$getScrollCoordinatesPercent(t, $7ed7ccaa27a98189$var$getElementScroll(v));
            const createScrollbarStyleFn = (t)=>(n)=>[
                        n.Lt,
                        {
                            [c]: $7ed7ccaa27a98189$var$roundCssNumber(t) + ""
                        }
                    ];
            scrollbarStyle(S, createScrollbarStyleFn(n.x));
            scrollbarStyle(m, createScrollbarStyleFn(n.y));
        }
    };
    const refreshScrollbarsScrollCoordinates = ()=>{
        const { Dt: t } = o;
        const n = $7ed7ccaa27a98189$var$isDefaultDirectionScrollCoordinates(t);
        const createScrollbarStyleFn = (t)=>(n)=>[
                    n.Lt,
                    {
                        [r]: t ? "0" : "1"
                    }
                ];
        scrollbarStyle(S, createScrollbarStyleFn(n.x));
        scrollbarStyle(m, createScrollbarStyleFn(n.y));
        if ($7ed7ccaa27a98189$var$p) {
            S.forEach(C.x.kt);
            m.forEach(C.y.kt);
        }
    };
    const refreshScrollbarsScrollbarOffset = ()=>{
        if (h && !g) {
            const { Rt: t, Dt: n } = o;
            const s = $7ed7ccaa27a98189$var$isDefaultDirectionScrollCoordinates(n);
            const e = $7ed7ccaa27a98189$var$getScrollCoordinatesPercent(n, $7ed7ccaa27a98189$var$getElementScroll(v));
            const styleScrollbarPosition = (n)=>{
                const { Lt: o } = n;
                const c = $7ed7ccaa27a98189$var$parent(o) === _ && o;
                const getTranslateValue = (t, n, o)=>{
                    const s = n * t;
                    return $7ed7ccaa27a98189$var$numberToCssPx(o ? s : -s);
                };
                return [
                    c,
                    c && {
                        transform: $7ed7ccaa27a98189$var$getTrasformTranslateValue({
                            x: getTranslateValue(e.x, t.x, s.x),
                            y: getTranslateValue(e.y, t.y, s.y)
                        })
                    }
                ];
            };
            scrollbarStyle(S, styleScrollbarPosition);
            scrollbarStyle(m, styleScrollbarPosition);
        }
    };
    const generateScrollbarDOM = (t)=>{
        const n = t ? "x" : "y";
        const o = t ? $7ed7ccaa27a98189$var$ft : $7ed7ccaa27a98189$var$_t;
        const e = $7ed7ccaa27a98189$var$createDiv(`${$7ed7ccaa27a98189$var$at} ${o}`);
        const c = $7ed7ccaa27a98189$var$createDiv($7ed7ccaa27a98189$var$dt);
        const r = $7ed7ccaa27a98189$var$createDiv($7ed7ccaa27a98189$var$pt);
        const i = {
            Lt: e,
            Ut: c,
            Mt: r
        };
        const l = C[n];
        $7ed7ccaa27a98189$var$push(t ? S : m, i);
        $7ed7ccaa27a98189$var$push(y, [
            $7ed7ccaa27a98189$var$appendChildren(e, c),
            $7ed7ccaa27a98189$var$appendChildren(c, r),
            $7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$removeElements, e),
            l && l.kt(i),
            s(i, scrollbarsAddRemoveClass, t)
        ]);
        return i;
    };
    const $ = $7ed7ccaa27a98189$var$bind(generateScrollbarDOM, true);
    const x = $7ed7ccaa27a98189$var$bind(generateScrollbarDOM, false);
    const appendElements = ()=>{
        $7ed7ccaa27a98189$var$appendChildren(O, S[0].Lt);
        $7ed7ccaa27a98189$var$appendChildren(O, m[0].Lt);
        return $7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$runEachAndClear, y);
    };
    $();
    x();
    return [
        {
            Pt: refreshScrollbarsHandleLength,
            Nt: refreshScrollbarsHandleOffset,
            qt: refreshScrollbarsScrollCoordinates,
            Bt: refreshScrollbarsScrollbarOffset,
            Ft: scrollbarsAddRemoveClass,
            jt: {
                Xt: S,
                Yt: $,
                Wt: $7ed7ccaa27a98189$var$bind(scrollbarStyle, S)
            },
            Jt: {
                Xt: m,
                Yt: x,
                Wt: $7ed7ccaa27a98189$var$bind(scrollbarStyle, m)
            }
        },
        appendElements
    ];
};
const $7ed7ccaa27a98189$var$createScrollbarsSetupEvents = (t, n, o, s)=>(r, i, l)=>{
        const { vt: u, L: f, V: _, gt: d, Gt: p, St: v } = n;
        const { Lt: g, Ut: h, Mt: b } = r;
        const [w, y] = $7ed7ccaa27a98189$var$selfClearTimeout(333);
        const [S, m] = $7ed7ccaa27a98189$var$selfClearTimeout(444);
        const scrollOffsetElementScrollBy = (t)=>{
            if ($7ed7ccaa27a98189$var$isFunction(d.scrollBy)) d.scrollBy({
                behavior: "smooth",
                left: t.x,
                top: t.y
            });
        };
        const createInteractiveScrollEvents = ()=>{
            const n = "pointerup pointercancel lostpointercapture";
            const s = `client${l ? "X" : "Y"}`;
            const r = l ? $7ed7ccaa27a98189$var$C : $7ed7ccaa27a98189$var$$;
            const i = l ? "left" : "top";
            const a = l ? "w" : "h";
            const u = l ? "x" : "y";
            const createRelativeHandleMove = (t, n)=>(s)=>{
                    const { Rt: e } = o;
                    const c = $7ed7ccaa27a98189$var$I(h)[a] - $7ed7ccaa27a98189$var$I(b)[a];
                    const r = n * s / c;
                    const i = r * e[u];
                    $7ed7ccaa27a98189$var$scrollElementTo(d, {
                        [u]: t + i
                    });
                };
            const f = [];
            return $7ed7ccaa27a98189$var$addEventListener(h, "pointerdown", (o)=>{
                const l = $7ed7ccaa27a98189$var$closest(o.target, `.${$7ed7ccaa27a98189$var$pt}`) === b;
                const _ = l ? b : h;
                const g = t.scrollbars;
                const w = g[l ? "dragScroll" : "clickScroll"];
                const { button: y, isPrimary: O, pointerType: C } = o;
                const { pointers: $ } = g;
                const x = y === 0 && O && w && ($ || []).includes(C);
                if (x) {
                    $7ed7ccaa27a98189$var$runEachAndClear(f);
                    m();
                    const t = !l && (o.shiftKey || w === "instant");
                    const g = $7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$getBoundingClientRect, b);
                    const y = $7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$getBoundingClientRect, h);
                    const getHandleOffset = (t, n)=>(t || g())[i] - (n || y())[i];
                    const O = $7ed7ccaa27a98189$var$e($7ed7ccaa27a98189$var$getBoundingClientRect(d)[r]) / $7ed7ccaa27a98189$var$I(d)[a] || 1;
                    const C = createRelativeHandleMove($7ed7ccaa27a98189$var$getElementScroll(d)[u], 1 / O);
                    const $ = o[s];
                    const x = g();
                    const H = y();
                    const E = x[r];
                    const z = getHandleOffset(x, H) + E / 2;
                    const T = $ - H[i];
                    const A = l ? 0 : T - z;
                    const releasePointerCapture = (t)=>{
                        $7ed7ccaa27a98189$var$runEachAndClear(k);
                        _.releasePointerCapture(t.pointerId);
                    };
                    const D = l || t;
                    const M = v();
                    const k = [
                        $7ed7ccaa27a98189$var$addEventListener(p, n, releasePointerCapture),
                        $7ed7ccaa27a98189$var$addEventListener(p, "selectstart", (t)=>$7ed7ccaa27a98189$var$preventDefault(t), {
                            T: false
                        }),
                        $7ed7ccaa27a98189$var$addEventListener(h, n, releasePointerCapture),
                        D && $7ed7ccaa27a98189$var$addEventListener(h, "pointermove", (t)=>C(A + (t[s] - $))),
                        D && (()=>{
                            const t = $7ed7ccaa27a98189$var$getElementScroll(d);
                            M();
                            const n = $7ed7ccaa27a98189$var$getElementScroll(d);
                            const o = {
                                x: n.x - t.x,
                                y: n.y - t.y
                            };
                            if ($7ed7ccaa27a98189$var$c(o.x) > 3 || $7ed7ccaa27a98189$var$c(o.y) > 3) {
                                v();
                                $7ed7ccaa27a98189$var$scrollElementTo(d, t);
                                scrollOffsetElementScrollBy(o);
                                S(M);
                            }
                        })
                    ];
                    _.setPointerCapture(o.pointerId);
                    if (t) C(A);
                    else if (!l) {
                        const t = $7ed7ccaa27a98189$var$getStaticPluginModuleInstance($7ed7ccaa27a98189$var$Et);
                        if (t) {
                            const n = t(C, A, E, (t)=>{
                                if (t) M();
                                else $7ed7ccaa27a98189$var$push(k, M);
                            });
                            $7ed7ccaa27a98189$var$push(k, n);
                            $7ed7ccaa27a98189$var$push(f, $7ed7ccaa27a98189$var$bind(n, true));
                        }
                    }
                }
            });
        };
        let O = true;
        return $7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$runEachAndClear, [
            $7ed7ccaa27a98189$var$addEventListener(b, "pointermove pointerleave", s),
            $7ed7ccaa27a98189$var$addEventListener(g, "pointerenter", ()=>{
                i($7ed7ccaa27a98189$var$ht, true);
            }),
            $7ed7ccaa27a98189$var$addEventListener(g, "pointerleave pointercancel", ()=>{
                i($7ed7ccaa27a98189$var$ht, false);
            }),
            !_ && $7ed7ccaa27a98189$var$addEventListener(g, "mousedown", ()=>{
                const t = $7ed7ccaa27a98189$var$getFocusedElement();
                if ($7ed7ccaa27a98189$var$hasAttr(t, $7ed7ccaa27a98189$var$j) || $7ed7ccaa27a98189$var$hasAttr(t, $7ed7ccaa27a98189$var$B) || t === document.body) $7ed7ccaa27a98189$var$a($7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$focusElement, f), 25);
            }),
            $7ed7ccaa27a98189$var$addEventListener(g, "wheel", (t)=>{
                const { deltaX: n, deltaY: o, deltaMode: s } = t;
                if (O && s === 0 && $7ed7ccaa27a98189$var$parent(g) === u) scrollOffsetElementScrollBy({
                    x: n,
                    y: o
                });
                O = false;
                i($7ed7ccaa27a98189$var$St, true);
                w(()=>{
                    O = true;
                    i($7ed7ccaa27a98189$var$St);
                });
                $7ed7ccaa27a98189$var$preventDefault(t);
            }, {
                T: false,
                I: true
            }),
            $7ed7ccaa27a98189$var$addEventListener(g, "pointerdown", ()=>{
                const t = $7ed7ccaa27a98189$var$addEventListener(p, "click", (t)=>{
                    n();
                    $7ed7ccaa27a98189$var$stopAndPrevent(t);
                }, {
                    A: true,
                    I: true,
                    T: false
                });
                const n = $7ed7ccaa27a98189$var$addEventListener(p, "pointerup pointercancel", ()=>{
                    n();
                    setTimeout(t, 150);
                }, {
                    I: true,
                    T: true
                });
            }, {
                I: true,
                T: true
            }),
            createInteractiveScrollEvents(),
            y,
            m
        ]);
    };
const $7ed7ccaa27a98189$var$createScrollbarsSetup = (t, n, o, s, e, c)=>{
    let r;
    let i;
    let l;
    let a;
    let u;
    let f = $7ed7ccaa27a98189$var$noop;
    let _ = 0;
    const d = [
        "mouse",
        "pen"
    ];
    const isHoverablePointerType = (t)=>d.includes(t.pointerType);
    const [p, v] = $7ed7ccaa27a98189$var$selfClearTimeout();
    const [g, h] = $7ed7ccaa27a98189$var$selfClearTimeout(100);
    const [b, w] = $7ed7ccaa27a98189$var$selfClearTimeout(100);
    const [y, S] = $7ed7ccaa27a98189$var$selfClearTimeout(()=>_);
    const [m, O] = $7ed7ccaa27a98189$var$createScrollbarsSetupElements(t, e, s, $7ed7ccaa27a98189$var$createScrollbarsSetupEvents(n, e, s, (t)=>isHoverablePointerType(t) && manageScrollbarsAutoHideInstantInteraction()));
    const { vt: C, Kt: $, bt: H } = e;
    const { Ft: z, Pt: T, Nt: I, qt: A, Bt: D } = m;
    const manageScrollbarsAutoHide = (t, n)=>{
        S();
        if (t) z($7ed7ccaa27a98189$var$yt);
        else {
            const t = $7ed7ccaa27a98189$var$bind(z, $7ed7ccaa27a98189$var$yt, true);
            if (_ > 0 && !n) y(t);
            else t();
        }
    };
    const manageScrollbarsAutoHideInstantInteraction = ()=>{
        if (l ? !r : !a) {
            manageScrollbarsAutoHide(true);
            g(()=>{
                manageScrollbarsAutoHide(false);
            });
        }
    };
    const manageAutoHideSuspension = (t)=>{
        z($7ed7ccaa27a98189$var$wt, t, true);
        z($7ed7ccaa27a98189$var$wt, t, false);
    };
    const onHostMouseEnter = (t)=>{
        if (isHoverablePointerType(t)) {
            r = l;
            if (l) manageScrollbarsAutoHide(true);
        }
    };
    const M = [
        S,
        h,
        w,
        v,
        ()=>f(),
        $7ed7ccaa27a98189$var$addEventListener(C, "pointerover", onHostMouseEnter, {
            A: true
        }),
        $7ed7ccaa27a98189$var$addEventListener(C, "pointerenter", onHostMouseEnter),
        $7ed7ccaa27a98189$var$addEventListener(C, "pointerleave", (t)=>{
            if (isHoverablePointerType(t)) {
                r = false;
                if (l) manageScrollbarsAutoHide(false);
            }
        }),
        $7ed7ccaa27a98189$var$addEventListener(C, "pointermove", (t)=>{
            if (isHoverablePointerType(t) && i) manageScrollbarsAutoHideInstantInteraction();
        }),
        $7ed7ccaa27a98189$var$addEventListener($, "scroll", (t)=>{
            p(()=>{
                I();
                manageScrollbarsAutoHideInstantInteraction();
            });
            c(t);
            D();
        })
    ];
    return [
        ()=>$7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$runEachAndClear, $7ed7ccaa27a98189$var$push(M, O())),
        ({ zt: t, It: n, Qt: e, Zt: c })=>{
            const { tn: r, nn: d, sn: p, en: v } = c || {};
            const { Ct: g, ft: h } = e || {};
            const { B: w } = o;
            const { k: y } = $7ed7ccaa27a98189$var$getEnvironment();
            const { cn: S, j: m } = s;
            const [O, C] = t("showNativeOverlaidScrollbars");
            const [M, k] = t("scrollbars.theme");
            const [R, V] = t("scrollbars.visibility");
            const [L, U] = t("scrollbars.autoHide");
            const [P, N] = t("scrollbars.autoHideSuspend");
            const [q] = t("scrollbars.autoHideDelay");
            const [B, F] = t("scrollbars.dragScroll");
            const [j, X] = t("scrollbars.clickScroll");
            const [Y, W] = t("overflow");
            const J = h && !n;
            const G = m.x || m.y;
            const K = r || d || v || g || n;
            const Q = p || V || W;
            const Z = O && y.x && y.y;
            const setScrollbarVisibility = (t, n, o)=>{
                const s = t.includes($7ed7ccaa27a98189$var$E) && (R === $7ed7ccaa27a98189$var$x || R === "auto" && n === $7ed7ccaa27a98189$var$E);
                z($7ed7ccaa27a98189$var$vt, s, o);
                return s;
            };
            _ = q;
            if (J) {
                if (P && G) {
                    manageAutoHideSuspension(false);
                    f();
                    b(()=>{
                        f = $7ed7ccaa27a98189$var$addEventListener($, "scroll", $7ed7ccaa27a98189$var$bind(manageAutoHideSuspension, true), {
                            A: true
                        });
                    });
                } else manageAutoHideSuspension(true);
            }
            if (C) z($7ed7ccaa27a98189$var$lt, Z);
            if (k) {
                z(u);
                z(M, true);
                u = M;
            }
            if (N && !P) manageAutoHideSuspension(true);
            if (U) {
                i = L === "move";
                l = L === "leave";
                a = L === "never";
                manageScrollbarsAutoHide(a, true);
            }
            if (F) z($7ed7ccaa27a98189$var$Ot, B);
            if (X) z($7ed7ccaa27a98189$var$mt, !!j);
            if (Q) {
                const t = setScrollbarVisibility(Y.x, S.x, true);
                const n = setScrollbarVisibility(Y.y, S.y, false);
                const o = t && n;
                z($7ed7ccaa27a98189$var$gt, !o);
            }
            if (K) {
                I();
                T();
                D();
                if (v) A();
                z($7ed7ccaa27a98189$var$bt, !m.x, true);
                z($7ed7ccaa27a98189$var$bt, !m.y, false);
                z($7ed7ccaa27a98189$var$ut, w && !H);
            }
        },
        {},
        m
    ];
};
const $7ed7ccaa27a98189$var$createStructureSetupElements = (t)=>{
    const o = $7ed7ccaa27a98189$var$getEnvironment();
    const { K: s, U: e } = o;
    const { elements: c } = s();
    const { padding: r, viewport: i, content: l } = c;
    const a = $7ed7ccaa27a98189$var$isHTMLElement(t);
    const u = a ? {} : t;
    const { elements: f } = u;
    const { padding: _, viewport: d, content: p } = f || {};
    const v = a ? t : u.target;
    const g = $7ed7ccaa27a98189$var$isBodyElement(v);
    const h = v.ownerDocument;
    const b = h.documentElement;
    const getDocumentWindow = ()=>h.defaultView || $7ed7ccaa27a98189$var$n;
    const w = $7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$staticInitializationElement, [
        v
    ]);
    const y = $7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$dynamicInitializationElement, [
        v
    ]);
    const S = $7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$createDiv, "");
    const C = $7ed7ccaa27a98189$var$bind(w, S, i);
    const $ = $7ed7ccaa27a98189$var$bind(y, S, l);
    const elementHasOverflow = (t)=>{
        const n = $7ed7ccaa27a98189$var$I(t);
        const o = $7ed7ccaa27a98189$var$D(t);
        const s = $7ed7ccaa27a98189$var$getStyles(t, $7ed7ccaa27a98189$var$m);
        const e = $7ed7ccaa27a98189$var$getStyles(t, $7ed7ccaa27a98189$var$O);
        return o.w - n.w > 0 && !$7ed7ccaa27a98189$var$overflowIsVisible(s) || o.h - n.h > 0 && !$7ed7ccaa27a98189$var$overflowIsVisible(e);
    };
    const x = C(d);
    const H = x === v;
    const E = H && g;
    const z = !H && $(p);
    const T = !H && x === z;
    const A = E ? b : x;
    const M = E ? A : v;
    const k = !H && y(S, r, _);
    const R = !T && z;
    const V = [
        R,
        A,
        k,
        M
    ].map((t)=>$7ed7ccaa27a98189$var$isHTMLElement(t) && !$7ed7ccaa27a98189$var$parent(t) && t);
    const elementIsGenerated = (t)=>t && $7ed7ccaa27a98189$var$inArray(V, t);
    const L = !elementIsGenerated(A) && elementHasOverflow(A) ? A : v;
    const U = E ? b : A;
    const N = E ? h : A;
    const X = {
        dt: v,
        vt: M,
        L: A,
        rn: k,
        ht: R,
        gt: U,
        Kt: N,
        ln: g ? b : L,
        Gt: h,
        bt: g,
        At: a,
        V: H,
        an: getDocumentWindow,
        wt: (t)=>$7ed7ccaa27a98189$var$hasAttrClass(A, $7ed7ccaa27a98189$var$j, t),
        yt: (t, n)=>$7ed7ccaa27a98189$var$addRemoveAttrClass(A, $7ed7ccaa27a98189$var$j, t, n),
        St: ()=>$7ed7ccaa27a98189$var$addRemoveAttrClass(U, $7ed7ccaa27a98189$var$j, $7ed7ccaa27a98189$var$G, true)
    };
    const { dt: Y, vt: W, rn: J, L: Q, ht: nt } = X;
    const ot = [
        ()=>{
            $7ed7ccaa27a98189$var$removeAttrs(W, [
                $7ed7ccaa27a98189$var$B,
                $7ed7ccaa27a98189$var$P
            ]);
            $7ed7ccaa27a98189$var$removeAttrs(Y, $7ed7ccaa27a98189$var$P);
            if (g) $7ed7ccaa27a98189$var$removeAttrs(b, [
                $7ed7ccaa27a98189$var$P,
                $7ed7ccaa27a98189$var$B
            ]);
        }
    ];
    let st = $7ed7ccaa27a98189$var$contents([
        nt,
        Q,
        J,
        W,
        Y
    ].find((t)=>t && !elementIsGenerated(t)));
    const et = E ? Y : nt || Q;
    const ct = $7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$runEachAndClear, ot);
    const appendElements = ()=>{
        const t = getDocumentWindow();
        const n = $7ed7ccaa27a98189$var$getFocusedElement();
        const unwrap = (t)=>{
            $7ed7ccaa27a98189$var$appendChildren($7ed7ccaa27a98189$var$parent(t), $7ed7ccaa27a98189$var$contents(t));
            $7ed7ccaa27a98189$var$removeElements(t);
        };
        const prepareWrapUnwrapFocus = (t)=>$7ed7ccaa27a98189$var$addEventListener(t, "focusin focusout focus blur", $7ed7ccaa27a98189$var$stopAndPrevent, {
                I: true,
                T: false
            });
        const o = "tabindex";
        const s = $7ed7ccaa27a98189$var$getAttr(Q, o);
        const c = prepareWrapUnwrapFocus(n);
        $7ed7ccaa27a98189$var$setAttrs(W, $7ed7ccaa27a98189$var$B, H ? "" : $7ed7ccaa27a98189$var$F);
        $7ed7ccaa27a98189$var$setAttrs(J, $7ed7ccaa27a98189$var$Z, "");
        $7ed7ccaa27a98189$var$setAttrs(Q, $7ed7ccaa27a98189$var$j, "");
        $7ed7ccaa27a98189$var$setAttrs(nt, $7ed7ccaa27a98189$var$tt, "");
        if (!H) {
            $7ed7ccaa27a98189$var$setAttrs(Q, o, s || "-1");
            if (g) $7ed7ccaa27a98189$var$setAttrs(b, $7ed7ccaa27a98189$var$q, "");
        }
        $7ed7ccaa27a98189$var$appendChildren(et, st);
        $7ed7ccaa27a98189$var$appendChildren(W, J);
        $7ed7ccaa27a98189$var$appendChildren(J || W, !H && Q);
        $7ed7ccaa27a98189$var$appendChildren(Q, nt);
        $7ed7ccaa27a98189$var$push(ot, [
            c,
            ()=>{
                const t = $7ed7ccaa27a98189$var$getFocusedElement();
                const n = elementIsGenerated(Q);
                const e = n && t === Q ? Y : t;
                const c = prepareWrapUnwrapFocus(e);
                $7ed7ccaa27a98189$var$removeAttrs(J, $7ed7ccaa27a98189$var$Z);
                $7ed7ccaa27a98189$var$removeAttrs(nt, $7ed7ccaa27a98189$var$tt);
                $7ed7ccaa27a98189$var$removeAttrs(Q, $7ed7ccaa27a98189$var$j);
                if (g) $7ed7ccaa27a98189$var$removeAttrs(b, $7ed7ccaa27a98189$var$q);
                if (s) $7ed7ccaa27a98189$var$setAttrs(Q, o, s);
                else $7ed7ccaa27a98189$var$removeAttrs(Q, o);
                if (elementIsGenerated(nt)) unwrap(nt);
                if (n) unwrap(Q);
                if (elementIsGenerated(J)) unwrap(J);
                $7ed7ccaa27a98189$var$focusElement(e);
                c();
            }
        ]);
        if (e && !H) {
            $7ed7ccaa27a98189$var$addAttrClass(Q, $7ed7ccaa27a98189$var$j, $7ed7ccaa27a98189$var$K);
            $7ed7ccaa27a98189$var$push(ot, $7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$removeAttrs, Q, $7ed7ccaa27a98189$var$j));
        }
        $7ed7ccaa27a98189$var$focusElement(!H && g && n === Y && t.top === t ? Q : n);
        c();
        st = 0;
        return ct;
    };
    return [
        X,
        appendElements,
        ct
    ];
};
const $7ed7ccaa27a98189$var$createTrinsicUpdateSegment = ({ ht: t })=>({ Qt: n, un: o, It: s })=>{
        const { $t: e } = n || {};
        const { Ot: c } = o;
        const r = t && (e || s);
        if (r) $7ed7ccaa27a98189$var$setStyles(t, {
            [$7ed7ccaa27a98189$var$$]: c && "100%"
        });
    };
const $7ed7ccaa27a98189$var$createPaddingUpdateSegment = ({ vt: t, rn: n, L: o, V: s }, e)=>{
    const [c, r] = $7ed7ccaa27a98189$var$createCache({
        i: $7ed7ccaa27a98189$var$equalTRBL,
        o: $7ed7ccaa27a98189$var$topRightBottomLeft()
    }, $7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$topRightBottomLeft, t, "padding", ""));
    return ({ zt: t, Qt: i, un: l, It: a })=>{
        let [u, f] = r(a);
        const { U: _ } = $7ed7ccaa27a98189$var$getEnvironment();
        const { _t: d, xt: p, Ct: m } = i || {};
        const { B: O } = l;
        const [$, x] = t("paddingAbsolute");
        const H = a || p;
        if (d || f || H) [u, f] = c(a);
        const E = !s && (x || m || f);
        if (E) {
            const t = !$ || !n && !_;
            const s = u.r + u.l;
            const c = u.t + u.b;
            const r = {
                [$7ed7ccaa27a98189$var$y]: t && !O ? -s : 0,
                [$7ed7ccaa27a98189$var$S]: t ? -c : 0,
                [$7ed7ccaa27a98189$var$w]: t && O ? -s : 0,
                top: t ? -u.t : 0,
                right: t ? O ? -u.r : "auto" : 0,
                left: t ? O ? "auto" : -u.l : 0,
                [$7ed7ccaa27a98189$var$C]: t && `calc(100% + ${s}px)`
            };
            const i = {
                [$7ed7ccaa27a98189$var$v]: t ? u.t : 0,
                [$7ed7ccaa27a98189$var$g]: t ? u.r : 0,
                [$7ed7ccaa27a98189$var$b]: t ? u.b : 0,
                [$7ed7ccaa27a98189$var$h]: t ? u.l : 0
            };
            $7ed7ccaa27a98189$var$setStyles(n || o, r);
            $7ed7ccaa27a98189$var$setStyles(o, i);
            $7ed7ccaa27a98189$var$assignDeep(e, {
                rn: u,
                fn: !t,
                F: n ? i : $7ed7ccaa27a98189$var$assignDeep({}, r, i)
            });
        }
        return {
            _n: E
        };
    };
};
const $7ed7ccaa27a98189$var$createOverflowUpdateSegment = (t, s)=>{
    const e = $7ed7ccaa27a98189$var$getEnvironment();
    const { vt: c, rn: r, L: i, V: a, Kt: u, gt: f, bt: _, yt: d, an: p } = t;
    const { U: v } = e;
    const g = _ && a;
    const h = $7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$o, 0);
    const b = {
        display: ()=>false,
        direction: (t)=>t !== "ltr",
        flexDirection: (t)=>t.endsWith("-reverse"),
        writingMode: (t)=>t !== "horizontal-tb"
    };
    const w = $7ed7ccaa27a98189$var$keys(b);
    const y = {
        i: $7ed7ccaa27a98189$var$equalWH,
        o: {
            w: 0,
            h: 0
        }
    };
    const S = {
        i: $7ed7ccaa27a98189$var$equalXY,
        o: {}
    };
    const setMeasuringMode = (t)=>{
        d($7ed7ccaa27a98189$var$J, !g && t);
    };
    const getMeasuredScrollCoordinates = (t)=>{
        const n = w.some((n)=>{
            const o = t[n];
            return o && b[n](o);
        });
        if (!n) return {
            D: {
                x: 0,
                y: 0
            },
            M: {
                x: 1,
                y: 1
            }
        };
        setMeasuringMode(true);
        const o = $7ed7ccaa27a98189$var$getElementScroll(f);
        const s = d($7ed7ccaa27a98189$var$Q, true);
        const e = $7ed7ccaa27a98189$var$addEventListener(u, $7ed7ccaa27a98189$var$E, (t)=>{
            const n = $7ed7ccaa27a98189$var$getElementScroll(f);
            if (t.isTrusted && n.x === o.x && n.y === o.y) $7ed7ccaa27a98189$var$stopPropagation(t);
        }, {
            I: true,
            A: true
        });
        $7ed7ccaa27a98189$var$scrollElementTo(f, {
            x: 0,
            y: 0
        });
        s();
        const c = $7ed7ccaa27a98189$var$getElementScroll(f);
        const r = $7ed7ccaa27a98189$var$D(f);
        $7ed7ccaa27a98189$var$scrollElementTo(f, {
            x: r.w,
            y: r.h
        });
        const i = $7ed7ccaa27a98189$var$getElementScroll(f);
        $7ed7ccaa27a98189$var$scrollElementTo(f, {
            x: i.x - c.x < 1 && -r.w,
            y: i.y - c.y < 1 && -r.h
        });
        const a = $7ed7ccaa27a98189$var$getElementScroll(f);
        $7ed7ccaa27a98189$var$scrollElementTo(f, o);
        $7ed7ccaa27a98189$var$l(()=>e());
        return {
            D: c,
            M: a
        };
    };
    const getOverflowAmount = (t, o)=>{
        const s = $7ed7ccaa27a98189$var$n.devicePixelRatio % 1 !== 0 ? 1 : 0;
        const e = {
            w: h(t.w - o.w),
            h: h(t.h - o.h)
        };
        return {
            w: e.w > s ? e.w : 0,
            h: e.h > s ? e.h : 0
        };
    };
    const getViewportOverflowStyle = (t, n)=>{
        const getAxisOverflowStyle = (t, n, o, s)=>{
            const e = t === $7ed7ccaa27a98189$var$x ? $7ed7ccaa27a98189$var$H : $7ed7ccaa27a98189$var$overflowBehaviorToOverflowStyle(t);
            const c = $7ed7ccaa27a98189$var$overflowIsVisible(t);
            const r = $7ed7ccaa27a98189$var$overflowIsVisible(o);
            if (!n && !s) return $7ed7ccaa27a98189$var$H;
            if (c && r) return $7ed7ccaa27a98189$var$x;
            if (c) {
                const t = n ? $7ed7ccaa27a98189$var$x : $7ed7ccaa27a98189$var$H;
                return n && s ? e : t;
            }
            const i = r && s ? $7ed7ccaa27a98189$var$x : $7ed7ccaa27a98189$var$H;
            return n ? e : i;
        };
        return {
            x: getAxisOverflowStyle(n.x, t.x, n.y, t.y),
            y: getAxisOverflowStyle(n.y, t.y, n.x, t.x)
        };
    };
    const setViewportOverflowStyle = (t)=>{
        const createAllOverflowStyleClassNames = (t)=>[
                $7ed7ccaa27a98189$var$x,
                $7ed7ccaa27a98189$var$H,
                $7ed7ccaa27a98189$var$E
            ].map((n)=>createViewportOverflowStyleClassName($7ed7ccaa27a98189$var$overflowCssValueToOverflowStyle(n), t));
        const n = createAllOverflowStyleClassNames(true).concat(createAllOverflowStyleClassNames()).join(" ");
        d(n);
        d($7ed7ccaa27a98189$var$keys(t).map((n)=>createViewportOverflowStyleClassName(t[n], n === "x")).join(" "), true);
    };
    const [m, O] = $7ed7ccaa27a98189$var$createCache(y, $7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$getFractionalSize, i));
    const [C, $] = $7ed7ccaa27a98189$var$createCache(y, $7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$D, i));
    const [z, T] = $7ed7ccaa27a98189$var$createCache(y);
    const [I] = $7ed7ccaa27a98189$var$createCache(S);
    const [M, k] = $7ed7ccaa27a98189$var$createCache(y);
    const [R] = $7ed7ccaa27a98189$var$createCache(S);
    const [V] = $7ed7ccaa27a98189$var$createCache({
        i: (t, n)=>$7ed7ccaa27a98189$var$equal(t, n, w),
        o: {}
    }, ()=>$7ed7ccaa27a98189$var$hasDimensions(i) ? $7ed7ccaa27a98189$var$getStyles(i, w) : {});
    const [L, U] = $7ed7ccaa27a98189$var$createCache({
        i: (t, n)=>$7ed7ccaa27a98189$var$equalXY(t.D, n.D) && $7ed7ccaa27a98189$var$equalXY(t.M, n.M),
        o: $7ed7ccaa27a98189$var$getZeroScrollCoordinates()
    });
    const P = $7ed7ccaa27a98189$var$getStaticPluginModuleInstance($7ed7ccaa27a98189$var$xt);
    const createViewportOverflowStyleClassName = (t, n)=>{
        const o = n ? $7ed7ccaa27a98189$var$X : $7ed7ccaa27a98189$var$Y;
        return `${o}${$7ed7ccaa27a98189$var$capitalizeFirstLetter(t)}`;
    };
    return ({ zt: n, Qt: o, un: l, It: a }, { _n: u })=>{
        const { _t: f, Ht: _, xt: b, Ct: w, ft: y, Et: S } = o || {};
        const x = P && P.R(t, s, l, e, n);
        const { X: H, Y: E, W: D } = x || {};
        const [q, F] = $7ed7ccaa27a98189$var$getShowNativeOverlaidScrollbars(n, e);
        const [j, X] = n("overflow");
        const Y = $7ed7ccaa27a98189$var$overflowIsVisible(j.x);
        const W = $7ed7ccaa27a98189$var$overflowIsVisible(j.y);
        const J = f || u || b || w || S || F;
        let G = O(a);
        let Q = $(a);
        let tt = T(a);
        let nt = k(a);
        if (F && v) d($7ed7ccaa27a98189$var$K, !q);
        if (J) {
            if ($7ed7ccaa27a98189$var$hasAttrClass(c, $7ed7ccaa27a98189$var$B, $7ed7ccaa27a98189$var$N)) setMeasuringMode(true);
            const t = E && E();
            const [n] = G = m(a);
            const [o] = Q = C(a);
            const s = $7ed7ccaa27a98189$var$A(i);
            const e = g && $7ed7ccaa27a98189$var$getWindowSize(p());
            const r = {
                w: h(o.w + n.w),
                h: h(o.h + n.h)
            };
            const l = {
                w: h((e ? e.w : s.w + h(s.w - o.w)) + n.w),
                h: h((e ? e.h : s.h + h(s.h - o.h)) + n.h)
            };
            if (t) t();
            nt = M(l);
            tt = z(getOverflowAmount(r, l), a);
        }
        const [ot, st] = nt;
        const [et, ct] = tt;
        const [rt, it] = Q;
        const [lt, at] = G;
        const [ut, ft] = I({
            x: et.w > 0,
            y: et.h > 0
        });
        const _t = Y && W && (ut.x || ut.y) || Y && ut.x && !ut.y || W && ut.y && !ut.x;
        const dt = u || w || S || at || it || st || ct || X || F || J || _ && g;
        const [pt, vt] = V(a);
        const gt = w || y || vt || ft || a;
        const [ht, bt] = gt ? L(getMeasuredScrollCoordinates(pt), a) : U();
        let wt = getViewportOverflowStyle(ut, j);
        setMeasuringMode(false);
        if (dt) {
            setViewportOverflowStyle(wt);
            wt = $7ed7ccaa27a98189$var$getElementOverflowStyle(i, ut);
            if (D && H) {
                H(wt, rt, lt);
                $7ed7ccaa27a98189$var$setStyles(i, D(wt));
            }
        }
        const [yt, St] = R(wt);
        $7ed7ccaa27a98189$var$addRemoveAttrClass(c, $7ed7ccaa27a98189$var$B, $7ed7ccaa27a98189$var$N, _t);
        $7ed7ccaa27a98189$var$addRemoveAttrClass(r, $7ed7ccaa27a98189$var$Z, $7ed7ccaa27a98189$var$N, _t);
        $7ed7ccaa27a98189$var$assignDeep(s, {
            cn: yt,
            Vt: {
                x: ot.w,
                y: ot.h
            },
            Rt: {
                x: et.w,
                y: et.h
            },
            j: ut,
            Dt: $7ed7ccaa27a98189$var$sanitizeScrollCoordinates(ht, et)
        });
        return {
            sn: St,
            tn: st,
            nn: ct,
            en: bt || ct,
            dn: gt
        };
    };
};
const $7ed7ccaa27a98189$var$createStructureSetup = (t)=>{
    const [n, o, s] = $7ed7ccaa27a98189$var$createStructureSetupElements(t);
    const e = {
        rn: {
            t: 0,
            r: 0,
            b: 0,
            l: 0
        },
        fn: false,
        F: {
            [$7ed7ccaa27a98189$var$y]: 0,
            [$7ed7ccaa27a98189$var$S]: 0,
            [$7ed7ccaa27a98189$var$w]: 0,
            [$7ed7ccaa27a98189$var$v]: 0,
            [$7ed7ccaa27a98189$var$g]: 0,
            [$7ed7ccaa27a98189$var$b]: 0,
            [$7ed7ccaa27a98189$var$h]: 0
        },
        Vt: {
            x: 0,
            y: 0
        },
        Rt: {
            x: 0,
            y: 0
        },
        cn: {
            x: $7ed7ccaa27a98189$var$H,
            y: $7ed7ccaa27a98189$var$H
        },
        j: {
            x: false,
            y: false
        },
        Dt: $7ed7ccaa27a98189$var$getZeroScrollCoordinates()
    };
    const { dt: c, gt: r, V: i, St: l } = n;
    const { U: a, k: u } = $7ed7ccaa27a98189$var$getEnvironment();
    const f = !a && (u.x || u.y);
    const _ = [
        $7ed7ccaa27a98189$var$createTrinsicUpdateSegment(n),
        $7ed7ccaa27a98189$var$createPaddingUpdateSegment(n, e),
        $7ed7ccaa27a98189$var$createOverflowUpdateSegment(n, e)
    ];
    return [
        o,
        (t)=>{
            const n = {};
            const o = f;
            const s = o && $7ed7ccaa27a98189$var$getElementScroll(r);
            const e = s && l();
            $7ed7ccaa27a98189$var$each(_, (o)=>{
                $7ed7ccaa27a98189$var$assignDeep(n, o(t, n) || {});
            });
            $7ed7ccaa27a98189$var$scrollElementTo(r, s);
            if (e) e();
            if (!i) $7ed7ccaa27a98189$var$scrollElementTo(c, 0);
            return n;
        },
        e,
        n,
        s
    ];
};
const $7ed7ccaa27a98189$var$createSetups = (t, n, o, s, e)=>{
    let c = false;
    const r = $7ed7ccaa27a98189$var$createOptionCheck(n, {});
    const [i, l, a, u, f] = $7ed7ccaa27a98189$var$createStructureSetup(t);
    const [_, d, p] = $7ed7ccaa27a98189$var$createObserversSetup(u, a, r, (t)=>{
        update({}, t);
    });
    const [v, g, , h] = $7ed7ccaa27a98189$var$createScrollbarsSetup(t, n, p, a, u, e);
    const updateHintsAreTruthy = (t)=>$7ed7ccaa27a98189$var$keys(t).some((n)=>!!t[n]);
    const update = (t, e)=>{
        if (o()) return false;
        const { pn: r, It: i, Tt: a, vn: u } = t;
        const f = r || {};
        const _ = !!i || !c;
        const v = {
            zt: $7ed7ccaa27a98189$var$createOptionCheck(n, f, _),
            pn: f,
            It: _
        };
        if (u) {
            g(v);
            return false;
        }
        const h = e || d($7ed7ccaa27a98189$var$assignDeep({}, v, {
            Tt: a
        }));
        const b = l($7ed7ccaa27a98189$var$assignDeep({}, v, {
            un: p,
            Qt: h
        }));
        g($7ed7ccaa27a98189$var$assignDeep({}, v, {
            Qt: h,
            Zt: b
        }));
        const w = updateHintsAreTruthy(h);
        const y = updateHintsAreTruthy(b);
        const S = w || y || !$7ed7ccaa27a98189$var$isEmptyObject(f) || _;
        c = true;
        if (S) s(t, {
            Qt: h,
            Zt: b
        });
        return S;
    };
    return [
        ()=>{
            const { ln: t, gt: n, St: o } = u;
            const s = $7ed7ccaa27a98189$var$getElementScroll(t);
            const e = [
                _(),
                i(),
                v()
            ];
            const c = o();
            $7ed7ccaa27a98189$var$scrollElementTo(n, s);
            c();
            return $7ed7ccaa27a98189$var$bind($7ed7ccaa27a98189$var$runEachAndClear, e);
        },
        update,
        ()=>({
                gn: p,
                hn: a
            }),
        {
            bn: u,
            wn: h
        },
        f
    ];
};
const $7ed7ccaa27a98189$var$Mt = new WeakMap;
const $7ed7ccaa27a98189$var$addInstance = (t, n)=>{
    $7ed7ccaa27a98189$var$Mt.set(t, n);
};
const $7ed7ccaa27a98189$var$removeInstance = (t)=>{
    $7ed7ccaa27a98189$var$Mt.delete(t);
};
const $7ed7ccaa27a98189$var$getInstance = (t)=>$7ed7ccaa27a98189$var$Mt.get(t);
const $7ed7ccaa27a98189$export$d08ab3fe303a3356 = (t, n, o)=>{
    const { tt: s } = $7ed7ccaa27a98189$var$getEnvironment();
    const e = $7ed7ccaa27a98189$var$isHTMLElement(t);
    const c = e ? t : t.target;
    const r = $7ed7ccaa27a98189$var$getInstance(c);
    if (n && !r) {
        let r = false;
        const i = [];
        const l = {};
        const validateOptions = (t)=>{
            const n = $7ed7ccaa27a98189$var$removeUndefinedProperties(t);
            const o = $7ed7ccaa27a98189$var$getStaticPluginModuleInstance($7ed7ccaa27a98189$var$R);
            return o ? o(n, true) : n;
        };
        const a = $7ed7ccaa27a98189$var$assignDeep({}, s(), validateOptions(n));
        const [u, f, _] = $7ed7ccaa27a98189$var$createEventListenerHub();
        const [d, p, v] = $7ed7ccaa27a98189$var$createEventListenerHub(o);
        const triggerEvent = (t, n)=>{
            v(t, n);
            _(t, n);
        };
        const [g, h, b, w, y] = $7ed7ccaa27a98189$var$createSetups(t, a, ()=>r, ({ pn: t, It: n }, { Qt: o, Zt: s })=>{
            const { _t: e, Ct: c, $t: r, xt: i, Ht: l, ft: a } = o;
            const { tn: u, nn: f, sn: _, en: d } = s;
            triggerEvent("updated", [
                S,
                {
                    updateHints: {
                        sizeChanged: !!e,
                        directionChanged: !!c,
                        heightIntrinsicChanged: !!r,
                        overflowEdgeChanged: !!u,
                        overflowAmountChanged: !!f,
                        overflowStyleChanged: !!_,
                        scrollCoordinatesChanged: !!d,
                        contentMutation: !!i,
                        hostMutation: !!l,
                        appear: !!a
                    },
                    changedOptions: t || {},
                    force: !!n
                }
            ]);
        }, (t)=>triggerEvent("scroll", [
                S,
                t
            ]));
        const destroy = (t)=>{
            $7ed7ccaa27a98189$var$removeInstance(c);
            $7ed7ccaa27a98189$var$runEachAndClear(i);
            r = true;
            triggerEvent("destroyed", [
                S,
                t
            ]);
            f();
            p();
        };
        const S = {
            options (t, n) {
                if (t) {
                    const o = n ? s() : {};
                    const e = $7ed7ccaa27a98189$var$getOptionsDiff(a, $7ed7ccaa27a98189$var$assignDeep(o, validateOptions(t)));
                    if (!$7ed7ccaa27a98189$var$isEmptyObject(e)) {
                        $7ed7ccaa27a98189$var$assignDeep(a, e);
                        h({
                            pn: e
                        });
                    }
                }
                return $7ed7ccaa27a98189$var$assignDeep({}, a);
            },
            on: d,
            off: (t, n)=>{
                if (t && n) p(t, n);
            },
            state () {
                const { gn: t, hn: n } = b();
                const { B: o } = t;
                const { Vt: s, Rt: e, cn: c, j: i, rn: l, fn: a, Dt: u } = n;
                return $7ed7ccaa27a98189$var$assignDeep({}, {
                    overflowEdge: s,
                    overflowAmount: e,
                    overflowStyle: c,
                    hasOverflow: i,
                    scrollCoordinates: {
                        start: u.D,
                        end: u.M
                    },
                    padding: l,
                    paddingAbsolute: a,
                    directionRTL: o,
                    destroyed: r
                });
            },
            elements () {
                const { dt: t, vt: n, rn: o, L: s, ht: e, gt: c, Kt: r } = w.bn;
                const { jt: i, Jt: l } = w.wn;
                const translateScrollbarStructure = (t)=>{
                    const { Mt: n, Ut: o, Lt: s } = t;
                    return {
                        scrollbar: s,
                        track: o,
                        handle: n
                    };
                };
                const translateScrollbarsSetupElement = (t)=>{
                    const { Xt: n, Yt: o } = t;
                    const s = translateScrollbarStructure(n[0]);
                    return $7ed7ccaa27a98189$var$assignDeep({}, s, {
                        clone: ()=>{
                            const t = translateScrollbarStructure(o());
                            h({
                                vn: true
                            });
                            return t;
                        }
                    });
                };
                return $7ed7ccaa27a98189$var$assignDeep({}, {
                    target: t,
                    host: n,
                    padding: o || s,
                    viewport: s,
                    content: e || s,
                    scrollOffsetElement: c,
                    scrollEventElement: r,
                    scrollbarHorizontal: translateScrollbarsSetupElement(i),
                    scrollbarVertical: translateScrollbarsSetupElement(l)
                });
            },
            update: (t)=>h({
                    It: t,
                    Tt: true
                }),
            destroy: $7ed7ccaa27a98189$var$bind(destroy, false),
            plugin: (t)=>l[$7ed7ccaa27a98189$var$keys(t)[0]]
        };
        $7ed7ccaa27a98189$var$push(i, [
            y
        ]);
        $7ed7ccaa27a98189$var$addInstance(c, S);
        $7ed7ccaa27a98189$var$registerPluginModuleInstances($7ed7ccaa27a98189$var$M, $7ed7ccaa27a98189$export$d08ab3fe303a3356, [
            S,
            u,
            l
        ]);
        if ($7ed7ccaa27a98189$var$cancelInitialization(w.bn.bt, !e && t.cancel)) {
            destroy(true);
            return S;
        }
        $7ed7ccaa27a98189$var$push(i, g());
        triggerEvent("initialized", [
            S
        ]);
        S.update();
        return S;
    }
    return r;
};
$7ed7ccaa27a98189$export$d08ab3fe303a3356.plugin = (t)=>{
    const n = $7ed7ccaa27a98189$var$isArray(t);
    const o = n ? t : [
        t
    ];
    const s = o.map((t)=>$7ed7ccaa27a98189$var$registerPluginModuleInstances(t, $7ed7ccaa27a98189$export$d08ab3fe303a3356)[0]);
    $7ed7ccaa27a98189$var$addPlugins(o);
    return n ? s : s[0];
};
$7ed7ccaa27a98189$export$d08ab3fe303a3356.valid = (t)=>{
    const n = t && t.elements;
    const o = $7ed7ccaa27a98189$var$isFunction(n) && n();
    return $7ed7ccaa27a98189$var$isPlainObject(o) && !!$7ed7ccaa27a98189$var$getInstance(o.target);
};
$7ed7ccaa27a98189$export$d08ab3fe303a3356.env = ()=>{
    const { P: t, k: n, U: o, J: s, ot: e, st: c, K: r, Z: i, tt: l, nt: a } = $7ed7ccaa27a98189$var$getEnvironment();
    return $7ed7ccaa27a98189$var$assignDeep({}, {
        scrollbarsSize: t,
        scrollbarsOverlaid: n,
        scrollbarsHiding: o,
        scrollTimeline: s,
        staticDefaultInitialization: e,
        staticDefaultOptions: c,
        getDefaultInitialization: r,
        setDefaultInitialization: i,
        getDefaultOptions: l,
        setDefaultOptions: a
    });
};
$7ed7ccaa27a98189$export$d08ab3fe303a3356.nonce = $7ed7ccaa27a98189$var$setNonce;
$7ed7ccaa27a98189$export$d08ab3fe303a3356.trustedTypePolicy = $7ed7ccaa27a98189$var$setTrustedTypePolicy;


const $a49f74f22381d7ff$export$6944478e880ebc5b = ()=>{
    const SCROLL_ELEMS = document.querySelectorAll("[data-scrollbar]");
    SCROLL_ELEMS.forEach((elem)=>{
        (0, $7ed7ccaa27a98189$export$d08ab3fe303a3356)(elem, {
            scrollbars: {
                autoHide: "leave"
            }
        });
    });
};




parcelRequire("8URGW");
// Overlay Scrollbars
(0, $a49f74f22381d7ff$export$6944478e880ebc5b)();
(0, $eccbe3a1ca6cfff6$export$565dcf582cc7e325)();
// Vanilla JS Datepicker
(0, $e8e41ed2307ec892$export$e95f23a3da8bb3c7)();
// Quill
(0, $c638fd68af85a519$export$3f3b4272299f29de)();
// noUiSlider
(0, $cbe8ad03059288e1$export$b38bf4f33e9e4c25)();
// Vanilla Colorful
(0, $994058d01def34af$export$fd9a8359a728871b)();
// Simple Datatables
(0, $10157cca0bb4dfb4$export$658dbe9fb20a4a65)();
(0, $1e293ee8d6058e7e$export$6739dba5f0edf6b4)();
(0, $5f4e22f5ef200e8a$export$9d9ea8dbe2f59d9a)();
(0, $afb98260d46aeb49$export$ef85b9a81e16cb26)();
(0, $eba3ea957fe5b72a$export$d63176c007b6bfe)();

})();
//# sourceMappingURL=vendor.072447f7.js.map
